/** GENERATED-PROVENANCE-START (SE-7598)
 * GENERATED FILE — DO NOT EDIT BY HAND. Regenerate via `bun run generate:types:*`.
 *
 * Schema provenance (SE-7598): a codegen run against the wrong or a stale
 * endpoint produces types that look authoritative but are silently wrong —
 * this records where and what was generated so a mismatch shows up in the
 * diff instead of only surfacing later as a runtime bug.
 *
 *   Source endpoint: https://gql.staging.geminisports.io/graphql
 *   Schema hash:     sha256:43eb4bd58f35bc1980386ce3f45de68889b4fab2b75e04bcc15869df76ed9cd3
 *   Generated at:    2026-10-03T02:27:40.384Z
 * GENERATED-PROVENANCE-END (SE-7598) */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  JSONObject: { input: Record<string, any>; output: Record<string, any>; }
};

/** Academy player with readiness information */
export type AcademyPositionPlayerModel = {
  __typename?: 'AcademyPositionPlayerModel';
  /** Player age from stats provider */
  age?: Maybe<Scalars['Int']['output']>;
  /** Annual amortisation charge (SE-7410): transfer fee plus agent fee spread straight-line over the contract's whole months, from organization player data. Null when no fee or no contract dates are recorded, or when the viewer's tier may not see it. */
  amortisationAnnual?: Maybe<Scalars['Float']['output']>;
  /** Contract expiry date */
  contractExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Estimated valuation from organization player data */
  estVal?: Maybe<Scalars['Float']['output']>;
  /** Player first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gemini Performance Rating (time-decayed) */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Gemini Player Valuation */
  gpv?: Maybe<Scalars['Float']['output']>;
  /** GPV upper bound */
  gpvMax?: Maybe<Scalars['Float']['output']>;
  /** GPV lower bound */
  gpvMin?: Maybe<Scalars['Float']['output']>;
  /** Player UUID */
  id: Scalars['ID']['output'];
  /** Whether this player was manually created by the organization */
  isManual: Scalars['Boolean']['output'];
  /** Player known name */
  knownName?: Maybe<Scalars['String']['output']>;
  /** Player last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Minutes played in the player's current season (most recent season with provider metrics) — SE-4775 */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** Display name (knownName or full name) */
  name: Scalars['String']['output'];
  /** Nationality name (e.g. 'Brazil', 'England') */
  nationalityName?: Maybe<Scalars['String']['output']>;
  /** Net book value (SE-7410): the unamortised remainder of the transfer fee at the request date, straight-line over the contract. Null when it cannot be computed or when the viewer's tier may not see it (Tier 1 only). */
  netBookValue?: Maybe<Scalars['Float']['output']>;
  /** Primary position abbreviation (e.g. ST, GK, LB) */
  position?: Maybe<Scalars['String']['output']>;
  /** All position abbreviations this player can play (from player_position table) */
  positions: Array<Scalars['String']['output']>;
  /** Academy player readiness level */
  readinessTag?: Maybe<ReadinessTag>;
  /** Player availability status (e.g. 'INJURED', 'AVAILABLE') */
  status?: Maybe<Scalars['String']['output']>;
  /** Team name — from provider team for roster players, free-text for manual players */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Scenario transition applied to this player (SELL, LOAN_OUT, LOAN_IN, PROMOTE, SIGN), or null if none */
  transitionType?: Maybe<TransitionType>;
  /** Gross annual salary from organization player data */
  wage?: Maybe<Scalars['Float']['output']>;
};

/** Input type for accepting an invitation */
export type AcceptInvitationInput = {
  /** Unique identifier of the invitation to accept */
  id: Scalars['ID']['input'];
};

/** Input for accepting a queued pipeline review request */
export type AcceptPipelineReviewRequestInput = {
  /** Terminal outcome to record. Overrides the request's requestedOutcome. Required (here or on the request) when the target stage is terminal; never defaulted by the backend. */
  outcome?: InputMaybe<KanbanCardOutcome>;
  /** Required approval reason; trimmed server-side. Empty after trim is rejected with REASON_REQUIRED. */
  reason: Scalars['String']['input'];
  /** The ID of the pipeline review request to accept */
  reviewRequestId: Scalars['ID']['input'];
};

/** Input type for activating a user's access to an organization */
export type ActivateOrganizationUserInput = {
  /** Unique identifier of the user to activate */
  userId: Scalars['ID']['input'];
};

/** Represents a user activity or notification in the system, tracking interactions and events */
export type Activity = Node & {
  __typename?: 'Activity';
  /** Activity type classification */
  activityType: ActivityType;
  /** Foreign key to activity type classification */
  activityTypeId: Scalars['ID']['output'];
  /** Detailed description or content of the activity */
  body: Scalars['String']['output'];
  /** Timestamp of activity creation */
  createdAt: Scalars['DateTime']['output'];
  /** Deep link URL for mobile app navigation */
  deepLink?: Maybe<Scalars['String']['output']>;
  /** URL for activity icon/image */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for activity record */
  id: Scalars['ID']['output'];
  /** Flag indicating if activity has been read/acknowledged */
  isRead: Scalars['Boolean']['output'];
  /** Flag indicating if activity has been viewed */
  isSeen: Scalars['Boolean']['output'];
  /** JSON data for additional activity context */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Body content for push notification */
  notificationBody?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if notification was sent */
  notificationSent: Scalars['Boolean']['output'];
  /** Timestamp when notification was sent */
  notificationSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Title for push notification */
  notificationTitle?: Maybe<Scalars['String']['output']>;
  /** Foreign key to organization where activity occurred */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Flag to determine if notification should be sent */
  shouldSendNotification: Scalars['Boolean']['output'];
  /** ID of the entity this activity relates to */
  targetId?: Maybe<Scalars['String']['output']>;
  /** Type of entity this activity relates to */
  targetType?: Maybe<Scalars['String']['output']>;
  /** Display title for the activity */
  title: Scalars['String']['output'];
  /** Timestamp of last activity update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** Foreign key to user who performed or is target of the activity. Null for system-generated activities (e.g. contract-expiring alerts). */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of user activities */
export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  /** A list of edges */
  edges: Array<UserActivityEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total count of user activities */
  totalCount: Scalars['Int']['output'];
};

/** Represents a type of activity that can be performed in the system with role-based visibility and notification settings */
export type ActivityType = Node & {
  __typename?: 'ActivityType';
  /** Unique code identifier for activity type */
  code: Scalars['String']['output'];
  /** Timestamp of activity type creation */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed description of activity type */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for activity type */
  id: Scalars['ID']['output'];
  /** Display name for activity type */
  name: Scalars['String']['output'];
  /** Timestamp of last activity type update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for adding a manual line item to extracted contract data */
export type AddContractExtractionLineItemInput = {
  /** Category name within extracted data */
  category: Scalars['String']['input'];
  /** The type of contract document */
  documentType: DocumentType;
  /** Label for the line item */
  label: Scalars['String']['input'];
  /** UUID of the player the extraction belongs to */
  playerId: Scalars['ID']['input'];
  /** Value for the line item */
  value: Scalars['String']['input'];
};

/** Input for adding a line item to extracted contract data */
export type AddContractLineItemInput = {
  /** Category key within extracted data (e.g. fixedTerms, clauses) */
  category: Scalars['String']['input'];
  /** UUID of the contract extraction to update */
  extractionId: Scalars['ID']['input'];
  /** Text value for the new line item */
  text: Scalars['String']['input'];
};

/** Adds players to a report's squad, leaving every existing squad member in place. Use this instead of setMatchReportSquad whenever the caller does not hold the complete squad — notably the phone capture picker, whose tick set would otherwise read as a removal of everyone it omits and be refused wholesale on a submitted report. Add-only by construction: this mutation can never delete an evaluation, so it never trips the published-row-removal guard. Adding a player who is already in the squad is a no-op, which makes a retry safe. */
export type AddMatchReportSquadPlayersInput = {
  /** Identifier of the report gaining the players */
  matchReportId: Scalars['ID']['input'];
  /** The players to add, each optionally carrying the side they are evaluated on and a shirt number. Players already in the squad are ignored rather than rejected, so a client may re-send a tick set safely. Nothing absent from this list is touched. */
  players: Array<MatchReportSquadPlayerInput>;
};

/** Input for adding a player to a kanban board */
export type AddPlayerToKanbanInput = {
  /** The ID of the kanban board to add the player to */
  kanbanBoardId: Scalars['ID']['input'];
  /** The ID of the phase to add the player to */
  kanbanPhaseId: Scalars['ID']['input'];
  /** Optional notes about this player's recruitment status */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the player to add */
  playerId: Scalars['ID']['input'];
  /** Optional tag IDs to assign to the card when creating it */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional 0-based slot to insert the card at within the phase. Cards at or after this position shift down by one. When omitted, the card is appended to the end of the phase. */
  targetPosition?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for adding a player to a watchlist */
export type AddPlayerToWatchlistInput = {
  /** The ID of the player to add */
  playerId: Scalars['ID']['input'];
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Input for adding a batch of players to a watchlist */
export type AddPlayersToWatchlistInput = {
  /** Optional slot requests for players in playerIds; honoured only where the slot exists in the formation and is free, otherwise the player lands Unassigned */
  placements?: InputMaybe<Array<WatchlistBulkPlacementInput>>;
  /** Player ids to add, at most 500 per call */
  playerIds: Array<Scalars['ID']['input']>;
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Input for adding players to a shadow team */
export type AddShadowTeamPlayersInput = {
  /** When true and `position` is omitted, resolve each player's primary position against the team's formation and place them at the matching slot. Players with no resolvable primary position are silently skipped. Ignored when `position` is provided. Throws BadRequestException when the shadow team has no formation set. */
  autoPlace?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of players to add to the shadow team (must be non-empty) */
  playerIds: Array<Scalars['ID']['input']>;
  /** Position in the formation (0-10, GK=0). When provided, places the player at that position; when omitted, the player is added to the roster pool without a position. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the shadow team to add players to */
  shadowTeamId: Scalars['ID']['input'];
};

/** Input for adding a squad planning transition */
export type AddTransitionInput = {
  /** Optional financial details for the transition */
  financialDetails?: InputMaybe<FinancialDetailsInput>;
  /** ID of the player affected by this transition */
  playerId: Scalars['ID']['input'];
  /** Type of transition: SELL, LOAN_OUT, LOAN_IN, PROMOTE, or SIGN */
  transitionType: TransitionType;
};

/** Input for adding a user to a kanban board with a specific permission role */
export type AddUserToKanbanBoardInput = {
  /** The ID of the kanban board */
  kanbanBoardId: Scalars['ID']['input'];
  /** The permission role to assign (OWNER, EDITOR, or VIEWER) */
  role: UserKanbanBoardRole;
  /** The ID of the user to add */
  userId: Scalars['ID']['input'];
};

/** Advanced PLAYER_SEASON_* competition-level stats for a player, aggregated per league and season */
export type AdvancedCompetitionStats = {
  __typename?: 'AdvancedCompetitionStats';
  /** League/competition identifier */
  leagueId: Scalars['ID']['output'];
  /** Organization identifier */
  organizationId: Scalars['ID']['output'];
  /** Player identifier */
  playerId: Scalars['ID']['output'];
  playerSeason90sPlayed?: Maybe<Scalars['Float']['output']>;
  playerSeason360Minutes?: Maybe<Scalars['Float']['output']>;
  playerSeasonAerialRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonAerialWins90?: Maybe<Scalars['Float']['output']>;
  playerSeasonAggressiveActions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonAppearances?: Maybe<Scalars['Int']['output']>;
  playerSeasonAssists90?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageF3SpaceReceivedIn?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageFhalfSpaceReceivedIn?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageLbpToSpaceDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageLbpToSpaceReceivedDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageMinutes?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageSpaceReceivedIn?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageXDefensiveAction?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageXPass?: Maybe<Scalars['Float']['output']>;
  playerSeasonAverageXPressure?: Maybe<Scalars['Float']['output']>;
  playerSeasonBackwardPassProportion?: Maybe<Scalars['Float']['output']>;
  playerSeasonBallReceiptsInSpace2Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonBallReceiptsInSpace5Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonBallReceiptsInSpace10Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonBallRecoveries90?: Maybe<Scalars['Float']['output']>;
  playerSeasonBlocksPerShot?: Maybe<Scalars['Float']['output']>;
  playerSeasonBoxCrossRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonCarries90?: Maybe<Scalars['Float']['output']>;
  playerSeasonCarryLength?: Maybe<Scalars['Float']['output']>;
  playerSeasonCarryRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonChallengeRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonChangeInPassingRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonClcaa?: Maybe<Scalars['Float']['output']>;
  playerSeasonClearance90?: Maybe<Scalars['Float']['output']>;
  playerSeasonConversionRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonCounterpressureRegains90?: Maybe<Scalars['Float']['output']>;
  playerSeasonCounterpressures90?: Maybe<Scalars['Float']['output']>;
  playerSeasonCrosses90?: Maybe<Scalars['Float']['output']>;
  playerSeasonCrossingRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonDaAggressiveDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonDeepCompletions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonDeepProgressions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonDefensiveActionRegains90?: Maybe<Scalars['Float']['output']>;
  playerSeasonDefensiveActions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonDispossessions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonDribbleFacedRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonDribbleRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonDribbledPast90?: Maybe<Scalars['Float']['output']>;
  playerSeasonDribbles90?: Maybe<Scalars['Float']['output']>;
  playerSeasonErrors90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3AverageLbpToSpaceDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3AverageLbpToSpaceReceivedDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3BallReceiptsInSpace2Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3BallReceiptsInSpace5Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3BallReceiptsInSpace10Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3Lbp90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpCompleted90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpPassRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpReceived90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpToSpace2Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpToSpace5Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpToSpace10Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpToSpace290?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpToSpace590?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3LbpToSpace1090?: Maybe<Scalars['Float']['output']>;
  playerSeasonF3ObvLbp90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFailedDribbles90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfAverageLbpToSpaceDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfAverageLbpToSpaceReceivedDistance?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfBallReceiptsInSpace2Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfBallReceiptsInSpace5Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfBallReceiptsInSpace10Ratio?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfBallRecoveries90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfCounterpressures90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfCounterpressuresRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbp90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpCompleted90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpPassRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpReceived90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpToSpace2Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpToSpace5Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpToSpace10Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpToSpace290?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpToSpace590?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfLbpToSpace1090?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfObvLbp90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfPressures90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFhalfPressuresRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonForwardPassProportion?: Maybe<Scalars['Float']['output']>;
  playerSeasonFouls90?: Maybe<Scalars['Float']['output']>;
  playerSeasonFoulsWon90?: Maybe<Scalars['Float']['output']>;
  playerSeasonGoals90?: Maybe<Scalars['Float']['output']>;
  playerSeasonGoalsFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonGsaa90?: Maybe<Scalars['Float']['output']>;
  playerSeasonGsaaRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonInterceptions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonKeyPasses90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbp90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpCompleted90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpPassRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpReceived90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpToSpace2Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpToSpace5Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpToSpace10Received90?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpToSpace290?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpToSpace590?: Maybe<Scalars['Float']['output']>;
  playerSeasonLbpToSpace1090?: Maybe<Scalars['Float']['output']>;
  playerSeasonLeftFootRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonLongBallRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonLongBalls90?: Maybe<Scalars['Float']['output']>;
  playerSeasonMinutes?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpOptimalGkDlength?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpPsxg90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpPsxgFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpShots90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpXg90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpXgFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpXgPerShot?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpg90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpga90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpotPsxgFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonNpxgxa90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObv90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObvDefensiveAction90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObvDribbleCarry90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObvGk90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObvLbp90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObvPass90?: Maybe<Scalars['Float']['output']>;
  playerSeasonObvShot90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpAssists90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpF3BackwardPassProportion?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpF3ForwardPassProportion?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpF3Passes90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpF3SidewaysPassProportion?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpKeyPasses90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpPasses90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpPassesIntoAndTouchesInsideBox90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpPassesIntoBox90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXa90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXgbuildup?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXgbuildup90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXgbuildupPerPossession?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXgchain?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXgchain90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOpXgchainPerPossession?: Maybe<Scalars['Float']['output']>;
  playerSeasonOtShotsFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonOtShotsFacedRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonOverUnderPerformance90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPPassLength?: Maybe<Scalars['Float']['output']>;
  playerSeasonPadjClearances90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPadjInterceptions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPadjPressures90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPadjTackles90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPadjTacklesAndInterceptions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassIntoDangerRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassIntoPressureRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassLength?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassLengthRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassesInsideBox90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassesIntoBox90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassesPressedRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPassingRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPenaltiesConceded90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPenaltiesFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPenaltyConversionRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPenaltyWins90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPositiveOutcome90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPositiveOutcomeScore?: Maybe<Scalars['Float']['output']>;
  playerSeasonPressureRegains90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPressuredChangeInPassLength?: Maybe<Scalars['Float']['output']>;
  playerSeasonPressuredLongBalls90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPressuredPassLengthRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPressuredPassingRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonPressures90?: Maybe<Scalars['Float']['output']>;
  playerSeasonPsPassLength?: Maybe<Scalars['Float']['output']>;
  playerSeasonRedCards90?: Maybe<Scalars['Float']['output']>;
  playerSeasonSPassLength?: Maybe<Scalars['Float']['output']>;
  playerSeasonSaveRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonSecondYellowCards90?: Maybe<Scalars['Float']['output']>;
  playerSeasonShotOnTargetRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonShotTouchRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonShotsFaced90?: Maybe<Scalars['Float']['output']>;
  playerSeasonShotsKeyPasses90?: Maybe<Scalars['Float']['output']>;
  playerSeasonSidewaysPassProportion?: Maybe<Scalars['Float']['output']>;
  playerSeasonSpAssists90?: Maybe<Scalars['Float']['output']>;
  playerSeasonSpKeyPasses90?: Maybe<Scalars['Float']['output']>;
  playerSeasonSpPassesIntoBox90?: Maybe<Scalars['Float']['output']>;
  playerSeasonSpXa90?: Maybe<Scalars['Float']['output']>;
  playerSeasonStartingAppearances?: Maybe<Scalars['Int']['output']>;
  playerSeasonTackles90?: Maybe<Scalars['Float']['output']>;
  playerSeasonTacklesAndInterceptions90?: Maybe<Scalars['Float']['output']>;
  playerSeasonThroughBalls90?: Maybe<Scalars['Float']['output']>;
  playerSeasonTotalDribbles90?: Maybe<Scalars['Float']['output']>;
  playerSeasonTouchesInsideBox90?: Maybe<Scalars['Float']['output']>;
  playerSeasonTurnovers90?: Maybe<Scalars['Float']['output']>;
  playerSeasonUnpressuredLongBalls90?: Maybe<Scalars['Float']['output']>;
  playerSeasonXa90?: Maybe<Scalars['Float']['output']>;
  playerSeasonXgbuildup?: Maybe<Scalars['Float']['output']>;
  playerSeasonXgbuildup90?: Maybe<Scalars['Float']['output']>;
  playerSeasonXgbuildupPerPossession?: Maybe<Scalars['Float']['output']>;
  playerSeasonXgchain?: Maybe<Scalars['Float']['output']>;
  playerSeasonXgchain90?: Maybe<Scalars['Float']['output']>;
  playerSeasonXgchainPerPossession?: Maybe<Scalars['Float']['output']>;
  playerSeasonXsRatio?: Maybe<Scalars['Float']['output']>;
  playerSeasonYellowCards90?: Maybe<Scalars['Float']['output']>;
  /** Season identifier */
  seasonId: Scalars['ID']['output'];
};

/** Input for archiving a SAVED contract extraction (Owner-only, status=SAVED required) */
export type ArchiveContractExtractionInput = {
  /** The type of contract document */
  documentType: DocumentType;
  /** The player whose extraction to archive */
  playerId: Scalars['ID']['input'];
};

/** Input for archiving feed updates for the calling user */
export type ArchiveFeedUpdatesInput = {
  /** Must be true. Asserts the caller intends to archive every currently-visible feed update under the active filter. */
  allCurrentlyVisible: Scalars['Boolean']['input'];
  /** Restrict archive to feed updates whose ActivityType maps to this FeedEventCategory (the same buckets the display feed uses). When null, archive applies across all categories. */
  categoryFilter?: InputMaybe<FeedEventCategory>;
};

/** Result of the archiveFeedUpdates mutation */
export type ArchiveFeedUpdatesResult = {
  __typename?: 'ArchiveFeedUpdatesResult';
  /** Number of feed-update rows soft-archived for the caller */
  archivedCount: Scalars['Int']['output'];
};

/** Input for assigning a pipeline card to an organization member, or clearing its assignment (SE-5628) */
export type AssignKanbanCardInput = {
  /** The organization member to assign the card to, or null to clear the assignment. Must be an active member of the card's organization, otherwise ASSIGNEE_NOT_IN_ORGANIZATION. */
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the pipeline card to assign */
  cardId: Scalars['ID']['input'];
};

/** A scout eligible for assignment, shaped for a person picker: a guaranteed display name plus the same-day workload count, without the watchlist payload a picker has no use for. */
export type AssignableScout = {
  __typename?: 'AssignableScout';
  /** Human-readable name for display, never null. Derived server-side as full name, falling back to the local part of the email address, falling back to the email address itself. A member with none of those is omitted from the list rather than shown under a placeholder. */
  displayName: Scalars['String']['output'];
  /** Unique identifier for the scout's user record */
  id: Scalars['ID']['output'];
  /** How many other scheduled things this scout is already assigned to on the requested date, powering the same-day conflict warning. Counts scheduled things of every kind, not only matches: a scout double-booked between a fixture and a training visit is just as conflicted, and a match-only count would silently become wrong once further kinds are registered. Zero when no date was supplied. */
  sameDayAssignmentCount: Scalars['Int']['output'];
  /** The scout's job title, when recorded */
  title?: Maybe<Scalars['String']['output']>;
};

/** A scout assigned to a scheduled thing. Carries no match-specific fields, so one fragment renders assignments across all present and future scheduled-thing kinds. */
export type Assignment = Node & {
  __typename?: 'Assignment';
  /** The scout carrying out the assignment */
  assigneeUser: User;
  /** Timestamp of assignment creation */
  createdAt: Scalars['DateTime']['output'];
  /** Optional deadline for the assignment. A genuine instant, unlike the scheduled thing's own civil date and time. */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the assignment */
  id: Scalars['ID']['output'];
  /** The thing being covered, as the polymorphic interface. Resolves to Match for match assignments and to GenericScheduledThing for any kind without a dedicated type. */
  scheduledThing: ScheduledThing;
  /** Lifecycle state of this scout's commitment */
  status: AssignmentStatus;
  /** Timestamp of last assignment update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Connection type for paginated Assignment results */
export type AssignmentConnection = Connection & {
  __typename?: 'AssignmentConnection';
  /** A list of edges */
  edges: Array<AssignmentEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for Assignment connection */
export type AssignmentEdge = Edge & {
  __typename?: 'AssignmentEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Assignment node */
  node: Assignment;
};

/** Filter for listing assignments. Expresses both 'who is covering this thing' and 'what is this scout doing on these dates' without naming a match, so the same query serves every scheduled-thing kind. */
export type AssignmentFilterInput = {
  /** Restrict to assignments held by these scouts. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Earliest scheduled civil date to include, ISO-8601 (YYYY-MM-DD), inclusive. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to these scheduled-thing kinds. Omit to include every kind, which is the correct default for a scout's calendar and for conflict detection. */
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to assignments against these scheduled things. For a match, pass the match's scheduledThing id. */
  scheduledThingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to assignments in any of these lifecycle states. */
  statuses?: InputMaybe<Array<AssignmentStatus>>;
  /** Latest scheduled civil date to include, ISO-8601 (YYYY-MM-DD), inclusive. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** Lifecycle of a scout's assignment to a scheduled thing: ASSIGNED (default), ACCEPTED, DECLINED, COMPLETED or CANCELLED. */
export enum AssignmentStatus {
  Accepted = 'ACCEPTED',
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED'
}

export enum AuthAllow {
  Groups = 'groups',
  Private = 'private'
}

export type AuthRule = {
  allow: AuthAllow;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requireOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of successful authentication */
export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  /** JWT access token for API requests */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Token expiration time in seconds */
  expiresIn?: Maybe<Scalars['Int']['output']>;
  /** JWT ID token containing user claims */
  idToken?: Maybe<Scalars['String']['output']>;
  /** Metadata for newly registered device */
  newDeviceMetadata?: Maybe<NewDeviceMetadata>;
  /** Refresh token for obtaining new access tokens */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** Type of token (typically 'Bearer') */
  tokenType?: Maybe<Scalars['String']['output']>;
};

/** Authentication result with status message */
export type AuthenticationResultWithMessage = {
  __typename?: 'AuthenticationResultWithMessage';
  /** The authentication result data */
  data?: Maybe<AuthenticationResult>;
  /** User-friendly status message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Basic competition-level stats for a player from Transfermarkt, aggregated per league and season */
export type BasicCompetitionStats = {
  __typename?: 'BasicCompetitionStats';
  /** Number of appearances */
  basicAppearances?: Maybe<Scalars['Float']['output']>;
  /** Number of assists */
  basicAssists?: Maybe<Scalars['Float']['output']>;
  /** Number of goals scored */
  basicGoals?: Maybe<Scalars['Float']['output']>;
  /** Number of times in squad */
  basicInSquad?: Maybe<Scalars['Float']['output']>;
  /** Total minutes played */
  basicMinutes?: Maybe<Scalars['Float']['output']>;
  /** Points per game */
  basicPpg?: Maybe<Scalars['Float']['output']>;
  /** Number of red cards */
  basicReds?: Maybe<Scalars['Float']['output']>;
  /** Number of second yellow cards */
  basicSecondYellows?: Maybe<Scalars['Float']['output']>;
  /** Number of times substituted off */
  basicSubsOff?: Maybe<Scalars['Float']['output']>;
  /** Number of times substituted on */
  basicSubsOn?: Maybe<Scalars['Float']['output']>;
  /** Number of yellow cards */
  basicYellows?: Maybe<Scalars['Float']['output']>;
  /** League/competition identifier */
  leagueId: Scalars['ID']['output'];
  /** Organization identifier */
  organizationId: Scalars['ID']['output'];
  /** Player identifier */
  playerId: Scalars['ID']['output'];
  /** Season identifier */
  seasonId: Scalars['ID']['output'];
};

/** Specifies the position of a card within a phase */
export type CardPosition = {
  /** The ID of the card */
  cardId: Scalars['ID']['input'];
  /** The new position for this card (0-based index) */
  position: Scalars['Int']['input'];
};

/** Definition of a categorical metric available for column display and sorting */
export type CategoricalMetricDefinition = {
  __typename?: 'CategoricalMetricDefinition';
  /** Category for UI grouping: "outfield" or "goalkeeper" */
  category: Scalars['String']['output'];
  /** bioData field name e.g. "carryingTransGlobalCategoricalScore" */
  key: Scalars['String']['output'];
  /** Display name e.g. "Carrying" */
  label: Scalars['String']['output'];
  /** SortField enum value for sorting by this metric */
  sortField: SortField;
};

/** Input for responding to authentication challenges */
export type ChallengeInput = {
  /** The type of challenge being responded to */
  challengeName: ChallengeNameType;
  /** Key-value pairs containing challenge responses */
  challengeResponses: Scalars['JSONObject']['input'];
  /** The session token from the challenge request */
  session: Scalars['String']['input'];
};

/** Challenge name types for Cognito authentication */
export enum ChallengeNameType {
  CustomChallenge = 'CUSTOM_CHALLENGE',
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  SmsMfa = 'SMS_MFA',
  SoftwareTokenMfa = 'SOFTWARE_TOKEN_MFA'
}

/** Parameters returned with authentication challenge */
export type ChallengeParametersResult = {
  __typename?: 'ChallengeParametersResult';
  /** Username associated with the challenge */
  USERNAME?: Maybe<Scalars['String']['output']>;
  /** Number of attempts made */
  attempts?: Maybe<Scalars['String']['output']>;
  /** Number of attempts remaining */
  attemptsLeft?: Maybe<Scalars['String']['output']>;
  /** Email address associated with the challenge */
  email?: Maybe<Scalars['String']['output']>;
  /** Maximum number of attempts allowed */
  maxAttempts?: Maybe<Scalars['String']['output']>;
};

/** Result of authentication challenge */
export type ChallengeResult = {
  __typename?: 'ChallengeResult';
  /** Name of the challenge type */
  ChallengeName?: Maybe<Scalars['String']['output']>;
  /** Parameters associated with the challenge */
  ChallengeParameters?: Maybe<ChallengeParametersResult>;
  /** Session token for the challenge */
  Session?: Maybe<Scalars['String']['output']>;
};

/** Claims ownership of a legacy scenario that has no owner; rejected when the revision moved or an owner already exists */
export type ClaimScenarioOwnershipInput = {
  /** Revision the client read; the claim is refused with SCENARIO_REVISION_CONFLICT when it moved */
  expectedRevision: Scalars['Int']['input'];
  /** Scenario to claim */
  scenarioId: Scalars['ID']['input'];
};

/** Withdraws a club's first-season-after-relegation assertion, returning it to 'nobody has answered'. Distinct from asserting false: an unresolved status withholds BOTH SCMP rules rather than selecting the 50% standard. Requires compliance Tier 1. */
export type ClearComplianceClubFirstSeasonAfterRelegationInput = {
  /** The club to configure. Defaults to the caller's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for closing a pipeline card into a terminal stage */
export type CloseKanbanCardToTerminalStageInput = {
  /** The ID of the pipeline card to close */
  cardId: Scalars['ID']['input'];
  /** The terminal outcome to record. Must be one of the board's validOutcomes. */
  outcome: KanbanCardOutcome;
  /** Required reason; trimmed server-side. Empty after trim is rejected with REASON_REQUIRED. */
  reason: Scalars['String']['input'];
  /** The terminal stage on the SAME pipeline to close into. Never defaulted by the backend. */
  targetPhaseId: Scalars['ID']['input'];
};

/** One club Objective — an Internal-layer rule on a metric, with its target, warning band and KPI flag. */
export type ClubObjective = {
  __typename?: 'ClubObjective';
  /** The amber warning boundary, or null for a green/red-only Objective. Null is an absent band, never a band at zero. */
  amberThreshold?: Maybe<Scalars['Float']['output']>;
  /** The timeframe it is assessed over. */
  assessmentWindow: ComplianceAssessmentWindow;
  /** SE-8663: the descriptive text naming what this Objective's figure is measured against — 'UEFA football earnings basis' for a PSR-shaped Objective. Null means no basis label is configured; there is no forced default. */
  basisLabel?: Maybe<Scalars['String']['output']>;
  /** The targeted metric's category. Carried here because PRD 5.4 admits only FINANCIAL rules to the Compliance tab's Objectives column. */
  category: ComplianceMetricCategory;
  /** How the value is compared to the target. */
  comparator: ComplianceComparator;
  /** The Objective. */
  id: Scalars['ID']['output'];
  /** Whether it participates in evaluation. */
  isEnabled: Scalars['Boolean']['output'];
  /** The metric it targets. */
  metricId: Scalars['ID']['output'];
  /** The metric's display name. */
  metricName: Scalars['String']['output'];
  /** The Objective's display name. */
  name: Scalars['String']['output'];
  /** The club that owns it. */
  organizationId: Scalars['ID']['output'];
  /** Whether it renders as a KPI card. PRD 7: a KPI is not an entity, it is this flag on a Rule. */
  showKpi: Scalars['Boolean']['output'];
  /** The target itself. */
  threshold: Scalars['Float']['output'];
};

/** AWS Cognito user account information including status and attributes */
export type CognitoUser = {
  __typename?: 'CognitoUser';
  /** User attributes (alternate field name used in some Cognito responses) */
  Attributes?: Maybe<Array<CognitoUserAttribute>>;
  /** Whether the user account is enabled */
  Enabled: Scalars['Boolean']['output'];
  /** User attributes from ListUsers API response */
  UserAttributes?: Maybe<Array<CognitoUserAttribute>>;
  /** User account status in Cognito */
  UserStatus: CognitoUserStatus;
  /** Cognito username (typically a UUID or phone number) */
  Username: Scalars['String']['output'];
};

/** AWS Cognito user attribute key-value pair (e.g., email, phone_number, custom attributes) */
export type CognitoUserAttribute = {
  __typename?: 'CognitoUserAttribute';
  /** Attribute name/key (e.g., "email", "phone_number", "custom:field") */
  Name: Scalars['String']['output'];
  /** Attribute value */
  Value: Scalars['String']['output'];
};

/** AWS Cognito user account status values */
export enum CognitoUserStatus {
  Confirmed = 'CONFIRMED',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN'
}

/** Column metadata including type, constraints, relationships, and value information */
export type ColumnInfoModel = {
  __typename?: 'ColumnInfoModel';
  /** Foreign key relationship if this column references another table */
  foreignKey?: Maybe<ForeignKeyInfoModel>;
  /** Whether this column is part of the primary key */
  isPrimaryKey: Scalars['Boolean']['output'];
  /** JSONB schema structure discovered through data sampling; only present for jsonb columns */
  jsonSchema?: Maybe<JsonSchemaModel>;
  /** Column name as defined in the database */
  name: Scalars['String']['output'];
  /** Whether the column allows NULL values */
  nullable: Scalars['Boolean']['output'];
  /** PostgreSQL data type (varchar, integer, uuid, jsonb, timestamp, etc.) */
  type: Scalars['String']['output'];
  /** Unique values for low-cardinality columns; null if more than 200 unique values exist */
  uniqueValues?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents a comment on a player note supporting threaded discussions and collaboration */
export type Comment = Node & {
  __typename?: 'Comment';
  /** Comment text content (max 300 chars) */
  body: Scalars['String']['output'];
  /** Timestamp of comment creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for comment */
  id: Scalars['ID']['output'];
  note: Note;
  /** Foreign key to associated note */
  noteId: Scalars['ID']['output'];
  /** Timestamp of last comment update */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** Foreign key to user who created comment */
  userId: Scalars['ID']['output'];
};

/** A connection to a list of comments */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges */
  edges: Array<CommentEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a CommentConnection */
export type CommentEdge = Edge & {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Comment node */
  node: Comment;
};

/** Cup or continental competition (e.g. UCL, UEL, UECL) separate from domestic leagues */
export type Competition = Node & {
  __typename?: 'Competition';
  /** Short code, e.g. UCL, UEL, UECL */
  code?: Maybe<Scalars['String']['output']>;
  /** External competition ID from data provider */
  competitionGGID?: Maybe<Scalars['String']['output']>;
  /** Timestamp of competition record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Gender division of the competition */
  gender: Gender;
  /** Unique identifier for the competition */
  id: Scalars['ID']['output'];
  /** Competition display name */
  name: Scalars['String']['output'];
  /** Timestamp of last competition record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of competitions */
export type CompetitionConnection = {
  __typename?: 'CompetitionConnection';
  /** A list of edges */
  edges: Array<CompetitionEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a CompetitionConnection */
export type CompetitionEdge = Edge & {
  __typename?: 'CompetitionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Competition node */
  node: Competition;
};

/** The time window a compliance Rule is assessed over. A property of the Rule, not of the review cadence. */
export enum ComplianceAssessmentWindow {
  PointInTime = 'POINT_IN_TIME',
  ReportingYear = 'REPORTING_YEAR',
  RollingThreeYears = 'ROLLING_THREE_YEARS',
  SeasonToDate = 'SEASON_TO_DATE'
}

/** One club's compliance calendar: the month its reporting (fiscal) year opens and the month its season opens. Absent entirely for a club that has not configured one. */
export type ComplianceClubCalendar = {
  __typename?: 'ComplianceClubCalendar';
  /** Month (1-12) the club's REPORTING (fiscal) year starts. Drives the REPORTING_YEAR assessment window — SCR's window per PRD 9(2). */
  fiscalYearStartMonth: Scalars['Int']['output'];
  /** The calendar row. */
  id: Scalars['ID']['output'];
  /** The club it configures. */
  organizationId: Scalars['ID']['output'];
  /** Month (1-12) the club's SEASON starts. Drives the SEASON_TO_DATE window — the wage-budget window per PRD 9(2). Separate from the fiscal year on purpose. */
  seasonStartMonth: Scalars['Int']['output'];
  /** When the calendar was last written. Changing a boundary changes which months every non-point-in-time window spans, so when it changed is part of reading a figure. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A club's authored domestic competition — the league a Tier 1 user says it plays in — and the regime edition that league currently resolves to. Absent entirely for a club that has configured none. */
export type ComplianceClubSetup = {
  __typename?: 'ComplianceClubSetup';
  /** The league the club plays in, as authored. Divisions are separate league rows, so this identifies the division. */
  domesticLeagueId: Scalars['ID']['output'];
  /** The regime edition now in force for the club, or null when the league resolves to none. */
  domesticRegimeId?: Maybe<Scalars['ID']['output']>;
  /** Whether that league resolved to exactly one enabled domestic regime edition. NOT_ENROLLED means no package is published for the league, or its edition is disabled — not that the competition is unset. */
  domesticRegimeState: ComplianceDomesticRegimeState;
  /** Whether the club is in its first season after relegation, as authored by a Tier 1 user. THREE-valued: true selects the EFL SCMP 65% relevant percentage, false is a positive assertion that it is not (50% standard), and null means nobody has answered — which withholds BOTH League One SCMP rules rather than defaulting. null and false are different answers; only one of them yields a verdict. */
  firstSeasonAfterRelegation?: Maybe<Scalars['Boolean']['output']>;
  /** The club it configures. */
  organizationId: Scalars['ID']['output'];
  /** When the club's competition was last stated. A division change is an update here, and it supersedes the previous enrolment rather than adding to it. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A regulatory circumstance a compliance Rule may condition its applicability on. A closed allowlist — a predicate naming an unknown status is unwritable. */
export enum ComplianceClubStatus {
  FirstSeasonAfterRelegation = 'FIRST_SEASON_AFTER_RELEGATION'
}

/** How a compliance Rule threshold, or a metric operand filter, compares an observed value to its configured value. */
export enum ComplianceComparator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ'
}

/** Whether a rule's measured value reflects every input (COMPLETE), only a lower bound because some subject rows were missing a summed quantity (INCOMPLETE, never GREEN), or no value was reached at all (NOT_CONFIGURED). */
export enum ComplianceCompleteness {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  NotConfigured = 'NOT_CONFIGURED'
}

/** What would clear one breached compliance Rule. Computed server-side so the remedy reads identically wherever it renders — clients must not re-derive it. */
export type ComplianceComputedFix = {
  __typename?: 'ComplianceComputedFix';
  /** COMPUTED when a remedy was produced, UNCOMPUTABLE when none could be. Every numeric field below is null unless this is COMPUTED — there is no partially-populated fix. */
  availability: ComplianceFixAvailability;
  /** Whether applying requiredChange actually satisfies the rule. False only for a continuous metric under a strict bound, where no smallest clearing change exists — render 'must go below X' rather than 'reduce by exactly X'. A COUNT metric under a strict bound reports TRUE, because a whole-unit step genuinely clears it. */
  clearsRule: Scalars['Boolean']['output'];
  /** Which way the metric must move. Read this rather than the sign of requiredChange — a strict rule sitting exactly on its boundary is in breach with a required change of zero, which has no sign to read. */
  direction?: Maybe<ComplianceFixDirection>;
  /** Whether targetValue must be PASSED rather than merely reached — true for the strict comparators LT and GT. A property of the RULE; see clearsRule for whether the answer satisfies it. */
  isTargetExclusive: Scalars['Boolean']['output'];
  /** The same remedy in the numerator's units — the actionable currency figure. Null when the metric has no closed-form inversion, which does NOT mean the fix failed: the metric-level change above still stands. */
  numeratorChange?: Maybe<ComplianceFixNumeratorChange>;
  /** Why numeratorChange is null, or null when it is present. SE-7202 — distinguishes the benign case (the metric does not divide, so there is nothing more to say) from the deliberate refusal (the numerator is a weighted or multi-term sum, so any remedy stated against it would be wrong by the coefficient). Do NOT compute the missing figure client-side when this is set; the server withheld it on purpose. */
  numeratorUnavailableReason?: Maybe<ComplianceInversionUnavailableReason>;
  /** Why no fix was computed. Empty if and only if availability is COMPUTED, so a client never renders 'no fix' with nothing named. NOT_BREACHED is the ordinary healthy case, not an error. */
  reasons: Array<ComplianceFixUncomputableReason>;
  /** How far the metric must move, in `unit`, as a NON-NEGATIVE magnitude. Rounded to a whole number when unit is COUNT, always AWAY from the breach — a club cannot sign 2.5 players, and rounding the other way would publish a remedy that leaves the rule red. */
  requiredChange?: Maybe<Scalars['Float']['output']>;
  /** The same remedy restated as the capital gain a player sale would have to realise — PRD 6.2's 'or offset via a sale worth ~EUR 35M capital gain'. PSR ONLY: null on the Squad Cost Ratio and on every other cost-ratio rule, where a sale gives cost-side relief only and the income side is CFO-entered adjusted revenue the module must never re-derive. Null does NOT mean the fix failed — the cost-side remedy above still stands. */
  saleOffset?: Maybe<ComplianceFixSaleOffset>;
  /** The value that satisfies the rule — the rule's own threshold, carried so a renderer can print 'to <=70%' without re-deriving which bound applies. */
  targetValue?: Maybe<Scalars['Float']['output']>;
  /** What requiredChange and targetValue are denominated in. PERCENTAGE renders '8.4 percentage points' where COUNT renders '2 players'. */
  unit: ComplianceQuantityUnit;
};

/** One club-entered per-player count/flag — homegrown status today. */
export type ComplianceCountEntry = {
  __typename?: 'ComplianceCountEntry';
  /** Which per-player attribute this entry supplies. */
  attribute: ComplianceFilterAttribute;
  /** The entry. */
  id: Scalars['ID']['output'];
  /** The club it belongs to. */
  organizationId: Scalars['ID']['output'];
  /** When the entry was recorded. */
  recordedAt: Scalars['DateTime']['output'];
  /** The player it's about. */
  subjectId: Scalars['ID']['output'];
  /** The entered value — 1/0 for a flag. */
  value: Scalars['Float']['output'];
};

/** Which figure actually stood in as a rule's denominator, when it was not the one the regulation names. Null on every rule whose denominator is the real figure. */
export enum ComplianceDenominatorSource {
  AdjustedRevenueFallback = 'ADJUSTED_REVENUE_FALLBACK'
}

/** Whether a club's domestic compliance layer resolved to exactly one regime. AMBIGUOUS withholds the domestic layer entirely rather than choosing between contradictory enrolments. */
export enum ComplianceDomesticRegimeState {
  Ambiguous = 'AMBIGUOUS',
  InForce = 'IN_FORCE',
  NotEnrolled = 'NOT_ENROLLED'
}

/** One contributing row behind a computed value. Drivers are only ever returned for a metric the viewer is permitted to see. */
export type ComplianceDriver = {
  __typename?: 'ComplianceDriver';
  /** Its display name. */
  label: Scalars['String']['output'];
  /** Its share of the computed total, 0-100. Null when the total is zero or the measure has no meaningful share. */
  sharePercent?: Maybe<Scalars['Float']['output']>;
  /** The contributing subject — the player id. */
  subjectId: Scalars['ID']['output'];
  /** The unit of `value` — SE-8376. A dividing metric (ratio/share) reports its drivers in the NUMERATOR's unit, not the rule's own unit: a Squad Cost Ratio driver is CURRENCY even though the rule itself is a PERCENTAGE. A non-dividing metric (count/sum/average) reports its drivers in the metric's own unit. */
  unit: ComplianceQuantityUnit;
  /** Its contribution, in the metric's units. */
  value: Scalars['Float']['output'];
};

/** One quantity excluded from a SUM as a lower bound, rather than blocking the value. Disjoint from missingInputs — a rule's value is never null when this list is non-empty. */
export type ComplianceExcludedInput = {
  __typename?: 'ComplianceExcludedInput';
  /** The quantity excluded from the sum on at least one subject row. */
  quantity: ComplianceQuantity;
  /** How many subject rows lacked it. */
  subjectCount: Scalars['Int']['output'];
};

/** Whether a field the viewer IS permitted to see has a value behind it. A field the viewer may NOT see is absent from the payload entirely and never carries this marker. */
export enum ComplianceFieldState {
  Configured = 'CONFIGURED',
  Unconfigured = 'UNCONFIGURED'
}

/** The attribute a compliance metric operand's optional WHERE clause tests. */
export enum ComplianceFilterAttribute {
  Age = 'AGE',
  DateOfBirth = 'DATE_OF_BIRTH',
  HomegrownStatus = 'HOMEGROWN_STATUS',
  Nationality = 'NATIONALITY',
  PositionCategory = 'POSITION_CATEGORY',
  SquadStatus = 'SQUAD_STATUS'
}

/** One CFO-entered club financial figure, effective-dated, with the FX conversion that produced it. */
export type ComplianceFinancialFigure = {
  __typename?: 'ComplianceFinancialFigure';
  /** The figure in the club's reporting currency, converted. */
  amount: Scalars['Float']['output'];
  /** The date from which this figure is true, YYYY-MM-DD. */
  effectiveFrom: Scalars['String']['output'];
  /** The rate applied at entry. */
  fxRate: Scalars['Float']['output'];
  /** The figure. */
  id: Scalars['ID']['output'];
  /** The figure as the CFO actually entered it, before conversion. */
  nativeAmount: Scalars['Float']['output'];
  /** The currency the figure was entered in. */
  nativeCurrency: CurrencyCode;
  /** The club it's about. */
  organizationId: Scalars['ID']['output'];
  /** Which quantity this figure supplies. */
  quantity: ComplianceQuantity;
  /** When this row was entered — the TRANSACTION-time axis (entity `recordedAt`), distinct from effectiveFrom. SE-7586: the only reliable way for a multi-row read (complianceFinancialFigures) to break a tie between two rows that share an effectiveFrom — array order from a query ordered only by effectiveFrom carries no such guarantee. */
  recordedAt: Scalars['DateTime']['output'];
  /** The club's reporting currency as at entry. */
  reportingCurrency: CurrencyCode;
  /** Why the past figure was restated, when it was. */
  restatementNote?: Maybe<Scalars['String']['output']>;
  /** The figure this one explicitly restates, or null for an ordinary entry. */
  restatesId?: Maybe<Scalars['ID']['output']>;
};

/** Whether a computed fix was produced. A rule the viewer may not see carries no fix at all — the whole rule is absent — so this marker only ever distinguishes 'here is the remedy' from 'here is why there is none'. */
export enum ComplianceFixAvailability {
  Computed = 'COMPUTED',
  Uncomputable = 'UNCOMPUTABLE'
}

/** Which way a figure must move to clear a breach. DERIVED FROM THE COMPARATOR, not from the sign of `deviation` — a cap and a floor report the same raw sign for opposite health, and a strict rule sitting exactly on its boundary is in breach with a deviation of zero. */
export enum ComplianceFixDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

/** A breach's remedy expressed in the units of the metric's numerator — the 'cut EUR 21.0M of squad cost' figure. Absent when the metric does not divide, or when its terms name a quantity the viewer may not see. */
export type ComplianceFixNumeratorChange = {
  __typename?: 'ComplianceFixNumeratorChange';
  /** What the figure is now. */
  currentValue: Scalars['Float']['output'];
  /** Which way the figure must move. */
  direction: ComplianceFixDirection;
  /** What to call this figure on a card — e.g. 'squad cost'. */
  label: Scalars['String']['output'];
  /** How far it must move, as a NON-NEGATIVE magnitude. Compose the sentence from `direction` + this — never from a sign. */
  requiredChange: Scalars['Float']['output'];
  /** What it must become for the rule to be satisfied. */
  targetValue: Scalars['Float']['output'];
  /** What all three figures are denominated in. */
  unit: ComplianceQuantityUnit;
};

/** A breach's remedy restated as the capital gain a player sale would have to realise. PSR only — absent on cost-ratio rules, where a sale gives cost-side relief and the income side is a regulator adjustment the module never re-derives. */
export type ComplianceFixSaleOffset = {
  __typename?: 'ComplianceFixSaleOffset';
  /** The capital gain that would clear the breach, as a NON-NEGATIVE magnitude. Equal to the fix's own requiredChange — a 1:1 restatement, not a second computation. Whether it actually satisfies the rule is the fix's clearsRule, unchanged. */
  capitalGain: Scalars['Float']['output'];
  /** Which way the result must move — always INCREASE. A capital gain can only improve a result, so a rule whose figure must come DOWN carries no sale offset at all. */
  direction: ComplianceFixDirection;
  /** What to call this figure on a card — 'capital gain'. Render it: the figure is a gain OVER net book value (fee received - NBV), not a sale price, and a card that says 'sell for X' understates the transfer required. */
  label: Scalars['String']['output'];
  /** What capitalGain is denominated in — CURRENCY, always. */
  unit: ComplianceQuantityUnit;
};

/** Why a computed fix was withheld. Every UNCOMPUTABLE fix carries at least one, so a client never renders 'no fix' with nothing named. */
export enum ComplianceFixUncomputableReason {
  NotBreached = 'NOT_BREACHED',
  NoMeasuredValue = 'NO_MEASURED_VALUE',
  NoMinimalChange = 'NO_MINIMAL_CHANGE',
  NoVerdict = 'NO_VERDICT',
  UnreadableThreshold = 'UNREADABLE_THRESHOLD'
}

/** The Compliance tab's Foreigner KPI card: a measured foreign-vs-domestic first-team headcount, with no verdict and no invented threshold. */
export type ComplianceForeignPlayerCount = {
  __typename?: 'ComplianceForeignPlayerCount';
  /** Every classified first-team player, foreign and domestic together — the drill-through dialog's source list (AC 3). */
  breakdown: Array<ComplianceForeignPlayerRow>;
  /** The club's enrolled domestic country this was measured against, or null when the club has not authored a domestic competition (SE-7203). */
  clubCountry?: Maybe<Scalars['String']['output']>;
  /** First-team players classified domestic. 0 when hasAnyInput is false — an unmeasured placeholder, not a measurement. */
  domesticCount: Scalars['Int']['output'];
  /** First-team players classified foreign. 0 when hasAnyInput is false — an unmeasured placeholder, not a measurement. */
  foreignCount: Scalars['Int']['output'];
  /** False means 'cannot be measured' — no authored club country, or no first-team player has a nationality on file — and is the ONLY condition under which the card may render an awaiting state (AC 6b). True means the counts and breakdown are real and must always be shown (AC 6): this field, not an absent/null card, is what a client renders the awaiting copy from. */
  hasAnyInput: Scalars['Boolean']['output'];
};

/** One first-team player behind the Foreigner KPI card's count, with the nationality it was classified against. */
export type ComplianceForeignPlayerRow = {
  __typename?: 'ComplianceForeignPlayerRow';
  /** True when this player's nationality differs from the club's enrolled country; false when it matches. */
  isForeign: Scalars['Boolean']['output'];
  /** Display name. */
  label: Scalars['String']['output'];
  /** The nationality name it was classified against, as recorded. */
  nationalityName: Scalars['String']['output'];
  /** The player. */
  subjectId: Scalars['ID']['output'];
};

/** One figure the viewer is permitted to see, marked CONFIGURED or UNCONFIGURED. A figure the viewer may NOT see is absent from the list entirely rather than appearing with a null value. */
export type ComplianceGatedQuantity = {
  __typename?: 'ComplianceGatedQuantity';
  /** Which quantity this is. */
  quantity: ComplianceQuantity;
  /** The minimum tier it demands. Always satisfied by the viewer, or the entry would be absent. */
  requiredTier: ComplianceSensitivityTier;
  /** CONFIGURED when a figure was entered, UNCONFIGURED when the viewer may see the field but nothing has been entered. Render the value for the former and a 'not configured' call to action for the latter. */
  state: ComplianceFieldState;
  /** What the value is denominated in. */
  unit: ComplianceQuantityUnit;
  /** The figure, or null when UNCONFIGURED. Null is NEVER a zero — an unentered revenue is not a club that earned nothing. Null appears if and only if state is UNCONFIGURED. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Why a compliance metric published no linear inversion terms. Every computation without terms carries exactly one, so 'no numerator remedy' is never an unstated absence. */
export enum ComplianceInversionUnavailableReason {
  MetricUncomputable = 'METRIC_UNCOMPUTABLE',
  MultiTermNumerator = 'MULTI_TERM_NUMERATOR',
  NoDividingMeasure = 'NO_DIVIDING_MEASURE',
  UnusableTerms = 'UNUSABLE_TERMS',
  WeightedNumerator = 'WEIGHTED_NUMERATOR',
  ZeroDenominator = 'ZERO_DENOMINATOR'
}

/** SE-8798: one figure a rule the app cannot verify can still state — e.g. 'Player salaries' and '50% of club revenue' on an EFL Salary Cost Management Protocol card. Informational only: it is NOT the rule's value and carries no verdict or colour. */
export type ComplianceKnownFigure = {
  __typename?: 'ComplianceKnownFigure';
  /** True when some squad rows lack the input (e.g. a player with no wage entered), so `value` is a lower bound — render it as 'at least <value>'. Always false when `value` is null. */
  isLowerBound: Scalars['Boolean']['output'];
  /** The card's label for the figure, e.g. 'Player salaries' or '50% of club revenue'. Render verbatim. */
  label: Scalars['String']['output'];
  /** What `value` is denominated in — the same enum as ComplianceRuleEvaluation.unit / numeratorUnit (CURRENCY for both SCMP figures). */
  unit: ComplianceQuantityUnit;
  /** The figure, in `unit`. NULL when it cannot be stated — an input nobody has entered (e.g. club revenue), or one the viewer's tier may not see. Never a substituted zero: render an explicit 'not entered' state for null. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The visible rules of one compliance layer. A layer with no visible rules is omitted rather than returned empty. */
export type ComplianceLayerGroup = {
  __typename?: 'ComplianceLayerGroup';
  /** Its rules, in registry order. */
  evaluations: Array<ComplianceRuleEvaluation>;
  /** The layer. */
  layer: ComplianceRuleLayer;
};

/** Whether a compliance metric is squad-shaped or financial. Financial Objectives render on the Compliance tab; squad ones do not. */
export enum ComplianceMetricCategory {
  Financial = 'FINANCIAL',
  Squad = 'SQUAD'
}

/** Whether a compliance registry metric is computed by registered code or by the declarative operand model. */
export enum ComplianceMetricKind {
  BuiltIn = 'BUILT_IN',
  UserBuilt = 'USER_BUILT'
}

/** The aggregation a user-built compliance metric applies to its operands. */
export enum ComplianceMetricMeasure {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Ratio = 'RATIO',
  Share = 'SHARE'
}

/** One metric in the registry, backing the METRIC selector. Metrics whose inputs the viewer may not see are absent entirely. */
export type ComplianceMetricSummary = {
  __typename?: 'ComplianceMetricSummary';
  /** The grouping the metric picker files it under. */
  category: ComplianceMetricCategory;
  /** The metric. */
  id: Scalars['ID']['output'];
  /** Whether this metric is global (available to every club) rather than authored by one club. */
  isGlobal: Scalars['Boolean']['output'];
  /** Code-backed (BUILT_IN) or authored through the builder (USER_BUILT). */
  kind: ComplianceMetricKind;
  /** Its display name. */
  name: Scalars['String']['output'];
  /** The tier a viewer must hold to see this metric — DERIVED from its inputs, not trusted from its stored column, and only ever made stricter by that column. */
  requiredTier: ComplianceSensitivityTier;
};

/** One operand's optional filter: attribute x comparator x value. Exactly one filter per operand (PRD 4.6). */
export type ComplianceOperandFilterInput = {
  /** What the filter tests — age, position category, squad status. */
  attribute: ComplianceFilterAttribute;
  /** How the attribute is compared to the value. */
  comparator: ComplianceComparator;
  /** The value when the attribute is numeric (AGE). Mutually exclusive with textValue. */
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  /** The value when the attribute is textual (POSITION_CATEGORY, SQUAD_STATUS). Mutually exclusive with numericValue. */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

/** One operand of a user-built metric: a quantity and at most one filter. */
export type ComplianceOperandInput = {
  /** The optional WHERE clause. Omit for an operand that ranges over every row. Only subject-scoped quantities can be filtered. */
  filter?: InputMaybe<ComplianceOperandFilterInput>;
  /** The raw quantity this operand addresses. */
  quantity: ComplianceQuantity;
};

/** One club's compliance picture for one viewer, gated to that viewer's sensitivity tier. */
export type ComplianceOverview = {
  __typename?: 'ComplianceOverview';
  /** Visible rules in AMBER or RED. Counted per rule and over VISIBLE rules only, so the count cannot disclose a gated rule. An unconfigured rule never alerts. */
  alertCount: Scalars['Int']['output'];
  /** The instant this picture describes. */
  asOf: Scalars['DateTime']['output'];
  /** Visible rules in RED. Counted over visible rules only, for the same reason as alertCount. */
  breachCount: Scalars['Int']['output'];
  /** The club-scoped figures this viewer may see, each positively marked CONFIGURED or UNCONFIGURED. */
  clubQuantities: Array<ComplianceGatedQuantity>;
  /** Whether the club's DOMESTIC layer resolved to exactly one regime. An absent DOMESTIC group in `layers` has three different causes and this names which: NOT_ENROLLED (no enabled domestic regime), IN_FORCE (one, and its rules are present), or AMBIGUOUS (two or more contradictory enrolments, so the whole layer is withheld rather than resolved by guessing). Ungated — it is a configuration fact, not a figure. */
  domesticRegimeState: ComplianceDomesticRegimeState;
  /** SE-8204: the Foreigner KPI card's data, computed independently of `layers` — present whether or not any Rule targets the underlying metric, so the card can render a measured value with no verdict until a regulator threshold exists. */
  foreignPlayerCount: ComplianceForeignPlayerCount;
  /** Whether the club has configured a season/fiscal calendar. False means every history window is unresolvable and its rules report NO_CLUB_CALENDAR — a configuration gap, not a computed answer. */
  isCalendarConfigured: Scalars['Boolean']['output'];
  /** Whether this picture is a scenario projection rather than current-squad actuals. */
  isScenarioProjection: Scalars['Boolean']['output'];
  /** The visible rules, grouped by layer. Empty when nothing is configured. */
  layers: Array<ComplianceLayerGroup>;
  /** The club this picture describes. */
  organizationId: Scalars['ID']['output'];
  /** Every quantity this viewer may see — an allow-list, never a deny-list. A quantity absent from this list is absent from the whole payload, which is how a client renders NOTHING for it rather than a 'not configured' call to action. */
  permittedQuantities: Array<ComplianceQuantity>;
  /** How many rules the viewer can see at all. */
  ruleCount: Scalars['Int']['output'];
  /** The Squad Planning scenario projected, or null for Current Squad actuals. */
  scenarioId?: Maybe<Scalars['ID']['output']>;
  /** The tier this payload was built for. Carried so a client knows what it is looking at without inferring it from what is missing, and so a mid-session downgrade takes effect on the very next response. */
  viewerTier: ComplianceSensitivityTier;
};

/** Why a compliance evaluation withheld a verdict. Every non-verdict state carries at least one of these, so a client never renders an unexplained partial. NOT_VERIFIABLE (SE-8798) means the app cannot verify the rule at all — it needs figures the app has no entry point for (named in ComplianceRuleEvaluation.unverifiableFigures). It is always the FIRST reason when present: render the not-verifiable text instead of a number, never a colour, and never count the rule as an alert or breach. */
export enum CompliancePartialReason {
  ClubFiguresNotAttributable = 'CLUB_FIGURES_NOT_ATTRIBUTABLE',
  IncompleteWindow = 'INCOMPLETE_WINDOW',
  MetricNotComputable = 'METRIC_NOT_COMPUTABLE',
  MissingInputs = 'MISSING_INPUTS',
  NotVerifiable = 'NOT_VERIFIABLE',
  NoClubCalendar = 'NO_CLUB_CALENDAR',
  UnreadableThreshold = 'UNREADABLE_THRESHOLD',
  UnresolvedClubStatus = 'UNRESOLVED_CLUB_STATUS'
}

/** One reporting period, identified by its start and end dates. */
export type CompliancePeriod = {
  __typename?: 'CompliancePeriod';
  /** Exclusive end date, ISO 8601 (YYYY-MM-DD). */
  periodEnd: Scalars['String']['output'];
  /** Inclusive start date, ISO 8601 (YYYY-MM-DD). */
  periodStart: Scalars['String']['output'];
};

/** A raw quantity a compliance metric operand may address. Closed set — the authoring allowlist. */
export enum ComplianceQuantity {
  AdjustedResultRollingThreeYears = 'ADJUSTED_RESULT_ROLLING_THREE_YEARS',
  AdjustedRevenue = 'ADJUSTED_REVENUE',
  AgentsFeesPayableAnnual = 'AGENTS_FEES_PAYABLE_ANNUAL',
  AgentFeeAmortisationAnnual = 'AGENT_FEE_AMORTISATION_ANNUAL',
  AllowableEquityInjectionIncome = 'ALLOWABLE_EQUITY_INJECTION_INCOME',
  AllowablePmTradingIncome = 'ALLOWABLE_PM_TRADING_INCOME',
  CoachWageAnnual = 'COACH_WAGE_ANNUAL',
  EquityInjectionReceivedAnnual = 'EQUITY_INJECTION_RECEIVED_ANNUAL',
  LoanFeeAnnual = 'LOAN_FEE_ANNUAL',
  ManagerSalaryAnnual = 'MANAGER_SALARY_ANNUAL',
  NetBookValue = 'NET_BOOK_VALUE',
  NonEstablishedU21PlayerCostAnnual = 'NON_ESTABLISHED_U21_PLAYER_COST_ANNUAL',
  PlayerAge = 'PLAYER_AGE',
  PlayerHeadcount = 'PLAYER_HEADCOUNT',
  PlayerWageAnnual = 'PLAYER_WAGE_ANNUAL',
  RelevantTurnover = 'RELEVANT_TURNOVER',
  TransferFeeAmortisationAnnual = 'TRANSFER_FEE_AMORTISATION_ANNUAL',
  TransferSpend = 'TRANSFER_SPEND'
}

/** What a compliance quantity is denominated in. */
export enum ComplianceQuantityUnit {
  Count = 'COUNT',
  Currency = 'CURRENCY',
  Percentage = 'PERCENTAGE',
  Years = 'YEARS'
}

/** One club's override of a regime-rule KPI's target, warn level, basis and Show KPI flag. */
export type ComplianceRegimeRuleOverride = {
  __typename?: 'ComplianceRegimeRuleOverride';
  /** This club's override amber warning boundary, or null for a green/red-only override. Null is an absent band, never a band at zero. */
  amberThreshold?: Maybe<Scalars['Float']['output']>;
  /** How the value is compared to the target, for this club. */
  comparator: ComplianceComparator;
  /** The override row. */
  id: Scalars['ID']['output'];
  /** The club this override applies to. */
  organizationId: Scalars['ID']['output'];
  /** The regime rule being overridden — the same id ComplianceRuleEvaluation.ruleId publishes when a backing rule exists. */
  ruleId: Scalars['ID']['output'];
  /** Whether this club renders the rule as a KPI card. */
  showKpi: Scalars['Boolean']['output'];
  /** This club's override target. */
  threshold: Scalars['Float']['output'];
};

/** One compliance Rule evaluated against one context. Rules whose metric the viewer may not see are absent from the response entirely. */
export type ComplianceRuleEvaluation = {
  __typename?: 'ComplianceRuleEvaluation';
  /** The amber boundary inside the passing region. Null means the rule has no warning band and is green/red only. */
  amberThreshold?: Maybe<Scalars['Float']['output']>;
  /** SE-8663: the descriptive text naming what this rule's figure is measured against — 'UEFA football earnings basis' for PSR. Null means no basis label is configured for this rule; render an explicit fallback rather than inventing text, the same rule `consequence` and `threshold` already follow. */
  basisLabel?: Maybe<Scalars['String']['output']>;
  /** How the value is compared to the threshold. LTE is a cap, GTE a floor. */
  comparator: ComplianceComparator;
  /** Whether `value` reflects every input (COMPLETE), is a lower bound because some subject rows were missing a summed quantity OR the assessment window is incomplete (INCOMPLETE — see excludedInputs/coveredPeriods, and never GREEN — SE-8375, SE-7510), or no value was reached at all (NOT_CONFIGURED). */
  completeness: ComplianceCompleteness;
  /** What would clear this rule — the COMPUTED FIX rendered in the card's Understand expander. Always present and never null; it carries either the remedy or the named reason there is none. */
  computedFix: ComplianceComputedFix;
  /** What breaching this rule leads to, in the regulator's own words — the CONSEQUENCE rendered in the card's Understand expander. NULL means no consequence is authored for this rule, which is permanent for a club Objective (an INTERNAL covenant carries no regulator's sanction) and temporary for a packaged rule whose text has not been transcribed yet. Never an empty string: absence has exactly one spelling, so an empty section is never rendered as though the regulation imposed no penalty. Present regardless of state — a consequence is a fact about the regulation, not about today's verdict, so it is served unchanged alongside PARTIAL and NOT_CONFIGURED. */
  consequence?: Maybe<Scalars['String']['output']>;
  /** Periods the window asked for that snapshot history DOES have — SE-7510. Populated whether or not the window is complete; load-bearing for a provisional REPORTING_YEAR verdict (see `completeness` INCOMPLETE and `partialReasons` INCOMPLETE_WINDOW), where this is the months the value covers — a provisional number with no stated coverage is worse than a blank. */
  coveredPeriods: Array<CompliancePeriod>;
  /** Which figure stood in for the denominator the regulation names, or null when it was the real figure — SE-8375 (the EFL allowance's RELEVANT_TURNOVER, when nobody has entered it, falls back to ADJUSTED_REVENUE). */
  denominatorSource?: Maybe<ComplianceDenominatorSource>;
  /** RAW signed distance from the threshold, in the metric's units: value - threshold. NOT normalised — the sign alone does NOT tell you whether the deviation is good or bad, because that depends on the comparator. Positive means ABOVE the threshold in both directions: for an LTE cap that is a breach, for a GTE floor it is healthy. To render good/bad, prefer `state` (RED is the breach, already decided server-side); use the sign only for wording, read against `comparator`. Null whenever no verdict was reached. */
  deviation?: Maybe<Scalars['Float']['output']>;
  /** The contributing rows behind the value, descending by contribution. */
  drivers: Array<ComplianceDriver>;
  /** Quantities excluded from a SUM as a lower bound, rather than blocking the value. Non-empty if and only if completeness is INCOMPLETE. */
  excludedInputs: Array<ComplianceExcludedInput>;
  /** Whether the assessment window is fully covered by snapshot history. */
  isWindowComplete: Scalars['Boolean']['output'];
  /** SE-8798: what a not-verifiable rule CAN state, in display order — e.g. 'Player salaries' and '50% of club revenue'. Empty for every ordinary rule. Informational: none of these is the rule's value. */
  knownFigures: Array<ComplianceKnownFigure>;
  /** The layer it renders in. INTERNAL rules are what the product calls Objectives. */
  layer: ComplianceRuleLayer;
  /** The metric it targets. */
  metricId: Scalars['ID']['output'];
  /** The metric's display name. */
  metricName: Scalars['String']['output'];
  /** Quantities the computation needed and could not find. Non-empty drives PARTIAL or NOT_CONFIGURED. */
  missingInputs: Array<ComplianceQuantity>;
  /** Periods the window asked for that snapshot history does not have. This is how a PSR partial names its missing YEARS rather than merely reporting that something is missing. */
  missingPeriods: Array<CompliancePeriod>;
  /** SE-8382: what to call the numerator on a card — 'squad cost'. Null exactly when numeratorUnit is null. */
  numeratorLabel?: Maybe<Scalars['String']['output']>;
  /** SE-8382: what the metric's numerator is denominated in — CURRENCY for the Squad Cost Ratio's squad cost, for example — carried alongside `unit` so a client can label the drivers column without re-deriving it. Null when the metric has no closed-form inversion (see `computedFix.numeratorUnavailableReason`), in which case `drivers[].unit` falls back to this evaluation's own `unit`. */
  numeratorUnit?: Maybe<ComplianceQuantityUnit>;
  /** Why no verdict was reached, or — SE-7510 — why a real verdict is provisional (a REPORTING_YEAR rule computed over an incomplete window with at least one captured month). Empty if and only if state is a verdict (GREEN/AMBER/RED) reached over a fully covered window, so a client never has to render a partial or a provisional verdict with nothing named. */
  partialReasons: Array<CompliancePartialReason>;
  /** SE-8561: the stable key of that regime across editions — e.g. PREMIER_LEAGUE, UEFA_CLUB_LICENSING. A plain string, not an enum: regimes are data and new packages add keys without a schema change. NULL exactly when regimeName is. */
  regimeKey?: Maybe<Scalars['String']['output']>;
  /** SE-8561: the display name of the regime edition this rule was packaged under, as enrolled for this club — e.g. 'Premier League Squad Cost Ratio 2026-27' or 'UEFA Club Licensing and Financial Sustainability 2026-27'. Per rule, not per layer: CONTINENTAL may hold several enrolments. NULL if and only if the rule is a club Objective (INTERNAL), which belongs to no regime; every DOMESTIC and CONTINENTAL rule carries one. */
  regimeName?: Maybe<Scalars['String']['output']>;
  /** The cross-regime family this rule belongs to, or null. A club is enrolled in exactly one regime, so at most one evaluation in an overview carries a given family — use this, not ruleId/ruleName/metricId (all per-regime or per-environment), to find a specific rule regardless of which regime the club is enrolled in. */
  ruleFamily?: Maybe<ComplianceRuleFamily>;
  /** The rule. */
  ruleId: Scalars['ID']['output'];
  /** The rule's display name. */
  ruleName: Scalars['String']['output'];
  /** The 'Show KPI' render flag. A KPI card IS this flag on a Rule, not a separate entity — toggling it off removes the card without deleting the rule. */
  showKpi: Scalars['Boolean']['output'];
  /** GREEN/AMBER/RED is a verdict. PARTIAL and NOT_CONFIGURED are explicit reports that inputs or history are missing, and are never a verdict — a not-configured rule is NOT compliant, it is unmeasured. */
  state: ComplianceRuleState;
  /** The configured limit. NULL when the stored threshold could not be read, in which case state is NOT_CONFIGURED and partialReasons carries UNREADABLE_THRESHOLD. Never a substituted zero — a zero limit would make every LTE rule breach and every GTE rule pass. */
  threshold?: Maybe<Scalars['Float']['output']>;
  /** This rule's sparkline — the last eight periods, oldest first, each value paired with the target effective in that same period. Batch-loaded for the whole overview, so asking for it on every rule costs the same as asking for it on one. Empty with hasHistory false until snapshots accrue, which is every club today. */
  trend: ComplianceTrend;
  /** What value, threshold and deviation are denominated in. PERCENTAGE renders '70%' where COUNT renders '70'. */
  unit: ComplianceQuantityUnit;
  /** Club statuses this rule's applicability predicate needed and could not resolve — SE-7202's arm of 'every non-verdict names its cause'. Empty for every unconditional rule. Non-empty only alongside partialReasons UNRESOLVED_CLUB_STATUS, and in that case state is NOT_CONFIGURED: the engine refuses to pick between a 50% and a 65% variant on a club whose status nobody has asserted, because guessing permissively renders a real breach GREEN. */
  unresolvedStatuses: Array<ComplianceClubStatus>;
  /** SE-8798: the figures the app has no entry point for, for a rule it cannot verify — e.g. ['Manager salaries', 'Transfer income', 'Owner equity injections', 'Costs of under-21 players not yet established'] on an EFL Salary Cost Management Protocol card. Render verbatim, in order. Empty for every ordinary rule; non-empty exactly when partialReasons[0] is NOT_VERIFIABLE, in which case state is PARTIAL, value/deviation are null, drivers and trend are empty, and the rule is not counted in alertCount or breachCount. */
  unverifiableFigures: Array<Scalars['String']['output']>;
  /** The measured value. Null whenever no verdict was reached; never a substituted zero. */
  value?: Maybe<Scalars['Float']['output']>;
  /** SE-8798: the rule's EFFECTIVE warn-only flag for this club — true when the regime package authors the rule as warn-only OR the club's enrolment in its regime is warn-only (SE-8791, e.g. a club outside every UEFA competition). A warn-only rule's failure is AMBER, never RED, and never counts as a breach. Use it to prefer a non-warn-only rule of the same family for a headline KPI slot — e.g. the domestic squad-cost rule over a warn-only UEFA one. */
  warnOnly: Scalars['Boolean']['output'];
  /** The timeframe this rule is assessed over. */
  window: ComplianceAssessmentWindow;
};

/** A cross-regime family a rule belongs to, for a caller that needs 'the Squad Cost Ratio card' regardless of which regime a club is enrolled in. Null for a rule that is not part of any such family. */
export enum ComplianceRuleFamily {
  ForeignPlayerLimit = 'FOREIGN_PLAYER_LIMIT',
  HomegrownHeadcount = 'HOMEGROWN_HEADCOUNT',
  SquadCostControl = 'SQUAD_COST_CONTROL',
  SquadListHeadcount = 'SQUAD_LIST_HEADCOUNT'
}

/** Which compliance layer a Rule belongs to. INTERNAL rules are what the product calls Objectives. */
export enum ComplianceRuleLayer {
  Continental = 'CONTINENTAL',
  Domestic = 'DOMESTIC',
  Internal = 'INTERNAL'
}

/** The outcome of evaluating one compliance Rule: a GREEN/AMBER/RED verdict, or an explicit report that inputs are missing. */
export enum ComplianceRuleState {
  Amber = 'AMBER',
  Green = 'GREEN',
  NotConfigured = 'NOT_CONFIGURED',
  Partial = 'PARTIAL',
  Red = 'RED'
}

/** Minimum permission tier required to see a compliance field or metric. TIER_1 is the most senior. */
export enum ComplianceSensitivityTier {
  Tier_1 = 'TIER_1',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3'
}

/** Whether a monthly compliance snapshot is still accruing (OPEN) or closed and frozen (CLOSED). */
export enum ComplianceSnapshotStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/** A KPI's trend across recent periods, capped at the last eight. An empty trend with hasHistory false is the ordinary day-one state, not an error — render the stated empty state rather than a flat line. */
export type ComplianceTrend = {
  __typename?: 'ComplianceTrend';
  /** Whether any snapshot history exists for this club at all. False is the empty-trend state; do not infer it from points being empty. */
  hasHistory: Scalars['Boolean']['output'];
  /** The points, OLDEST FIRST — the order a sparkline draws in. Empty when the club has no snapshot history. */
  points: Array<ComplianceTrendPoint>;
};

/** One period on a KPI's trend line. A period whose metric could not be computed is PRESENT with a null value — never dropped, and never a zero. */
export type ComplianceTrendPoint = {
  __typename?: 'ComplianceTrendPoint';
  /** The amber boundary effective in this period, or null. */
  amberThreshold?: Maybe<Scalars['Float']['output']>;
  /** value − threshold for this period, or null whenever either side is absent. Never computed from a substituted zero, which would report an unmeasured period as the full width of the budget under plan. */
  deviation?: Maybe<Scalars['Float']['output']>;
  /** Whether any input was found at all. False with a null value is NOT_CONFIGURED (nobody entered anything); true with a null value is a genuine PARTIAL. The two render differently. */
  hasAnyInput: Scalars['Boolean']['output'];
  /** The quantities the computation needed and could not find, naming why the value is null. Deliberately String rather than the ComplianceQuantity enum: these labels were frozen into history at capture time, and a label that has since been renamed or retired would fail GraphQL enum serialization and take the WHOLE overview down through the non-null chain rather than just this point. */
  missingInputs: Array<Scalars['String']['output']>;
  /** The period this point describes. */
  period: CompliancePeriod;
  /** When this period was restated, or null if it never was. The '12 Mar' of a 'restated 12 Mar' marker. */
  restatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Why this period was restated, or null. */
  restatementNote?: Maybe<Scalars['String']['output']>;
  /** Whether the period is still accruing (OPEN) or frozen. An OPEN period's value can still move; a CLOSED one is what a board report reproduces. */
  status: ComplianceSnapshotStatus;
  /** The target that was effective in THIS period — not the rule's current threshold. That is what keeps a board-reported number reproducible after a target is raised. Null when no target was recorded for the period. */
  threshold?: Maybe<Scalars['Float']['output']>;
  /** What the value is denominated in, frozen with it so a later change to the metric cannot re-denominate history. Null exactly when there is no value. */
  unit?: Maybe<ComplianceQuantityUnit>;
  /** The value computed in this period, or null when it could not be computed. NEVER a substituted zero — a period nobody could measure is not a period that measured nothing. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Input for confirming sign-in with OTP */
export type ConfirmSignInInput = {
  /** The identifier used during sign-in (email or phone number) */
  identifier: Scalars['String']['input'];
  /** The OTP code sent to the user */
  otpCode: Scalars['String']['input'];
  /** The session token from the sign-in request */
  session: Scalars['String']['input'];
};

/** Result of confirm sign-in operation */
export type ConfirmSignInResult = {
  __typename?: 'ConfirmSignInResult';
  /** Authentication result if sign-in was successful */
  authResult?: Maybe<AuthenticationResultWithMessage>;
  /** Error message if sign-in confirmation failed */
  errorMessage?: Maybe<Message>;
  /** Additional challenge required for sign-in */
  signInResult?: Maybe<SignInResult>;
  /** Validation codes indicating missing required profile fields. Only populated on successful authentication. */
  validationCodes?: Maybe<Array<ValidationCodes>>;
};

/** Union type for confirm sign-in responses */
export type ConfirmSignInResultOrSignInResult = ConfirmSignInResult | Message | SignInResult;

/** A connection to a list of items */
export type Connection = {
  /** A list of edges */
  edges: Array<Edge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Connection details for a single database endpoint */
export type ConnectionInfo = {
  __typename?: 'ConnectionInfo';
  /** Configured host from env vars */
  configuredHost: Scalars['String']['output'];
  /** pg_is_in_recovery() result: false = writer, true = reader replica */
  isInRecovery?: Maybe<Scalars['Boolean']['output']>;
  /** Query runner replication mode */
  mode: Scalars['String']['output'];
  /** Actual server IP from inet_server_addr() */
  serverAddress?: Maybe<Scalars['String']['output']>;
  /** PostgreSQL server version */
  serverVersion?: Maybe<Scalars['String']['output']>;
};

/** A single contract clause extracted from a player's contract document (Round C). Flattened from the JSON `extractedData` produced by the OCR/LLM extraction pipeline. Returned by `getPlayerContractClauses`. */
export type ContractClause = {
  __typename?: 'ContractClause';
  /** Clause body — verbatim extracted text from the contract document. May be a literal 'Not applicable' / 'N/A' sentinel when the LLM determined the clause is absent from the source document; surface that to the user rather than treating it as missing data. */
  body: Scalars['String']['output'];
  /** Clause name — e.g. 'Release Clause', 'Sell-On %', 'First Right of Refusal', 'Buyback Clause'. Derived from the leading `Name:` prefix of the extracted text when present (the common case), otherwise a section-derived fallback ('Clause', 'Other Term', 'Fixed Term', 'Variable Bonus'). The agent should match user phrasing (e.g. 'release clause' / 'buyout clause', 'ROFR' / 'first right of refusal') against this field client-side rather than passing the synonym back to the resolver. */
  name: Scalars['String']['output'];
  /** When the parent extraction was last admin-saved. Null while the extraction is still PENDING_REVIEW / PROCESSING / FAILED. */
  savedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status of the parent extraction — typically 'SAVED' (final, admin-reviewed) or 'PENDING_REVIEW' (extracted but not yet confirmed). Useful for caveating answers from in-flight extractions. */
  status?: Maybe<Scalars['String']['output']>;
};

/** A contract document uploaded to S3 for a player */
export type ContractDocument = {
  __typename?: 'ContractDocument';
  /** MIME type inferred from the file extension */
  contentType: Scalars['String']['output'];
  /** Display-ready file name with the storage timestamp prefix removed */
  fileName: Scalars['String']['output'];
  /** Size of the document in bytes */
  fileSize: Scalars['Float']['output'];
  /** Canonical S3 object key: contracts/{orgId}/{playerId}/{timestamp}-{fileName} */
  s3Key: Scalars['String']['output'];
  /** Timestamp when the document was uploaded (S3 last modified) */
  uploadedAt: Scalars['DateTime']['output'];
};

/** Extracted contract data for a player, produced by the OCR/LLM extraction pipeline */
export type ContractExtractionObject = {
  __typename?: 'ContractExtractionObject';
  /** Timestamp when the extraction was archived; null until archived (and null again after restore) */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the Owner who archived the extraction; preserved across restore for audit trail */
  archivedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Type of document that was extracted */
  documentType: DocumentType;
  /** Contract end / termination date as a literal YYYY-MM-DD string; null when not present in the source document */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the extraction completed; null while processing */
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Structured extraction results as JSON; shape varies by document type */
  extractedData: Scalars['JSON']['output'];
  /** Unique identifier for the contract extraction */
  id: Scalars['ID']['output'];
  /** UUID of the player this extraction belongs to */
  playerId: Scalars['ID']['output'];
  /** Timestamp when the extraction was restored (unarchived); null otherwise */
  restoredAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the Owner who restored the extraction */
  restoredByUserId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when an admin saved the extraction; null until saved */
  savedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status of the extraction (e.g. PENDING_REVIEW, SAVED) */
  status: ContractExtractionStatus;
};

/** Lifecycle status of a contract extraction record */
export enum ContractExtractionStatus {
  Failed = 'FAILED',
  PendingReview = 'PENDING_REVIEW',
  Processing = 'PROCESSING',
  Saved = 'SAVED'
}

/** Result of a contract line item mutation */
export type ContractLineItemResult = {
  __typename?: 'ContractLineItemResult';
  /** Whether the operation completed successfully */
  success: Scalars['Boolean']['output'];
};

/** Result of creating a contract upload presigned URL */
export type ContractUploadUrlResult = {
  __typename?: 'ContractUploadUrlResult';
  /** Presigned S3 PUT URL valid for 1 hour */
  presignedUrl: Scalars['String']['output'];
  /** S3 object key where the file will be stored */
  s3Key: Scalars['String']['output'];
};

/** A single message in a conversation thread */
export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  /** Message content */
  content: Scalars['String']['output'];
  /** Unique message identifier */
  id: Scalars['String']['output'];
  /** Message metadata */
  metadata?: Maybe<ConversationMessageMetadata>;
  /** Role of the message sender */
  role: ConversationRole;
  /** Message timestamp */
  timestamp: Scalars['String']['output'];
};

/** Metadata associated with a conversation message */
export type ConversationMessageMetadata = {
  __typename?: 'ConversationMessageMetadata';
  /** Additional custom data */
  additionalData?: Maybe<Scalars['JSON']['output']>;
  /** Data sources referenced */
  dataSources?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of input tokens */
  inputTokens?: Maybe<Scalars['Int']['output']>;
  /** AI model used */
  model?: Maybe<Scalars['String']['output']>;
  /** Number of output tokens */
  outputTokens?: Maybe<Scalars['Int']['output']>;
  /** Processing time in milliseconds */
  processingTimeMs?: Maybe<Scalars['Int']['output']>;
};

/** Role of the participant in a conversation */
export enum ConversationRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

/** A new club Objective — an Internal-layer rule on a metric. */
export type CreateClubObjectiveInput = {
  /** The amber warning boundary, which must sit inside the passing region. Omit for a green/red-only Objective — omission is NOT an amber band of zero. */
  amberThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** The timeframe the Objective is assessed over. Defaults to POINT_IN_TIME. */
  assessmentWindow?: InputMaybe<ComplianceAssessmentWindow>;
  /** How the metric's value is compared to the threshold. LTE for a cap, GTE for a floor. */
  comparator: ComplianceComparator;
  /** The registry metric this Objective targets — a global built-in or one of the club's own. */
  metricId: Scalars['ID']['input'];
  /** The Objective's display name. */
  name: Scalars['String']['input'];
  /** The club that will own the Objective. Defaults to the author's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to render this Objective as a KPI card. Defaults to false. */
  showKpi?: InputMaybe<Scalars['Boolean']['input']>;
  /** The limit itself. */
  threshold: Scalars['Float']['input'];
};

/** Input for creating a new comment */
export type CreateCommentInput = {
  /** The content of the comment (max 300 chars) */
  body: Scalars['String']['input'];
  /** The ID of the note this comment belongs to */
  noteId: Scalars['ID']['input'];
};

/** A new user-built compliance metric (PRD 4.6 builder). */
export type CreateComplianceMetricInput = {
  /** Squad or Financial. */
  category: ComplianceMetricCategory;
  /** The aggregation applied — Count, Share %, Ratio or Average. */
  measure: ComplianceMetricMeasure;
  /** The metric's display name. */
  name: Scalars['String']['input'];
  /** The measured quantity (OF). */
  of: ComplianceOperandInput;
  /** The club that will own the metric. Defaults to the author's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The denominator (OVER). Required for SHARE and RATIO; rejected for COUNT and AVERAGE, which do not divide. */
  over?: InputMaybe<ComplianceOperandInput>;
};

/** Input for creating a presigned URL to upload a contract document */
export type CreateContractUploadUrlInput = {
  /** Type of document being uploaded */
  documentType: DocumentType;
  /** Original file name including extension */
  fileName: Scalars['String']['input'];
  /** UUID of the player the document belongs to */
  playerId: Scalars['ID']['input'];
};

/** Input for registering a device for push notifications */
export type CreateDeviceInput = {
  /** Web push authentication secret for encryption (required for web platform) */
  auth?: InputMaybe<Scalars['String']['input']>;
  /** Device push token */
  deviceToken: Scalars['String']['input'];
  /** Web push subscription endpoint URL (required for web platform) */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  /** Web push ECDH public key p256dh for encryption (required for web platform) */
  p256dh?: InputMaybe<Scalars['String']['input']>;
  /** Platform type (ios, android, web) */
  platform: Scalars['String']['input'];
};

/** Grants a group EDITOR or VIEWER access to a watchlist or scenario; owner only. A repeat with another role updates the grant in place */
export type CreateGroupGrantInput = {
  /** The watchlist or scenario to share */
  entityId: Scalars['ID']['input'];
  /** WATCHLIST or SCENARIO */
  entityType: ShareEntityType;
  /** EVERYONE in v1 */
  groupKey: ShareGroupKey;
  /** EDITOR or VIEWER */
  role: GroupGrantRole;
};

/** Input type for creating and sending an invitation */
export type CreateInvitationInput = {
  /** Phone number of the invitee */
  phoneNumber: Scalars['String']['input'];
  /** Foreign key to role being assigned */
  roleId: Scalars['ID']['input'];
};

/** Input for creating a new kanban board */
export type CreateKanbanBoardInput = {
  /** When true, the board is visible to all users in the organization. Defaults to true if not specified. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the kanban board */
  name: Scalars['String']['input'];
  /** The seeded workflow template for a PIPELINE board */
  pipelineTemplate?: InputMaybe<KanbanPipelineTemplate>;
  /** The ID of the source entity. Required for WATCHLIST boards (to specify which watchlist). Optional for ROSTER boards (user only has one roster). */
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of source this board will be connected to */
  sourceType: KanbanSourceType;
};

/** Input for creating a new phase within a kanban board */
export type CreateKanbanPhaseInput = {
  /** Whether the phase contains sensitive player information */
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a terminal pipeline phase */
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the kanban board to add this phase to */
  kanbanBoardId: Scalars['ID']['input'];
  /** The display name for the phase */
  name: Scalars['String']['input'];
  /** The position where this phase should be inserted. If not provided, the phase will be added at the end. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Optional target number of days for cards in this phase */
  timeTargetDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a new kanban tag */
export type CreateKanbanTagInput = {
  /** The name of the tag. Must be unique within the organization. */
  name: Scalars['String']['input'];
};

/** Input for creating a manually-added player */
export type CreateManualPlayerInput = {
  /** Player's date of birth */
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  /** Player's first name */
  firstName: Scalars['String']['input'];
  /** Whether this player is an academy player for squad planning purposes. Defaults to false. */
  isAcademy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Player's known name or nickname */
  knownName?: InputMaybe<Scalars['String']['input']>;
  /** Player's last name */
  lastName: Scalars['String']['input'];
  /** ID of the player's nationality */
  nationalityId?: InputMaybe<Scalars['ID']['input']>;
  /** List of position IDs to assign to the manual player */
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-text team name for the manual player */
  teamName?: InputMaybe<Scalars['String']['input']>;
};

/** Input for recording a basic match event by hand. Player and minute are optional — a goal or card observed without the scorer or the exact minute is still a fact about the match. */
export type CreateMatchEventInput = {
  /** What happened: GOAL, OWN_GOAL, YELLOW_CARD or RED_CARD */
  kind: MatchEventKind;
  /** The match this event happened in */
  matchId: Scalars['ID']['input'];
  /** Minute the event occurred. Stoppage time is the minute played in (93), never 90+3. */
  minute?: InputMaybe<Scalars['Int']['input']>;
  /** The player involved, when known */
  playerId?: InputMaybe<Scalars['ID']['input']>;
  /** The side the player involved was playing for. For an OWN_GOAL this is the scorer's OWN team, not the side the goal counts for. */
  teamId: Scalars['ID']['input'];
};

/** Input for creating a match. Requires only the two teams and a date; every provider-supplied field is optional so a fixture with zero provider data is a complete record. Scouts may be assigned in the same call to keep the Add-match action atomic. */
export type CreateMatchInput = {
  /** Scouts to assign to this fixture on creation, so the Add-match action is a single atomic write rather than a create followed by a separate assign that can fail on its own. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Identifier of the away team */
  awayTeamId: Scalars['ID']['input'];
  /** Away score, for a fixture already played */
  awayTeamScore?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text competition label for fixtures with no catalog league row. */
  competitionLabel?: InputMaybe<Scalars['String']['input']>;
  /** How precisely the date is known. Defaults to EXACT. Use WINDOW or ROUND_ONLY rather than inventing a date you do not have. */
  datePrecision?: InputMaybe<MatchDatePrecision>;
  /** Identifier of the home team */
  homeTeamId: Scalars['ID']['input'];
  /** Home score, for a fixture already played */
  homeTeamScore?: InputMaybe<Scalars['Int']['input']>;
  /** Catalog league this fixture belongs to. Omit for a friendly or youth fixture and supply competitionLabel instead. */
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  /** Civil date of the fixture at the venue, ISO-8601 (YYYY-MM-DD). For WINDOW precision this is the first day of the window. */
  scheduledDate: Scalars['String']['input'];
  /** Inclusive last day of the window. Supply only with datePrecision WINDOW; a two-day window is scheduledDate plus one day. */
  scheduledEndDate?: InputMaybe<Scalars['String']['input']>;
  /** Kick-off as a civil time at the venue (HH:mm). Omit when unconfirmed — omitting it is correct and renders as 'time TBC', whereas sending 00:00 asserts a midnight kick-off as fact. */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Lifecycle state at creation. Defaults to SCHEDULED. */
  status?: InputMaybe<MatchStatus>;
  /** IANA timezone for interpreting the date and kick-off. Omit to use the organisation's locale. */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Free-text venue name. Omit when the venue is unknown. */
  venue?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a match report. Idempotent per match and scout: a second call returns the existing report UNCHANGED, silently ignoring any watchMode or reportTeams supplied in that call — use updateMatchReport to change them afterwards. Deliberately imposes no kick-off precondition: opening a report against a future fixture is supported behaviour, not an oversight. */
export type CreateMatchReportInput = {
  /** Identifier of the match this report covers */
  matchId: Scalars['ID']['input'];
  /** Teams this report covers and their squad sizes. Applied on first create only — a later create for the same match and scout ignores it. Omit to open a report with no teams set and add them later via setMatchReportSquad. */
  reportTeams?: InputMaybe<Array<MatchReportTeamInput>>;
  /** How the scout will observe the fixture. Applied on first create only — a later create for the same match and scout ignores it. Omit to decide later and set it with updateMatchReport, which is the only way to change it once the report exists. */
  watchMode?: InputMaybe<MatchWatchMode>;
};

/** Input for creating a new note */
export type CreateNoteInput = {
  /** The content of the note (max 2000 chars) */
  body: Scalars['String']['input'];
  /** Determines if this note will be visible to other users in the organization. Defaults to the organization setting when omitted. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the player this note is about */
  playerId: Scalars['ID']['input'];
  /** The title of the note (max 100 chars) */
  title: Scalars['String']['input'];
};

/** Input type for creating a new organization */
export type CreateOrganizationInput = {
  /** Currency code for the organization */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** Default formation for squad planning */
  defaultFormation?: InputMaybe<ShadowTeamFormation>;
  /** Default visibility for new kanban boards. False=private, true=public. */
  defaultKanbanBoardVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default visibility for new notes. False=private, true=public. */
  defaultNoteVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the default scout report type for this organization */
  defaultScoutReportTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Default visibility for new scout reports. False=private, true=public. */
  defaultScoutReportVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gender division this organization operates in. Scopes every org-scoped read. Defaults to male. */
  gender?: InputMaybe<Gender>;
  /** Name of the organization */
  name: Scalars['String']['input'];
  /** Foreign key to primary sport */
  sportId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for creating an organization-league association */
export type CreateOrganizationLeagueInput = {
  /** Foreign key to league */
  leagueId: Scalars['ID']['input'];
  /** Foreign key to organization */
  organizationId: Scalars['ID']['input'];
};

/** Input type for creating an organization-team association */
export type CreateOrganizationTeamInput = {
  /** Foreign key to organization */
  organizationId: Scalars['ID']['input'];
  /** Foreign key to team */
  teamId: Scalars['ID']['input'];
};

/** Input for authoring a new pipeline automation rule (SE-5507) */
export type CreatePipelineAutomationRuleInput = {
  /** What the rule does when it matches */
  actionType: PipelineAutomationActionType;
  /** Member to assign the card to for ASSIGN (SE-5628). Their organization membership is re-validated at FIRING time, not stored as a snapshot — a member who leaves the club stops being a valid assignee without the rule being edited. */
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Conditions, combined with AND. An empty list always matches. */
  conditions: Array<PipelineAutomationRuleConditionInput>;
  /** The pipeline this rule governs. Rules are per-pipeline. */
  kanbanBoardId: Scalars['ID']['input'];
  /** Tag for APPLY_TAG / REMOVE_TAG */
  kanbanTagId?: InputMaybe<Scalars['ID']['input']>;
  /** Display name. Snapshotted onto every audit and ledger row the rule produces, so a later rename cannot rewrite history. */
  name: Scalars['String']['input'];
  /** The author's rationale, recorded as the rationale on every audit row and review request the rule produces. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Outcome to PROPOSE when the target stage is terminal. Optional — the backend never picks an outcome on the approver's behalf, so leaving it null simply asks the human to choose at accept time. */
  requestedOutcome?: InputMaybe<KanbanCardOutcome>;
  /** Target stage for MOVE_TO_STAGE / ADD_TO_REVIEW_QUEUE. Whether the move needs approval is decided LIVE from the stage at evaluation time and is deliberately not configurable here. */
  targetKanbanPhaseId?: InputMaybe<Scalars['ID']['input']>;
  /** Stage the trigger watches. Required for TIME_IN_STAGE_EXCEEDED; optional for CARD_ENTERED_STAGE, where omitting it means any stage; ignored by every other trigger. */
  triggerKanbanPhaseId?: InputMaybe<Scalars['ID']['input']>;
  /** What causes the rule to be evaluated */
  triggerType: PipelineAutomationTriggerType;
};

/** Input type for creating a PlayerDataSummary and generating a presigned URL for upload */
export type CreatePlayerDataSummaryInput = {
  /** The name of the file to be uploaded */
  fileName: Scalars['String']['input'];
  /** The GGID of the player */
  playerGGID?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the player */
  playerId?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a scenario with a name and a complete set of actions (batch save) */
export type CreateScenarioInput = {
  /** Complete set of actions for this scenario. May be empty — the create-first flow (SE-5345) starts scenarios with zero actions. */
  actions: Array<ScenarioActionInput>;
  /** SE-8409: when duplicating an existing scenario, its id — copies that scenario's own manual-salary snapshot instead of the Current Squad's live one. Omit for a fresh scenario. */
  duplicateFromScenarioId?: InputMaybe<Scalars['ID']['input']>;
  /** Display name. Auto-generated (e.g. "Scenario A") if omitted. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** SE-8609: when true, SIGN actions of a real player who is already on the organization roster or not accessible to it are skipped instead of failing the create. Other action types and external-player signings are never skipped. Defaults to false (strict). */
  skipIneligibleSignings?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Creates a non-match scheduled thing (training visit, tournament, meeting). MATCH is refused — a match carries a specialisation createMatch owns. The temporal fields carry the same semantics as a fixture's: honest precision, no fabricated times. */
export type CreateScheduledThingInput = {
  /** Scouts to assign in the same round trip. The same conflict and workload semantics as a fixture's assignments apply. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** How precisely the date is known. Defaults to EXACT. */
  datePrecision?: InputMaybe<MatchDatePrecision>;
  /** Registered kind: TRAINING_VISIT, TOURNAMENT or MEETING. A String rather than an enum so future kinds need no schema change. */
  kind: Scalars['String']['input'];
  /** Civil date at the venue, ISO-8601 (YYYY-MM-DD). For WINDOW precision this is the first day of the window. */
  scheduledDate: Scalars['String']['input'];
  /** Inclusive last day of the window. Supply only with datePrecision WINDOW. */
  scheduledEndDate?: InputMaybe<Scalars['String']['input']>;
  /** Start as a civil time at the venue (HH:mm). Omit when unconfirmed — never send a fabricated 00:00. */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone for interpreting the date and start time. Omit to use the organisation's locale. */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Human title the planning surfaces render ("U19 training visit — away fixture"). Required: a generic thing has no teams to derive a display from. */
  title: Scalars['String']['input'];
  /** Free-text venue name. Omit when the venue is unknown. */
  venue?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new shadow team */
export type CreateShadowTeamInput = {
  /** The formation type for the shadow team (e.g., F_442, F_433) */
  formation?: InputMaybe<ShadowTeamFormation>;
  /** The display name for the shadow team */
  name?: InputMaybe<Scalars['String']['input']>;
  /** When true (default), a from-scratch team is auto-seeded with org + watchlist players. Set false to start with an empty roster. Ignored when sourceWatchlistId is provided. */
  seedFromOrgAndWatchlists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional watchlist ID. When set, the new shadow team is populated from the watchlist's players, each placed at their primary position slot for the chosen formation. */
  sourceWatchlistId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for creating a team that the provider catalog does not cover, so a scout can free-type a club and proceed. Distinct from creating an organization-team association, which links an existing team. */
export type CreateTeamInput = {
  /** Gender division of the team. Required with no default: a club's men's and women's sides are separate team records, and guessing would silently attach fixtures to the wrong one. */
  gender: Gender;
  /** Catalog league this team competes in. OPTIONAL: omit it for a club the catalog does not cover — a youth, trial or friendly-only side — which is the manual-entry case a free-typed competition puts a scout in. Omitting it records 'no catalog league known', not a claim that the club is unaffiliated, and it can be filled in if the club is later reconciled. */
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the team */
  name: Scalars['String']['input'];
};

/** Grants one person EDITOR or VIEWER access to a scenario; owner only. A repeat with another role updates the grant in place */
export type CreateUserScenarioInput = {
  /** EDITOR or VIEWER */
  role: UserScenarioRole;
  /** Scenario to share */
  scenarioId: Scalars['ID']['input'];
  /** The invitee; must hold an ACTIVE MANAGER+ membership in the scenario's organization */
  userId: Scalars['ID']['input'];
};

/** Input for creating a user watchlist association */
export type CreateUserWatchlistInput = {
  /** The role of the user on the watchlist */
  role: UserWatchlistRole;
  /** The id of the user to add to the watchlist */
  userId: Scalars['ID']['input'];
  /** The id of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Input for creating a new watchlist */
export type CreateWatchlistInput = {
  /** Initial Pitch formation; defaults to 4-3-3 when omitted */
  formation?: InputMaybe<PitchFormation>;
  /** The display name for the watchlist. Trimmed; must be non-empty and at most 50 characters (SE-8449). Unique within the organization regardless of case. */
  name: Scalars['String']['input'];
};

/** Currency codes following ISO 4217 standard */
export enum CurrencyCode {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

/** Definition of a custom statistic available for filtering and display */
export type CustomStatDefinition = {
  __typename?: 'CustomStatDefinition';
  /** Description of what this statistic measures */
  description: Scalars['String']['output'];
  /** Name of the custom statistic */
  name: Scalars['String']['output'];
};

/** Filter players by custom statistics with optional min/max value ranges */
export type CustomStatFilterInput = {
  /** Maximum value for the custom statistic */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value for the custom statistic */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the custom statistic to filter by */
  statName: Scalars['String']['input'];
};

/** Database connection diagnostics comparing master, slave, and auto-routed reads */
export type DatabaseDiagnosticsModel = {
  __typename?: 'DatabaseDiagnosticsModel';
  /** Auto-routed read via SelectQueryBuilder (should match slave if routing works) */
  autoRoutedRead: ConnectionInfo;
  /** True if auto-routed reads hit the reader instance (isInRecovery = true) */
  autoRoutingWorking: Scalars['Boolean']['output'];
  /** Explicit master connection diagnostics */
  master: ConnectionInfo;
  /** Whether TypeORM replication config is present */
  replicationConfigured: Scalars['Boolean']['output'];
  /** Explicit slave connection diagnostics */
  slave: ConnectionInfo;
};

/** Input type for deactivating a user's access to an organization */
export type DeactivateOrganizationUserInput = {
  /** Unique identifier of the user to deactivate */
  userId: Scalars['ID']['input'];
};

/** Input for declining a queued pipeline review request */
export type DeclinePipelineReviewRequestInput = {
  /** Optional reason for declining; trimmed server-side. Blank or omitted is stored as null. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the pipeline review request to decline */
  reviewRequestId: Scalars['ID']['input'];
};

/** Input for deleting a comment */
export type DeleteCommentInput = {
  /** The ID of the comment to delete */
  id: Scalars['ID']['input'];
};

/** Input for deleting all extracted contract data */
export type DeleteContractExtractionInput = {
  /** The type of contract document */
  documentType: DocumentType;
  /** The player whose extraction data to delete */
  playerId: Scalars['ID']['input'];
};

/** Input for deleting a line item from extracted contract data */
export type DeleteContractLineItemInput = {
  /** Category key within extracted data (e.g. fixedTerms, clauses) */
  category: Scalars['String']['input'];
  /** UUID of the contract extraction to update */
  extractionId: Scalars['ID']['input'];
  /** Zero-based index of the item to delete within the category */
  itemIndex: Scalars['Int']['input'];
};

/** Revokes a group grant; owner only */
export type DeleteGroupGrantInput = {
  /** The group grant to remove */
  groupGrantId: Scalars['ID']['input'];
};

/** Outcome of deleteGroupGrant: the submitted grant id and whether a row was removed */
export type DeleteGroupGrantPayload = {
  __typename?: 'DeleteGroupGrantPayload';
  /** The submitted grant id */
  id: Scalars['ID']['output'];
  /** True when a grant row was deleted; false on a repeat */
  removed: Scalars['Boolean']['output'];
};

/** Input type for deleting a pending invitation */
export type DeleteInvitationInput = {
  /** Unique identifier of the invitation to delete */
  id: Scalars['ID']['input'];
};

/** Input for deleting a manually-added player */
export type DeleteManualPlayerInput = {
  /** The ID of the manual player to delete */
  id: Scalars['ID']['input'];
};

/** Input for deleting a manually created fixture. Only the identifier is accepted: the organisation comes from the session, and the manual-source guard is read from the stored row rather than asserted by the caller. */
export type DeleteMatchInput = {
  /** Identifier of the match to delete */
  id: Scalars['ID']['input'];
};

/** Input for deleting a note */
export type DeleteNoteInput = {
  /** The ID of the note to delete */
  id: Scalars['ID']['input'];
};

/** Input type for deleting an organization-league association */
export type DeleteOrganizationLeagueInput = {
  /** Foreign key to league */
  leagueId: Scalars['ID']['input'];
  /** Foreign key to organization */
  organizationId: Scalars['ID']['input'];
};

/** Input type for deleting an organization-team association */
export type DeleteOrganizationTeamInput = {
  /** Foreign key to organization */
  organizationId: Scalars['ID']['input'];
  /** Foreign key to team */
  teamId: Scalars['ID']['input'];
};

/** Input for deleting a shadow team */
export type DeleteShadowTeamInput = {
  /** ID of the shadow team to delete */
  id: Scalars['ID']['input'];
};

/** Input for deleting a thread */
export type DeleteThreadInput = {
  /** The ID of the thread to delete */
  id: Scalars['String']['input'];
};

/** Revokes a grant. The owner removes anyone; an invitee removes only their own row (leave) */
export type DeleteUserScenarioInput = {
  /** The grant to remove */
  userScenarioId: Scalars['ID']['input'];
};

/** Outcome of deleteUserScenario: the submitted grant id and whether a row was removed */
export type DeleteUserScenarioPayload = {
  __typename?: 'DeleteUserScenarioPayload';
  /** The submitted grant id */
  id: Scalars['ID']['output'];
  /** True when a grant row was deleted; false on a repeat */
  removed: Scalars['Boolean']['output'];
};

/** Input for deleting a user watchlist association */
export type DeleteUserWatchlistInput = {
  /** The ID of the user watchlist association to delete */
  id: Scalars['ID']['input'];
};

/** Input for deleting a watchlist */
export type DeleteWatchlistInput = {
  /** The ID of the watchlist to delete */
  id: Scalars['ID']['input'];
};

/** A device registered for push notifications */
export type Device = {
  __typename?: 'Device';
  /** Web push authentication secret for encryption (web platform only) */
  auth?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['String']['output'];
  /** Device push token */
  deviceToken: Scalars['String']['output'];
  /** Web push subscription endpoint URL (web platform only) */
  endpoint?: Maybe<Scalars['String']['output']>;
  /** Unique device identifier */
  id: Scalars['ID']['output'];
  /** Device active status */
  isActive: Scalars['Boolean']['output'];
  /** Web push ECDH public key p256dh for encryption (web platform only) */
  p256dh?: Maybe<Scalars['String']['output']>;
  /** Platform type (ios, android, web) */
  platform: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['String']['output'];
  /** Owner user ID */
  userId: Scalars['ID']['output'];
};

/** Per-player metric scores for distribution scatter-plot visualization */
export type DistributionPlayerScore = {
  __typename?: 'DistributionPlayerScore';
  /** Carrying score (seasonal positional or career global) */
  carrying?: Maybe<Scalars['Float']['output']>;
  /** Dribbling score (seasonal positional or career global) */
  dribbling?: Maybe<Scalars['Float']['output']>;
  /** GK passing score */
  gkPassing?: Maybe<Scalars['Float']['output']>;
  /** GK positioning score */
  gkPositioning?: Maybe<Scalars['Float']['output']>;
  /** GK shot stopping score */
  gkShotStopping?: Maybe<Scalars['Float']['output']>;
  /** GPR (seasonal from time series or career time-decayed) */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Passing score (positional in both seasonal and career) */
  passing?: Maybe<Scalars['Float']['output']>;
  /** Lifetime physical score from player_stats_pivoted */
  physicalScore?: Maybe<Scalars['Float']['output']>;
  /** Player UUID for identifying dots on hover */
  playerId: Scalars['ID']['output'];
  /** Display name for tooltip */
  playerName: Scalars['String']['output'];
  /** Shooting score (positional in both seasonal and career) */
  shooting?: Maybe<Scalars['Float']['output']>;
};

/** One extracted clause from a roster player's contract or transfer agreement, tagged with its document type (SE-8720). */
export type DocumentContractClause = {
  __typename?: 'DocumentContractClause';
  /** Verbatim clause text. May be a 'Not applicable' sentinel when the extraction found the clause absent. */
  body: Scalars['String']['output'];
  /** Which document the clause came from. */
  documentType: DocumentType;
  /** Clause name, e.g. 'No-Trade Clause', 'Release Clause', 'Buyback Clause'. */
  name: Scalars['String']['output'];
  /** When the parent extraction was last admin-saved. */
  savedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the parent extraction, e.g. 'SAVED' (admin-reviewed) or 'PENDING_REVIEW'. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Type of contract document being uploaded */
export enum DocumentType {
  Contract = 'CONTRACT',
  TransferAgreement = 'TRANSFER_AGREEMENT'
}

/** An edge in a connection */
export type Edge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Node;
};

/** Input for editing the contract end date of an extraction */
export type EditContractEndDateInput = {
  /** New contract end date as a YYYY-MM-DD literal, or null to clear it */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the contract extraction to update */
  extractionId: Scalars['ID']['input'];
};

/** Input for editing a line item in extracted contract data */
export type EditContractLineItemInput = {
  /** Category key within extracted data (e.g. fixedTerms, clauses) */
  category: Scalars['String']['input'];
  /** UUID of the contract extraction to update */
  extractionId: Scalars['ID']['input'];
  /** Zero-based index of the item to edit within the category */
  itemIndex: Scalars['Int']['input'];
  /** New text value for the line item */
  newText: Scalars['String']['input'];
};

/** Input for executing a SQL query. The query must be a valid PostgreSQL SELECT statement using schema-qualified table names from getSqlSchema. */
export type ExecuteSqlQueryInput = {
  /** PostgreSQL SELECT query to execute. Must use schema-qualified table names (e.g., public.player) and column names exactly as returned by getSqlSchema (snake_case for tables, UPPERCASE with double-quotes for materialized views). Only SELECT statements allowed. */
  query: Scalars['String']['input'];
};

/** Result of SQL query execution including rows and execution metadata */
export type ExecuteSqlQueryResult = {
  __typename?: 'ExecuteSqlQueryResult';
  /** Time in milliseconds to execute the query */
  executionTimeMs: Scalars['Int']['output'];
  /** Number of rows returned by the query */
  rowCount: Scalars['Int']['output'];
  /** Array of row objects returned by the query */
  rows: Scalars['JSON']['output'];
  /** Whether the result set was truncated due to size limits */
  truncated?: Maybe<Scalars['Boolean']['output']>;
};

/** Connection type for paginated ExpiringContract results */
export type ExpiringContractConnection = Connection & {
  __typename?: 'ExpiringContractConnection';
  /** A list of edges */
  edges: Array<ExpiringContractEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for ExpiringContract connection */
export type ExpiringContractEdge = Edge & {
  __typename?: 'ExpiringContractEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The ExpiringContract node */
  node: ExpiringContractModel;
};

/** Player with contract expiring within the requested threshold period */
export type ExpiringContractModel = Node & {
  __typename?: 'ExpiringContractModel';
  /** Contract expiration date */
  contractExpires: Scalars['DateTime']['output'];
  /** Unique player identifier */
  id: Scalars['ID']['output'];
  /** Whole months remaining until contract expires (floored from precise calculation) */
  monthsRemaining: Scalars['Int']['output'];
  /** The player with the expiring contract */
  player?: Maybe<Player>;
  /** Player ID for frontend convenience */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation (e.g. ST, CB, GK) */
  position?: Maybe<Scalars['String']['output']>;
  /** Current team name */
  teamName?: Maybe<Scalars['String']['output']>;
};

/** A first-team roster player with an expiring contract and contract details */
export type ExpiringContractPlayer = {
  __typename?: 'ExpiringContractPlayer';
  /** Date the contract expires */
  contractExpires: Scalars['DateTime']['output'];
  /** Player display name */
  name: Scalars['String']['output'];
  /** Player UUID */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation */
  primaryPosition: Scalars['String']['output'];
  /** Team name */
  teamName: Scalars['String']['output'];
};

/** External player data for a SIGN action targeting a player outside the system */
export type ExternalPlayerDataInput = {
  /** Age */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** GPR rating */
  gpr?: InputMaybe<Scalars['Float']['input']>;
  /** Display name of the external player */
  name: Scalars['String']['input'];
  /** Nationality name */
  nationalityName?: InputMaybe<Scalars['String']['input']>;
  /** Position abbreviations the player can play */
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Current team name */
  teamName?: InputMaybe<Scalars['String']['input']>;
};

/** A single rendered event in the Update Feed (server-rendered headline, category, optional clickthrough, and group key) */
export type FeedEvent = Node & {
  __typename?: 'FeedEvent';
  /** High-level category used by the FE to bucket the event */
  category: FeedEventCategory;
  /** URL or in-app path the FE should navigate to on click; null when the event has no destination */
  clickthrough?: Maybe<Scalars['String']['output']>;
  /** Stable grouping key (category:entityId) used by the FE to collapse adjacent events into a single visual stack */
  groupKey: Scalars['String']['output'];
  /** Server-rendered headline with all template substitutions already applied */
  headline: Scalars['String']['output'];
  /** Globally unique identifier for this feed event (UserActivity.id) */
  id: Scalars['ID']['output'];
  /** When the underlying activity was created */
  timestamp: Scalars['DateTime']['output'];
};

/** High-level categorization of update-feed events used to group items into the home-feed sections */
export enum FeedEventCategory {
  /** Catch-all for organizational, admin, and manual-player events */
  Activity = 'ACTIVITY',
  /** Threshold-driven alerts (e.g. avg-rating, inactivity) */
  Alerts = 'ALERTS',
  /** Players with contracts expiring in the configured horizon */
  ExpiringContracts = 'EXPIRING_CONTRACTS',
  /** Completed transfers in followed leagues / teams */
  RecentTransfers = 'RECENT_TRANSFERS',
  /** New recommended-player suggestions */
  RecommendedPlayers = 'RECOMMENDED_PLAYERS',
  /** Scouting domain events: notes, watchlists, and scout reports */
  Scouting = 'SCOUTING'
}

/** A connection to a list of update-feed events */
export type FeedEventConnection = {
  __typename?: 'FeedEventConnection';
  /** A list of edges */
  edges: Array<FeedEventEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total count of underlying user activities (pre-batching upper bound) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a FeedEventConnection */
export type FeedEventEdge = Edge & {
  __typename?: 'FeedEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The FeedEvent node */
  node: FeedEvent;
};

/** A player in the squad final state with basic info */
export type FinalStatePlayerModel = {
  __typename?: 'FinalStatePlayerModel';
  /** Player UUID */
  id: Scalars['ID']['output'];
  /** Whether this player was added by a transition (SIGN/PROMOTE) */
  isTransitionAddition: Scalars['Boolean']['output'];
  /** Whether this player is being removed by a transition (SELL/LOAN_OUT) */
  isTransitionRemoval: Scalars['Boolean']['output'];
  /** Player display name */
  name: Scalars['String']['output'];
};

/** Financial details for a transition (sale price, loan fee, signing fee, wage) */
export type FinancialDetailsInput = {
  /** Agent fee for SIGN transitions */
  agentFee?: InputMaybe<Scalars['Float']['input']>;
  /** Percent 0-100 of the player's wage the BORROWING club covers. On a LOAN_IN this club is the borrower and carries that share; on a LOAN_OUT this club is the lender and retains the remaining (100 - share). Absent means unknown — compliance reports PARTIAL rather than assuming 100. */
  coveredSharePercent?: InputMaybe<Scalars['Int']['input']>;
  /** Contract duration in months */
  durationMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Loan fee for LOAN_OUT and LOAN_IN transitions */
  loanFee?: InputMaybe<Scalars['Float']['input']>;
  /** Sale price for SELL transitions */
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  /** Signing bonus for SIGN transitions */
  signingBonus?: InputMaybe<Scalars['Float']['input']>;
  /** Signing fee for SIGN transitions */
  signingFee?: InputMaybe<Scalars['Float']['input']>;
  /** Annual wage for the transitions that establish a salary at this club — SIGN, PROMOTE and LOAN_IN. Ignored on SELL and LOAN_OUT, which keep the player's recorded salary: a departure changes who bears the wage, not what the player earns. */
  wage?: InputMaybe<Scalars['Float']['input']>;
};

/** Financial details of a squad planning transition */
export type FinancialDetailsModel = {
  __typename?: 'FinancialDetailsModel';
  /** Agent fee */
  agentFee?: Maybe<Scalars['Float']['output']>;
  /** Percent 0-100 of the player's wage the BORROWING club covers. On a LOAN_IN this club is the borrower and carries that share; on a LOAN_OUT this club is the lender and retains the remaining (100 - share). Null means unknown — compliance reports PARTIAL rather than assuming 100. */
  coveredSharePercent?: Maybe<Scalars['Int']['output']>;
  /** Contract duration in months */
  durationMonths?: Maybe<Scalars['Int']['output']>;
  /** Loan fee */
  loanFee?: Maybe<Scalars['Float']['output']>;
  /** Sale price */
  salePrice?: Maybe<Scalars['Float']['output']>;
  /** Signing bonus */
  signingBonus?: Maybe<Scalars['Float']['output']>;
  /** Signing fee */
  signingFee?: Maybe<Scalars['Float']['output']>;
  /** Annual wage */
  wage?: Maybe<Scalars['Float']['output']>;
};

/** Foreign key relationship information identifying the referenced table and column */
export type ForeignKeyInfoModel = {
  __typename?: 'ForeignKeyInfoModel';
  /** Name of the column containing the foreign key */
  column: Scalars['String']['output'];
  /** Name of the column in the foreign table this key references */
  foreignColumn: Scalars['String']['output'];
  /** Name of the table this foreign key references */
  foreignTable: Scalars['String']['output'];
};

/** Game-level intelligence metrics for a player, aggregated from the game_metrics materialized view */
export type GameMetrics = {
  __typename?: 'GameMetrics';
  /** Intelligence ball progression score */
  ballProgression?: Maybe<Scalars['Float']['output']>;
  /** Intelligence ball retention score */
  ballRetention?: Maybe<Scalars['Float']['output']>;
  /** Intelligence chance creation score */
  chanceCreation?: Maybe<Scalars['Float']['output']>;
  /** Intelligence defensive actions score */
  defensiveActions?: Maybe<Scalars['Float']['output']>;
  /** Intelligence finishing score */
  finishing?: Maybe<Scalars['Float']['output']>;
  /** Intelligence game difficulty score */
  gameDifficulty?: Maybe<Scalars['Float']['output']>;
  /** Game identifier */
  gameId: Scalars['ID']['output'];
  /** GGR percentile ranking */
  ggrPercentile?: Maybe<Scalars['Float']['output']>;
  /** GGR rating value */
  ggrRating?: Maybe<Scalars['Float']['output']>;
  /** Whether player was injured */
  isInjured?: Maybe<Scalars['Boolean']['output']>;
  /** Organization identifier */
  organizationId: Scalars['ID']['output'];
  /** Whether player played enough minutes */
  playedEnoughMinutes?: Maybe<Scalars['Boolean']['output']>;
  /** Player identifier */
  playerId: Scalars['ID']['output'];
  /** Whether player was substituted in */
  wasSubbedIn?: Maybe<Scalars['Boolean']['output']>;
  /** Whether player was substituted out */
  wasSubbedOut?: Maybe<Scalars['Boolean']['output']>;
};

/** Game-level provider metrics for a player, aggregated from the game_provider_metrics materialized view */
export type GameProviderMetrics = {
  __typename?: 'GameProviderMetrics';
  /** Total aerial clearances */
  aerialClearancesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total aerials in forward half */
  aerialFhalfTotal?: Maybe<Scalars['Float']['output']>;
  /** Total aerials contested */
  aerialsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total backward passes */
  backwardPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total blocks */
  blocksTotal?: Maybe<Scalars['Float']['output']>;
  /** Total carry box entries */
  carryBoxEntriesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total carry on-ball value gain */
  carryObvGainTotal?: Maybe<Scalars['Float']['output']>;
  /** Total clearances */
  clearancesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total corner expected assists */
  cornerXaTotal?: Maybe<Scalars['Float']['output']>;
  /** Total cross expected assists */
  crossXaTotal?: Maybe<Scalars['Float']['output']>;
  /** Total crosses */
  crossesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total difference between actual non-penalty goals and npxG */
  diffActualNpGoalsAndNpXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Count of dismissals for this player in this game. Derived as secondYellowCardsTotal + straightRedCardsTotal, because a dismissal arrives either way and neither raw count answers it alone. The two routes are mutually exclusive in the feed, so in practice this is 0 or 1 - but the sum is not clamped, so a player-game carrying both would report 2. This is the field to use for sendings-off; an Int rather than a Boolean so it still composes when summed across games. */
  dismissalsTotal: Scalars['Int']['output'];
  /** Total dribble on-ball value gain */
  dribbleObvGainTotal?: Maybe<Scalars['Float']['output']>;
  /** Total times dribbled past */
  dribbledPastTotal?: Maybe<Scalars['Float']['output']>;
  /** Total dribbles faced */
  dribblesFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total dribbles tackled */
  dribblesTackledTotal?: Maybe<Scalars['Float']['output']>;
  /** Total duels */
  duelsTotal?: Maybe<Scalars['Float']['output']>;
  /** Game identifier */
  gameId: Scalars['ID']['output'];
  /** Total goalkeeper clears attempted */
  gkClearsAttemptedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper clears */
  gkClearsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper collected */
  gkCollectedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper collects attempted */
  gkCollectsAttemptedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper goals conceded */
  gkGoalsConcededTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper non-shot saves */
  gkNonShotSavesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper penalties faced */
  gkPenaltiesFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper penalties saved */
  gkPenaltiesSavedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper post-shot xG faced */
  gkPsXgFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper save difficulty xG */
  gkSaveDifficultyXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper shots faced */
  gkShotsFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper shots on target faced */
  gkShotsOnTargetTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper shots saved */
  gkShotsSavedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total header goals */
  headerGoalsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total header expected goals */
  headerXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Total header xG uplift */
  headerXgUpliftTotal?: Maybe<Scalars['Float']['output']>;
  /** Total headers */
  headersTotal?: Maybe<Scalars['Float']['output']>;
  /** Total successful inswing deliveries */
  inswingSuccessTotal?: Maybe<Scalars['Float']['output']>;
  /** Total inswing deliveries */
  inswingTotal?: Maybe<Scalars['Float']['output']>;
  /** Total interceptions */
  interceptionsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total passes into final third */
  intoF3PassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total left foot passes */
  leftFootPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total left foot shots */
  leftFootShotsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total minutes played */
  minutesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total non-penalty expected goals */
  npXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Number of possessions */
  numPossessions?: Maybe<Scalars['Float']['output']>;
  /** Total net on-ball value for team */
  obvForNetTotal?: Maybe<Scalars['Float']['output']>;
  /** Total net on-ball value */
  obvTotalNetTotal?: Maybe<Scalars['Float']['output']>;
  /** Organization identifier */
  organizationId: Scalars['ID']['output'];
  /** Total successful outswing deliveries */
  outswingSuccessTotal?: Maybe<Scalars['Float']['output']>;
  /** Total outswing deliveries */
  outswingTotal?: Maybe<Scalars['Float']['output']>;
  /** Total pass expected value difference */
  passXpDiffTotal?: Maybe<Scalars['Float']['output']>;
  /** Total passes into the box */
  passesIntoBoxTotal?: Maybe<Scalars['Float']['output']>;
  /** Total passes attempted */
  passesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total penalty goals */
  penaltyGoalsTotal?: Maybe<Scalars['Float']['output']>;
  /** Player identifier */
  playerId: Scalars['ID']['output'];
  /** Total pressure regains */
  pressureRegainsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total pressures applied */
  pressuresTotal?: Maybe<Scalars['Float']['output']>;
  /** Total progressive carries */
  progressiveCarriesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total progressive passes */
  progressivePassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total right foot passes */
  rightFootPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total right foot shots */
  rightFootShotsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total save blocks */
  saveBlocksTotal?: Maybe<Scalars['Float']['output']>;
  /** Second yellow cards in this game (0 or 1). A second yellow IS a dismissal but carries NO red card in the feed, so it is counted only here. Prefer dismissalsTotal over summing this yourself. */
  secondYellowCardsTotal: Scalars['Int']['output'];
  /** STRAIGHT red cards in this game (0 or 1). Does NOT include dismissals by second yellow, which carry no red - so this is not 'was sent off' and alone misses roughly 45% of dismissals. Use dismissalsTotal for that. */
  straightRedCardsTotal: Scalars['Int']['output'];
  /** Total successful aerials in forward half */
  successfulAerialsFhalfTotal?: Maybe<Scalars['Float']['output']>;
  /** Total successful aerials */
  successfulAerialsTotal?: Maybe<Scalars['Float']['output']>;
  /** Total successful dribbles */
  successfulDribblesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total successful passes */
  successfulPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total successful tackles */
  successfulTacklesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total tackles */
  tacklesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total passes to final third */
  toF3PassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Total xG uplift */
  xgUpliftTotal?: Maybe<Scalars['Float']['output']>;
  /** Yellow cards received in this game, exactly as the provider emits them (not rolled up). A dismissal by second yellow reports 1 here AND 1 in secondYellowCardsTotal - the two are counted separately rather than combined. The value follows the feed and is not capped. 0 means no yellow in a game that has data - a game with no data returns no record at all rather than a zero. */
  yellowCardsTotal: Scalars['Int']['output'];
};

/** Gender division of a player, team, league, or competition */
export enum Gender {
  Female = 'female',
  Male = 'male'
}

/** A scheduled thing of a kind that has no dedicated type yet. Exposes only the shared ScheduledThing fields, so a newly registered kind is immediately assignable and queryable without a migration or a schema change. */
export type GenericScheduledThing = Node & ScheduledThing & {
  __typename?: 'GenericScheduledThing';
  /** How precisely the date is known. */
  datePrecision: MatchDatePrecision;
  /** Unique identifier for the scheduled thing */
  id: Scalars['ID']['output'];
  /** The registered kind of this thing. Unrecognised values are expected here — that is the point of this type. */
  kind: Scalars['String']['output'];
  /** Civil date at the venue in ISO-8601 (YYYY-MM-DD), not an instant. */
  scheduledDate: Scalars['String']['output'];
  /** Inclusive last day of the window when datePrecision is WINDOW; null otherwise. */
  scheduledEndDate?: Maybe<Scalars['String']['output']>;
  /** Identifier of the scheduled_thing row this node specialises. Distinct from `id`, which is the concrete node's own key — for a Match the two are minted separately. Exposed because it is the key `listAssignments(filter: { scheduledThingIds })` matches on: joining assignments on `id` compiles, returns 200 and yields an empty list forever, which renders as 'no scouts assigned' rather than as an error. */
  scheduledThingId: Scalars['ID']['output'];
  /** Start time as a civil time at the venue (HH:mm), or null when to be confirmed. */
  startTime?: Maybe<Scalars['String']['output']>;
  /** IANA timezone for interpreting the date and time. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Human label for this thing, such as a tournament name or meeting subject. */
  title?: Maybe<Scalars['String']['output']>;
  /** Free-text venue name, or null when unknown. */
  venue?: Maybe<Scalars['String']['output']>;
};

/** GPR score bands for first-team player distribution */
export enum GprBand {
  /** Players with GPR >= 70 and < 80 */
  Gpr_70To_79 = 'GPR_70_TO_79',
  /** Players with GPR >= 80 */
  Gpr_80Plus = 'GPR_80_PLUS',
  /** Players with GPR < 70 */
  GprBelow_70 = 'GPR_BELOW_70'
}

/** A first-team player within a specific GPR band */
export type GprBandPlayer = {
  __typename?: 'GprBandPlayer';
  /** Time-decayed GPR score */
  gpr: Scalars['Float']['output'];
  /** Player display name */
  name: Scalars['String']['output'];
  /** Player UUID */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation */
  primaryPosition: Scalars['String']['output'];
  /** Team name */
  teamName: Scalars['String']['output'];
};

/** One group's EDITOR or VIEWER grant on a watchlist or scenario; a group is never the owner */
export type GroupGrant = Node & {
  __typename?: 'GroupGrant';
  /** Timestamp of the grant */
  createdAt: Scalars['DateTime']['output'];
  /** The shared watchlist or scenario */
  entityId: Scalars['ID']['output'];
  /** WATCHLIST or SCENARIO */
  entityType: ShareEntityType;
  /** The owner who granted it */
  grantedByUserId: Scalars['ID']['output'];
  /** The group this grant reaches, with its current audience */
  group: ShareGroup;
  /** Unique identifier of the group grant */
  id: Scalars['ID']['output'];
  /** The aggregate's organization */
  organizationId: Scalars['ID']['output'];
  /** EDITOR or VIEWER */
  role: GroupGrantRole;
};

/** EDITOR or VIEWER; a group is never OWNER */
export enum GroupGrantRole {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

/** Composite home dashboard payload bundling the six per-squad home widgets in a single round trip */
export type HomeDashboardData = {
  __typename?: 'HomeDashboardData';
  /** First-team roster players with contracts expiring within 12 months, or NULL when the viewer may not see contract dates. Null is NEVER an empty list — an empty list asserts that no contract expires in the window, which is a statement about the squad rather than a refusal to answer. Distinguish the two: null means 'not permitted to know', [] means 'none'. */
  expiringContractPlayers?: Maybe<Array<ExpiringContractPlayer>>;
  /** Currently injured first-team roster players */
  injuredRosterPlayers: Array<InjuredPlayer>;
  /** League GPR spectrum with the user's club position */
  leagueGprSpectrum: LeagueGprSpectrum;
  /** First-team roster players currently on loan */
  onLoanPlayers: Array<OnLoanPlayer>;
  /** Counts of first-team roster players with contracts expiring within 6 and 12 months */
  rosterExpiringContracts: RosterExpiringContracts;
  /** GPR distribution counts across first-team players by band */
  squadGprDistribution: SquadGprDistribution;
};

/** A currently injured first-team roster player with injury details */
export type InjuredPlayer = {
  __typename?: 'InjuredPlayer';
  /** Expected recovery duration in days (null = unknown) */
  daysMissed?: Maybe<Scalars['Int']['output']>;
  /** Date the injury occurred */
  injuryDate: Scalars['DateTime']['output'];
  /** Injury type / description */
  injuryType: Scalars['String']['output'];
  /** Player display name */
  name: Scalars['String']['output'];
  /** Player UUID */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation */
  primaryPosition: Scalars['String']['output'];
};

/** Handles user invitations to join organizations, managing the invitation lifecycle from creation to acceptance or rejection */
export type Invitation = Node & {
  __typename?: 'Invitation';
  /** Timestamp of invitation creation */
  createdAt: Scalars['DateTime']['output'];
  /** Email address of invitee */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for invitation */
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  /** Foreign key to organization being invited to */
  organizationId: Scalars['ID']['output'];
  /** Phone number of invitee */
  phoneNumber: Scalars['String']['output'];
  receiver?: Maybe<User>;
  role?: Maybe<Role>;
  /** Foreign key to role being assigned */
  roleId: Scalars['ID']['output'];
  /** Current status of invitation */
  status: InvitationStatus;
  /** Timestamp of last invitation update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** Foreign key to user who sent invitation */
  userId: Scalars['ID']['output'];
};

/** A connection to a list of invitations */
export type InvitationConnection = {
  __typename?: 'InvitationConnection';
  /** A list of edges */
  edges: Array<InvitationEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in an InvitationConnection */
export type InvitationEdge = Edge & {
  __typename?: 'InvitationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Invitation node */
  node: Invitation;
};

/** Status of an invitation to join an organization */
export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Field definition within a JSONB column structure for schema discovery */
export type JsonSchemaFieldModel = {
  __typename?: 'JsonSchemaFieldModel';
  /** Name of the JSON field */
  name: Scalars['String']['output'];
  /** Nested fields if this is an object type */
  nested?: Maybe<Array<JsonSchemaFieldModel>>;
  /** Whether null values were observed for this field */
  nullable: Scalars['Boolean']['output'];
  /** Inferred data type of the field (string, number, boolean, object, array) */
  type: Scalars['String']['output'];
};

/** Schema structure discovered from a JSONB column through data sampling */
export type JsonSchemaModel = {
  __typename?: 'JsonSchemaModel';
  /** List of fields discovered in the JSONB column */
  fields: Array<JsonSchemaFieldModel>;
};

/** Represents a kanban board for tracking player recruitment and scouting progress. Each board contains multiple phases that players move through during the evaluation process. */
export type KanbanBoard = Node & {
  __typename?: 'KanbanBoard';
  /** Timestamp of kanban board creation */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this kanban board */
  createdBy: Scalars['ID']['output'];
  creator: User;
  /** Whether the current viewer keeps a personal card order on this PIPELINE board. When false the viewer sees the shared default order. Always false for ROSTER and WATCHLIST boards. */
  hasPersonalCardOrder: Scalars['Boolean']['output'];
  /** Unique identifier for the kanban board */
  id: Scalars['ID']['output'];
  /** When true, the kanban board is visible to all users in the organization */
  isPublic: Scalars['Boolean']['output'];
  /** The display name of the kanban board */
  name: Scalars['String']['output'];
  organization: Organization;
  /** The organization that owns this kanban board */
  organizationId: Scalars['ID']['output'];
  phases: Array<KanbanPhase>;
  /** The seeded workflow template used by this pipeline board */
  pipelineTemplate?: Maybe<KanbanPipelineTemplate>;
  /** The ID of the source entity. Required for WATCHLIST boards (to specify which watchlist). Optional for ROSTER boards (user only has one roster). */
  sourceId?: Maybe<Scalars['ID']['output']>;
  /** The type of source this board is connected to (e.g., ROSTER, WATCHLIST) */
  sourceType: KanbanSourceType;
  /** Timestamp of last kanban board update */
  updatedAt: Scalars['DateTime']['output'];
  users: UserKanbanBoardConnection;
  validOutcomes: Array<KanbanCardOutcome>;
};


/** Represents a kanban board for tracking player recruitment and scouting progress. Each board contains multiple phases that players move through during the evaluation process. */
export type KanbanBoardUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of kanban boards */
export type KanbanBoardConnection = {
  __typename?: 'KanbanBoardConnection';
  /** A list of edges */
  edges: Array<KanbanBoardEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a KanbanBoardConnection */
export type KanbanBoardEdge = Edge & {
  __typename?: 'KanbanBoardEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The KanbanBoard node */
  node: KanbanBoard;
};

/** Filterable performance and goalkeeper metrics for a player carded on a kanban board. Field names match PlayerBioData so filter predicates can be reused verbatim. */
export type KanbanBoardPlayerMetrics = {
  __typename?: 'KanbanBoardPlayerMetrics';
  /** Carrying global categorical score (transformed) */
  carryingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling global categorical score (transformed) */
  dribblingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Overall fit score (0-1) */
  fitScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper passing categorical score (transformed) */
  gkPassingTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper positioning categorical score (transformed) */
  gkPositioningTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shot stopping categorical score (transformed) */
  gkShotStoppingTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing global categorical score (transformed) */
  passingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** The player this metrics row belongs to */
  playerId: Scalars['ID']['output'];
  /** Shot location global categorical score (transformed); backs the Shooting filter */
  shotLocationTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Team style fit score (0-100) */
  teamStyleFit?: Maybe<Scalars['Float']['output']>;
};

/** Represents a board-specific color customization for a tag. When a tag is used on a board, it can have a custom color that overrides the default. All users who access the board see the same color. */
export type KanbanBoardTag = {
  __typename?: 'KanbanBoardTag';
  board: KanbanBoard;
  /** Hex color code for the tag on this board (e.g., #3B82F6). Null means use the default blue color. */
  color?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this association was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the board-tag association */
  id: Scalars['ID']['output'];
  /** The kanban board this color customization belongs to */
  kanbanBoardId: Scalars['ID']['output'];
  /** The tag being customized */
  kanbanTagId: Scalars['ID']['output'];
  /** Organization this association belongs to */
  organizationId: Scalars['ID']['output'];
  tag: KanbanTag;
  /** Timestamp when this association was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Connection type for paginated KanbanBoardTag queries following Relay spec */
export type KanbanBoardTagConnection = {
  __typename?: 'KanbanBoardTagConnection';
  /** A list of edges */
  edges: Array<KanbanBoardTagEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for KanbanBoardTag connections */
export type KanbanBoardTagEdge = {
  __typename?: 'KanbanBoardTagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The KanbanBoardTag node */
  node: KanbanBoardTag;
};

/** Represents a player card within a kanban phase. Each card tracks a specific player's position and progress through the recruitment pipeline. */
export type KanbanCard = Node & {
  __typename?: 'KanbanCard';
  /** SE-5628: the organization member who owns this card's progression, or null when the card is unassigned. */
  assignedToUserId?: Maybe<Scalars['ID']['output']>;
  assignee?: Maybe<User>;
  /** Timestamp when the terminal outcome was recorded */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of kanban card creation */
  createdAt: Scalars['DateTime']['output'];
  /** The user who added this player to the kanban board */
  createdBy: Scalars['ID']['output'];
  creator: User;
  /** Timestamp when the card entered its current pipeline stage */
  enteredStageAt: Scalars['DateTime']['output'];
  /** Unique identifier for the kanban card */
  id: Scalars['ID']['output'];
  kanbanBoard: KanbanBoard;
  /** The ID of the kanban board this card belongs to */
  kanbanBoardId: Scalars['ID']['output'];
  kanbanPhase: KanbanPhase;
  /** The ID of the phase this card is currently in */
  kanbanPhaseId: Scalars['ID']['output'];
  /** SE-6866: the user who last edited this card, or null if no human has edited it since the field shipped. Never set by automation. */
  lastEditedByUserId?: Maybe<Scalars['ID']['output']>;
  lastEditor?: Maybe<User>;
  /** Optional notes about this player's recruitment status or evaluation */
  notes?: Maybe<Scalars['String']['output']>;
  /** Terminal pipeline outcome, or null while still active */
  outcome?: Maybe<KanbanCardOutcome>;
  player?: Maybe<Player>;
  /** The ID of the player this card represents */
  playerId: Scalars['ID']['output'];
  /** The position of this card within its phase. Lower numbers appear first. */
  position: Scalars['Int']['output'];
  /** The 1-based rank within this phase. PIPELINE ranks use the current viewer's private ordering; ROSTER and WATCHLIST ranks remain derived from shared position. Writes use updateKanbanCardPositions. */
  rank: Scalars['Int']['output'];
  tags: Array<KanbanTag>;
  /** Timestamp of last kanban card update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Relay-compliant connection type for paginated KanbanCard results. Implements the standard Connection interface for consistent pagination. */
export type KanbanCardConnection = Connection & {
  __typename?: 'KanbanCardConnection';
  /** A list of edges */
  edges: Array<KanbanCardEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Relay-compliant edge type for KanbanCard connections. Wraps each KanbanCard node with its pagination cursor. */
export type KanbanCardEdge = Edge & {
  __typename?: 'KanbanCardEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The KanbanCard node */
  node: KanbanCard;
};

/** The terminal outcome recorded for a pipeline candidate */
export enum KanbanCardOutcome {
  Passed = 'PASSED',
  Promoted = 'PROMOTED',
  Returned = 'RETURNED',
  Signed = 'SIGNED',
  Sold = 'SOLD',
  Withdrawn = 'WITHDRAWN'
}

/** Represents a phase or stage within a kanban board. Players are organized into phases as they progress through the recruitment process. */
export type KanbanPhase = Node & {
  __typename?: 'KanbanPhase';
  cards: Array<KanbanCard>;
  /** Timestamp of kanban phase creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the kanban phase */
  id: Scalars['ID']['output'];
  /** Whether the phase contains sensitive player information */
  isProtected: Scalars['Boolean']['output'];
  /** Whether this is a terminal phase */
  isTerminal: Scalars['Boolean']['output'];
  kanbanBoard: KanbanBoard;
  /** The ID of the kanban board this phase belongs to */
  kanbanBoardId: Scalars['ID']['output'];
  /** The display name of this phase (e.g., "Discovery", "Evaluation") */
  name: Scalars['String']['output'];
  /** The position of this phase within the board. Lower numbers appear first. */
  position: Scalars['Int']['output'];
  /** Optional target number of days for cards in this phase */
  timeTargetDays?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of last kanban phase update */
  updatedAt: Scalars['DateTime']['output'];
};

/** The seeded workflow template used by a player pipeline */
export enum KanbanPipelineTemplate {
  AcademyPromotions = 'ACADEMY_PROMOTIONS',
  Custom = 'CUSTOM',
  NewAcquisitions = 'NEW_ACQUISITIONS',
  OutgoingTransfers = 'OUTGOING_TRANSFERS'
}

/** The type of source a kanban board can be connected to */
export enum KanbanSourceType {
  Pipeline = 'PIPELINE',
  Roster = 'ROSTER',
  Watchlist = 'WATCHLIST'
}

/** Represents a tag that can be applied to kanban cards. Tags are organization-specific and can be used to categorize or label cards. */
export type KanbanTag = Node & {
  __typename?: 'KanbanTag';
  /** The number of kanban cards that have this tag. Cards on PIPELINE boards are excluded, for every caller regardless of role. */
  cardCount: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  /** Timestamp of kanban tag creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the kanban tag */
  id: Scalars['ID']['output'];
  /** The name of the tag (e.g., "High Priority", "Backend", "Design Review") */
  name: Scalars['String']['output'];
  /** Timestamp of last kanban tag update */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a tag that can be applied to kanban cards. Tags are organization-specific and can be used to categorize or label cards. */
export type KanbanTagColorArgs = {
  kanbanBoardId: Scalars['ID']['input'];
};

/** A connection to a list of kanban tags */
export type KanbanTagConnection = {
  __typename?: 'KanbanTagConnection';
  /** A list of edges */
  edges: Array<KanbanTagEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a KanbanTagConnection */
export type KanbanTagEdge = Edge & {
  __typename?: 'KanbanTagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The KanbanTag node */
  node: KanbanTag;
};

/** Professional sports league with sport affiliation and country association */
export type League = Node & {
  __typename?: 'League';
  /** Country the league is based in */
  country?: Maybe<Scalars['String']['output']>;
  /** Timestamp of league record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Gender division of the league */
  gender: Gender;
  /** Unique identifier for the league */
  id: Scalars['ID']['output'];
  isMyOrganizationLeague: Scalars['Boolean']['output'];
  /** Name of the league */
  name: Scalars['String']['output'];
  /** Sport this league belongs to */
  sport: Sport;
  /** Sport ID this league belongs to */
  sportId: Scalars['ID']['output'];
  /** Timestamp of last league record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of leagues */
export type LeagueConnection = {
  __typename?: 'LeagueConnection';
  /** A list of edges */
  edges: Array<LeagueEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a LeagueConnection */
export type LeagueEdge = Edge & {
  __typename?: 'LeagueEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The League node */
  node: League;
};

/** League GPR spectrum showing user's club position relative to the league */
export type LeagueGprSpectrum = {
  __typename?: 'LeagueGprSpectrum';
  /** Highest club average GPR in the league */
  highestClubGpr: Scalars['Float']['output'];
  /** League-wide average GPR across all clubs */
  leagueAverageGpr: Scalars['Float']['output'];
  /** Lowest club average GPR in the league */
  lowestClubGpr: Scalars['Float']['output'];
  /** Total clubs in the league with GPR data */
  totalClubs: Scalars['Int']['output'];
  /** User's club average GPR (top 23 players), null if no data */
  userClubGpr?: Maybe<Scalars['Float']['output']>;
  /** User's club rank in the league, null if no data */
  userClubRank?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a paginated list of league player search results */
export type LeaguePlayerSearchConnection = {
  __typename?: 'LeaguePlayerSearchConnection';
  /** A list of edges */
  edges: Array<LeaguePlayerSearchEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a LeaguePlayerSearchConnection */
export type LeaguePlayerSearchEdge = Edge & {
  __typename?: 'LeaguePlayerSearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The league player search node */
  node: LeaguePlayerSearchNode;
};

/** Lightweight player node for the dashboard comparison search dropdown */
export type LeaguePlayerSearchNode = Node & {
  __typename?: 'LeaguePlayerSearchNode';
  /** Time-decayed GPR score */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Player UUID */
  id: Scalars['ID']['output'];
  /** The full player entity, resolved via DataLoader */
  player?: Maybe<Player>;
};

/** Input for listing assignable scouts. Supplying onDate populates each scout's same-day workload in the same round trip rather than requiring a per-scout query. */
export type ListAssignableScoutsInput = {
  /** Scheduled thing to exclude from the same-day count. Pass the fixture being assigned so a scout already on it is not reported as conflicting with themselves. */
  excludeScheduledThingId?: InputMaybe<Scalars['ID']['input']>;
  /** Civil date, ISO-8601 (YYYY-MM-DD), to compute each scout's same-day assignment count against. Omit to receive zero counts. */
  onDate?: InputMaybe<Scalars['String']['input']>;
  /** Optional case-insensitive, accent-insensitive substring filter on the scout's display name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Filter input for listing user watchlists */
export type ListMyUserWatchlistsFilterInput = {
  /** Filter by user's role on the watchlist */
  role?: InputMaybe<UserWatchlistRole>;
};

/** Optional filter for listScheduledThings: by registered kind and by inclusive civil-date range. */
export type ListScheduledThingsInput = {
  /** Inclusive first civil date (YYYY-MM-DD). */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Kinds to include (e.g. TRAINING_VISIT). Omit for every kind, matches included. */
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Inclusive last civil date (YYYY-MM-DD). */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** Input for ordering shadow team list results */
export type ListShadowTeamOrderByInput = {
  /** Sort by shadow team creation date */
  createdAt?: InputMaybe<OrderByDirection>;
  /** Sort by shadow team name */
  name?: InputMaybe<OrderByDirection>;
};

/** Direction of a loan relative to a queried team — OUT = the team's players on loan elsewhere; IN = players on loan at the team; ALL = both (argument only). */
export enum LoanDirection {
  All = 'ALL',
  In = 'IN',
  Out = 'OUT'
}

/** Input type for logging a user into a specific organization */
export type LogIntoOrganizationInput = {
  /** The ID of the organization to log into */
  organizationId: Scalars['ID']['input'];
};

/** Input for logging a player profile view */
export type LogPlayerProfileViewInput = {
  /** The ID of the player whose profile was viewed */
  playerId: Scalars['ID']['input'];
};

/** Input for marking activities as read */
export type MarkActivitiesAsReadInput = {
  /** The IDs of the activities to mark as read */
  activityIds: Array<Scalars['String']['input']>;
};

/** A match as a first-class entity, usable by fixture planning, the match page and capture. Fully functional with zero provider data: manual fixtures carry source MANUAL, a null provider linkage, and may have an unconfirmed kick-off or unknown venue. */
export type Match = Node & ScheduledThing & {
  __typename?: 'Match';
  /** The away team */
  awayTeam: Team;
  /** Final away score, or null when the fixture has no known score. */
  awayTeamScore?: Maybe<Scalars['Int']['output']>;
  /** Free-text competition label used when there is no catalog league. Prefer competitionName, which resolves this and league.name into one value. */
  competitionLabel?: Maybe<Scalars['String']['output']>;
  /** Display name of the competition, derived server-side as league.name falling back to competitionLabel. Exposed so clients render one field rather than reimplementing the fallback. */
  competitionName?: Maybe<Scalars['String']['output']>;
  /** Timestamp of match creation */
  createdAt: Scalars['DateTime']['output'];
  /** How precisely the fixture's date is known. */
  datePrecision: MatchDatePrecision;
  /** The home team */
  homeTeam: Team;
  /** Final home score, or null when the fixture has no known score. */
  homeTeamScore?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the match */
  id: Scalars['ID']['output'];
  /** Discriminator for the ScheduledThing interface. Always MATCH for this type. */
  kind: Scalars['String']['output'];
  /** The competition catalog row this fixture belongs to, or null for a friendly or youth fixture with no catalog league. */
  league?: Maybe<League>;
  /** Provider match key when this fixture is linked to or was reconciled against provider data; null for a purely manual fixture. */
  providerMatchGgid?: Maybe<Scalars['String']['output']>;
  /** Civil date of the fixture at the venue in ISO-8601 (YYYY-MM-DD), not an instant. */
  scheduledDate: Scalars['String']['output'];
  /** Inclusive last day of the window when datePrecision is WINDOW; null otherwise. */
  scheduledEndDate?: Maybe<Scalars['String']['output']>;
  /** Identifier of the scheduled_thing row this node specialises. Distinct from `id`, which is the concrete node's own key — for a Match the two are minted separately. Exposed because it is the key `listAssignments(filter: { scheduledThingIds })` matches on: joining assignments on `id` compiles, returns 200 and yields an empty list forever, which renders as 'no scouts assigned' rather than as an error. */
  scheduledThingId: Scalars['ID']['output'];
  /** Provenance of this record. MANUAL is the signal for the 'Added by you · no provider data' marker. This is history rather than current linkage: a MERGED match whose provider fixture was later removed stays MERGED. */
  source: MatchSource;
  /** Kick-off time as a civil time at the venue (HH:mm), or null when to be confirmed. Render null as 'time TBC', never as 00:00. */
  startTime?: Maybe<Scalars['String']['output']>;
  /** Lifecycle of the fixture. Note that nothing gates report creation or evaluation writes on this value — capture against a future SCHEDULED fixture is supported by design. SE-7295: this is a MANUAL annotation nothing transitions automatically; use `timeframe` for past/upcoming, never `status`. */
  status: MatchStatus;
  /** IANA timezone for interpreting the date and kick-off; null means the organisation's locale. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** SE-7295: whether the fixture is PAST or UPCOMING, derived on the server from the scheduled date (civil, no timezone), never from `status`. A fixture dated today is UPCOMING. The stat cards count this and the Past/Upcoming filter narrows on the same rule, so the two cannot disagree. */
  timeframe: MatchTimeframe;
  /** Null for matches — the interface field exists for kinds that carry their own label. */
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last match update */
  updatedAt: Scalars['DateTime']['output'];
  /** Free-text venue name, or null when unknown. */
  venue?: Maybe<Scalars['String']['output']>;
};

/** Minutes one player was on the pitch in one match, entered by hand. One record per player per match. Distinct from a match event, whose minute is a moment rather than a duration. */
export type MatchAppearance = Node & {
  __typename?: 'MatchAppearance';
  /** Timestamp of appearance creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the appearance */
  id: Scalars['ID']['output'];
  /** Identifier of the match this appearance belongs to */
  matchId: Scalars['ID']['output'];
  /** Minutes on the pitch. Null means the appearance is recorded but its duration is not yet known — never treat it as zero, because 'featured' and 'played 0 minutes' are different facts. */
  minutesPlayed?: Maybe<Scalars['Int']['output']>;
  /** The player who appeared */
  player: Player;
  /** The side the player appeared for */
  team: Team;
  /** Timestamp of last appearance update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Connection type for paginated Match results. Carries no totalCount: the count is a full unbounded COUNT(*) that type-ahead callers should not pay for. */
export type MatchConnection = Connection & {
  __typename?: 'MatchConnection';
  /** A list of edges */
  edges: Array<MatchEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Scouting coverage aggregates for a date range, computed server-side so the figures describe the whole range rather than whichever page a client happens to have loaded. */
export type MatchCoverageSummary = {
  __typename?: 'MatchCoverageSummary';
  /** Distinct scouts holding at least one assignment in the range. A measure of who is deployed, not of how many scouts exist in the organisation. */
  activeScoutCount: Scalars['Int']['output'];
  /** Fixtures in the range with no scout assigned. Always upcomingFixtureCount minus withCoverageCount; exposed explicitly so the unassigned stat card needs no client arithmetic. */
  unassignedCount: Scalars['Int']['output'];
  /** Fixtures scheduled within the requested range */
  upcomingFixtureCount: Scalars['Int']['output'];
  /** Fixtures in the range with at least one scout assigned. Counts fixtures, not assignments, so two scouts on one fixture count once. */
  withCoverageCount: Scalars['Int']['output'];
};

/** Inclusive civil-date range for a coverage summary. Both bounds are required, so a stat card can never accidentally aggregate an organisation's whole fixture history. */
export type MatchCoverageSummaryInput = {
  /** First civil date in range, ISO-8601 (YYYY-MM-DD), inclusive. */
  fromDate: Scalars['String']['input'];
  /** Last civil date in range, ISO-8601 (YYYY-MM-DD), inclusive. */
  toDate: Scalars['String']['input'];
};

/** How precisely a scheduled thing's date is known: EXACT is a confirmed day, WINDOW spans scheduledDate..scheduledEndDate inclusive, ROUND_ONLY means only the competition round is known. */
export enum MatchDatePrecision {
  Exact = 'EXACT',
  RoundOnly = 'ROUND_ONLY',
  Window = 'WINDOW'
}

/** Basic information about a specific match */
export type MatchDetail = {
  __typename?: 'MatchDetail';
  /** Match venue */
  ground?: Maybe<Scalars['String']['output']>;
  /** Date the match was played */
  matchDate?: Maybe<Scalars['DateTime']['output']>;
  /** Opposing team name */
  opponent?: Maybe<Scalars['String']['output']>;
  /** Team name */
  team?: Maybe<Scalars['String']['output']>;
};

/** Edge type for Match connection */
export type MatchEdge = Edge & {
  __typename?: 'MatchEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Match node */
  node: Match;
};

/** A basic match event entered by hand — a goal or a card, with the minute it happened. Attached to the match rather than to a report, because what happened in a fixture is the same for every scout who watched it. */
export type MatchEvent = Node & {
  __typename?: 'MatchEvent';
  /** Timestamp of event creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the match event */
  id: Scalars['ID']['output'];
  /** What happened. An own goal is its own kind rather than a flag on GOAL, because the side it counts for is not the scorer's. */
  kind: MatchEventKind;
  /** Identifier of the match this event happened in */
  matchId: Scalars['ID']['output'];
  /** Minute the event occurred. Stoppage time is the minute played in (93), not 90+3 — a plain integer is what every reader can sort and compare, and the notation is a presentation concern. Null when the event is known but its minute is not. */
  minute?: Maybe<Scalars['Int']['output']>;
  /** The player involved, when known. Null is a legitimate record rather than missing data: a goal seen without the scorer being identified is still a fact about the match, and refusing it would discard it. */
  player?: Maybe<Player>;
  /** The side the player involved was playing for. For an OWN_GOAL this is still the scorer's own team — the benefiting side is derived by the reader, so this field never changes meaning. */
  team: Team;
  /** Timestamp of last event update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A basic, manually recorded match event: GOAL, OWN_GOAL, YELLOW_CARD or RED_CARD. Deliberately limited to the basics the PRD includes — this is not a provider event feed. */
export enum MatchEventKind {
  Goal = 'GOAL',
  OwnGoal = 'OWN_GOAL',
  RedCard = 'RED_CARD',
  YellowCard = 'YELLOW_CARD'
}

/** Filter for listing matches. Date bounds are inclusive and compare against the fixture's civil date; a WINDOW-precision fixture matches when any day of its window falls in range. */
export type MatchFilterInput = {
  /** Restrict to fixtures assigned to any of these scouts. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Earliest civil date to include, ISO-8601 (YYYY-MM-DD), inclusive. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to fixtures in any of these catalog leagues. */
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict by provenance, for example MANUAL to list only fixtures added in-product. */
  sources?: InputMaybe<Array<MatchSource>>;
  /** Restrict to fixtures in any of these lifecycle states. */
  statuses?: InputMaybe<Array<MatchStatus>>;
  /** Restrict to fixtures involving any of these teams, on either side. */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to past or upcoming fixtures, derived from the scheduled date on the server (SE-7295). Orthogonal to `statuses`, which is a manual lifecycle nobody transitions: a played fixture never moved off SCHEDULED is still PAST here. Omit for both. */
  timeframe?: InputMaybe<MatchTimeframe>;
  /** Latest civil date to include, ISO-8601 (YYYY-MM-DD), inclusive. */
  toDate?: InputMaybe<Scalars['String']['input']>;
  /** When true, return only fixtures with no scout assigned. When false, return only fixtures with at least one. Omit for both. */
  unassignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The fixture-level shell of a match report, holding N independent per-player evaluations. Status and all counts are derived server-side on every read so the capture screen, the reports list and the player page cannot compute completeness three different ways. */
export type MatchReport = Node & {
  __typename?: 'MatchReport';
  /** Timestamp of report creation */
  createdAt: Scalars['DateTime']['output'];
  /** SE-7556 — whether the working copy currently differs from the published snapshot, i.e. there are edits the club has not yet been shown. A real per-evaluation content comparison, computed on every read so it survives a cold load (a reload or a second device, where the client holds no local edit history). False before submit — there is no published snapshot to differ from. It is complete from the evaluations alone because watchMode is the only report-level editable field and updateMatchReport is refused once submitted, so nothing report-level can change post-submit. */
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  /** Unique identifier for the match report */
  id: Scalars['ID']['output'];
  /** SE-7556 — when the published snapshot was last written: stamped on first submit (submit is a publish) and on every publishMatchReport. Null until submitted. This is a 'last saved at' timestamp, NOT the unsaved-changes signal — read hasUnpublishedChanges for that. */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The fixture this report covers */
  match: Match;
  /** SE-8013: evaluations the scout formed a judgement on, i.e. carrying notedAt — the same population a client gets by filtering playerEvaluations on isNoted. The only count here that can be lower than playerCount, and the one a 'N players' summary should show when its detail view lists noted rows: counting playerCount there states a number the detail then contradicts. Reads the same snapshot as the rest of the counts, so it cannot disagree with the playerEvaluations returned alongside it. Expect it BELOW the pre-SE-7817 value: a starter toggle alone no longer notes a player. */
  notedCount: Scalars['Int']['output'];
  /** Evaluation rows on this report, that is the squad actually loaded for capture. Distinct from squadSize, which is the squad the scout intends to cover. */
  playerCount: Scalars['Int']['output'];
  /** The independent per-player evaluations on this report. Each is a separate record; no field of one is reachable through another. */
  playerEvaluations: Array<MatchReportPlayerEvaluation>;
  /** Teams this report covers, with each covered squad's size */
  reportTeams: Array<MatchReportTeam>;
  /** Evaluations carrying a Performance score. The numerator of the completion condition behind status (over tickedCount, the squad). */
  scoredCount: Scalars['Int']['output'];
  /** The scout who authors this report */
  scoutUser: User;
  /** Scouts assigned to this fixture, read from the fixture's assignments rather than stored on the report, so coverage has a single source of truth shared with the fixture-planning surfaces. */
  scouts: Array<User>;
  /** Total intended squad size across the covered teams. Null until squads are known; null rather than zero so a client renders no ratio instead of a misleading one. NOTE (SE-7286): the old 'tickedCount of squadSize = N noted of M' header is void now that tickedCount means squad membership, not noted — the replacement header/denominator is the frontend half's call (AC#3). */
  squadSize?: Maybe<Scalars['Int']['output']>;
  /** Server-derived completeness (SE-7286): COMPLETE when the squad is non-empty and every squad member carries a Performance score, otherwise PARTIAL. The denominator is the squad, so scoring only some of the squad is PARTIAL. Never client-set and never stored, so it cannot drift from the evaluations that define it. */
  status: MatchReportStatus;
  /** When the report was submitted, or null if never. Independent of status: a PARTIAL report can be submitted, which is what the partial-submit flow does. Re-submitting does not change this value. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** SE-7286: squad members — every evaluation row on the report, i.e. the scout's intended-to-evaluate set. The completion denominator (under scoredCount). Equals playerCount by construction (see match-report-status.util). It no longer means 'noted' — a seeded, untouched player counts. */
  tickedCount: Scalars['Int']['output'];
  /** Timestamp of last report update */
  updatedAt: Scalars['DateTime']['output'];
  /** How the scout observed the fixture, or null until chosen. A single enum rather than a pair of booleans, so live-and-video and neither-live-nor-video are unrepresentable. */
  watchMode?: Maybe<MatchWatchMode>;
};

/** Connection type for paginated MatchReport results, shaped one row per report rather than one row per player. */
export type MatchReportConnection = Connection & {
  __typename?: 'MatchReportConnection';
  /** A list of edges */
  edges: Array<MatchReportEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for MatchReport connection */
export type MatchReportEdge = Edge & {
  __typename?: 'MatchReportEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The MatchReport node */
  node: MatchReport;
};

/** Filter for listing match reports. Note that filtering by status filters on a server-derived value rather than a stored column, since status is computed from the evaluation rows. */
export type MatchReportFilterInput = {
  /** Earliest fixture civil date to include, ISO-8601 (YYYY-MM-DD), inclusive. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to reports covering these matches. */
  matchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to reports containing an evaluation of any of these players. */
  playerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to reports authored by these scouts. */
  scoutUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict by derived completeness. Evaluated from the evaluation rows rather than read from a stored column. */
  statuses?: InputMaybe<Array<MatchReportStatus>>;
  /** When true, return only submitted reports; when false, only unsubmitted. Omit for both. Independent of status, since a PARTIAL report can be submitted. */
  submittedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to reports whose fixture involves any of these teams, on either side. Matched on the fixture's home and away sides rather than on the report's covered teams, because covered teams are optional and absent on many reports — a covered-team filter would silently omit them. */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Latest fixture civil date to include, ISO-8601 (YYYY-MM-DD), inclusive. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** One independent per-player evaluation within a match report: Performance and Potential on a 0-10 scale, a note, a starter flag and a noted state. Stored as its own row with typed columns, so no evaluation's fields are reachable through another and aggregation needs no payload parsing. */
export type MatchReportPlayerEvaluation = Node & {
  __typename?: 'MatchReportPlayerEvaluation';
  /** Timestamp of evaluation creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the evaluation */
  id: Scalars['ID']['output'];
  /** Whether the scout has attended to this player at all, defined as any of performanceScore, potentialScore or note being present — a judgement about the player. Roster metadata (isStarter, shirtNumber) is deliberately excluded, so marking a starting XI files nobody into the report. */
  isNoted: Scalars['Boolean']['output'];
  /** Whether the player started. Three-state on purpose: null means the scout has not said, which is not the same as an explicit did-not-start and must not be rendered as false. Roster metadata rather than a judgement: it does not contribute to isNoted. */
  isStarter?: Maybe<Scalars['Boolean']['output']>;
  /** Free-text note about this player in this fixture */
  note?: Maybe<Scalars['String']['output']>;
  /** When this evaluation first became noted, or null while untouched. Exposed alongside isNoted so a client can order by recency of attention rather than only by presence. */
  notedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Performance rating on a 0-10 scale, or null when not yet scored. Null is meaningfully different from 0 and must not be rendered as a zero score. */
  performanceScore?: Maybe<Scalars['Int']['output']>;
  /** The evaluated player. Null when the row holds a placeholder for an unidentified player, or when the caller's organization and gender scope does not permit seeing that player. */
  player?: Maybe<Player>;
  /** Potential rating on a 0-10 scale, or null when not yet scored. Independent of performanceScore — a scout may record either alone. */
  potentialScore?: Maybe<Scalars['Int']['output']>;
  /** The player's shirt number in this fixture, captured onto this evaluation as a point-in-time snapshot, or null when unknown. Null renders as no digit at all — never a placeholder like 0. Roster metadata rather than a judgement: it does not contribute to isNoted. */
  shirtNumber?: Maybe<Scalars['Int']['output']>;
  /** Team the player was evaluated as playing for. Null when the side is unsettled or the fixture is a trial with unattached players. */
  team?: Maybe<Team>;
  /** Timestamp of last evaluation update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Which copy of a submitted match report a read resolves: PUBLISHED (the club's view, the default) or WORKING (the scout's in-progress edits). Before submit the two are identical. Mutation payloads are always WORKING. */
export enum MatchReportSnapshot {
  Published = 'PUBLISHED',
  Working = 'WORKING'
}

/** A player to include in a report's squad, optionally with the side they are being evaluated on. Supply teamId whenever the caller knows the side: deriving it from the player's registered team mis-columns loaned players. When omitted the server matches the player's registered team against the fixture's two sides, and leaves the side null if neither agrees rather than guessing. */
export type MatchReportSquadPlayerInput = {
  /** Identifier of the player to include */
  playerId: Scalars['ID']['input'];
  /** The player's shirt number in this fixture, 1 to 99, stamped onto the evaluation created for a NEWLY added squad member. Ignored for players already in the squad — their number is edited through upsertPlayerEvaluation, same as every other per-row field. Omit when unknown; unknown is null, never 0. */
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The side this player is evaluated on. Omit to let the server derive it from the fixture, which leaves it null when the player's registered team matches neither side. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Server-derived completeness of a match report (SE-7286). COMPLETE when the squad is non-empty and every squad member carries a Performance score; otherwise PARTIAL — so scoring only part of the squad is PARTIAL. Never client-set and never stored. */
export enum MatchReportStatus {
  Complete = 'COMPLETE',
  Partial = 'PARTIAL'
}

/** A team covered by a match report, with the size of the squad the scout intends to cover. The report-level squadSize is the sum of these, so the denominator has one source of truth. */
export type MatchReportTeam = {
  __typename?: 'MatchReportTeam';
  /** Unique identifier for the report-team row */
  id: Scalars['ID']['output'];
  /** Number of players in this squad the scout intends to cover. Null until known — deliberately not defaulted to zero, which would render a misleading '3 of 0'. */
  squadSize?: Maybe<Scalars['Int']['output']>;
  /** The covered team */
  team: Team;
};

/** A team to cover in a report, with the intended squad size. Squad size is optional because it is often unknown when a report is opened; omitting it suppresses the progress ratio rather than making it wrong. */
export type MatchReportTeamInput = {
  /** Number of players in this squad the scout intends to cover. Omit when unknown rather than guessing. */
  squadSize?: InputMaybe<Scalars['Int']['input']>;
  /** Identifier of the team to cover */
  teamId: Scalars['ID']['input'];
};

/** Provenance of a match record: MANUAL was created in-product with no provider data, PROVIDER came from ingestion, MERGED was manual and has since been reconciled against a provider fixture. */
export enum MatchSource {
  Manual = 'MANUAL',
  Merged = 'MERGED',
  Provider = 'PROVIDER'
}

/** Lifecycle of a match: SCHEDULED (the default for new fixtures), IN_PROGRESS, COMPLETED, POSTPONED or CANCELLED. */
export enum MatchStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Postponed = 'POSTPONED',
  Scheduled = 'SCHEDULED'
}

/** Whether a fixture's scheduled day is in the past or still to come, derived from the scheduled date on the server — never from status. A fixture dated today is UPCOMING. */
export enum MatchTimeframe {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

/** How a scout observed the fixture a report covers: LIVE (in person) or VIDEO. */
export enum MatchWatchMode {
  Live = 'LIVE',
  Video = 'VIDEO'
}

/** Simple message response type */
export type Message = {
  __typename?: 'Message';
  /** The message content */
  message: Scalars['String']['output'];
};

/** Bounds for minutes played in dynamic UI controls */
export type MinutesPlayedBounds = {
  __typename?: 'MinutesPlayedBounds';
  /** Maximum minutes played across all players in the dataset */
  max: Scalars['Float']['output'];
  /** Minimum minutes played in the dataset (always 0) */
  min: Scalars['Float']['output'];
};

/** Input for moving a kanban card to a different phase or position */
export type MoveKanbanCardInput = {
  /** The ID of the card to move */
  cardId: Scalars['ID']['input'];
  /** Optional rationale recorded with a stage change; surfaced in the pipeline activity log. Ignored for a same-stage reorder. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the phase to move the card to */
  targetPhaseId: Scalars['ID']['input'];
  /** The position within the target phase. If not provided, the card will be added at the end. */
  targetPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accepts an invitation to join an organization */
  acceptInvitation: Invitation;
  /** Accepts a queued pipeline review request, atomically performing the deferred move with a required reason. */
  acceptPipelineReviewRequest: PipelineReviewRequest;
  /** Activates a user within an organization */
  activateUser: OrganizationUser;
  /**
   * Add a manual line item to a category in the extracted contract data (Owner-only)
   * @deprecated Use addContractLineItem instead. This legacy mutation will be removed.
   */
  addContractExtractionLineItem: ContractExtractionObject;
  /** Add a new line item to a category in extracted contract data (Owner-only) */
  addContractLineItem: ContractLineItemResult;
  /** Adds players to a report's squad, leaving every existing squad member in place. Use this instead of setMatchReportSquad whenever the caller does not hold the complete squad — notably the phone capture picker, whose tick set would otherwise read as removing everyone it omits and be refused wholesale on a submitted report. Add-only by construction: it computes no removal set, so it can never delete an evaluation and never trips the published-row-removal guard. Adding a player already in the squad is a no-op, so a retry is safe. Removing a published player is still refused, on setMatchReportSquad, by design (SE-7556). */
  addMatchReportSquadPlayers: MatchReport;
  /** Adds a player to a kanban board */
  addPlayerToKanban: KanbanCard;
  /** Adds a player to a watchlist */
  addPlayerToWatchlist: Watchlist;
  /** Adds up to 500 players to a watchlist atomically, reporting which were new and which were already members */
  addPlayersToWatchlist: WatchlistBulkMembershipPayload;
  /** Adds multiple players to a shadow team */
  addShadowTeamPlayers: Array<ShadowTeamPlayer>;
  /** Adds a suggested player to the first stage of a pipeline board. */
  addSuggestedPlayerToPipeline: KanbanCard;
  /** Adds tags to a kanban card */
  addTagsToKanbanCard: KanbanCard;
  /** Adds a squad planning transition (sell, loan out, promote, sign) to the current edit state. Requires MANAGER+ role. */
  addTransitionToEditState: SquadTransitionModel;
  /** Adds a user to a kanban board with a role */
  addUserToKanbanBoard: UserKanbanBoard;
  /** Archive a SAVED contract extraction for a departed player. Archived rows are retained indefinitely and can be restored (SE-4349, Owner-only). */
  archiveContractExtraction: ContractExtractionObject;
  /** Soft-archives active feed updates for the calling user matching the optional category filter. Updates are applied in bounded chunks and may partially apply on error. SE-4896 / SE-5029. */
  archiveFeedUpdates: ArchiveFeedUpdatesResult;
  /** Archive a scout report (soft delete). Archived reports are hidden from queries and permanently deleted after 6 months. Requires confirmation string 'archive'. */
  archiveScoutReport: ScoutReport;
  /** Assigns a pipeline card to an organization member, or clears its assignment when assignedToUserId is null. */
  assignKanbanCard: KanbanCard;
  /** Sets priority values for multiple competition stats in bulk */
  bulkSetCompetitionStatPriorities: Array<StatPriority>;
  /** Sets priority values for multiple game stats in bulk */
  bulkSetGameStatPriorities: Array<StatPriority>;
  /** Sets priority values for multiple lifetime stats in bulk */
  bulkSetLifetimeStatPriorities: Array<StatPriority>;
  /** Sets priority values for multiple season stats in bulk */
  bulkSetSeasonStatPriorities: Array<StatPriority>;
  /** Responds to a Cognito authentication challenge */
  challenge: ConfirmSignInResultOrSignInResult;
  /** Claims a legacy no-owner scenario for the caller (MANAGER+). Refused with SCENARIO_REVISION_CONFLICT when the revision moved and with ERR_SCENARIO_ALREADY_OWNED when an owner exists. */
  claimScenarioOwnership: ScenarioModel;
  /** Removes a club's authored domestic competition and every DOMESTIC regime enrolment it implied, so the domestic layer becomes absent rather than remaining in force under a competition nobody authored. Requires compliance Tier 1. */
  clearComplianceClubDomesticLeague: Scalars['Boolean']['output'];
  /** Withdraws a club's first-season-after-relegation assertion, returning it to 'nobody has answered'. Distinct from asserting false: an unresolved status withholds BOTH SCMP rules rather than selecting the 50% standard, so the club gets no domestic verdict rather than one nobody authored. Requires compliance Tier 1. */
  clearComplianceClubFirstSeasonAfterRelegation: ComplianceClubSetup;
  /** Clears a tag color customization from a kanban board */
  clearKanbanBoardTagColor: Scalars['Boolean']['output'];
  /** Atomically closes a pipeline card into a terminal stage with an outcome and a required reason. */
  closeKanbanCardToTerminalStage: KanbanCard;
  /** Commits the calling user's lastFeedVisitAt with monotonic semantics — older or equal timestamps are silent no-ops */
  commitLastFeedVisitAt: User;
  /** Confirms sign-in by verifying the one-time password */
  confirmSignIn: ConfirmSignInResult;
  /** Creates a club Objective — an Internal-layer rule on a registry metric, with its target, optional amber band and Show KPI flag. Requires compliance Tier 1 or 2. */
  createClubObjective: ClubObjective;
  /** Creates a new comment on a note */
  createComment: Comment;
  /** Creates a user-built compliance metric from the PRD 4.6 builder. Its sensitivity tier is DERIVED from the operands' quantities and cannot be supplied. Requires compliance Tier 1 or 2. */
  createComplianceMetric: ComplianceMetricSummary;
  /** Creates a presigned S3 PUT URL for uploading a contract document (Owner-only) */
  createContractUploadUrl: ContractUploadUrlResult;
  /** Registers a device for push notifications or returns an existing device */
  createDevice: Device;
  /** Grants a group EDITOR or VIEWER access to a watchlist or scenario; owner only. A repeat with another role updates the grant in place */
  createGroupGrant: GroupGrant;
  /** Creates a new invitation to join an organization */
  createInvitation: Invitation;
  /** Creates a new kanban board */
  createKanbanBoard: KanbanBoard;
  /** Creates a new phase within a kanban board */
  createKanbanPhase: KanbanPhase;
  /** Creates a new kanban tag */
  createKanbanTag: KanbanTag;
  /** Creates a manually-added player scoped to the user's organization */
  createManualPlayer: Player;
  /** Creates a match. Only the two teams and a date are required: a fixture created with zero provider data is a complete record usable by fixture planning, the match page and capture. Scouts may be assigned in the same call so the action is atomic. */
  createMatch: Match;
  /** Records a basic match event by hand. Player and minute are optional: a goal or card seen without the scorer or the exact minute is still a fact worth keeping, and refusing it would discard it. */
  createMatchEvent: MatchEvent;
  /** Opens a match report against a fixture, or returns the existing one. GET-OR-CREATE on the (match, scout) unique key: calling this for a fixture the scout already has a report on returns that report rather than raising a conflict, so screen re-entry and offline replay need no racy list-then-create. IMPORTANT: the existing report is returned UNCHANGED — watchMode and reportTeams apply on first create only and are silently ignored on any later call, which is what makes a replayed mutation safe. Use updateMatchReport to change them after the report exists. Imposes no kick-off precondition either: opening a report on a future fixture is supported behaviour. */
  createMatchReport: MatchReport;
  /** Creates a new note for a player */
  createNote: Note;
  /** Creates a new organization for admin users */
  createOrganization?: Maybe<Organization>;
  /** Creates a new organization-league association */
  createOrganizationLeague: OrganizationLeague;
  /** Creates a new organization-team association */
  createOrganizationTeam: OrganizationTeam;
  /** Authors a new pipeline automation rule. Manager+ only (SE-5507 guardrail 5). */
  createPipelineAutomationRule: PipelineAutomationRule;
  /** Creates a presigned URL for uploading player data summary files to S3 */
  createPresignedUrlForUpload: Scalars['String']['output'];
  /** Creates a new scenario with all actions at once (batch save). Auto-generates name if omitted. */
  createScenario: ScenarioModel;
  /** Creates a non-match scheduled thing (training visit, tournament, meeting) with the same honest-precision temporal semantics as a fixture, optionally assigning scouts in the same round trip. MATCH is refused — use createMatch. */
  createScheduledThing: ScheduledThing;
  /** Creates a new shadow team */
  createShadowTeam: ShadowTeam;
  /** Creates a team that the provider catalog does not cover, so a scout can free-type a club and proceed. The league is optional: omit it for a youth, trial or friendly-only side with no catalog competition, which is the case a free-typed competition puts a scout in. Distinct from createOrganizationTeam, which associates an existing team with an organization. */
  createTeam: Team;
  /** Grants one ACTIVE MANAGER+ member EDITOR or VIEWER access to a scenario; owner only. A repeat with another role updates the grant in place */
  createUserScenario: UserScenario;
  /** Adds a user to a watchlist with a specified role */
  createUserWatchlist: UserWatchlist;
  /** Creates a new watchlist */
  createWatchlist: Watchlist;
  /** Deactivates the authenticated user's account */
  deactivateMe: User;
  /** Deactivates a user within an organization */
  deactivateUser: OrganizationUser;
  /** Declines a queued pipeline review request. When the request guarded the stage the card currently occupies, the card is returned to the stage it came from if that is still possible; a request proposing a move the card never made leaves it where it is. The decision is recorded immutably either way. */
  declinePipelineReviewRequest: PipelineReviewRequest;
  /** Deletes a club Objective. To retire one while keeping it auditable, set isEnabled false instead. Requires compliance Tier 1 or 2. */
  deleteClubObjective: Scalars['ID']['output'];
  /** Deletes a comment owned by the authenticated user */
  deleteComment: Comment;
  /** Deletes a user-built compliance metric. Fails if any rule still targets it — the rules are never cascaded away. Requires compliance Tier 1 or 2. */
  deleteComplianceMetric: Scalars['ID']['output'];
  /** Deletes a contract document from S3 (Owner-only) */
  deleteContractDocument: Scalars['Boolean']['output'];
  /** Soft-delete all extracted contract data for a player. Requires confirmation string 'confirm'. (Owner-only) */
  deleteContractExtraction: Scalars['Boolean']['output'];
  /** Delete a line item from a category in extracted contract data (Owner-only) */
  deleteContractLineItem: ContractLineItemResult;
  /** Revokes a group grant; owner only. Idempotent */
  deleteGroupGrant: DeleteGroupGrantPayload;
  /** Deletes an invitation */
  deleteInvitation: Invitation;
  /** Deletes a kanban board and all associated data */
  deleteKanbanBoard: KanbanBoard;
  /** Deletes a kanban phase and its cards */
  deleteKanbanPhase: KanbanPhase;
  /** Deletes a kanban tag */
  deleteKanbanTag: KanbanTag;
  /** Soft-deletes a manually-added player. Blocked if notes or reports are attached. */
  deleteManualPlayer: Player;
  /** TEST-FIXTURE AFFORDANCE, not a product operation: it exists so an automated suite can reclaim the manual fixtures it creates, and it is scheduled for removal. Permanently deletes a manually created fixture, together with any match reports filed against it and their evaluations. Refuses unless the deployment is an enumerated non-production stage, the caller holds the OWNER role on the organisation, the fixture is in that organisation, and its stored source is MANUAL — a provider-ingested or reconciled fixture is not deletable, and the source is read from the stored row rather than supplied by the caller. Returns the identifier of the deleted match. */
  deleteMatch: Scalars['ID']['output'];
  /** Removes a recorded appearance. */
  deleteMatchAppearance: Scalars['Boolean']['output'];
  /** Removes an event recorded in error. A hard delete: an event entered by mistake is not history worth keeping, unlike a submitted report. */
  deleteMatchEvent: Scalars['Boolean']['output'];
  /** Deletes a multi-player scout report */
  deleteMultiPlayerScoutReport: Scalars['Boolean']['output'];
  /** Deletes a note owned by the authenticated user */
  deleteNote: Note;
  /** Deletes an organization-league association */
  deleteOrganizationLeague: OrganizationLeague;
  /** Deletes an organization-team association */
  deleteOrganizationTeam: OrganizationTeam;
  /** Deletes a rule. Its conditions and latches cascade away; its firing ledger deliberately survives, so the record of what it did is not erased. Manager+ only. */
  deletePipelineAutomationRule: Scalars['ID']['output'];
  /** Deletes a scenario and all associated data */
  deleteScenario: RemoveTransitionResult;
  /** Deletes a shadow team and all associated players */
  deleteShadowTeam: ShadowTeam;
  /** Permanently deletes a conversation thread */
  deleteThread: UserThread;
  /** Revokes a grant. The owner removes anyone; an invitee removes only their own row (leave). Idempotent */
  deleteUserScenario: DeleteUserScenarioPayload;
  /** Removes a user from a watchlist. Returns null when the association was already absent — removal is idempotent, so a repeat call reports that there was nothing left to remove rather than failing. */
  deleteUserWatchlist?: Maybe<UserWatchlist>;
  /** Deletes a watchlist and all associated players */
  deleteWatchlist: Watchlist;
  /** Edit the contract end date of an extraction; pass a YYYY-MM-DD date or null to clear it (Owner-only, SE-4881). */
  editContractEndDate: ContractExtractionObject;
  /** Edit the text of a line item in extracted contract data (Owner-only) */
  editContractLineItem: ContractLineItemResult;
  /** Execute a read-only SQL SELECT query. IMPORTANT: Call getSqlSchema first to discover available tables and columns. Requirements: Only SELECT statements allowed (no INSERT/UPDATE/DELETE/DDL). One statement per call — anything after a semicolon is rejected. Only the tables getSqlSchema returns are queryable; any other table is rejected. Standard SQL functions (aggregates, window, string/date/math/JSON) are available; other functions are rejected — never schema-qualify a function call. Use schema-qualified table names (e.g., SELECT * FROM public.player, not just 'player'). Column casing: regular tables use snake_case, materialized views use UPPERCASE that MUST be double-quoted (e.g., SELECT "FIT_SCORE" FROM stat.player_stats_pivoted). Check getSqlSchema for exact column names. For JSONB: use -> for objects, ->> for text. Cast UUIDs explicitly (e.g., WHERE id = 'value'::uuid). Constraints: 30-second timeout, max 10,000 rows. Use LIMIT to control result size. Organization data filtering is automatic. Do not add WHERE organization_id clauses. */
  executeSqlQuery: ExecuteSqlQueryResult;
  /** Switches the authenticated user into a different organization */
  logIntoOrganization?: Maybe<User>;
  /** Records that the authenticated user viewed a player's profile, powering the Search 'Recently Viewed' section */
  logPlayerProfileView: RecentlyInteractedPlayer;
  /** Marks specific activities as read for the current user */
  markActivitiesAsRead: Scalars['Boolean']['output'];
  /** Marks all activities as read for the current user */
  markAllMyActivitiesAsRead: Scalars['Boolean']['output'];
  /** Marks the user's selected watchlist as recently used by updating its lastSelectedAt timestamp. Drives the Scouting Watchlists pills row recents ordering. */
  markUserWatchlistAsRecentlySelected: UserWatchlist;
  /** Moves a kanban card to a different phase or position */
  moveKanbanCard: KanbanCard;
  /** Publishes a submitted match report's working copy: copies the working copy over the published snapshot for every evaluation and re-stamps lastPublishedAt, so the scout's post-submit edits and late ticks become visible to the club in one step. The report must already be submitted. Unlike submitMatchReport it does NOT fire the submission feed — republishing edited content re-notifies nobody. Returns the report (WORKING, which now equals published) with hasUnpublishedChanges false. */
  publishMatchReport: MatchReport;
  /** Records one club-entered per-player count/flag, e.g. homegrown status (value 1/0). Never an update — every entry is a new row and always wins over the derived default. Requires compliance Tier 1. */
  recordComplianceCount: ComplianceCountEntry;
  /** Records one CFO-entered club financial figure, effective-dated. Never an UPDATE — a correction to a CLOSED period requires an explicit restatesId + restatementNote. Requires compliance Tier 1. */
  recordComplianceFinancialFigure: RecordComplianceFinancialFigureResult;
  /** Refreshes authentication tokens using a valid refresh token */
  refreshToken: AuthenticationResultWithMessage;
  /** Rejects an invitation to join an organization */
  rejectInvitation: Invitation;
  /** Removes a player from a kanban board */
  removePlayerFromKanban: KanbanCard;
  /** Removes a player from all recommendation types for the user's organization */
  removePlayerFromRecommendations?: Maybe<Player>;
  /** Removes a player from a watchlist */
  removePlayerFromWatchlist: Watchlist;
  /** Removes up to 500 players from a watchlist atomically, reporting which were members and which were not */
  removePlayersFromWatchlist: WatchlistBulkMembershipPayload;
  /** Removes one player's action from a scenario (MANAGER+). Idempotent; refused with SCENARIO_REVISION_CONFLICT when expectedRevision is stale. */
  removeScenarioAction: RemoveScenarioActionPayload;
  /**
   * Removes a player from a shadow team
   * @deprecated Use `removeShadowTeamPlayerPlacement` to remove a single placement, or `removeShadowTeamPlayerFromTeam` to remove all placements for a player.
   */
  removeShadowTeamPlayer: ShadowTeamPlayer;
  /** Removes a player from every placement in a shadow team (including roster pool). */
  removeShadowTeamPlayerFromTeam: RemoveShadowTeamPlayerFromTeamResult;
  /** Removes a single placement of a player from a shadow team by junction-row id. */
  removeShadowTeamPlayerPlacement: ShadowTeamPlayer;
  /** Removes tags from a kanban card */
  removeTagsFromKanbanCard: KanbanCard;
  /** Removes a transition from the edit state. Requires MANAGER+ role. */
  removeTransitionFromEditState: RemoveTransitionResult;
  /** Removes a user from a kanban board */
  removeUserFromKanbanBoard: UserKanbanBoard;
  /** Atomically reopens a closed pipeline card into an explicitly chosen non-terminal stage. */
  reopenKanbanCard: KanbanCard;
  /** Resends an invitation */
  resendInvitation: Invitation;
  /** Resends a new one-time password to the user */
  resendOTP: SignInResult;
  /** Drops the personal card order of the caller on a PIPELINE board, so the caller sees the shared default order again and follows later changes to it. */
  resetKanbanBoardCardOrder: Array<KanbanCard>;
  /** Mark all conflicting line items in a category as resolved (Owner-only) */
  resolveCategoryConflicts: ContractLineItemResult;
  /** Applies a human decision to one pending reconciliation ambiguity: MERGE applies SE-7017's merge rules to the chosen candidate (the candidate keeps its id, provider linkage attaches, a MANUAL record moves to MERGED); KEEP_SEPARATE dismisses the ambiguity durably — re-ingestion will not resurrect it. */
  resolveReconciliationAmbiguity: ReconciliationAmbiguity;
  /** Restores a soft-deleted manual player within the 6-month recovery window. */
  restoreManualPlayer: Player;
  /** Revert a PENDING_REVIEW contract extraction to a caller-supplied snapshot of extractedData (Owner-only, SE-4771). */
  revertContractExtraction: ContractExtractionObject;
  /** Revoke note sharing access from a user */
  revokeNoteShare: Scalars['Boolean']['output'];
  /** Revoke scout report sharing access from a user */
  revokeScoutReportShare: Scalars['Boolean']['output'];
  /** Save a reviewed contract extraction, deleting source documents from S3 (Owner-only) */
  saveContractExtraction: ContractExtractionObject;
  /** Sends a test push notification to all registered devices for the current user */
  sendMyDevicesAPushNotification: Array<Device>;
  /** Sets the priority value for a competition stat */
  setCompetitionStatPriority: StatPriority;
  /** Sets or replaces a club's compliance calendar — the month its reporting (fiscal) year opens and the month its season opens. This is the opt-in that makes a club eligible for monthly snapshot capture (PRD 9(1)). Both months are stated together; a calendar is never half-set. Requires compliance Tier 1. */
  setComplianceClubCalendar: ComplianceClubCalendar;
  /** States the league (division) a club plays in, and rewrites its DOMESTIC regime enrolment to match — superseding any previous one, never accumulating a second. Deliberately not inferred from organization.primaryLeagueId, which is derived nightly from where the club's players sit and is not a division boundary. Requires compliance Tier 1. */
  setComplianceClubDomesticLeague: ComplianceClubSetup;
  /** States whether a club is in its first season after relegation — the EFL SCMP status selecting the 65% relevant percentage over the 50% standard (Part 2 Rule 2.2). Never derived from season or league history: the status selects the PERMISSIVE variant, so asserting it wrongly grants headroom that renders a real breach compliant. Requires compliance Tier 1, and requires the club's domestic competition to be set first. */
  setComplianceClubFirstSeasonAfterRelegation: ComplianceClubSetup;
  /** Sets the priority value for a game stat */
  setGameStatPriority: StatPriority;
  /** Publishes the current card order the caller sees on a PIPELINE board as the shared default order every user without a personal order sees, and clears the personal order of the caller. Manager+ only (OWNER, ADMIN, MANAGER). Users who keep a personal order are unaffected. */
  setKanbanBoardDefaultCardOrder: Array<KanbanCard>;
  /** Sets a tag color on a kanban board */
  setKanbanBoardTagColor: KanbanBoardTag;
  /** Set kanban board visibility to public or private */
  setKanbanBoardVisibility: KanbanBoard;
  /** Sets the complete tag set for a kanban card */
  setKanbanCardTags: KanbanCard;
  /** Sets the priority value for a lifetime stat */
  setLifetimeStatPriority: StatPriority;
  /** Records or corrects a player's minutes in a match. Upserts on (match, player), so re-sending the same player corrects the existing record rather than creating a second one. */
  setMatchAppearance: MatchAppearance;
  /** Replaces the entire set of scouts assigned to a match and returns the match, so coverage is reflected in the same round trip. Replace-set semantics avoid the lost updates that concurrent add/remove calls produce; an empty list clears coverage. */
  setMatchAssignments: Match;
  /** Replaces a report's covered squad and teams in one call, so an undo is another replace-set rather than an optimistic local reversal. Removing a player deletes that player's evaluation, notes included. */
  setMatchReportSquad: MatchReport;
  /** Set note visibility to public or private */
  setNoteVisibility: Note;
  /** Pauses or resumes a rule. Pausing is read LIVE inside every firing transaction, so a rule paused mid-flight still does nothing. Manager+ only. */
  setPipelineAutomationRuleEnabled: PipelineAutomationRule;
  /** Sets the academy status of a player in the user's organization */
  setPlayerAcademyStatus: Player;
  /** Turns the scenario's Financials switch on or off; owner only, under the revision CAS (SCENARIO_REVISION_CONFLICT when stale) */
  setScenarioFinancialsVisibility: ScenarioModel;
  /** Replaces the complete set of scouts assigned to a scheduled thing of ANY kind — the kind-agnostic counterpart of setMatchAssignments, with identical replace-set semantics. */
  setScheduledThingAssignments: ScheduledThing;
  /** Sets whether an organisation member is offered in Assign scouts. Requires an organisation ADMIN or OWNER. This is an opt-in for a picker, not a permission — setting it false removes no access from the member. */
  setScoutAssignable: ScoutAssignability;
  /** Set scout report visibility to public or private */
  setScoutReportVisibility: ScoutReport;
  /** Sets the priority value for a season stat */
  setSeasonStatPriority: StatPriority;
  /** Share a note with another user in the same organization */
  shareNote: Scalars['Boolean']['output'];
  /** Share a scout report with another user in the same organization */
  shareScoutReport: Scalars['Boolean']['output'];
  /** Initiates sign-in by sending a one-time password to the user */
  signIn: SignInResult;
  /** Signs out the current device by revoking its refresh token. Other devices remain signed in. */
  signOut: Message;
  /** Signs out the user from every device by revoking all refresh tokens */
  signOutAllDevices: Message;
  /** Submits a match report. Typed and sharing no code path with the form.io flow. Idempotent: a repeated submit neither duplicates the report nor overwrites the original submission time. A PARTIAL report may be submitted. */
  submitMatchReport: MatchReport;
  /** Submits a new multi-player scout report */
  submitMultiPlayerScoutReport: ScoutReport;
  /** Re-derives a club's DOMESTIC regime enrolment from its already-authored competition, without changing the competition. Use after publishing or enabling a regime package for a league whose clubs are already set up. Idempotent, and never invents a competition: a club with none ends with no enrolment. Requires compliance Tier 1. */
  syncComplianceClubDomesticEnrollment?: Maybe<ComplianceClubSetup>;
  /** Toggles the favorite status of a conversation thread */
  toggleThreadFavorite: UserThread;
  /** Transfers a kanban board's ownership to another member */
  transferKanbanBoardOwnership: UserKanbanBoard;
  /** Atomically transfers all scout reports and notes from a manual player to a provider-sourced player */
  transferManualPlayerData: TransferResult;
  /** Translate a scout report's text fields into the requested locale on demand */
  translateScoutReport: PlayerScoutReport;
  /** Trigger AI extraction on uploaded contract documents for a player (Owner-only) */
  triggerContractExtraction: ContractExtractionObject;
  /** Restore a previously archived contract extraction back to the Active list (SE-4349, Owner-only). */
  unarchiveContractExtraction: ContractExtractionObject;
  /** Restore a previously archived scout report, making it visible in queries again. */
  unarchiveScoutReport: ScoutReport;
  /** Reverses an automated move and latches the rule off for that card so it is not immediately redone. Manager+ only. */
  undoPipelineAutomationFiring: PipelineAutomationRuleFiring;
  /** Restores a previously removed player back into recommendations */
  undoRemovePlayerFromRecommendations?: Maybe<Player>;
  /** Sets all notification preferences to the same enabled state for the current user */
  updateAllNotificationPreferences: Scalars['Boolean']['output'];
  /** Edits a club Objective. Omitting amberThreshold leaves it unchanged; pass clearAmberThreshold to remove the band. Requires compliance Tier 1 or 2. */
  updateClubObjective: ClubObjective;
  /** Updates an existing comment owned by the authenticated user */
  updateComment: Comment;
  /** Edits a user-built compliance metric. Operands are replaced as a set and the sensitivity tier is recomputed on every write. Requires compliance Tier 1 or 2. */
  updateComplianceMetric: ComplianceMetricSummary;
  /** Changes a group grant between EDITOR and VIEWER; owner only. The same role is a no-op */
  updateGroupGrantRole: GroupGrant;
  /** Updates kanban board properties */
  updateKanbanBoard: KanbanBoard;
  /** Updates kanban card properties */
  updateKanbanCard: KanbanCard;
  /** Updates positions of multiple kanban cards within a phase */
  updateKanbanCardPositions: Array<KanbanCard>;
  /** Updates kanban phase properties */
  updateKanbanPhase: KanbanPhase;
  /** Updates positions of multiple phases within a board */
  updateKanbanPhasePositions: Array<KanbanPhase>;
  /** Updates a kanban tag name */
  updateKanbanTag: KanbanTag;
  /** Edits an already-configured KPI's target, warn level, basis or Show KPI flag. Omitting amberThreshold leaves it unchanged; pass clearAmberThreshold to remove the band. Requires compliance Tier 1 — a stricter bar than updateClubObjective's Tier 1-2, by design (SE-7010 AC3). */
  updateKpiTarget: ClubObjective;
  /** Updates a manually-added player. Only the creator or org admins can edit. */
  updateManualPlayer: Player;
  /** Updates a match. Omitted fields are left unchanged; the clear flags reset a nullable field back to unknown. */
  updateMatch: Match;
  /** Corrects a recorded event. Omitted fields are left unchanged; sending null for player or minute clears it, which is how a misattributed scorer is undone. */
  updateMatchEvent: MatchEvent;
  /** Updates a match report shell — today the watch mode a scout deferred when opening the report. Refused once the report is submitted, because submittedAt marks the point where it became a record of what a scout reported. Squad and per-player fields have their own mutations. */
  updateMatchReport: MatchReport;
  /** Updates an existing multi-player scout report */
  updateMultiPlayerScoutReport: ScoutReport;
  /** Updates the authenticated user's profile */
  updateMyProfile: User;
  /** Updates an existing note owned by the authenticated user */
  updateNote: Note;
  /** Updates the notification preference for a specific activity type */
  updateNotificationPreference: UserNotificationPreference;
  /** Updates an existing organization for admin users */
  updateOrganization?: Maybe<Organization>;
  /** Replaces a rule wholesale, including its conditions, and bumps its revision (which re-arms it). Manager+ only. */
  updatePipelineAutomationRule: PipelineAutomationRule;
  /** Updates a player's gross annual salary. Requires MANAGER+ role. SE-8504: naming scenarioId scopes the write to that scenario's own isolated copy instead of the shared row. */
  updatePlayerWage: OrganizationPlayerDataModel;
  /** Overrides a regime-rule KPI's target, warn level, basis or Show KPI flag for this club. Use this — not updateKpiTarget — for a KPI with no backing club Objective (e.g. Squad Cost Ratio, Amortisation/Salary, PSR/FFP Deviation, Foreigner/Homegrown), since a packaged rule is one row shared by every enrolled club. comparator and threshold are required on this club's first override of the rule. Requires compliance Tier 1. */
  updateRegimeRuleTarget: ComplianceRegimeRuleOverride;
  /** Updates a scenario name and/or replaces all actions atomically */
  updateScenario: ScenarioModel;
  /** SE-8467: change the scenario's shared formation under pitch-revision CAS; vanished slots become unassigned and are never restored */
  updateScenarioFormation: ScenarioPitch;
  /** SE-8467: place one occupant on a slot (null unassigns) under pitch-revision CAS */
  updateScenarioPitchAssignment: ScenarioPitch;
  /** SE-8467: reorder a subset of occupants inside the global order under pitch-revision CAS */
  updateScenarioPreferenceOrder: ScenarioPitch;
  /** Updates a shadow team's properties and player positions */
  updateShadowTeam: ShadowTeam;
  /** Updates the status of a conversation thread */
  updateThreadStatus: UserThread;
  /** Updates a user's role on a kanban board */
  updateUserKanbanBoardRole: UserKanbanBoard;
  /** Changes a grant between EDITOR and VIEWER; owner only. The same role is a no-op */
  updateUserScenarioRole: UserScenario;
  /** Updates a watchlist's position in the user's watchlist order */
  updateUserWatchlistPosition: Watchlist;
  /** Changes an existing sharee's role between EDITOR and VIEWER. Owner-only. */
  updateUserWatchlistRole: UserWatchlist;
  /** Updates a watchlist's name */
  updateWatchlist: Watchlist;
  updateWatchlistFormation: WatchlistPitchAssignmentPayload;
  updateWatchlistPitchAssignment: WatchlistPitchAssignmentPayload;
  /**
   * Updates a player's position within a watchlist
   * @deprecated Use updateWatchlistPreferenceOrder for revision-checked saved order updates
   */
  updateWatchlistPlayerPosition: Watchlist;
  /**
   * Reorders multiple players within a watchlist
   * @deprecated Use updateWatchlistPreferenceOrder for revision-checked saved order updates
   */
  updateWatchlistPlayerPositions: Watchlist;
  updateWatchlistPreferenceOrder: WatchlistPreferenceOrderPayload;
  /** Upserts organization-scoped player data (salary, valuation, readiness). Requires MANAGER+ role. SE-8504: naming scenarioId scopes a grossAnnualSalary write to that scenario's own isolated copy instead of the shared row. */
  upsertOrganizationPlayerData: OrganizationPlayerDataModel;
  /** Creates or updates exactly one player's evaluation on a report, touching no other player's row. Omitted fields are left unchanged and the clear flags reset them, because quick capture sends small deltas and treating omission as null would erase a scout's work. Returns the written evaluation together with the parent report, whose status and counts are already recomputed to include this write, so a debounced auto-save needs one round trip rather than two. */
  upsertPlayerEvaluation: UpsertPlayerEvaluationPayload;
  /**
   * Validates the current user's profile for completeness
   * @deprecated Use validationCodes field from confirmSignIn mutation instead. This mutation makes additional Cognito API calls.
   */
  validateCurrentUser: ValidationResponse;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAcceptPipelineReviewRequestArgs = {
  input: AcceptPipelineReviewRequestInput;
};


export type MutationActivateUserArgs = {
  input: ActivateOrganizationUserInput;
};


export type MutationAddContractExtractionLineItemArgs = {
  input: AddContractExtractionLineItemInput;
};


export type MutationAddContractLineItemArgs = {
  input: AddContractLineItemInput;
};


export type MutationAddMatchReportSquadPlayersArgs = {
  input: AddMatchReportSquadPlayersInput;
};


export type MutationAddPlayerToKanbanArgs = {
  input: AddPlayerToKanbanInput;
};


export type MutationAddPlayerToWatchlistArgs = {
  input: AddPlayerToWatchlistInput;
};


export type MutationAddPlayersToWatchlistArgs = {
  input: AddPlayersToWatchlistInput;
};


export type MutationAddShadowTeamPlayersArgs = {
  input: AddShadowTeamPlayersInput;
};


export type MutationAddSuggestedPlayerToPipelineArgs = {
  kanbanBoardId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationAddTagsToKanbanCardArgs = {
  cardId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};


export type MutationAddTransitionToEditStateArgs = {
  input: AddTransitionInput;
};


export type MutationAddUserToKanbanBoardArgs = {
  input: AddUserToKanbanBoardInput;
};


export type MutationArchiveContractExtractionArgs = {
  input: ArchiveContractExtractionInput;
};


export type MutationArchiveFeedUpdatesArgs = {
  input: ArchiveFeedUpdatesInput;
};


export type MutationArchiveScoutReportArgs = {
  confirmation: Scalars['String']['input'];
  scoutReportId: Scalars['ID']['input'];
};


export type MutationAssignKanbanCardArgs = {
  input: AssignKanbanCardInput;
};


export type MutationBulkSetCompetitionStatPrioritiesArgs = {
  priorities: Array<StatPriorityInput>;
};


export type MutationBulkSetGameStatPrioritiesArgs = {
  priorities: Array<StatPriorityInput>;
};


export type MutationBulkSetLifetimeStatPrioritiesArgs = {
  priorities: Array<StatPriorityInput>;
};


export type MutationBulkSetSeasonStatPrioritiesArgs = {
  priorities: Array<StatPriorityInput>;
};


export type MutationChallengeArgs = {
  input: ChallengeInput;
};


export type MutationClaimScenarioOwnershipArgs = {
  input: ClaimScenarioOwnershipInput;
};


export type MutationClearComplianceClubDomesticLeagueArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationClearComplianceClubFirstSeasonAfterRelegationArgs = {
  input: ClearComplianceClubFirstSeasonAfterRelegationInput;
};


export type MutationClearKanbanBoardTagColorArgs = {
  kanbanBoardId: Scalars['ID']['input'];
  kanbanTagId: Scalars['ID']['input'];
};


export type MutationCloseKanbanCardToTerminalStageArgs = {
  input: CloseKanbanCardToTerminalStageInput;
};


export type MutationCommitLastFeedVisitAtArgs = {
  at: Scalars['DateTime']['input'];
};


export type MutationConfirmSignInArgs = {
  input: ConfirmSignInInput;
};


export type MutationCreateClubObjectiveArgs = {
  input: CreateClubObjectiveInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateComplianceMetricArgs = {
  input: CreateComplianceMetricInput;
};


export type MutationCreateContractUploadUrlArgs = {
  input: CreateContractUploadUrlInput;
};


export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput;
};


export type MutationCreateGroupGrantArgs = {
  input: CreateGroupGrantInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateKanbanBoardArgs = {
  input: CreateKanbanBoardInput;
};


export type MutationCreateKanbanPhaseArgs = {
  input: CreateKanbanPhaseInput;
};


export type MutationCreateKanbanTagArgs = {
  input: CreateKanbanTagInput;
};


export type MutationCreateManualPlayerArgs = {
  input: CreateManualPlayerInput;
};


export type MutationCreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationCreateMatchEventArgs = {
  input: CreateMatchEventInput;
};


export type MutationCreateMatchReportArgs = {
  input: CreateMatchReportInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationLeagueArgs = {
  input: CreateOrganizationLeagueInput;
};


export type MutationCreateOrganizationTeamArgs = {
  input: CreateOrganizationTeamInput;
};


export type MutationCreatePipelineAutomationRuleArgs = {
  input: CreatePipelineAutomationRuleInput;
};


export type MutationCreatePresignedUrlForUploadArgs = {
  input: CreatePlayerDataSummaryInput;
};


export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
};


export type MutationCreateScheduledThingArgs = {
  input: CreateScheduledThingInput;
};


export type MutationCreateShadowTeamArgs = {
  input: CreateShadowTeamInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateUserScenarioArgs = {
  input: CreateUserScenarioInput;
};


export type MutationCreateUserWatchlistArgs = {
  input: CreateUserWatchlistInput;
};


export type MutationCreateWatchlistArgs = {
  input: CreateWatchlistInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateOrganizationUserInput;
};


export type MutationDeclinePipelineReviewRequestArgs = {
  input: DeclinePipelineReviewRequestInput;
};


export type MutationDeleteClubObjectiveArgs = {
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteComplianceMetricArgs = {
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteContractDocumentArgs = {
  playerId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
};


export type MutationDeleteContractExtractionArgs = {
  confirmation: Scalars['String']['input'];
  input: DeleteContractExtractionInput;
};


export type MutationDeleteContractLineItemArgs = {
  input: DeleteContractLineItemInput;
};


export type MutationDeleteGroupGrantArgs = {
  input: DeleteGroupGrantInput;
};


export type MutationDeleteInvitationArgs = {
  input: DeleteInvitationInput;
};


export type MutationDeleteKanbanBoardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKanbanPhaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKanbanTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManualPlayerArgs = {
  input: DeleteManualPlayerInput;
};


export type MutationDeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationDeleteMatchAppearanceArgs = {
  matchAppearanceId: Scalars['ID']['input'];
};


export type MutationDeleteMatchEventArgs = {
  matchEventId: Scalars['ID']['input'];
};


export type MutationDeleteMultiPlayerScoutReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


export type MutationDeleteOrganizationLeagueArgs = {
  input: DeleteOrganizationLeagueInput;
};


export type MutationDeleteOrganizationTeamArgs = {
  input: DeleteOrganizationTeamInput;
};


export type MutationDeletePipelineAutomationRuleArgs = {
  automationRuleId: Scalars['ID']['input'];
};


export type MutationDeleteScenarioArgs = {
  scenarioId: Scalars['ID']['input'];
};


export type MutationDeleteShadowTeamArgs = {
  input: DeleteShadowTeamInput;
};


export type MutationDeleteThreadArgs = {
  input: DeleteThreadInput;
};


export type MutationDeleteUserScenarioArgs = {
  input: DeleteUserScenarioInput;
};


export type MutationDeleteUserWatchlistArgs = {
  input: DeleteUserWatchlistInput;
};


export type MutationDeleteWatchlistArgs = {
  input: DeleteWatchlistInput;
};


export type MutationEditContractEndDateArgs = {
  input: EditContractEndDateInput;
};


export type MutationEditContractLineItemArgs = {
  input: EditContractLineItemInput;
};


export type MutationExecuteSqlQueryArgs = {
  input: ExecuteSqlQueryInput;
};


export type MutationLogIntoOrganizationArgs = {
  input: LogIntoOrganizationInput;
};


export type MutationLogPlayerProfileViewArgs = {
  input: LogPlayerProfileViewInput;
};


export type MutationMarkActivitiesAsReadArgs = {
  input: MarkActivitiesAsReadInput;
};


export type MutationMarkUserWatchlistAsRecentlySelectedArgs = {
  watchlistId: Scalars['ID']['input'];
};


export type MutationMoveKanbanCardArgs = {
  input: MoveKanbanCardInput;
};


export type MutationPublishMatchReportArgs = {
  input: PublishMatchReportInput;
};


export type MutationRecordComplianceCountArgs = {
  input: RecordComplianceCountInput;
};


export type MutationRecordComplianceFinancialFigureArgs = {
  input: RecordComplianceFinancialFigureInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRejectInvitationArgs = {
  input: RejectInvitationInput;
};


export type MutationRemovePlayerFromKanbanArgs = {
  kanbanBoardId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemovePlayerFromRecommendationsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationRemovePlayerFromWatchlistArgs = {
  input: RemovePlayerFromWatchlistInput;
};


export type MutationRemovePlayersFromWatchlistArgs = {
  input: RemovePlayersFromWatchlistInput;
};


export type MutationRemoveScenarioActionArgs = {
  input: RemoveScenarioActionInput;
};


export type MutationRemoveShadowTeamPlayerArgs = {
  input: RemoveShadowTeamPlayerInput;
};


export type MutationRemoveShadowTeamPlayerFromTeamArgs = {
  input: RemoveShadowTeamPlayerFromTeamInput;
};


export type MutationRemoveShadowTeamPlayerPlacementArgs = {
  input: RemoveShadowTeamPlayerPlacementInput;
};


export type MutationRemoveTagsFromKanbanCardArgs = {
  cardId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveTransitionFromEditStateArgs = {
  transitionId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromKanbanBoardArgs = {
  input: RemoveUserFromKanbanBoardInput;
};


export type MutationReopenKanbanCardArgs = {
  input: ReopenKanbanCardInput;
};


export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


export type MutationResendOtpArgs = {
  input: ResendOtpInput;
};


export type MutationResetKanbanBoardCardOrderArgs = {
  kanbanBoardId: Scalars['ID']['input'];
};


export type MutationResolveCategoryConflictsArgs = {
  input: ResolveCategoryConflictsInput;
};


export type MutationResolveReconciliationAmbiguityArgs = {
  input: ResolveReconciliationAmbiguityInput;
};


export type MutationRestoreManualPlayerArgs = {
  input: RestoreManualPlayerInput;
};


export type MutationRevertContractExtractionArgs = {
  input: RevertContractExtractionInput;
};


export type MutationRevokeNoteShareArgs = {
  input: RevokeNoteShareInput;
};


export type MutationRevokeScoutReportShareArgs = {
  input: RevokeScoutReportShareInput;
};


export type MutationSaveContractExtractionArgs = {
  extractionId: Scalars['ID']['input'];
};


export type MutationSendMyDevicesAPushNotificationArgs = {
  input: SendMyDevicesAPushNotificationInput;
};


export type MutationSetCompetitionStatPriorityArgs = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  statId: Scalars['ID']['input'];
};


export type MutationSetComplianceClubCalendarArgs = {
  input: SetComplianceClubCalendarInput;
};


export type MutationSetComplianceClubDomesticLeagueArgs = {
  input: SetComplianceClubDomesticLeagueInput;
};


export type MutationSetComplianceClubFirstSeasonAfterRelegationArgs = {
  input: SetComplianceClubFirstSeasonAfterRelegationInput;
};


export type MutationSetGameStatPriorityArgs = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  statId: Scalars['ID']['input'];
};


export type MutationSetKanbanBoardDefaultCardOrderArgs = {
  kanbanBoardId: Scalars['ID']['input'];
};


export type MutationSetKanbanBoardTagColorArgs = {
  input: SetKanbanBoardTagColorInput;
};


export type MutationSetKanbanBoardVisibilityArgs = {
  isPublic: Scalars['Boolean']['input'];
  kanbanBoardId: Scalars['ID']['input'];
};


export type MutationSetKanbanCardTagsArgs = {
  cardId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};


export type MutationSetLifetimeStatPriorityArgs = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  statId: Scalars['ID']['input'];
};


export type MutationSetMatchAppearanceArgs = {
  input: SetMatchAppearanceInput;
};


export type MutationSetMatchAssignmentsArgs = {
  input: SetMatchAssignmentsInput;
};


export type MutationSetMatchReportSquadArgs = {
  input: SetMatchReportSquadInput;
};


export type MutationSetNoteVisibilityArgs = {
  isPublic: Scalars['Boolean']['input'];
  noteId: Scalars['ID']['input'];
};


export type MutationSetPipelineAutomationRuleEnabledArgs = {
  input: SetPipelineAutomationRuleEnabledInput;
};


export type MutationSetPlayerAcademyStatusArgs = {
  input: SetPlayerAcademyStatusInput;
};


export type MutationSetScenarioFinancialsVisibilityArgs = {
  input: SetScenarioFinancialsVisibilityInput;
};


export type MutationSetScheduledThingAssignmentsArgs = {
  input: SetScheduledThingAssignmentsInput;
};


export type MutationSetScoutAssignableArgs = {
  input: SetScoutAssignableInput;
};


export type MutationSetScoutReportVisibilityArgs = {
  isPublic: Scalars['Boolean']['input'];
  scoutReportId: Scalars['ID']['input'];
};


export type MutationSetSeasonStatPriorityArgs = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  statId: Scalars['ID']['input'];
};


export type MutationShareNoteArgs = {
  input: ShareNoteInput;
};


export type MutationShareScoutReportArgs = {
  input: ShareScoutReportInput;
};


export type MutationSignInArgs = {
  input: SignInInput;
};


export type MutationSignOutArgs = {
  input: SignOutInput;
};


export type MutationSubmitMatchReportArgs = {
  input: SubmitMatchReportInput;
};


export type MutationSubmitMultiPlayerScoutReportArgs = {
  payload: Scalars['JSONObject']['input'];
  reportTypeId: Scalars['ID']['input'];
};


export type MutationSyncComplianceClubDomesticEnrollmentArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationToggleThreadFavoriteArgs = {
  threadId: Scalars['String']['input'];
};


export type MutationTransferKanbanBoardOwnershipArgs = {
  input: TransferKanbanBoardOwnershipInput;
};


export type MutationTransferManualPlayerDataArgs = {
  input: TransferManualPlayerDataInput;
};


export type MutationTranslateScoutReportArgs = {
  input: TranslateScoutReportInput;
};


export type MutationTriggerContractExtractionArgs = {
  input: TriggerContractExtractionInput;
};


export type MutationUnarchiveContractExtractionArgs = {
  extractionId: Scalars['ID']['input'];
};


export type MutationUnarchiveScoutReportArgs = {
  scoutReportId: Scalars['ID']['input'];
};


export type MutationUndoPipelineAutomationFiringArgs = {
  input: UndoPipelineAutomationFiringInput;
};


export type MutationUndoRemovePlayerFromRecommendationsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationUpdateAllNotificationPreferencesArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateClubObjectiveArgs = {
  input: UpdateClubObjectiveInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateComplianceMetricArgs = {
  input: UpdateComplianceMetricInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateGroupGrantRoleArgs = {
  input: UpdateGroupGrantRoleInput;
};


export type MutationUpdateKanbanBoardArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKanbanBoardInput;
};


export type MutationUpdateKanbanCardArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKanbanCardInput;
};


export type MutationUpdateKanbanCardPositionsArgs = {
  input: UpdateKanbanCardPositionsInput;
};


export type MutationUpdateKanbanPhaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKanbanPhaseInput;
};


export type MutationUpdateKanbanPhasePositionsArgs = {
  input: UpdateKanbanPhasePositionsInput;
};


export type MutationUpdateKanbanTagArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKanbanTagInput;
};


export type MutationUpdateKpiTargetArgs = {
  input: UpdateKpiTargetInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateManualPlayerArgs = {
  input: UpdateManualPlayerInput;
};


export type MutationUpdateMatchArgs = {
  input: UpdateMatchInput;
};


export type MutationUpdateMatchEventArgs = {
  input: UpdateMatchEventInput;
};


export type MutationUpdateMatchReportArgs = {
  input: UpdateMatchReportInput;
};


export type MutationUpdateMultiPlayerScoutReportArgs = {
  payload: Scalars['JSONObject']['input'];
  reportId: Scalars['ID']['input'];
};


export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  activityTypeCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdatePipelineAutomationRuleArgs = {
  input: UpdatePipelineAutomationRuleInput;
};


export type MutationUpdatePlayerWageArgs = {
  input: UpdatePlayerWageInput;
};


export type MutationUpdateRegimeRuleTargetArgs = {
  input: UpdateRegimeRuleTargetInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateScenarioArgs = {
  input: UpdateScenarioInput;
};


export type MutationUpdateScenarioFormationArgs = {
  input: UpdateScenarioFormationInput;
};


export type MutationUpdateScenarioPitchAssignmentArgs = {
  input: UpdateScenarioPitchAssignmentInput;
};


export type MutationUpdateScenarioPreferenceOrderArgs = {
  input: UpdateScenarioPreferenceOrderInput;
};


export type MutationUpdateShadowTeamArgs = {
  input: UpdateShadowTeamInput;
};


export type MutationUpdateThreadStatusArgs = {
  status: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationUpdateUserKanbanBoardRoleArgs = {
  input: UpdateUserKanbanBoardRoleInput;
};


export type MutationUpdateUserScenarioRoleArgs = {
  input: UpdateUserScenarioRoleInput;
};


export type MutationUpdateUserWatchlistPositionArgs = {
  input: UpdateUserWatchlistPositionInput;
};


export type MutationUpdateUserWatchlistRoleArgs = {
  input: UpdateUserWatchlistRoleInput;
};


export type MutationUpdateWatchlistArgs = {
  input: UpdateWatchlistInput;
};


export type MutationUpdateWatchlistFormationArgs = {
  input: UpdateWatchlistFormationInput;
};


export type MutationUpdateWatchlistPitchAssignmentArgs = {
  input: UpdateWatchlistPitchAssignmentInput;
};


export type MutationUpdateWatchlistPlayerPositionArgs = {
  input: UpdateWatchlistPlayerPositionInput;
};


export type MutationUpdateWatchlistPlayerPositionsArgs = {
  input: UpdateWatchlistPlayerPositionsInput;
};


export type MutationUpdateWatchlistPreferenceOrderArgs = {
  input: UpdateWatchlistPreferenceOrderInput;
};


export type MutationUpsertOrganizationPlayerDataArgs = {
  input: UpsertOrganizationPlayerDataInput;
};


export type MutationUpsertPlayerEvaluationArgs = {
  input: UpsertPlayerEvaluationInput;
};

/** Country or nationality classification for player origin tracking */
export type Nationality = Node & {
  __typename?: 'Nationality';
  /** Unique identifier for the nationality */
  id: Scalars['ID']['output'];
  /** Name of the nationality */
  name: Scalars['String']['output'];
};

/** Connection type for paginated Nationality results */
export type NationalityConnection = Connection & {
  __typename?: 'NationalityConnection';
  /** A list of edges */
  edges: Array<NationalityEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for Nationality connection */
export type NationalityEdge = Edge & {
  __typename?: 'NationalityEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Nationality node */
  node: Nationality;
};

/** Metadata for newly registered device */
export type NewDeviceMetadata = {
  __typename?: 'NewDeviceMetadata';
  /** Device group key for related devices */
  deviceGroupKey?: Maybe<Scalars['String']['output']>;
  /** Unique device key identifier */
  deviceKey?: Maybe<Scalars['String']['output']>;
};

/** Input for a player's new position */
export type NewPosition = {
  /** The ID of the player */
  playerId: Scalars['ID']['input'];
  /** The new position for the player */
  position: Scalars['Float']['input'];
};

/** An object with a globally unique ID */
export type Node = {
  /** The globally unique ID */
  id: Scalars['ID']['output'];
};

/** Represents a note about a player in the system with privacy controls for scouting reports and evaluations */
export type Note = Node & {
  __typename?: 'Note';
  /** Note content (max 2000 chars) */
  body: Scalars['String']['output'];
  /** Timestamp of note creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for note */
  id: Scalars['ID']['output'];
  /** When true, the note is visible to all users in the organization */
  isPublic: Scalars['Boolean']['output'];
  /** Foreign key to player */
  playerId: Scalars['ID']['output'];
  /** Note title (max 100 chars) */
  title: Scalars['String']['output'];
  /** Timestamp of last note update */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** Foreign key to user who created note */
  userId: Scalars['ID']['output'];
};

/** A connection to a list of notes */
export type NoteConnection = {
  __typename?: 'NoteConnection';
  /** A list of edges */
  edges: Array<NoteEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a NoteConnection */
export type NoteEdge = Edge & {
  __typename?: 'NoteEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Note node */
  node: Note;
};

/** Information about a user with access to a note */
export type NoteShare = {
  __typename?: 'NoteShare';
  /** When the permission was created */
  createdAt: Scalars['DateTime']['output'];
  /** Permission role (OWNER or VIEWER) */
  role: UserNoteRole;
  /** User details */
  user: User;
  /** User ID */
  userId: Scalars['ID']['output'];
};

/** A first-team roster player currently on loan with loan and contract details */
export type OnLoanPlayer = {
  __typename?: 'OnLoanPlayer';
  /** Date the home club contract expires */
  contractExpires?: Maybe<Scalars['DateTime']['output']>;
  /** Player display name */
  name: Scalars['String']['output'];
  /** Club the player is on loan from */
  onLoanFrom: Scalars['String']['output'];
  /** Player UUID */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation */
  primaryPosition: Scalars['String']['output'];
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Root entity representing football clubs, teams, or scouting organizations using the talent identification system */
export type Organization = Node & {
  __typename?: 'Organization';
  /** Timestamp of organization creation */
  createdAt: Scalars['DateTime']['output'];
  /** Currency code for organization */
  currencyCode: CurrencyCode;
  /** Default formation for squad planning */
  defaultFormation: ShadowTeamFormation;
  /** Default visibility for new kanban boards. False=private, true=public. */
  defaultKanbanBoardVisibility: Scalars['Boolean']['output'];
  /** Default visibility for new notes. False=private, true=public. */
  defaultNoteVisibility: Scalars['Boolean']['output'];
  /** Default visibility for new scout reports. False=private, true=public. */
  defaultScoutReportVisibility: Scalars['Boolean']['output'];
  /** Gender division this organization operates in; scopes every org-scoped read (`male` by default for all existing orgs) */
  gender: Gender;
  /** Unique identifier for organization */
  id: Scalars['ID']['output'];
  /** URL for organization intake form */
  intakeFormUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the organization */
  name: Scalars['String']['output'];
  organizationTeams: Array<OrganizationTeam>;
  /** FK to primary league, determined by player count across org teams */
  primaryLeagueId?: Maybe<Scalars['ID']['output']>;
  recommendationTypes: Array<RecommendationType>;
  sport?: Maybe<Sport>;
  /** Foreign key to primary sport */
  sportId?: Maybe<Scalars['ID']['output']>;
  /** Org-level team selection mode (`hidden` by default for all existing orgs) */
  teamSelectionMode: TeamSelectionMode;
  /** Timestamp of last organization update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents an organization-activity association enabling organization-scoped activity filtering and management */
export type OrganizationActivity = Node & {
  __typename?: 'OrganizationActivity';
  /** The associated activity */
  activity: Activity;
  /** Foreign key to activity */
  activityId: Scalars['ID']['output'];
  /** Timestamp of link creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for organization activity link */
  id: Scalars['ID']['output'];
  /** Foreign key to organization */
  organizationId: Scalars['ID']['output'];
  /** Timestamp of last link update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of organization activities */
export type OrganizationActivityConnection = {
  __typename?: 'OrganizationActivityConnection';
  /** A list of edges */
  edges: Array<OrganizationActivityEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total count of organization activities */
  totalCount: Scalars['Int']['output'];
};

/** An edge in an OrganizationActivityConnection */
export type OrganizationActivityEdge = Edge & {
  __typename?: 'OrganizationActivityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The OrganizationActivity node */
  node: OrganizationActivity;
};

/** A connection to a list of organizations */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges */
  edges: Array<OrganizationEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in an OrganizationConnection */
export type OrganizationEdge = Edge & {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Organization node */
  node: Organization;
};

/** Many-to-many relationship between organizations and leagues, defining which leagues an organization monitors or participates in */
export type OrganizationLeague = {
  __typename?: 'OrganizationLeague';
  /** Timestamp of link creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for organization league link */
  id: Scalars['ID']['output'];
  /** Foreign key to league */
  leagueId: Scalars['ID']['output'];
  /** Foreign key to organization */
  organizationId: Scalars['ID']['output'];
  /** Timestamp of last link update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Organization-scoped player data for squad planning (salary, valuation, readiness) */
export type OrganizationPlayerDataModel = {
  __typename?: 'OrganizationPlayerDataModel';
  /** SE-7328: agent fee paid on the player's contract, in organization currency */
  agentFee?: Maybe<Scalars['Float']['output']>;
  /** SE-7328: contract end date as a YYYY-MM-DD literal */
  contractEnd?: Maybe<Scalars['String']['output']>;
  /** SE-7328 / AC4: the contract extraction whose save last asserted these fields */
  contractSourceExtractionId?: Maybe<Scalars['ID']['output']>;
  /** SE-7328 / AC4: when a saved contract extraction last asserted the financial fields on this record. Non-null means the figures came from a contract, not from manual entry — render it so a planner can see why a value they typed has changed. */
  contractSourcedAt?: Maybe<Scalars['DateTime']['output']>;
  /** SE-7328: contract start date as a YYYY-MM-DD literal */
  contractStart?: Maybe<Scalars['String']['output']>;
  /** Timestamp of record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Estimated player valuation in organization currency */
  estValuation?: Maybe<Scalars['Float']['output']>;
  /** Gross annual salary in organization currency */
  grossAnnualSalary?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** FK to organization */
  organizationId: Scalars['ID']['output'];
  /** FK to player */
  playerId: Scalars['ID']['output'];
  /** Player readiness level for squad planning */
  readinessTag?: Maybe<ReadinessTag>;
  /** SE-7328: transfer fee paid to acquire the player, in organization currency */
  transferFee?: Maybe<Scalars['Float']['output']>;
  /** Timestamp of last record update */
  updatedAt: Scalars['DateTime']['output'];
  /** SE-8409: which writer last asserted grossAnnualSalary. MANUAL overrides any contract-sourced value everywhere Compliance and the wage bill read wages. */
  wageSource: WageSource;
};

/** A paginated connection of scout reports for the organization table view */
export type OrganizationScoutReportConnection = {
  __typename?: 'OrganizationScoutReportConnection';
  /** A list of edges */
  edges: Array<OrganizationScoutReportEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Exact number of reports per player over the SAME filters (including regions) and visibility as this query, ignoring pagination; the counts sum to totalCount. Ordered by count descending, then name; a null playerId counts reports with no player and comes last. Computed only when selected. */
  playerCounts?: Maybe<Array<ScoutReportPlayerCount>>;
  /** Exact number of reports per FM24 scouting region over the SAME filters and visibility as this query, ignoring pagination; the counts sum to totalCount. Region = the FM24 region of the league the player was playing in when the report was written (its match; the current league when it has no resolvable match); a null region counts reports with no region. Computed only when selected. */
  regionCounts?: Maybe<Array<ScoutReportRegionCount>>;
  /** Total count of scout reports matching the filter. Null on subsequent pages (cursor provided) to skip the COUNT query. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in an OrganizationScoutReportConnection */
export type OrganizationScoutReportEdge = Edge & {
  __typename?: 'OrganizationScoutReportEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The organization scout report node */
  node: OrganizationScoutReportNode;
};

/** A scout report node for the organization-level table view, combining report, player, user, and type data */
export type OrganizationScoutReportNode = Node & {
  __typename?: 'OrganizationScoutReportNode';
  /** Single-select categorical attributes surfaced as columns, per the report type's categoricalFieldOverrides allowlist (SE-4621). Empty unless the report type opts specific fields in. */
  categoricalRatings: Array<ScoutReportCategoricalRating>;
  /** Club/team name from processedData.team */
  club?: Maybe<Scalars['String']['output']>;
  /** Report creation timestamp */
  createdAt: Scalars['String']['output'];
  /** Scout report unique identifier */
  id: Scalars['ID']['output'];
  /** Match date if available */
  matchDate?: Maybe<Scalars['String']['output']>;
  /** Match name computed as "team vs opponent" */
  matchName?: Maybe<Scalars['String']['output']>;
  /** Individual match details for this report, fetched from the player matches view */
  matches?: Maybe<Array<MatchDetail>>;
  /** Numeric ratings extracted from processedData based on the processor type */
  numericRatings: Array<ScoutReportNumericRating>;
  /** Overall score from processedData */
  overallScore?: Maybe<Scalars['Float']['output']>;
  /** Player unique identifier */
  playerId?: Maybe<Scalars['ID']['output']>;
  /** Player full display name from the player relation (firstName + knownName + lastName) */
  playerName?: Maybe<Scalars['String']['output']>;
  /** FM24 scouting region of the league the player was playing in when the report was written (the report's match; the current league when it has no resolvable match), e.g. "UK & Ireland". Null only when neither the match nor the current league gives a country inside the FM24 table. */
  region?: Maybe<Scalars['String']['output']>;
  /** Scout report type unique identifier */
  reportTypeId?: Maybe<Scalars['ID']['output']>;
  /** Scout report type name */
  reportTypeName?: Maybe<Scalars['String']['output']>;
  /** Scout name from processedData or user relation */
  scoutName?: Maybe<Scalars['String']['output']>;
  /** Scout user unique identifier */
  scoutUserId?: Maybe<Scalars['ID']['output']>;
  /** Report last update timestamp */
  updatedAt: Scalars['String']['output'];
};

/** Filter options for organization scout reports */
export type OrganizationScoutReportsFilterInput = {
  /** Filter by club/team names from processedData.team */
  clubs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by fixture linkage: true = only reports linked to a fixture, false = only reports with no fixture, null/omitted = both */
  hasMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inclusive lower bound for match date (ISO date string) */
  matchDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive upper bound for match date (ISO date string) */
  matchDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by match names in "team vs opponent" format (multi-select) */
  matchNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dynamic numeric rating filters keyed by processedData field name */
  ratingFilters?: InputMaybe<Array<ScoutReportRatingFilterInput>>;
  /** Filter by FM24 scouting region of the league the player was playing in when the report was written (multi-select, OR), using the exact region names, e.g. "UK & Ireland", "South America (South)". A name that is not an FM24 region is rejected (BAD_USER_INPUT) with the list of valid names. */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Inclusive lower bound for report creation date (ISO date string) */
  reportDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive upper bound for report creation date (ISO date string) */
  reportDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter to reports of a specific scout report type */
  reportTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by scout user IDs (multi-select) */
  scoutUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-text search across player name, scout name, team, and opponent */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting organization scout reports in the table view */
export enum OrganizationScoutReportsSortField {
  CreatedAt = 'CREATED_AT',
  MatchDate = 'MATCH_DATE',
  PlayerName = 'PLAYER_NAME',
  Region = 'REGION',
  ScoutName = 'SCOUT_NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Sort options for organization scout reports */
export type OrganizationScoutReportsSortInput = {
  /** The sort direction (ASC or DESC) */
  direction: SortDirection;
  /** Built-in field to sort by (mutually exclusive with ratingKey) */
  field?: InputMaybe<OrganizationScoutReportsSortField>;
  /** Sort by a numeric rating key from processedData (e.g. overallScore, workRate). Mutually exclusive with field. */
  ratingKey?: InputMaybe<Scalars['String']['input']>;
};

/** Links organizations to teams they manage, scout, or have interest in, supporting multi-team organization structures */
export type OrganizationTeam = {
  __typename?: 'OrganizationTeam';
  /** Timestamp of link creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for organization team link */
  id: Scalars['ID']['output'];
  /** Foreign key to organization */
  organizationId: Scalars['ID']['output'];
  /** Foreign key to team */
  teamId: Scalars['ID']['output'];
  /** Timestamp of last link update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Junction table managing user memberships within organizations, including roles and status information */
export type OrganizationUser = Node & {
  __typename?: 'OrganizationUser';
  /** Timestamp of link creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for organization user link */
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  /** Foreign key to organization */
  organizationId: Scalars['ID']['output'];
  role?: Maybe<Role>;
  /** User status in organization */
  status: OrganizationUserStatus;
  /** Timestamp of last link update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** Foreign key to user */
  userId: Scalars['ID']['output'];
};

/** A connection to a list of organization users */
export type OrganizationUserConnection = {
  __typename?: 'OrganizationUserConnection';
  /** A list of edges */
  edges: Array<OrganizationUserEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in an OrganizationUserConnection */
export type OrganizationUserEdge = Edge & {
  __typename?: 'OrganizationUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The OrganizationUser node */
  node: OrganizationUser;
};

/** Status of a user's membership within an organization */
export enum OrganizationUserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** A kanban board with no owner, listed so an organization administrator can assign one. Carries no board contents. */
export type OwnerlessKanbanBoard = {
  __typename?: 'OwnerlessKanbanBoard';
  /** Unique identifier for the kanban board */
  id: Scalars['ID']['output'];
  /** The display name of the kanban board */
  name: Scalars['String']['output'];
  /** When the board was last modified; the repair list is ordered by this, most recent first */
  updatedAt: Scalars['DateTime']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Specifies the position of a phase within a kanban board */
export type PhasePosition = {
  /** The ID of the phase */
  phaseId: Scalars['ID']['input'];
  /** The new position for this phase (0-based index) */
  position: Scalars['Int']['input'];
};

/** What happened to a pipeline card: ADDED / MOVED / REMOVED are stage movements; REPORT_ADDED, TAG_APPLIED and TAG_REMOVED (SE-5503), CLOSED and REOPENED (SE-5540) plus NOTES_UPDATED (SE-6925) are non-movement events that carry no phase transition; REVIEW_REQUESTED, REVIEW_ACCEPTED and REVIEW_DECLINED (SE-5498) are Review-queue events that DO carry the from-stage and proposed target stage. */
export enum PipelineActivityAction {
  Added = 'ADDED',
  Assigned = 'ASSIGNED',
  Closed = 'CLOSED',
  Moved = 'MOVED',
  NotesUpdated = 'NOTES_UPDATED',
  Removed = 'REMOVED',
  Reopened = 'REOPENED',
  ReportAdded = 'REPORT_ADDED',
  ReviewAccepted = 'REVIEW_ACCEPTED',
  ReviewDeclined = 'REVIEW_DECLINED',
  ReviewRequested = 'REVIEW_REQUESTED',
  TagApplied = 'TAG_APPLIED',
  TagRemoved = 'TAG_REMOVED',
  Unassigned = 'UNASSIGNED'
}

/** One entry in a pipeline's chronological activity log (SE-5503). */
export type PipelineActivityEntry = Node & {
  __typename?: 'PipelineActivityEntry';
  /** What happened */
  action: PipelineActivityAction;
  /** USER = a human performed this; AUTOMATION_RULE = an automation rule did; SYSTEM = migration/cron. */
  actorType: PipelineActorType;
  /** Acting user id. Null means the actor was not threaded through — NOT that the action was automated; use actorType for that. */
  actorUserId?: Maybe<Scalars['ID']['output']>;
  /** SE-5628: the member an ASSIGNED entry assigned the card to. Null for every other action, including UNASSIGNED. */
  assignedToUserId?: Maybe<Scalars['ID']['output']>;
  /** Automation rule that performed this action */
  automationRuleId?: Maybe<Scalars['ID']['output']>;
  /** Rule display name snapshotted at event time. Non-null exactly when actorType is AUTOMATION_RULE. */
  automationRuleName?: Maybe<Scalars['String']['output']>;
  /** Stage the card left */
  fromKanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** Name of the stage the card left */
  fromPhaseName?: Maybe<Scalars['String']['output']>;
  /** Audit row id */
  id: Scalars['ID']['output'];
  /** Pipeline board the event happened on */
  kanbanBoardId: Scalars['ID']['output'];
  /** Card the event concerns. Null when the card no longer exists — the audit row outlives it. */
  kanbanCardId?: Maybe<Scalars['ID']['output']>;
  /** Tag involved in a TAG_APPLIED / TAG_REMOVED entry */
  kanbanTagId?: Maybe<Scalars['ID']['output']>;
  /** Tag name snapshotted at event time */
  kanbanTagName?: Maybe<Scalars['String']['output']>;
  /** When the event happened */
  occurredAt: Scalars['DateTime']['output'];
  /** Terminal outcome recorded by a CLOSED entry, or cleared by a REOPENED entry. Null for every other action. */
  outcome?: Maybe<KanbanCardOutcome>;
  /** Pipeline review request this entry created or decided (SE-5498). Join key for composing approval copy client-side. */
  pipelineReviewRequestId?: Maybe<Scalars['ID']['output']>;
  /** Player the card represents */
  playerId: Scalars['ID']['output'];
  /** Player display name; null when the player can no longer be resolved */
  playerName?: Maybe<Scalars['String']['output']>;
  /** Reason recorded with the event, when one was supplied: a stage-change rationale, a close reason, or (SE-6249) a removal reason. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** Scout report behind a REPORT_ADDED entry */
  scoutReportId?: Maybe<Scalars['ID']['output']>;
  /** Stage the card entered */
  toKanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** Name of the stage the card entered */
  toPhaseName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of pipeline activity-log entries (SE-5503) */
export type PipelineActivityLogConnection = {
  __typename?: 'PipelineActivityLogConnection';
  /** A list of edges */
  edges: Array<PipelineActivityLogEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** True total number of activity-log entries for this pipeline (from the page query's own COUNT) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a PipelineActivityLogConnection */
export type PipelineActivityLogEdge = Edge & {
  __typename?: 'PipelineActivityLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The PipelineActivityEntry node */
  node: PipelineActivityEntry;
};

/** Who performed a pipeline activity-log entry: USER = a human; AUTOMATION_RULE = an automation rule; SYSTEM = a migration or cron job. Structural — the backend never emits a pre-formatted 'Automated by rule X' sentence; the client composes it from actorType + automationRuleName. */
export enum PipelineActorType {
  AutomationRule = 'AUTOMATION_RULE',
  System = 'SYSTEM',
  User = 'USER'
}

/** What a matching pipeline automation rule does. MOVE_TO_STAGE moves the card unless the LIVE target stage is sensitive or terminal, in which case it queues a review request; ADD_TO_REVIEW_QUEUE always queues one; ASSIGN (SE-5628) sets the card's owner to a member of the pipeline's organization. */
export enum PipelineAutomationActionType {
  AddToReviewQueue = 'ADD_TO_REVIEW_QUEUE',
  ApplyTag = 'APPLY_TAG',
  Assign = 'ASSIGN',
  MoveToStage = 'MOVE_TO_STAGE',
  NotifyPipelineOwner = 'NOTIFY_PIPELINE_OWNER',
  RemoveTag = 'REMOVE_TAG'
}

/** How an automation rule condition compares the observed value to its configured value. */
export enum PipelineAutomationComparator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

/** What a single automation rule condition tests. GPR is the RAW stored time-decayed value, not the league-translated number rendered in the UI. */
export enum PipelineAutomationConditionType {
  CardInStage = 'CARD_IN_STAGE',
  ContractMonthsRemaining = 'CONTRACT_MONTHS_REMAINING',
  DaysInStage = 'DAYS_IN_STAGE',
  Gpr = 'GPR',
  NoteCount = 'NOTE_COUNT',
  ReportCount = 'REPORT_COUNT',
  Verdict = 'VERDICT'
}

/** What one evaluation of one automation rule against one card did — including the skip and deferral reasons, so a rule author can answer 'why didn't my rule fire?'. */
export enum PipelineAutomationFiringOutcome {
  Assigned = 'ASSIGNED',
  DeferredReviewPending = 'DEFERRED_REVIEW_PENDING',
  Failed = 'FAILED',
  Moved = 'MOVED',
  Notified = 'NOTIFIED',
  ReviewRequested = 'REVIEW_REQUESTED',
  SkippedPaused = 'SKIPPED_PAUSED',
  SkippedSuppressed = 'SKIPPED_SUPPRESSED',
  SkippedUnchanged = 'SKIPPED_UNCHANGED',
  TagApplied = 'TAG_APPLIED',
  TagRemoved = 'TAG_REMOVED',
  Undone = 'UNDONE'
}

/** A pipeline automation rule (SE-5507). Manager+ only. */
export type PipelineAutomationRule = Node & {
  __typename?: 'PipelineAutomationRule';
  /** What the rule does when it matches */
  actionType: PipelineAutomationActionType;
  /** Conditions, combined with AND */
  conditions: Array<PipelineAutomationRuleCondition>;
  /** When the rule was authored */
  createdAt: Scalars['DateTime']['output'];
  /** Author */
  createdBy: Scalars['ID']['output'];
  /** Rule id */
  id: Scalars['ID']['output'];
  /** False means PAUSED — the rule does nothing. Re-read live inside every firing transaction, never snapshotted at dispatch. */
  isEnabled: Scalars['Boolean']['output'];
  /** Pipeline the rule governs */
  kanbanBoardId: Scalars['ID']['output'];
  /** Tag for APPLY_TAG / REMOVE_TAG */
  kanbanTagId?: Maybe<Scalars['ID']['output']>;
  /** Display name */
  name: Scalars['String']['output'];
  /** The author's rationale */
  reason?: Maybe<Scalars['String']['output']>;
  /** Outcome proposed when the target stage is terminal */
  requestedOutcome?: Maybe<KanbanCardOutcome>;
  /** Bumped on every edit. It is an input to the firing fingerprint, which is what makes an edited rule re-arm against cards it has already fired on. */
  revision: Scalars['Int']['output'];
  /** Target stage for a move-shaped action. Whether the move needs approval is decided LIVE from that stage at evaluation time — nothing about sensitivity is stored on the rule. */
  targetKanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** Stage the trigger watches, for TIME_IN_STAGE_EXCEEDED and CARD_ENTERED_STAGE. Null when the trigger names no stage, or when a CARD_ENTERED_STAGE rule is unscoped. Use it to find rules referencing a stage before deleting it. */
  triggerKanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** What causes the rule to be evaluated */
  triggerType: PipelineAutomationTriggerType;
  /** Last edit */
  updatedAt: Scalars['DateTime']['output'];
};

/** One condition of an automation rule. A rule's conditions are combined with AND; OR and nesting are not representable. */
export type PipelineAutomationRuleCondition = {
  __typename?: 'PipelineAutomationRuleCondition';
  /** How the observed value is compared */
  comparator?: Maybe<PipelineAutomationComparator>;
  /** What this condition tests */
  conditionType: PipelineAutomationConditionType;
  /** Condition id */
  id: Scalars['ID']['output'];
  /** Stage a CARD_IN_STAGE condition tests */
  kanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** Configured threshold as a decimal string — the column is `numeric`, so a Float would perturb the author's exact value. */
  numericValue?: Maybe<Scalars['String']['output']>;
  /** Configured value for a text condition */
  textValue?: Maybe<Scalars['String']['output']>;
};

/** One condition of an automation rule. All of a rule's conditions are combined with AND; there is no OR and no nesting. */
export type PipelineAutomationRuleConditionInput = {
  /** How the observed value is compared. Omit for CARD_IN_STAGE, whose test is stage occupancy. */
  comparator?: InputMaybe<PipelineAutomationComparator>;
  /** What this condition tests */
  conditionType: PipelineAutomationConditionType;
  /** Stage a CARD_IN_STAGE condition tests */
  kanbanPhaseId?: InputMaybe<Scalars['ID']['input']>;
  /** Threshold for a numeric condition, as a decimal string (the column is `numeric`, so a Float would silently perturb the author's exact value). */
  numericValue?: InputMaybe<Scalars['String']['input']>;
  /** Value for a text condition. Compared case-insensitively. */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of pipeline automation rules (SE-5507) */
export type PipelineAutomationRuleConnection = {
  __typename?: 'PipelineAutomationRuleConnection';
  /** A list of edges */
  edges: Array<PipelineAutomationRuleEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** True total number of matching rules (from the page's own COUNT) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a PipelineAutomationRuleConnection */
export type PipelineAutomationRuleEdge = Edge & {
  __typename?: 'PipelineAutomationRuleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The PipelineAutomationRule node */
  node: PipelineAutomationRule;
};

/** One recorded evaluation of an automation rule against a card — including the skip and deferral reasons, so 'why didn't my rule fire?' is answerable. */
export type PipelineAutomationRuleFiring = Node & {
  __typename?: 'PipelineAutomationRuleFiring';
  /** The rule. FK-by-value: the ledger deliberately outlives the rule, so this id may no longer resolve. */
  automationRuleId: Scalars['ID']['output'];
  /** Rule name snapshotted at firing time. Compose any 'Automated by …' copy from this — the backend never pre-formats it. */
  automationRuleName: Scalars['String']['output'];
  /** When the firing committed */
  createdAt: Scalars['DateTime']['output'];
  /** Machine-readable code behind a FAILED outcome */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Stage before the firing. With `toKanbanPhaseId`, this is the whole reversibility payload. */
  fromKanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** Firing id */
  id: Scalars['ID']['output'];
  /** Pipeline */
  kanbanBoardId: Scalars['ID']['output'];
  /** Card evaluated */
  kanbanCardId: Scalars['ID']['output'];
  /** Tag applied or removed */
  kanbanTagId?: Maybe<Scalars['ID']['output']>;
  /** What this evaluation did */
  outcome: PipelineAutomationFiringOutcome;
  /** Review request raised by this firing */
  pipelineReviewRequestId?: Maybe<Scalars['ID']['output']>;
  /** Player */
  playerId: Scalars['ID']['output'];
  /** Human-readable explanation of the outcome */
  reason?: Maybe<Scalars['String']['output']>;
  /** Stage moved or proposed into */
  toKanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** Trigger that caused the evaluation */
  triggerType: PipelineAutomationTriggerType;
  /** When a Manager+ reversed this firing */
  undoneAt?: Maybe<Scalars['DateTime']['output']>;
  /** Manager+ who reversed this firing */
  undoneByUserId?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of automation firings (SE-5507) */
export type PipelineAutomationRuleFiringConnection = {
  __typename?: 'PipelineAutomationRuleFiringConnection';
  /** A list of edges */
  edges: Array<PipelineAutomationRuleFiringEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** True total number of matching firings (from the page's own COUNT) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a PipelineAutomationRuleFiringConnection */
export type PipelineAutomationRuleFiringEdge = Edge & {
  __typename?: 'PipelineAutomationRuleFiringEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The PipelineAutomationRuleFiring node */
  node: PipelineAutomationRuleFiring;
};

/** What causes a pipeline automation rule to be evaluated: a card entering a stage, a card being added, conditions becoming true, a stage time target being exceeded, or a weekly re-check. */
export enum PipelineAutomationTriggerType {
  CardAddedToPipeline = 'CARD_ADDED_TO_PIPELINE',
  CardEnteredStage = 'CARD_ENTERED_STAGE',
  ConditionBecameTrue = 'CONDITION_BECAME_TRUE',
  PeriodicWeekly = 'PERIODIC_WEEKLY',
  TimeInStageExceeded = 'TIME_IN_STAGE_EXCEEDED'
}

/** A queued request for a Manager+ to accept or decline a deferred pipeline stage change (SE-5498). */
export type PipelineReviewRequest = Node & {
  __typename?: 'PipelineReviewRequest';
  /** Pipeline owner the request is routed to, for the addressedToMe filter and badging. ROUTING ONLY — any Manager+ in the organization may decide any request. */
  addressedToUserId?: Maybe<Scalars['ID']['output']>;
  /** Automation rule that raised the request */
  automationRuleId?: Maybe<Scalars['ID']['output']>;
  /** Rule display name snapshotted at request time. Compose approval copy from this plus decidedByUserId — the backend never pre-formats it. */
  automationRuleName?: Maybe<Scalars['String']['output']>;
  /** Producer idempotency key. Unique among PENDING requests within the organization. */
  correlationKey: Scalars['String']['output'];
  /** When the request was raised */
  createdAt: Scalars['DateTime']['output'];
  /** When the terminal decision committed. Null while PENDING. */
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Manager+ who accepted or declined. Null while PENDING. */
  decidedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Trimmed decision reason. Always present on an acceptance; optional on a decline. */
  decisionReason?: Maybe<Scalars['String']['output']>;
  /** Stage the card was in when the request was raised */
  fromKanbanPhaseId: Scalars['ID']['output'];
  /** Name of the stage the card was in. Null when the stage no longer exists — the request outlives it by design. */
  fromPhaseName?: Maybe<Scalars['String']['output']>;
  /** Review request id */
  id: Scalars['ID']['output'];
  /** Pipeline board the request concerns */
  kanbanBoardId: Scalars['ID']['output'];
  /** Candidate card the request concerns */
  kanbanCardId: Scalars['ID']['output'];
  /** Player the card represents */
  playerId: Scalars['ID']['output'];
  /** Rationale supplied by the producer */
  requestReason?: Maybe<Scalars['String']['output']>;
  /** Human who raised the request. Null for AUTOMATION_RULE. */
  requestedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Outcome proposed for a terminal target. Null for a non-terminal target. */
  requestedOutcome?: Maybe<KanbanCardOutcome>;
  /** What produced this request */
  source: PipelineReviewSource;
  /** Lifecycle status */
  status: PipelineReviewStatus;
  /** Stage the request proposes moving into */
  targetKanbanPhaseId: Scalars['ID']['output'];
  /** Name of the proposed target stage. Null when the stage no longer exists. */
  targetPhaseName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of pipeline review requests (SE-5498) */
export type PipelineReviewRequestConnection = {
  __typename?: 'PipelineReviewRequestConnection';
  /** A list of edges */
  edges: Array<PipelineReviewRequestEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** True total number of matching review requests (from the page query's own COUNT) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a PipelineReviewRequestConnection */
export type PipelineReviewRequestEdge = Edge & {
  __typename?: 'PipelineReviewRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The PipelineReviewRequest node */
  node: PipelineReviewRequest;
};

/** What produced a pipeline review request: an SE-5507 automation rule, a human, or (reserved) a bottom-up scout flag. */
export enum PipelineReviewSource {
  AutomationRule = 'AUTOMATION_RULE',
  Manual = 'MANUAL',
  ScoutFlag = 'SCOUT_FLAG'
}

/** Lifecycle of a pipeline review request: PENDING awaits a Manager+ decision; ACCEPTED and DECLINED are terminal. */
export enum PipelineReviewStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

/** A player suggested for a pipeline, sourced from the same recommendation output that backs the Squad Analysis Recommended Players panel. */
export type PipelineSuggestedPlayer = Node & {
  __typename?: 'PipelineSuggestedPlayer';
  /** The player's best rank across the recommendation types that surfaced them, where 1 is strongest. Used as the primary sort key. */
  bestRank: Scalars['Int']['output'];
  /** The suggested player's id. Stable across nightly recommendation snapshots, and the key the frontend uses for its session-scoped Dismiss. */
  id: Scalars['ID']['output'];
  /** The suggested player */
  player: Player;
  /** Why this player is suggested. A player surfaced by more than one recommendation type carries one entry per type, strongest rank first. Recommendation types with no supported category are omitted, never replaced by a fallback. */
  reasons: Array<SuggestionReasonCategory>;
  /** Timestamp of the recommendation snapshot backing this suggestion. */
  snapshotTimestamp: Scalars['DateTime']['output'];
};

/** Relay-compliant connection type for a pipeline's suggested players. */
export type PipelineSuggestedPlayerConnection = Connection & {
  __typename?: 'PipelineSuggestedPlayerConnection';
  /** A list of edges */
  edges: Array<PipelineSuggestedPlayerEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Relay-compliant edge type for PipelineSuggestedPlayer connections. Wraps each suggested player with its pagination cursor. */
export type PipelineSuggestedPlayerEdge = Edge & {
  __typename?: 'PipelineSuggestedPlayerEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The PipelineSuggestedPlayer node */
  node: PipelineSuggestedPlayer;
};

export enum PitchAssignmentOrigin {
  Calculated = 'CALCULATED',
  Saved = 'SAVED',
  Unassigned = 'UNASSIGNED'
}

/** The user whose write last bumped a pitch's revision — what the conflict banner names */
export type PitchEditor = {
  __typename?: 'PitchEditor';
  /** Cognito full name, else the email's local part, else a generic label — never null */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Supported watchlist pitch formations from R01-J */
export enum PitchFormation {
  F_334 = 'F_334',
  F_343 = 'F_343',
  F_352 = 'F_352',
  F_424 = 'F_424',
  F_433 = 'F_433',
  F_442 = 'F_442',
  F_451 = 'F_451',
  F_532 = 'F_532',
  F_541 = 'F_541',
  F_3412 = 'F_3412',
  F_4123 = 'F_4123',
  F_4132 = 'F_4132',
  F_4213 = 'F_4213',
  F_4222 = 'F_4222',
  F_4231 = 'F_4231',
  F_4312 = 'F_4312',
  F_4321 = 'F_4321',
  F_4411 = 'F_4411',
  F_5221 = 'F_5221'
}

/** Professional athlete entity with biographical data, statistics, and relationships to teams, leagues, and scouting information */
export type Player = Node & {
  __typename?: 'Player';
  /** Badge type derived from player flags: 'Academy', 'Manual', or null */
  badgeType?: Maybe<Scalars['String']['output']>;
  /** Biographical and statistical data for the player */
  bioData?: Maybe<PlayerBioData>;
  /** Current club name (e.g. "Manchester City") — bioData.currentClub, or teamName for manual players — available on every player list result */
  clubName?: Maybe<Scalars['String']['output']>;
  /** Timestamp of player record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Date of birth for manual players. Provider-sourced players use bioData.dateOfBirth */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Soft-delete timestamp for manually-created players. NULL means the player is active */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  doesBelongToCurrentUsersOrganization: Scalars['Boolean']['output'];
  /** Player's first name */
  firstName: Scalars['String']['output'];
  /** Game-level intelligence metrics for the player */
  gameMetrics: Array<GameMetrics>;
  /** Game-level provider metrics for the player across all games */
  gameProviderMetrics: Array<GameProviderMetrics>;
  /** Gender division of the player */
  gender: Gender;
  /**
   * Gemini Player Metric (GPM) - overall player performance metric
   * @deprecated Always null — nothing populates this field. Use bioData.gpm instead.
   */
  gpm?: Maybe<Scalars['Float']['output']>;
  /** Gemini Player Rating (GPR) — always equal to bioData.gpr for this player, available on every player list result */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the player */
  id: Scalars['ID']['output'];
  /** Canonical player image URL; null when no image is available — SE-5538. V1 is schema + API plumbing only: no image source exists yet, so this is null for every player and clients render the initials fallback. Population lands in a follow-up ticket without further API change. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** All injuries for this player, ordered by date descending */
  injuries: Array<PlayerInjuryModel>;
  /** Whether this player is an academy player for squad planning purposes */
  isAcademy: Scalars['Boolean']['output'];
  /** Whether this player was manually created by an organization user */
  isManual: Scalars['Boolean']['output'];
  /** Whether this player is currently on loan. SE-4586 — surfaces the player in the Loanee tier in the contracts overview regardless of direction. V1 is schema + resolver plumbing only; real provider-feed / manual-entry data lands in a later ticket. */
  isOnLoan?: Maybe<Scalars['Boolean']['output']>;
  isOnShadowTeam: Scalars['Boolean']['output'];
  isOnWatchlist: Scalars['Boolean']['output'];
  isWatchedByCurrentUser: Scalars['Boolean']['output'];
  /** Player's known name or nickname */
  knownName?: Maybe<Scalars['String']['output']>;
  /** Player's last name */
  lastName: Scalars['String']['output'];
  /** Current league the player participates in */
  league?: Maybe<League>;
  /** This player's own evaluations within match reports, each projected to this player alone — no other player's note or score is reachable through it. Merge with `scoutReports` to render one list; `reportKind` tells the two apart. */
  matchReportEvaluations: Array<PlayerMatchReportEvaluation>;
  /** Canonical display name: knownName when set, otherwise firstName and lastName */
  name: Scalars['String']['output'];
  /** Player's nationality */
  nationality?: Maybe<Nationality>;
  /** ID of the organization that owns this manual player. NULL for provider-sourced players */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Time series data for player ratings including GPR, Z-VAEP, and Z-GPM scores */
  playerRatingTimeSeries?: Maybe<Array<PlayerRatingTimeSeries>>;
  /** Positions the player can play */
  positions?: Maybe<Array<Position>>;
  /** Scout reports written about this player */
  scoutReports?: Maybe<Array<PlayerScoutReport>>;
  /** Season categorical scores for the player */
  seasonCategoricalScores?: Maybe<Array<PlayerSeasonCategoricalScore>>;
  /** Season-level provider metrics for the player */
  seasonProviderMetrics: Array<SeasonProviderMetrics>;
  /** Season-weighted average metrics for the player */
  seasonWeightedAvgMetrics?: Maybe<Array<PlayerSeasonWeightedAvgMetrics>>;
  /** Current team the player is affiliated with */
  team?: Maybe<Team>;
  /** Free-text team name for manual players not linked to a provider team */
  teamName?: Maybe<Scalars['String']['output']>;
  /**
   * Time-decayed Gemini Player Rating (GPR)
   * @deprecated Always null — nothing populates this field. Use bioData.gpr instead (same TIME_DECAYED_GPR source).
   */
  timeDecayedGPR?: Maybe<Scalars['Float']['output']>;
  /** Counts of transferable data (reports + notes). Null for provider-sourced players. */
  transferableDataCounts?: Maybe<TransferableDataCounts>;
  /** Transfermarkt player ID for cross-referencing with Transfermarkt data */
  transfermarktId?: Maybe<Scalars['Int']['output']>;
  /** All transfers for this player, ordered by date descending */
  transfers: Array<TransferModel>;
  /** Timestamp of last player record update */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Valuing Actions by Estimating Probabilities (VAEP) metric
   * @deprecated Always null — nothing populates this field. Use bioData.vaep instead.
   */
  vaep?: Maybe<Scalars['Float']['output']>;
  watchlists: Array<WatchlistSummary>;
  /**
   * Z-score normalized GPM
   * @deprecated Always null — nothing populates this field. Use bioData.zGpm instead.
   */
  zGpm?: Maybe<Scalars['Float']['output']>;
  /**
   * Z-score normalized VAEP
   * @deprecated Always null — nothing populates this field. Use bioData.zVaep instead.
   */
  zVaep?: Maybe<Scalars['Float']['output']>;
};


/** Professional athlete entity with biographical data, statistics, and relationships to teams, leagues, and scouting information */
export type PlayerIsOnShadowTeamArgs = {
  shadowTeamId: Scalars['ID']['input'];
};


/** Professional athlete entity with biographical data, statistics, and relationships to teams, leagues, and scouting information */
export type PlayerIsOnWatchlistArgs = {
  watchlistId: Scalars['ID']['input'];
};

/** Advanced filtering options for player search with multiple criteria including demographics, performance metrics, and custom statistics */
export type PlayerAdvancedFilterInput = {
  /** Filter by competition IDs (UCL, UEL, etc.) — matches players whose team participates in the competition */
  competitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by custom player statistics */
  customStats?: InputMaybe<Array<CustomStatFilterInput>>;
  /** Filter by preferred foot. Pass [LEFT, BOTH] for left-footed, [RIGHT, BOTH] for right-footed. */
  feet?: InputMaybe<Array<PlayerFoot>>;
  /** Filter by league IDs */
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Maximum age filter */
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum carrying categorical score */
  maxCarrying?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum dribbling categorical score */
  maxDribbling?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum overall fit score */
  maxFitScore?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum Gemini Player Valuation (GPV) midpoint. Players without a GPV are excluded when set. */
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum goalkeeper passing categorical score */
  maxGkPassing?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum goalkeeper positioning categorical score */
  maxGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum goalkeeper shot stopping categorical score */
  maxGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum Gemini Player Metric (GPM) score */
  maxGpm?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum Gemini Player Rating (GPR) score */
  maxGpr?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum height filter (in meters, e.g. 1.89) */
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum minutes played filter */
  maxMinutesPlayed?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum contract months remaining */
  maxMonthsRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum passing categorical score */
  maxPassing?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum shooting categorical score */
  maxShooting?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum team style fit score */
  maxTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum VAEP (Valuing Actions by Estimating Probabilities) score */
  maxVaep?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum player valuation */
  maxValuation?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum age filter */
  minAge?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum carrying categorical score */
  minCarrying?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum dribbling categorical score */
  minDribbling?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum overall fit score */
  minFitScore?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum Gemini Player Valuation (GPV) midpoint. Players without a GPV are excluded when set. */
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum goalkeeper passing categorical score */
  minGkPassing?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum goalkeeper positioning categorical score */
  minGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum goalkeeper shot stopping categorical score */
  minGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum Gemini Player Metric (GPM) score */
  minGpm?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum Gemini Player Rating (GPR) score */
  minGpr?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum height filter (in meters, e.g. 1.89) */
  minHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum minutes played filter */
  minMinutesPlayed?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum contract months remaining */
  minMonthsRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum passing categorical score */
  minPassing?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum shooting categorical score */
  minShooting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum team style fit score */
  minTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum VAEP (Valuing Actions by Estimating Probabilities) score */
  minVaep?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum player valuation */
  minValuation?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by nationalities */
  nationalities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by outer cluster name from player clustering analysis */
  outerClusterName?: InputMaybe<Scalars['String']['input']>;
  /** rankPlayersByMetric only: keep players who had minutes in these leagues during the ranked season (seasonId). Unlike leagueIds, which is the player's CURRENT league. Advanced metrics are read from these leagues' rows; provider metrics, MINUTES_TOTAL included, stay season-wide. filterPlayers rejects it. */
  playedInLeagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by position IDs */
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by PRIMARY position IDs (from listPositions). Unlike positionIds, which matches any position a player lists, this matches only the player's primary position. */
  primaryPositionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by role archetypes (playing style classifications) */
  roleArchetypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by the organization's scout-report verdicts (only reports the caller may see) */
  scoutReport?: InputMaybe<ScoutReportPlayerFilterInput>;
  /** Filter by team IDs */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Comprehensive biographical and statistical data for a player including personal details, contract info, performance metrics, and AI-derived analysis */
export type PlayerBioData = {
  __typename?: 'PlayerBioData';
  /** Aerials global categorical score */
  aerialsGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Aerials positional categorical score */
  aerialsPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Aerials global categorical score (transformed) */
  aerialsTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Aerials positional categorical score (transformed) */
  aerialsTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Player's age in years */
  age?: Maybe<Scalars['Float']['output']>;
  /** Anticipating global categorical score */
  anticipatingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating positional categorical score */
  anticipatingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating global categorical score (transformed) */
  anticipatingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating positional categorical score (transformed) */
  anticipatingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Player key for archetype comparison */
  archetypeGgPlayerKey?: Maybe<Scalars['String']['output']>;
  /** Assisting global categorical score */
  assistingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting positional categorical score */
  assistingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting global categorical score (transformed) */
  assistingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting positional categorical score (transformed) */
  assistingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup global categorical score */
  buildupGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup positional categorical score */
  buildupPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup global categorical score (transformed) */
  buildupTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup positional categorical score (transformed) */
  buildupTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying global categorical score */
  carryingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying positional categorical score */
  carryingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying global categorical score (transformed) */
  carryingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying positional categorical score (transformed) */
  carryingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Projected GPR at peak age, 99th percentile. Retrospective for players already past peak age. */
  ceilingGpr?: Maybe<Scalars['Float']['output']>;
  /** Contract expiration date */
  contractExpires?: Maybe<Scalars['DateTime']['output']>;
  /** Contract option details */
  contractOption?: Maybe<Scalars['String']['output']>;
  /** Contract expiration at loan origin club */
  contractThereExpires?: Maybe<Scalars['DateTime']['output']>;
  /** Creating global categorical score */
  creatingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating positional categorical score */
  creatingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating global categorical score (transformed) */
  creatingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating positional categorical score (transformed) */
  creatingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing global categorical score */
  crossingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing positional categorical score */
  crossingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing global categorical score (transformed) */
  crossingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing positional categorical score (transformed) */
  crossingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Current club name */
  currentClub?: Maybe<Scalars['String']['output']>;
  /** Current league name */
  currentLeague?: Maybe<Scalars['String']['output']>;
  /** Custom organization-specific statistics */
  customStats?: Maybe<Scalars['JSONObject']['output']>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Defensive aerials global categorical score */
  defensiveAerialsGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials positional categorical score */
  defensiveAerialsPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials global categorical score (transformed) */
  defensiveAerialsTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials positional categorical score (transformed) */
  defensiveAerialsTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling global categorical score */
  dribblingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling positional categorical score */
  dribblingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling global categorical score (transformed) */
  dribblingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling positional categorical score (transformed) */
  dribblingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /**
   * Expected transfer fee
   * @deprecated Use minGeminiPlayerValuation and maxGeminiPlayerValuation instead. This field will be removed in a future version.
   */
  expectedFee?: Maybe<Scalars['Float']['output']>;
  /**
   * Fair transfer fee estimation
   * @deprecated Use minGeminiPlayerValuation and maxGeminiPlayerValuation instead. This field will be removed in a future version.
   */
  fairFee?: Maybe<Scalars['Float']['output']>;
  /** Finishing global categorical score */
  finishingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing positional categorical score */
  finishingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing global categorical score (transformed) */
  finishingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing positional categorical score (transformed) */
  finishingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Player first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Overall fit score (0-1) */
  fitScore?: Maybe<Scalars['Float']['output']>;
  /** Projected GPR at peak age, 25th percentile. Retrospective for players already past peak age. */
  floorGpr?: Maybe<Scalars['Float']['output']>;
  /** Preferred foot */
  foot?: Maybe<Scalars['String']['output']>;
  /** Gemini player valuation estimate */
  geminiPlayerValuation?: Maybe<Scalars['Float']['output']>;
  /** General position classification */
  generalPosition?: Maybe<Scalars['String']['output']>;
  /** External player identifier from data provider */
  ggPlayerKey: Scalars['ID']['output'];
  /** Goalkeeper cross intercept categorical score */
  gkCrossInterceptCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper cross intercept categorical score (transformed) */
  gkCrossInterceptTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper keeper sweeper categorical score */
  gkKeeperSweeperCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper keeper sweeper categorical score (transformed) */
  gkKeeperSweeperTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper passing categorical score */
  gkPassingCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper passing categorical score (transformed) */
  gkPassingTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper positioning categorical score */
  gkPositioningCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper positioning categorical score (transformed) */
  gkPositioningTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shot stopping categorical score */
  gkShotStoppingCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shot stopping categorical score (transformed) */
  gkShotStoppingTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Gemini Player Metric (GPM) */
  gpm?: Maybe<Scalars['Float']['output']>;
  /** Gemini Player Rating (GPR) */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Heading global categorical score */
  headingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading positional categorical score */
  headingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading global categorical score (transformed) */
  headingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading positional categorical score (transformed) */
  headingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Height in centimeters */
  height?: Maybe<Scalars['Float']['output']>;
  /** Date injured until */
  injuredUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the player is currently injured */
  isInjured?: Maybe<Scalars['Boolean']['output']>;
  /** Player known/nick name */
  knownName?: Maybe<Scalars['String']['output']>;
  /** Player last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Country of the player's current league */
  leagueCountry?: Maybe<Scalars['String']['output']>;
  /** Warning flag for limited data availability */
  limitedDataWarning?: Maybe<Scalars['Boolean']['output']>;
  /** AI-generated summary of player profile */
  llmDerivedSummary?: Maybe<Scalars['String']['output']>;
  /** Maximum Gemini player valuation estimate */
  maxGeminiPlayerValuation?: Maybe<Scalars['Float']['output']>;
  /** Mean projected GPR at peak age (central estimate). Retrospective for players already past peak age. */
  meanPeakGpr?: Maybe<Scalars['Float']['output']>;
  /** Minimum Gemini player valuation estimate */
  minGeminiPlayerValuation?: Maybe<Scalars['Float']['output']>;
  /** Total minutes played across all seasons based on data available in our system */
  minutesTotal?: Maybe<Scalars['Float']['output']>;
  /** Player's nationality */
  nationality?: Maybe<Scalars['String']['output']>;
  /** Club player is on loan from */
  onLoanFrom?: Maybe<Scalars['String']['output']>;
  /** Competition key for loan origin league */
  onLoanFromGgCompetitionKey?: Maybe<Scalars['String']['output']>;
  /** Team key for loan origin club */
  onLoanFromGgTeamKey?: Maybe<Scalars['String']['output']>;
  /** Potential opportunities for player development */
  opportunities?: Maybe<Array<Scalars['String']['output']>>;
  /** Passing global categorical score */
  passingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing positional categorical score */
  passingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing global categorical score (transformed) */
  passingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing positional categorical score (transformed) */
  passingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Physical score assessment */
  physicalScore?: Maybe<Scalars['Float']['output']>;
  /** Player's agent */
  playerAgent?: Maybe<Scalars['String']['output']>;
  /**
   * Player valuation
   * @deprecated Use minGeminiPlayerValuation and maxGeminiPlayerValuation instead. This field will be removed in a future version.
   */
  playerValuation?: Maybe<Scalars['Float']['output']>;
  /** Projected GPR at peak age, 95th percentile. Retrospective for players already past peak age. */
  potentialGpr?: Maybe<Scalars['Float']['output']>;
  /** Pressing global categorical score */
  pressingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing positional categorical score */
  pressingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing global categorical score (transformed) */
  pressingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing positional categorical score (transformed) */
  pressingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Primary playing position */
  primaryPosition?: Maybe<Scalars['String']['output']>;
  /** Proactive defending global categorical score */
  proactiveDefendingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending positional categorical score */
  proactiveDefendingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending global categorical score (transformed) */
  proactiveDefendingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending positional categorical score (transformed) */
  proactiveDefendingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Role archetype classification */
  roleArchetype?: Maybe<Scalars['String']['output']>;
  /** Secondary role archetype classification */
  secondaryRoleArchetype?: Maybe<Scalars['String']['output']>;
  /** Set piece delivering global categorical score */
  setPieceDeliveringGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Set piece delivering positional categorical score */
  setPieceDeliveringPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Set piece delivering global categorical score (transformed) */
  setPieceDeliveringTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Set piece delivering positional categorical score (transformed) */
  setPieceDeliveringTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location global categorical score */
  shotLocationGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location positional categorical score */
  shotLocationPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location global categorical score (transformed) */
  shotLocationTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location positional categorical score (transformed) */
  shotLocationTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement global categorical score */
  shotPlacementGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement positional categorical score */
  shotPlacementPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement global categorical score (transformed) */
  shotPlacementTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement positional categorical score (transformed) */
  shotPlacementTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Player strengths identified by analysis */
  strengths?: Maybe<Array<Scalars['String']['output']>>;
  /** Tackling global categorical score */
  tacklingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling positional categorical score */
  tacklingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling global categorical score (transformed) */
  tacklingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling positional categorical score (transformed) */
  tacklingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Team style fit score (0-100) */
  teamStyleFit?: Maybe<Scalars['Int']['output']>;
  /** Potential threats to player development */
  threats?: Maybe<Array<Scalars['String']['output']>>;
  /** Time-decayed GPR prediction */
  timeDecayedGprPred?: Maybe<Scalars['Float']['output']>;
  /** Lower bound of time-decayed GPR prediction */
  timeDecayedGprPredLower?: Maybe<Scalars['Float']['output']>;
  /** Upper bound of time-decayed GPR prediction */
  timeDecayedGprPredUpper?: Maybe<Scalars['Float']['output']>;
  /** Time-decayed seasonal GPM (rounded to integer) */
  timeDecayedSeasonalGpm?: Maybe<Scalars['Int']['output']>;
  /** Time-decayed VAEP score */
  timeDecayedVaep?: Maybe<Scalars['Float']['output']>;
  /** Time-decayed Z-scored VAEP */
  timeDecayedZVaep?: Maybe<Scalars['Float']['output']>;
  /** Transfermarkt player ID for cross-referencing */
  transfermarktId?: Maybe<Scalars['Int']['output']>;
  /** VAEP (Valuing Actions by Estimating Probabilities) score */
  vaep?: Maybe<Scalars['Float']['output']>;
  /** Valuation status */
  valuationStatus?: Maybe<Scalars['String']['output']>;
  /** Player weaknesses identified by analysis */
  weaknesses?: Maybe<Array<Scalars['String']['output']>>;
  /** Z-scored GPM */
  zGpm?: Maybe<Scalars['Float']['output']>;
  /** Z-scored VAEP */
  zVaep?: Maybe<Scalars['Float']['output']>;
};

/** Connection type for paginated Player results */
export type PlayerConnection = Connection & {
  __typename?: 'PlayerConnection';
  /** A list of edges */
  edges: Array<PlayerEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total number of players matching the filter/search criteria. Resolved lazily — selecting it runs a cheap COUNT-only query; omitting it costs nothing. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A single player row in the contracts overview table with contract and transfer status */
export type PlayerContractRow = {
  __typename?: 'PlayerContractRow';
  /** Player age in whole years computed from dateOfBirth; null when DOB is unknown */
  age?: Maybe<Scalars['Int']['output']>;
  /** Contract end date as parsed from the active CONTRACT extraction; null when no active contract extraction exists or the document had no parseable end date */
  contractEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the active CONTRACT extraction; null when no active contract extraction exists for this player */
  contractStatus?: Maybe<ContractExtractionStatus>;
  /** Max updatedAt across the player's active contract and transfer extractions; null when none exist */
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Display name of the player — `knownName` when set, otherwise `firstName lastName` */
  name: Scalars['String']['output'];
  /** UUID of the player */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation (e.g. 'GK', 'CAM', 'CB'); null when no primary position is recorded for the player */
  position?: Maybe<Scalars['String']['output']>;
  /** Tier bucket derived from the canonical `is_academy` signal: 'Loanee' when `is_on_loan=true`, 'Academy' when `COALESCE(opd.is_academy, p.is_academy)=true`, otherwise 'First Team' (SE-4764). */
  tier: Scalars['String']['output'];
  /** Why the active TRANSFER_AGREEMENT's fee was not applied to Squad Planning (e.g. a currency mismatch against the organization's reporting currency); null when it was applied or there is nothing to apply */
  transferFeeNotAppliedReason?: Maybe<Scalars['String']['output']>;
  /** Status of the active TRANSFER_AGREEMENT extraction; null when no active transfer extraction exists for this player */
  transferStatus?: Maybe<ContractExtractionStatus>;
};

/** Aggregate payload for the contracts overview: flat player rows plus per-tier completeness totals */
export type PlayerContractsOverview = {
  __typename?: 'PlayerContractsOverview';
  /** Completeness totals for Academy players (canonical `is_academy` signal — SE-4764). */
  academyCompleteness: TierCompleteness;
  /** Completeness totals for First Team (provider-sourced) players */
  firstTeamCompleteness: TierCompleteness;
  /** Completeness totals for Loanee (`isOnLoan=true`) players (SE-4586) */
  loaneeCompleteness: TierCompleteness;
  /** Flat list of in-org players (First Team, Academy, and Loanees) with their contract and transfer status */
  players: Array<PlayerContractRow>;
};

/** Represents a summary of player data */
export type PlayerDataSummary = {
  __typename?: 'PlayerDataSummary';
  /** The date and time when the PlayerDataSummary was created */
  createdAt: Scalars['String']['output'];
  /** The unique ID of the PlayerDataSummary */
  id: Scalars['ID']['output'];
  /** The ID of the organization */
  organizationId: Scalars['ID']['output'];
  /** The ID of the player */
  playerId: Scalars['ID']['output'];
  /** The date and time when the PlayerDataSummary was last updated */
  updatedAt: Scalars['String']['output'];
};

/** A player's disciplinary signal for the squad-pick row (SE-7018): recorded card counts and a nullable suspension WARNING. It never asserts availability and never blocks selection — absence of a warning is silence, not a clearance. */
export type PlayerDisciplineSignal = {
  __typename?: 'PlayerDisciplineSignal';
  /** The player this signal is about. */
  playerId: Scalars['ID']['output'];
  /** Red cards recorded for this player across the organisation's matches. A fact. A red is a ban in every competition, so any red drives the LIKELY_SUSPENDED warning (SE-7018). */
  recordedRedCards: Scalars['Int']['output'];
  /** Yellow cards recorded for this player across the organisation's matches. A COUNT OF ALL recorded yellows — NOT scoped to a league's accumulation-reset window (that is SE-7018 phase 2). Render it as 'recorded', never as 'toward a ban': without the reset it would claim more than it knows. */
  recordedYellowCards: Scalars['Int']['output'];
  /** A suspension WARNING, or null. LIKELY_SUSPENDED means a red card is recorded. NULL is SILENCE — no warning — and is the ONLY 'not warned' state: it never means the player is available. No card recorded yields null, which is a well-formed 'nothing recorded', not an error. */
  suspensionWarning?: Maybe<SuspensionWarning>;
};

/** Edge type for Player connection */
export type PlayerEdge = Edge & {
  __typename?: 'PlayerEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Player node */
  node: Player;
};

/** A player's evaluations aggregated across every report and scout in the organization: matches watched, average Performance and Potential, and a staleness flag. Averages skip unscored evaluations rather than counting them as zero. */
export type PlayerEvaluationAggregate = {
  __typename?: 'PlayerEvaluationAggregate';
  /** Mean Performance rating across scored evaluations, or null when none carry a score. Null rather than zero, because an unscored player has no average rather than an average of nothing. */
  averagePerformance?: Maybe<Scalars['Float']['output']>;
  /** Mean Potential rating across scored evaluations, or null when none carry a score. */
  averagePotential?: Maybe<Scalars['Float']['output']>;
  /** Whether the most recent evaluation is older than the staleness threshold. A player never evaluated is stale, since the intent is to surface who needs attention. */
  isStale: Scalars['Boolean']['output'];
  /** When this player was most recently evaluated, or null if never. The input to the staleness flag, exposed so a client can show the actual date rather than only the flag. */
  lastEvaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Distinct matches this player has been evaluated in. Counts matches rather than evaluations, so two scouts reporting on the same fixture count once. */
  matchesWatched: Scalars['Int']['output'];
  /** Identifier of the player these figures describe */
  playerId: Scalars['ID']['output'];
  /** Number of evaluations contributing a Performance or Potential score. Exposed so a consumer can distinguish an average over one evaluation from an average over twenty. */
  scoredEvaluationCount: Scalars['Int']['output'];
  /** The staleness threshold in days that produced isStale, echoed back so a consumer can label the flag with the window it reflects instead of assuming a default. */
  stalenessThresholdDays: Scalars['Int']['output'];
};

/** Options for a player evaluation aggregate. Carries no staleness threshold: that is server-owned so the flag means the same thing on every surface. The date bounds narrow which fixtures are aggregated rather than redefining staleness. */
export type PlayerEvaluationAggregateInput = {
  /** Restrict the aggregate to fixtures on or after this civil date, ISO-8601 (YYYY-MM-DD). Omit to span the player's whole history. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Restrict the aggregate to fixtures on or before this civil date, ISO-8601 (YYYY-MM-DD). */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** Player filtering by team, league, or player origin. Team and league filters are mutually exclusive. */
export type PlayerFilterInput = {
  /** Filter by competition IDs (UCL, UEL, etc.) — matches players whose team participates in the competition */
  competitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, excludes manually-created players from results (returns only provider-sourced players) */
  excludeManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter players by league ID */
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter players by team ID */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** A player's preferred foot. For footedness queries, include BOTH alongside the side — a two-footed player can play left- or right-footed (e.g. left-footed → [LEFT, BOTH]). */
export enum PlayerFoot {
  Both = 'BOTH',
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** Player injury record */
export type PlayerInjuryModel = {
  __typename?: 'PlayerInjuryModel';
  /** Number of days missed due to the injury */
  daysMissed?: Maybe<Scalars['Int']['output']>;
  /** Number of games missed due to the injury */
  gamesMissed?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the injury */
  id: Scalars['ID']['output'];
  /** Description of the injury suffered */
  injury?: Maybe<Scalars['String']['output']>;
  /** Date when the injury occurred */
  injuryDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the player associated with this injury */
  playerId: Scalars['ID']['output'];
  /** ID of the season when this injury occurred */
  seasonId?: Maybe<Scalars['ID']['output']>;
};

/** Information about a specific match a player participated in including competition details and venue */
export type PlayerMatch = {
  __typename?: 'PlayerMatch';
  /** Competition key identifier */
  competitionKey?: Maybe<Scalars['String']['output']>;
  /** Match venue */
  ground?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the match (nullable for backwards compatibility) */
  id?: Maybe<Scalars['ID']['output']>;
  /** Date the match was played */
  matchDate?: Maybe<Scalars['DateTime']['output']>;
  /** Match identifier (required) */
  matchId: Scalars['String']['output'];
  /** Name of the opposing team */
  oppositionName?: Maybe<Scalars['String']['output']>;
  /** Season key identifier */
  seasonKey?: Maybe<Scalars['String']['output']>;
  /** Select box information */
  selectBox?: Maybe<Scalars['String']['output']>;
  /** Name of the player's team */
  teamName?: Maybe<Scalars['String']['output']>;
};

/** Connection type for paginated PlayerMatch results */
export type PlayerMatchConnection = {
  __typename?: 'PlayerMatchConnection';
  /** A list of edges */
  edges: Array<PlayerMatchEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for PlayerMatch connection */
export type PlayerMatchEdge = {
  __typename?: 'PlayerMatchEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The PlayerMatch node */
  node: PlayerMatch;
};

/** A player's own evaluation within a match report, projected to that player alone. Rendered in the player page's existing reports list alongside PlayerScoutReport. */
export type PlayerMatchReportEvaluation = {
  __typename?: 'PlayerMatchReportEvaluation';
  /** Identifier of this specific evaluation row. */
  evaluationId: Scalars['ID']['output'];
  /** Whether the player started, under the published snapshot. Three-state: null means the scout has not said, which is not the same as an explicit false. */
  isStarter?: Maybe<Scalars['Boolean']['output']>;
  /** Scheduled date of the fixture as a civil date, `YYYY-MM-DD`, with no timezone — when the football happened, as opposed to `reportDate`, which is when the report was written. A String and not a DateTime on purpose: the column is a Postgres `date`, and rendering it through an instant moves it to the previous day for any viewer EAST of UTC (measured: shifts in London, Tokyo and Kiritimati; does not shift in New York or Recife). Nullable because a fixture's date precision can leave it unset. Rows arrive already ordered by this field, descending. RENDER-ONLY for a merged list — sort on `sortDate`, which resolves this same fixture date on BOTH report kinds and falls back to the creation day for a report covering no match, so no client needs a normaliser or a per-row fallback (SE-7928). */
  matchDate?: Maybe<Scalars['String']['output']>;
  /** The fixture the report covers. */
  matchId: Scalars['ID']['output'];
  /** The scout's note about THIS player under the published snapshot. No other player's note is reachable from this type. */
  note?: Maybe<Scalars['String']['output']>;
  /** When this evaluation became noted, under the published snapshot. */
  notedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The other side of the fixture, relative to `team`. */
  opponent?: Maybe<Scalars['String']['output']>;
  /** Performance rating 0-10 under the published snapshot, or null when not scored. */
  performanceScore?: Maybe<Scalars['Int']['output']>;
  /** Potential rating 0-10 under the published snapshot, or null when not scored. */
  potentialScore?: Maybe<Scalars['Int']['output']>;
  /** When the report was created — the twin of `PlayerScoutReport.reportDate`, same meaning and same type. Kept for display and as the documented tie-break WITHIN a `sortDate` day, since `sortDate` resolves to a day and leaves same-day rows equal. It is no longer the sort key itself (SE-7928). */
  reportDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the match report this evaluation belongs to. Not the evaluation's own id — this is what a caller navigates to. */
  reportId: Scalars['ID']['output'];
  /** Always MATCH. Present so a client merging this with `Player.scoutReports` can tell the two apart after flattening. */
  reportKind: ReportKind;
  /** Human display name of the scout who wrote the report: Cognito full name, else the email local part, else the email, else "Unnamed user". Never null — the twin of `PlayerScoutReport.scoutName`. */
  scoutName: Scalars['String']['output'];
  /** UUID of the scout who owns the report. */
  scoutUserId?: Maybe<Scalars['ID']['output']>;
  /** Shirt number under the published snapshot. */
  shirtNumber?: Maybe<Scalars['Int']['output']>;
  /** The day this row is ordered on in the player page's merged reports list: the fixture's civil date when the row has one, otherwise the report's own creation day in UTC. `YYYY-MM-DD`, never null. SORT ON THIS — it is the only key comparable across both report kinds, and the backend owns the rule so no client re-derives it. It resolves to a DAY, so break ties on `reportDate` and then on id. Never render it; use `matchDate` for the fixture and `reportDate` for authorship. */
  sortDate: Scalars['String']['output'];
  /** When the report was submitted. Never null in practice — this field returns submitted reports only — but kept nullable so the column's own shape is not misrepresented on the wire. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The team this player was evaluated as playing for, from the evaluation's own team, falling back to the fixture's home side when the scout did not state one. */
  team?: Maybe<Scalars['String']['output']>;
};

/** Connection type for players ranked by a raw provider metric, each edge carrying its metric values */
export type PlayerMetricRankConnection = Connection & {
  __typename?: 'PlayerMetricRankConnection';
  /** The season-minutes floor applied from minutesFloorLadder: the first rung that admits a full page, else the lowest rung. Null when no ladder was sent. */
  appliedMinutesFloor?: Maybe<Scalars['Int']['output']>;
  /** A list of edges */
  edges: Array<PlayerMetricRankEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total number of players matching the cohort + threshold criteria (optional; omitted when not computed). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Edge type for a metric-ranked Player connection */
export type PlayerMetricRankEdge = Edge & {
  __typename?: 'PlayerMetricRankEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** Raw provider-metric values for this player — the sort metric plus every requested threshold metric */
  metricValues: Array<ProviderMetricValue>;
  /** The ranked Player node */
  node: Player;
};

/** Time series data point for player ratings enabling performance trend analysis across seasons */
export type PlayerRatingTimeSeries = {
  __typename?: 'PlayerRatingTimeSeries';
  /** The season key for this data point */
  ggUnifiedSeasonKey?: Maybe<Scalars['Int']['output']>;
  /** Gemini Player Rating for this season */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Per-season league-variant GPR (anchored to the sport's reference league, translatable on the fly) */
  gprLeague?: Maybe<Scalars['Float']['output']>;
  /** Z-score of GPM for this season */
  zGpm?: Maybe<Scalars['Float']['output']>;
  /** Z-score of VAEP for this season */
  zVaep?: Maybe<Scalars['Float']['output']>;
};

/** Represents a recommended player with ranking information and trend data */
export type PlayerRecommendationResult = Node & {
  __typename?: 'PlayerRecommendationResult';
  /** Current ranking position for this recommendation type */
  currentRank: Scalars['Int']['output'];
  /** Unique identifier for player recommendation */
  id: Scalars['ID']['output'];
  /** The recommended player */
  player: Player;
  /** Previous ranking position for this recommendation type (null if first time ranked) */
  previousRank?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the previous ranking (null if first time ranked) */
  previousTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Change in ranking position (negative = improved, positive = declined, null if first time ranked) */
  rankChange?: Maybe<Scalars['Int']['output']>;
  /** Recommendation score for the player (0.0 to 1.0) */
  recommendationScore: Scalars['Float']['output'];
  /** Type of recommendation (e.g., YOUNG_PLAYERS, UNDERPERFORMING_PLAYERS, SQUAD_DEPTH) */
  recommendationType: Scalars['String']['output'];
  /** Timestamp when the recommendation was generated */
  timestamp: Scalars['DateTime']['output'];
};

/** Scout report containing observations and assessments from match attendance */
export type PlayerScoutReport = {
  __typename?: 'PlayerScoutReport';
  /** Locale codes for which cached translations exist on this report */
  availableTranslations?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the current user can archive this report (soft delete) */
  canArchive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user can edit this report via Form.io */
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  /** GG global match keys — provider-agnostic identifiers for the observed matches */
  ggMatchKeys?: Maybe<Array<Scalars['String']['output']>>;
  /** External player identifier from data provider */
  ggPlayerKey?: Maybe<Scalars['String']['output']>;
  /** Match venue */
  ground?: Maybe<Scalars['String']['output']>;
  /** Date of the last edit to this report */
  lastEditDate?: Maybe<Scalars['DateTime']['output']>;
  /** Name of the user who last edited this report */
  lastEditorName?: Maybe<Scalars['String']['output']>;
  /** UUID of the user who last edited this report */
  lastEditorUserId?: Maybe<Scalars['ID']['output']>;
  /** Name of the match */
  matchName?: Maybe<Scalars['String']['output']>;
  /** Match details associated with this report */
  matches?: Maybe<Array<MatchDetail>>;
  /** Opposing team */
  opponent?: Maybe<Scalars['String']['output']>;
  /** Overall performance score given by scout */
  overallScore?: Maybe<Scalars['Float']['output']>;
  /** Free-form text responses from scout questionnaire */
  qnaText?: Maybe<Scalars['String']['output']>;
  /** Date the report was created */
  reportDate?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the report */
  reportId?: Maybe<Scalars['ID']['output']>;
  /** Always SCOUT. Present so a client that merges this list with `Player.matchReportEvaluations` can tell the two apart after flattening, without inferring provenance from which query produced the row. */
  reportKind: ReportKind;
  /** Name of the scout who created the report */
  scoutName?: Maybe<Scalars['String']['output']>;
  /** UUID of the user who created the report */
  scoutUserId?: Maybe<Scalars['ID']['output']>;
  /** The day this row is ordered on in the player page's merged reports list: the fixture's civil date when the row has one, otherwise the report's own creation day in UTC. `YYYY-MM-DD`, never null. SORT ON THIS — it is the only key comparable across both report kinds, and the backend owns the rule so no client re-derives it. It resolves to a DAY, so break ties on `reportDate` and then on id. Never render it; use `matchDate` for the fixture and `reportDate` for authorship. */
  sortDate: Scalars['String']['output'];
  /** Team the player was playing for */
  team?: Maybe<Scalars['String']['output']>;
  /** Translated version of qnaText in the requested locale, null when not yet translated */
  translatedQnaText?: Maybe<Scalars['String']['output']>;
};

/** Scout reports for a single requested player, returned as one labelled group per name in a comparison */
export type PlayerScoutReportGroup = {
  __typename?: 'PlayerScoutReportGroup';
  /** The visible scout reports for this player (capped at 100). Empty when totalCount is 0. */
  reports: Array<OrganizationScoutReportNode>;
  /** The player name that was searched for this group (echoes the requested name) */
  search: Scalars['String']['output'];
  /** Total number of scout reports this player has that the current user is permitted to see. 0 means this player has no visible reports. */
  totalCount: Scalars['Int']['output'];
};

/** Detailed categorical performance scores for a player during a season including skill-specific metrics */
export type PlayerSeasonCategoricalScore = {
  __typename?: 'PlayerSeasonCategoricalScore';
  /** Aerials global categorical score */
  aerialsGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Aerials positional categorical score */
  aerialsPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Aerials global categorical score (transformed) */
  aerialsTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Aerials positional categorical score (transformed) */
  aerialsTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating global categorical score */
  anticipatingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating positional categorical score */
  anticipatingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating global categorical score (transformed) */
  anticipatingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Anticipating positional categorical score (transformed) */
  anticipatingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting global categorical score */
  assistingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting positional categorical score */
  assistingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting global categorical score (transformed) */
  assistingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Assisting positional categorical score (transformed) */
  assistingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup global categorical score */
  buildupGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup positional categorical score */
  buildupPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup global categorical score (transformed) */
  buildupTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Buildup positional categorical score (transformed) */
  buildupTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying global categorical score */
  carryingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying positional categorical score */
  carryingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying global categorical score (transformed) */
  carryingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Carrying positional categorical score (transformed) */
  carryingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating global categorical score */
  creatingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating positional categorical score */
  creatingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating global categorical score (transformed) */
  creatingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Creating positional categorical score (transformed) */
  creatingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing global categorical score */
  crossingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing positional categorical score */
  crossingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing global categorical score (transformed) */
  crossingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Crossing positional categorical score (transformed) */
  crossingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials global categorical score */
  defensiveAerialsGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials positional categorical score */
  defensiveAerialsPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials global categorical score (transformed) */
  defensiveAerialsTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Defensive aerials positional categorical score (transformed) */
  defensiveAerialsTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling global categorical score */
  dribblingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling positional categorical score */
  dribblingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling global categorical score (transformed) */
  dribblingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Dribbling positional categorical score (transformed) */
  dribblingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing global categorical score */
  finishingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing positional categorical score */
  finishingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing global categorical score (transformed) */
  finishingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Finishing positional categorical score (transformed) */
  finishingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** External player identifier from data provider */
  ggPlayerKey: Scalars['String']['output'];
  /** Unified season key identifier */
  ggUnifiedSeasonKey: Scalars['Int']['output'];
  /** Goalkeeper cross intercept categorical score */
  gkCrossInterceptCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper cross intercept categorical score (transformed) */
  gkCrossInterceptTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper keeper sweeper categorical score */
  gkKeeperSweeperCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper keeper sweeper categorical score (transformed) */
  gkKeeperSweeperTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper passing categorical score */
  gkPassingCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper passing categorical score (transformed) */
  gkPassingTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper positioning categorical score */
  gkPositioningCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper positioning categorical score (transformed) */
  gkPositioningTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shot stopping categorical score */
  gkShotStoppingCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shot stopping categorical score (transformed) */
  gkShotStoppingTransCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading global categorical score */
  headingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading positional categorical score */
  headingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading global categorical score (transformed) */
  headingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Heading positional categorical score (transformed) */
  headingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing global categorical score */
  passingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing positional categorical score */
  passingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing global categorical score (transformed) */
  passingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Passing positional categorical score (transformed) */
  passingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing global categorical score */
  pressingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing positional categorical score */
  pressingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing global categorical score (transformed) */
  pressingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Pressing positional categorical score (transformed) */
  pressingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending global categorical score */
  proactiveDefendingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending positional categorical score */
  proactiveDefendingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending global categorical score (transformed) */
  proactiveDefendingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Proactive defending positional categorical score (transformed) */
  proactiveDefendingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Native season UUID from stat.season table */
  seasonId: Scalars['ID']['output'];
  /** Set piece delivering global categorical score */
  setPieceDeliveringGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Set piece delivering positional categorical score */
  setPieceDeliveringPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Set piece delivering global categorical score (transformed) */
  setPieceDeliveringTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Set piece delivering positional categorical score (transformed) */
  setPieceDeliveringTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location global categorical score */
  shotLocationGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location positional categorical score */
  shotLocationPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location global categorical score (transformed) */
  shotLocationTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot location positional categorical score (transformed) */
  shotLocationTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement global categorical score */
  shotPlacementGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement positional categorical score */
  shotPlacementPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement global categorical score (transformed) */
  shotPlacementTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Shot placement positional categorical score (transformed) */
  shotPlacementTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling global categorical score */
  tacklingGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling positional categorical score */
  tacklingPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling global categorical score (transformed) */
  tacklingTransGlobalCategoricalScore?: Maybe<Scalars['Float']['output']>;
  /** Tackling positional categorical score (transformed) */
  tacklingTransPositionalCategoricalScore?: Maybe<Scalars['Float']['output']>;
};

/** Season-specific weighted average performance metrics for a player */
export type PlayerSeasonWeightedAvgMetrics = {
  __typename?: 'PlayerSeasonWeightedAvgMetrics';
  /** Estimated Plus-Minus metric */
  epm?: Maybe<Scalars['Float']['output']>;
  /** External player identifier from data provider */
  ggPlayerKey: Scalars['String']['output'];
  /** Unified season key identifier */
  ggUnifiedSeasonKey: Scalars['Int']['output'];
  /** Regularized Adjusted Plus-Minus metric */
  rapm?: Maybe<Scalars['Float']['output']>;
  /** Seasonal Gemini Player Metric */
  seasonalGpm?: Maybe<Scalars['Float']['output']>;
  /** Statistical Plus-Minus metric */
  spm?: Maybe<Scalars['Float']['output']>;
  /** Standard deviation of EPM */
  stdEpm?: Maybe<Scalars['Float']['output']>;
  /** Transformed standard deviation of EPM */
  stdEpmTransform?: Maybe<Scalars['Float']['output']>;
};

/** Whether a player belongs to the user's roster or the wider league */
export enum PlayerSource {
  League = 'LEAGUE',
  Roster = 'ROSTER'
}

/** Pre-populated player information for scout report templates to help scouts quickly identify and evaluate players */
export type PlayerTemplate = {
  __typename?: 'PlayerTemplate';
  /** Additional custom fields specific to organization's needs */
  customFields?: Maybe<Scalars['JSONObject']['output']>;
  /** Date of birth of the player */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Height of the player in centimeters */
  height?: Maybe<Scalars['Float']['output']>;
  /** Minutes played in the match */
  minutesPlayed?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the player */
  playerId: Scalars['ID']['output'];
  /** Name of the player */
  playerName: Scalars['String']['output'];
  /** Playing position of the player */
  position?: Maybe<Scalars['String']['output']>;
};

/** A player with their associated kanban card data for tracking recruitment progress */
export type PlayerWithKanban = {
  __typename?: 'PlayerWithKanban';
  /** The kanban card associated with this player on the board */
  kanbanCard?: Maybe<KanbanCard>;
  /** The ID of the kanban phase the player is currently in */
  kanbanPhaseId?: Maybe<Scalars['ID']['output']>;
  /** The player entity */
  player: Player;
};

/** A connection to a list of PlayerWithKanban items following Relay specification */
export type PlayerWithKanbanConnection = {
  __typename?: 'PlayerWithKanbanConnection';
  /** A list of edges containing PlayerWithKanban nodes */
  edges: Array<PlayerWithKanbanEdge>;
  /** Information about pagination in the connection */
  pageInfo: PageInfo;
};

/** An edge in a PlayerWithKanban connection */
export type PlayerWithKanbanEdge = {
  __typename?: 'PlayerWithKanbanEdge';
  /** A cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The PlayerWithKanban at the end of this edge */
  node: PlayerWithKanban;
};

/** Playing position classification with sport-specific context and generality indicator */
export type Position = Node & {
  __typename?: 'Position';
  /** Abbreviated name of the position */
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** Timestamp of position record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the position */
  id: Scalars['ID']['output'];
  /** Whether this is a general position category */
  isGeneral: Scalars['Boolean']['output'];
  /** Name of the position */
  name: Scalars['String']['output'];
  /** Sport ID this position belongs to */
  sportId: Scalars['ID']['output'];
  /** Timestamp of last position record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** High-level position groupings for the dashboard scatter chart distribution */
export enum PositionCategory {
  Cb = 'CB',
  Cm = 'CM',
  Dm = 'DM',
  F = 'F',
  Fb = 'FB',
  Gk = 'GK',
  W = 'W'
}

/** Connection type for paginated Position results */
export type PositionConnection = Connection & {
  __typename?: 'PositionConnection';
  /** A list of edges */
  edges: Array<PositionEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** A player data point for the dashboard position distribution scatter chart */
export type PositionDistributionPoint = {
  __typename?: 'PositionDistributionPoint';
  /** Time-decayed GPR score */
  gpr: Scalars['Float']['output'];
  /** The full player entity, resolved via DataLoader */
  player?: Maybe<Player>;
  /** Player UUID */
  playerId: Scalars['ID']['output'];
  /** Broad position category (e.g. CB, W, F) */
  positionCategory?: Maybe<PositionCategory>;
  /** Whether the player is on the user's roster or from the league */
  source: PlayerSource;
};

/** Edge type for Position connection */
export type PositionEdge = Edge & {
  __typename?: 'PositionEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Position node */
  node: Position;
};

/** Count of watchlist players per positional profile (ROLE_ARCHETYPE) */
export type PositionalProfileCoverage = {
  __typename?: 'PositionalProfileCoverage';
  /** Number of watchlist players with this profile */
  playerCount: Scalars['Int']['output'];
  /** Positional profile name (ROLE_ARCHETYPE) */
  profileName: Scalars['String']['output'];
};

export enum PrimaryPositionSource {
  None = 'NONE',
  PivotedStats = 'PIVOTED_STATS',
  Player = 'PLAYER'
}

/** Raw per-90 (and total) StatsBomb provider metrics that rankPlayersByMetric can threshold-filter and sort a cohort by. Distinct from the categorical ability scores filterPlayers exposes. */
export enum ProviderMetricField {
  AerialsP90 = 'AERIALS_P90',
  AggressiveActions_90 = 'AGGRESSIVE_ACTIONS_90',
  Assists_90 = 'ASSISTS_90',
  BallRecoveries_90 = 'BALL_RECOVERIES_90',
  CarryObvGainP90 = 'CARRY_OBV_GAIN_P90',
  CrossesP90 = 'CROSSES_P90',
  CrossingRatio = 'CROSSING_RATIO',
  CrossXaP90 = 'CROSS_XA_P90',
  DeepProgressions_90 = 'DEEP_PROGRESSIONS_90',
  DribbleObvGainP90 = 'DRIBBLE_OBV_GAIN_P90',
  Errors_90 = 'ERRORS_90',
  InterceptionsP90 = 'INTERCEPTIONS_P90',
  KeyPasses_90 = 'KEY_PASSES_90',
  MinutesTotal = 'MINUTES_TOTAL',
  Npxgxa_90 = 'NPXGXA_90',
  NpShots_90 = 'NP_SHOTS_90',
  NpXgP90 = 'NP_XG_P90',
  NpXgTotal = 'NP_XG_TOTAL',
  Obv_90 = 'OBV_90',
  ObvForNetP90 = 'OBV_FOR_NET_P90',
  ObvTotalNetP90 = 'OBV_TOTAL_NET_P90',
  OpAssists_90 = 'OP_ASSISTS_90',
  OpKeyPasses_90 = 'OP_KEY_PASSES_90',
  PadjInterceptions_90 = 'PADJ_INTERCEPTIONS_90',
  PadjTackles_90 = 'PADJ_TACKLES_90',
  PadjTacklesAndInterceptions_90 = 'PADJ_TACKLES_AND_INTERCEPTIONS_90',
  PassesIntoBoxP90 = 'PASSES_INTO_BOX_P90',
  PassingRatio = 'PASSING_RATIO',
  PenaltyGoalsP90 = 'PENALTY_GOALS_P90',
  PressuresP90 = 'PRESSURES_P90',
  PressureRegainsP90 = 'PRESSURE_REGAINS_P90',
  ProgressiveCarriesP90 = 'PROGRESSIVE_CARRIES_P90',
  ProgressivePassesP90 = 'PROGRESSIVE_PASSES_P90',
  SuccessfulDribblesP90 = 'SUCCESSFUL_DRIBBLES_P90',
  TacklesP90 = 'TACKLES_P90',
  Xa_90 = 'XA_90'
}

/** Threshold filter on a raw provider metric with optional min/max bounds (used to narrow a cohort before ranking). */
export type ProviderMetricFilterInput = {
  /** Inclusive maximum value for the metric */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The provider metric to threshold-filter on */
  metric: ProviderMetricField;
  /** Inclusive minimum value for the metric */
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** A raw provider-metric value for a ranked player. */
export type ProviderMetricValue = {
  __typename?: 'ProviderMetricValue';
  /** The provider metric this value corresponds to */
  metric: ProviderMetricField;
  /** The raw metric value from the season provider metrics view; null when the player has no value for this metric in the season */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Publishes a submitted match report's working copy: copies working over published for every evaluation and stamps lastPublishedAt, so post-submit edits become visible to the club. The report must already be submitted. Does not fire the submission feed. */
export type PublishMatchReportInput = {
  /** Identifier of the submitted report to publish */
  matchReportId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** Every Objective a club owns, DISABLED ONES INCLUDED — each carrying its own isEnabled flag. Deliberately unfiltered: complianceOverview reports the rules that evaluated, and a disabled Objective is excluded before evaluation, so a list that also hid them would leave a retired Objective unreachable by any query. Ordered by name. Requires compliance Tier 1 or 2, and omits any Objective whose metric the caller's tier does not reach. */
  clubObjectives: Array<ClubObjective>;
  /** Returns scout reports for several named players at once, grouped per player (one bucket per name, including players with zero reports). Use for comparing two or more players' scouting reports in a single call. */
  compareOrganizationScoutReports: Array<PlayerScoutReportGroup>;
  /** Lists competition stat priorities for the current organization */
  competitionStatPriorities: Array<StatPriority>;
  /** One club's compliance calendar — the month its reporting (fiscal) year opens and the month its season opens. Null means the club has not configured one and is therefore not eligible for snapshot capture; a viewer who may not read it is refused rather than served null. Requires compliance Tier 1. */
  complianceClubCalendar?: Maybe<ComplianceClubCalendar>;
  /** A club's authored domestic competition — the league a Tier 1 user says it plays in — and the regime edition it currently resolves to. Null when the club has configured none, which is a real answer and not a permission failure: a caller who may not see it receives a Forbidden error instead. Requires compliance Tier 1. */
  complianceClubSetup?: Maybe<ComplianceClubSetup>;
  /** The individually-entered rows for one club-scoped quantity, oldest effectiveFrom first then oldest recordedAt first — the raw CFO entries recordComplianceFinancialFigure writes, not the single resolved value complianceOverview.clubQuantities returns. Optionally bounded to an effectiveFrom range. Requires compliance Tier 1, the same bar as entering them. */
  complianceFinancialFigures: Array<ComplianceFinancialFigure>;
  /** The compliance metrics a club may build rules on, filtered to those whose inputs the viewer's tier permits. NULL when the club HAS metrics but the viewer's tier permits none of them; [] ONLY when the club has configured none. Null is NEVER an empty list — an empty list asserts that the club has no metrics, which is a statement about the club rather than a refusal to answer. Distinguish the two: null means 'not permitted to know', [] means 'none configured'. A partial withhold is still a list; a metric the viewer may not see is absent from it. */
  complianceMetrics?: Maybe<Array<ComplianceMetricSummary>>;
  /** One club's compliance picture — every rule the viewer may see, grouped by layer, with state, value, threshold, deviation, drivers and the computed fix for any breach, plus the club figures and the viewer's own tier. Returns a valid empty overview for an unconfigured club. */
  complianceOverview: ComplianceOverview;
  /** Admin-only diagnostic query that checks if read replica routing is working. Compares explicit master, explicit slave, and auto-routed connections. */
  databaseDiagnostics: DatabaseDiagnosticsModel;
  /** The groups the owner can invite; v1: Everyone at {organization}. Owner only */
  eligibleShareGroups: Array<ShareGroup>;
  /** Returns a paginated, optionally category-filtered Update Feed for the authenticated user */
  feedEvents: FeedEventConnection;
  /** Returns players matching advanced filter criteria with optional sorting */
  filterPlayers: PlayerConnection;
  /** Lists game stat priorities for the current organization */
  gameStatPriorities: Array<StatPriority>;
  /** Retrieves a comment by its unique identifier */
  getComment?: Maybe<Comment>;
  /** Returns a presigned inline GET URL for a contract document (Owner-only) */
  getContractDocumentPreviewUrl: Scalars['String']['output'];
  /** Get the contract extraction for a player and document type (Owner-only). Defaults to the active row; pass `archived: true` to read the archived row instead — needed by the Archived contracts drawer (SE-4349) so it can render extracted data + the Restore button. */
  getContractExtraction?: Maybe<ContractExtractionObject>;
  /** Returns the calling user's stored lastFeedVisitAt timestamp (nullable until first commit) */
  getCurrentLastFeedVisitAt?: Maybe<Scalars['DateTime']['output']>;
  /** Returns per-player metric scores for distribution scatter-plot charts. Pass seasonId for seasonal scores or omit it for career (all-time) scores. */
  getDistributionScores: Array<DistributionPlayerScore>;
  /** Returns the count of players with contracts expiring within the specified threshold */
  getExpiringContractsCount: Scalars['Int']['output'];
  /** Returns ordered position abbreviations for a given formation (e.g. GK, LB, LCB, ...). Requires MANAGER+ role. */
  getFormationPositions: Array<Scalars['String']['output']>;
  /** Generates a temporary URL for the intake form renderer with a scoped token */
  getIntakeFormUrl: Scalars['String']['output'];
  /** Retrieves a kanban board by ID */
  getKanbanBoard?: Maybe<KanbanBoard>;
  /** Returns league GPR spectrum showing user's club position relative to the league (top 23 players per club) */
  getLeagueGprSpectrum: LeagueGprSpectrum;
  /** Retrieves a match by ID within the caller's organization. Returns null rather than an error for a match belonging to another organization, so the response cannot be used to probe foreign identifiers. */
  getMatch?: Maybe<Match>;
  /** Retrieves a match report by ID within the caller's organization, with server-derived status and counts. Returns null rather than an error for a report in another organization. The `snapshot` argument selects the published copy (the default, the club's view) or the working copy (the capture screen's in-progress edits); before submit the two are identical. */
  getMatchReport?: Maybe<MatchReport>;
  /** Min and max minutes played bounds for the organization */
  getMinutesPlayedBounds: MinutesPlayedBounds;
  /** Retrieves the current user's organization-team association by team ID */
  getMyOrganizationTeamByTeamId?: Maybe<OrganizationTeam>;
  /** Retrieves a note by its unique identifier */
  getNote?: Maybe<Note>;
  /** Retrieves an organization by its ID for admin users */
  getOrganization?: Maybe<Organization>;
  /** Retrieves organization-scoped player data (salary, valuation, readiness) for a player. Money and contract fields are null when the viewer's tier may not see wages (SE-7410). */
  getOrganizationPlayerData?: Maybe<OrganizationPlayerDataModel>;
  /** Retrieves a single player by UUID. To find a player by name, use searchPlayers first to get the UUID. */
  getPlayer?: Maybe<Player>;
  /** Retrieves biographical and performance data for a player by ID */
  getPlayerBioDataByPlayerId?: Maybe<PlayerBioData>;
  /** Retrieves a single player by their GG external identifier */
  getPlayerByPlayerGGID?: Maybe<Player>;
  /** Retrieves a single player by their Transfermarkt ID */
  getPlayerByTransfermarktId?: Maybe<Player>;
  /** Returns the extracted contract clauses for a player as a flat list (Owner-only). Returns [] (never null) when no extraction exists for (playerId, documentType, org). Document type defaults to CONTRACT (playing contract); pass TRANSFER_AGREEMENT for transfer-fee terms. */
  getPlayerContractClauses: Array<ContractClause>;
  /** Retrieves a player data summary by its unique identifier */
  getPlayerDataSummary?: Maybe<PlayerDataSummary>;
  /** Retrieves a player data summary by GG external ID for the current user's organization */
  getPlayerDataSummaryByPlayerGGID?: Maybe<PlayerDataSummary>;
  /** Retrieves a player data summary by player ID for the current user's organization */
  getPlayerDataSummaryByPlayerId?: Maybe<PlayerDataSummary>;
  /** Returns season-level categorical scores aka attributes for a player by ID. Useful for understanding a player's performance profile across different skill areas. */
  getPlayerSeasonCategoricalScores: Array<PlayerSeasonCategoricalScore>;
  /** Returns a player's team-style fit score (0-100) against a specific team. Use this for 'how does X fit team Y' and per-team compare-fit prompts. Returns null when no manager-vector data is available for the (player, team) pair in the user's organization. */
  getPlayerTeamFit?: Maybe<Scalars['Int']['output']>;
  /** Returns count of watchlist players per positional profile (ROLE_ARCHETYPE) */
  getPositionalProfileCoverage: Array<PositionalProfileCoverage>;
  /** Returns counts of first-team roster players with contracts expiring within 6 and 12 months */
  getRosterExpiringContracts: RosterExpiringContracts;
  /** Returns a scenario with all actions and resolved player names */
  getScenario: ScenarioDetailModel;
  /** SE-8467: the persisted pitch state of a scenario. MANAGER+ only; NotFound when the scenario is not accessible to the caller. */
  getScenarioPitch: ScenarioPitch;
  /** Returns a single scout report by ID as a player scout report view */
  getScoutReport: PlayerScoutReport;
  /** Generates a temporary edit URL for a Form.io scout report submission */
  getScoutReportEditUrl: Scalars['String']['output'];
  /** Retrieves a scout report template with pre-populated fields for a match */
  getScoutReportTemplate: ScoutReportTemplate;
  /** Returns all active scout report types for the current organization */
  getScoutReportTypes: Array<ScoutReportType>;
  /** Returns summary counts of scouting watchlist players and identified gaps (without report, no action 30 days) */
  getScoutingWidgetSummary: ScoutingWidgetSummary;
  /** Returns season-level team and position categorical metric averages */
  getSeasonMetricAverages: SeasonMetricAveragesResult;
  /** Retrieves a shadow team by ID */
  getShadowTeam: ShadowTeam;
  /** Returns comprehensive database schema metadata. IMPORTANT: Call this BEFORE executeSqlQuery to discover available tables, columns, and relationships. Response structure: tables (schema-qualified keys like 'public.player'), columns (PostgreSQL types, nullability, primary keys), foreignKeys (JOIN conditions), uniqueValues (low-cardinality column values for WHERE filters), jsonSchema (JSONB structure — use -> for objects, ->> for text). Column casing: regular tables use snake_case, materialized views (e.g., stat.player_stats_pivoted) use UPPERCASE names that MUST be double-quoted. Use column names exactly as returned. Use the table 'key' field (e.g., 'public.player') as the schema-qualified name. Read the queryGuidelines array for example queries and semantic mappings. */
  getSqlSchema: SqlSchemaModel;
  /** Returns position nodes with first-team player depth counts for the organization's formation */
  getSquadDepthByPosition: SquadDepthByPositionModel;
  /** Computes the final squad state by applying transitions to the baseline roster. Omit scenarioId for current edit state. */
  getSquadFinalState: SquadFinalStateModel;
  /** Returns GPR distribution counts across first-team players bucketed by score bands */
  getSquadGprDistribution: SquadGprDistribution;
  /** Returns aggregated squad KPIs including player counts, contract status, wages, and optional scenario impact */
  getSquadKPIs: SquadKpIsModel;
  /** Returns squad players grouped by tier (first team, academy, targets). When positionIds is omitted or empty, returns all positions; with several entries, players matching ANY of them are returned (union semantics). */
  getSquadPlayersByPosition: SquadPlayersByPositionModel;
  /** Returns team league ranking, radar chart percentiles, and roster summary stats */
  getTeamLeagueStats: TeamLeagueStats;
  /** Retrieves a single conversation thread by its identifier */
  getThread?: Maybe<UserThread>;
  /** Retrieves a user by their ID within the caller's organization */
  getUser?: Maybe<User>;
  /** Retrieves a watchlist by ID */
  getWatchlist?: Maybe<Watchlist>;
  getWatchlistPitch?: Maybe<WatchlistPitch>;
  /** Composite home dashboard payload bundling the six per-squad home widgets in a single round trip */
  homeGetDashboardData: HomeDashboardData;
  /** Get all injuries for a specific player, ordered by date descending */
  injuriesByPlayerId: Array<PlayerInjuryModel>;
  /** Get injuries for multiple players in a single request */
  injuriesByPlayerIds: Array<PlayerInjuryModel>;
  /** Retrieves a single kanban card by ID */
  kanbanCard?: Maybe<KanbanCard>;
  /** Retrieves a kanban tag by ID */
  kanbanTag?: Maybe<KanbanTag>;
  /** Lists lifetime stat priorities for the current organization */
  lifetimeStatPriorities: Array<StatPriority>;
  /** Advanced PLAYER_SEASON_* stats by league/season */
  listAdvancedCompetitionStats: Array<AdvancedCompetitionStats>;
  /** Lists all players across all watchlists the user has access to, deduplicated */
  listAllScoutingTargets: ScoutingTargetConnection;
  /** Lists scouts available for assignment with a guaranteed display name and their same-day workload. The workload counts scheduled things of every kind, not only matches, so it stays correct once training visits and tournaments exist. */
  listAssignableScouts: Array<AssignableScout>;
  /** Lists scout assignments in the caller's organization. Kind-agnostic: the same query answers who is covering a fixture and what a scout is doing on a given day, and keeps working unchanged when non-match scheduled things are registered. */
  listAssignments: AssignmentConnection;
  /** Custom stat definitions available for filtering and sorting */
  listAvailableCustomStats: Array<CustomStatDefinition>;
  /** Basic Transfermarkt stats by league/season */
  listBasicCompetitionStats: Array<BasicCompetitionStats>;
  /** Returns available categorical metric definitions for dynamic column and sort configuration */
  listCategoricalMetrics: Array<CategoricalMetricDefinition>;
  /** Returns paginated comments for a specific note */
  listCommentsByNoteId: CommentConnection;
  /** Lists all available cup/continental competitions (e.g. UCL, UEL, UECL) */
  listCompetitions: CompetitionConnection;
  /** Lists contract documents uploaded for a player (Owner-only). Pass documentType (CONTRACT or TRANSFER_AGREEMENT) to scope the list to a single type — the contract drawer relies on this filter so each tab only shows its own uploads (SE-4710). */
  listContractDocuments: Array<ContractDocument>;
  /** Returns players with contracts expiring within the specified threshold (months) */
  listExpiringContracts: ExpiringContractConnection;
  /** Returns all feature flags from the current configuration */
  listFeatureFlags: Scalars['JSON']['output'];
  /** Returns first-team players within a specific GPR band for the modal drill-down */
  listFirstTeamPlayersByGprBand: Array<GprBandPlayer>;
  /** Game-level intelligence metrics, optionally filtered by game */
  listGameMetrics: Array<GameMetrics>;
  /** Game-level provider metrics, optionally filtered by game, a list of games, or a date range */
  listGameProviderMetrics: Array<GameProviderMetrics>;
  /** The aggregate's group grants; owner only */
  listGroupGrants: Array<GroupGrant>;
  /** Returns currently injured first-team roster players with injury details */
  listInjuredRosterPlayers: Array<InjuredPlayer>;
  /** Returns one flat row of filterable performance/goalkeeper metrics per player carded on a board. Field names match PlayerBioData. */
  listKanbanBoardPlayerMetrics: Array<KanbanBoardPlayerMetrics>;
  /** Lists tags with custom colors for a kanban board */
  listKanbanBoardTags: KanbanBoardTagConnection;
  /** Returns kanban cards with player data for a board */
  listKanbanCards: PlayerWithKanbanConnection;
  /** Lists all phases for a kanban board */
  listKanbanPhases: Array<KanbanPhase>;
  /** Lists kanban tags for the current organization */
  listKanbanTags: KanbanTagConnection;
  /** Lists all available leagues with optional search filtering */
  listLeagues: LeagueConnection;
  /** Lists leagues filtered by a specific sport */
  listLeaguesBySportId: LeagueConnection;
  /** List a team's current loans: OUT = its players on loan at other clubs; IN = players on loan at the team from other clubs; ALL = both (OUT rows first). Current loans only; the data has no loan history, so there is no season filter. Each row carries the transfer that started the loan (date, fee) when one is recorded. Returns [] (never null) when the team has no loans. */
  listLoansByTeamId: Array<TeamLoanModel>;
  /** Lists per-player minutes recorded for a match. One record per player; a null duration means the appearance is known but its length is not, and must not be read as zero. */
  listMatchAppearances: Array<MatchAppearance>;
  /** Lists the basic events recorded against a match, ordered by minute. An event whose minute is unknown sorts last rather than at kick-off. */
  listMatchEvents: Array<MatchEvent>;
  /** Lists match reports one row per report, with derived status and counts. Distinct from the per-player scout report list: a 22-player match report is one report with N players, which that surface cannot express. */
  listMatchReports: MatchReportConnection;
  /** Lists matches in the caller's organization with cursor pagination. Date bounds compare against the fixture's civil date at the venue, and a WINDOW-precision fixture matches when any day of its window falls in range. */
  listMatches: MatchConnection;
  /** Returns a paginated list of activities for the current user and marks them as seen */
  listMyActivities: ActivityConnection;
  /** Lists all kanban boards accessible to the current user, most recently updated first (ties broken by board id) */
  listMyKanbanBoards: KanbanBoardConnection;
  /** Returns a paginated list of activities for the current user's organization */
  listMyOrganizationActivities: OrganizationActivityConnection;
  /** Lists organizations the authenticated user is a member of */
  listMyOrganizations: OrganizationConnection;
  /** Lists eligible teams that can be added to the current user's organization */
  listMyOrganizationsEligibleTeams: TeamConnection;
  /** Lists kanban cards for a board within the user's organization */
  listMyOrganizationsKanbanCards: KanbanCardConnection;
  /** Lists all leagues in the current user's organization */
  listMyOrganizationsLeagues: LeagueConnection;
  /** Lists organization users for the current user's organization */
  listMyOrganizationsOrganizationUsers: OrganizationUserConnection;
  /** Lists all players in the current user's organization */
  listMyOrganizationsPlayers: PlayerConnection;
  /** Lists invitations sent by the current user's organization */
  listMyOrganizationsSentInvitations: InvitationConnection;
  /** Lists all teams in the current user's organization */
  listMyOrganizationsTeams: TeamConnection;
  /** Lists invitations received by the current user */
  listMyReceivedInvitations: InvitationConnection;
  /** Lists invitations sent by the current user */
  listMySentInvitations: InvitationConnection;
  /** Lists all watchlists for the authenticated user */
  listMyUserWatchlists: UserWatchlistConnection;
  /** Lists all available nationalities with pagination */
  listNationalities: NationalityConnection;
  /** List all users with access to a note */
  listNoteShares: Array<NoteShare>;
  /** Returns paginated notes for a player filtered by the user's organizational role */
  listNotesByPlayerId: NoteConnection;
  /** Returns first-team roster players currently on loan with loan and contract details */
  listOnLoanPlayers: Array<OnLoanPlayer>;
  /** Lists all organizations with pagination for admin users */
  listOrganizations: OrganizationConnection;
  /** Lists org members' watchlists the calling MANAGER has no access to (SE-5073 Others section) */
  listOthersWatchlists: WatchlistConnection;
  /** Lists kanban boards in the organization that have no owner, so an administrator can assign one. Organization managers, admins and owners only. */
  listOwnerlessKanbanBoards: Array<OwnerlessKanbanBoard>;
  /** Lists the fixture reconciliations the ingestion engine refused to decide, oldest first, in the caller's organization. Each carries the source's snapshotted claim and every candidate match with enough context to tell them apart. */
  listPendingReconciliationAmbiguities: Array<ReconciliationAmbiguity>;
  /** Returns players suggested for a pipeline, sourced from the organization's existing recommendation output. */
  listPipelineSuggestedPlayers: PipelineSuggestedPlayerConnection;
  /** SE-7018: recorded card counts and a nullable suspension warning for each requested player, for the squad-pick row. Never asserts availability and never blocks selection — a player with no recorded cards returns zero counts and a null warning (silence, not a clearance). */
  listPlayerDisciplineSignals: Array<PlayerDisciplineSignal>;
  /** Lists match history for a player with pagination */
  listPlayerMatches: PlayerMatchConnection;
  /** Returns top recommended players filtered by recommendation type */
  listPlayerRecommendations: Array<PlayerRecommendationResult>;
  /** Lists season-weighted average metrics for a player by ID */
  listPlayerSeasonWeightedAvgMetricsByPlayerId?: Maybe<Array<PlayerSeasonWeightedAvgMetrics>>;
  /** Lists players filtered by league and position IDs */
  listPlayersByLeagueIdsAndPositionIds: PlayerConnection;
  /** Lists players filtered by team and position IDs */
  listPlayersByTeamIdsAndPositionIds: PlayerConnection;
  /** Returns position distribution scatter chart data for the league */
  listPositionDistributionData: Array<PositionDistributionPoint>;
  /** Lists available positions with optional general/specific filtering */
  listPositions: PositionConnection;
  /** Lists distinct player profiles for the user's organization */
  listProfiles: Array<Scalars['String']['output']>;
  /** Returns paginated recent transfers, optionally filtered by league(s) */
  listRecentTransfers: TransferConnection;
  /** Returns players the user recently viewed (logged via logPlayerProfileView), deduplicated by player, most recent view first */
  listRecentlyInteractedPlayers: Array<RecentlyInteractedPlayer>;
  /** Lists players that have been removed from recommendations for the user's organization */
  listRemovedPlayerRecommendations: PlayerConnection;
  /** Lists distinct role archetypes or positional profiles for the user's organization. Returns archetype names such as MOPPER, GAMEWEAVER, SAFECRACKER, ROADRUNNER, COMBO FORWARD, NUMBER 6, STOPPER, etc. Use this to get valid archetype values before passing them as filter criteria to filterPlayers. */
  listRoleArchetypes: Array<Scalars['String']['output']>;
  /** Lists all available roles in the system */
  listRoles: RoleConnection;
  /** Contract clauses across the whole roster in one call (Owner-only). The roster is the Contracts tab's active list; organization comes from the authenticated user. Filter clause names with clauseNameContains (OR'd, case-insensitive substrings). rosterCount and checkedCount say how many players were in scope and how many had a document on file. */
  listRosterContractClauses: RosterContractClauses;
  /** First-team roster players with contracts expiring within 12 months, or NULL when the viewer may not see contract dates. Null is NEVER an empty list — an empty list asserts that no contract expires in the window, which is a statement about the squad rather than a refusal to answer. Distinguish the two: null means 'not permitted to know', [] means 'none'. */
  listRosterExpiringContracts?: Maybe<Array<ExpiringContractPlayer>>;
  /** Lists all scenarios for the user's organization */
  listScenarios: Array<ScenarioModel>;
  /** Lists the caller's organization's scheduled things across every kind — fixtures, training visits, tournaments, meetings — as the polymorphic interface, so the planning surface renders them with one fragment and keeps working when further kinds are registered. */
  listScheduledThings: ScheduledThingConnection;
  /** List all users with access to a scout report */
  listScoutReportShares: Array<ScoutReportShare>;
  /** Lists all scouts with their owned watchlists in the organization */
  listScoutingScouts: Array<ScoutWithWatchlists>;
  /** Season-level provider metrics, optionally filtered by season */
  listSeasonProviderMetrics: Array<SeasonProviderMetrics>;
  /** Returns the list of available seasons (id, displayYear like '2024/25', startYear, endYear), most recent first. Use this to resolve a season name or 'last/this season' into the seasonId UUID required by listSeasonProviderMetrics and other season-scoped tools. */
  listSeasons: Array<Season>;
  /** Lists players in a shadow team with optional search filtering */
  listShadowTeamPlayers: ShadowTeamPlayerConnection;
  /** Lists shadow teams for the authenticated user */
  listShadowTeams: ShadowTeamConnection;
  /** Lists players similar to a target player with filtering and pagination */
  listSimilarPlayers: SimilarPlayerConnection;
  /** Lists all available sports */
  listSports: SportConnection;
  /** Lists watchlist players matching a specific positional profile (ROLE_ARCHETYPE) */
  listTargetsByPositionalProfile: Array<ScoutingTargetPlayer>;
  /** Lists watchlist players with no activity in the last 30 days (org-scoped) */
  listTargetsNoAction30Days: Array<ScoutingTargetPlayer>;
  /** Lists watchlist players that have no non-archived scout reports (org-scoped) */
  listTargetsWithoutReport: Array<ScoutingTargetPlayer>;
  /** Lists all teams available to the user's organization */
  listTeams: Array<Team>;
  /** Ranks players by total goals scored within a league and season */
  listTopScorers: Array<TopScorer>;
  /** List transfers involving a specific team, optionally filtered by direction (IN/OUT/ALL), window (SUMMER/WINTER), and season. Powers club-scoped transfer prompts ('Chelsea's summer signings', 'who did Bayern sell last window'). Returns [] (never null) when no rows match. Note: window and season are derived from transfer.date — the Transfer entity has no first-class window/season columns. */
  listTransfersByTeamId: Array<TransferModel>;
  /** Lists users associated with a specific watchlist */
  listUserWatchlistsByWatchlistId: UserWatchlistConnection;
  /** Lists players in one or more watchlists with optional sorting and pagination */
  listWatchlistPlayers: PlayerConnection;
  /** Lists all watchlists for the authenticated user */
  listWatchlists: WatchlistConnection;
  /** Aggregates fixture coverage over a date range in one round trip. Computed in SQL so the figures describe the whole range rather than whichever page a client has loaded. */
  matchCoverageSummary: MatchCoverageSummary;
  /** Returns the authenticated user's profile */
  me?: Maybe<User>;
  /** Returns paginated scout reports for the user's organization with filtering and sorting */
  organizationScoutReports: OrganizationScoutReportConnection;
  /** Chronological log of every event on one pipeline. Manager+ only; a sub-Manager receives the same not-found response a nonexistent board produces. Optional action / actorType / actorUserId filters are applied in the SQL predicate, so totalCount describes the FILTERED set. */
  pipelineActivityLog: PipelineActivityLogConnection;
  /** Recorded automation rule evaluations, newest first — including the skip and deferral reasons. Manager+ only. */
  pipelineAutomationFirings: PipelineAutomationRuleFiringConnection;
  /** Automation rules authored against a pipeline. Manager+ only; a sub-Manager receives the same not-found a nonexistent board produces. */
  pipelineAutomationRules: PipelineAutomationRuleConnection;
  /** Pipeline review requests awaiting (or past) a Manager+ decision. Manager+ only; a sub-Manager naming a board receives the same not-found a nonexistent board produces, and with no board named receives an empty connection. */
  pipelineReviewQueue: PipelineReviewRequestConnection;
  /** Aggregate contracts-overview payload for the current user's organization (Owner-only). organizationId is derived server-side from the authenticated user and cannot be provided by the client. Pass archivedOnly: true to view archived rows (SE-4349). POV active-team comes from the `x-pov-team-id` request header (SE-4927) and scopes the roster cohort in ALL/LINKED mode; contract records remain org-scoped. */
  playerContractsOverview: PlayerContractsOverview;
  /** Aggregates a player's evaluations across every report and scout in the organization: matches watched, average Performance and Potential, and a staleness flag. Averages skip unscored evaluations rather than counting them as zero, and the staleness window is server-owned so the flag means the same thing on every surface. */
  playerEvaluationAggregate: PlayerEvaluationAggregate;
  /** Ranks a filtered cohort by a raw StatsBomb metric — a per-90 (or total) provider metric (e.g. npxG/90, successful dribbles/90) or an advanced StatsBomb-360 metric (e.g. total xA, key passes, OBV) — the capability filterPlayers lacks. Resolve league/team/position/nationality IDs into the filter first; omit seasonId for the latest season with data. */
  rankPlayersByMetric: PlayerMetricRankConnection;
  /** Ranks teams by player fit (0-100), highest first. Use for 'what teams does X fit best?', 'who could I sell X to?', and similar one-player-many-teams prompts. Optional teamIds narrows to a specific batch (use this for 'how does X fit teams A, B, C?'). Optional leagueIds narrows to teams in named leagues. */
  rankTeamsByPlayerFit: Array<TeamFitResult>;
  /** Returns distinct values for scout report filter dropdowns (clubs, matches, scouts, FM24 regions visible to the requesting user) */
  scoutReportFilterOptions: ScoutReportFilterOptions;
  /** Searches players available to add to a shadow team, excluding existing members */
  searchAvailablePlayersForShadowTeam: PlayerConnection;
  /** Searches league players by name for the comparison dropdown */
  searchLeaguePlayers: LeaguePlayerSearchConnection;
  /** Searches matches by team name, competition or venue, case- and accent-insensitively, for the multi-entity search surface. */
  searchMatches: MatchConnection;
  /** Returns a paginated list of the current user's conversation threads with optional filtering */
  searchMyThreads: UserThreadConnection;
  /** Searches players by name and filter criteria within the user's organization */
  searchPlayers: PlayerConnection;
  /** Searches teams by name, case- and accent-insensitively, for the fixture picker's type-ahead. Carries no totalCount, which a type-ahead never renders and should not pay for. */
  searchTeams: TeamConnection;
  /** Lists season stat priorities for the current organization */
  seasonStatPriorities: Array<StatPriority>;
  /** Teams the authenticated user may select as the active team, per the org's teamSelectionMode. Throws TEAM_FORBIDDEN_IN_HIDDEN in HIDDEN mode; ignores `query` in LINKED mode; requires non-empty `query` in ALL mode. */
  selectableTeams: TeamConnection;
  /** Returns all supported locale codes for internationalization */
  supportedLocales: Array<Scalars['String']['output']>;
  /** Get all transfers for a specific player, ordered by date descending */
  transfersByPlayerId: Array<TransferModel>;
  /** Get transfers for multiple players in a single request */
  transfersByPlayerIds: Array<TransferModel>;
  /** Returns the count of unread activities for the current user */
  unreadActivityCount: Scalars['Int']['output'];
  /** Returns all notification preferences for the current user */
  userNotificationPreferences: Array<UserNotificationPreference>;
};


export type QueryClubObjectivesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompareOrganizationScoutReportsArgs = {
  playerNames: Array<Scalars['String']['input']>;
};


export type QueryComplianceClubCalendarArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryComplianceClubSetupArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryComplianceFinancialFiguresArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  quantity: ComplianceQuantity;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryComplianceMetricsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryComplianceOverviewArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  draftActions?: InputMaybe<Array<ScenarioActionInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEligibleShareGroupsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: ShareEntityType;
};


export type QueryFeedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<FeedEventCategory>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFilterPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: PlayerAdvancedFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
};


export type QueryGetCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContractDocumentPreviewUrlArgs = {
  playerId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
};


export type QueryGetContractExtractionArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  documentType: DocumentType;
  playerId: Scalars['ID']['input'];
};


export type QueryGetDistributionScoresArgs = {
  competitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludePlayerId?: InputMaybe<Scalars['ID']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  shadowTeamId?: InputMaybe<Scalars['ID']['input']>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetExpiringContractsCountArgs = {
  thresholdMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFormationPositionsArgs = {
  formation: ShadowTeamFormation;
};


export type QueryGetIntakeFormUrlArgs = {
  matchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  playerId: Scalars['ID']['input'];
};


export type QueryGetKanbanBoardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMatchReportArgs = {
  id: Scalars['ID']['input'];
  snapshot?: MatchReportSnapshot;
};


export type QueryGetMyOrganizationTeamByTeamIdArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationPlayerDataArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryGetPlayerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPlayerBioDataByPlayerIdArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryGetPlayerByPlayerGgidArgs = {
  playerGGID: Scalars['String']['input'];
};


export type QueryGetPlayerByTransfermarktIdArgs = {
  transfermarktId: Scalars['Int']['input'];
};


export type QueryGetPlayerContractClausesArgs = {
  documentType?: DocumentType;
  playerId: Scalars['ID']['input'];
};


export type QueryGetPlayerDataSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPlayerDataSummaryByPlayerGgidArgs = {
  playerGGID: Scalars['ID']['input'];
};


export type QueryGetPlayerDataSummaryByPlayerIdArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryGetPlayerSeasonCategoricalScoresArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryGetPlayerTeamFitArgs = {
  playerId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetScenarioArgs = {
  scenarioId: Scalars['ID']['input'];
};


export type QueryGetScenarioPitchArgs = {
  scenarioId: Scalars['ID']['input'];
};


export type QueryGetScoutReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetScoutReportEditUrlArgs = {
  scoutReportId: Scalars['ID']['input'];
};


export type QueryGetScoutReportTemplateArgs = {
  matchId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
  reportTypeId: Scalars['ID']['input'];
};


export type QueryGetSeasonMetricAveragesArgs = {
  excludePlayerId: Scalars['ID']['input'];
  positionIds: Array<Scalars['ID']['input']>;
  teamIds: Array<Scalars['ID']['input']>;
};


export type QueryGetShadowTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSquadDepthByPositionArgs = {
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSquadFinalStateArgs = {
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSquadKpIsArgs = {
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSquadPlayersByPositionArgs = {
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWatchlistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWatchlistPitchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WatchlistPitchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryInjuriesByPlayerIdArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryInjuriesByPlayerIdsArgs = {
  playerIds: Array<Scalars['ID']['input']>;
};


export type QueryKanbanCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKanbanTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListAdvancedCompetitionStatsArgs = {
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  playerId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListAllScoutingTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterByCustomStats?: InputMaybe<Array<CustomStatFilterInput>>;
  filterByLeagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByNationalityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByOrganizationRoster?: InputMaybe<Scalars['Boolean']['input']>;
  filterByPositionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByRoleArchetypes?: InputMaybe<Array<Scalars['String']['input']>>;
  filterByScoutIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByWatchlistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  maxAerials?: InputMaybe<Scalars['Float']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxAnticipating?: InputMaybe<Scalars['Float']['input']>;
  maxAssisting?: InputMaybe<Scalars['Float']['input']>;
  maxBuildup?: InputMaybe<Scalars['Float']['input']>;
  maxCarrying?: InputMaybe<Scalars['Float']['input']>;
  maxContractMonths?: InputMaybe<Scalars['Int']['input']>;
  maxCreating?: InputMaybe<Scalars['Float']['input']>;
  maxCrossing?: InputMaybe<Scalars['Float']['input']>;
  maxDefensiveAerials?: InputMaybe<Scalars['Float']['input']>;
  maxDribbling?: InputMaybe<Scalars['Float']['input']>;
  maxFinishing?: InputMaybe<Scalars['Float']['input']>;
  maxFitScore?: InputMaybe<Scalars['Float']['input']>;
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  maxGkCrossIntercept?: InputMaybe<Scalars['Float']['input']>;
  maxGkKeeperSweeper?: InputMaybe<Scalars['Float']['input']>;
  maxGkPassing?: InputMaybe<Scalars['Float']['input']>;
  maxGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  maxGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  maxGpr?: InputMaybe<Scalars['Float']['input']>;
  maxHeading?: InputMaybe<Scalars['Float']['input']>;
  maxPassing?: InputMaybe<Scalars['Float']['input']>;
  maxPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  maxPressing?: InputMaybe<Scalars['Float']['input']>;
  maxProactiveDefending?: InputMaybe<Scalars['Float']['input']>;
  maxSetPieceDelivering?: InputMaybe<Scalars['Float']['input']>;
  maxShooting?: InputMaybe<Scalars['Float']['input']>;
  maxShotPlacement?: InputMaybe<Scalars['Float']['input']>;
  maxTackling?: InputMaybe<Scalars['Float']['input']>;
  maxTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  minAerials?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  minAnticipating?: InputMaybe<Scalars['Float']['input']>;
  minAssisting?: InputMaybe<Scalars['Float']['input']>;
  minBuildup?: InputMaybe<Scalars['Float']['input']>;
  minCarrying?: InputMaybe<Scalars['Float']['input']>;
  minContractMonths?: InputMaybe<Scalars['Int']['input']>;
  minCreating?: InputMaybe<Scalars['Float']['input']>;
  minCrossing?: InputMaybe<Scalars['Float']['input']>;
  minDefensiveAerials?: InputMaybe<Scalars['Float']['input']>;
  minDribbling?: InputMaybe<Scalars['Float']['input']>;
  minFinishing?: InputMaybe<Scalars['Float']['input']>;
  minFitScore?: InputMaybe<Scalars['Float']['input']>;
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  minGkCrossIntercept?: InputMaybe<Scalars['Float']['input']>;
  minGkKeeperSweeper?: InputMaybe<Scalars['Float']['input']>;
  minGkPassing?: InputMaybe<Scalars['Float']['input']>;
  minGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  minGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  minGpr?: InputMaybe<Scalars['Float']['input']>;
  minHeading?: InputMaybe<Scalars['Float']['input']>;
  minPassing?: InputMaybe<Scalars['Float']['input']>;
  minPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  minPressing?: InputMaybe<Scalars['Float']['input']>;
  minProactiveDefending?: InputMaybe<Scalars['Float']['input']>;
  minSetPieceDelivering?: InputMaybe<Scalars['Float']['input']>;
  minShooting?: InputMaybe<Scalars['Float']['input']>;
  minShotPlacement?: InputMaybe<Scalars['Float']['input']>;
  minTackling?: InputMaybe<Scalars['Float']['input']>;
  minTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
};


export type QueryListAssignableScoutsArgs = {
  input?: InputMaybe<ListAssignableScoutsInput>;
};


export type QueryListAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssignmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListBasicCompetitionStatsArgs = {
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  playerId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListCommentsByNoteIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  noteId: Scalars['ID']['input'];
};


export type QueryListCompetitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListContractDocumentsArgs = {
  documentType?: InputMaybe<DocumentType>;
  playerId: Scalars['ID']['input'];
};


export type QueryListExpiringContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  competitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  thresholdMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListFirstTeamPlayersByGprBandArgs = {
  band: GprBand;
};


export type QueryListGameMetricsArgs = {
  gameId?: InputMaybe<Scalars['ID']['input']>;
  playerId: Scalars['ID']['input'];
};


export type QueryListGameProviderMetricsArgs = {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  gameIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  playerId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryListGroupGrantsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: ShareEntityType;
};


export type QueryListKanbanBoardPlayerMetricsArgs = {
  kanbanBoardId: Scalars['ID']['input'];
};


export type QueryListKanbanBoardTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  kanbanBoardId: Scalars['ID']['input'];
};


export type QueryListKanbanCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanBoardId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListKanbanPhasesArgs = {
  kanbanBoardId: Scalars['ID']['input'];
};


export type QueryListKanbanTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLeaguesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLeaguesBySportIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sportId: Scalars['ID']['input'];
};


export type QueryListLoansByTeamIdArgs = {
  direction?: InputMaybe<LoanDirection>;
  teamId: Scalars['ID']['input'];
};


export type QueryListMatchAppearancesArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryListMatchEventsArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryListMatchReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MatchReportFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MatchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyKanbanBoardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyOrganizationActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyOrganizationsEligibleTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListMyOrganizationsKanbanCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanBoardId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyOrganizationsLeaguesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyOrganizationsOrganizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyOrganizationsPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
};


export type QueryListMyOrganizationsSentInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InvitationStatus>;
};


export type QueryListMyOrganizationsTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyReceivedInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InvitationStatus>;
};


export type QueryListMySentInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListMyUserWatchlistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListMyUserWatchlistsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListNationalitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListNoteSharesArgs = {
  noteId: Scalars['ID']['input'];
};


export type QueryListNotesByPlayerIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['ID']['input'];
};


export type QueryListOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOthersWatchlistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListPipelineSuggestedPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanBoardId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListPlayerDisciplineSignalsArgs = {
  playerIds: Array<Scalars['ID']['input']>;
};


export type QueryListPlayerMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['ID']['input'];
};


export type QueryListPlayerRecommendationsArgs = {
  recommendationType: Scalars['String']['input'];
};


export type QueryListPlayerSeasonWeightedAvgMetricsByPlayerIdArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryListPlayersByLeagueIdsAndPositionIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leagueIds: Array<Scalars['ID']['input']>;
  positionIds: Array<Scalars['ID']['input']>;
};


export type QueryListPlayersByTeamIdsAndPositionIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  positionIds: Array<Scalars['ID']['input']>;
  teamIds: Array<Scalars['ID']['input']>;
};


export type QueryListPositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isGeneral?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListRecentTransfersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  competitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryListRecentlyInteractedPlayersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListRemovedPlayerRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListRosterContractClausesArgs = {
  clauseNameContains?: InputMaybe<Array<Scalars['String']['input']>>;
  documentTypes?: InputMaybe<Array<DocumentType>>;
};


export type QueryListScheduledThingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListScheduledThingsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListScoutReportSharesArgs = {
  scoutReportId: Scalars['ID']['input'];
};


export type QueryListSeasonProviderMetricsArgs = {
  playerId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListShadowTeamPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  shadowTeamId: Scalars['ID']['input'];
};


export type QueryListShadowTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ListShadowTeamOrderByInput>;
};


export type QueryListSimilarPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SimilarPlayerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['ID']['input'];
};


export type QueryListSportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListTargetsByPositionalProfileArgs = {
  profileName: Scalars['String']['input'];
};


export type QueryListTopScorersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListTransfersByTeamIdArgs = {
  direction?: TransferDirection;
  feeDisclosed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  season?: InputMaybe<Scalars['ID']['input']>;
  teamId: Scalars['ID']['input'];
  window?: InputMaybe<TransferWindow>;
};


export type QueryListUserWatchlistsByWatchlistIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  watchlistId: Scalars['ID']['input'];
};


export type QueryListWatchlistPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
  watchlistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryListWatchlistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchCoverageSummaryArgs = {
  input: MatchCoverageSummaryInput;
};


export type QueryOrganizationScoutReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationScoutReportsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrganizationScoutReportsSortInput>;
};


export type QueryPipelineActivityLogArgs = {
  action?: InputMaybe<Array<PipelineActivityAction>>;
  actorType?: InputMaybe<Array<PipelineActorType>>;
  actorUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanBoardId: Scalars['ID']['input'];
  kanbanCardId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipelineAutomationFiringsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  automationRuleId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanCardId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipelineAutomationRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanBoardId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipelineReviewQueueArgs = {
  addressedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kanbanBoardId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PipelineReviewStatus>;
};


export type QueryPlayerContractsOverviewArgs = {
  archivedOnly?: Scalars['Boolean']['input'];
};


export type QueryPlayerEvaluationAggregateArgs = {
  input?: InputMaybe<PlayerEvaluationAggregateInput>;
  playerId: Scalars['ID']['input'];
};


export type QueryRankPlayersByMetricArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: PlayerAdvancedFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  metricFilters?: InputMaybe<Array<ProviderMetricFilterInput>>;
  minutesFloorLadder?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortByMetric: ProviderMetricField;
  sortOrder?: InputMaybe<OrderByDirection>;
};


export type QueryRankTeamsByPlayerFitArgs = {
  first?: Scalars['Int']['input'];
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  playerId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySearchAvailablePlayersForShadowTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  shadowTeamId: Scalars['ID']['input'];
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
};


export type QuerySearchLeaguePlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QuerySearchMyThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlayerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
};


export type QuerySearchTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QuerySelectableTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransfersByPlayerIdArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryTransfersByPlayerIdsArgs = {
  playerIds: Array<Scalars['ID']['input']>;
};

/** Five categorical metric percentiles for the dashboard radar chart */
export type RadarMetrics = {
  __typename?: 'RadarMetrics';
  /** Carrying score percentile */
  carrying: Scalars['Float']['output'];
  /** Dribbling score percentile */
  dribbling: Scalars['Float']['output'];
  /** GPR percentile among league teams */
  gpr: Scalars['Float']['output'];
  /** Passing score percentile */
  passing: Scalars['Float']['output'];
  /** Shooting score percentile */
  shooting: Scalars['Float']['output'];
};

/** Player readiness level for squad planning: first-team training, bench minutes, or academy */
export enum ReadinessTag {
  Academy = 'ACADEMY',
  BenchMinutes = 'BENCH_MINUTES',
  FirstTeamTraining = 'FIRST_TEAM_TRAINING'
}

/** A player the user recently viewed, including view metadata */
export type RecentlyInteractedPlayer = {
  __typename?: 'RecentlyInteractedPlayer';
  /** Activity type code describing the entry (always PROFILE_VIEWED for recently-viewed players) */
  activityType: Scalars['String']['output'];
  /** Profile view record unique identifier */
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent view of this player */
  lastActivityAt: Scalars['DateTime']['output'];
  player?: Maybe<Player>;
};

/** Defines categories of player recommendations available in the system */
export type RecommendationType = Node & {
  __typename?: 'RecommendationType';
  /** Unique identifier for recommendation type */
  id: Scalars['ID']['output'];
  /** Human-readable label for the recommendation type (e.g., Upside Potential, Roster Upgrades) */
  label: Scalars['String']['output'];
  /** Type code for the recommendation (e.g., YOUNG_PLAYERS, UNDERPERFORMING_PLAYERS, SQUAD_DEPTH) */
  type: Scalars['String']['output'];
};

/** A fixture reconciliation with more than one candidate inside the natural-key tolerance, awaiting or carrying a human decision. Candidates are full Match records so a reviewer can distinguish them; a candidate deleted since the ambiguity was recorded is simply absent from the list. */
export type ReconciliationAmbiguity = {
  __typename?: 'ReconciliationAmbiguity';
  /** The existing fixtures that all matched the natural key, hydrated with enough context to tell apart. May be shorter than originally recorded when a candidate was legitimately deleted before review. */
  candidates: Array<Match>;
  /** What the source claimed at the moment of ambiguity — a snapshot, immune to later ingestion runs. */
  claim: ReconciliationSourceClaim;
  /** When the engine recorded the ambiguity */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the ambiguity */
  id: Scalars['ID']['output'];
  /** When it was resolved, once resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ingestion source whose fixture could not be reconciled. */
  sourceId: Scalars['String']['output'];
  /** Lifecycle state: PENDING until resolved, then MERGED or DISMISSED. */
  status: Scalars['String']['output'];
};

/** How a human resolves a fixture-reconciliation ambiguity: MERGE applies SE-7017's merge rules to one chosen candidate; KEEP_SEPARATE dismisses the ambiguity durably, leaving every record intact. */
export enum ReconciliationResolution {
  KeepSeparate = 'KEEP_SEPARATE',
  Merge = 'MERGE'
}

/** The source fixture a reconciliation ambiguity is about, snapshotted at the moment of ambiguity. Team sides render exactly as the source published them (label or provider id). */
export type ReconciliationSourceClaim = {
  __typename?: 'ReconciliationSourceClaim';
  /** The away side as the source published it: a club label, or a provider team id. */
  awayTeamRef: Scalars['String']['output'];
  /** The competition as the catalog knows it (league competition GGID). */
  competitionGGID: Scalars['String']['output'];
  /** How much of the date the source had committed to. */
  datePrecision: MatchDatePrecision;
  /** The home side as the source published it: a club label, or a provider team id. */
  homeTeamRef: Scalars['String']['output'];
  /** Civil date (YYYY-MM-DD) the source claimed — the window's first day when precision is WINDOW. */
  scheduledDate: Scalars['String']['output'];
  /** Window end (YYYY-MM-DD) when precision is WINDOW. */
  scheduledEndDate?: Maybe<Scalars['String']['output']>;
  /** The source's stable reference for the fixture. */
  sourceRef: Scalars['String']['output'];
  /** Kick-off time (HH:MM) when the source published one. */
  startTime?: Maybe<Scalars['String']['output']>;
  /** IANA time zone of startTime, when published. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Venue name when the source published one. Never guessed. */
  venue?: Maybe<Scalars['String']['output']>;
};

/** One club-entered per-player count/flag, e.g. homegrown status (value 1/0). Never an update — every entry is a new row. Requires compliance Tier 1. */
export type RecordComplianceCountInput = {
  /** Which per-player attribute this entry supplies a value for (e.g. HOMEGROWN_STATUS). */
  attribute: ComplianceFilterAttribute;
  /** The club the entry belongs to. Defaults to the caller's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The player the entry is about. */
  subjectId: Scalars['ID']['input'];
  /** The value — 1/0 for a boolean flag like homegrown status. A future consumer may enter a genuine count. */
  value: Scalars['Float']['input'];
};

/** One CFO-entered club financial figure — adjusted revenue, a PSR result, or any other Tier-1 club-scoped quantity. Never an update: every entry is a new effective-dated row. */
export type RecordComplianceFinancialFigureInput = {
  /** The date from which this figure is true of the club, YYYY-MM-DD. */
  effectiveFrom: Scalars['String']['input'];
  /** The rate such that amount = nativeAmount x fxRate. Must be 1 for a same-currency entry. Defaults to 1. */
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  /** The date the FX rate was quoted for, YYYY-MM-DD. Defaults to effectiveFrom. */
  fxRateAsOf?: InputMaybe<Scalars['String']['input']>;
  /** The figure as the CFO typed it, in nativeCurrency. */
  nativeAmount: Scalars['Float']['input'];
  /** The currency the figure was entered in. */
  nativeCurrency: CurrencyCode;
  /** The club the figure is about. Defaults to the caller's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Which club-scoped quantity this figure supplies (e.g. ADJUSTED_REVENUE, ADJUSTED_RESULT_ROLLING_THREE_YEARS for PSR). */
  quantity: ComplianceQuantity;
  /** Why the past figure was corrected. Required together with restatesId. */
  restatementNote?: InputMaybe<Scalars['String']['input']>;
  /** The figure this entry explicitly restates, for correcting a CLOSED period. Omit for an ordinary correction, which applies forward. */
  restatesId?: InputMaybe<Scalars['ID']['input']>;
};

/** The figure just written, and the figure now governing at its effective date. */
export type RecordComplianceFinancialFigureResult = {
  __typename?: 'RecordComplianceFinancialFigureResult';
  /** The figure governing at figure.effectiveFrom, or null when a later restatement or a more recent entry already supersedes it. */
  effectiveFigure?: Maybe<ComplianceFinancialFigure>;
  /** Why the past was restated, for display alongside the restatedAt marker. Null unless isRestatement. */
  effectiveRestatementNote?: Maybe<Scalars['String']['output']>;
  /** The row just written. */
  figure: ComplianceFinancialFigure;
  /** Whether effectiveFigure is itself an explicit restatement of a closed period, rather than an ordinary forward-applying entry. */
  isRestatement: Scalars['Boolean']['output'];
  /** When the restatement was recorded — the '12 Mar' of 'restated 12 Mar'. Null unless isRestatement. */
  restatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for refreshing authentication token */
export type RefreshTokenInput = {
  /** The refresh token from a previous authentication */
  refreshToken: Scalars['String']['input'];
};

/** Input type for rejecting an invitation */
export type RejectInvitationInput = {
  /** Unique identifier of the invitation to reject */
  id: Scalars['ID']['input'];
};

/** Input for removing a player from a watchlist */
export type RemovePlayerFromWatchlistInput = {
  /** The ID of the player to remove */
  playerId: Scalars['ID']['input'];
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Input for removing a batch of players from a watchlist */
export type RemovePlayersFromWatchlistInput = {
  /** Player ids to remove, at most 500 per call */
  playerIds: Array<Scalars['ID']['input']>;
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Removes the action a scenario holds for one player; idempotent, rejected with SCENARIO_REVISION_CONFLICT when the revision moved */
export type RemoveScenarioActionInput = {
  /** Revision the client read; the removal is refused with SCENARIO_REVISION_CONFLICT when it moved */
  expectedRevision: Scalars['Int']['input'];
  /** Player id as reported by getScenario (real player id, or the external row id for an unlinked external signing) */
  playerId: Scalars['ID']['input'];
  /** Scenario holding the action */
  scenarioId: Scalars['ID']['input'];
};

/** Outcome of removeScenarioAction: the scenario after the call, whether a row was removed, and what it was */
export type RemoveScenarioActionPayload = {
  __typename?: 'RemoveScenarioActionPayload';
  /** True when an action row was deleted; false when the player had no action (idempotent no-op) */
  removed: Scalars['Boolean']['output'];
  /** Type of the removed action (SIGN for an external signing); null when nothing was removed */
  removedTransitionType?: Maybe<TransitionType>;
  /** The scenario after the call; its revision advanced only when a row was removed */
  scenario: ScenarioModel;
  /** True when the removed action was an external signing (its scenario_external_player row is gone too) */
  wasExternal: Scalars['Boolean']['output'];
};

/** Input for removing a player from every placement in a shadow team (roster pool and all positions) */
export type RemoveShadowTeamPlayerFromTeamInput = {
  /** ID of the player whose placements should all be removed from the shadow team */
  playerId: Scalars['ID']['input'];
  /** ID of the shadow team to remove the player from */
  shadowTeamId: Scalars['ID']['input'];
};

/** Result of removing a player from all placements in a shadow team */
export type RemoveShadowTeamPlayerFromTeamResult = {
  __typename?: 'RemoveShadowTeamPlayerFromTeamResult';
  /** Number of shadow_team_player rows deleted (0 if the player was not in the team) */
  affectedCount: Scalars['Int']['output'];
  /** Whether the operation completed successfully */
  success: Scalars['Boolean']['output'];
};

/** Input for removing a player from a shadow team */
export type RemoveShadowTeamPlayerInput = {
  /** ID of the player to remove from the shadow team */
  playerId: Scalars['ID']['input'];
  /** ID of the shadow team to remove the player from */
  shadowTeamId: Scalars['ID']['input'];
};

/** Input for removing a single placement of a player from a shadow team by junction-row id */
export type RemoveShadowTeamPlayerPlacementInput = {
  /** ID of the shadow_team_player row to remove */
  shadowPlayerId: Scalars['ID']['input'];
};

/** Result of removing a transition from the edit state */
export type RemoveTransitionResult = {
  __typename?: 'RemoveTransitionResult';
  /** Whether the removal was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for removing a user's permission from a kanban board */
export type RemoveUserFromKanbanBoardInput = {
  /** The ID of the user kanban board permission record to remove */
  id: Scalars['ID']['input'];
};

/** Input for reopening a closed pipeline card */
export type ReopenKanbanCardInput = {
  /** The ID of the closed pipeline card */
  cardId: Scalars['ID']['input'];
  /** Optional rationale recorded with the reopen stage change; surfaced in the pipeline activity log. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** REQUIRED non-terminal stage on the SAME pipeline to reopen into. The backend never selects a default. */
  targetPhaseId: Scalars['ID']['input'];
};

/** Format of scout report - single player evaluation or multi-player evaluation */
export enum ReportFormat {
  MultiPlayer = 'MULTI_PLAYER',
  SinglePlayer = 'SINGLE_PLAYER'
}

/** Which kind of report a player-page reports-list row came from. Carried on every row so the two sources stay distinguishable after the client merges them into one list. */
export enum ReportKind {
  /** This player's evaluation within a 22-player match report, from `match_report_player_evaluation`. Every `PlayerMatchReportEvaluation` carries this. */
  Match = 'MATCH',
  /** A single-player scout report, from `scout_report`. Every `PlayerScoutReport` carries this. */
  Scout = 'SCOUT'
}

/** Source of scout report data - Form.io forms or custom submission methods */
export enum ReportSourceType {
  Custom = 'CUSTOM',
  FormIo = 'FORM_IO'
}

/** A team option for the Reports filter chip, carrying both the name the scout-report half matches on and the team ids the match-report half matches on */
export type ReportTeamOption = {
  __typename?: 'ReportTeamOption';
  /** Display name, and the value to send as `clubs` to organizationScoutReports */
  name: Scalars['String']['output'];
  /** Every team id sharing this name, to send as `teamIds` to listMatchReports. EMPTY when this name appears only in scout reports and matches no team row — in that case skip the match-report connection entirely rather than sending `teamIds: []`, which is not a filter and would return every match report. */
  teamIds: Array<Scalars['ID']['output']>;
};

/** Input type for resending an invitation SMS */
export type ResendInvitationInput = {
  /** Unique identifier of the invitation to resend */
  id: Scalars['ID']['input'];
};

/** Input for resending OTP code */
export type ResendOtpInput = {
  /** The identifier to send the OTP to (email or phone number) */
  identifier: Scalars['String']['input'];
};

/** Input for marking all conflicting line items in a category as resolved */
export type ResolveCategoryConflictsInput = {
  /** Category key within extracted data (e.g. fixedTerms, clauses) */
  category: Scalars['String']['input'];
  /** UUID of the contract extraction to update */
  extractionId: Scalars['ID']['input'];
};

/** Resolves one reconciliation ambiguity: MERGE with a chosen candidate applies SE-7017's merge rules; KEEP_SEPARATE dismisses it durably. */
export type ResolveReconciliationAmbiguityInput = {
  /** The ambiguity being resolved. */
  ambiguityId: Scalars['ID']['input'];
  /** The candidate to merge onto. Required when resolution is MERGE; must be one of the ambiguity's candidates. Ignored for KEEP_SEPARATE. */
  chosenMatchId?: InputMaybe<Scalars['ID']['input']>;
  /** The decision: MERGE onto a chosen candidate, or KEEP_SEPARATE. */
  resolution: ReconciliationResolution;
};

/** Input for restoring a soft-deleted manual player */
export type RestoreManualPlayerInput = {
  /** The ID of the soft-deleted manual player to restore */
  id: Scalars['ID']['input'];
};

/** Input for reverting a PENDING_REVIEW contract extraction to a prior snapshot (Owner-only) */
export type RevertContractExtractionInput = {
  /** UUID of the contract extraction to revert */
  extractionId: Scalars['ID']['input'];
  /** Prior extractedData snapshot (category-keyed map of line-item arrays) to overwrite the current row with */
  snapshotData: Scalars['JSONObject']['input'];
};

/** Input for revoking note sharing access */
export type RevokeNoteShareInput = {
  /** ID of the note to revoke sharing for */
  noteId: Scalars['ID']['input'];
  /** ID of the user to revoke access from */
  targetUserId: Scalars['ID']['input'];
};

/** Input for revoking scout report sharing access */
export type RevokeScoutReportShareInput = {
  /** ID of the scout report to revoke sharing for */
  scoutReportId: Scalars['ID']['input'];
  /** ID of the user to revoke access from */
  targetUserId: Scalars['ID']['input'];
};

/** Defines user roles within organizations (admin, scout, manager, etc.) with associated permissions and capabilities */
export type Role = Node & {
  __typename?: 'Role';
  /** Timestamp of role creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for role */
  id: Scalars['ID']['output'];
  /** Name of the role */
  name: RoleName;
  /** Timestamp of last role update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of roles */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** A list of edges */
  edges: Array<RoleEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a RoleConnection */
export type RoleEdge = Edge & {
  __typename?: 'RoleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Role node */
  node: Role;
};

/** Available user role types within an organization */
export enum RoleName {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

/** Roster-wide contract clause answer (SE-8720, Owner-only): one call covers the whole roster. */
export type RosterContractClauses = {
  __typename?: 'RosterContractClauses';
  /** Roster players with at least one requested document on file, i.e. whose clauses were checked. */
  checkedCount: Scalars['Int']['output'];
  /** Without clauseNameContains: every roster player. With it: players with a matching clause, plus players with no requested document on file (so they can be reported as unchecked). Checked players without a match are omitted but counted in checkedCount. */
  players: Array<RosterPlayerContractClauses>;
  /** Players in the roster cohort (the Contracts tab's active list, POV team included). */
  rosterCount: Scalars['Int']['output'];
};

/** Summary of first-team roster players whose contracts expire within 6/12 months */
export type RosterExpiringContracts = {
  __typename?: 'RosterExpiringContracts';
  /** Players whose contract expires within 6 months. Null when the viewer's tier may not see contract dates (SE-7421). */
  expiring6Months?: Maybe<Scalars['Int']['output']>;
  /** Players whose contract expires within 12 months. Null when the viewer's tier may not see contract dates (SE-7421). */
  expiring12Months?: Maybe<Scalars['Int']['output']>;
};

/** A roster player with the documents on file and their (optionally filtered) clauses (SE-8720). */
export type RosterPlayerContractClauses = {
  __typename?: 'RosterPlayerContractClauses';
  /** Clauses from the requested document types, filtered by clauseNameContains when given. Empty for a player with nothing on file. */
  clauses: Array<DocumentContractClause>;
  /** True when an active CONTRACT extraction is on file and CONTRACT was requested. */
  hasContract: Scalars['Boolean']['output'];
  /** True when an active TRANSFER_AGREEMENT extraction is on file and TRANSFER_AGREEMENT was requested. */
  hasTransferAgreement: Scalars['Boolean']['output'];
  /** Player display name. */
  name: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
};

/** Aggregate roster statistics for the dashboard team overview */
export type RosterStats = {
  __typename?: 'RosterStats';
  /** Average age of the first-team squad */
  avgAge: Scalars['Float']['output'];
  /** Average GPR of the first-team squad (top 18 by GPR) */
  avgGpr: Scalars['Float']['output'];
  /** Total number of players on the roster */
  playerCount: Scalars['Int']['output'];
  /** Sum of all roster players' market valuations (not just first-team) */
  totalMarketValue: Scalars['Float']['output'];
};

/** A single action within a scenario */
export type ScenarioActionInput = {
  /** Data for an external player being signed. Only for SIGN actions targeting players outside the system. */
  externalPlayerData?: InputMaybe<ExternalPlayerDataInput>;
  /** Financial details for the action */
  financialDetails?: InputMaybe<FinancialDetailsInput>;
  /** ID of the player. Required for Sell, Loan, Promote, and Sign of existing players. Omit for external player signs. */
  playerId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of action: SELL, LOAN_OUT, LOAN_IN, PROMOTE, or SIGN */
  transitionType: TransitionType;
};

/** A single action within a scenario with resolved player name */
export type ScenarioActionModel = {
  __typename?: 'ScenarioActionModel';
  /** External player data (only for SIGN of external players) */
  externalPlayerData?: Maybe<ScenarioExternalPlayerModel>;
  /** Financial details for the action */
  financialDetails?: Maybe<FinancialDetailsModel>;
  /** Identifier this action's subject appears under in the roster. A real player ID for identified players; for an external sign, the same id the roster reports for the injected row — its real-player link when it has one, otherwise the ScenarioExternalPlayer row id. */
  playerId?: Maybe<Scalars['ID']['output']>;
  /** Resolved display name (from player table or externalPlayerData) */
  playerName: Scalars['String']['output'];
  /** Type of action */
  transitionType: TransitionType;
};

/** Scenario with resolved actions for detail view */
export type ScenarioDetailModel = {
  __typename?: 'ScenarioDetailModel';
  /** All actions in this scenario with resolved player names */
  actions: Array<ScenarioActionModel>;
  /** True when the caller may share the scenario or flip its Financials switch (the owner). Rename and delete are the owner's too, except on a legacy no-owner scenario */
  canManageSharing: Scalars['Boolean']['output'];
  /** Timestamp of record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Owner-only Financials switch; false hides the scenario's financial payload from invitees */
  financialsVisible: Scalars['Boolean']['output'];
  /** The scenario's grants, in grant order; null unless the caller is the owner */
  grants?: Maybe<Array<UserScenario>>;
  /** The scenario's group grants, in grant order; null unless the caller is the owner */
  groupGrants?: Maybe<Array<GroupGrant>>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** True when the scenario predates ownership and nobody has claimed it */
  isLegacyNoOwner: Scalars['Boolean']['output'];
  /** The caller's role: OWNER, EDITOR or VIEWER (EDITOR on a legacy no-owner scenario) */
  myRole: ScenarioRole;
  /** Display name of the scenario */
  name: Scalars['String']['output'];
  /** FK to organization */
  organizationId: Scalars['ID']['output'];
  /** User who created or claimed the scenario; null for a legacy scenario with no owner */
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  /** Aggregate revision; send it back as expectedRevision on claimScenarioOwnership */
  revision: Scalars['Int']['output'];
  /** Timestamp of last record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** An external player added to a scenario (not in the player table) */
export type ScenarioExternalPlayerModel = {
  __typename?: 'ScenarioExternalPlayerModel';
  /** Age */
  age?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of record creation */
  createdAt: Scalars['DateTime']['output'];
  /** GPR rating */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Nationality name */
  nationalityName?: Maybe<Scalars['String']['output']>;
  /** Position abbreviations */
  positions?: Maybe<Array<Scalars['String']['output']>>;
  /** FK to scenario */
  scenarioId: Scalars['ID']['output'];
  /** Current team name */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A finance term an incoming action must carry: WAGE, SIGNING_FEE (SIGN) or LOAN_FEE (LOAN_IN) */
export enum ScenarioFinanceField {
  LoanFee = 'LOAN_FEE',
  SigningFee = 'SIGNING_FEE',
  Wage = 'WAGE'
}

/** Completeness of the scenario's incoming finance: complete, or the arrivals still lacking a term */
export type ScenarioImpactCompleteness = {
  __typename?: 'ScenarioImpactCompleteness';
  /** True when no arrival lacks a required finance term */
  complete: Scalars['Boolean']['output'];
  /** The arrivals lacking a term, in scenario order */
  notProvided: Array<ScenarioImpactNotProvided>;
  /** Number of arrivals lacking at least one term */
  notProvidedCount: Scalars['Int']['output'];
};

/** Financial and roster impact when a scenario is applied */
export type ScenarioImpactModel = {
  __typename?: 'ScenarioImpactModel';
  /** Net change in academy headcount (a promotion is -1) */
  academyDelta: Scalars['Int']['output'];
  /** Total acquisition cost of incoming players in the scenario */
  acquisitionCost: Scalars['Float']['output'];
  /** Total capital gains from player sales in the scenario */
  capitalGains: Scalars['Float']['output'];
  /** Whether every incoming action carries the finance the sums need; a Not provided value is never priced as zero */
  completeness: ScenarioImpactCompleteness;
  /** Net change in first-team headcount (arrivals and promotions +1, departures -1) */
  firstTeamDelta: Scalars['Int']['output'];
  /** Net change in total squad size: firstTeamDelta + academyDelta. A PROMOTE moves a player between tiers and contributes 0 here (SE-8342). */
  playerDelta: Scalars['Int']['output'];
  /** Net wage impact from the scenario (new wages minus departing wages) */
  wageImpact: Scalars['Float']['output'];
};

/** An incoming action (SIGN, LOAN_IN or PROMOTE) whose finance is not fully provided */
export type ScenarioImpactNotProvided = {
  __typename?: 'ScenarioImpactNotProvided';
  /** Terms that are absent, non-finite or negative */
  missing: Array<ScenarioFinanceField>;
  /** Player id as getScenario reports it (real player id, or the external row id) */
  playerId: Scalars['ID']['output'];
  /** Display name of the player */
  playerName: Scalars['String']['output'];
  /** The arrival's action type */
  transitionType: TransitionType;
};

/** A named scenario for squad planning what-if analysis */
export type ScenarioModel = {
  __typename?: 'ScenarioModel';
  /** True when the caller may share the scenario or flip its Financials switch (the owner). Rename and delete are the owner's too, except on a legacy no-owner scenario */
  canManageSharing: Scalars['Boolean']['output'];
  /** Timestamp of record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Owner-only Financials switch; false hides the scenario's financial payload from invitees */
  financialsVisible: Scalars['Boolean']['output'];
  /** The scenario's grants, in grant order; null unless the caller is the owner */
  grants?: Maybe<Array<UserScenario>>;
  /** The scenario's group grants, in grant order; null unless the caller is the owner */
  groupGrants?: Maybe<Array<GroupGrant>>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** True when the scenario predates ownership and nobody has claimed it */
  isLegacyNoOwner: Scalars['Boolean']['output'];
  /** The caller's role: OWNER, EDITOR or VIEWER (EDITOR on a legacy no-owner scenario) */
  myRole: ScenarioRole;
  /** Display name of the scenario */
  name: Scalars['String']['output'];
  /** FK to organization */
  organizationId: Scalars['ID']['output'];
  /** User who created or claimed the scenario; null for a legacy scenario with no owner */
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  /** Aggregate revision; send it back as expectedRevision on claimScenarioOwnership */
  revision: Scalars['Int']['output'];
  /** Timestamp of last record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** SE-8467: the persisted pitch state of a scenario — shared formation, CAS counter, and the saved slot and order of every occupant */
export type ScenarioPitch = {
  __typename?: 'ScenarioPitch';
  /** OWNER or EDITOR (including the legacy MANAGER+ EDITOR of a no-owner scenario); a VIEWER reads with false */
  canEdit: Scalars['Boolean']['output'];
  /** Persisted occupants in global order (rank 1..N) */
  entries: Array<ScenarioPitchEntry>;
  /** Shared formation of the scenario pitch — the same for every reader (D9) */
  formation: PitchFormation;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who last wrote the pitch — the name the conflict banner shows; null before the first write */
  lastEditedBy?: Maybe<PitchEditor>;
  myRole: ScenarioRole;
  /** false until the first pitch write; entries is then empty and the client derives every slot */
  pitchInitialized: Scalars['Boolean']['output'];
  /** CAS counter for the three pitch mutations; independent of ScenarioModel.revision */
  pitchRevision: Scalars['Int']['output'];
  scenarioId: Scalars['ID']['output'];
};

/** One persisted pitch occupant. An occupant absent from entries is CALCULATED by the client and sorts after every entry of its slot by GPR desc. */
export type ScenarioPitchEntry = {
  __typename?: 'ScenarioPitchEntry';
  /** Real player id, or the ScenarioExternalPlayer id for an unlinked external — the same id ScenarioActionModel.playerId and the roster report */
  playerId: Scalars['ID']['output'];
  /** 1-based global rank; the per-slot rank is the ordinal among entries sharing tacticalSlot */
  rank: Scalars['Int']['output'];
  /** null = explicitly unassigned; the client renders it in the Unassigned panel even if a natural slot exists */
  tacticalSlot?: Maybe<TacticalSlot>;
};

/** The caller's role on a scenario: OWNER (owner_user_id), EDITOR or VIEWER (a grant, or EDITOR on a legacy no-owner scenario) */
export enum ScenarioRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** Anything a scout can be assigned to. Matches implement this in v1; training visits, tournaments and meetings are expected to implement it later without requiring a migration. `kind` is a String rather than an enum precisely so new kinds need no schema change. */
export type ScheduledThing = {
  /** How precisely the date is known. Governs how scheduledDate and scheduledEndDate should be read, and is independent of startTime. */
  datePrecision: MatchDatePrecision;
  /** The concrete node's own identifier. For a Match this is the match's key, NOT the scheduled_thing id — joining assignments on it silently matches nothing (SE-7213). Use `scheduledThingId` as the join and filter key. */
  id: Scalars['ID']['output'];
  /** Discriminator naming what this thing is, such as MATCH. A String rather than an enum so a new kind requires no schema change; clients should treat unrecognised values as renderable via the shared fields rather than as an error. */
  kind: Scalars['String']['output'];
  /** Civil date at the venue in ISO-8601 (YYYY-MM-DD), not an instant. For WINDOW precision this is the first day of the window; for ROUND_ONLY it is the round's anchor date. */
  scheduledDate: Scalars['String']['output'];
  /** Inclusive last day of the window when datePrecision is WINDOW; null for every other precision. A two-day window is scheduledDate plus one day. */
  scheduledEndDate?: Maybe<Scalars['String']['output']>;
  /** Identifier of the scheduled_thing row this node specialises. Distinct from `id`, which is the concrete node's own key — for a Match the two are minted separately. Exposed because it is the key `listAssignments(filter: { scheduledThingIds })` matches on: joining assignments on `id` compiles, returns 200 and yields an empty list forever, which renders as 'no scouts assigned' rather than as an error. */
  scheduledThingId: Scalars['ID']['output'];
  /** Kick-off or start time as a civil time at the venue (HH:mm), or null when genuinely to be confirmed. Null MUST render as 'time TBC' — never as 00:00, which would present a fabricated kick-off as fact. */
  startTime?: Maybe<Scalars['String']['output']>;
  /** IANA timezone name for interpreting scheduledDate and startTime. Null means interpret in the organisation's locale. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Human label for kinds that need one, such as a tournament name or meeting subject. Null for matches, whose label derives from the two team names. */
  title?: Maybe<Scalars['String']['output']>;
  /** Free-text venue name, or null when unknown. Nullable by design: a manually added fixture frequently has no venue yet. */
  venue?: Maybe<Scalars['String']['output']>;
};

/** Connection type for paginated ScheduledThing results, kind-agnostic by construction. */
export type ScheduledThingConnection = Connection & {
  __typename?: 'ScheduledThingConnection';
  /** A list of edges */
  edges: Array<ScheduledThingEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for ScheduledThing connection */
export type ScheduledThingEdge = Edge & {
  __typename?: 'ScheduledThingEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The scheduled thing, as the polymorphic interface: a Match for MATCH rows, GenericScheduledThing for every other kind. */
  node: ScheduledThing;
};

/** The resulting assignability of one organisation membership. Returned for both directions, including opting a member out, when there is no picker row to describe. */
export type ScoutAssignability = {
  __typename?: 'ScoutAssignability';
  /** Whether this member is now offered in Assign scouts. Reflects the stored value after the write, not merely that the write succeeded. */
  isAssignableScout: Scalars['Boolean']['output'];
  /** The member whose assignability was set */
  userId: Scalars['ID']['output'];
};

/** A scout option for the filter dropdown */
export type ScoutOption = {
  __typename?: 'ScoutOption';
  /** Scout display name */
  name: Scalars['String']['output'];
  /** Scout user unique identifier */
  userId: Scalars['ID']['output'];
};

/** Average rating for a single metric across all scout reports for a player */
export type ScoutRatingAverage = {
  __typename?: 'ScoutRatingAverage';
  /** Mean score across all reports that include this metric */
  average: Scalars['Float']['output'];
  /** Number of reports that contributed to this average */
  count: Scalars['Int']['output'];
  /** Rating metric name (e.g. "Offensive Performance", "Defending") */
  name: Scalars['String']['output'];
};

/** Scout report submission storing both raw form data and AI-processed analysis for player evaluations */
export type ScoutReport = Node & {
  __typename?: 'ScoutReport';
  /** Timestamp when the report was archived (soft delete). Null means active. */
  archivedAt?: Maybe<Scalars['String']['output']>;
  /** Whether the current user can archive/unarchive this report */
  canArchive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user can edit this report via Form.io */
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of report creation */
  createdAt: Scalars['String']['output'];
  /** Raw scout report data in JSON format from submission form */
  data: Scalars['JSONObject']['output'];
  /** Unique identifier for scout report */
  id: Scalars['ID']['output'];
  /** Flag indicating if report has been processed by AI */
  isProcessed: Scalars['Boolean']['output'];
  /** When true, the scout report is visible to all users in the organization */
  isPublic: Scalars['Boolean']['output'];
  /** User ID of the person who last edited this report */
  lastEditedByUserId?: Maybe<Scalars['ID']['output']>;
  /** Name of the user who last edited this report */
  lastEditorName?: Maybe<Scalars['String']['output']>;
  /** Organization ID that owns this report */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Owner or creator name of the scout report */
  owner?: Maybe<Scalars['String']['output']>;
  /** Parent report ID for multi-player reports (links child reports to parent) */
  parentReportId?: Maybe<Scalars['ID']['output']>;
  /** External player ID from data provider (GGID) */
  playerGGID?: Maybe<Scalars['String']['output']>;
  /** Player ID being evaluated (for single-player reports) */
  playerId?: Maybe<Scalars['ID']['output']>;
  /** AI-processed report data with structured analysis and scores */
  processedData?: Maybe<Scalars['JSONObject']['output']>;
  /** Scout report type ID defining the report configuration */
  reportTypeId?: Maybe<Scalars['ID']['output']>;
  /** Cached translations of processed data fields, keyed by locale */
  translations?: Maybe<Scalars['JSONObject']['output']>;
  /** Timestamp of last report update */
  updatedAt: Scalars['String']['output'];
  /** User ID of the scout who submitted the report */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** A single single-select categorical attribute extracted from a scout report's processed data */
export type ScoutReportCategoricalRating = {
  __typename?: 'ScoutReportCategoricalRating';
  /** The processedData field key for this categorical attribute */
  key: Scalars['String']['output'];
  /** Human-readable display label for this categorical attribute */
  label: Scalars['String']['output'];
  /** Categorical value of the attribute (e.g. "Bom"), null when the field is missing or empty */
  value?: Maybe<Scalars['String']['output']>;
};

/** Available filter options for the scout reports table view dropdowns */
export type ScoutReportFilterOptions = {
  __typename?: 'ScoutReportFilterOptions';
  /**
   * DEPRECATED (SE-7861): prefer `teams`. Distinct club/team names from visible SCOUT reports only, so a team whose only reports are match reports never appears here. Also inherently partial: the source field is present on roughly 55% of scout reports, so this has never covered the whole list.
   * @deprecated SE-7861 — use `teams`, which also covers match reports.
   */
  clubs: Array<Scalars['String']['output']>;
  /** Distinct match names in "team vs opponent" format from visible reports */
  matchNames: Array<Scalars['String']['output']>;
  /** Distinct numeric rating keys and labels found across all reports in the organization */
  ratingKeys: Array<ScoutReportRatingDefinition>;
  /** FM24 scouting regions with at least one scout report visible to the requesting user (region = the FM24 region of the league the player was playing in when the report was written; the current league when it has no resolvable match). Send as `regions` to organizationScoutReports. */
  regions: Array<Scalars['String']['output']>;
  /** Distinct scouts from visible reports */
  scouts: Array<ScoutOption>;
  /** Teams selectable in the Reports filter, drawn from BOTH match reports and scout reports (SE-7861). Note this remains partial on the scout-report side for the reason given on `clubs` — fixing the match-report omission does not make the club facet total. */
  teams: Array<ReportTeamOption>;
};

/** A single numeric rating extracted from a scout report's processed data */
export type ScoutReportNumericRating = {
  __typename?: 'ScoutReportNumericRating';
  /** The processedData field key for this rating */
  key: Scalars['String']['output'];
  /** Human-readable display label for this rating */
  label: Scalars['String']['output'];
  /** Numeric value of the rating, null when the field is missing or non-numeric */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The number of scout reports about one player, over the same filters and visibility as the page */
export type ScoutReportPlayerCount = {
  __typename?: 'ScoutReportPlayerCount';
  /** Number of reports about this player */
  count: Scalars['Int']['output'];
  /** The player's id. Null counts reports with no player, so the counts sum to totalCount. */
  playerId?: Maybe<Scalars['ID']['output']>;
  /** The player's display name, as the report rows show it. Null only for the no-player bucket. */
  playerName?: Maybe<Scalars['String']['output']>;
};

/** Filter players by the organization's scout-report verdicts. Only reports the caller may see count, and every criterion given must hold on the same report. */
export type ScoutReportPlayerFilterInput = {
  /** true: only players with at least one scout report the caller can see. false: only players with none (combine with other filters; it cannot be mixed with the verdict criteria below). */
  hasReport?: InputMaybe<Scalars['Boolean']['input']>;
  /** The scout rated the player an Investment Player */
  investmentPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Scout positional profiles to match, case-insensitive (e.g. "Mopper", "Stopper", "#6"). Only report forms that record a positional profile can match. */
  positionalProfiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The scout rated the player a Starting XI player */
  startingXI?: InputMaybe<Scalars['Boolean']['input']>;
  /** The scout would sign the player (stored as Starting XI or Investment Player) */
  wouldSignPlayer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Definition of a numeric rating field available for a scout report type's processor */
export type ScoutReportRatingDefinition = {
  __typename?: 'ScoutReportRatingDefinition';
  /** The processedData field key for this rating */
  key: Scalars['String']['output'];
  /** Human-readable display label for this rating */
  label: Scalars['String']['output'];
};

/** Filter criterion for a numeric rating field in scout report processedData */
export type ScoutReportRatingFilterInput = {
  /** The processedData field name to filter on (e.g. "workRate", "overallScore") */
  key: Scalars['String']['input'];
  /** Maximum value (inclusive) */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value (inclusive) */
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** The number of scout reports in one FM24 scouting region, over the same filters and visibility as the page */
export type ScoutReportRegionCount = {
  __typename?: 'ScoutReportRegionCount';
  /** Number of reports in this region */
  count: Scalars['Int']['output'];
  /** FM24 scouting region of the league the player was playing in when the report was written (the report's match; the current league when it has no resolvable match), e.g. "UK & Ireland", "South America (South)". Null counts reports with no region: neither the match nor the current league gives a country inside the FM24 table. */
  region?: Maybe<Scalars['String']['output']>;
};

/** Information about a user with access to a scout report */
export type ScoutReportShare = {
  __typename?: 'ScoutReportShare';
  /** When the permission was created */
  createdAt: Scalars['DateTime']['output'];
  /** Permission role (OWNER or VIEWER) */
  role: UserScoutReportRole;
  /** User details */
  user: User;
  /** User ID */
  userId: Scalars['ID']['output'];
};

/** Pre-populated scout report template with match context, team rosters, and field schema for quick report submission */
export type ScoutReportTemplate = {
  __typename?: 'ScoutReportTemplate';
  /** Name of the away team */
  awayTeamName: Scalars['String']['output'];
  /** List of players on the away team with pre-populated data */
  awayTeamPlayers: Array<PlayerTemplate>;
  /** JSON schema defining the structure and fields for this report */
  fieldSchema: Scalars['JSONObject']['output'];
  /** Date of the match */
  gameDate: Scalars['String']['output'];
  /** Name of the home team */
  homeTeamName: Scalars['String']['output'];
  /** List of players on the home team with pre-populated data */
  homeTeamPlayers: Array<PlayerTemplate>;
  /** Unique identifier for the match being scouted */
  matchId: Scalars['ID']['output'];
  /** Scout report type configuration for this template */
  reportType: ScoutReportType;
  /** Name of the scout filling out the report */
  scoutName: Scalars['String']['output'];
};

/** Defines different types of scout reports available for each organization with configuration for data source, processing, and format */
export type ScoutReportType = Node & {
  __typename?: 'ScoutReportType';
  /** Single-select categorical column definitions for this report type (SE-4621). Empty array means the report type has not opted any categorical fields into the table. */
  categoricalRatingDefinitions: Array<ScoutReportRatingDefinition>;
  /** JSON schema defining custom fields for this report type */
  fieldSchema?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier for scout report type */
  id: Scalars['ID']['output'];
  /** URL for the intake form (for Form.io source types) */
  intakeFormUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if this report type is active and available for use */
  isActive: Scalars['Boolean']['output'];
  /** Name of the scout report type */
  name: Scalars['String']['output'];
  /** Organization ID that owns this report type */
  organizationId: Scalars['ID']['output'];
  /** Type of processor to use for parsing and processing report data. Must match a registered processor type. */
  processorType: Scalars['String']['output'];
  /** Numeric rating field definitions for this report type. Empty array means columns are discovered dynamically from report data. */
  ratingDefinitions: Array<ScoutReportRatingDefinition>;
  /** Optional curated list of numeric rating fields. When null, ratings are discovered dynamically from report data. */
  ratingFieldOverrides?: Maybe<Array<ScoutReportRatingDefinition>>;
  /** Format of the report - single player or multi-player evaluation */
  reportFormat: ReportFormat;
  /** Source of scout report data (Form.io or custom) */
  sourceType: ReportSourceType;
};

/** A scout user with their owned watchlists for grouping in the Scout Lists dropdown */
export type ScoutWithWatchlists = {
  __typename?: 'ScoutWithWatchlists';
  /** Scout's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Scout user unique identifier */
  id: Scalars['ID']['output'];
  /** Scout's job title or role */
  title?: Maybe<Scalars['String']['output']>;
  /** Watchlists owned by this scout */
  watchlists: Array<WatchlistSummaryItem>;
};

/** A player appearing in one or more watchlists, deduplicated for the All Targets view */
export type ScoutingTarget = Node & {
  __typename?: 'ScoutingTarget';
  averageRatings: Array<ScoutRatingAverage>;
  avgScoutRating?: Maybe<Scalars['Float']['output']>;
  /** Player unique identifier (same as player.id) */
  id: Scalars['ID']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedByUserId?: Maybe<Scalars['ID']['output']>;
  lastEditor?: Maybe<User>;
  player?: Maybe<Player>;
  /** Saved one-based preference rank for the single selected watchlist; null outside that scope */
  preferenceRank?: Maybe<Scalars['Int']['output']>;
  scoutRatingScaleMax?: Maybe<Scalars['Int']['output']>;
  scoutReportCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  watchlists: Array<WatchlistSummary>;
};

/** Paginated list of deduplicated scouting targets */
export type ScoutingTargetConnection = {
  __typename?: 'ScoutingTargetConnection';
  /** List of target edges */
  edges: Array<ScoutingTargetEdge>;
  /** Pagination metadata */
  pageInfo: PageInfo;
  /** Total count of targets matching the filters */
  totalCount: Scalars['Int']['output'];
};

/** Edge containing a ScoutingTarget and its cursor */
export type ScoutingTargetEdge = Edge & {
  __typename?: 'ScoutingTargetEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The ScoutingTarget node */
  node: ScoutingTarget;
};

/** A watchlist player surfaced in scouting gap detail modals */
export type ScoutingTargetPlayer = {
  __typename?: 'ScoutingTargetPlayer';
  /** Date of the last activity on this player (null if no activity ever) */
  lastActionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of the last activity (e.g. "Note created", "Player added to watchlist") */
  lastActionType?: Maybe<Scalars['String']['output']>;
  /** Player display name */
  name: Scalars['String']['output'];
  /** Player UUID */
  playerId: Scalars['ID']['output'];
  /** Primary position abbreviation */
  primaryPosition: Scalars['String']['output'];
  /** Team name the player belongs to */
  teamName: Scalars['String']['output'];
  /** Name of the watchlist this player appears in */
  watchlistName: Scalars['String']['output'];
};

/** Summary counts of scouting watchlist players and identified gaps */
export type ScoutingWidgetSummary = {
  __typename?: 'ScoutingWidgetSummary';
  /** Players on watchlist with no activity in the last 30 days (org-scoped) */
  noAction30DaysCount: Scalars['Int']['output'];
  /** Total distinct players across all watchlists accessible to the user */
  totalWatchlistPlayers: Scalars['Int']['output'];
  /** Players on watchlist with zero non-archived scout reports (org-scoped) */
  withoutReportCount: Scalars['Int']['output'];
};

/** Football season reference data exposing the season UUID and its display year for resolving season-scoped queries */
export type Season = {
  __typename?: 'Season';
  /** Display format for the season (e.g. "2024/25") */
  displayYear: Scalars['String']['output'];
  /** Ending calendar year of the season */
  endYear: Scalars['Int']['output'];
  /** Unique identifier for the season */
  id: Scalars['ID']['output'];
  /** Starting calendar year of the season */
  startYear: Scalars['Int']['output'];
};

/** Team and position categorical metric averages for a single season */
export type SeasonMetricAverages = {
  __typename?: 'SeasonMetricAverages';
  /** Average across same-position players on the team(s), excluding the viewed player */
  positionAverage?: Maybe<Scalars['Float']['output']>;
  /** Unified season key (e.g. 2023) */
  season: Scalars['Int']['output'];
  /** Average across all players on the team(s), regardless of position */
  teamAverage?: Maybe<Scalars['Float']['output']>;
};

/** Season-level team and position averages for all categorical metrics */
export type SeasonMetricAveragesResult = {
  __typename?: 'SeasonMetricAveragesResult';
  /** Aerials categorical score averages per season */
  aerials: Array<SeasonMetricAverages>;
  /** Anticipating categorical score averages per season */
  anticipating: Array<SeasonMetricAverages>;
  /** Assisting categorical score averages per season */
  assisting: Array<SeasonMetricAverages>;
  /** Buildup categorical score averages per season */
  buildup: Array<SeasonMetricAverages>;
  /** Carrying categorical score averages per season */
  carrying: Array<SeasonMetricAverages>;
  /** Creating categorical score averages per season */
  creating: Array<SeasonMetricAverages>;
  /** Crossing categorical score averages per season */
  crossing: Array<SeasonMetricAverages>;
  /** Defensive aerials categorical score averages per season */
  defensiveAerials: Array<SeasonMetricAverages>;
  /** Dribbling categorical score averages per season */
  dribbling: Array<SeasonMetricAverages>;
  /** Finishing categorical score averages per season */
  finishing: Array<SeasonMetricAverages>;
  /** Goalkeeper cross intercept categorical score averages per season */
  gkCrossIntercept: Array<SeasonMetricAverages>;
  /** Goalkeeper keeper sweeper categorical score averages per season */
  gkKeeperSweeper: Array<SeasonMetricAverages>;
  /** Goalkeeper passing categorical score averages per season */
  gkPassing: Array<SeasonMetricAverages>;
  /** Goalkeeper positioning categorical score averages per season */
  gkPositioning: Array<SeasonMetricAverages>;
  /** Goalkeeper shot stopping categorical score averages per season */
  gkShotStopping: Array<SeasonMetricAverages>;
  /** Heading categorical score averages per season */
  heading: Array<SeasonMetricAverages>;
  /** Passing categorical score averages per season */
  passing: Array<SeasonMetricAverages>;
  /** Pressing categorical score averages per season */
  pressing: Array<SeasonMetricAverages>;
  /** Proactive defending categorical score averages per season */
  proactiveDefending: Array<SeasonMetricAverages>;
  /** Set piece delivering categorical score averages per season */
  setPieceDelivering: Array<SeasonMetricAverages>;
  /** Shooting categorical score averages per season */
  shooting: Array<SeasonMetricAverages>;
  /** Shot placement categorical score averages per season */
  shotPlacement: Array<SeasonMetricAverages>;
  /** Tackling categorical score averages per season */
  tackling: Array<SeasonMetricAverages>;
};

/** Season-level provider metrics for a player, aggregated from the season_provider_metrics materialized view */
export type SeasonProviderMetrics = {
  __typename?: 'SeasonProviderMetrics';
  /** Aerial clearances per 90 minutes */
  aerialClearancesP90?: Maybe<Scalars['Float']['output']>;
  /** Aerial clearances per 90 minutes, possession adjusted */
  aerialClearancesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total aerial clearances */
  aerialClearancesTotal?: Maybe<Scalars['Float']['output']>;
  /** Aerials in forward half per 90 minutes */
  aerialFhalfP90?: Maybe<Scalars['Float']['output']>;
  /** Aerials in forward half per 90 minutes, possession adjusted */
  aerialFhalfP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total aerials in forward half */
  aerialFhalfTotal?: Maybe<Scalars['Float']['output']>;
  /** Aerials contested per 90 minutes */
  aerialsP90?: Maybe<Scalars['Float']['output']>;
  /** Total aerials contested */
  aerialsTotal?: Maybe<Scalars['Float']['output']>;
  /** Backward passes per 90 minutes */
  backwardPassesP90?: Maybe<Scalars['Float']['output']>;
  /** Backward passes per 90 minutes, possession adjusted */
  backwardPassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total backward passes */
  backwardPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Blocks per 90 minutes */
  blocksP90?: Maybe<Scalars['Float']['output']>;
  /** Blocks per 90 minutes, possession adjusted */
  blocksP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Blocks per 100 opponent possessions */
  blocksPer100OppPoss?: Maybe<Scalars['Float']['output']>;
  /** Total blocks */
  blocksTotal?: Maybe<Scalars['Float']['output']>;
  /** Carry box entries per 90 minutes */
  carryBoxEntriesP90?: Maybe<Scalars['Float']['output']>;
  /** Carry box entries per 90 minutes, possession adjusted */
  carryBoxEntriesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total carry box entries */
  carryBoxEntriesTotal?: Maybe<Scalars['Float']['output']>;
  /** Carry on-ball value gain per 90 minutes */
  carryObvGainP90?: Maybe<Scalars['Float']['output']>;
  /** Carry on-ball value gain per 90 minutes, possession adjusted */
  carryObvGainP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total carry on-ball value gain */
  carryObvGainTotal?: Maybe<Scalars['Float']['output']>;
  /** Clearances per 90 minutes */
  clearancesP90?: Maybe<Scalars['Float']['output']>;
  /** Clearances per 90 minutes, possession adjusted */
  clearancesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total clearances */
  clearancesTotal?: Maybe<Scalars['Float']['output']>;
  /** Corner expected assists per 90 minutes */
  cornerXaP90?: Maybe<Scalars['Float']['output']>;
  /** Corner expected assists per 90 minutes, possession adjusted */
  cornerXaP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total corner expected assists */
  cornerXaTotal?: Maybe<Scalars['Float']['output']>;
  /** Cross expected assists per 90 minutes */
  crossXaP90?: Maybe<Scalars['Float']['output']>;
  /** Cross expected assists per 90 minutes, possession adjusted */
  crossXaP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total cross expected assists */
  crossXaTotal?: Maybe<Scalars['Float']['output']>;
  /** Crosses per 90 minutes */
  crossesP90?: Maybe<Scalars['Float']['output']>;
  /** Crosses per 90 minutes, possession adjusted */
  crossesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total crosses */
  crossesTotal?: Maybe<Scalars['Float']['output']>;
  /** Difference between actual non-penalty goals and npxG per 90 minutes */
  diffActualNpGoalsAndNpXgP90?: Maybe<Scalars['Float']['output']>;
  /** Difference between actual non-penalty goals and npxG per 90 minutes, possession adjusted */
  diffActualNpGoalsAndNpXgP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total difference between actual non-penalty goals and npxG */
  diffActualNpGoalsAndNpXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Dribble on-ball value gain per 90 minutes */
  dribbleObvGainP90?: Maybe<Scalars['Float']['output']>;
  /** Dribble on-ball value gain per 90 minutes, possession adjusted */
  dribbleObvGainP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total dribble on-ball value gain */
  dribbleObvGainTotal?: Maybe<Scalars['Float']['output']>;
  /** Times dribbled past per 90 minutes */
  dribbledPastP90?: Maybe<Scalars['Float']['output']>;
  /** Times dribbled past per 90 minutes, possession adjusted */
  dribbledPastP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total times dribbled past */
  dribbledPastTotal?: Maybe<Scalars['Float']['output']>;
  /** Dribbles faced per 90 minutes */
  dribblesFacedP90?: Maybe<Scalars['Float']['output']>;
  /** Dribbles faced per 90 minutes, possession adjusted */
  dribblesFacedP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total dribbles faced */
  dribblesFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Dribbles tackled per 90 minutes */
  dribblesTackledP90?: Maybe<Scalars['Float']['output']>;
  /** Dribbles tackled per 90 minutes, possession adjusted */
  dribblesTackledP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total dribbles tackled */
  dribblesTackledTotal?: Maybe<Scalars['Float']['output']>;
  /** Duels per 90 minutes */
  duelsP90?: Maybe<Scalars['Float']['output']>;
  /** Total duels */
  duelsTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper clears attempted per 90 minutes */
  gkClearsAttemptedP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper clears attempted */
  gkClearsAttemptedTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper clears per 90 minutes */
  gkClearsP90?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper clears ratio */
  gkClearsRatio?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper clears */
  gkClearsTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper collected per 90 minutes */
  gkCollectedP90?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper collected ratio */
  gkCollectedRatio?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper collected */
  gkCollectedTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper collects attempted per 90 minutes */
  gkCollectsAttemptedP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper collects attempted */
  gkCollectsAttemptedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper goals conceded */
  gkGoalsConcededTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper non-shot saves per 90 minutes */
  gkNonShotSavesP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper non-shot saves */
  gkNonShotSavesTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper penalties faced per 90 minutes */
  gkPenaltiesFacedP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper penalties faced */
  gkPenaltiesFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper penalties saved per 90 minutes */
  gkPenaltiesSavedP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper penalties saved */
  gkPenaltiesSavedTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper penalty save ratio */
  gkPenaltySaveRatio?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper prevented xG ratio */
  gkPreventedXgRatio?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper post-shot xG faced */
  gkPsXgFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper save difficulty xG per 90 minutes */
  gkSaveDifficultyXgP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper save difficulty xG */
  gkSaveDifficultyXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shot saving ratio */
  gkShotSavingRatio?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper shots faced */
  gkShotsFacedTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shots on target faced per 90 minutes */
  gkShotsOnTargetP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper shots on target faced */
  gkShotsOnTargetTotal?: Maybe<Scalars['Float']['output']>;
  /** Goalkeeper shots saved per 90 minutes */
  gkShotsSavedP90?: Maybe<Scalars['Float']['output']>;
  /** Total goalkeeper shots saved */
  gkShotsSavedTotal?: Maybe<Scalars['Float']['output']>;
  /** Header goals per 90 minutes */
  headerGoalsP90?: Maybe<Scalars['Float']['output']>;
  /** Header goals per 90 minutes, possession adjusted */
  headerGoalsP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total header goals */
  headerGoalsTotal?: Maybe<Scalars['Float']['output']>;
  /** Header expected goals per 90 minutes */
  headerXgP90?: Maybe<Scalars['Float']['output']>;
  /** Header expected goals per 90 minutes, possession adjusted */
  headerXgP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total header expected goals */
  headerXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Header xG uplift per 90 minutes */
  headerXgUpliftP90?: Maybe<Scalars['Float']['output']>;
  /** Header xG uplift per 90 minutes, possession adjusted */
  headerXgUpliftP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total header xG uplift */
  headerXgUpliftTotal?: Maybe<Scalars['Float']['output']>;
  /** Headers per 90 minutes */
  headersP90?: Maybe<Scalars['Float']['output']>;
  /** Headers per 90 minutes, possession adjusted */
  headersP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total headers */
  headersTotal?: Maybe<Scalars['Float']['output']>;
  /** Inswing deliveries per 90 minutes */
  inswingP90?: Maybe<Scalars['Float']['output']>;
  /** Inswing deliveries per 90 minutes, possession adjusted */
  inswingP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Successful inswing deliveries per 90 minutes */
  inswingSuccessP90?: Maybe<Scalars['Float']['output']>;
  /** Successful inswing deliveries per 90 minutes, possession adjusted */
  inswingSuccessP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total successful inswing deliveries */
  inswingSuccessTotal?: Maybe<Scalars['Float']['output']>;
  /** Total inswing deliveries */
  inswingTotal?: Maybe<Scalars['Float']['output']>;
  /** Interceptions per 90 minutes */
  interceptionsP90?: Maybe<Scalars['Float']['output']>;
  /** Interceptions per 90 minutes, possession adjusted */
  interceptionsP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total interceptions */
  interceptionsTotal?: Maybe<Scalars['Float']['output']>;
  /** Passes into final third per 90 minutes */
  intoF3PassesP90?: Maybe<Scalars['Float']['output']>;
  /** Passes into final third per 90 minutes, possession adjusted */
  intoF3PassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total passes into final third */
  intoF3PassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Left foot passes per 90 minutes */
  leftFootPassesP90?: Maybe<Scalars['Float']['output']>;
  /** Left foot passes per 90 minutes, possession adjusted */
  leftFootPassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total left foot passes */
  leftFootPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Left foot shots per 90 minutes */
  leftFootShotsP90?: Maybe<Scalars['Float']['output']>;
  /** Left foot shots per 90 minutes, possession adjusted */
  leftFootShotsP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total left foot shots */
  leftFootShotsTotal?: Maybe<Scalars['Float']['output']>;
  /** Minutes out of position */
  minutesOop?: Maybe<Scalars['Float']['output']>;
  /** Minutes position */
  minutesPos?: Maybe<Scalars['Float']['output']>;
  /** Total minutes played */
  minutesTotal?: Maybe<Scalars['Float']['output']>;
  /** Non-penalty expected goals per 90 minutes */
  npXgP90?: Maybe<Scalars['Float']['output']>;
  /** Non-penalty expected goals per 90 minutes, possession adjusted */
  npXgP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total non-penalty expected goals */
  npXgTotal?: Maybe<Scalars['Float']['output']>;
  /** Net on-ball value for team per 90 minutes */
  obvForNetP90?: Maybe<Scalars['Float']['output']>;
  /** Net on-ball value for team per 90 minutes, possession adjusted */
  obvForNetP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total net on-ball value for team */
  obvForNetTotal?: Maybe<Scalars['Float']['output']>;
  /** Net on-ball value per 90 minutes */
  obvTotalNetP90?: Maybe<Scalars['Float']['output']>;
  /** Net on-ball value per 90 minutes, possession adjusted */
  obvTotalNetP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total net on-ball value */
  obvTotalNetTotal?: Maybe<Scalars['Float']['output']>;
  /** Organization identifier */
  organizationId: Scalars['ID']['output'];
  /** Outswing deliveries per 90 minutes */
  outswingP90?: Maybe<Scalars['Float']['output']>;
  /** Outswing deliveries per 90 minutes, possession adjusted */
  outswingP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Successful outswing deliveries per 90 minutes */
  outswingSuccessP90?: Maybe<Scalars['Float']['output']>;
  /** Successful outswing deliveries per 90 minutes, possession adjusted */
  outswingSuccessP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total successful outswing deliveries */
  outswingSuccessTotal?: Maybe<Scalars['Float']['output']>;
  /** Total outswing deliveries */
  outswingTotal?: Maybe<Scalars['Float']['output']>;
  /** Pass expected value difference per 90 minutes */
  passXpDiffP90?: Maybe<Scalars['Float']['output']>;
  /** Pass expected value difference per 90 minutes, possession adjusted */
  passXpDiffP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total pass expected value difference */
  passXpDiffTotal?: Maybe<Scalars['Float']['output']>;
  /** Passes into the box per 90 minutes */
  passesIntoBoxP90?: Maybe<Scalars['Float']['output']>;
  /** Passes into the box per 90 minutes, possession adjusted */
  passesIntoBoxP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total passes into the box */
  passesIntoBoxTotal?: Maybe<Scalars['Float']['output']>;
  /** Passes per 90 minutes */
  passesP90?: Maybe<Scalars['Float']['output']>;
  /** Passes per 90 minutes, possession adjusted */
  passesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total passes attempted */
  passesTotal?: Maybe<Scalars['Float']['output']>;
  /** Penalty goals per 90 minutes */
  penaltyGoalsP90?: Maybe<Scalars['Float']['output']>;
  /** Penalty goals per 90 minutes, possession adjusted */
  penaltyGoalsP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total penalty goals */
  penaltyGoalsTotal?: Maybe<Scalars['Float']['output']>;
  /** Player identifier */
  playerId: Scalars['ID']['output'];
  /** Pressure regains per 90 minutes */
  pressureRegainsP90?: Maybe<Scalars['Float']['output']>;
  /** Pressure regains per 90 minutes, possession adjusted */
  pressureRegainsP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total pressure regains */
  pressureRegainsTotal?: Maybe<Scalars['Float']['output']>;
  /** Pressures per 90 minutes */
  pressuresP90?: Maybe<Scalars['Float']['output']>;
  /** Pressures per 90 minutes, possession adjusted */
  pressuresP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total pressures applied */
  pressuresTotal?: Maybe<Scalars['Float']['output']>;
  /** Progressive carries per 90 minutes */
  progressiveCarriesP90?: Maybe<Scalars['Float']['output']>;
  /** Progressive carries per 90 minutes, possession adjusted */
  progressiveCarriesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total progressive carries */
  progressiveCarriesTotal?: Maybe<Scalars['Float']['output']>;
  /** Progressive passes per 90 minutes */
  progressivePassesP90?: Maybe<Scalars['Float']['output']>;
  /** Progressive passes per 90 minutes, possession adjusted */
  progressivePassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total progressive passes */
  progressivePassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Right foot passes per 90 minutes */
  rightFootPassesP90?: Maybe<Scalars['Float']['output']>;
  /** Right foot passes per 90 minutes, possession adjusted */
  rightFootPassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total right foot passes */
  rightFootPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Right foot shots per 90 minutes */
  rightFootShotsP90?: Maybe<Scalars['Float']['output']>;
  /** Right foot shots per 90 minutes, possession adjusted */
  rightFootShotsP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total right foot shots */
  rightFootShotsTotal?: Maybe<Scalars['Float']['output']>;
  /** Save blocks per 90 minutes */
  saveBlocksP90?: Maybe<Scalars['Float']['output']>;
  /** Save blocks per 90 minutes, possession adjusted */
  saveBlocksP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Save blocks per 100 opponent possessions */
  saveBlocksPer100OppPoss?: Maybe<Scalars['Float']['output']>;
  /** Total save blocks */
  saveBlocksTotal?: Maybe<Scalars['Float']['output']>;
  /** Season identifier */
  seasonId: Scalars['ID']['output'];
  /** Successful aerials in forward half per 90 minutes */
  successfulAerialsFhalfP90?: Maybe<Scalars['Float']['output']>;
  /** Successful aerials in forward half per 90 minutes, possession adjusted */
  successfulAerialsFhalfP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total successful aerials in forward half */
  successfulAerialsFhalfTotal?: Maybe<Scalars['Float']['output']>;
  /** Successful aerials per 90 minutes */
  successfulAerialsP90?: Maybe<Scalars['Float']['output']>;
  /** Total successful aerials */
  successfulAerialsTotal?: Maybe<Scalars['Float']['output']>;
  /** Successful dribbles per 90 minutes */
  successfulDribblesP90?: Maybe<Scalars['Float']['output']>;
  /** Successful dribbles per 90 minutes, possession adjusted */
  successfulDribblesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total successful dribbles */
  successfulDribblesTotal?: Maybe<Scalars['Float']['output']>;
  /** Successful passes per 90 minutes */
  successfulPassesP90?: Maybe<Scalars['Float']['output']>;
  /** Successful passes per 90 minutes, possession adjusted */
  successfulPassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total successful passes */
  successfulPassesTotal?: Maybe<Scalars['Float']['output']>;
  /** Successful tackles per 90 minutes */
  successfulTacklesP90?: Maybe<Scalars['Float']['output']>;
  /** Successful tackles per 90 minutes, possession adjusted */
  successfulTacklesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total successful tackles */
  successfulTacklesTotal?: Maybe<Scalars['Float']['output']>;
  /** Tackles per 90 minutes */
  tacklesP90?: Maybe<Scalars['Float']['output']>;
  /** Tackles per 90 minutes, possession adjusted */
  tacklesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total tackles */
  tacklesTotal?: Maybe<Scalars['Float']['output']>;
  /** Passes to final third per 90 minutes */
  toF3PassesP90?: Maybe<Scalars['Float']['output']>;
  /** Passes to final third per 90 minutes, possession adjusted */
  toF3PassesP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total passes to final third */
  toF3PassesTotal?: Maybe<Scalars['Float']['output']>;
  /** xG uplift per 90 minutes */
  xgUpliftP90?: Maybe<Scalars['Float']['output']>;
  /** xG uplift per 90 minutes, possession adjusted */
  xgUpliftP90Padj?: Maybe<Scalars['Float']['output']>;
  /** Total xG uplift */
  xgUpliftTotal?: Maybe<Scalars['Float']['output']>;
};

/** Input for sending a push notification to user devices */
export type SendMyDevicesAPushNotificationInput = {
  /** Notification body content */
  body: Scalars['String']['input'];
  /** Notification title */
  title: Scalars['String']['input'];
};

/** A club's compliance calendar. Both months are required — a calendar is set as a whole, never half-set, because a missing boundary would have to be guessed. */
export type SetComplianceClubCalendarInput = {
  /** Month (1-12) the club's REPORTING (fiscal) year starts. Deliberately has no default: guessing a fiscal year silently assesses SCR over the wrong twelve months. */
  fiscalYearStartMonth: Scalars['Int']['input'];
  /** The club to configure. Defaults to the caller's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Month (1-12) the club's SEASON starts. Deliberately has no default, and deliberately not assumed to equal the fiscal year start. */
  seasonStartMonth: Scalars['Int']['input'];
};

/** The league — i.e. the division — a club plays in. Stated by a Tier 1 user; never inferred from the nightly player-derived primaryLeagueId, which is not a division boundary. */
export type SetComplianceClubDomesticLeagueInput = {
  /** The league the club plays in. Divisions are separate league rows — the Championship league and the League One league are different leagues, not one league with a tier — so naming the league names the division. */
  domesticLeagueId: Scalars['ID']['input'];
  /** The club to configure. Defaults to the caller's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Whether a club is in its first season after relegation — the EFL SCMP status that selects the 65% relevant percentage instead of the 50% standard (Part 2 Rule 2.2). Stated by a Tier 1 user and never derived: the status selects the PERMISSIVE variant, so granting it wrongly hands a club headroom it is not entitled to. Withdrawing the assertion is a separate mutation. */
export type SetComplianceClubFirstSeasonAfterRelegationInput = {
  /** true: the club IS in its first season after relegation (65% relevant percentage). false: a positive assertion that it is NOT (50% standard). Not nullable — to return the club to 'nobody has answered', which withholds BOTH rules, use clearComplianceClubFirstSeasonAfterRelegation. */
  firstSeasonAfterRelegation: Scalars['Boolean']['input'];
  /** The club to configure. Defaults to the caller's own organization. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for setting or updating a tag's color on a specific board */
export type SetKanbanBoardTagColorInput = {
  /** Hex color code (e.g., #3B82F6). Set to null to use default color. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** The kanban board ID */
  kanbanBoardId: Scalars['ID']['input'];
  /** The tag ID to set color for */
  kanbanTagId: Scalars['ID']['input'];
};

/** Input for recording or correcting a player's minutes in a match. Upserts on (match, player), so re-sending the same player corrects the existing record rather than adding a second one. */
export type SetMatchAppearanceInput = {
  /** The match the player appeared in */
  matchId: Scalars['ID']['input'];
  /** Minutes on the pitch. Omit or send null when the player featured but the duration is not yet known — this is not zero. */
  minutesPlayed?: InputMaybe<Scalars['Int']['input']>;
  /** The player who appeared */
  playerId: Scalars['ID']['input'];
  /** The side the player appeared for */
  teamId: Scalars['ID']['input'];
};

/** Replaces the entire set of scouts assigned to a match. Replace-set semantics match the popover's Done gesture and avoid the lost updates an add/remove pair would produce with concurrent editors. An empty list clears coverage. */
export type SetMatchAssignmentsInput = {
  /** The complete set of scouts who should be assigned after this call. Scouts present now and absent here are unassigned; an empty list clears all coverage and flags the fixture unassigned. */
  assigneeUserIds: Array<Scalars['ID']['input']>;
  /** Identifier of the match whose assignments are being replaced */
  matchId: Scalars['ID']['input'];
};

/** Replaces a report's covered squad and teams in one call. Replace-set semantics make undo authoritative rather than an optimistic local reversal. Removing a player deletes that player's evaluation including any note — and if that player was already noted, the mutation refuses and names them unless discardEvaluationsOfOmittedPlayers is set. */
export type SetMatchReportSquadInput = {
  /** Set true to permit discarding the recorded evaluations — notes included — of players omitted from `players`. Required only when an omitted player has already been NOTED: without it the mutation refuses and names those players, because the deletion is unrecoverable (the evaluation table has no soft-delete and no audit column) and the undo story depends on the client having held the previous state. Omitting an untouched squad row needs no flag, so the opt-in stays meaningful rather than becoming something callers set by habit. It does NOT permit editing a submitted report. */
  discardEvaluationsOfOmittedPlayers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of the report whose squad is being replaced */
  matchReportId: Scalars['ID']['input'];
  /** The complete set of players who should have evaluations on this report afterwards, each optionally carrying the side they are evaluated on. Players present now and absent here have their evaluations deleted, notes included. An empty list clears the squad. */
  players: Array<MatchReportSquadPlayerInput>;
  /** Teams covered and their squad sizes, replaced wholesale when supplied. Omit to leave the existing teams untouched. */
  reportTeams?: InputMaybe<Array<MatchReportTeamInput>>;
};

/** Input for pausing or resuming a rule. Pausing is `isEnabled = false`; it is re-read live inside every firing transaction. */
export type SetPipelineAutomationRuleEnabledInput = {
  /** The rule to pause or resume */
  automationRuleId: Scalars['ID']['input'];
  /** False pauses the rule; true resumes it. */
  isEnabled: Scalars['Boolean']['input'];
};

/** Input for setting a player's academy status */
export type SetPlayerAcademyStatusInput = {
  /** Whether the player is an academy player */
  isAcademy: Scalars['Boolean']['input'];
  /** The ID of the player to update */
  playerId: Scalars['ID']['input'];
};

/** Turns the scenario's Financials switch on or off; owner only, refused with SCENARIO_REVISION_CONFLICT when the revision moved */
export type SetScenarioFinancialsVisibilityInput = {
  /** Revision the client read; the write is refused with SCENARIO_REVISION_CONFLICT when it moved */
  expectedRevision: Scalars['Int']['input'];
  /** Scenario whose switch changes */
  scenarioId: Scalars['ID']['input'];
  /** True shows the scenario's financial payload to invitees */
  visible: Scalars['Boolean']['input'];
};

/** Replaces the complete set of scouts assigned to a scheduled thing of any kind. Same replace-set semantics as setMatchAssignments; an empty list unassigns everyone. */
export type SetScheduledThingAssignmentsInput = {
  /** The full set of scouts that should hold assignments afterwards. Omit or send empty to unassign everyone. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The scheduled thing being covered. */
  scheduledThingId: Scalars['ID']['input'];
};

/** Input for setting whether an organisation member can be assigned to fixtures. The desired value is explicit rather than a toggle, so a retried mutation is idempotent instead of flipping the member back. */
export type SetScoutAssignableInput = {
  /** True to offer this member in Assign scouts, false to stop offering them. Setting false removes nobody's access — it is not a permission. */
  isAssignableScout: Scalars['Boolean']['input'];
  /** The member whose assignability is being set */
  userId: Scalars['ID']['input'];
};

/** User-created fantasy or target team lineups, allowing users to build and manage ideal team formations */
export type ShadowTeam = Node & {
  __typename?: 'ShadowTeam';
  assignedPlayers: Array<ShadowTeamPlayer>;
  /** Average team GPR (Goals Per Ratio) across all players */
  avgTeamGPR: Scalars['Float']['output'];
  /** Timestamp of shadow team creation */
  createdAt: Scalars['DateTime']['output'];
  /** Team formation type (e.g., F_442, F_433) */
  formation?: Maybe<ShadowTeamFormation>;
  /** Unique identifier for the shadow team */
  id: Scalars['ID']['output'];
  /** Name of the shadow team */
  name: Scalars['String']['output'];
  players: Array<ShadowTeamPlayer>;
  /** Timestamp of last shadow team update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Connection type for paginated ShadowTeam results */
export type ShadowTeamConnection = Connection & {
  __typename?: 'ShadowTeamConnection';
  /** A list of edges */
  edges: Array<ShadowTeamEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for ShadowTeam connection */
export type ShadowTeamEdge = Edge & {
  __typename?: 'ShadowTeamEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The ShadowTeam node */
  node: ShadowTeam;
};

/** Team formation types for shadow teams, using notation like F_442 for 4-4-2 formation */
export enum ShadowTeamFormation {
  F_334 = 'F_334',
  F_343 = 'F_343',
  F_352 = 'F_352',
  F_361 = 'F_361',
  F_424 = 'F_424',
  F_433 = 'F_433',
  F_442 = 'F_442',
  F_451 = 'F_451',
  F_532 = 'F_532',
  F_541 = 'F_541',
  F_3241 = 'F_3241',
  F_3313 = 'F_3313',
  F_3331 = 'F_3331',
  F_3412 = 'F_3412',
  F_4123 = 'F_4123',
  F_4132 = 'F_4132',
  F_4213 = 'F_4213',
  F_4222 = 'F_4222',
  F_4231 = 'F_4231',
  F_4312 = 'F_4312',
  F_4321 = 'F_4321',
  F_4411 = 'F_4411',
  F_5221 = 'F_5221',
  F_41212 = 'F_41212'
}

/** Junction table linking players to shadow teams with specific positions and ordering within formations */
export type ShadowTeamPlayer = Node & {
  __typename?: 'ShadowTeamPlayer';
  /** Timestamp of link creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the shadow team player link */
  id: Scalars['ID']['output'];
  /** Flag indicating if player was manually added by user */
  isManualAdding: Scalars['Boolean']['output'];
  /** Display order for player within the position */
  order?: Maybe<Scalars['Int']['output']>;
  /** The player associated with this shadow team player link */
  player?: Maybe<Player>;
  /** Foreign key to the player */
  playerId: Scalars['ID']['output'];
  /** Player position in formation (0-10, GK=0; NULL means roster pool) */
  position?: Maybe<Scalars['Int']['output']>;
  /** Foreign key to the shadow team */
  shadowTeamId: Scalars['ID']['output'];
  /** Timestamp of last link update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Connection type for paginated ShadowTeamPlayer results */
export type ShadowTeamPlayerConnection = Connection & {
  __typename?: 'ShadowTeamPlayerConnection';
  /** A list of edges */
  edges: Array<ShadowTeamPlayerEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for ShadowTeamPlayer connection */
export type ShadowTeamPlayerEdge = Edge & {
  __typename?: 'ShadowTeamPlayerEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The ShadowTeamPlayer node */
  node: ShadowTeamPlayer;
};

/** Input for specifying a shadow team player's position and order */
export type ShadowTeamPlayerPositionInput = {
  /** Display order within the position */
  order: Scalars['Int']['input'];
  /** Position in the formation (0-10, GK=0) */
  position: Scalars['Int']['input'];
  /** ID of the shadow team player to update */
  shadowPlayerId: Scalars['ID']['input'];
};

/** The aggregates a group can be invited to */
export enum ShareEntityType {
  Scenario = 'SCENARIO',
  Watchlist = 'WATCHLIST'
}

/** A group an owner can invite: its key, display label and the ACTIVE audience it reaches */
export type ShareGroup = {
  __typename?: 'ShareGroup';
  /** EVERYONE in v1 */
  key: ShareGroupKey;
  /** "Everyone at <organization name>" */
  label: Scalars['String']['output'];
  /** ACTIVE members reached (scenario: ACTIVE non-MEMBER) */
  memberCount: Scalars['Int']['output'];
};

/** v1: one group; role-based keys are later values */
export enum ShareGroupKey {
  Everyone = 'EVERYONE'
}

/** Input for sharing a note with another user */
export type ShareNoteInput = {
  /** ID of the note to share */
  noteId: Scalars['ID']['input'];
  /** ID of the user to share with */
  targetUserId: Scalars['ID']['input'];
};

/** Input for sharing a scout report with another user */
export type ShareScoutReportInput = {
  /** ID of the scout report to share */
  scoutReportId: Scalars['ID']['input'];
  /** ID of the user to share with */
  targetUserId: Scalars['ID']['input'];
};

/** Input for initiating sign-in process */
export type SignInInput = {
  /** The identifier used to sign in (email or phone number) */
  identifier: Scalars['String']['input'];
};

/** Result of sign-in initiation */
export type SignInResult = {
  __typename?: 'SignInResult';
  /** Challenge data requiring user response */
  data: ChallengeResult;
  /** Status message about the sign-in process */
  message: Scalars['String']['output'];
};

/** Input for signing out of the current device */
export type SignOutInput = {
  /** The refresh token for the current device's session, used to revoke only this device */
  refreshToken: Scalars['String']['input'];
};

/** A connection to a list of similar player results */
export type SimilarPlayerConnection = {
  __typename?: 'SimilarPlayerConnection';
  /** A list of edges */
  edges: Array<SimilarPlayerEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a SimilarPlayerConnection */
export type SimilarPlayerEdge = Edge & {
  __typename?: 'SimilarPlayerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The SimilarPlayerResult node */
  node: SimilarPlayerResult;
};

/** Filtering, sorting, and range options for the similar players query */
export type SimilarPlayerFilterInput = {
  leagueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum Gemini Player Valuation (GPV) midpoint. Players without a GPV are excluded when set. */
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  maxMinutesPlayed?: InputMaybe<Scalars['Float']['input']>;
  maxMonthsRemaining?: InputMaybe<Scalars['Float']['input']>;
  maxValuation?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum Gemini Player Valuation (GPV) midpoint. Players without a GPV are excluded when set. */
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  minMinutesPlayed?: InputMaybe<Scalars['Float']['input']>;
  minMonthsRemaining?: InputMaybe<Scalars['Float']['input']>;
  minValuation?: InputMaybe<Scalars['Float']['input']>;
  nationalityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Field to sort by (default: similarityScore) */
  sortBy?: InputMaybe<SimilarPlayerSortField>;
  /** Sort direction (default: DESC) */
  sortOrder?: InputMaybe<SortOrder>;
};

/** Represents a player similar to a reference player with similarity score */
export type SimilarPlayerResult = Node & {
  __typename?: 'SimilarPlayerResult';
  /** Unique identifier for similar player result */
  id: Scalars['ID']['output'];
  /** The player entity for this similar player result */
  player?: Maybe<Player>;
  /** Similarity score between players (0.0 to 1.0) */
  similarityScore?: Maybe<Scalars['Float']['output']>;
};

/** Sort fields available for similar player queries */
export enum SimilarPlayerSortField {
  Carrying = 'carrying',
  Dribbling = 'dribbling',
  FitScore = 'fitScore',
  GeminiPlayerValuation = 'geminiPlayerValuation',
  GkPassing = 'gkPassing',
  GkPositioning = 'gkPositioning',
  GkShotStopping = 'gkShotStopping',
  Gpm = 'gpm',
  Gpr = 'gpr',
  MonthsRemaining = 'monthsRemaining',
  Passing = 'passing',
  PlayerValuation = 'playerValuation',
  Shooting = 'shooting',
  SimilarityScore = 'similarityScore',
  TeamStyleFit = 'teamStyleFit'
}

/** Sort direction for paginated query results */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Available fields for sorting player data */
export enum SortField {
  Aerials = 'AERIALS',
  Anticipating = 'ANTICIPATING',
  Assisting = 'ASSISTING',
  Buildup = 'BUILDUP',
  Carrying = 'CARRYING',
  Creating = 'CREATING',
  Crossing = 'CROSSING',
  CustomStat = 'CUSTOM_STAT',
  DefensiveAerials = 'DEFENSIVE_AERIALS',
  Dribbling = 'DRIBBLING',
  Finishing = 'FINISHING',
  FitScore = 'FIT_SCORE',
  GeminiPlayerValuation = 'GEMINI_PLAYER_VALUATION',
  GkCrossIntercept = 'GK_CROSS_INTERCEPT',
  GkKeeperSweeper = 'GK_KEEPER_SWEEPER',
  GkPassing = 'GK_PASSING',
  GkPositioning = 'GK_POSITIONING',
  GkShotStopping = 'GK_SHOT_STOPPING',
  Gpm = 'GPM',
  Gpr = 'GPR',
  Heading = 'HEADING',
  MonthsRemaining = 'MONTHS_REMAINING',
  Passing = 'PASSING',
  PipelineStage = 'PIPELINE_STAGE',
  PlayerValuation = 'PLAYER_VALUATION',
  Pressing = 'PRESSING',
  ProactiveDefending = 'PROACTIVE_DEFENDING',
  ScoutRating = 'SCOUT_RATING',
  SetPieceDelivering = 'SET_PIECE_DELIVERING',
  Shooting = 'SHOOTING',
  ShotPlacement = 'SHOT_PLACEMENT',
  Tackling = 'TACKLING',
  TeamStyleFit = 'TEAM_STYLE_FIT'
}

/** Sort direction for ordering query results */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Athletic competition category used to classify leagues, teams, and players */
export type Sport = Node & {
  __typename?: 'Sport';
  /** Timestamp of sport record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the sport */
  id: Scalars['ID']['output'];
  /** Name of the sport */
  name: Scalars['String']['output'];
  /** Timestamp of last sport record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of sports */
export type SportConnection = {
  __typename?: 'SportConnection';
  /** A list of edges */
  edges: Array<SportEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a SportConnection */
export type SportEdge = Edge & {
  __typename?: 'SportEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Sport node */
  node: Sport;
};

/** Complete SQL schema metadata for generating valid PostgreSQL queries. Contains all tables, views, and materialized views with columns, types, foreign keys, and value metadata. Use the 'key' field on each table as the schema-qualified name in FROM clauses (e.g., SELECT * FROM public.player). Check foreignKeys for valid JOIN paths, uniqueValues for filterable column values, and jsonSchema for JSONB column structure. */
export type SqlSchemaModel = {
  __typename?: 'SqlSchemaModel';
  /** IMPORTANT: Read these guidelines FIRST before examining tables. Actionable guidelines for generating valid PostgreSQL queries from this schema, including example queries and column mappings. */
  queryGuidelines: Array<Scalars['String']['output']>;
  /** List of all tables, views, and materialized views with their complete metadata */
  tables: Array<TableInfoModel>;
};

/** Position map showing first-team player depth for each position in the formation */
export type SquadDepthByPositionModel = {
  __typename?: 'SquadDepthByPositionModel';
  /** Formation identifier (e.g. F_433, F_442) */
  formation: Scalars['String']['output'];
  /** Position nodes with player depth counts */
  positions: Array<SquadDepthPositionModel>;
};

/** Position node with first-team player depth count and avg GPR */
export type SquadDepthPositionModel = {
  __typename?: 'SquadDepthPositionModel';
  /** Average GPR of first-team players at this position (excludes academy and players without GPR) */
  avgGpr?: Maybe<Scalars['Float']['output']>;
  /** Full position name (e.g. Striker, Goalkeeper) */
  name?: Maybe<Scalars['String']['output']>;
  /** Number of first-team players at this position */
  playerCount: Scalars['Int']['output'];
  /** Position abbreviation (e.g. ST, GK, LB) */
  positionId: Scalars['String']['output'];
};

/** Computed squad final state after applying transitions to the baseline roster */
export type SquadFinalStateModel = {
  __typename?: 'SquadFinalStateModel';
  /** Players in the academy after transitions */
  academy: Array<FinalStatePlayerModel>;
  /** Players in the first team after transitions */
  firstTeam: Array<FinalStatePlayerModel>;
};

/** GPR distribution across first-team players, bucketed by score bands */
export type SquadGprDistribution = {
  __typename?: 'SquadGprDistribution';
  /** Players with GPR >= 70 and < 80 */
  gpr70to79: Scalars['Int']['output'];
  /** Players with GPR >= 80 */
  gpr80Plus: Scalars['Int']['output'];
  /** Players with GPR < 70 */
  gprBelow70: Scalars['Int']['output'];
  /** Total first-team players with GPR data */
  totalFirstTeamPlayers: Scalars['Int']['output'];
};

/** Squad KPI summary including player counts, contract status, wages, and optional scenario impact */
export type SquadKpIsModel = {
  __typename?: 'SquadKPIsModel';
  /** Number of players with contracts expiring within 12 months. Null when the viewer's tier may not see contract dates (SE-7421). */
  contractsExpiring12Mo?: Maybe<Scalars['Int']['output']>;
  /** Scenario impact data when a scenarioId is provided, null otherwise */
  scenarioImpact?: Maybe<ScenarioImpactModel>;
  /** Breakdown of player count by first team and academy */
  totalPlayers: TotalPlayersModel;
  /** Sum of gross annual salary across all players with wage data. Null when the viewer's tier may not see wages (SE-7410). */
  totalWageBill?: Maybe<Scalars['Float']['output']>;
  /** Number of unavailable players (injured or suspended) */
  unavailableCount: Scalars['Int']['output'];
  /** Ratio of players with wage data entered vs total players (0 to 1). Null when the viewer's tier may not see wages (SE-7410). */
  wageCompleteness?: Maybe<Scalars['Float']['output']>;
};

/** Squad players grouped by tier (first team, academy, targets) for a given position */
export type SquadPlayersByPositionModel = {
  __typename?: 'SquadPlayersByPositionModel';
  /** Academy players at this position */
  academy: Array<AcademyPositionPlayerModel>;
  /** First-team players at this position */
  firstTeam: Array<SquadPositionPlayerModel>;
  /** Target players from watchlists at this position */
  targets: Array<TargetPositionPlayerModel>;
};

/** Base player data for the squad position depth panel */
export type SquadPositionPlayerModel = {
  __typename?: 'SquadPositionPlayerModel';
  /** Player age from stats provider */
  age?: Maybe<Scalars['Int']['output']>;
  /** Annual amortisation charge (SE-7410): transfer fee plus agent fee spread straight-line over the contract's whole months, from organization player data. Null when no fee or no contract dates are recorded, or when the viewer's tier may not see it. */
  amortisationAnnual?: Maybe<Scalars['Float']['output']>;
  /** Contract expiry date */
  contractExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Estimated valuation from organization player data */
  estVal?: Maybe<Scalars['Float']['output']>;
  /** Player first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gemini Performance Rating (time-decayed) */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Gemini Player Valuation */
  gpv?: Maybe<Scalars['Float']['output']>;
  /** GPV upper bound */
  gpvMax?: Maybe<Scalars['Float']['output']>;
  /** GPV lower bound */
  gpvMin?: Maybe<Scalars['Float']['output']>;
  /** Player UUID */
  id: Scalars['ID']['output'];
  /** Whether this player was manually created by the organization */
  isManual: Scalars['Boolean']['output'];
  /** Player known name */
  knownName?: Maybe<Scalars['String']['output']>;
  /** Player last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Minutes played in the player's current season (most recent season with provider metrics) — SE-4775 */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** Display name (knownName or full name) */
  name: Scalars['String']['output'];
  /** Nationality name (e.g. 'Brazil', 'England') */
  nationalityName?: Maybe<Scalars['String']['output']>;
  /** Net book value (SE-7410): the unamortised remainder of the transfer fee at the request date, straight-line over the contract. Null when it cannot be computed or when the viewer's tier may not see it (Tier 1 only). */
  netBookValue?: Maybe<Scalars['Float']['output']>;
  /** Primary position abbreviation (e.g. ST, GK, LB) */
  position?: Maybe<Scalars['String']['output']>;
  /** All position abbreviations this player can play (from player_position table) */
  positions: Array<Scalars['String']['output']>;
  /** Player availability status (e.g. 'INJURED', 'AVAILABLE') */
  status?: Maybe<Scalars['String']['output']>;
  /** Team name — from provider team for roster players, free-text for manual players */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Scenario transition applied to this player (SELL, LOAN_OUT, LOAN_IN, PROMOTE, SIGN), or null if none */
  transitionType?: Maybe<TransitionType>;
  /** Gross annual salary from organization player data */
  wage?: Maybe<Scalars['Float']['output']>;
};

/** A squad planning transition representing a hypothetical roster change */
export type SquadTransitionModel = {
  __typename?: 'SquadTransitionModel';
  /** Timestamp of record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Financial details for the transition */
  financialDetails?: Maybe<FinancialDetailsModel>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** FK to organization */
  organizationId: Scalars['ID']['output'];
  /** FK to player */
  playerId: Scalars['ID']['output'];
  /** Scenario ID, null for current edit state */
  scenarioId?: Maybe<Scalars['ID']['output']>;
  /** Type of transition */
  transitionType: TransitionType;
  /** Timestamp of last record update */
  updatedAt: Scalars['DateTime']['output'];
};

export type StatPriority = Node & {
  __typename?: 'StatPriority';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  priority?: Maybe<Scalars['Float']['output']>;
  statId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StatPriorityInput = {
  priority?: InputMaybe<Scalars['Float']['input']>;
  statId: Scalars['ID']['input'];
};

/** Submits a match report. Typed and independent of the form.io flow. Idempotent: a repeated submit neither creates a second report for the same match and scout nor overwrites the original submission time. Partial reports may be submitted — completeness and submission are independent. */
export type SubmitMatchReportInput = {
  /** Identifier of the report to submit */
  matchReportId: Scalars['ID']['input'];
};

/** Why a player is being suggested for a pipeline. Only categories backed by explicit recommendation output are ever emitted; an unsupported or custom recommendation type is omitted rather than mapped to a fallback. */
export enum SuggestionReasonCategory {
  SquadDepth = 'SQUAD_DEPTH',
  UnderperformingPlayers = 'UNDERPERFORMING_PLAYERS',
  YoungPlayers = 'YOUNG_PLAYERS'
}

/** Supported locale codes for internationalization */
export enum SupportedLocale {
  ArSa = 'ar_SA',
  DaDk = 'da_DK',
  DeDe = 'de_DE',
  EnGb = 'en_GB',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  EsMx = 'es_MX',
  FrFr = 'fr_FR',
  ItIt = 'it_IT',
  JaJp = 'ja_JP',
  KoKr = 'ko_KR',
  NlNl = 'nl_NL',
  NoNo = 'no_NO',
  PlPl = 'pl_PL',
  PtBr = 'pt_BR',
  PtPt = 'pt_PT',
  RuRu = 'ru_RU',
  SvSe = 'sv_SE',
  TrTr = 'tr_TR',
  ZhCn = 'zh_CN'
}

/** A suspension WARNING a player carries, or null for silence. LIKELY_SUSPENDED means a red card is recorded (a ban in every competition). There is deliberately no 'available' state: this surface never asserts a player can play — absence of a warning is silence, not availability (SE-7018). */
export enum SuspensionWarning {
  LikelySuspended = 'LIKELY_SUSPENDED'
}

/** Table-level foreign key constraint describing relationships between tables */
export type TableForeignKeyModel = {
  __typename?: 'TableForeignKeyModel';
  /** Name of the column containing the foreign key */
  column: Scalars['String']['output'];
  /** Name of the column in the foreign table this key references */
  foreignColumn: Scalars['String']['output'];
  /** Name of the table this foreign key references */
  foreignTable: Scalars['String']['output'];
};

/** Complete metadata for a table, view, or materialized view including columns and relationships */
export type TableInfoModel = {
  __typename?: 'TableInfoModel';
  /** List of columns with their type, constraint, and value metadata */
  columns: Array<ColumnInfoModel>;
  /** List of foreign key constraints defining relationships to other tables */
  foreignKeys: Array<TableForeignKeyModel>;
  /** Unique key combining schema and name (e.g., "public.users") */
  key: Scalars['String']['output'];
  /** Name of the table, view, or materialized view */
  name: Scalars['String']['output'];
  /** Database schema containing this object (typically "public") */
  schema: Scalars['String']['output'];
  /** Type of database object (table, view, or materialized view) */
  type: TableType;
};

/** Type of database object (table, view, or materialized view) indicating query capabilities */
export enum TableType {
  Matview = 'MATVIEW',
  Table = 'TABLE',
  View = 'VIEW'
}

/** Semantic slot keys supported by watchlist Pitch view */
export enum TacticalSlot {
  Cam = 'CAM',
  Cb = 'CB',
  Cdm = 'CDM',
  Cm = 'CM',
  Gk = 'GK',
  Lam = 'LAM',
  Lb = 'LB',
  Lcb = 'LCB',
  Lcdm = 'LCDM',
  Lcm = 'LCM',
  Lm = 'LM',
  Lst = 'LST',
  Lw = 'LW',
  Lwb = 'LWB',
  Ram = 'RAM',
  Rb = 'RB',
  Rcb = 'RCB',
  Rcdm = 'RCDM',
  Rcm = 'RCM',
  Rm = 'RM',
  Rst = 'RST',
  Rw = 'RW',
  Rwb = 'RWB',
  Ss = 'SS',
  St = 'ST'
}

/** Target player with source watchlist information */
export type TargetPositionPlayerModel = {
  __typename?: 'TargetPositionPlayerModel';
  /** Player age from stats provider */
  age?: Maybe<Scalars['Int']['output']>;
  /** Annual amortisation charge (SE-7410): transfer fee plus agent fee spread straight-line over the contract's whole months, from organization player data. Null when no fee or no contract dates are recorded, or when the viewer's tier may not see it. */
  amortisationAnnual?: Maybe<Scalars['Float']['output']>;
  /** Contract expiry date */
  contractExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Estimated valuation from organization player data */
  estVal?: Maybe<Scalars['Float']['output']>;
  /** Player first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gemini Performance Rating (time-decayed) */
  gpr?: Maybe<Scalars['Float']['output']>;
  /** Gemini Player Valuation */
  gpv?: Maybe<Scalars['Float']['output']>;
  /** GPV upper bound */
  gpvMax?: Maybe<Scalars['Float']['output']>;
  /** GPV lower bound */
  gpvMin?: Maybe<Scalars['Float']['output']>;
  /** Player UUID */
  id: Scalars['ID']['output'];
  /** Whether this player was manually created by the organization */
  isManual: Scalars['Boolean']['output'];
  /** Player known name */
  knownName?: Maybe<Scalars['String']['output']>;
  /** Player last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Minutes played in the player's current season (most recent season with provider metrics) — SE-4775 */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** Display name (knownName or full name) */
  name: Scalars['String']['output'];
  /** Nationality name (e.g. 'Brazil', 'England') */
  nationalityName?: Maybe<Scalars['String']['output']>;
  /** Net book value (SE-7410): the unamortised remainder of the transfer fee at the request date, straight-line over the contract. Null when it cannot be computed or when the viewer's tier may not see it (Tier 1 only). */
  netBookValue?: Maybe<Scalars['Float']['output']>;
  /** Primary position abbreviation (e.g. ST, GK, LB) */
  position?: Maybe<Scalars['String']['output']>;
  /** All position abbreviations this player can play (from player_position table) */
  positions: Array<Scalars['String']['output']>;
  /** Names of watchlists this player appears in */
  sourceWatchlists: Array<Scalars['String']['output']>;
  /** Player availability status (e.g. 'INJURED', 'AVAILABLE') */
  status?: Maybe<Scalars['String']['output']>;
  /** Team name — from provider team for roster players, free-text for manual players */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Scenario transition applied to this player (SELL, LOAN_OUT, LOAN_IN, PROMOTE, SIGN), or null if none */
  transitionType?: Maybe<TransitionType>;
  /** Gross annual salary from organization player data */
  wage?: Maybe<Scalars['Float']['output']>;
};

/** Professional sports team entity with league affiliation and organization tracking */
export type Team = Node & {
  __typename?: 'Team';
  /** Timestamp of team record creation */
  createdAt: Scalars['DateTime']['output'];
  /** Gender division of the team */
  gender: Gender;
  /** Unique identifier for the team */
  id: Scalars['ID']['output'];
  isMyOrganizationTeam: Scalars['Boolean']['output'];
  /** League the team competes in */
  league?: Maybe<League>;
  /** Name of the team */
  name: Scalars['String']['output'];
  /** Timestamp of last team record update */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of teams */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** A list of edges */
  edges: Array<TeamEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** An edge in a TeamConnection */
export type TeamEdge = Edge & {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The Team node */
  node: Team;
};

/** Pairs a team with the player's computed team-style fit score (0-100) against that team. */
export type TeamFitResult = {
  __typename?: 'TeamFitResult';
  /** Fit score on a 0-100 scale (higher = better stylistic fit). Computed as the player's max similarity over their manager history against the team's latest manager-style vector. */
  fitScore: Scalars['Int']['output'];
  /** The candidate team that was scored. */
  team: Team;
};

/** Team league ranking, radar chart percentiles, and roster summary stats */
export type TeamLeagueStats = {
  __typename?: 'TeamLeagueStats';
  /** League average percentile for each metric (useful as a baseline on the radar chart) */
  leagueAveragePercentiles: RadarMetrics;
  /** Aggregate statistics for the user's roster */
  rosterStats: RosterStats;
  /** Team's rank among all league teams by average GPR (1 = best) */
  teamGprRank: Scalars['Int']['output'];
  /** Team's percentile for each metric relative to all league teams */
  teamPercentiles: RadarMetrics;
  /** Total number of teams in the league */
  totalTeams: Scalars['Int']['output'];
};

/** A player currently on loan to or from the queried team. Current loans only; the data has no loan history. */
export type TeamLoanModel = {
  __typename?: 'TeamLoanModel';
  /** OUT = the queried team's player on loan elsewhere; IN = a player on loan at the queried team. Never ALL. */
  direction: LoanDirection;
  /** The club the player is on loan at */
  loanTeam?: Maybe<Team>;
  /** Internal UUID of the club the player is on loan at; null when not known */
  loanTeamId?: Maybe<Scalars['ID']['output']>;
  /** Name of the club the player is on loan at */
  loanTeamName?: Maybe<Scalars['String']['output']>;
  /** The club the player is on loan from */
  parentTeam?: Maybe<Team>;
  /** Internal UUID of the club the player is on loan from; null when that club is not in the catalog */
  parentTeamId?: Maybe<Scalars['ID']['output']>;
  /** Name of the club the player is on loan from */
  parentTeamName?: Maybe<Scalars['String']['output']>;
  /** The loaned player */
  player?: Maybe<Player>;
  /** ID of the loaned player */
  playerId: Scalars['ID']['output'];
  /** Display name of the loaned player */
  playerName: Scalars['String']['output'];
  /** The latest transfer from the parent club (to the loan club when known) — the move that started the loan, with its date and fee. Null when none is recorded. */
  transfer?: Maybe<TransferModel>;
};

/** Org-level team selection mode */
export enum TeamSelectionMode {
  All = 'all',
  Hidden = 'hidden',
  Linked = 'linked'
}

/** Metadata associated with a user thread */
export type ThreadMetadata = {
  __typename?: 'ThreadMetadata';
  customFields?: Maybe<Scalars['JSON']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  messages: Array<ConversationMessage>;
  modelUsed?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  sessionContext?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** Per-tier contract and transfer completeness totals for the contracts overview summary */
export type TierCompleteness = {
  __typename?: 'TierCompleteness';
  /** Number of players in this tier with a SAVED contract extraction */
  contractsSaved: Scalars['Int']['output'];
  /** Total number of rostered players in this tier (denominator for both contracts and transfers) */
  contractsTotal: Scalars['Int']['output'];
  /** Number of players in this tier with a SAVED transfer-agreement extraction */
  transfersSaved: Scalars['Int']['output'];
  /** Total number of rostered players in this tier (denominator for transfers — equals contractsTotal) */
  transfersTotal: Scalars['Int']['output'];
};

/** A player ranked by total goals scored within a league and season */
export type TopScorer = {
  __typename?: 'TopScorer';
  /** Current club name */
  clubName?: Maybe<Scalars['String']['output']>;
  /** Total goals scored */
  goals: Scalars['Int']['output'];
  /** League name */
  leagueName: Scalars['String']['output'];
  /** Player identifier */
  playerId: Scalars['ID']['output'];
  /** Player full name */
  playerName: Scalars['String']['output'];
  /** Season display name */
  seasonName?: Maybe<Scalars['String']['output']>;
};

/** Player count breakdown by first team and academy */
export type TotalPlayersModel = {
  __typename?: 'TotalPlayersModel';
  /** Number of academy players */
  academy: Scalars['Int']['output'];
  /** Number of first-team players */
  firstTeam: Scalars['Int']['output'];
};

/** Connection type for paginated Transfer results */
export type TransferConnection = Connection & {
  __typename?: 'TransferConnection';
  /** A list of edges */
  edges: Array<TransferEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Direction of a transfer relative to a queried team — IN = signings (team is destination); OUT = departures (team is source); ALL = both. */
export enum TransferDirection {
  All = 'ALL',
  In = 'IN',
  Out = 'OUT'
}

/** Edge type for Transfer connection */
export type TransferEdge = Edge & {
  __typename?: 'TransferEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Transfer node */
  node: TransferModel;
};

/** Input for transferring a kanban board's ownership to another member */
export type TransferKanbanBoardOwnershipInput = {
  /** The ID of the kanban board whose ownership is moving */
  kanbanBoardId: Scalars['ID']['input'];
  /** The ID of the member who becomes the board's single OWNER. Must be an active member of the board's organization. */
  newOwnerUserId: Scalars['ID']['input'];
};

/** Input for transferring reports and notes from a manual player to a provider-sourced player */
export type TransferManualPlayerDataInput = {
  /** ID of the source manual player whose data will be transferred */
  sourcePlayerId: Scalars['ID']['input'];
  /** ID of the target provider-sourced player to receive the data */
  targetPlayerId: Scalars['ID']['input'];
};

/** Player transfer record between teams */
export type TransferModel = Node & {
  __typename?: 'TransferModel';
  /** Duration of the contract at new team */
  contractDuration?: Maybe<Scalars['String']['output']>;
  /** Contract expiry date at new team */
  contractExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Date of the transfer */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Destination team to which player transferred */
  destinationTeam?: Maybe<Team>;
  /** Internal UUID of the destination team */
  destinationTeamId?: Maybe<Scalars['ID']['output']>;
  /** Transfer fee (e.g., '80m', 'free transfer', 'Loan') */
  fee?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the transfer */
  id: Scalars['ID']['output'];
  /** listTransfersByTeamId IN rows only: true when the same player left this club for the source club since the previous season began (a likely loan return). Null on OUT rows and elsewhere. */
  likelyLoanReturn?: Maybe<Scalars['Boolean']['output']>;
  /** Player market value at time of transfer */
  marketValue?: Maybe<Scalars['String']['output']>;
  /** The player associated with this transfer */
  player?: Maybe<Player>;
  /** ID of the player associated with this transfer */
  playerId: Scalars['ID']['output'];
  /** Source team from which player transferred */
  sourceTeam?: Maybe<Team>;
  /** Internal UUID of the source team */
  sourceTeamId?: Maybe<Scalars['ID']['output']>;
  /** URL to transfer details page */
  url?: Maybe<Scalars['String']['output']>;
};

/** Result of a manual player data transfer operation */
export type TransferResult = {
  __typename?: 'TransferResult';
  /** Number of notes transferred */
  notesTransferred: Scalars['Int']['output'];
  /** Number of scout reports transferred */
  scoutReportsTransferred: Scalars['Int']['output'];
  /** ID of the source manual player */
  sourcePlayerId: Scalars['ID']['output'];
  /** ID of the target provider-sourced player */
  targetPlayerId: Scalars['ID']['output'];
};

/** Football transfer window. Derived from transfer.date: SUMMER = Jun 1–Sep 1, WINTER = Jan 1–Feb 28. Federation-specific edges are not modeled here. */
export enum TransferWindow {
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

/** Counts of transferable scout reports and notes for a manual player */
export type TransferableDataCounts = {
  __typename?: 'TransferableDataCounts';
  /** Number of notes attached to this player */
  noteCount: Scalars['Int']['output'];
  /** Number of scout reports attached to this player */
  scoutReportCount: Scalars['Int']['output'];
};

/** Type of squad planning transition: sell, loan out, loan in, promote from academy, or sign a new player */
export enum TransitionType {
  LoanIn = 'LOAN_IN',
  LoanOut = 'LOAN_OUT',
  Promote = 'PROMOTE',
  Sell = 'SELL',
  Sign = 'SIGN'
}

/** Input for translating a scout report into a specific locale on demand */
export type TranslateScoutReportInput = {
  /** Target locale to translate the scout report into (e.g. es_ES, fr_FR) */
  locale: SupportedLocale;
  /** ID of the scout report to translate */
  scoutReportId: Scalars['ID']['input'];
};

/** Input for triggering AI extraction on uploaded contract documents */
export type TriggerContractExtractionInput = {
  /** The type of contract document */
  documentType: DocumentType;
  /** UUID of the player whose documents to extract */
  playerId: Scalars['ID']['input'];
};

/** Input for reversing an automated move (SE-5507) */
export type UndoPipelineAutomationFiringInput = {
  /** The automation firing to reverse */
  firingId: Scalars['ID']['input'];
  /** Required reason, trimmed server-side and recorded as the reversing move's rationale. */
  reason: Scalars['String']['input'];
};

/** An edit to a club Objective. */
export type UpdateClubObjectiveInput = {
  /** A new amber boundary. Omit to leave unchanged; pass `clearAmberThreshold: true` to remove the band entirely. A null here is treated as omission, never as an amber of zero. */
  amberThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** A new timeframe. Omit to leave unchanged. */
  assessmentWindow?: InputMaybe<ComplianceAssessmentWindow>;
  /** Removes the amber band. The explicit companion to `amberThreshold`, because omitting a nullable field cannot express 'clear this'. */
  clearAmberThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new comparator. Omit to leave unchanged. */
  comparator?: InputMaybe<ComplianceComparator>;
  /** The Objective to edit. */
  id: Scalars['ID']['input'];
  /** Whether the Objective participates in evaluation. Disabling is how an Objective is retired without losing its history. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new display name. Omit to leave unchanged. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A new Show KPI flag. Omit to leave unchanged. */
  showKpi?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new threshold. Omit to leave unchanged. */
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating an existing comment */
export type UpdateCommentInput = {
  /** The content of the comment (max 300 chars) */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment to update */
  id: Scalars['ID']['input'];
};

/** An edit to a user-built compliance metric. */
export type UpdateComplianceMetricInput = {
  /** A new category. Omit to leave unchanged. */
  category?: InputMaybe<ComplianceMetricCategory>;
  /** The metric to edit. */
  id: Scalars['ID']['input'];
  /** A new measure. Omit to leave unchanged. Supplying this requires supplying the operands too, since the measure decides whether a denominator is needed. */
  measure?: InputMaybe<ComplianceMetricMeasure>;
  /** A new display name. Omit to leave unchanged. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The replacement OF operand. Supply with `over` to replace the operand set; omit both to leave the operands untouched. */
  of?: InputMaybe<ComplianceOperandInput>;
  /** The replacement OVER operand. Only meaningful alongside `of`. */
  over?: InputMaybe<ComplianceOperandInput>;
};

/** Changes a group grant's role between EDITOR and VIEWER; owner only */
export type UpdateGroupGrantRoleInput = {
  /** The group grant to change */
  groupGrantId: Scalars['ID']['input'];
  /** EDITOR or VIEWER */
  role: GroupGrantRole;
};

/** Input for updating an existing kanban board */
export type UpdateKanbanBoardInput = {
  /** The display name for the kanban board */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a kanban card's properties */
export type UpdateKanbanCardInput = {
  /** Updated notes for the player's recruitment status */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Input for reordering cards within a phase */
export type UpdateKanbanCardPositionsInput = {
  /** The new positions for each card. All cards in the phase must be included. */
  cardPositions: Array<CardPosition>;
  /** The ID of the phase containing the cards to reorder */
  kanbanPhaseId: Scalars['ID']['input'];
};

/** Input for updating an existing kanban phase */
export type UpdateKanbanPhaseInput = {
  /** Whether the phase contains sensitive player information */
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a terminal pipeline phase */
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the phase */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional target number of days for cards in this phase */
  timeTargetDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for reordering phases within a kanban board */
export type UpdateKanbanPhasePositionsInput = {
  /** The ID of the kanban board containing the phases */
  kanbanBoardId: Scalars['ID']['input'];
  /** The new positions for each phase. All phases must be included */
  phasePositions: Array<PhasePosition>;
};

/** Input for updating an existing kanban tag */
export type UpdateKanbanTagInput = {
  /** The name of the tag. Must be unique within the organization. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An edit to an already-configured KPI's target, warn level, basis or Show KPI flag. Requires compliance Tier 1 — see UpdateClubObjectiveInput for the separate Tier 1-2 authoring surface. */
export type UpdateKpiTargetInput = {
  /** A new warn level (amber boundary). Omit to leave unchanged; pass `clearAmberThreshold: true` to remove the band entirely. A null here is treated as omission, never as a warn level of zero. */
  amberThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Removes the warn level. The explicit companion to `amberThreshold`, because omitting a nullable field cannot express 'clear this'. */
  clearAmberThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new basis (comparator). Omit to leave unchanged. */
  comparator?: InputMaybe<ComplianceComparator>;
  /** The KPI's underlying Objective to edit. */
  id: Scalars['ID']['input'];
  /** A new Show KPI flag — removes the card from the dashboard without deleting the underlying Objective. Omit to leave unchanged. */
  showKpi?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new target (threshold). Omit to leave unchanged. */
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating a manually-added player */
export type UpdateManualPlayerInput = {
  /** Player's date of birth */
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  /** Player's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the manual player to update */
  id: Scalars['ID']['input'];
  /** Whether this player is an academy player for squad planning purposes. Defaults to false. */
  isAcademy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Player's known name or nickname */
  knownName?: InputMaybe<Scalars['String']['input']>;
  /** Player's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the player's nationality */
  nationalityId?: InputMaybe<Scalars['ID']['input']>;
  /** List of position IDs to assign to the manual player */
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-text team name for the manual player */
  teamName?: InputMaybe<Scalars['String']['input']>;
};

/** Input for correcting a recorded match event. Omitted fields are left unchanged; sending null for player or minute explicitly clears it, which is how a misattributed scorer is undone. */
export type UpdateMatchEventInput = {
  /** Corrected kind; omit to leave unchanged */
  kind?: InputMaybe<MatchEventKind>;
  /** The event to correct */
  matchEventId: Scalars['ID']['input'];
  /** Corrected minute. Send null to clear it; omit to leave unchanged. */
  minute?: InputMaybe<Scalars['Int']['input']>;
  /** Corrected player. Send null to clear a misattributed scorer; omit to leave unchanged. */
  playerId?: InputMaybe<Scalars['ID']['input']>;
  /** Corrected side; omit to leave unchanged */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating a match. Omitted fields are left unchanged; use the clear flags to reset a nullable field back to unknown, since an omitted field and an explicit null cannot be distinguished. */
export type UpdateMatchInput = {
  /** New away team */
  awayTeamId?: InputMaybe<Scalars['ID']['input']>;
  /** New away score */
  awayTeamScore?: InputMaybe<Scalars['Int']['input']>;
  /** Set true to reset the kick-off to unconfirmed. Takes precedence over startTime if both are supplied. */
  clearStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set true to reset the venue to unknown. Takes precedence over venue if both are supplied. */
  clearVenue?: InputMaybe<Scalars['Boolean']['input']>;
  /** New free-text competition label */
  competitionLabel?: InputMaybe<Scalars['String']['input']>;
  /** New date precision */
  datePrecision?: InputMaybe<MatchDatePrecision>;
  /** New home team */
  homeTeamId?: InputMaybe<Scalars['ID']['input']>;
  /** New home score */
  homeTeamScore?: InputMaybe<Scalars['Int']['input']>;
  /** Identifier of the match to update */
  id: Scalars['ID']['input'];
  /** New catalog league */
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  /** New civil date at the venue, ISO-8601 (YYYY-MM-DD) */
  scheduledDate?: InputMaybe<Scalars['String']['input']>;
  /** New inclusive last day of the window, for WINDOW precision */
  scheduledEndDate?: InputMaybe<Scalars['String']['input']>;
  /** New kick-off as a civil time at the venue (HH:mm) */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** New lifecycle state */
  status?: InputMaybe<MatchStatus>;
  /** New IANA timezone */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** New venue name */
  venue?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a match report shell. Rejected once the report is submitted, because submittedAt marks the point where the report became a record of what a scout reported. Squad and per-player fields have their own mutations. */
export type UpdateMatchReportInput = {
  /** Identifier of the report to update */
  matchReportId: Scalars['ID']['input'];
  /** How the scout observed the fixture. Omit to leave unchanged. This is the field CreateMatchReportInput defers when a scout opens a report before deciding how they will watch. */
  watchMode?: InputMaybe<MatchWatchMode>;
};

/** Input type for updating the authenticated user's profile information */
export type UpdateMyProfileInput = {
  /** User's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's preferred language/locale for UI and communications */
  languagePreference?: InputMaybe<SupportedLocale>;
  /** User's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's job title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing note */
export type UpdateNoteInput = {
  /** The content of the note (max 2000 chars) */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the note to update */
  id: Scalars['ID']['input'];
  /** Determines if this note will be visible to other users in the organization. Defaults to the organization setting when omitted. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the note (max 100 chars) */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing organization */
export type UpdateOrganizationInput = {
  /** Currency code for the organization */
  currencyCode?: InputMaybe<CurrencyCode>;
  /** Default formation for squad planning */
  defaultFormation?: InputMaybe<ShadowTeamFormation>;
  /** Default visibility for new kanban boards. False=private, true=public. */
  defaultKanbanBoardVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default visibility for new notes. False=private, true=public. */
  defaultNoteVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the default scout report type for this organization */
  defaultScoutReportTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Default visibility for new scout reports. False=private, true=public. */
  defaultScoutReportVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the organization to update */
  id: Scalars['ID']['input'];
  /** Name of the organization */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Foreign key to primary sport */
  sportId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for editing a pipeline automation rule. A full replacement, including the condition list — never a partial patch. */
export type UpdatePipelineAutomationRuleInput = {
  /** What the rule does when it matches */
  actionType: PipelineAutomationActionType;
  /** Member to assign the card to for ASSIGN (SE-5628). Their organization membership is re-validated at FIRING time, not stored as a snapshot — a member who leaves the club stops being a valid assignee without the rule being edited. */
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  /** The rule to edit */
  automationRuleId: Scalars['ID']['input'];
  /** Conditions, combined with AND. An empty list always matches. */
  conditions: Array<PipelineAutomationRuleConditionInput>;
  /** Tag for APPLY_TAG / REMOVE_TAG */
  kanbanTagId?: InputMaybe<Scalars['ID']['input']>;
  /** Display name. Snapshotted onto every audit and ledger row the rule produces, so a later rename cannot rewrite history. */
  name: Scalars['String']['input'];
  /** The author's rationale, recorded as the rationale on every audit row and review request the rule produces. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Outcome to PROPOSE when the target stage is terminal. Optional — the backend never picks an outcome on the approver's behalf, so leaving it null simply asks the human to choose at accept time. */
  requestedOutcome?: InputMaybe<KanbanCardOutcome>;
  /** Target stage for MOVE_TO_STAGE / ADD_TO_REVIEW_QUEUE. Whether the move needs approval is decided LIVE from the stage at evaluation time and is deliberately not configurable here. */
  targetKanbanPhaseId?: InputMaybe<Scalars['ID']['input']>;
  /** Stage the trigger watches. Required for TIME_IN_STAGE_EXCEEDED; optional for CARD_ENTERED_STAGE, where omitting it means any stage; ignored by every other trigger. */
  triggerKanbanPhaseId?: InputMaybe<Scalars['ID']['input']>;
  /** What causes the rule to be evaluated */
  triggerType: PipelineAutomationTriggerType;
};

/** Input for updating a player's wage */
export type UpdatePlayerWageInput = {
  /** Gross annual salary in organization currency (must be non-negative) */
  grossAnnualSalary: Scalars['Float']['input'];
  /** ID of the player */
  playerId: Scalars['ID']['input'];
  /** SE-8504: when set, scopes this write to this scenario's own isolated copy instead of the shared organization_player_data row. */
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};

/** An override of a regime-rule KPI's target, warn level, basis or Show KPI flag, scoped to one club. comparator and threshold are required the first time this club overrides the rule; both become optional (omit to leave unchanged) on every edit after that. Requires compliance Tier 1 — see UpdateKpiTargetInput for the club-Objective counterpart. */
export type UpdateRegimeRuleTargetInput = {
  /** A new warn level (amber boundary). Omit to leave unchanged; pass `clearAmberThreshold: true` to remove the band entirely. A null here is treated as omission, never as a warn level of zero. */
  amberThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Removes the warn level. The explicit companion to `amberThreshold`, because omitting a nullable field cannot express 'clear this'. */
  clearAmberThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new basis (comparator). Required on this club's first override of the rule; omit on a later edit to leave unchanged. */
  comparator?: InputMaybe<ComplianceComparator>;
  /** The regime rule being overridden, for this club. The same id ComplianceRuleEvaluation.ruleId already publishes when a backing rule exists. */
  ruleId: Scalars['ID']['input'];
  /** A new Show KPI flag for this club, independent of the shared rule's own default. Omit to leave unchanged; defaults to false on this club's first override. */
  showKpi?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new target (threshold). Required on this club's first override of the rule; omit on a later edit to leave unchanged. */
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

/** SE-8467: change the scenario's shared formation */
export type UpdateScenarioFormationInput = {
  /** The pitchRevision the client read; conflict when stale */
  expectedPitchRevision: Scalars['Int']['input'];
  formation: PitchFormation;
  scenarioId: Scalars['ID']['input'];
};

/** Updates a scenario name and/or replaces all actions atomically */
export type UpdateScenarioInput = {
  /** New complete set of actions. If provided, replaces all existing actions atomically. */
  actions?: InputMaybe<Array<ScenarioActionInput>>;
  /** New display name (unchanged if omitted) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the scenario to update */
  scenarioId: Scalars['ID']['input'];
};

/** SE-8467: place one pitch occupant on a slot, or unassign him with a null slot */
export type UpdateScenarioPitchAssignmentInput = {
  /** The pitchRevision the client read; conflict when stale */
  expectedPitchRevision: Scalars['Int']['input'];
  /** Real player id, or the ScenarioExternalPlayer id for an unlinked external — ScenarioActionModel.playerId */
  playerId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  /** Omit or null to unassign (Unassigned panel); a slot outside the current formation is a BadRequest */
  tacticalSlot?: InputMaybe<TacticalSlot>;
};

/** SE-8467: reorder a subset of pitch occupants — normally one slot's rows as the pop-out shows them */
export type UpdateScenarioPreferenceOrderInput = {
  /** The pitchRevision the client read; conflict when stale */
  expectedPitchRevision: Scalars['Int']['input'];
  /** The new relative order of the subset; ids not named keep their place (SE-8299 filtered-subset semantics) */
  orderedPlayerIds: Array<Scalars['ID']['input']>;
  scenarioId: Scalars['ID']['input'];
};

/** Input for updating an existing shadow team */
export type UpdateShadowTeamInput = {
  /** The formation type for the shadow team (e.g., F_442, F_433) */
  formation?: InputMaybe<ShadowTeamFormation>;
  /** ID of the shadow team to update */
  id: Scalars['ID']['input'];
  /** The display name for the shadow team */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated player positions and orders within the formation */
  playerPositions?: InputMaybe<Array<ShadowTeamPlayerPositionInput>>;
  /** When true (default), a from-scratch team is auto-seeded with org + watchlist players. Set false to start with an empty roster. Ignored when sourceWatchlistId is provided. */
  seedFromOrgAndWatchlists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional watchlist ID. When set, the new shadow team is populated from the watchlist's players, each placed at their primary position slot for the chosen formation. */
  sourceWatchlistId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating a user's permission role on a kanban board */
export type UpdateUserKanbanBoardRoleInput = {
  /** The ID of the user kanban board permission record to update */
  id: Scalars['ID']['input'];
  /** The new permission role to assign (EDITOR or VIEWER). Cannot be OWNER as there can only be one owner per board. */
  role: UserKanbanBoardRole;
};

/** Changes a grant's role between EDITOR and VIEWER; owner only */
export type UpdateUserScenarioRoleInput = {
  /** EDITOR or VIEWER */
  role: UserScenarioRole;
  /** The grant to change */
  userScenarioId: Scalars['ID']['input'];
};

/** Input for updating a watchlist's position in the user's list of watchlists */
export type UpdateUserWatchlistPositionInput = {
  /** The new position for the watchlist */
  newPosition: Scalars['Float']['input'];
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Input for changing the role of an existing watchlist grant */
export type UpdateUserWatchlistRoleInput = {
  /** The new role for the grant (EDITOR or VIEWER) */
  role: UserWatchlistRole;
  /** The ID of the user watchlist association to change */
  userWatchlistId: Scalars['ID']['input'];
};

export type UpdateWatchlistFormationInput = {
  expectedPitchRevision: Scalars['Int']['input'];
  formation: PitchFormation;
  watchlistId: Scalars['ID']['input'];
};

/** Input for updating an existing watchlist */
export type UpdateWatchlistInput = {
  /** Initial Pitch formation; defaults to 4-3-3 when omitted */
  formation?: InputMaybe<PitchFormation>;
  /** The ID of the watchlist to update */
  id: Scalars['ID']['input'];
  /** The display name for the watchlist. Trimmed; must be non-empty and at most 50 characters (SE-8449). Unique within the organization regardless of case. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWatchlistPitchAssignmentInput = {
  expectedPitchRevision: Scalars['Int']['input'];
  playerId: Scalars['ID']['input'];
  tacticalSlot?: InputMaybe<TacticalSlot>;
  watchlistId: Scalars['ID']['input'];
};

/** Input for updating a single player's position within a watchlist */
export type UpdateWatchlistPlayerPositionInput = {
  /** The new position for the player */
  newPosition: Scalars['Float']['input'];
  /** The ID of the player */
  playerId: Scalars['ID']['input'];
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

/** Input for updating multiple players' positions within a watchlist */
export type UpdateWatchlistPlayerPositionsInput = {
  /** Array of new positions for players */
  newPositions: Array<NewPosition>;
  /** The ID of the watchlist */
  watchlistId: Scalars['ID']['input'];
};

export type UpdateWatchlistPreferenceOrderInput = {
  expectedPitchRevision: Scalars['Int']['input'];
  orderedPlayerIds: Array<Scalars['ID']['input']>;
  watchlistId: Scalars['ID']['input'];
};

/** Input for upserting organization-scoped player data */
export type UpsertOrganizationPlayerDataInput = {
  /** SE-7328: agent fee paid on the player's contract, in organization currency */
  agentFee?: InputMaybe<Scalars['Float']['input']>;
  /** SE-7328: contract end date as a YYYY-MM-DD literal */
  contractEnd?: InputMaybe<Scalars['String']['input']>;
  /** SE-7328: contract start date as a YYYY-MM-DD literal */
  contractStart?: InputMaybe<Scalars['String']['input']>;
  /** Estimated player valuation in organization currency */
  estValuation?: InputMaybe<Scalars['Float']['input']>;
  /** Gross annual salary in organization currency */
  grossAnnualSalary?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the player */
  playerId: Scalars['ID']['input'];
  /** Player readiness level for squad planning */
  readinessTag?: InputMaybe<ReadinessTag>;
  /** SE-8504: when set, scopes a grossAnnualSalary write to this scenario's own isolated copy instead of the shared organization_player_data row. Must be the only other field named besides playerId and grossAnnualSalary. */
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
  /** SE-7328: transfer fee paid to acquire the player, in organization currency */
  transferFee?: InputMaybe<Scalars['Float']['input']>;
};

/** Creates or updates one player's evaluation on a report. Omitted fields are left unchanged and the clear flags reset them, because quick capture sends small deltas and treating omission as null would erase a scout's work. Writing any capture field sets the noted state; clearing all four clears it. */
export type UpsertPlayerEvaluationInput = {
  /** Set true to return the starter flag to unset, which is different from setting it false. */
  clearIsStarter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set true to clear the note. Takes precedence over note if both are supplied. */
  clearNote?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set true to clear the Performance score back to unscored. Takes precedence over performanceScore if both are supplied. */
  clearPerformanceScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set true to clear the Potential score back to unscored. Takes precedence over potentialScore if both are supplied. */
  clearPotentialScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set true to clear the shirt number back to unknown. Takes precedence over shirtNumber if both are supplied. */
  clearShirtNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the player started. Note that false is a meaningful answer distinct from unset — use clearIsStarter to return to unset. */
  isStarter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of the report this evaluation belongs to */
  matchReportId: Scalars['ID']['input'];
  /** Free-text note about this player in this fixture. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Performance rating, 0 to 10 inclusive. Values outside the range are rejected rather than clamped, since a clamped score silently misreports what the scout entered. */
  performanceScore?: InputMaybe<Scalars['Int']['input']>;
  /** Identifier of the player being evaluated */
  playerId: Scalars['ID']['input'];
  /** Potential rating, 0 to 10 inclusive. */
  potentialScore?: InputMaybe<Scalars['Int']['input']>;
  /** The player's shirt number in this fixture, 1 to 99 inclusive — a capture-time snapshot on this evaluation, immune to later roster churn. Roster metadata rather than a judgement: setting it never makes the player count as noted. Unknown is represented by omission/clearing, never by 0. */
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Team the player is evaluated as playing for. Omit when the side is unsettled. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** The result of writing one player's evaluation: the evaluation itself plus the parent report with its status and counts already recomputed to include this write. Both are returned so a debounced auto-save needs exactly one round trip and can never render counts older than the row on screen. */
export type UpsertPlayerEvaluationPayload = {
  __typename?: 'UpsertPlayerEvaluationPayload';
  /** The evaluation as stored, including the server-owned notedAt and isNoted the client cannot derive itself. */
  evaluation: MatchReportPlayerEvaluation;
  /** The parent report with status, scoredCount, tickedCount, playerCount and squadSize recomputed to include this write, so the header needs no second fetch. */
  matchReport: MatchReport;
};

/** System user including scouts, managers, and administrators with authentication and organization membership information */
export type User = Node & {
  __typename?: 'User';
  cognitoUser?: Maybe<CognitoUser>;
  /** Timestamp of user creation */
  createdAt: Scalars['DateTime']['output'];
  /** Human display name: Cognito full name, else the email local part, else the email, else "Unnamed user". Never null. */
  displayName: Scalars['String']['output'];
  /** User's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user */
  id: Scalars['ID']['output'];
  /** Flag indicating if user is an admin */
  isAdmin: Scalars['Boolean']['output'];
  /** User's preferred language/locale for UI and communications */
  languagePreference: SupportedLocale;
  /** Timestamp of the user's most recent commit of feed visit. Monotonically non-decreasing once set; older values are no-ops. */
  lastFeedVisitAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  /** Foreign key to user's organization */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** User's phone number (max 15 characters) */
  phoneNumber: Scalars['String']['output'];
  role?: Maybe<Role>;
  /** User's job title */
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last user update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a user-activity association tracking which users have seen or read specific activities */
export type UserActivity = Node & {
  __typename?: 'UserActivity';
  /** The associated activity */
  activity: Activity;
  /** Foreign key to activity */
  activityId: Scalars['ID']['output'];
  /** Timestamp of link creation */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for user activity link */
  id: Scalars['ID']['output'];
  /** Flag indicating if activity was read */
  isRead: Scalars['Boolean']['output'];
  /** Flag indicating if activity was seen */
  isSeen: Scalars['Boolean']['output'];
  /** Timestamp of last link update */
  updatedAt: Scalars['DateTime']['output'];
  /** Foreign key to user */
  userId: Scalars['ID']['output'];
};

/** An edge in an ActivityConnection */
export type UserActivityEdge = Edge & {
  __typename?: 'UserActivityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The UserActivity node */
  node: UserActivity;
};

/** Junction record representing a user's permission to access a specific kanban board */
export type UserKanbanBoard = Node & {
  __typename?: 'UserKanbanBoard';
  /** The date and time this permission was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the user kanban board permission */
  id: Scalars['ID']['output'];
  kanbanBoard: KanbanBoard;
  /** The ID of the kanban board */
  kanbanBoardId: Scalars['ID']['output'];
  organization: Organization;
  /** The ID of the organization (for multi-tenancy enforcement) */
  organizationId: Scalars['ID']['output'];
  /** The permission role of the user on the kanban board */
  role: UserKanbanBoardRole;
  /** The date and time this permission was last updated */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** The ID of the user with this permission */
  userId: Scalars['ID']['output'];
};

/** Connection type for paginated UserKanbanBoard results */
export type UserKanbanBoardConnection = Connection & {
  __typename?: 'UserKanbanBoardConnection';
  /** A list of edges */
  edges: Array<UserKanbanBoardEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for UserKanbanBoard connection */
export type UserKanbanBoardEdge = Edge & {
  __typename?: 'UserKanbanBoardEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The UserKanbanBoard node */
  node: UserKanbanBoard;
};

/** The valid permission roles for users on a kanban board. Only applicable to WATCHLIST boards. ROSTER boards maintain organization-wide access. */
export enum UserKanbanBoardRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** Permission levels for note access (OWNER or VIEWER) */
export enum UserNoteRole {
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** Represents user preferences for receiving notifications about different types of activities */
export type UserNotificationPreference = Node & {
  __typename?: 'UserNotificationPreference';
  /** The associated activity type */
  activityType: ActivityType;
  /** Foreign key to activity type */
  activityTypeId: Scalars['String']['output'];
  /** Timestamp of preference creation */
  createdAt: Scalars['DateTime']['output'];
  /** Flag indicating if notifications are enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier for preference */
  id: Scalars['ID']['output'];
  /** Timestamp of last preference update */
  updatedAt: Scalars['DateTime']['output'];
  /** Foreign key to user */
  userId: Scalars['String']['output'];
};

/** One person's EDITOR or VIEWER grant on a scenario; the owner is never a grant */
export type UserScenario = Node & {
  __typename?: 'UserScenario';
  /** Timestamp of the grant */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the grant */
  id: Scalars['ID']['output'];
  /** True while the invitee holds an ACTIVE membership; false = grant kept, ineffective */
  isMembershipActive: Scalars['Boolean']['output'];
  /** The scenario's organization */
  organizationId: Scalars['ID']['output'];
  /** EDITOR or VIEWER on a grant row */
  role: ScenarioRole;
  /** The shared scenario */
  scenarioId: Scalars['ID']['output'];
  user: User;
  /** The invited user */
  userId: Scalars['ID']['output'];
};

/** The roles a scenario grant can carry: EDITOR or VIEWER. OWNER is never grantable */
export enum UserScenarioRole {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

/** Permission levels for scout report access (OWNER or VIEWER) */
export enum UserScoutReportRole {
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** A conversation thread belonging to a user */
export type UserThread = {
  __typename?: 'UserThread';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** First question in thread */
  firstQuestion?: Maybe<Scalars['String']['output']>;
  /** Unique thread identifier */
  id: Scalars['String']['output'];
  /** Favorite flag */
  isFavorite: Scalars['Boolean']['output'];
  /** Last access timestamp */
  lastAccessed: Scalars['DateTime']['output'];
  /** Last answer provided */
  lastAnswer?: Maybe<Scalars['String']['output']>;
  /** Last question asked */
  lastQuestion?: Maybe<Scalars['String']['output']>;
  /** Total message count */
  messageCount: Scalars['Int']['output'];
  /** Thread metadata */
  metadata: ThreadMetadata;
  /** Organization ID */
  organizationId: Scalars['String']['output'];
  /** Thread status */
  status: Scalars['String']['output'];
  /** Thread title */
  title?: Maybe<Scalars['String']['output']>;
  /** Total tokens used */
  totalTokensUsed: Scalars['Int']['output'];
  /** Number of conversation turns */
  turnCount: Scalars['Int']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Owner user ID */
  userId: Scalars['String']['output'];
};

/** Paginated list of user threads */
export type UserThreadConnection = {
  __typename?: 'UserThreadConnection';
  /** List of thread edges */
  edges: Array<UserThreadEdge>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Total thread count */
  totalCount: Scalars['Int']['output'];
};

/** Edge containing a UserThread and its cursor */
export type UserThreadEdge = {
  __typename?: 'UserThreadEdge';
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** The thread at this edge */
  node: UserThread;
};

/** Links users to their watchlists with role-based access and positioning information for personalized player tracking */
export type UserWatchlist = Node & {
  __typename?: 'UserWatchlist';
  /** The date and time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** max(direct, group) at read time */
  effectiveRole: UserWatchlistRole;
  /** DIRECT = a grant; GROUP = a presence row of a member reached only through the group grant (no authorization weight) */
  grantSource: UserWatchlistGrantSource;
  /** Unique identifier for the user watchlist link */
  id: Scalars['ID']['output'];
  /** Flag indicating if this is the user's default watchlist */
  isDefault: Scalars['Boolean']['output'];
  /** True while the user holds an ACTIVE membership; false = grant kept, ineffective */
  isMembershipActive: Scalars['Boolean']['output'];
  /** Timestamp of the most recent time the user selected this watchlist from the See all lists drawer. NULL means never selected. */
  lastSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  organization: Organization;
  /** The id of the organization associated with the record */
  organizationId: Scalars['ID']['output'];
  /** For sorting, the user defined position the record should appear in */
  position: Scalars['Float']['output'];
  /** The role of the user on the watchlist */
  role: UserWatchlistRole;
  /** The date and time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** The id of the user associated with the record */
  userId: Scalars['ID']['output'];
  watchlist: Watchlist;
  /** The id of the watchlist associated with the record */
  watchlistId: Scalars['ID']['output'];
};

/** Connection type for paginated UserWatchlist results */
export type UserWatchlistConnection = Connection & {
  __typename?: 'UserWatchlistConnection';
  /** A list of edges */
  edges: Array<UserWatchlistEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total rows across every page (SE-8683). Set by listMyUserWatchlists so a client — including the Ask Gemini agent — knows how many lists to page through; null where a query does not compute it. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Edge type for UserWatchlist connection */
export type UserWatchlistEdge = Edge & {
  __typename?: 'UserWatchlistEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The UserWatchlist node */
  node: UserWatchlist;
};

/** GROUP = presence row only, no authorization weight */
export enum UserWatchlistGrantSource {
  Direct = 'DIRECT',
  Group = 'GROUP'
}

/** The valid roles for collaborators on a watchlist */
export enum UserWatchlistRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** Validation error codes for user profile validation */
export enum ValidationCodes {
  MissingFirstName = 'MISSING_FIRST_NAME',
  MissingLastName = 'MISSING_LAST_NAME',
  MissingTitle = 'MISSING_TITLE'
}

/** Response type containing validation error codes for user profile validation */
export type ValidationResponse = {
  __typename?: 'ValidationResponse';
  /** List of validation error codes indicating missing required fields */
  codes: Array<ValidationCodes>;
};

/** Which writer last asserted the player's gross annual salary: a human (MANUAL) or the contract bridge (CONTRACT). MANUAL wins over CONTRACT everywhere Compliance and the wage bill read wages (SE-8409). */
export enum WageSource {
  Contract = 'CONTRACT',
  Manual = 'MANUAL'
}

/** Named collections of players that users want to monitor, supporting collaborative scouting and player tracking */
export type Watchlist = Node & {
  __typename?: 'Watchlist';
  /** Timestamp of watchlist creation */
  createdAt: Scalars['DateTime']['output'];
  /** The list's group grants; null unless the caller is the OWNER */
  groupGrants?: Maybe<Array<GroupGrant>>;
  /** Unique identifier for the watchlist */
  id: Scalars['ID']['output'];
  isOnWatchlist: Scalars['Boolean']['output'];
  /** Timestamp of the most recent activity on this watchlist (rename, player added, player removed). Drives See all lists drawer ordering. Null on rows untouched since the column was introduced — clients should fall back to updatedAt for those. */
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** The caller's max(direct, group) role; null = no access */
  myEffectiveRole?: Maybe<UserWatchlistRole>;
  /** Name of the watchlist */
  name: Scalars['String']['output'];
  playerCount: Scalars['Int']['output'];
  players: PlayerConnection;
  /** Timestamp of last watchlist update */
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};


/** Named collections of players that users want to monitor, supporting collaborative scouting and player tracking */
export type WatchlistIsOnWatchlistArgs = {
  playerId?: InputMaybe<Scalars['ID']['input']>;
};


/** Named collections of players that users want to monitor, supporting collaborative scouting and player tracking */
export type WatchlistPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
};

export type WatchlistBulkMembershipPayload = {
  __typename?: 'WatchlistBulkMembershipPayload';
  addedPlayerIds: Array<Scalars['ID']['output']>;
  alreadyPresentPlayerIds: Array<Scalars['ID']['output']>;
  notPresentPlayerIds: Array<Scalars['ID']['output']>;
  pitchRevision: Scalars['Int']['output'];
  placementOutcomes: Array<WatchlistBulkPlacementOutcome>;
  removedPlayerIds: Array<Scalars['ID']['output']>;
  watchlist: Watchlist;
};

/** Requested tactical slot for one player of the batch; honoured only when the slot exists in the list's formation and is free */
export type WatchlistBulkPlacementInput = {
  /** A player id also listed in playerIds */
  playerId: Scalars['ID']['input'];
  /** The slot requested for the player */
  tacticalSlot: TacticalSlot;
};

export type WatchlistBulkPlacementOutcome = {
  __typename?: 'WatchlistBulkPlacementOutcome';
  outcome: WatchlistBulkPlacementResult;
  playerId: Scalars['ID']['output'];
  requestedSlot: TacticalSlot;
  tacticalSlot?: Maybe<TacticalSlot>;
};

/** Outcome of one requested placement on addPlayersToWatchlist: PLACED wrote the slot; the other values left the player Unassigned (new member) or untouched (existing member) */
export enum WatchlistBulkPlacementResult {
  AlreadyPresent = 'ALREADY_PRESENT',
  Placed = 'PLACED',
  SlotNotInFormation = 'SLOT_NOT_IN_FORMATION',
  /** @deprecated Never returned: a Pitch slot holds any number of members (SE-8626) */
  SlotTaken = 'SLOT_TAKEN'
}

/** Connection type for paginated Watchlist results */
export type WatchlistConnection = Connection & {
  __typename?: 'WatchlistConnection';
  /** A list of edges */
  edges: Array<WatchlistEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge type for Watchlist connection */
export type WatchlistEdge = Edge & {
  __typename?: 'WatchlistEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The Watchlist node */
  node: Watchlist;
};

export type WatchlistPitch = {
  __typename?: 'WatchlistPitch';
  canEdit: Scalars['Boolean']['output'];
  formation: PitchFormation;
  id: Scalars['ID']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** SE-8467: who last wrote the pitch — the name the conflict banner shows; null before the first pitch write */
  lastEditedBy?: Maybe<PitchEditor>;
  manualOrder: Scalars['Boolean']['output'];
  members: WatchlistPitchMemberConnection;
  name: Scalars['String']['output'];
  overlay: Array<WatchlistPitchOverlayPlayer>;
  overlayCount: Scalars['Int']['output'];
  pitchInitialized: Scalars['Boolean']['output'];
  pitchRevision: Scalars['Int']['output'];
  role: UserWatchlistRole;
  watchlistCount: Scalars['Int']['output'];
};

export type WatchlistPitchAssignmentPayload = {
  __typename?: 'WatchlistPitchAssignmentPayload';
  assignments: Array<WatchlistPitchSavedAssignment>;
  formation: PitchFormation;
  pitchInitialized: Scalars['Boolean']['output'];
  pitchRevision: Scalars['Int']['output'];
  watchlistId: Scalars['ID']['output'];
};

export type WatchlistPitchFilterInput = {
  competitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customStats?: InputMaybe<Array<CustomStatFilterInput>>;
  feet?: InputMaybe<Array<PlayerFoot>>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxAerials?: InputMaybe<Scalars['Float']['input']>;
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  maxAnticipating?: InputMaybe<Scalars['Float']['input']>;
  maxAssisting?: InputMaybe<Scalars['Float']['input']>;
  maxBuildup?: InputMaybe<Scalars['Float']['input']>;
  maxCarrying?: InputMaybe<Scalars['Float']['input']>;
  maxCreating?: InputMaybe<Scalars['Float']['input']>;
  maxCrossing?: InputMaybe<Scalars['Float']['input']>;
  maxDefensiveAerials?: InputMaybe<Scalars['Float']['input']>;
  maxDribbling?: InputMaybe<Scalars['Float']['input']>;
  maxFinishing?: InputMaybe<Scalars['Float']['input']>;
  maxFitScore?: InputMaybe<Scalars['Float']['input']>;
  maxGkCrossIntercept?: InputMaybe<Scalars['Float']['input']>;
  maxGkKeeperSweeper?: InputMaybe<Scalars['Float']['input']>;
  maxGkPassing?: InputMaybe<Scalars['Float']['input']>;
  maxGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  maxGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  maxGpm?: InputMaybe<Scalars['Float']['input']>;
  maxGpr?: InputMaybe<Scalars['Float']['input']>;
  maxHeading?: InputMaybe<Scalars['Float']['input']>;
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  maxMinutesPlayed?: InputMaybe<Scalars['Float']['input']>;
  maxPassing?: InputMaybe<Scalars['Float']['input']>;
  maxPressing?: InputMaybe<Scalars['Float']['input']>;
  maxProactiveDefending?: InputMaybe<Scalars['Float']['input']>;
  maxSetPieceDelivering?: InputMaybe<Scalars['Float']['input']>;
  maxShooting?: InputMaybe<Scalars['Float']['input']>;
  maxShotPlacement?: InputMaybe<Scalars['Float']['input']>;
  maxTackling?: InputMaybe<Scalars['Float']['input']>;
  maxTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  maxVaep?: InputMaybe<Scalars['Float']['input']>;
  minAerials?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Float']['input']>;
  minAnticipating?: InputMaybe<Scalars['Float']['input']>;
  minAssisting?: InputMaybe<Scalars['Float']['input']>;
  minBuildup?: InputMaybe<Scalars['Float']['input']>;
  minCarrying?: InputMaybe<Scalars['Float']['input']>;
  minCreating?: InputMaybe<Scalars['Float']['input']>;
  minCrossing?: InputMaybe<Scalars['Float']['input']>;
  minDefensiveAerials?: InputMaybe<Scalars['Float']['input']>;
  minDribbling?: InputMaybe<Scalars['Float']['input']>;
  minFinishing?: InputMaybe<Scalars['Float']['input']>;
  minFitScore?: InputMaybe<Scalars['Float']['input']>;
  minGkCrossIntercept?: InputMaybe<Scalars['Float']['input']>;
  minGkKeeperSweeper?: InputMaybe<Scalars['Float']['input']>;
  minGkPassing?: InputMaybe<Scalars['Float']['input']>;
  minGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  minGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  minGpm?: InputMaybe<Scalars['Float']['input']>;
  minGpr?: InputMaybe<Scalars['Float']['input']>;
  minHeading?: InputMaybe<Scalars['Float']['input']>;
  minHeight?: InputMaybe<Scalars['Float']['input']>;
  minMinutesPlayed?: InputMaybe<Scalars['Float']['input']>;
  minPassing?: InputMaybe<Scalars['Float']['input']>;
  minPressing?: InputMaybe<Scalars['Float']['input']>;
  minProactiveDefending?: InputMaybe<Scalars['Float']['input']>;
  minSetPieceDelivering?: InputMaybe<Scalars['Float']['input']>;
  minShooting?: InputMaybe<Scalars['Float']['input']>;
  minShotPlacement?: InputMaybe<Scalars['Float']['input']>;
  minTackling?: InputMaybe<Scalars['Float']['input']>;
  minTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  minVaep?: InputMaybe<Scalars['Float']['input']>;
  nationalities?: InputMaybe<Array<Scalars['String']['input']>>;
  nationalityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  outerClusterName?: InputMaybe<Scalars['String']['input']>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleArchetypes?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tacticalSlots?: InputMaybe<Array<TacticalSlot>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WatchlistPitchMember = {
  __typename?: 'WatchlistPitchMember';
  assignmentOrigin: PitchAssignmentOrigin;
  club?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  effectiveSlot?: Maybe<TacticalSlot>;
  gpr?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  naturalPositions: Array<WatchlistPitchNaturalPosition>;
  playerId: Scalars['ID']['output'];
  primaryPositionCode?: Maybe<Scalars['String']['output']>;
  primaryPositionSource: PrimaryPositionSource;
  rank: Scalars['Int']['output'];
};

export type WatchlistPitchMemberConnection = {
  __typename?: 'WatchlistPitchMemberConnection';
  edges: Array<WatchlistPitchMemberEdge>;
  pageInfo: PageInfo;
};

export type WatchlistPitchMemberEdge = {
  __typename?: 'WatchlistPitchMemberEdge';
  cursor: Scalars['String']['output'];
  node: WatchlistPitchMember;
};

export type WatchlistPitchNaturalPosition = {
  __typename?: 'WatchlistPitchNaturalPosition';
  abbreviation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WatchlistPitchOverlayPlayer = {
  __typename?: 'WatchlistPitchOverlayPlayer';
  age?: Maybe<Scalars['Int']['output']>;
  club?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  gpr?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Country name from the sporting statistics, matching the player table. */
  nationality?: Maybe<Scalars['String']['output']>;
  naturalPositions: Array<WatchlistPitchNaturalPosition>;
  rosterTier: WatchlistPitchRosterTier;
};

export enum WatchlistPitchRosterTier {
  Academy = 'ACADEMY',
  FirstTeam = 'FIRST_TEAM'
}

export type WatchlistPitchSavedAssignment = {
  __typename?: 'WatchlistPitchSavedAssignment';
  playerId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  tacticalSlot?: Maybe<TacticalSlot>;
};

export type WatchlistPreferenceOrderPayload = {
  __typename?: 'WatchlistPreferenceOrderPayload';
  manualOrder: Scalars['Boolean']['output'];
  orderedPlayers: Array<WatchlistPreferenceOrderedPlayer>;
  pitchRevision: Scalars['Int']['output'];
  watchlistId: Scalars['ID']['output'];
};

export type WatchlistPreferenceOrderedPlayer = {
  __typename?: 'WatchlistPreferenceOrderedPlayer';
  playerId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
};

/** Lightweight watchlist summary showing which lists contain a scouting target */
export type WatchlistSummary = {
  __typename?: 'WatchlistSummary';
  /** Watchlist unique identifier */
  id: Scalars['ID']['output'];
  /** Watchlist display name */
  name: Scalars['String']['output'];
};

/** Lightweight watchlist reference within a scout's ownership list */
export type WatchlistSummaryItem = {
  __typename?: 'WatchlistSummaryItem';
  /** Watchlist unique identifier */
  id: Scalars['ID']['output'];
  /** Watchlist display name */
  name: Scalars['String']['output'];
};

export type ListFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFeatureFlagsQuery = { __typename?: 'Query', listFeatureFlags: any };

export type ActivityFeedFragment = { __typename?: 'UserActivity', id: string, activityId: string, isRead: boolean, isSeen: boolean, createdAt: string, userId: string, activity: { __typename?: 'Activity', id: string, body: string, deepLink?: string | null, metadata?: Record<string, any> | null, targetId?: string | null, createdAt: string, title: string, notificationTitle?: string | null, notificationBody?: string | null, iconUrl?: string | null, userId?: string | null, activityType: { __typename?: 'ActivityType', id: string, code: string, name: string }, user?: { __typename?: 'User', id: string, title?: string | null, displayName: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } };

export type ListActivitiesFeedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListActivitiesFeedQuery = { __typename?: 'Query', listMyActivities: { __typename?: 'ActivityConnection', edges: Array<{ __typename?: 'UserActivityEdge', node: { __typename?: 'UserActivity', id: string, activityId: string, isRead: boolean, isSeen: boolean, createdAt: string, userId: string, activity: { __typename?: 'Activity', id: string, body: string, deepLink?: string | null, metadata?: Record<string, any> | null, targetId?: string | null, createdAt: string, title: string, notificationTitle?: string | null, notificationBody?: string | null, iconUrl?: string | null, userId?: string | null, activityType: { __typename?: 'ActivityType', id: string, code: string, name: string }, user?: { __typename?: 'User', id: string, title?: string | null, displayName: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type MarkActivitiesAsReadMutationVariables = Exact<{
  input: MarkActivitiesAsReadInput;
}>;


export type MarkActivitiesAsReadMutation = { __typename?: 'Mutation', markActivitiesAsRead: boolean };

export type ActivityFeedGetPlayerNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivityFeedGetPlayerNameQuery = { __typename?: 'Query', getPlayer?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string } | null };

export type AuthCognitoUserAttributeFragment = { __typename?: 'CognitoUserAttribute', Name: string, Value: string };

export type AuthOrganizationFragment = { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> };

export type AuthCognitoUserFragment = { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null };

export type AuthAuthenticationResultFragment = { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, tokenType?: string | null, refreshToken?: string | null, idToken?: string | null };

export type AuthSignInResultFragment = { __typename?: 'SignInResult', message: string, data: { __typename?: 'ChallengeResult', ChallengeName?: string | null, Session?: string | null, ChallengeParameters?: { __typename?: 'ChallengeParametersResult', USERNAME?: string | null, attempts?: string | null, attemptsLeft?: string | null, email?: string | null, maxAttempts?: string | null } | null } };

export type AuthGetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthGetUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, organizationId?: string | null, phoneNumber: string, isAdmin: boolean, title?: string | null, languagePreference: SupportedLocale, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } | null };

export type AuthRefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type AuthRefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'AuthenticationResultWithMessage', message?: string | null, data?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, tokenType?: string | null, refreshToken?: string | null, idToken?: string | null } | null } };

export type MessageFragment = { __typename?: 'Message', message: string };

export type AuthChallengeParametersResultFragment = { __typename?: 'ChallengeParametersResult', USERNAME?: string | null, attempts?: string | null, attemptsLeft?: string | null, email?: string | null, maxAttempts?: string | null };

export type AuthChallengeResultFragment = { __typename?: 'ChallengeResult', ChallengeName?: string | null, Session?: string | null, ChallengeParameters?: { __typename?: 'ChallengeParametersResult', USERNAME?: string | null, attempts?: string | null, attemptsLeft?: string | null, email?: string | null, maxAttempts?: string | null } | null };

export type AuthAuthenticationResultWithMessageFragment = { __typename?: 'AuthenticationResultWithMessage', message?: string | null, data?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, tokenType?: string | null, refreshToken?: string | null, idToken?: string | null } | null };

export type AuthConfirmSignInResultFragment = { __typename?: 'ConfirmSignInResult', validationCodes?: Array<ValidationCodes> | null, errorMessage?: { __typename?: 'Message', message: string } | null, authResult?: { __typename?: 'AuthenticationResultWithMessage', message?: string | null, data?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, tokenType?: string | null, refreshToken?: string | null, idToken?: string | null } | null } | null, signInResult?: { __typename?: 'SignInResult', message: string, data: { __typename?: 'ChallengeResult', ChallengeName?: string | null, Session?: string | null, ChallengeParameters?: { __typename?: 'ChallengeParametersResult', USERNAME?: string | null, attempts?: string | null, attemptsLeft?: string | null, email?: string | null, maxAttempts?: string | null } | null } } | null };

export type AuthUserFragment = { __typename?: 'User', id: string, email?: string | null, organizationId?: string | null, phoneNumber: string, isAdmin: boolean, title?: string | null, languagePreference: SupportedLocale, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null };

export type AuthSignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type AuthSignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInResult', message: string, data: { __typename?: 'ChallengeResult', Session?: string | null } } };

export type AuthResendVerifyIdentifierMutationVariables = Exact<{
  input: ResendOtpInput;
}>;


export type AuthResendVerifyIdentifierMutation = { __typename?: 'Mutation', resendOTP: { __typename?: 'SignInResult', data: { __typename?: 'ChallengeResult', Session?: string | null } } };

export type AuthConfirmSignInMutationVariables = Exact<{
  input: ConfirmSignInInput;
}>;


export type AuthConfirmSignInMutation = { __typename?: 'Mutation', confirmSignIn: { __typename?: 'ConfirmSignInResult', validationCodes?: Array<ValidationCodes> | null, errorMessage?: { __typename?: 'Message', message: string } | null, authResult?: { __typename?: 'AuthenticationResultWithMessage', message?: string | null, data?: { __typename?: 'AuthenticationResult', accessToken?: string | null, expiresIn?: number | null, tokenType?: string | null, refreshToken?: string | null, idToken?: string | null } | null } | null, signInResult?: { __typename?: 'SignInResult', message: string, data: { __typename?: 'ChallengeResult', ChallengeName?: string | null, Session?: string | null, ChallengeParameters?: { __typename?: 'ChallengeParametersResult', USERNAME?: string | null, attempts?: string | null, attemptsLeft?: string | null, email?: string | null, maxAttempts?: string | null } | null } } | null } };

export type AuthUpdateMyProfileMutationVariables = Exact<{
  input: UpdateMyProfileInput;
}>;


export type AuthUpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile: { __typename?: 'User', id: string, email?: string | null, organizationId?: string | null, phoneNumber: string, isAdmin: boolean, title?: string | null, languagePreference: SupportedLocale, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type AuthSignOutMutationVariables = Exact<{
  input: SignOutInput;
}>;


export type AuthSignOutMutation = { __typename?: 'Mutation', signOut: { __typename?: 'Message', message: string } };

export type AuthSignOutAllDevicesMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthSignOutAllDevicesMutation = { __typename?: 'Mutation', signOutAllDevices: { __typename?: 'Message', message: string } };

export type AuthMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, organizationId?: string | null, phoneNumber: string, isAdmin: boolean, title?: string | null, languagePreference: SupportedLocale, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } | null };

export type AuthDeactivateMeMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthDeactivateMeMutation = { __typename?: 'Mutation', deactivateMe: { __typename?: 'User', id: string, email?: string | null, organizationId?: string | null, phoneNumber: string, isAdmin: boolean, title?: string | null, languagePreference: SupportedLocale, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type ComparePlayersPlayerResultFragment = { __typename?: 'SimilarPlayerResult', similarityScore?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null };

export type ComparePlayersSimilarPlayerConnectionFragment = { __typename?: 'SimilarPlayerConnection', edges: Array<{ __typename?: 'SimilarPlayerEdge', node: { __typename?: 'SimilarPlayerResult', similarityScore?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type ComparePlayersListSimilarPlayersQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SimilarPlayerFilterInput>;
}>;


export type ComparePlayersListSimilarPlayersQuery = { __typename?: 'Query', listSimilarPlayers: { __typename?: 'SimilarPlayerConnection', edges: Array<{ __typename?: 'SimilarPlayerEdge', node: { __typename?: 'SimilarPlayerResult', similarityScore?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CompareGetComparisonPlayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompareGetComparisonPlayerQuery = { __typename?: 'Query', getPlayer?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } | null };

export type PlayerContractsOverviewQueryVariables = Exact<{
  archivedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlayerContractsOverviewQuery = { __typename?: 'Query', playerContractsOverview: { __typename?: 'PlayerContractsOverview', players: Array<{ __typename?: 'PlayerContractRow', playerId: string, name: string, age?: number | null, tier: string, position?: string | null, contractEndDate?: string | null, contractStatus?: ContractExtractionStatus | null, transferStatus?: ContractExtractionStatus | null, transferFeeNotAppliedReason?: string | null, lastUpdated?: string | null }>, firstTeamCompleteness: { __typename?: 'TierCompleteness', contractsTotal: number, contractsSaved: number, transfersTotal: number, transfersSaved: number }, academyCompleteness: { __typename?: 'TierCompleteness', contractsTotal: number, contractsSaved: number, transfersTotal: number, transfersSaved: number }, loaneeCompleteness: { __typename?: 'TierCompleteness', contractsTotal: number, contractsSaved: number, transfersTotal: number, transfersSaved: number } } };

export type ArchiveContractExtractionMutationVariables = Exact<{
  input: ArchiveContractExtractionInput;
}>;


export type ArchiveContractExtractionMutation = { __typename?: 'Mutation', archiveContractExtraction: { __typename?: 'ContractExtractionObject', id: string, playerId: string, documentType: DocumentType, status: ContractExtractionStatus } };

export type UnarchiveContractExtractionMutationVariables = Exact<{
  extractionId: Scalars['ID']['input'];
}>;


export type UnarchiveContractExtractionMutation = { __typename?: 'Mutation', unarchiveContractExtraction: { __typename?: 'ContractExtractionObject', id: string, playerId: string, documentType: DocumentType, status: ContractExtractionStatus } };

export type CreateContractUploadUrlMutationVariables = Exact<{
  input: CreateContractUploadUrlInput;
}>;


export type CreateContractUploadUrlMutation = { __typename?: 'Mutation', createContractUploadUrl: { __typename?: 'ContractUploadUrlResult', presignedUrl: string, s3Key: string } };

export type ListContractDocumentsQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type ListContractDocumentsQuery = { __typename?: 'Query', listContractDocuments: Array<{ __typename?: 'ContractDocument', fileName: string, fileSize: number, uploadedAt: string, s3Key: string, contentType: string }> };

export type GetContractDocumentPreviewUrlQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
}>;


export type GetContractDocumentPreviewUrlQuery = { __typename?: 'Query', getContractDocumentPreviewUrl: string };

export type DeleteContractDocumentMutationVariables = Exact<{
  playerId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
}>;


export type DeleteContractDocumentMutation = { __typename?: 'Mutation', deleteContractDocument: boolean };

export type GetContractExtractionQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  documentType: DocumentType;
}>;


export type GetContractExtractionQuery = { __typename?: 'Query', getContractExtraction?: { __typename?: 'ContractExtractionObject', id: string, playerId: string, documentType: DocumentType, status: ContractExtractionStatus, extractedData: any, extractedAt?: string | null, savedAt?: string | null, endDate?: string | null } | null };

export type EditContractEndDateMutationVariables = Exact<{
  input: EditContractEndDateInput;
}>;


export type EditContractEndDateMutation = { __typename?: 'Mutation', editContractEndDate: { __typename?: 'ContractExtractionObject', id: string, playerId: string, documentType: DocumentType, status: ContractExtractionStatus, extractedData: any, extractedAt?: string | null, savedAt?: string | null, endDate?: string | null } };

export type DeleteContractExtractionMutationVariables = Exact<{
  input: DeleteContractExtractionInput;
  confirmation: Scalars['String']['input'];
}>;


export type DeleteContractExtractionMutation = { __typename?: 'Mutation', deleteContractExtraction: boolean };

export type AddContractLineItemMutationVariables = Exact<{
  input: AddContractLineItemInput;
}>;


export type AddContractLineItemMutation = { __typename?: 'Mutation', addContractLineItem: { __typename?: 'ContractLineItemResult', success: boolean } };

export type TriggerContractExtractionMutationVariables = Exact<{
  input: TriggerContractExtractionInput;
}>;


export type TriggerContractExtractionMutation = { __typename?: 'Mutation', triggerContractExtraction: { __typename?: 'ContractExtractionObject', id: string, status: ContractExtractionStatus } };

export type ResolveCategoryConflictsMutationVariables = Exact<{
  input: ResolveCategoryConflictsInput;
}>;


export type ResolveCategoryConflictsMutation = { __typename?: 'Mutation', resolveCategoryConflicts: { __typename?: 'ContractLineItemResult', success: boolean } };

export type SaveContractExtractionMutationVariables = Exact<{
  extractionId: Scalars['ID']['input'];
}>;


export type SaveContractExtractionMutation = { __typename?: 'Mutation', saveContractExtraction: { __typename?: 'ContractExtractionObject', id: string, status: ContractExtractionStatus, savedAt?: string | null } };

export type DashboardLeagueFragment = { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean };

export type DashboardLeagueEdgeFragment = { __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean } };

export type DashboardLeagueConnectionFragment = { __typename?: 'LeagueConnection', edges: Array<{ __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type DashboardTeamFragment = { __typename?: 'Team', id: string, name: string };

export type DashboardPositionFragment = { __typename?: 'Position', id: string, name: string, abbreviation?: string | null };

export type DashboardPlayerBioDataFragment = { __typename?: 'PlayerBioData', ggPlayerKey: string, contractExpires?: string | null, onLoanFrom?: string | null };

export type DashboardTransferFragment = { __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null }> | null } | null };

export type DashboardTransferEdgeFragment = { __typename?: 'TransferEdge', cursor: string, node: { __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null }> | null } | null } };

export type DashboardTransferConnectionFragment = { __typename?: 'TransferConnection', edges: Array<{ __typename?: 'TransferEdge', cursor: string, node: { __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null }> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type DashboardPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, contractExpires?: string | null, onLoanFrom?: string | null } | null };

export type DashboardPlayerEdgeFragment = { __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, contractExpires?: string | null, onLoanFrom?: string | null } | null } };

export type DashboardPlayerConnectionFragment = { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, contractExpires?: string | null, onLoanFrom?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type DashboardListMyOrganizationsLeaguesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardListMyOrganizationsLeaguesQuery = { __typename?: 'Query', listMyOrganizationsLeagues: { __typename?: 'LeagueConnection', edges: Array<{ __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DashboardListRecentTransfersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardListRecentTransfersQuery = { __typename?: 'Query', listRecentTransfers: { __typename?: 'TransferConnection', edges: Array<{ __typename?: 'TransferEdge', cursor: string, node: { __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null }> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DashboardExpiringContractFragment = { __typename?: 'ExpiringContractModel', id: string, playerId: string, position?: string | null, teamName?: string | null, contractExpires: string, monthsRemaining: number, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string } | null };

export type DashboardExpiringContractEdgeFragment = { __typename?: 'ExpiringContractEdge', cursor: string, node: { __typename?: 'ExpiringContractModel', id: string, playerId: string, position?: string | null, teamName?: string | null, contractExpires: string, monthsRemaining: number, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string } | null } };

export type DashboardExpiringContractConnectionFragment = { __typename?: 'ExpiringContractConnection', edges: Array<{ __typename?: 'ExpiringContractEdge', cursor: string, node: { __typename?: 'ExpiringContractModel', id: string, playerId: string, position?: string | null, teamName?: string | null, contractExpires: string, monthsRemaining: number, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type DashboardListExpiringContractsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  thresholdMonths?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardListExpiringContractsQuery = { __typename?: 'Query', listExpiringContracts: { __typename?: 'ExpiringContractConnection', edges: Array<{ __typename?: 'ExpiringContractEdge', cursor: string, node: { __typename?: 'ExpiringContractModel', id: string, playerId: string, position?: string | null, teamName?: string | null, contractExpires: string, monthsRemaining: number, player?: { __typename?: 'Player', id: string, name: string, firstName: string, knownName?: string | null, lastName: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DashboardGetExpiringContractsCountQueryVariables = Exact<{
  thresholdMonths?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardGetExpiringContractsCountQuery = { __typename?: 'Query', getExpiringContractsCount: number };

export type DashboardListPositionDistributionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardListPositionDistributionDataQuery = { __typename?: 'Query', listPositionDistributionData: Array<{ __typename?: 'PositionDistributionPoint', playerId: string, positionCategory?: PositionCategory | null, gpr: number, source: PlayerSource, player?: { __typename?: 'Player', name: string, firstName: string, lastName: string, knownName?: string | null } | null }> };

export type DashboardRadarMetricsFragment = { __typename?: 'RadarMetrics', gpr: number, passing: number, dribbling: number, carrying: number, shooting: number };

export type DashboardRosterStatsFragment = { __typename?: 'RosterStats', avgGpr: number, avgAge: number, totalMarketValue: number, playerCount: number };

export type DashboardGetTeamLeagueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardGetTeamLeagueStatsQuery = { __typename?: 'Query', getTeamLeagueStats: { __typename?: 'TeamLeagueStats', teamGprRank: number, totalTeams: number, teamPercentiles: { __typename?: 'RadarMetrics', gpr: number, passing: number, dribbling: number, carrying: number, shooting: number }, leagueAveragePercentiles: { __typename?: 'RadarMetrics', gpr: number, passing: number, dribbling: number, carrying: number, shooting: number }, rosterStats: { __typename?: 'RosterStats', avgGpr: number, avgAge: number, totalMarketValue: number, playerCount: number } } };

export type DashboardLeaguePlayerSearchNodeFragment = { __typename?: 'LeaguePlayerSearchNode', id: string, gpr?: number | null, player?: { __typename?: 'Player', name: string, firstName: string, lastName: string, knownName?: string | null, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null, name: string }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null, passingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null } | null } | null };

export type DashboardLeaguePlayerSearchEdgeFragment = { __typename?: 'LeaguePlayerSearchEdge', cursor: string, node: { __typename?: 'LeaguePlayerSearchNode', id: string, gpr?: number | null, player?: { __typename?: 'Player', name: string, firstName: string, lastName: string, knownName?: string | null, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null, name: string }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null, passingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null } | null } | null } };

export type DashboardSearchLeaguePlayersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardSearchLeaguePlayersQuery = { __typename?: 'Query', searchLeaguePlayers: { __typename?: 'LeaguePlayerSearchConnection', edges: Array<{ __typename?: 'LeaguePlayerSearchEdge', cursor: string, node: { __typename?: 'LeaguePlayerSearchNode', id: string, gpr?: number | null, player?: { __typename?: 'Player', name: string, firstName: string, lastName: string, knownName?: string | null, positions?: Array<{ __typename?: 'Position', abbreviation?: string | null, name: string }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null, passingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ComplianceViewerTierQueryVariables = Exact<{ [key: string]: never; }>;


export type ComplianceViewerTierQuery = { __typename?: 'Query', complianceOverview: { __typename?: 'ComplianceOverview', organizationId: string, scenarioId?: string | null, viewerTier: ComplianceSensitivityTier } };

export type CompliancePlanStatusQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CompliancePlanStatusQuery = { __typename?: 'Query', complianceOverview: { __typename?: 'ComplianceOverview', organizationId: string, scenarioId?: string | null, isScenarioProjection: boolean, viewerTier: ComplianceSensitivityTier, permittedQuantities: Array<ComplianceQuantity>, ruleCount: number, alertCount: number, breachCount: number, layers: Array<{ __typename?: 'ComplianceLayerGroup', layer: ComplianceRuleLayer, evaluations: Array<{ __typename?: 'ComplianceRuleEvaluation', ruleId: string, ruleName: string, metricId: string, metricName: string, layer: ComplianceRuleLayer, state: ComplianceRuleState, value?: number | null, threshold?: number | null, deviation?: number | null, unit: ComplianceQuantityUnit, comparator: ComplianceComparator, showKpi: boolean, partialReasons: Array<CompliancePartialReason>, unverifiableFigures: Array<string>, completeness: ComplianceCompleteness, denominatorSource?: ComplianceDenominatorSource | null, missingInputs: Array<ComplianceQuantity>, excludedInputs: Array<{ __typename?: 'ComplianceExcludedInput', quantity: ComplianceQuantity, subjectCount: number }>, trend: { __typename?: 'ComplianceTrend', hasHistory: boolean, points: Array<{ __typename?: 'ComplianceTrendPoint', value?: number | null, period: { __typename?: 'CompliancePeriod', periodStart: string, periodEnd: string } }> } }> }> } };

export type ClubObjectivesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClubObjectivesQuery = { __typename?: 'Query', complianceOverview: { __typename?: 'ComplianceOverview', organizationId: string, scenarioId?: string | null, viewerTier: ComplianceSensitivityTier, layers: Array<{ __typename?: 'ComplianceLayerGroup', layer: ComplianceRuleLayer, evaluations: Array<{ __typename?: 'ComplianceRuleEvaluation', ruleId: string, ruleName: string, regimeName?: string | null, regimeKey?: string | null, ruleFamily?: ComplianceRuleFamily | null, layer: ComplianceRuleLayer, metricId: string, metricName: string, comparator: ComplianceComparator, threshold?: number | null, amberThreshold?: number | null, basisLabel?: string | null, consequence?: string | null, showKpi: boolean, state: ComplianceRuleState, partialReasons: Array<CompliancePartialReason>, isWindowComplete: boolean, unit: ComplianceQuantityUnit, value?: number | null, window: ComplianceAssessmentWindow, completeness: ComplianceCompleteness, denominatorSource?: ComplianceDenominatorSource | null, missingInputs: Array<ComplianceQuantity>, warnOnly: boolean, unverifiableFigures: Array<string>, excludedInputs: Array<{ __typename?: 'ComplianceExcludedInput', quantity: ComplianceQuantity, subjectCount: number }>, knownFigures: Array<{ __typename?: 'ComplianceKnownFigure', label: string, value?: number | null, unit: ComplianceQuantityUnit, isLowerBound: boolean }>, coveredPeriods: Array<{ __typename?: 'CompliancePeriod', periodStart: string, periodEnd: string }>, trend: { __typename?: 'ComplianceTrend', hasHistory: boolean, points: Array<{ __typename?: 'ComplianceTrendPoint', value?: number | null, period: { __typename?: 'CompliancePeriod', periodStart: string, periodEnd: string } }> } }> }> } };

export type AllClubObjectivesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllClubObjectivesQuery = { __typename?: 'Query', clubObjectives: Array<{ __typename?: 'ClubObjective', id: string, name: string, metricId: string, metricName: string, category: ComplianceMetricCategory, comparator: ComplianceComparator, threshold: number, amberThreshold?: number | null, assessmentWindow: ComplianceAssessmentWindow, showKpi: boolean, isEnabled: boolean }> };

export type ComplianceMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type ComplianceMetricsQuery = { __typename?: 'Query', complianceMetrics?: Array<{ __typename?: 'ComplianceMetricSummary', id: string, name: string, category: ComplianceMetricCategory, isGlobal: boolean, kind: ComplianceMetricKind, requiredTier: ComplianceSensitivityTier }> | null };

export type CreateClubObjectiveMutationVariables = Exact<{
  input: CreateClubObjectiveInput;
}>;


export type CreateClubObjectiveMutation = { __typename?: 'Mutation', createClubObjective: { __typename?: 'ClubObjective', id: string, organizationId: string, name: string, metricId: string, metricName: string, category: ComplianceMetricCategory, comparator: ComplianceComparator, threshold: number, amberThreshold?: number | null, assessmentWindow: ComplianceAssessmentWindow, showKpi: boolean, isEnabled: boolean } };

export type UpdateClubObjectiveMutationVariables = Exact<{
  input: UpdateClubObjectiveInput;
}>;


export type UpdateClubObjectiveMutation = { __typename?: 'Mutation', updateClubObjective: { __typename?: 'ClubObjective', id: string, organizationId: string, name: string, metricId: string, metricName: string, category: ComplianceMetricCategory, comparator: ComplianceComparator, threshold: number, amberThreshold?: number | null, assessmentWindow: ComplianceAssessmentWindow, showKpi: boolean, isEnabled: boolean } };

export type DeleteClubObjectiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClubObjectiveMutation = { __typename?: 'Mutation', deleteClubObjective: string };

export type CreateComplianceMetricMutationVariables = Exact<{
  input: CreateComplianceMetricInput;
}>;


export type CreateComplianceMetricMutation = { __typename?: 'Mutation', createComplianceMetric: { __typename?: 'ComplianceMetricSummary', id: string, name: string, category: ComplianceMetricCategory, isGlobal: boolean, kind: ComplianceMetricKind, requiredTier: ComplianceSensitivityTier } };

export type ComplianceLayersQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ComplianceLayersQuery = { __typename?: 'Query', complianceOverview: { __typename?: 'ComplianceOverview', organizationId: string, scenarioId?: string | null, isScenarioProjection: boolean, viewerTier: ComplianceSensitivityTier, asOf: string, domesticRegimeState: ComplianceDomesticRegimeState, isCalendarConfigured: boolean, layers: Array<{ __typename?: 'ComplianceLayerGroup', layer: ComplianceRuleLayer, evaluations: Array<{ __typename?: 'ComplianceRuleEvaluation', ruleId: string, ruleName: string, regimeName?: string | null, regimeKey?: string | null, ruleFamily?: ComplianceRuleFamily | null, metricId: string, metricName: string, layer: ComplianceRuleLayer, state: ComplianceRuleState, value?: number | null, threshold?: number | null, amberThreshold?: number | null, deviation?: number | null, unit: ComplianceQuantityUnit, comparator: ComplianceComparator, window: ComplianceAssessmentWindow, isWindowComplete: boolean, partialReasons: Array<CompliancePartialReason>, missingInputs: Array<ComplianceQuantity>, warnOnly: boolean, unverifiableFigures: Array<string>, completeness: ComplianceCompleteness, denominatorSource?: ComplianceDenominatorSource | null, showKpi: boolean, consequence?: string | null, knownFigures: Array<{ __typename?: 'ComplianceKnownFigure', label: string, value?: number | null, unit: ComplianceQuantityUnit, isLowerBound: boolean }>, excludedInputs: Array<{ __typename?: 'ComplianceExcludedInput', quantity: ComplianceQuantity, subjectCount: number }>, missingPeriods: Array<{ __typename?: 'CompliancePeriod', periodStart: string, periodEnd: string }>, computedFix: { __typename?: 'ComplianceComputedFix', availability: ComplianceFixAvailability, clearsRule: boolean, direction?: ComplianceFixDirection | null, isTargetExclusive: boolean, requiredChange?: number | null, targetValue?: number | null, unit: ComplianceQuantityUnit, reasons: Array<ComplianceFixUncomputableReason>, numeratorUnavailableReason?: ComplianceInversionUnavailableReason | null, numeratorChange?: { __typename?: 'ComplianceFixNumeratorChange', label: string, direction: ComplianceFixDirection, currentValue: number, requiredChange: number, targetValue: number, unit: ComplianceQuantityUnit } | null, saleOffset?: { __typename?: 'ComplianceFixSaleOffset', label: string, direction: ComplianceFixDirection, capitalGain: number, unit: ComplianceQuantityUnit } | null }, drivers: Array<{ __typename?: 'ComplianceDriver', subjectId: string, label: string, value: number, unit: ComplianceQuantityUnit, sharePercent?: number | null }>, trend: { __typename?: 'ComplianceTrend', hasHistory: boolean } }> }> } };

export type ComplianceForeignPlayerCountQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ComplianceForeignPlayerCountQuery = { __typename?: 'Query', complianceOverview: { __typename?: 'ComplianceOverview', organizationId: string, scenarioId?: string | null, foreignPlayerCount: { __typename?: 'ComplianceForeignPlayerCount', clubCountry?: string | null, foreignCount: number, domesticCount: number, hasAnyInput: boolean, breakdown: Array<{ __typename?: 'ComplianceForeignPlayerRow', subjectId: string, label: string, nationalityName: string, isForeign: boolean }> } } };

export type PsrClubCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type PsrClubCalendarQuery = { __typename?: 'Query', complianceClubCalendar?: { __typename?: 'ComplianceClubCalendar', id: string, fiscalYearStartMonth: number } | null };

export type PsrEnteredFiguresQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
}>;


export type PsrEnteredFiguresQuery = { __typename?: 'Query', complianceFinancialFigures: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, recordedAt: string, amount: number, restatesId?: string | null, restatementNote?: string | null }> };

export type AdjustedRevenueEnteredFiguresQueryVariables = Exact<{
  to?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdjustedRevenueEnteredFiguresQuery = { __typename?: 'Query', complianceFinancialFigures: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number, restatesId?: string | null, restatementNote?: string | null }> };

// SE-8792 frontend follow-up: hand-applied rather than a full
// `generate:types:staging`/`:dev` regen, which fails on PRE-EXISTING unrelated
// schema drift — `src/features/player-detail/operations.graphql`'s dead
// `PlayerDetailPlayerDataSummary` fragment still queries
// `PlayerDataSummary.openAiThreadId`/`openAiSummary`, fields SE-8431 removed
// from both the dev and staging schemas. Same justification PR #7812's
// `fix(financial-compliance): name League Two SCMP's new figures when
// missing [SE-8792]` already gave for the four enum members above.
export type LeagueTwoScmpEnteredFiguresQueryVariables = Exact<{
  to?: InputMaybe<Scalars['String']['input']>;
}>;


export type LeagueTwoScmpEnteredFiguresQuery = { __typename?: 'Query', relevantTurnover: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number }>, allowablePmTradingIncome: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number }>, equityInjectionReceivedAnnual: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number }>, managerSalaryAnnual: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number }>, agentsFeesPayableAnnual: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number }>, nonEstablishedU21PlayerCostAnnual: Array<{ __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number }> };

export type RecordComplianceFinancialFigureMutationVariables = Exact<{
  input: RecordComplianceFinancialFigureInput;
}>;


export type RecordComplianceFinancialFigureMutation = { __typename?: 'Mutation', recordComplianceFinancialFigure: { __typename?: 'RecordComplianceFinancialFigureResult', isRestatement: boolean, restatedAt?: string | null, effectiveRestatementNote?: string | null, figure: { __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number, restatesId?: string | null, restatementNote?: string | null }, effectiveFigure?: { __typename?: 'ComplianceFinancialFigure', id: string, effectiveFrom: string, amount: number, restatesId?: string | null, restatementNote?: string | null } | null } };

export type UpdateRegimeRuleTargetMutationVariables = Exact<{
  input: UpdateRegimeRuleTargetInput;
}>;


export type UpdateRegimeRuleTargetMutation = { __typename?: 'Mutation', updateRegimeRuleTarget: { __typename?: 'ComplianceRegimeRuleOverride', id: string, organizationId: string, ruleId: string, comparator: ComplianceComparator, threshold: number, amberThreshold?: number | null, showKpi: boolean } };

export type UpdateKpiTargetMutationVariables = Exact<{
  input: UpdateKpiTargetInput;
}>;


export type UpdateKpiTargetMutation = { __typename?: 'Mutation', updateKpiTarget: { __typename?: 'ClubObjective', id: string, organizationId: string, name: string, metricId: string, metricName: string, category: ComplianceMetricCategory, comparator: ComplianceComparator, threshold: number, amberThreshold?: number | null, assessmentWindow: ComplianceAssessmentWindow, showKpi: boolean, isEnabled: boolean } };

export type ComplianceDraftEvaluationQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
  draftActions?: InputMaybe<Array<ScenarioActionInput> | ScenarioActionInput>;
}>;


export type ComplianceDraftEvaluationQuery = { __typename?: 'Query', complianceOverview: { __typename?: 'ComplianceOverview', organizationId: string, scenarioId?: string | null, viewerTier: ComplianceSensitivityTier, permittedQuantities: Array<ComplianceQuantity>, layers: Array<{ __typename?: 'ComplianceLayerGroup', layer: ComplianceRuleLayer, evaluations: Array<{ __typename?: 'ComplianceRuleEvaluation', ruleId: string, ruleName: string, metricName: string, layer: ComplianceRuleLayer, state: ComplianceRuleState, value?: number | null, threshold?: number | null, unit: ComplianceQuantityUnit, comparator: ComplianceComparator, partialReasons: Array<CompliancePartialReason>, unverifiableFigures: Array<string>, showKpi: boolean }> }> } };

export type FixturePlanningMatchFragment = { __typename?: 'Match', id: string, scheduledThingId: string, scheduledDate: string, scheduledEndDate?: string | null, datePrecision: MatchDatePrecision, startTime?: string | null, timeZone?: string | null, venue?: string | null, status: MatchStatus, timeframe: MatchTimeframe, source: MatchSource, competitionName?: string | null, homeTeamScore?: number | null, awayTeamScore?: number | null, league?: { __typename?: 'League', id: string, name: string } | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string } };

export type FixturePlanningMatchesQueryVariables = Exact<{
  filter: MatchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FixturePlanningMatchesQuery = { __typename?: 'Query', listMatches: { __typename?: 'MatchConnection', edges: Array<{ __typename?: 'MatchEdge', cursor: string, node: { __typename?: 'Match', id: string, scheduledThingId: string, scheduledDate: string, scheduledEndDate?: string | null, datePrecision: MatchDatePrecision, startTime?: string | null, timeZone?: string | null, venue?: string | null, status: MatchStatus, timeframe: MatchTimeframe, source: MatchSource, competitionName?: string | null, homeTeamScore?: number | null, awayTeamScore?: number | null, league?: { __typename?: 'League', id: string, name: string } | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type FixturePlanningAssignmentsQueryVariables = Exact<{
  filter: AssignmentFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FixturePlanningAssignmentsQuery = { __typename?: 'Query', listAssignments: { __typename?: 'AssignmentConnection', edges: Array<{ __typename?: 'AssignmentEdge', cursor: string, node: { __typename?: 'Assignment', id: string, status: AssignmentStatus, scheduledThing: { __typename?: 'GenericScheduledThing', scheduledThingId: string } | { __typename?: 'Match', scheduledThingId: string }, assigneeUser: { __typename?: 'User', id: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type FixturePlanningAssignableScoutsQueryVariables = Exact<{
  input?: InputMaybe<ListAssignableScoutsInput>;
}>;


export type FixturePlanningAssignableScoutsQuery = { __typename?: 'Query', listAssignableScouts: Array<{ __typename?: 'AssignableScout', id: string, displayName: string, title?: string | null, sameDayAssignmentCount: number }> };

export type FixturePlanningLeaguesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FixturePlanningLeaguesQuery = { __typename?: 'Query', listLeagues: { __typename?: 'LeagueConnection', edges: Array<{ __typename?: 'LeagueEdge', node: { __typename?: 'League', id: string, name: string, country?: string | null, gender: Gender } }> } };

export type FixturePlanningSearchTeamsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FixturePlanningSearchTeamsQuery = { __typename?: 'Query', searchTeams: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', node: { __typename?: 'Team', id: string, name: string, gender: Gender, league?: { __typename?: 'League', id: string, name: string } | null } }> } };

export type FixturePlanningCreateMatchMutationVariables = Exact<{
  input: CreateMatchInput;
}>;


export type FixturePlanningCreateMatchMutation = { __typename?: 'Mutation', createMatch: { __typename?: 'Match', id: string, scheduledThingId: string, scheduledDate: string, scheduledEndDate?: string | null, datePrecision: MatchDatePrecision, startTime?: string | null, timeZone?: string | null, venue?: string | null, status: MatchStatus, timeframe: MatchTimeframe, source: MatchSource, competitionName?: string | null, homeTeamScore?: number | null, awayTeamScore?: number | null, league?: { __typename?: 'League', id: string, name: string } | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string } } };

export type FixturePlanningCreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type FixturePlanningCreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, gender: Gender, league?: { __typename?: 'League', id: string, name: string } | null } };

export type FixturePlanningSetAssignmentsMutationVariables = Exact<{
  input: SetMatchAssignmentsInput;
}>;


export type FixturePlanningSetAssignmentsMutation = { __typename?: 'Mutation', setMatchAssignments: { __typename?: 'Match', id: string, scheduledThingId: string } };

export type FixturePlanningMyReportsQueryVariables = Exact<{
  filter: MatchReportFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FixturePlanningMyReportsQuery = { __typename?: 'Query', listMatchReports: { __typename?: 'MatchReportConnection', edges: Array<{ __typename?: 'MatchReportEdge', node: { __typename?: 'MatchReport', id: string, submittedAt?: string | null, notedCount: number, match: { __typename?: 'Match', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type HomeGetScoutingWidgetSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeGetScoutingWidgetSummaryQuery = { __typename?: 'Query', getScoutingWidgetSummary: { __typename?: 'ScoutingWidgetSummary', totalWatchlistPlayers: number, withoutReportCount: number, noAction30DaysCount: number } };

export type HomeListTargetsWithoutReportQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeListTargetsWithoutReportQuery = { __typename?: 'Query', listTargetsWithoutReport: Array<{ __typename?: 'ScoutingTargetPlayer', playerId: string, name: string, primaryPosition: string, teamName: string, watchlistName: string }> };

export type HomeListTargetsNoAction30DaysQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeListTargetsNoAction30DaysQuery = { __typename?: 'Query', listTargetsNoAction30Days: Array<{ __typename?: 'ScoutingTargetPlayer', playerId: string, name: string, primaryPosition: string, teamName: string, watchlistName: string, lastActionDate?: string | null, lastActionType?: string | null }> };

export type HomeGetSquadGprDistributionQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeGetSquadGprDistributionQuery = { __typename?: 'Query', getSquadGprDistribution: { __typename?: 'SquadGprDistribution', totalFirstTeamPlayers: number, gpr80Plus: number, gpr70to79: number, gprBelow70: number } };

export type HomeListFirstTeamPlayersByGprBandQueryVariables = Exact<{
  band: GprBand;
}>;


export type HomeListFirstTeamPlayersByGprBandQuery = { __typename?: 'Query', listFirstTeamPlayersByGprBand: Array<{ __typename?: 'GprBandPlayer', playerId: string, name: string, primaryPosition: string, teamName: string, gpr: number }> };

export type HomeListInjuredRosterPlayersQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeListInjuredRosterPlayersQuery = { __typename?: 'Query', listInjuredRosterPlayers: Array<{ __typename?: 'InjuredPlayer', playerId: string, name: string, primaryPosition: string, injuryDate: string, daysMissed?: number | null, injuryType: string }> };

export type HomeListOnLoanPlayersQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeListOnLoanPlayersQuery = { __typename?: 'Query', listOnLoanPlayers: Array<{ __typename?: 'OnLoanPlayer', playerId: string, name: string, primaryPosition: string, onLoanFrom: string, contractExpires?: string | null }> };

export type HomeGetRosterExpiringContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeGetRosterExpiringContractsQuery = { __typename?: 'Query', getRosterExpiringContracts: { __typename?: 'RosterExpiringContracts', expiring6Months?: number | null, expiring12Months?: number | null } };

export type HomeListRosterExpiringContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeListRosterExpiringContractsQuery = { __typename?: 'Query', listRosterExpiringContracts?: Array<{ __typename?: 'ExpiringContractPlayer', playerId: string, name: string, primaryPosition: string, teamName: string, contractExpires: string }> | null };

export type HomeGetPositionalProfileCoverageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeGetPositionalProfileCoverageQuery = { __typename?: 'Query', getPositionalProfileCoverage: Array<{ __typename?: 'PositionalProfileCoverage', profileName: string, playerCount: number }> };

export type HomeListTargetsByPositionalProfileQueryVariables = Exact<{
  profileName: Scalars['String']['input'];
}>;


export type HomeListTargetsByPositionalProfileQuery = { __typename?: 'Query', listTargetsByPositionalProfile: Array<{ __typename?: 'ScoutingTargetPlayer', playerId: string, name: string, primaryPosition: string, teamName: string, watchlistName: string }> };

export type HomeGetLeagueGprSpectrumQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeGetLeagueGprSpectrumQuery = { __typename?: 'Query', getLeagueGprSpectrum: { __typename?: 'LeagueGprSpectrum', userClubGpr?: number | null, userClubRank?: number | null, lowestClubGpr: number, highestClubGpr: number, leagueAverageGpr: number, totalClubs: number } };

export type InvitationsOrganizationConnectionFragment = { __typename?: 'OrganizationConnection', edges: Array<{ __typename?: 'OrganizationEdge', cursor: string, node: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type InvitationsOrganizationEdgeFragment = { __typename?: 'OrganizationEdge', cursor: string, node: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } };

export type InvitationsOrganizationFragment = { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null };

export type InvitationsRoleConnectionFragment = { __typename?: 'RoleConnection', edges: Array<{ __typename?: 'RoleEdge', cursor: string, node: { __typename?: 'Role', id: string, name: RoleName } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type InvitationsRoleEdgeFragment = { __typename?: 'RoleEdge', cursor: string, node: { __typename?: 'Role', id: string, name: RoleName } };

export type InvitationsRoleFragment = { __typename?: 'Role', id: string, name: RoleName };

export type InvitationsSportConnectionFragment = { __typename?: 'SportConnection', edges: Array<{ __typename?: 'SportEdge', cursor: string, node: { __typename?: 'Sport', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type InvitationsSportEdgeFragment = { __typename?: 'SportEdge', cursor: string, node: { __typename?: 'Sport', id: string, name: string } };

export type InvitationsSportFragment = { __typename?: 'Sport', id: string, name: string };

export type InvitationsInvitationConnectionFragment = { __typename?: 'InvitationConnection', edges: Array<{ __typename?: 'InvitationEdge', cursor: string, node: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type InvitationsInvitationEdgeFragment = { __typename?: 'InvitationEdge', cursor: string, node: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type InvitationsInvitationFragment = { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null };

export type InvitationsOrganizationUserConnectionFragment = { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, status: OrganizationUserStatus, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type InvitationsOrganizationUserEdgeFragment = { __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, status: OrganizationUserStatus, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } };

export type InvitationsOrganizationUserFragment = { __typename?: 'OrganizationUser', id: string, status: OrganizationUserStatus, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null };

export type InvitationsListMySentInvitationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListMySentInvitationsQuery = { __typename?: 'Query', listMySentInvitations: { __typename?: 'InvitationConnection', edges: Array<{ __typename?: 'InvitationEdge', cursor: string, node: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsListMyOrganiationsSentInvitationsQueryVariables = Exact<{
  status?: InputMaybe<InvitationStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListMyOrganiationsSentInvitationsQuery = { __typename?: 'Query', listMyOrganizationsSentInvitations: { __typename?: 'InvitationConnection', edges: Array<{ __typename?: 'InvitationEdge', cursor: string, node: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsListMyReceivedInvitationsQueryVariables = Exact<{
  status?: InputMaybe<InvitationStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListMyReceivedInvitationsQuery = { __typename?: 'Query', listMyReceivedInvitations: { __typename?: 'InvitationConnection', edges: Array<{ __typename?: 'InvitationEdge', cursor: string, node: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsListMyOrganizationsOrganizationUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListMyOrganizationsOrganizationUsersQuery = { __typename?: 'Query', listMyOrganizationsOrganizationUsers: { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, status: OrganizationUserStatus, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsListSportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListSportsQuery = { __typename?: 'Query', listSports: { __typename?: 'SportConnection', edges: Array<{ __typename?: 'SportEdge', cursor: string, node: { __typename?: 'Sport', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsListRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListRolesQuery = { __typename?: 'Query', listRoles: { __typename?: 'RoleConnection', edges: Array<{ __typename?: 'RoleEdge', cursor: string, node: { __typename?: 'Role', id: string, name: RoleName } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsGetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InvitationsGetOrganizationQuery = { __typename?: 'Query', getOrganization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } | null };

export type InvitationsListOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListOrganizationsQuery = { __typename?: 'Query', listOrganizations: { __typename?: 'OrganizationConnection', edges: Array<{ __typename?: 'OrganizationEdge', cursor: string, node: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsListMyOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsListMyOrganizationsQuery = { __typename?: 'Query', listMyOrganizations: { __typename?: 'OrganizationConnection', edges: Array<{ __typename?: 'OrganizationEdge', cursor: string, node: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InvitationsCreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type InvitationsCreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } | null };

export type InvitationsLogIntoOrganizationMutationVariables = Exact<{
  input: LogIntoOrganizationInput;
}>;


export type InvitationsLogIntoOrganizationMutation = { __typename?: 'Mutation', logIntoOrganization?: { __typename?: 'User', id: string, email?: string | null, organizationId?: string | null, phoneNumber: string, isAdmin: boolean, title?: string | null, languagePreference: SupportedLocale, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Enabled: boolean, UserStatus: CognitoUserStatus, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sportId?: string | null, defaultNoteVisibility: boolean, defaultScoutReportVisibility: boolean, teamSelectionMode: TeamSelectionMode, organizationTeams: Array<{ __typename?: 'OrganizationTeam', id: string, teamId: string }>, recommendationTypes: Array<{ __typename?: 'RecommendationType', type: string, label: string }> } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } | null };

export type InvitationsUpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type InvitationsUpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'Organization', id: string, name: string, currencyCode: CurrencyCode, intakeFormUrl?: string | null, sport?: { __typename?: 'Sport', id: string, name: string } | null } | null };

export type InvitationsCreateInvitationMutationVariables = Exact<{
  input: CreateInvitationInput;
}>;


export type InvitationsCreateInvitationMutation = { __typename?: 'Mutation', createInvitation: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type InvitationsAcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type InvitationsAcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type InvitationsResendInvitationMutationVariables = Exact<{
  input: ResendInvitationInput;
}>;


export type InvitationsResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type InvitationsDeleteInvitationMutationVariables = Exact<{
  input: DeleteInvitationInput;
}>;


export type InvitationsDeleteInvitationMutation = { __typename?: 'Mutation', deleteInvitation: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type InvitationActivateUserMutationVariables = Exact<{
  input: ActivateOrganizationUserInput;
}>;


export type InvitationActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'OrganizationUser', id: string, status: OrganizationUserStatus, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } };

export type InvitationDeactivateUserMutationVariables = Exact<{
  input: DeactivateOrganizationUserInput;
}>;


export type InvitationDeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'OrganizationUser', id: string, status: OrganizationUserStatus, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } };

export type InvitationRejectInvitationMutationVariables = Exact<{
  input: RejectInvitationInput;
}>;


export type InvitationRejectInvitationMutation = { __typename?: 'Mutation', rejectInvitation: { __typename?: 'Invitation', id: string, status: InvitationStatus, phoneNumber: string, receiver?: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, user?: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null, role?: { __typename?: 'Role', id: string, name: RoleName } | null } };

export type SearchMyThreadsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchMyThreadsQuery = { __typename?: 'Query', searchMyThreads: { __typename?: 'UserThreadConnection', edges: Array<{ __typename?: 'UserThreadEdge', node: { __typename?: 'UserThread', id: string, firstQuestion?: string | null, lastAccessed: string, messageCount: number, title?: string | null, status: string, isFavorite: boolean, createdAt: string, updatedAt: string } }> } };

export type GetThreadQueryVariables = Exact<{
  threadId: Scalars['String']['input'];
}>;


export type GetThreadQuery = { __typename?: 'Query', getThread?: { __typename?: 'UserThread', createdAt: string, firstQuestion?: string | null, id: string, isFavorite: boolean, lastAccessed: string, lastAnswer?: string | null, lastQuestion?: string | null, messageCount: number, organizationId: string, status: string, title?: string | null, updatedAt: string, userId: string, metadata: { __typename?: 'ThreadMetadata', lastUpdated?: string | null, language?: string | null, customFields?: any | null, topic?: string | null, tags?: Array<string> | null, sentiment?: string | null, sessionContext?: any | null, messages: Array<{ __typename?: 'ConversationMessage', content: string, id: string, role: ConversationRole, timestamp: string, metadata?: { __typename?: 'ConversationMessageMetadata', model?: string | null, inputTokens?: number | null, outputTokens?: number | null, dataSources?: Array<string> | null, additionalData?: any | null } | null }> } } | null };

export type ToggleThreadFavoriteMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
}>;


export type ToggleThreadFavoriteMutation = { __typename?: 'Mutation', toggleThreadFavorite: { __typename?: 'UserThread', id: string, isFavorite: boolean, updatedAt: string } };

export type UpdateThreadStatusMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateThreadStatusMutation = { __typename?: 'Mutation', updateThreadStatus: { __typename?: 'UserThread', id: string, status: string, updatedAt: string } };

export type MatchDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchDetailQuery = { __typename?: 'Query', getMatch?: { __typename?: 'Match', id: string, scheduledThingId: string, scheduledDate: string, scheduledEndDate?: string | null, datePrecision: MatchDatePrecision, startTime?: string | null, timeZone?: string | null, venue?: string | null, status: MatchStatus, source: MatchSource, competitionName?: string | null, homeTeamScore?: number | null, awayTeamScore?: number | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string } } | null };

export type MatchDetailAssignmentsQueryVariables = Exact<{
  filter: AssignmentFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MatchDetailAssignmentsQuery = { __typename?: 'Query', listAssignments: { __typename?: 'AssignmentConnection', edges: Array<{ __typename?: 'AssignmentEdge', node: { __typename?: 'Assignment', id: string, assigneeUser: { __typename?: 'User', id: string, displayName: string } } }> } };

export type MatchDetailReportsQueryVariables = Exact<{
  filter: MatchReportFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MatchDetailReportsQuery = { __typename?: 'Query', listMatchReports: { __typename?: 'MatchReportConnection', edges: Array<{ __typename?: 'MatchReportEdge', node: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, scoutUser: { __typename?: 'User', id: string, displayName: string } } }> } };

export type MatchEventsQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchEventsQuery = { __typename?: 'Query', listMatchEvents: Array<{ __typename?: 'MatchEvent', id: string, kind: MatchEventKind, minute?: number | null, matchId: string, team: { __typename?: 'Team', id: string, name: string }, player?: { __typename?: 'Player', id: string, name: string } | null }> };

export type MatchAppearancesQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchAppearancesQuery = { __typename?: 'Query', listMatchAppearances: Array<{ __typename?: 'MatchAppearance', id: string, minutesPlayed?: number | null, matchId: string, team: { __typename?: 'Team', id: string, name: string }, player: { __typename?: 'Player', id: string, name: string } }> };

export type CreateMatchEventMutationVariables = Exact<{
  input: CreateMatchEventInput;
}>;


export type CreateMatchEventMutation = { __typename?: 'Mutation', createMatchEvent: { __typename?: 'MatchEvent', id: string, kind: MatchEventKind, minute?: number | null, matchId: string, team: { __typename?: 'Team', id: string, name: string }, player?: { __typename?: 'Player', id: string, name: string } | null } };

export type UpdateMatchEventMutationVariables = Exact<{
  input: UpdateMatchEventInput;
}>;


export type UpdateMatchEventMutation = { __typename?: 'Mutation', updateMatchEvent: { __typename?: 'MatchEvent', id: string, kind: MatchEventKind, minute?: number | null, matchId: string, team: { __typename?: 'Team', id: string, name: string }, player?: { __typename?: 'Player', id: string, name: string } | null } };

export type DeleteMatchEventMutationVariables = Exact<{
  matchEventId: Scalars['ID']['input'];
}>;


export type DeleteMatchEventMutation = { __typename?: 'Mutation', deleteMatchEvent: boolean };

export type SetMatchAppearanceMutationVariables = Exact<{
  input: SetMatchAppearanceInput;
}>;


export type SetMatchAppearanceMutation = { __typename?: 'Mutation', setMatchAppearance: { __typename?: 'MatchAppearance', id: string, minutesPlayed?: number | null, matchId: string, team: { __typename?: 'Team', id: string, name: string }, player: { __typename?: 'Player', id: string, name: string } } };

export type DeleteMatchAppearanceMutationVariables = Exact<{
  matchAppearanceId: Scalars['ID']['input'];
}>;


export type DeleteMatchAppearanceMutation = { __typename?: 'Mutation', deleteMatchAppearance: boolean };

export type MatchReportCaptureSquadPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type MatchReportCaptureSquadQueryVariables = Exact<{
  filter: PlayerAdvancedFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchReportCaptureSquadQuery = { __typename?: 'Query', filterPlayers: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type MatchReportCaptureEvaluationFragment = { __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null };

export type MatchReportCaptureReportFragment = { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> };

export type MatchReportCaptureFixtureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchReportCaptureFixtureQuery = { __typename?: 'Query', getMatch?: { __typename?: 'Match', id: string, scheduledDate: string, startTime?: string | null, venue?: string | null, competitionName?: string | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string } } | null };

export type MatchReportCaptureCreateReportMutationVariables = Exact<{
  input: CreateMatchReportInput;
}>;


export type MatchReportCaptureCreateReportMutation = { __typename?: 'Mutation', createMatchReport: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } };

export type MatchReportCaptureSetSquadMutationVariables = Exact<{
  input: SetMatchReportSquadInput;
}>;


export type MatchReportCaptureSetSquadMutation = { __typename?: 'Mutation', setMatchReportSquad: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } };

export type MatchReportCaptureAddSquadPlayersMutationVariables = Exact<{
  input: AddMatchReportSquadPlayersInput;
}>;


export type MatchReportCaptureAddSquadPlayersMutation = { __typename?: 'Mutation', addMatchReportSquadPlayers: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } };

export type MatchReportCaptureUpdateReportMutationVariables = Exact<{
  input: UpdateMatchReportInput;
}>;


export type MatchReportCaptureUpdateReportMutation = { __typename?: 'Mutation', updateMatchReport: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } };

export type MatchReportCaptureUpsertEvaluationMutationVariables = Exact<{
  input: UpsertPlayerEvaluationInput;
}>;


export type MatchReportCaptureUpsertEvaluationMutation = { __typename?: 'Mutation', upsertPlayerEvaluation: { __typename?: 'UpsertPlayerEvaluationPayload', evaluation: { __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }, matchReport: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } } };

export type MatchReportCaptureSubmitMutationVariables = Exact<{
  input: SubmitMatchReportInput;
}>;


export type MatchReportCaptureSubmitMutation = { __typename?: 'Mutation', submitMatchReport: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } };

export type MatchReportCapturePublishMutationVariables = Exact<{
  input: PublishMatchReportInput;
}>;


export type MatchReportCapturePublishMutation = { __typename?: 'Mutation', publishMatchReport: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, playerCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, hasUnpublishedChanges: boolean, lastPublishedAt?: string | null, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, createdAt: string, isNoted: boolean, isStarter?: boolean | null, note?: string | null, notedAt?: string | null, performanceScore?: number | null, potentialScore?: number | null, shirtNumber?: number | null, updatedAt: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, isManual: boolean, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string } | null }> } };

export type MatchReportCaptureDisciplineSignalFragment = { __typename?: 'PlayerDisciplineSignal', playerId: string, recordedRedCards: number, recordedYellowCards: number, suspensionWarning?: SuspensionWarning | null };

export type MatchReportCaptureDisciplineSignalsQueryVariables = Exact<{
  playerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MatchReportCaptureDisciplineSignalsQuery = { __typename?: 'Query', listPlayerDisciplineSignals: Array<{ __typename?: 'PlayerDisciplineSignal', playerId: string, recordedRedCards: number, recordedYellowCards: number, suspensionWarning?: SuspensionWarning | null }> };

export type MatchReportViewReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchReportViewReportQuery = { __typename?: 'Query', getMatchReport?: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, watchMode?: MatchWatchMode | null, submittedAt?: string | null, updatedAt: string, playerCount: number, notedCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, match: { __typename?: 'Match', id: string, scheduledDate: string, startTime?: string | null, timeZone?: string | null, venue?: string | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string }, league?: { __typename?: 'League', id: string, name: string } | null }, scoutUser: { __typename?: 'User', id: string, displayName: string }, scouts: Array<{ __typename?: 'User', id: string, displayName: string }>, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, isNoted: boolean, isStarter?: boolean | null, performanceScore?: number | null, potentialScore?: number | null, note?: string | null, shirtNumber?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, positions?: Array<{ __typename?: 'Position', id: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null }> } | null };

export type NotesNoteFragment = { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } };

export type NotesGetNoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotesGetNoteQuery = { __typename?: 'Query', getNote?: { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } | null };

export type NotesListNotesByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotesListNotesByPlayerIdQuery = { __typename?: 'Query', listNotesByPlayerId: { __typename?: 'NoteConnection', edges: Array<{ __typename?: 'NoteEdge', cursor: string, node: { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type NotesCreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type NotesCreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type NotesUpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type NotesUpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type NotesDeleteNoteMutationVariables = Exact<{
  input: DeleteNoteInput;
}>;


export type NotesDeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type NotesNoteShareFragment = { __typename?: 'NoteShare', userId: string, role: UserNoteRole, createdAt: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } };

export type NotesShareNoteMutationVariables = Exact<{
  input: ShareNoteInput;
}>;


export type NotesShareNoteMutation = { __typename?: 'Mutation', shareNote: boolean };

export type NotesListNoteSharesQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type NotesListNoteSharesQuery = { __typename?: 'Query', listNoteShares: Array<{ __typename?: 'NoteShare', userId: string, role: UserNoteRole, createdAt: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } }> };

export type NotesRevokeNoteShareMutationVariables = Exact<{
  input: RevokeNoteShareInput;
}>;


export type NotesRevokeNoteShareMutation = { __typename?: 'Mutation', revokeNoteShare: boolean };

export type NotesSetNoteVisibilityMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
}>;


export type NotesSetNoteVisibilityMutation = { __typename?: 'Mutation', setNoteVisibility: { __typename?: 'Note', id: string, createdAt: string, updatedAt: string, title: string, body: string, isPublic: boolean, playerId: string, userId: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type NotificationSettingPreferenceFragment = { __typename?: 'UserNotificationPreference', id: string, userId: string, activityTypeId: string, enabled: boolean, createdAt: string, updatedAt: string, activityType: { __typename?: 'ActivityType', id: string, code: string, name: string, description?: string | null, createdAt: string, updatedAt: string } };

export type NotificationSettingTypeFragment = { __typename?: 'ActivityType', id: string, code: string, name: string, description?: string | null, createdAt: string, updatedAt: string };

export type UserNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationPreferencesQuery = { __typename?: 'Query', userNotificationPreferences: Array<{ __typename?: 'UserNotificationPreference', id: string, userId: string, activityTypeId: string, enabled: boolean, createdAt: string, updatedAt: string, activityType: { __typename?: 'ActivityType', id: string, code: string, name: string, description?: string | null, createdAt: string, updatedAt: string } }> };

export type UpdateAllNotificationPreferencesMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateAllNotificationPreferencesMutation = { __typename?: 'Mutation', updateAllNotificationPreferences: boolean };

export type UpdateNotificationPreferenceMutationVariables = Exact<{
  activityTypeCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateNotificationPreferenceMutation = { __typename?: 'Mutation', updateNotificationPreference: { __typename?: 'UserNotificationPreference', id: string, userId: string, activityTypeId: string, enabled: boolean, createdAt: string, updatedAt: string, activityType: { __typename?: 'ActivityType', id: string, code: string, name: string, description?: string | null, createdAt: string, updatedAt: string } } };

export type PlayerDetailPositionFragment = { __typename?: 'Position', id: string, name: string, abbreviation?: string | null };

export type PlayerDetailTeamFragment = { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string } | null };

export type PlayerDetailNationalityFragment = { __typename?: 'Nationality', id: string, name: string };

export type PlayerDetailSupportedLocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerDetailSupportedLocalesQuery = { __typename?: 'Query', supportedLocales: Array<string> };

export type PlayerDetailChartPlayerConectionFragment = { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type PlayerDetailPlayerBioDataFragment = { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null };

export type PlayerDetailPlayerSeasonWeightedAvgMetricsFragment = { __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number };

export type PlayerDetailMatchDetailFragment = { __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null };

export type PlayerDetailScoutReportsFragment = { __typename?: 'PlayerScoutReport', reportId?: string | null, sortDate: string, reportKind: ReportKind, ggPlayerKey?: string | null, scoutName?: string | null, reportDate?: string | null, team?: string | null, opponent?: string | null, ground?: string | null, overallScore?: number | null, qnaText?: string | null, canEdit?: boolean | null, canArchive?: boolean | null, lastEditDate?: string | null, lastEditorName?: string | null, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null };

export type PlayerDetailMatchReportEvaluationFragment = { __typename?: 'PlayerMatchReportEvaluation', evaluationId: string, sortDate: string, reportId: string, reportKind: ReportKind, matchId: string, matchDate?: string | null, reportDate?: string | null, scoutName: string, scoutUserId?: string | null, team?: string | null, opponent?: string | null, performanceScore?: number | null, potentialScore?: number | null, note?: string | null, isStarter?: boolean | null, shirtNumber?: number | null, notedAt?: string | null, submittedAt?: string | null };

export type PlayerDetailSeasonCategoricalScoresFragment = { __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null };

export type PlayerDetailPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, dateOfBirth?: string | null, isWatchedByCurrentUser: boolean, teamName?: string | null, transferableDataCounts?: { __typename?: 'TransferableDataCounts', scoutReportCount: number, noteCount: number } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string } | null } | null, league?: { __typename?: 'League', id: string } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, scoutReports?: Array<{ __typename?: 'PlayerScoutReport', reportId?: string | null, sortDate: string, reportKind: ReportKind, ggPlayerKey?: string | null, scoutName?: string | null, reportDate?: string | null, team?: string | null, opponent?: string | null, ground?: string | null, overallScore?: number | null, qnaText?: string | null, canEdit?: boolean | null, canArchive?: boolean | null, lastEditDate?: string | null, lastEditorName?: string | null, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null }> | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null, injuries: Array<{ __typename?: 'PlayerInjuryModel', id: string, playerId: string, injuryDate?: string | null, injury?: string | null, daysMissed?: number | null, gamesMissed?: number | null, seasonId?: string | null }>, transfers: Array<{ __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null }>, seasonProviderMetrics: Array<{ __typename?: 'SeasonProviderMetrics', seasonId: string, playerId: string, minutesTotal?: number | null, npXgTotal?: number | null, headerGoalsTotal?: number | null, penaltyGoalsTotal?: number | null, diffActualNpGoalsAndNpXgTotal?: number | null, cornerXaTotal?: number | null, crossXaTotal?: number | null }>, gameProviderMetrics: Array<{ __typename?: 'GameProviderMetrics', gameId: string, minutesTotal?: number | null, obvTotalNetTotal?: number | null }>, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string, name: string }> };

export type PlayerDetailPlayerMetaFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, dateOfBirth?: string | null, isWatchedByCurrentUser: boolean, teamName?: string | null, transferableDataCounts?: { __typename?: 'TransferableDataCounts', scoutReportCount: number, noteCount: number } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string } | null } | null, league?: { __typename?: 'League', id: string } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, scoutReports?: Array<{ __typename?: 'PlayerScoutReport', reportId?: string | null, sortDate: string, reportKind: ReportKind, ggPlayerKey?: string | null, scoutName?: string | null, reportDate?: string | null, team?: string | null, opponent?: string | null, ground?: string | null, overallScore?: number | null, qnaText?: string | null, canEdit?: boolean | null, canArchive?: boolean | null, lastEditDate?: string | null, lastEditorName?: string | null, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null }> | null, matchReportEvaluations: Array<{ __typename?: 'PlayerMatchReportEvaluation', evaluationId: string, sortDate: string, reportId: string, reportKind: ReportKind, matchId: string, matchDate?: string | null, reportDate?: string | null, scoutName: string, scoutUserId?: string | null, team?: string | null, opponent?: string | null, performanceScore?: number | null, potentialScore?: number | null, note?: string | null, isStarter?: boolean | null, shirtNumber?: number | null, notedAt?: string | null, submittedAt?: string | null }>, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null, injuries: Array<{ __typename?: 'PlayerInjuryModel', id: string, playerId: string, injuryDate?: string | null, injury?: string | null, daysMissed?: number | null, gamesMissed?: number | null, seasonId?: string | null }>, transfers: Array<{ __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null }>, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string, name: string }> };

export type PlayerDetailChartPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null };

export type PlayerDetailGetPlayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlayerDetailGetPlayerQuery = { __typename?: 'Query', getPlayer?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, dateOfBirth?: string | null, isWatchedByCurrentUser: boolean, teamName?: string | null, transferableDataCounts?: { __typename?: 'TransferableDataCounts', scoutReportCount: number, noteCount: number } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string } | null } | null, league?: { __typename?: 'League', id: string } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, scoutReports?: Array<{ __typename?: 'PlayerScoutReport', reportId?: string | null, sortDate: string, reportKind: ReportKind, ggPlayerKey?: string | null, scoutName?: string | null, reportDate?: string | null, team?: string | null, opponent?: string | null, ground?: string | null, overallScore?: number | null, qnaText?: string | null, canEdit?: boolean | null, canArchive?: boolean | null, lastEditDate?: string | null, lastEditorName?: string | null, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null }> | null, matchReportEvaluations: Array<{ __typename?: 'PlayerMatchReportEvaluation', evaluationId: string, sortDate: string, reportId: string, reportKind: ReportKind, matchId: string, matchDate?: string | null, reportDate?: string | null, scoutName: string, scoutUserId?: string | null, team?: string | null, opponent?: string | null, performanceScore?: number | null, potentialScore?: number | null, note?: string | null, isStarter?: boolean | null, shirtNumber?: number | null, notedAt?: string | null, submittedAt?: string | null }>, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null, injuries: Array<{ __typename?: 'PlayerInjuryModel', id: string, playerId: string, injuryDate?: string | null, injury?: string | null, daysMissed?: number | null, gamesMissed?: number | null, seasonId?: string | null }>, transfers: Array<{ __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null }>, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string, name: string }> } | null };

export type PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  teamIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  positionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery = { __typename?: 'Query', listPlayersByTeamIdsAndPositionIds: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PlayerDetailGetPlayerKanbanStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerDetailGetPlayerKanbanStatusQuery = { __typename?: 'Query', listMyKanbanBoards: { __typename?: 'KanbanBoardConnection', edges: Array<{ __typename?: 'KanbanBoardEdge', node: { __typename?: 'KanbanBoard', id: string, name: string, phases: Array<{ __typename?: 'KanbanPhase', id: string, name: string, position: number, cards: Array<{ __typename?: 'KanbanCard', id: string, player?: { __typename?: 'Player', id: string } | null, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string, position: number } }> }> } }> } };

export type PlayerDetailTransferFragment = { __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null };

export type PlayerDetailInjuryFragment = { __typename?: 'PlayerInjuryModel', id: string, playerId: string, injuryDate?: string | null, injury?: string | null, daysMissed?: number | null, gamesMissed?: number | null, seasonId?: string | null };

export type PlayerDetailSeasonProviderMetricsFragment = { __typename?: 'SeasonProviderMetrics', seasonId: string, playerId: string, minutesTotal?: number | null, npXgTotal?: number | null, headerGoalsTotal?: number | null, penaltyGoalsTotal?: number | null, diffActualNpGoalsAndNpXgTotal?: number | null, cornerXaTotal?: number | null, crossXaTotal?: number | null };

export type PlayerDetailGetTransfersByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayerDetailGetTransfersByPlayerIdQuery = { __typename?: 'Query', transfersByPlayerId: Array<{ __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null }> };

export type PlayerDetailGetInjuriesByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayerDetailGetInjuriesByPlayerIdQuery = { __typename?: 'Query', injuriesByPlayerId: Array<{ __typename?: 'PlayerInjuryModel', id: string, playerId: string, injuryDate?: string | null, injury?: string | null, daysMissed?: number | null, gamesMissed?: number | null, seasonId?: string | null }> };

export type PlayerDetailGameProviderMetricsFragment = { __typename?: 'GameProviderMetrics', gameId: string, minutesTotal?: number | null, obvTotalNetTotal?: number | null };

export type PlayerDetailGameMetricsFragment = { __typename?: 'GameMetrics', gameId: string, ggrRating?: number | null, playedEnoughMinutes?: boolean | null, wasSubbedIn?: boolean | null, wasSubbedOut?: boolean | null };

export type PlayerDetailListGameMetricsQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayerDetailListGameMetricsQuery = { __typename?: 'Query', listGameMetrics: Array<{ __typename?: 'GameMetrics', gameId: string, ggrRating?: number | null, playedEnoughMinutes?: boolean | null, wasSubbedIn?: boolean | null, wasSubbedOut?: boolean | null }> };

export type PlayerDetailPlayerMatchFragment = { __typename?: 'PlayerMatch', id?: string | null, matchId: string, matchDate?: string | null, oppositionName?: string | null, ground?: string | null };

export type PlayerDetailListGameProviderMetricsQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayerDetailListGameProviderMetricsQuery = { __typename?: 'Query', listGameProviderMetrics: Array<{ __typename?: 'GameProviderMetrics', gameId: string, minutesTotal?: number | null, obvTotalNetTotal?: number | null }> };

export type PlayerDetailListPlayerMatchesQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlayerDetailListPlayerMatchesQuery = { __typename?: 'Query', listPlayerMatches: { __typename?: 'PlayerMatchConnection', edges: Array<{ __typename?: 'PlayerMatchEdge', cursor: string, node: { __typename?: 'PlayerMatch', id?: string | null, matchId: string, matchDate?: string | null, oppositionName?: string | null, ground?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PerformanceAnalyticsPlayerScoresFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, physicalScore?: number | null, gpr?: number | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null };

export type PerformanceAnalyticsFilterPlayersQueryVariables = Exact<{
  filter: PlayerAdvancedFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PerformanceAnalyticsFilterPlayersQuery = { __typename?: 'Query', filterPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, physicalScore?: number | null, gpr?: number | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }> } };

export type PerformanceAnalyticsGetComparisonPlayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PerformanceAnalyticsGetComparisonPlayerQuery = { __typename?: 'Query', getPlayer?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, physicalScore?: number | null, gpr?: number | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } | null };

export type PlayerDetailSeasonMetricAveragesFragment = { __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null };

export type PlayerDetailGetSeasonMetricAveragesQueryVariables = Exact<{
  teamIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  positionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  excludePlayerId: Scalars['ID']['input'];
}>;


export type PlayerDetailGetSeasonMetricAveragesQuery = { __typename?: 'Query', getSeasonMetricAverages: { __typename?: 'SeasonMetricAveragesResult', passing: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, dribbling: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, carrying: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, shooting: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, gkPassing: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, gkShotStopping: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, gkPositioning: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, aerials: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, anticipating: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, assisting: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, buildup: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, creating: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, crossing: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, defensiveAerials: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, finishing: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, heading: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, pressing: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, proactiveDefending: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, setPieceDelivering: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, shotPlacement: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, tackling: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, gkCrossIntercept: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }>, gkKeeperSweeper: Array<{ __typename?: 'SeasonMetricAverages', season: number, teamAverage?: number | null, positionAverage?: number | null }> } };

export type PlayerDetailUpdateManualPlayerMutationVariables = Exact<{
  input: UpdateManualPlayerInput;
}>;


export type PlayerDetailUpdateManualPlayerMutation = { __typename?: 'Mutation', updateManualPlayer: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, dateOfBirth?: string | null, isWatchedByCurrentUser: boolean, teamName?: string | null, transferableDataCounts?: { __typename?: 'TransferableDataCounts', scoutReportCount: number, noteCount: number } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', age?: number | null, archetypeGgPlayerKey?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, contractExpires?: string | null, contractOption?: string | null, currentClub?: string | null, currentLeague?: string | null, dateOfBirth?: string | null, fitScore?: number | null, foot?: string | null, ggPlayerKey: string, gpm?: number | null, gpr?: number | null, floorGpr?: number | null, ceilingGpr?: number | null, height?: number | null, injuredUntil?: string | null, isInjured?: boolean | null, strengths?: Array<string> | null, weaknesses?: Array<string> | null, limitedDataWarning?: boolean | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, llmDerivedSummary?: string | null, timeDecayedSeasonalGpm?: number | null, threats?: Array<string> | null, opportunities?: Array<string> | null, timeDecayedVaep?: number | null, timeDecayedZVaep?: number | null, physicalScore?: number | null, teamStyleFit?: number | null, playerAgent?: string | null, primaryPosition?: string | null, generalPosition?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string } | null } | null, league?: { __typename?: 'League', id: string } | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, scoutReports?: Array<{ __typename?: 'PlayerScoutReport', reportId?: string | null, sortDate: string, reportKind: ReportKind, ggPlayerKey?: string | null, scoutName?: string | null, reportDate?: string | null, team?: string | null, opponent?: string | null, ground?: string | null, overallScore?: number | null, qnaText?: string | null, canEdit?: boolean | null, canArchive?: boolean | null, lastEditDate?: string | null, lastEditorName?: string | null, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null }> | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', seasonId: string, ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null, injuries: Array<{ __typename?: 'PlayerInjuryModel', id: string, playerId: string, injuryDate?: string | null, injury?: string | null, daysMissed?: number | null, gamesMissed?: number | null, seasonId?: string | null }>, transfers: Array<{ __typename?: 'TransferModel', id: string, playerId: string, date?: string | null, fee?: string | null, marketValue?: string | null, sourceTeamId?: string | null, destinationTeamId?: string | null, sourceTeam?: { __typename?: 'Team', id: string, name: string } | null, destinationTeam?: { __typename?: 'Team', id: string, name: string } | null }>, seasonProviderMetrics: Array<{ __typename?: 'SeasonProviderMetrics', seasonId: string, playerId: string, minutesTotal?: number | null, npXgTotal?: number | null, headerGoalsTotal?: number | null, penaltyGoalsTotal?: number | null, diffActualNpGoalsAndNpXgTotal?: number | null, cornerXaTotal?: number | null, crossXaTotal?: number | null }>, gameProviderMetrics: Array<{ __typename?: 'GameProviderMetrics', gameId: string, minutesTotal?: number | null, obvTotalNetTotal?: number | null }>, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string, name: string }> } };

export type PlayerDetailDeleteManualPlayerMutationVariables = Exact<{
  input: DeleteManualPlayerInput;
}>;


export type PlayerDetailDeleteManualPlayerMutation = { __typename?: 'Mutation', deleteManualPlayer: { __typename?: 'Player', id: string } };

export type PlayerDetailTransferManualPlayerDataMutationVariables = Exact<{
  input: TransferManualPlayerDataInput;
}>;


export type PlayerDetailTransferManualPlayerDataMutation = { __typename?: 'Mutation', transferManualPlayerData: { __typename?: 'TransferResult', scoutReportsTransferred: number, notesTransferred: number, sourcePlayerId: string, targetPlayerId: string } };

export type GetDistributionScoresQueryVariables = Exact<{
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludePlayerId?: InputMaybe<Scalars['ID']['input']>;
  shadowTeamId?: InputMaybe<Scalars['ID']['input']>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDistributionScoresQuery = { __typename?: 'Query', getDistributionScores: Array<{ __typename?: 'DistributionPlayerScore', playerId: string, playerName: string, carrying?: number | null, dribbling?: number | null, passing?: number | null, shooting?: number | null, gpr?: number | null, physicalScore?: number | null, gkPassing?: number | null, gkShotStopping?: number | null, gkPositioning?: number | null }> };

export type PlayerDetailBasicCompetitionStatsFragment = { __typename?: 'BasicCompetitionStats', playerId: string, leagueId: string, seasonId: string, basicAppearances?: number | null, basicGoals?: number | null, basicAssists?: number | null, basicMinutes?: number | null };

export type PlayerDetailListBasicCompetitionStatsQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayerDetailListBasicCompetitionStatsQuery = { __typename?: 'Query', listBasicCompetitionStats: Array<{ __typename?: 'BasicCompetitionStats', playerId: string, leagueId: string, seasonId: string, basicAppearances?: number | null, basicGoals?: number | null, basicAssists?: number | null, basicMinutes?: number | null }> };

export type PlayerIntakeGetFormUrlQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  matchIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PlayerIntakeGetFormUrlQuery = { __typename?: 'Query', getIntakeFormUrl: string };

export type KanbanTagFragmentFragment = { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string };

export type KanbanBoardTagFragmentFragment = { __typename?: 'KanbanBoardTag', id: string, kanbanBoardId: string, color?: string | null, createdAt: string, updatedAt: string, tag: { __typename?: 'KanbanTag', id: string, name: string } };

export type KanbanBoardFragmentFragment = { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, organization: { __typename?: 'Organization', id: string, name: string } };

export type KanbanPhaseFragmentFragment = { __typename?: 'KanbanPhase', id: string, name: string, position: number, kanbanBoardId: string, isProtected: boolean, isTerminal: boolean, timeTargetDays?: number | null, createdAt: string, updatedAt: string };

export type KanbanCardFragmentFragment = { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } };

export type KanbanCardWithTagsFragmentFragment = { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, tags: Array<{ __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string }>, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } };

export type KanbanWatchlistDataFragment = { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean };

export type KanbanPlayerDataFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null };

export type KanbanPlayerConnectionFragment = { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type KanbanFilterablePlayerDataFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, league?: { __typename?: 'League', id: string, name: string } | null, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string }>, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, secondaryRoleArchetype?: string | null, nationality?: string | null, geminiPlayerValuation?: number | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, age?: number | null, gpr?: number | null, roleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null };

export type KanbanWatchlistWithPlayersFragment = { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type KanbanUserWatchlistFragment = { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, watchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type KanbanUserWatchlistMetaFragment = { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, watchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean } };

export type KanbanGetWatchlistQueryVariables = Exact<{
  watchlistId: Scalars['ID']['input'];
}>;


export type KanbanGetWatchlistQuery = { __typename?: 'Query', getWatchlist?: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } | null };

export type KanbanListMyUserWatchlistsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type KanbanListMyUserWatchlistsQuery = { __typename?: 'Query', listMyUserWatchlists: { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', cursor: string, node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, watchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type KanbanListWatchlistPlayersQueryVariables = Exact<{
  watchlistIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  sortBy?: InputMaybe<SortField>;
  sortOrder?: InputMaybe<OrderByDirection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
}>;


export type KanbanListWatchlistPlayersQuery = { __typename?: 'Query', listWatchlistPlayers: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type KanbanListMyOrganizationsPlayersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type KanbanListMyOrganizationsPlayersQuery = { __typename?: 'Query', listMyOrganizationsPlayers: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type KanbanFilteredWatchlistPlayersQueryVariables = Exact<{
  watchlistIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
}>;


export type KanbanFilteredWatchlistPlayersQuery = { __typename?: 'Query', listWatchlistPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, league?: { __typename?: 'League', id: string, name: string } | null, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string }>, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, secondaryRoleArchetype?: string | null, nationality?: string | null, geminiPlayerValuation?: number | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, age?: number | null, gpr?: number | null, roleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type KanbanFilteredMyOrganizationsPlayersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type KanbanFilteredMyOrganizationsPlayersQuery = { __typename?: 'Query', listMyOrganizationsPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, league?: { __typename?: 'League', id: string, name: string } | null, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string }>, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, secondaryRoleArchetype?: string | null, nationality?: string | null, geminiPlayerValuation?: number | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, age?: number | null, gpr?: number | null, roleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type KanbanCreateWatchlistMutationVariables = Exact<{
  input: CreateWatchlistInput;
}>;


export type KanbanCreateWatchlistMutation = { __typename?: 'Mutation', createWatchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean } };

export type KanbanUpdateWatchlistMutationVariables = Exact<{
  input: UpdateWatchlistInput;
}>;


export type KanbanUpdateWatchlistMutation = { __typename?: 'Mutation', updateWatchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean } };

export type KanbanDeleteWatchlistMutationVariables = Exact<{
  input: DeleteWatchlistInput;
}>;


export type KanbanDeleteWatchlistMutation = { __typename?: 'Mutation', deleteWatchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean } };

export type KanbanAddPlayerToWatchlistMutationVariables = Exact<{
  input: AddPlayerToWatchlistInput;
}>;


export type KanbanAddPlayerToWatchlistMutation = { __typename?: 'Mutation', addPlayerToWatchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type KanbanRemovePlayerFromWatchlistMutationVariables = Exact<{
  input: RemovePlayerFromWatchlistInput;
}>;


export type KanbanRemovePlayerFromWatchlistMutation = { __typename?: 'Mutation', removePlayerFromWatchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type KanbanUpdateWatchlistPlayerPositionMutationVariables = Exact<{
  input: UpdateWatchlistPlayerPositionInput;
}>;


export type KanbanUpdateWatchlistPlayerPositionMutation = { __typename?: 'Mutation', updateWatchlistPlayerPosition: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type KanbanUpdateWatchlistPlayerPositionsMutationVariables = Exact<{
  input: UpdateWatchlistPlayerPositionsInput;
}>;


export type KanbanUpdateWatchlistPlayerPositionsMutation = { __typename?: 'Mutation', updateWatchlistPlayerPositions: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PlayerKanbanPlayerFragmentFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null };

export type GetKanbanBoardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKanbanBoardQuery = { __typename?: 'Query', getKanbanBoard?: { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, organization: { __typename?: 'Organization', id: string, name: string } } | null };

export type ListMyKanbanBoardsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListMyKanbanBoardsQuery = { __typename?: 'Query', listMyKanbanBoards: { __typename?: 'KanbanBoardConnection', edges: Array<{ __typename?: 'KanbanBoardEdge', cursor: string, node: { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, users: { __typename?: 'UserKanbanBoardConnection', edges: Array<{ __typename?: 'UserKanbanBoardEdge', node: { __typename?: 'UserKanbanBoard', id: string, userId: string, role: UserKanbanBoardRole } }> }, organization: { __typename?: 'Organization', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AddToPipelineDialogBoardsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddToPipelineDialogBoardsQuery = { __typename?: 'Query', listMyKanbanBoards: { __typename?: 'KanbanBoardConnection', edges: Array<{ __typename?: 'KanbanBoardEdge', node: { __typename?: 'KanbanBoard', id: string, name: string, sourceType: KanbanSourceType } }> } };

export type PipelineSwitcherBoardsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PipelineSwitcherBoardsQuery = { __typename?: 'Query', listMyKanbanBoards: { __typename?: 'KanbanBoardConnection', edges: Array<{ __typename?: 'KanbanBoardEdge', node: { __typename?: 'KanbanBoard', id: string, name: string, sourceType: KanbanSourceType, createdBy: string, pipelineTemplate?: KanbanPipelineTemplate | null, updatedAt: string, creator: { __typename?: 'User', id: string, email?: string | null }, users: { __typename?: 'UserKanbanBoardConnection', edges: Array<{ __typename?: 'UserKanbanBoardEdge', node: { __typename?: 'UserKanbanBoard', userId: string, role: UserKanbanBoardRole } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PipelineDrawerCardCountQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PipelineDrawerCardCountQuery = { __typename?: 'Query', listKanbanCards: { __typename?: 'PlayerWithKanbanConnection', edges: Array<{ __typename?: 'PlayerWithKanbanEdge', node: { __typename?: 'PlayerWithKanban', player: { __typename?: 'Player', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type ListKanbanPhasesQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type ListKanbanPhasesQuery = { __typename?: 'Query', listKanbanPhases: Array<{ __typename?: 'KanbanPhase', id: string, name: string, position: number, kanbanBoardId: string, isProtected: boolean, isTerminal: boolean, timeTargetDays?: number | null, createdAt: string, updatedAt: string }> };

export type PipelineActivityLogQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  kanbanCardId?: InputMaybe<Scalars['ID']['input']>;
  action?: InputMaybe<Array<PipelineActivityAction> | PipelineActivityAction>;
  actorType?: InputMaybe<Array<PipelineActorType> | PipelineActorType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PipelineActivityLogQuery = { __typename?: 'Query', pipelineActivityLog: { __typename?: 'PipelineActivityLogConnection', totalCount: number, edges: Array<{ __typename?: 'PipelineActivityLogEdge', cursor: string, node: { __typename?: 'PipelineActivityEntry', id: string, action: PipelineActivityAction, actorType: PipelineActorType, actorUserId?: string | null, automationRuleId?: string | null, automationRuleName?: string | null, playerId: string, playerName?: string | null, kanbanBoardId: string, kanbanCardId?: string | null, fromKanbanPhaseId?: string | null, toKanbanPhaseId?: string | null, fromPhaseName?: string | null, toPhaseName?: string | null, rationale?: string | null, outcome?: KanbanCardOutcome | null, occurredAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PipelineActivityEntryFragmentFragment = { __typename?: 'PipelineActivityEntry', id: string, action: PipelineActivityAction, actorType: PipelineActorType, actorUserId?: string | null, automationRuleId?: string | null, automationRuleName?: string | null, playerId: string, playerName?: string | null, kanbanBoardId: string, kanbanCardId?: string | null, fromKanbanPhaseId?: string | null, toKanbanPhaseId?: string | null, fromPhaseName?: string | null, toPhaseName?: string | null, rationale?: string | null, outcome?: KanbanCardOutcome | null, occurredAt: string };

export type ListKanbanCardsQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListKanbanCardsQuery = { __typename?: 'Query', listKanbanCards: { __typename?: 'PlayerWithKanbanConnection', edges: Array<{ __typename?: 'PlayerWithKanbanEdge', node: { __typename?: 'PlayerWithKanban', kanbanPhaseId?: string | null, player: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, imageUrl?: string | null, transferableDataCounts?: { __typename?: 'TransferableDataCounts', scoutReportCount: number } | null, scoutReports?: Array<{ __typename?: 'PlayerScoutReport', reportDate?: string | null, overallScore?: number | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, nationality?: string | null, geminiPlayerValuation?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, primaryPosition?: string | null, leagueCountry?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string, name: string }> }, kanbanCard?: { __typename?: 'KanbanCard', outcome?: KanbanCardOutcome | null, closedAt?: string | null, lastEditedByUserId?: string | null, id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, tags: Array<{ __typename?: 'KanbanTag', id: string, name: string, cardCount: number, color?: string | null, createdAt: string, updatedAt: string }>, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type CreateKanbanBoardMutationVariables = Exact<{
  input: CreateKanbanBoardInput;
}>;


export type CreateKanbanBoardMutation = { __typename?: 'Mutation', createKanbanBoard: { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, phases: Array<{ __typename?: 'KanbanPhase', id: string }>, organization: { __typename?: 'Organization', id: string, name: string } } };

export type UpdateKanbanBoardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKanbanBoardInput;
}>;


export type UpdateKanbanBoardMutation = { __typename?: 'Mutation', updateKanbanBoard: { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, organization: { __typename?: 'Organization', id: string, name: string } } };

export type DeleteKanbanBoardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKanbanBoardMutation = { __typename?: 'Mutation', deleteKanbanBoard: { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, organization: { __typename?: 'Organization', id: string, name: string } } };

export type CreateKanbanPhaseMutationVariables = Exact<{
  input: CreateKanbanPhaseInput;
}>;


export type CreateKanbanPhaseMutation = { __typename?: 'Mutation', createKanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string, position: number, kanbanBoardId: string, isProtected: boolean, isTerminal: boolean, timeTargetDays?: number | null, createdAt: string, updatedAt: string } };

export type UpdateKanbanPhaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKanbanPhaseInput;
}>;


export type UpdateKanbanPhaseMutation = { __typename?: 'Mutation', updateKanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string, position: number, kanbanBoardId: string, isProtected: boolean, isTerminal: boolean, timeTargetDays?: number | null, createdAt: string, updatedAt: string } };

export type DeleteKanbanPhaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKanbanPhaseMutation = { __typename?: 'Mutation', deleteKanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string, position: number, kanbanBoardId: string, isProtected: boolean, isTerminal: boolean, timeTargetDays?: number | null, createdAt: string, updatedAt: string } };

export type UpdateKanbanPhasePositionsMutationVariables = Exact<{
  input: UpdateKanbanPhasePositionsInput;
}>;


export type UpdateKanbanPhasePositionsMutation = { __typename?: 'Mutation', updateKanbanPhasePositions: Array<{ __typename?: 'KanbanPhase', id: string, name: string, position: number, kanbanBoardId: string, isProtected: boolean, isTerminal: boolean, timeTargetDays?: number | null, createdAt: string, updatedAt: string }> };

export type AddPlayerToKanbanMutationVariables = Exact<{
  input: AddPlayerToKanbanInput;
}>;


export type AddPlayerToKanbanMutation = { __typename?: 'Mutation', addPlayerToKanban: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type MoveKanbanCardMutationVariables = Exact<{
  input: MoveKanbanCardInput;
}>;


export type MoveKanbanCardMutation = { __typename?: 'Mutation', moveKanbanCard: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type UpdateKanbanCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKanbanCardInput;
}>;


export type UpdateKanbanCardMutation = { __typename?: 'Mutation', updateKanbanCard: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type CloseKanbanCardToTerminalStageMutationVariables = Exact<{
  input: CloseKanbanCardToTerminalStageInput;
}>;


export type CloseKanbanCardToTerminalStageMutation = { __typename?: 'Mutation', closeKanbanCardToTerminalStage: { __typename?: 'KanbanCard', outcome?: KanbanCardOutcome | null, closedAt?: string | null, id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type ReopenKanbanCardMutationVariables = Exact<{
  input: ReopenKanbanCardInput;
}>;


export type ReopenKanbanCardMutation = { __typename?: 'Mutation', reopenKanbanCard: { __typename?: 'KanbanCard', outcome?: KanbanCardOutcome | null, closedAt?: string | null, id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type RemovePlayerFromKanbanMutationVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemovePlayerFromKanbanMutation = { __typename?: 'Mutation', removePlayerFromKanban: { __typename?: 'KanbanCard', id: string, position: number, notes?: string | null, kanbanPhaseId: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type UpdateKanbanCardPositionsMutationVariables = Exact<{
  input: UpdateKanbanCardPositionsInput;
}>;


export type UpdateKanbanCardPositionsMutation = { __typename?: 'Mutation', updateKanbanCardPositions: Array<{ __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } }> };

export type SetKanbanBoardDefaultCardOrderMutationVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type SetKanbanBoardDefaultCardOrderMutation = { __typename?: 'Mutation', setKanbanBoardDefaultCardOrder: Array<{ __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } }> };

export type ResetKanbanBoardCardOrderMutationVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type ResetKanbanBoardCardOrderMutation = { __typename?: 'Mutation', resetKanbanBoardCardOrder: Array<{ __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } }> };

export type GetKanbanBoardCardOrderStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKanbanBoardCardOrderStateQuery = { __typename?: 'Query', getKanbanBoard?: { __typename?: 'KanbanBoard', id: string, hasPersonalCardOrder: boolean } | null };

export type KanbanCreateUserWatchlistMutationVariables = Exact<{
  input: CreateUserWatchlistInput;
}>;


export type KanbanCreateUserWatchlistMutation = { __typename?: 'Mutation', createUserWatchlist: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, watchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } } };

export type KanbanDeleteUserWatchlistMutationVariables = Exact<{
  input: DeleteUserWatchlistInput;
}>;


export type KanbanDeleteUserWatchlistMutation = { __typename?: 'Mutation', deleteUserWatchlist?: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, watchlist: { __typename?: 'Watchlist', id: string, name: string, createdAt: string, updatedAt: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, minGeminiPlayerValuation?: number | null, maxGeminiPlayerValuation?: number | null, contractExpires?: string | null, playerAgent?: string | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } } | null };

export type ListKanbanTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListKanbanTagsQuery = { __typename?: 'Query', listKanbanTags: { __typename?: 'KanbanTagConnection', edges: Array<{ __typename?: 'KanbanTagEdge', cursor: string, node: { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ListKanbanTagsWithColorQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListKanbanTagsWithColorQuery = { __typename?: 'Query', listKanbanTags: { __typename?: 'KanbanTagConnection', edges: Array<{ __typename?: 'KanbanTagEdge', cursor: string, node: { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, color?: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetKanbanTagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKanbanTagQuery = { __typename?: 'Query', kanbanTag?: { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string } | null };

export type ListKanbanBoardTagsQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListKanbanBoardTagsQuery = { __typename?: 'Query', listKanbanBoardTags: { __typename?: 'KanbanBoardTagConnection', edges: Array<{ __typename?: 'KanbanBoardTagEdge', cursor: string, node: { __typename?: 'KanbanBoardTag', id: string, kanbanBoardId: string, color?: string | null, createdAt: string, updatedAt: string, tag: { __typename?: 'KanbanTag', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type KanbanCardTagsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type KanbanCardTagsQuery = { __typename?: 'Query', kanbanCard?: { __typename?: 'KanbanCard', id: string, tags: Array<{ __typename?: 'KanbanTag', id: string, name: string, cardCount: number, color?: string | null, createdAt: string, updatedAt: string }> } | null };

export type CreateKanbanTagMutationVariables = Exact<{
  input: CreateKanbanTagInput;
}>;


export type CreateKanbanTagMutation = { __typename?: 'Mutation', createKanbanTag: { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string } };

export type UpdateKanbanTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKanbanTagInput;
}>;


export type UpdateKanbanTagMutation = { __typename?: 'Mutation', updateKanbanTag: { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string } };

export type DeleteKanbanTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKanbanTagMutation = { __typename?: 'Mutation', deleteKanbanTag: { __typename?: 'KanbanTag', id: string, name: string, cardCount: number, createdAt: string, updatedAt: string } };

export type SetKanbanBoardTagColorMutationVariables = Exact<{
  input: SetKanbanBoardTagColorInput;
}>;


export type SetKanbanBoardTagColorMutation = { __typename?: 'Mutation', setKanbanBoardTagColor: { __typename?: 'KanbanBoardTag', id: string, kanbanBoardId: string, color?: string | null, createdAt: string, updatedAt: string, tag: { __typename?: 'KanbanTag', id: string, name: string } } };

export type AddTagsToKanbanCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type AddTagsToKanbanCardMutation = { __typename?: 'Mutation', addTagsToKanbanCard: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, tags: Array<{ __typename?: 'KanbanTag', id: string, name: string, cardCount: number, color?: string | null, createdAt: string, updatedAt: string }>, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type RemoveTagsFromKanbanCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type RemoveTagsFromKanbanCardMutation = { __typename?: 'Mutation', removeTagsFromKanbanCard: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, tags: Array<{ __typename?: 'KanbanTag', id: string, name: string, cardCount: number, color?: string | null, createdAt: string, updatedAt: string }>, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type SetKanbanCardTagsMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type SetKanbanCardTagsMutation = { __typename?: 'Mutation', setKanbanCardTags: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, tags: Array<{ __typename?: 'KanbanTag', id: string, name: string, cardCount: number, color?: string | null, createdAt: string, updatedAt: string }>, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type KanbanCognitoUserFragment = { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null };

export type KanbanUserFragment = { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null };

export type KanbanOrganizationUserFragment = { __typename?: 'OrganizationUser', id: string, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null };

export type KanbanOrganizationUserConnectionFragment = { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UserKanbanBoardFragmentFragment = { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } };

export type UserKanbanBoardConnectionFragment = { __typename?: 'UserKanbanBoardConnection', edges: Array<{ __typename?: 'UserKanbanBoardEdge', cursor: string, node: { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type GetKanbanBoardWithPermissionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetKanbanBoardWithPermissionsQuery = { __typename?: 'Query', getKanbanBoard?: { __typename?: 'KanbanBoard', id: string, name: string, createdAt: string, createdBy: string, organizationId: string, sourceType: KanbanSourceType, sourceId?: string | null, validOutcomes: Array<KanbanCardOutcome>, pipelineTemplate?: KanbanPipelineTemplate | null, users: { __typename?: 'UserKanbanBoardConnection', edges: Array<{ __typename?: 'UserKanbanBoardEdge', cursor: string, node: { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } }, organization: { __typename?: 'Organization', id: string, name: string } } | null };

export type ListKanbanOrganizationUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListKanbanOrganizationUsersQuery = { __typename?: 'Query', listMyOrganizationsOrganizationUsers: { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AddUserToKanbanBoardMutationVariables = Exact<{
  input: AddUserToKanbanBoardInput;
}>;


export type AddUserToKanbanBoardMutation = { __typename?: 'Mutation', addUserToKanbanBoard: { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type RemoveUserFromKanbanBoardMutationVariables = Exact<{
  input: RemoveUserFromKanbanBoardInput;
}>;


export type RemoveUserFromKanbanBoardMutation = { __typename?: 'Mutation', removeUserFromKanbanBoard: { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type UpdateUserKanbanBoardRoleMutationVariables = Exact<{
  input: UpdateUserKanbanBoardRoleInput;
}>;


export type UpdateUserKanbanBoardRoleMutation = { __typename?: 'Mutation', updateUserKanbanBoardRole: { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type TransferKanbanBoardOwnershipMutationVariables = Exact<{
  input: TransferKanbanBoardOwnershipInput;
}>;


export type TransferKanbanBoardOwnershipMutation = { __typename?: 'Mutation', transferKanbanBoardOwnership: { __typename?: 'UserKanbanBoard', id: string, userId: string, kanbanBoardId: string, role: UserKanbanBoardRole, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type PipelineReviewRequestFragmentFragment = { __typename?: 'PipelineReviewRequest', id: string, status: PipelineReviewStatus, source: PipelineReviewSource, automationRuleId?: string | null, automationRuleName?: string | null, kanbanBoardId: string, kanbanCardId: string, playerId: string, fromKanbanPhaseId: string, fromPhaseName?: string | null, targetKanbanPhaseId: string, targetPhaseName?: string | null, requestedOutcome?: KanbanCardOutcome | null, requestReason?: string | null, requestedByUserId?: string | null, addressedToUserId?: string | null, decidedAt?: string | null, decidedByUserId?: string | null, decisionReason?: string | null, correlationKey: string, createdAt: string };

export type PipelineReviewQueueQueryVariables = Exact<{
  status?: InputMaybe<PipelineReviewStatus>;
  kanbanBoardId?: InputMaybe<Scalars['ID']['input']>;
  addressedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PipelineReviewQueueQuery = { __typename?: 'Query', pipelineReviewQueue: { __typename?: 'PipelineReviewRequestConnection', totalCount: number, edges: Array<{ __typename?: 'PipelineReviewRequestEdge', cursor: string, node: { __typename?: 'PipelineReviewRequest', id: string, status: PipelineReviewStatus, source: PipelineReviewSource, automationRuleId?: string | null, automationRuleName?: string | null, kanbanBoardId: string, kanbanCardId: string, playerId: string, fromKanbanPhaseId: string, fromPhaseName?: string | null, targetKanbanPhaseId: string, targetPhaseName?: string | null, requestedOutcome?: KanbanCardOutcome | null, requestReason?: string | null, requestedByUserId?: string | null, addressedToUserId?: string | null, decidedAt?: string | null, decidedByUserId?: string | null, decisionReason?: string | null, correlationKey: string, createdAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PipelineReviewQueuePlayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PipelineReviewQueuePlayerQuery = { __typename?: 'Query', getPlayer?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, teamName?: string | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null } | null };

export type AcceptPipelineReviewRequestMutationVariables = Exact<{
  input: AcceptPipelineReviewRequestInput;
}>;


export type AcceptPipelineReviewRequestMutation = { __typename?: 'Mutation', acceptPipelineReviewRequest: { __typename?: 'PipelineReviewRequest', id: string, status: PipelineReviewStatus, source: PipelineReviewSource, automationRuleId?: string | null, automationRuleName?: string | null, kanbanBoardId: string, kanbanCardId: string, playerId: string, fromKanbanPhaseId: string, fromPhaseName?: string | null, targetKanbanPhaseId: string, targetPhaseName?: string | null, requestedOutcome?: KanbanCardOutcome | null, requestReason?: string | null, requestedByUserId?: string | null, addressedToUserId?: string | null, decidedAt?: string | null, decidedByUserId?: string | null, decisionReason?: string | null, correlationKey: string, createdAt: string } };

export type DeclinePipelineReviewRequestMutationVariables = Exact<{
  input: DeclinePipelineReviewRequestInput;
}>;


export type DeclinePipelineReviewRequestMutation = { __typename?: 'Mutation', declinePipelineReviewRequest: { __typename?: 'PipelineReviewRequest', id: string, status: PipelineReviewStatus, source: PipelineReviewSource, automationRuleId?: string | null, automationRuleName?: string | null, kanbanBoardId: string, kanbanCardId: string, playerId: string, fromKanbanPhaseId: string, fromPhaseName?: string | null, targetKanbanPhaseId: string, targetPhaseName?: string | null, requestedOutcome?: KanbanCardOutcome | null, requestReason?: string | null, requestedByUserId?: string | null, addressedToUserId?: string | null, decidedAt?: string | null, decidedByUserId?: string | null, decisionReason?: string | null, correlationKey: string, createdAt: string } };

export type PipelineAutomationRuleConditionFragmentFragment = { __typename?: 'PipelineAutomationRuleCondition', id: string, conditionType: PipelineAutomationConditionType, comparator?: PipelineAutomationComparator | null, numericValue?: string | null, textValue?: string | null, kanbanPhaseId?: string | null };

export type PipelineAutomationRuleFragmentFragment = { __typename?: 'PipelineAutomationRule', id: string, name: string, isEnabled: boolean, kanbanBoardId: string, triggerType: PipelineAutomationTriggerType, actionType: PipelineAutomationActionType, triggerKanbanPhaseId?: string | null, targetKanbanPhaseId?: string | null, kanbanTagId?: string | null, requestedOutcome?: KanbanCardOutcome | null, reason?: string | null, revision: number, createdAt: string, updatedAt: string, conditions: Array<{ __typename?: 'PipelineAutomationRuleCondition', id: string, conditionType: PipelineAutomationConditionType, comparator?: PipelineAutomationComparator | null, numericValue?: string | null, textValue?: string | null, kanbanPhaseId?: string | null }> };

export type PipelineAutomationRulesQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PipelineAutomationRulesQuery = { __typename?: 'Query', pipelineAutomationRules: { __typename?: 'PipelineAutomationRuleConnection', totalCount: number, edges: Array<{ __typename?: 'PipelineAutomationRuleEdge', cursor: string, node: { __typename?: 'PipelineAutomationRule', id: string, name: string, isEnabled: boolean, kanbanBoardId: string, triggerType: PipelineAutomationTriggerType, actionType: PipelineAutomationActionType, triggerKanbanPhaseId?: string | null, targetKanbanPhaseId?: string | null, kanbanTagId?: string | null, requestedOutcome?: KanbanCardOutcome | null, reason?: string | null, revision: number, createdAt: string, updatedAt: string, conditions: Array<{ __typename?: 'PipelineAutomationRuleCondition', id: string, conditionType: PipelineAutomationConditionType, comparator?: PipelineAutomationComparator | null, numericValue?: string | null, textValue?: string | null, kanbanPhaseId?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type CreatePipelineAutomationRuleMutationVariables = Exact<{
  input: CreatePipelineAutomationRuleInput;
}>;


export type CreatePipelineAutomationRuleMutation = { __typename?: 'Mutation', createPipelineAutomationRule: { __typename?: 'PipelineAutomationRule', id: string, name: string, isEnabled: boolean, kanbanBoardId: string, triggerType: PipelineAutomationTriggerType, actionType: PipelineAutomationActionType, triggerKanbanPhaseId?: string | null, targetKanbanPhaseId?: string | null, kanbanTagId?: string | null, requestedOutcome?: KanbanCardOutcome | null, reason?: string | null, revision: number, createdAt: string, updatedAt: string, conditions: Array<{ __typename?: 'PipelineAutomationRuleCondition', id: string, conditionType: PipelineAutomationConditionType, comparator?: PipelineAutomationComparator | null, numericValue?: string | null, textValue?: string | null, kanbanPhaseId?: string | null }> } };

export type UpdatePipelineAutomationRuleMutationVariables = Exact<{
  input: UpdatePipelineAutomationRuleInput;
}>;


export type UpdatePipelineAutomationRuleMutation = { __typename?: 'Mutation', updatePipelineAutomationRule: { __typename?: 'PipelineAutomationRule', id: string, name: string, isEnabled: boolean, kanbanBoardId: string, triggerType: PipelineAutomationTriggerType, actionType: PipelineAutomationActionType, triggerKanbanPhaseId?: string | null, targetKanbanPhaseId?: string | null, kanbanTagId?: string | null, requestedOutcome?: KanbanCardOutcome | null, reason?: string | null, revision: number, createdAt: string, updatedAt: string, conditions: Array<{ __typename?: 'PipelineAutomationRuleCondition', id: string, conditionType: PipelineAutomationConditionType, comparator?: PipelineAutomationComparator | null, numericValue?: string | null, textValue?: string | null, kanbanPhaseId?: string | null }> } };

export type DeletePipelineAutomationRuleMutationVariables = Exact<{
  automationRuleId: Scalars['ID']['input'];
}>;


export type DeletePipelineAutomationRuleMutation = { __typename?: 'Mutation', deletePipelineAutomationRule: string };

export type SetPipelineAutomationRuleEnabledMutationVariables = Exact<{
  input: SetPipelineAutomationRuleEnabledInput;
}>;


export type SetPipelineAutomationRuleEnabledMutation = { __typename?: 'Mutation', setPipelineAutomationRuleEnabled: { __typename?: 'PipelineAutomationRule', id: string, name: string, isEnabled: boolean, kanbanBoardId: string, triggerType: PipelineAutomationTriggerType, actionType: PipelineAutomationActionType, triggerKanbanPhaseId?: string | null, targetKanbanPhaseId?: string | null, kanbanTagId?: string | null, requestedOutcome?: KanbanCardOutcome | null, reason?: string | null, revision: number, createdAt: string, updatedAt: string, conditions: Array<{ __typename?: 'PipelineAutomationRuleCondition', id: string, conditionType: PipelineAutomationConditionType, comparator?: PipelineAutomationComparator | null, numericValue?: string | null, textValue?: string | null, kanbanPhaseId?: string | null }> } };

export type PipelineSuggestedPlayerFragmentFragment = { __typename?: 'PipelineSuggestedPlayer', id: string, bestRank: number, reasons: Array<SuggestionReasonCategory>, snapshotTimestamp: string, player: { __typename?: 'Player', id: string, name: string, knownName?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string }>, positions?: Array<{ __typename?: 'Position', id: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, nationality?: string | null, contractExpires?: string | null, geminiPlayerValuation?: number | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, customStats?: Record<string, any> | null } | null } };

export type ListPipelineSuggestedPlayersQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListPipelineSuggestedPlayersQuery = { __typename?: 'Query', listPipelineSuggestedPlayers: { __typename?: 'PipelineSuggestedPlayerConnection', edges: Array<{ __typename?: 'PipelineSuggestedPlayerEdge', cursor: string, node: { __typename?: 'PipelineSuggestedPlayer', id: string, bestRank: number, reasons: Array<SuggestionReasonCategory>, snapshotTimestamp: string, player: { __typename?: 'Player', id: string, name: string, knownName?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string }>, positions?: Array<{ __typename?: 'Position', id: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, gpr?: number | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, nationality?: string | null, contractExpires?: string | null, geminiPlayerValuation?: number | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, customStats?: Record<string, any> | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AddSuggestedPlayerToPipelineMutationVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
}>;


export type AddSuggestedPlayerToPipelineMutation = { __typename?: 'Mutation', addSuggestedPlayerToPipeline: { __typename?: 'KanbanCard', id: string, position: number, rank: number, notes?: string | null, kanbanPhaseId: string, enteredStageAt: string, createdAt: string, updatedAt: string, kanbanPhase: { __typename?: 'KanbanPhase', id: string, name: string } } };

export type ListKanbanBoardPlayerMetricsQueryVariables = Exact<{
  kanbanBoardId: Scalars['ID']['input'];
}>;


export type ListKanbanBoardPlayerMetricsQuery = { __typename?: 'Query', listKanbanBoardPlayerMetrics: Array<{ __typename?: 'KanbanBoardPlayerMetrics', playerId: string, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null }> };

export type PlayerMatchReportsQueryVariables = Exact<{
  filter: MatchReportFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlayerMatchReportsQuery = { __typename?: 'Query', listMatchReports: { __typename?: 'MatchReportConnection', edges: Array<{ __typename?: 'MatchReportEdge', cursor: string, node: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, submittedAt?: string | null, watchMode?: MatchWatchMode | null, scoutUser: { __typename?: 'User', id: string, email?: string | null, displayName: string }, match: { __typename?: 'Match', id: string, scheduledDate: string, startTime?: string | null, venue?: string | null, competitionName?: string | null, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string } }, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, isNoted: boolean, performanceScore?: number | null, potentialScore?: number | null, note?: string | null, isStarter?: boolean | null, notedAt?: string | null, player?: { __typename?: 'Player', id: string } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PlayerSearchTeamFragment = { __typename?: 'Team', id: string, name: string };

export type PlayerSearchPositionFragment = { __typename?: 'Position', id: string, name: string, abbreviation?: string | null };

export type PlayerSearchPlayerBioDataFragment = { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null };

export type PlayerSearchPlayerSeasonWeightedAvgMetricsFragment = { __typename?: 'PlayerSeasonWeightedAvgMetrics', ggPlayerKey: string, ggUnifiedSeasonKey: number, epm?: number | null, rapm?: number | null, spm?: number | null, stdEpm?: number | null, stdEpmTransform?: number | null };

export type PlayerSearchPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null };

export type PlayerSearchPlayerConnectionFragment = { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type PlayerSearchPlayerConnectionLiteFragment = { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type PlayerSearchPlayerEdgeFragment = { __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } };

export type PlayerSearchWatchlistWithPlayerFragment = { __typename?: 'Watchlist', id: string, name: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PlayerSearchWatchlistFragment = { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PlayerSearchWatchlistMetaFragment = { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PlayerSearchWatchlistConnectionFragment = { __typename?: 'WatchlistConnection', edges: Array<{ __typename?: 'WatchlistEdge', cursor: string, node: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type PlayerSearchWatchlistEdgeFragment = { __typename?: 'WatchlistEdge', cursor: string, node: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PlayerSearchWatchlistConnectionWithPlayerFragment = { __typename?: 'WatchlistConnection', edges: Array<{ __typename?: 'WatchlistEdge', cursor: string, node: { __typename?: 'Watchlist', id: string, name: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type PlayerSearchWatchlistEdgeWithPlayerFragment = { __typename?: 'WatchlistEdge', cursor: string, node: { __typename?: 'Watchlist', id: string, name: string, isOnWatchlist: boolean, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PlayerSearchCompetitionFragment = { __typename?: 'Competition', id: string, name: string, code?: string | null };

export type PlayerSearchListCompetitionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlayerSearchListCompetitionsQuery = { __typename?: 'Query', listCompetitions: { __typename?: 'CompetitionConnection', edges: Array<{ __typename?: 'CompetitionEdge', cursor: string, node: { __typename?: 'Competition', id: string, name: string, code?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type PlayerSearchFilterPlayersQueryVariables = Exact<{
  filter: PlayerAdvancedFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
}>;


export type PlayerSearchFilterPlayersQuery = { __typename?: 'Query', filterPlayers: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PlayerSearchSearchPlayersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
}>;


export type PlayerSearchSearchPlayersQuery = { __typename?: 'Query', searchPlayers: { __typename?: 'PlayerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PlayerSearchSearchPlayersLiteQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
}>;


export type PlayerSearchSearchPlayersLiteQuery = { __typename?: 'Query', searchPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PlayerSearchGetPlayerByTransfermarktIdQueryVariables = Exact<{
  transfermarktId: Scalars['Int']['input'];
}>;


export type PlayerSearchGetPlayerByTransfermarktIdQuery = { __typename?: 'Query', getPlayerByTransfermarktId?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null };

export type PlayerSearchListRoleArchetypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSearchListRoleArchetypesQuery = { __typename?: 'Query', listRoleArchetypes: Array<string> };

export type PlayerSearchListAvailableCustomStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSearchListAvailableCustomStatsQuery = { __typename?: 'Query', listAvailableCustomStats: Array<{ __typename?: 'CustomStatDefinition', name: string, description: string }> };

export type PlayerSearchAddPlayerToWatchlistMutationVariables = Exact<{
  input: AddPlayerToWatchlistInput;
}>;


export type PlayerSearchAddPlayerToWatchlistMutation = { __typename?: 'Mutation', addPlayerToWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PlayerSearchRemovePlayerFromWatchlistMutationVariables = Exact<{
  input: RemovePlayerFromWatchlistInput;
}>;


export type PlayerSearchRemovePlayerFromWatchlistMutation = { __typename?: 'Mutation', removePlayerFromWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PlayerSearchCreateWatchlistMutationVariables = Exact<{
  input: CreateWatchlistInput;
}>;


export type PlayerSearchCreateWatchlistMutation = { __typename?: 'Mutation', createWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PlayerSearchCreateManualPlayerMutationVariables = Exact<{
  input: CreateManualPlayerInput;
}>;


export type PlayerSearchCreateManualPlayerMutation = { __typename?: 'Mutation', createManualPlayer: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } };

export type PushNotificationsCreateDeviceMutationVariables = Exact<{
  input: CreateDeviceInput;
}>;


export type PushNotificationsCreateDeviceMutation = { __typename?: 'Mutation', createDevice: { __typename?: 'Device', id: string } };

export type RecommendationsTeamFragment = { __typename?: 'Team', id: string, name: string };

export type RecommendationsPlayerPositionFragment = { __typename?: 'Position', id: string, name: string, abbreviation?: string | null };

export type RecommendationsPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null } | null };

export type RecommendationsPlayerRecommendationResultFragment = { __typename?: 'PlayerRecommendationResult', id: string, recommendationScore: number, recommendationType: string, rankChange?: number | null, currentRank: number, previousRank?: number | null, player: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null } | null } };

export type RecommendationsListPlayerRecommendationsQueryVariables = Exact<{
  recommendationType: Scalars['String']['input'];
}>;


export type RecommendationsListPlayerRecommendationsQuery = { __typename?: 'Query', listPlayerRecommendations: Array<{ __typename?: 'PlayerRecommendationResult', id: string, recommendationScore: number, recommendationType: string, rankChange?: number | null, currentRank: number, previousRank?: number | null, player: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null } | null } }> };

export type RecommendationsRemovePlayerFromRecommendationsMutationVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type RecommendationsRemovePlayerFromRecommendationsMutation = { __typename?: 'Mutation', removePlayerFromRecommendations?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null } | null } | null };

export type ReportsGetScoutReportEditUrlQueryVariables = Exact<{
  scoutReportId: Scalars['ID']['input'];
}>;


export type ReportsGetScoutReportEditUrlQuery = { __typename?: 'Query', getScoutReportEditUrl: string };

export type ReportsShareScoutReportMutationVariables = Exact<{
  input: ShareScoutReportInput;
}>;


export type ReportsShareScoutReportMutation = { __typename?: 'Mutation', shareScoutReport: boolean };

export type ReportsScoutReportShareFragment = { __typename?: 'ScoutReportShare', userId: string, role: UserScoutReportRole, createdAt: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } };

export type ReportsListScoutReportSharesQueryVariables = Exact<{
  scoutReportId: Scalars['ID']['input'];
}>;


export type ReportsListScoutReportSharesQuery = { __typename?: 'Query', listScoutReportShares: Array<{ __typename?: 'ScoutReportShare', userId: string, role: UserScoutReportRole, createdAt: string, user: { __typename?: 'User', id: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } }> };

export type ReportsRevokeScoutReportShareMutationVariables = Exact<{
  input: RevokeScoutReportShareInput;
}>;


export type ReportsRevokeScoutReportShareMutation = { __typename?: 'Mutation', revokeScoutReportShare: boolean };

export type ReportsSetScoutReportVisibilityMutationVariables = Exact<{
  scoutReportId: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
}>;


export type ReportsSetScoutReportVisibilityMutation = { __typename?: 'Mutation', setScoutReportVisibility: { __typename?: 'ScoutReport', id: string, isPublic: boolean } };

export type ReportsPlayerMatchFragment = { __typename?: 'PlayerMatch', id?: string | null, competitionKey?: string | null, seasonKey?: string | null, matchId: string, teamName?: string | null, oppositionName?: string | null, matchDate?: string | null, ground?: string | null, selectBox?: string | null };

export type ReportsArchiveScoutReportMutationVariables = Exact<{
  scoutReportId: Scalars['ID']['input'];
  confirmation: Scalars['String']['input'];
}>;


export type ReportsArchiveScoutReportMutation = { __typename?: 'Mutation', archiveScoutReport: { __typename?: 'ScoutReport', id: string, archivedAt?: string | null } };

export type ReportsUnarchiveScoutReportMutationVariables = Exact<{
  scoutReportId: Scalars['ID']['input'];
}>;


export type ReportsUnarchiveScoutReportMutation = { __typename?: 'Mutation', unarchiveScoutReport: { __typename?: 'ScoutReport', id: string, archivedAt?: string | null } };

export type ReportsTranslateScoutReportMutationVariables = Exact<{
  input: TranslateScoutReportInput;
}>;


export type ReportsTranslateScoutReportMutation = { __typename?: 'Mutation', translateScoutReport: { __typename?: 'PlayerScoutReport', reportId?: string | null, qnaText?: string | null, translatedQnaText?: string | null, availableTranslations?: Array<string> | null } };

export type ReportsListPlayerMatchesQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportsListPlayerMatchesQuery = { __typename?: 'Query', listPlayerMatches: { __typename?: 'PlayerMatchConnection', edges: Array<{ __typename?: 'PlayerMatchEdge', cursor: string, node: { __typename?: 'PlayerMatch', id?: string | null, competitionKey?: string | null, seasonKey?: string | null, matchId: string, teamName?: string | null, oppositionName?: string | null, matchDate?: string | null, ground?: string | null, selectBox?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementLeagueConnectionFragment = { __typename?: 'LeagueConnection', edges: Array<{ __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean, country?: string | null, sport: { __typename?: 'Sport', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type RosterManagementLeagueEdgeFragment = { __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean, country?: string | null, sport: { __typename?: 'Sport', id: string, name: string } } };

export type RosterManagementSportFragment = { __typename?: 'Sport', id: string, name: string };

export type RosterManagementLeagueFragment = { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean, country?: string | null, sport: { __typename?: 'Sport', id: string, name: string } };

export type RosterManagementTeamConnectionFragment = { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, isMyOrganizationTeam: boolean, league?: { __typename?: 'League', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type RosterManagementTeamEdgeFragment = { __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, isMyOrganizationTeam: boolean, league?: { __typename?: 'League', id: string, name: string } | null } };

export type RosterManagementTeamFragment = { __typename?: 'Team', id: string, name: string, isMyOrganizationTeam: boolean, league?: { __typename?: 'League', id: string, name: string } | null };

export type RosterManagmentOrganizationTeamFragment = { __typename?: 'OrganizationTeam', id: string, organizationId: string, teamId: string };

export type RosterManagmentOrganizationLeagueFragment = { __typename?: 'OrganizationLeague', id: string, organizationId: string, leagueId: string };

export type RosterListPlayerBioDataFragment = { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, isInjured?: boolean | null, contractExpires?: string | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, physicalScore?: number | null, playerValuation?: number | null, gpr?: number | null, customStats?: Record<string, any> | null };

export type RosterListPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, isInjured?: boolean | null, contractExpires?: string | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, physicalScore?: number | null, playerValuation?: number | null, gpr?: number | null, customStats?: Record<string, any> | null } | null };

export type RosterListPlayerConnectionFragment = { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, isInjured?: boolean | null, contractExpires?: string | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, physicalScore?: number | null, playerValuation?: number | null, gpr?: number | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type RosterManagementListMyOrganizationsPlayersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListMyOrganizationsPlayersQuery = { __typename?: 'Query', listMyOrganizationsPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, isInjured?: boolean | null, contractExpires?: string | null, fitScore?: number | null, teamStyleFit?: number | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, physicalScore?: number | null, playerValuation?: number | null, gpr?: number | null, customStats?: Record<string, any> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type RosterManagementListMyOrganizationsTeamsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListMyOrganizationsTeamsQuery = { __typename?: 'Query', listMyOrganizationsTeams: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, isMyOrganizationTeam: boolean, league?: { __typename?: 'League', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementListMyOrganizationsLeaguesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListMyOrganizationsLeaguesQuery = { __typename?: 'Query', listMyOrganizationsLeagues: { __typename?: 'LeagueConnection', edges: Array<{ __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean, country?: string | null, sport: { __typename?: 'Sport', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementListMyOrganizationsEligibleTeamsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListMyOrganizationsEligibleTeamsQuery = { __typename?: 'Query', listMyOrganizationsEligibleTeams: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, isMyOrganizationTeam: boolean, league?: { __typename?: 'League', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementListLeaguesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListLeaguesQuery = { __typename?: 'Query', listLeagues: { __typename?: 'LeagueConnection', edges: Array<{ __typename?: 'LeagueEdge', cursor: string, node: { __typename?: 'League', id: string, name: string, isMyOrganizationLeague: boolean, country?: string | null, sport: { __typename?: 'Sport', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementNationalityFragment = { __typename?: 'Nationality', id: string, name: string };

export type RosterManagementNationalityEdgeFragment = { __typename?: 'NationalityEdge', cursor: string, node: { __typename?: 'Nationality', id: string, name: string } };

export type RosterManagementNationalityConnectionFragment = { __typename?: 'NationalityConnection', edges: Array<{ __typename?: 'NationalityEdge', cursor: string, node: { __typename?: 'Nationality', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type RosterManagementListNationalitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListNationalitiesQuery = { __typename?: 'Query', listNationalities: { __typename?: 'NationalityConnection', edges: Array<{ __typename?: 'NationalityEdge', cursor: string, node: { __typename?: 'Nationality', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementPositionFragment = { __typename?: 'Position', id: string, name: string, sportId: string, abbreviation?: string | null, createdAt: string, updatedAt: string };

export type RosterManagementPositionEdgeFragment = { __typename?: 'PositionEdge', cursor: string, node: { __typename?: 'Position', id: string, name: string, sportId: string, abbreviation?: string | null, createdAt: string, updatedAt: string } };

export type RosterManagementPositionConnectionFragment = { __typename?: 'PositionConnection', edges: Array<{ __typename?: 'PositionEdge', cursor: string, node: { __typename?: 'Position', id: string, name: string, sportId: string, abbreviation?: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type RosterManagementListPositionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RosterManagementListPositionsQuery = { __typename?: 'Query', listPositions: { __typename?: 'PositionConnection', edges: Array<{ __typename?: 'PositionEdge', cursor: string, node: { __typename?: 'Position', id: string, name: string, sportId: string, abbreviation?: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RosterManagementCreateOrganizationLeagueMutationVariables = Exact<{
  input: CreateOrganizationLeagueInput;
}>;


export type RosterManagementCreateOrganizationLeagueMutation = { __typename?: 'Mutation', createOrganizationLeague: { __typename?: 'OrganizationLeague', id: string, organizationId: string, leagueId: string } };

export type RosterManagementDeleteOrganizationLeagueMutationVariables = Exact<{
  input: DeleteOrganizationLeagueInput;
}>;


export type RosterManagementDeleteOrganizationLeagueMutation = { __typename?: 'Mutation', deleteOrganizationLeague: { __typename?: 'OrganizationLeague', id: string, organizationId: string, leagueId: string } };

export type RosterManagementCreateOrganizationTeamMutationVariables = Exact<{
  input: CreateOrganizationTeamInput;
}>;


export type RosterManagementCreateOrganizationTeamMutation = { __typename?: 'Mutation', createOrganizationTeam: { __typename?: 'OrganizationTeam', id: string, organizationId: string, teamId: string } };

export type RosterManagementDeleteOrganizationTeamMutationVariables = Exact<{
  input: DeleteOrganizationTeamInput;
}>;


export type RosterManagementDeleteOrganizationTeamMutation = { __typename?: 'Mutation', deleteOrganizationTeam: { __typename?: 'OrganizationTeam', id: string, organizationId: string, teamId: string } };

export type ScoutingListAllTargetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  filterByPositionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterByTeamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterByWatchlistIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterByScoutIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterByNationalityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterByLeagueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filterByRoleArchetypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sortBy?: InputMaybe<SortField>;
  sortOrder?: InputMaybe<OrderByDirection>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  maxGeminiPlayerValuation?: InputMaybe<Scalars['Float']['input']>;
  minContractMonths?: InputMaybe<Scalars['Int']['input']>;
  maxContractMonths?: InputMaybe<Scalars['Int']['input']>;
  minGpr?: InputMaybe<Scalars['Float']['input']>;
  maxGpr?: InputMaybe<Scalars['Float']['input']>;
  minFitScore?: InputMaybe<Scalars['Float']['input']>;
  maxFitScore?: InputMaybe<Scalars['Float']['input']>;
  minTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  maxTeamStyleFit?: InputMaybe<Scalars['Float']['input']>;
  minCarrying?: InputMaybe<Scalars['Float']['input']>;
  maxCarrying?: InputMaybe<Scalars['Float']['input']>;
  minPassing?: InputMaybe<Scalars['Float']['input']>;
  maxPassing?: InputMaybe<Scalars['Float']['input']>;
  minDribbling?: InputMaybe<Scalars['Float']['input']>;
  maxDribbling?: InputMaybe<Scalars['Float']['input']>;
  minShooting?: InputMaybe<Scalars['Float']['input']>;
  maxShooting?: InputMaybe<Scalars['Float']['input']>;
  minGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  maxGkShotStopping?: InputMaybe<Scalars['Float']['input']>;
  minGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  maxGkPositioning?: InputMaybe<Scalars['Float']['input']>;
  minGkPassing?: InputMaybe<Scalars['Float']['input']>;
  maxGkPassing?: InputMaybe<Scalars['Float']['input']>;
  filterByCustomStats?: InputMaybe<Array<CustomStatFilterInput> | CustomStatFilterInput>;
  filterByOrganizationRoster?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ScoutingListAllTargetsQuery = { __typename?: 'Query', listAllScoutingTargets: { __typename?: 'ScoutingTargetConnection', totalCount: number, edges: Array<{ __typename?: 'ScoutingTargetEdge', cursor: string, node: { __typename?: 'ScoutingTarget', id: string, scoutReportCount: number, avgScoutRating?: number | null, scoutRatingScaleMax?: number | null, lastEditedAt?: string | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, dateOfBirth?: string | null, teamName?: string | null, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null, primaryPosition?: string | null, fitScore?: number | null, teamStyleFit?: number | null, customStats?: Record<string, any> | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, dateOfBirth?: string | null, age?: number | null } | null } | null, lastEditor?: { __typename?: 'User', id: string, displayName: string } | null, averageRatings: Array<{ __typename?: 'ScoutRatingAverage', name: string, average: number, count: number }>, watchlists: Array<{ __typename?: 'WatchlistSummary', id: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ScoutingListRoleArchetypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutingListRoleArchetypesQuery = { __typename?: 'Query', listRoleArchetypes: Array<string> };

export type ScoutingListScoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutingListScoutsQuery = { __typename?: 'Query', listScoutingScouts: Array<{ __typename?: 'ScoutWithWatchlists', id: string, email?: string | null, title?: string | null }> };

export type ScoutingListRecentlyInteractedPlayersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ScoutingListRecentlyInteractedPlayersQuery = { __typename?: 'Query', listRecentlyInteractedPlayers: Array<{ __typename?: 'RecentlyInteractedPlayer', id: string, lastActivityAt: string, activityType: string, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, teamName?: string | null, positions?: Array<{ __typename?: 'Position', id: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, gpr?: number | null } | null } | null }> };

export type LogPlayerProfileViewMutationVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type LogPlayerProfileViewMutation = { __typename?: 'Mutation', logPlayerProfileView: { __typename?: 'RecentlyInteractedPlayer', id: string } };

export type ScoutingListUserWatchlistsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ScoutingListUserWatchlistsQuery = { __typename?: 'Query', listMyUserWatchlists: { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, effectiveRole: UserWatchlistRole, grantSource: UserWatchlistGrantSource, userId: string, isDefault: boolean, lastSelectedAt?: string | null, watchlist: { __typename?: 'Watchlist', id: string, name: string, playerCount: number, updatedAt: string } } }> } };

export type ScoutingGetWatchlistPitchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WatchlistPitchFilterInput>;
}>;


export type ScoutingGetWatchlistPitchQuery = { __typename?: 'Query', getWatchlistPitch?: { __typename?: 'WatchlistPitch', id: string, name: string, role: UserWatchlistRole, canEdit: boolean, formation: PitchFormation, pitchRevision: number, pitchInitialized: boolean, manualOrder: boolean, watchlistCount: number, overlayCount: number, members: { __typename?: 'WatchlistPitchMemberConnection', edges: Array<{ __typename?: 'WatchlistPitchMemberEdge', cursor: string, node: { __typename?: 'WatchlistPitchMember', id: string, playerId: string, rank: number, effectiveSlot?: TacticalSlot | null, assignmentOrigin: PitchAssignmentOrigin, primaryPositionCode?: string | null, primaryPositionSource: PrimaryPositionSource, displayName: string, club?: string | null, imageUrl?: string | null, gpr?: number | null, naturalPositions: Array<{ __typename?: 'WatchlistPitchNaturalPosition', id: string, name: string, abbreviation?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } }, overlay: Array<{ __typename?: 'WatchlistPitchOverlayPlayer', id: string, club?: string | null, age?: number | null, nationality?: string | null, displayName: string, imageUrl?: string | null, gpr?: number | null, rosterTier: WatchlistPitchRosterTier, naturalPositions: Array<{ __typename?: 'WatchlistPitchNaturalPosition', id: string, name: string, abbreviation?: string | null }> }> } | null };

export type ScoutingUpdateWatchlistPitchAssignmentMutationVariables = Exact<{
  input: UpdateWatchlistPitchAssignmentInput;
}>;


export type ScoutingUpdateWatchlistPitchAssignmentMutation = { __typename?: 'Mutation', updateWatchlistPitchAssignment: { __typename?: 'WatchlistPitchAssignmentPayload', watchlistId: string, formation: PitchFormation, pitchInitialized: boolean, pitchRevision: number, assignments: Array<{ __typename?: 'WatchlistPitchSavedAssignment', playerId: string, rank: number, tacticalSlot?: TacticalSlot | null }> } };

export type ScoutingUpdateWatchlistFormationMutationVariables = Exact<{
  input: UpdateWatchlistFormationInput;
}>;


export type ScoutingUpdateWatchlistFormationMutation = { __typename?: 'Mutation', updateWatchlistFormation: { __typename?: 'WatchlistPitchAssignmentPayload', watchlistId: string, formation: PitchFormation, pitchInitialized: boolean, pitchRevision: number, assignments: Array<{ __typename?: 'WatchlistPitchSavedAssignment', playerId: string, rank: number, tacticalSlot?: TacticalSlot | null }> } };

export type ScoutingGetScoutReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ScoutingGetScoutReportQuery = { __typename?: 'Query', getScoutReport: { __typename?: 'PlayerScoutReport', reportId?: string | null, canEdit?: boolean | null, canArchive?: boolean | null, ggPlayerKey?: string | null, scoutUserId?: string | null, scoutName?: string | null, reportDate?: string | null, team?: string | null, opponent?: string | null, ground?: string | null, overallScore?: number | null, qnaText?: string | null, translatedQnaText?: string | null, availableTranslations?: Array<string> | null, matchName?: string | null, lastEditorUserId?: string | null, lastEditorName?: string | null, lastEditDate?: string | null, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null } };

export type ScoutingGetScoutReportTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutingGetScoutReportTypesQuery = { __typename?: 'Query', getScoutReportTypes: Array<{ __typename?: 'ScoutReportType', id: string, name: string, reportFormat: ReportFormat, ratingDefinitions: Array<{ __typename?: 'ScoutReportRatingDefinition', key: string, label: string }>, categoricalRatingDefinitions: Array<{ __typename?: 'ScoutReportRatingDefinition', key: string, label: string }> }> };

export type ScoutingScoutReportFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ScoutingScoutReportFilterOptionsQuery = { __typename?: 'Query', scoutReportFilterOptions: { __typename?: 'ScoutReportFilterOptions', matchNames: Array<string>, teams: Array<{ __typename?: 'ReportTeamOption', name: string, teamIds: Array<string> }>, scouts: Array<{ __typename?: 'ScoutOption', userId: string, name: string }>, ratingKeys: Array<{ __typename?: 'ScoutReportRatingDefinition', key: string, label: string }> } };

export type ScoutingOrganizationScoutReportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationScoutReportsFilterInput>;
  sort?: InputMaybe<OrganizationScoutReportsSortInput>;
}>;


export type ScoutingOrganizationScoutReportsQuery = { __typename?: 'Query', organizationScoutReports: { __typename?: 'OrganizationScoutReportConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrganizationScoutReportEdge', cursor: string, node: { __typename?: 'OrganizationScoutReportNode', id: string, playerName?: string | null, playerId?: string | null, club?: string | null, matchName?: string | null, matchDate?: string | null, createdAt: string, updatedAt: string, scoutName?: string | null, scoutUserId?: string | null, reportTypeName?: string | null, reportTypeId?: string | null, overallScore?: number | null, numericRatings: Array<{ __typename?: 'ScoutReportNumericRating', key: string, label: string, value?: number | null }>, categoricalRatings: Array<{ __typename?: 'ScoutReportCategoricalRating', key: string, label: string, value?: string | null }>, matches?: Array<{ __typename?: 'MatchDetail', team?: string | null, opponent?: string | null, ground?: string | null, matchDate?: string | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SeeAllListsDrawerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SeeAllListsDrawerQuery = { __typename?: 'Query', listMyUserWatchlists: { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, effectiveRole: UserWatchlistRole, grantSource: UserWatchlistGrantSource, lastSelectedAt?: string | null, watchlist: { __typename?: 'Watchlist', id: string, name: string, playerCount: number, lastActivityAt?: string | null, updatedAt: string, users: Array<{ __typename?: 'User', id: string }> } } }> } };

export type SeeAllListsDrawerMarkSelectedMutationVariables = Exact<{
  watchlistId: Scalars['ID']['input'];
}>;


export type SeeAllListsDrawerMarkSelectedMutation = { __typename?: 'Mutation', markUserWatchlistAsRecentlySelected: { __typename?: 'UserWatchlist', id: string, watchlistId: string, lastSelectedAt?: string | null } };

export type ScoutingListMatchReportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MatchReportFilterInput>;
}>;


export type ScoutingListMatchReportsQuery = { __typename?: 'Query', listMatchReports: { __typename?: 'MatchReportConnection', edges: Array<{ __typename?: 'MatchReportEdge', cursor: string, node: { __typename?: 'MatchReport', id: string, status: MatchReportStatus, notedCount: number, tickedCount: number, scoredCount: number, squadSize?: number | null, submittedAt?: string | null, createdAt: string, updatedAt: string, watchMode?: MatchWatchMode | null, match: { __typename?: 'Match', id: string, scheduledDate: string, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string }, league?: { __typename?: 'League', id: string, name: string } | null }, scoutUser: { __typename?: 'User', id: string, displayName: string }, scouts: Array<{ __typename?: 'User', id: string, displayName: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ScoutingMatchReportPlayersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ScoutingMatchReportPlayersQuery = { __typename?: 'Query', getMatchReport?: { __typename?: 'MatchReport', id: string, playerEvaluations: Array<{ __typename?: 'MatchReportPlayerEvaluation', id: string, isNoted: boolean, performanceScore?: number | null, potentialScore?: number | null, note?: string | null, shirtNumber?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, positions?: Array<{ __typename?: 'Position', id: string, abbreviation?: string | null }> | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null }> } | null };

export type ScoutingWatchlistBulkMembershipPayloadFragment = { __typename?: 'WatchlistBulkMembershipPayload', addedPlayerIds: Array<string>, alreadyPresentPlayerIds: Array<string>, removedPlayerIds: Array<string>, notPresentPlayerIds: Array<string>, pitchRevision: number, watchlist: { __typename?: 'Watchlist', id: string, name: string, playerCount: number }, placementOutcomes: Array<{ __typename?: 'WatchlistBulkPlacementOutcome', playerId: string, requestedSlot: TacticalSlot, tacticalSlot?: TacticalSlot | null, outcome: WatchlistBulkPlacementResult }> };

export type ScoutingAddPlayersToWatchlistMutationVariables = Exact<{
  input: AddPlayersToWatchlistInput;
}>;


export type ScoutingAddPlayersToWatchlistMutation = { __typename?: 'Mutation', addPlayersToWatchlist: { __typename?: 'WatchlistBulkMembershipPayload', addedPlayerIds: Array<string>, alreadyPresentPlayerIds: Array<string>, removedPlayerIds: Array<string>, notPresentPlayerIds: Array<string>, pitchRevision: number, watchlist: { __typename?: 'Watchlist', id: string, name: string, playerCount: number }, placementOutcomes: Array<{ __typename?: 'WatchlistBulkPlacementOutcome', playerId: string, requestedSlot: TacticalSlot, tacticalSlot?: TacticalSlot | null, outcome: WatchlistBulkPlacementResult }> } };

export type ScoutingRemovePlayersFromWatchlistMutationVariables = Exact<{
  input: RemovePlayersFromWatchlistInput;
}>;


export type ScoutingRemovePlayersFromWatchlistMutation = { __typename?: 'Mutation', removePlayersFromWatchlist: { __typename?: 'WatchlistBulkMembershipPayload', addedPlayerIds: Array<string>, alreadyPresentPlayerIds: Array<string>, removedPlayerIds: Array<string>, notPresentPlayerIds: Array<string>, pitchRevision: number, watchlist: { __typename?: 'Watchlist', id: string, name: string, playerCount: number }, placementOutcomes: Array<{ __typename?: 'WatchlistBulkPlacementOutcome', playerId: string, requestedSlot: TacticalSlot, tacticalSlot?: TacticalSlot | null, outcome: WatchlistBulkPlacementResult }> } };

export type ScoutingCreateWatchlistFromSelectionMutationVariables = Exact<{
  input: CreateWatchlistInput;
}>;


export type ScoutingCreateWatchlistFromSelectionMutation = { __typename?: 'Mutation', createWatchlist: { __typename?: 'Watchlist', id: string, name: string, playerCount: number } };

export type ScoutingListWatchlistPlayerIdsQueryVariables = Exact<{
  watchlistId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScoutingListWatchlistPlayerIdsQuery = { __typename?: 'Query', listWatchlistPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ScoutingShareGroupFragment = { __typename?: 'ShareGroup', key: ShareGroupKey, label: string, memberCount: number };

export type ScoutingGroupGrantFragment = { __typename?: 'GroupGrant', id: string, entityType: ShareEntityType, entityId: string, organizationId: string, role: GroupGrantRole, grantedByUserId: string, createdAt: string, group: { __typename?: 'ShareGroup', key: ShareGroupKey, label: string, memberCount: number } };

export type ScoutingEligibleShareGroupsQueryVariables = Exact<{
  entityType: ShareEntityType;
  entityId: Scalars['ID']['input'];
}>;


export type ScoutingEligibleShareGroupsQuery = { __typename?: 'Query', eligibleShareGroups: Array<{ __typename?: 'ShareGroup', key: ShareGroupKey, label: string, memberCount: number }> };

export type ScoutingListGroupGrantsQueryVariables = Exact<{
  entityType: ShareEntityType;
  entityId: Scalars['ID']['input'];
}>;


export type ScoutingListGroupGrantsQuery = { __typename?: 'Query', listGroupGrants: Array<{ __typename?: 'GroupGrant', id: string, entityType: ShareEntityType, entityId: string, organizationId: string, role: GroupGrantRole, grantedByUserId: string, createdAt: string, group: { __typename?: 'ShareGroup', key: ShareGroupKey, label: string, memberCount: number } }> };

export type ScoutingCreateGroupGrantMutationVariables = Exact<{
  input: CreateGroupGrantInput;
}>;


export type ScoutingCreateGroupGrantMutation = { __typename?: 'Mutation', createGroupGrant: { __typename?: 'GroupGrant', id: string, entityType: ShareEntityType, entityId: string, organizationId: string, role: GroupGrantRole, grantedByUserId: string, createdAt: string, group: { __typename?: 'ShareGroup', key: ShareGroupKey, label: string, memberCount: number } } };

export type ScoutingUpdateGroupGrantRoleMutationVariables = Exact<{
  input: UpdateGroupGrantRoleInput;
}>;


export type ScoutingUpdateGroupGrantRoleMutation = { __typename?: 'Mutation', updateGroupGrantRole: { __typename?: 'GroupGrant', id: string, entityType: ShareEntityType, entityId: string, organizationId: string, role: GroupGrantRole, grantedByUserId: string, createdAt: string, group: { __typename?: 'ShareGroup', key: ShareGroupKey, label: string, memberCount: number } } };

export type ScoutingDeleteGroupGrantMutationVariables = Exact<{
  input: DeleteGroupGrantInput;
}>;


export type ScoutingDeleteGroupGrantMutation = { __typename?: 'Mutation', deleteGroupGrant: { __typename?: 'DeleteGroupGrantPayload', id: string, removed: boolean } };

export type SimilarPlayersPlayerResultFragment = { __typename?: 'SimilarPlayerResult', similarityScore?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null };

export type SimilarPlayersSimilarPlayerConnectionFragment = { __typename?: 'SimilarPlayerConnection', edges: Array<{ __typename?: 'SimilarPlayerEdge', node: { __typename?: 'SimilarPlayerResult', similarityScore?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type SimilarPlayersListSimilarPlayersQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SimilarPlayerFilterInput>;
}>;


export type SimilarPlayersListSimilarPlayersQuery = { __typename?: 'Query', listSimilarPlayers: { __typename?: 'SimilarPlayerConnection', edges: Array<{ __typename?: 'SimilarPlayerEdge', node: { __typename?: 'SimilarPlayerResult', similarityScore?: number | null, player?: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isWatchedByCurrentUser: boolean, teamName?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, team?: { __typename?: 'Team', id: string, name: string } | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, age?: number | null, dateOfBirth?: string | null, fitScore?: number | null, teamStyleFit?: number | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, valuationStatus?: string | null, onLoanFrom?: string | null, carryingTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, contractExpires?: string | null, gpr?: number | null, customStats?: Record<string, any> | null, roleArchetype?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SquadPlanningGetSquadPlayersByPositionQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SquadPlanningGetSquadPlayersByPositionQuery = { __typename?: 'Query', getSquadPlayersByPosition: { __typename?: 'SquadPlayersByPositionModel', firstTeam: Array<{ __typename?: 'SquadPositionPlayerModel', id: string, name: string, firstName?: string | null, knownName?: string | null, lastName?: string | null, age?: number | null, gpr?: number | null, gpv?: number | null, gpvMin?: number | null, gpvMax?: number | null, minutes?: number | null, wage?: number | null, amortisationAnnual?: number | null, netBookValue?: number | null, estVal?: number | null, contractExpiry?: string | null, status?: string | null, position?: string | null, positions: Array<string>, nationalityName?: string | null, isManual: boolean, teamName?: string | null, transitionType?: TransitionType | null }>, academy: Array<{ __typename?: 'AcademyPositionPlayerModel', id: string, name: string, firstName?: string | null, knownName?: string | null, lastName?: string | null, age?: number | null, gpr?: number | null, gpv?: number | null, gpvMin?: number | null, gpvMax?: number | null, minutes?: number | null, wage?: number | null, amortisationAnnual?: number | null, netBookValue?: number | null, estVal?: number | null, contractExpiry?: string | null, status?: string | null, position?: string | null, positions: Array<string>, nationalityName?: string | null, isManual: boolean, teamName?: string | null, readinessTag?: ReadinessTag | null, transitionType?: TransitionType | null }>, targets: Array<{ __typename?: 'TargetPositionPlayerModel', id: string, name: string, age?: number | null, gpr?: number | null, gpv?: number | null, gpvMin?: number | null, gpvMax?: number | null, minutes?: number | null, wage?: number | null, amortisationAnnual?: number | null, netBookValue?: number | null, estVal?: number | null, contractExpiry?: string | null, status?: string | null, position?: string | null, positions: Array<string>, nationalityName?: string | null, isManual: boolean, teamName?: string | null, sourceWatchlists: Array<string>, transitionType?: TransitionType | null }> } };

export type SquadPlanningGetSquadDepthByPositionQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SquadPlanningGetSquadDepthByPositionQuery = { __typename?: 'Query', getSquadDepthByPosition: { __typename?: 'SquadDepthByPositionModel', formation: string, positions: Array<{ __typename?: 'SquadDepthPositionModel', positionId: string, name?: string | null, playerCount: number, avgGpr?: number | null }> } };

export type SquadPlanningGetSquadKpIsQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SquadPlanningGetSquadKpIsQuery = { __typename?: 'Query', getSquadKPIs: { __typename?: 'SquadKPIsModel', totalWageBill?: number | null, contractsExpiring12Mo?: number | null, unavailableCount: number, wageCompleteness?: number | null, totalPlayers: { __typename?: 'TotalPlayersModel', firstTeam: number, academy: number }, scenarioImpact?: { __typename?: 'ScenarioImpactModel', acquisitionCost: number, capitalGains: number, playerDelta: number, firstTeamDelta: number, academyDelta: number, wageImpact: number, completeness: { __typename?: 'ScenarioImpactCompleteness', complete: boolean, notProvidedCount: number, notProvided: Array<{ __typename?: 'ScenarioImpactNotProvided', playerId: string, playerName: string, transitionType: TransitionType, missing: Array<ScenarioFinanceField> }> } } | null } };

export type SquadPlanningGetScenarioQueryVariables = Exact<{
  scenarioId: Scalars['ID']['input'];
}>;


export type SquadPlanningGetScenarioQuery = { __typename?: 'Query', getScenario: { __typename?: 'ScenarioDetailModel', id: string, name: string, createdAt: string, updatedAt: string, ownerUserId?: string | null, isLegacyNoOwner: boolean, revision: number, actions: Array<{ __typename?: 'ScenarioActionModel', playerId?: string | null, playerName: string, transitionType: TransitionType, financialDetails?: { __typename?: 'FinancialDetailsModel', salePrice?: number | null, loanFee?: number | null, signingFee?: number | null, wage?: number | null, durationMonths?: number | null, signingBonus?: number | null, agentFee?: number | null, coveredSharePercent?: number | null } | null, externalPlayerData?: { __typename?: 'ScenarioExternalPlayerModel', name: string, teamName?: string | null, positions?: Array<string> | null, age?: number | null, gpr?: number | null, nationalityName?: string | null } | null }> } };

export type SquadPlanningListScenariosQueryVariables = Exact<{ [key: string]: never; }>;


export type SquadPlanningListScenariosQuery = { __typename?: 'Query', listScenarios: Array<{ __typename?: 'ScenarioModel', id: string, name: string, createdAt: string, updatedAt: string, ownerUserId?: string | null, isLegacyNoOwner: boolean, revision: number }> };

export type SquadPlanningCreateScenarioMutationVariables = Exact<{
  input: CreateScenarioInput;
}>;


export type SquadPlanningCreateScenarioMutation = { __typename?: 'Mutation', createScenario: { __typename?: 'ScenarioModel', id: string, name: string, createdAt: string, updatedAt: string, ownerUserId?: string | null, isLegacyNoOwner: boolean, revision: number } };

export type SquadPlanningClaimScenarioOwnershipMutationVariables = Exact<{
  input: ClaimScenarioOwnershipInput;
}>;


export type SquadPlanningClaimScenarioOwnershipMutation = { __typename?: 'Mutation', claimScenarioOwnership: { __typename?: 'ScenarioModel', id: string, name: string, createdAt: string, updatedAt: string, ownerUserId?: string | null, isLegacyNoOwner: boolean, revision: number } };

export type SquadPlanningRemoveScenarioActionMutationVariables = Exact<{
  input: RemoveScenarioActionInput;
}>;


export type SquadPlanningRemoveScenarioActionMutation = { __typename?: 'Mutation', removeScenarioAction: { __typename?: 'RemoveScenarioActionPayload', removed: boolean, removedTransitionType?: TransitionType | null, wasExternal: boolean, scenario: { __typename?: 'ScenarioModel', id: string, revision: number, updatedAt: string } } };

export type SquadPlanningUpdateScenarioMutationVariables = Exact<{
  input: UpdateScenarioInput;
}>;


export type SquadPlanningUpdateScenarioMutation = { __typename?: 'Mutation', updateScenario: { __typename?: 'ScenarioModel', id: string, name: string, updatedAt: string } };

export type SquadPlanningDeleteScenarioMutationVariables = Exact<{
  scenarioId: Scalars['ID']['input'];
}>;


export type SquadPlanningDeleteScenarioMutation = { __typename?: 'Mutation', deleteScenario: { __typename?: 'RemoveTransitionResult', success: boolean } };

export type SquadPlanningSetPlayerAcademyStatusMutationVariables = Exact<{
  input: SetPlayerAcademyStatusInput;
}>;


export type SquadPlanningSetPlayerAcademyStatusMutation = { __typename?: 'Mutation', setPlayerAcademyStatus: { __typename?: 'Player', id: string, isAcademy: boolean, isManual: boolean } };

export type SquadPlanningUpsertOrganizationPlayerDataMutationVariables = Exact<{
  input: UpsertOrganizationPlayerDataInput;
}>;


export type SquadPlanningUpsertOrganizationPlayerDataMutation = { __typename?: 'Mutation', upsertOrganizationPlayerData: { __typename?: 'OrganizationPlayerDataModel', id: string, grossAnnualSalary?: number | null, estValuation?: number | null, readinessTag?: ReadinessTag | null } };

export type SquadPlanningShareUserFragment = { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null };

export type SquadPlanningScenarioAccessFragment = { __typename?: 'ScenarioModel', id: string, revision: number, financialsVisible: boolean, myRole: ScenarioRole, canManageSharing: boolean };

export type SquadPlanningUserScenarioFragment = { __typename?: 'UserScenario', id: string, scenarioId: string, userId: string, organizationId: string, role: ScenarioRole, isMembershipActive: boolean, createdAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } };

export type SquadPlanningListScenarioAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type SquadPlanningListScenarioAccessQuery = { __typename?: 'Query', listScenarios: Array<{ __typename?: 'ScenarioModel', id: string, revision: number, financialsVisible: boolean, myRole: ScenarioRole, canManageSharing: boolean }> };

export type SquadPlanningGetScenarioGrantsQueryVariables = Exact<{
  scenarioId: Scalars['ID']['input'];
}>;


export type SquadPlanningGetScenarioGrantsQuery = { __typename?: 'Query', getScenario: { __typename?: 'ScenarioDetailModel', id: string, revision: number, financialsVisible: boolean, myRole: ScenarioRole, canManageSharing: boolean, grants?: Array<{ __typename?: 'UserScenario', id: string, scenarioId: string, userId: string, organizationId: string, role: ScenarioRole, isMembershipActive: boolean, createdAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } }> | null } };

export type SquadPlanningListOrganizationUsersForSharingQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SquadPlanningListOrganizationUsersForSharingQuery = { __typename?: 'Query', listMyOrganizationsOrganizationUsers: { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', node: { __typename?: 'OrganizationUser', id: string, role?: { __typename?: 'Role', id: string, name: RoleName } | null, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SquadPlanningCreateUserScenarioMutationVariables = Exact<{
  input: CreateUserScenarioInput;
}>;


export type SquadPlanningCreateUserScenarioMutation = { __typename?: 'Mutation', createUserScenario: { __typename?: 'UserScenario', id: string, scenarioId: string, userId: string, organizationId: string, role: ScenarioRole, isMembershipActive: boolean, createdAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type SquadPlanningUpdateUserScenarioRoleMutationVariables = Exact<{
  input: UpdateUserScenarioRoleInput;
}>;


export type SquadPlanningUpdateUserScenarioRoleMutation = { __typename?: 'Mutation', updateUserScenarioRole: { __typename?: 'UserScenario', id: string, scenarioId: string, userId: string, organizationId: string, role: ScenarioRole, isMembershipActive: boolean, createdAt: string, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type SquadPlanningDeleteUserScenarioMutationVariables = Exact<{
  input: DeleteUserScenarioInput;
}>;


export type SquadPlanningDeleteUserScenarioMutation = { __typename?: 'Mutation', deleteUserScenario: { __typename?: 'DeleteUserScenarioPayload', id: string, removed: boolean } };

export type SquadPlanningSetScenarioFinancialsVisibilityMutationVariables = Exact<{
  input: SetScenarioFinancialsVisibilityInput;
}>;


export type SquadPlanningSetScenarioFinancialsVisibilityMutation = { __typename?: 'Mutation', setScenarioFinancialsVisibility: { __typename?: 'ScenarioModel', id: string, revision: number, financialsVisible: boolean, myRole: ScenarioRole, canManageSharing: boolean } };

export type SquadPlanningScenarioPitchFragment = { __typename?: 'ScenarioPitch', scenarioId: string, formation: PitchFormation, pitchRevision: number, pitchInitialized: boolean, canEdit: boolean, myRole: ScenarioRole, lastEditedAt?: string | null, entries: Array<{ __typename?: 'ScenarioPitchEntry', playerId: string, tacticalSlot?: TacticalSlot | null, rank: number }>, lastEditedBy?: { __typename?: 'PitchEditor', id: string, displayName: string } | null };

export type SquadPlanningGetScenarioPitchQueryVariables = Exact<{
  scenarioId: Scalars['ID']['input'];
}>;


export type SquadPlanningGetScenarioPitchQuery = { __typename?: 'Query', getScenarioPitch: { __typename?: 'ScenarioPitch', scenarioId: string, formation: PitchFormation, pitchRevision: number, pitchInitialized: boolean, canEdit: boolean, myRole: ScenarioRole, lastEditedAt?: string | null, entries: Array<{ __typename?: 'ScenarioPitchEntry', playerId: string, tacticalSlot?: TacticalSlot | null, rank: number }>, lastEditedBy?: { __typename?: 'PitchEditor', id: string, displayName: string } | null } };

export type SquadPlanningUpdateScenarioPreferenceOrderMutationVariables = Exact<{
  input: UpdateScenarioPreferenceOrderInput;
}>;


export type SquadPlanningUpdateScenarioPreferenceOrderMutation = { __typename?: 'Mutation', updateScenarioPreferenceOrder: { __typename?: 'ScenarioPitch', scenarioId: string, formation: PitchFormation, pitchRevision: number, pitchInitialized: boolean, canEdit: boolean, myRole: ScenarioRole, lastEditedAt?: string | null, entries: Array<{ __typename?: 'ScenarioPitchEntry', playerId: string, tacticalSlot?: TacticalSlot | null, rank: number }>, lastEditedBy?: { __typename?: 'PitchEditor', id: string, displayName: string } | null } };

export type SquadPlanningUpdateScenarioPitchAssignmentMutationVariables = Exact<{
  input: UpdateScenarioPitchAssignmentInput;
}>;


export type SquadPlanningUpdateScenarioPitchAssignmentMutation = { __typename?: 'Mutation', updateScenarioPitchAssignment: { __typename?: 'ScenarioPitch', scenarioId: string, formation: PitchFormation, pitchRevision: number, pitchInitialized: boolean, canEdit: boolean, myRole: ScenarioRole, lastEditedAt?: string | null, entries: Array<{ __typename?: 'ScenarioPitchEntry', playerId: string, tacticalSlot?: TacticalSlot | null, rank: number }>, lastEditedBy?: { __typename?: 'PitchEditor', id: string, displayName: string } | null } };

export type SquadPlanningUpdateScenarioFormationMutationVariables = Exact<{
  input: UpdateScenarioFormationInput;
}>;


export type SquadPlanningUpdateScenarioFormationMutation = { __typename?: 'Mutation', updateScenarioFormation: { __typename?: 'ScenarioPitch', scenarioId: string, formation: PitchFormation, pitchRevision: number, pitchInitialized: boolean, canEdit: boolean, myRole: ScenarioRole, lastEditedAt?: string | null, entries: Array<{ __typename?: 'ScenarioPitchEntry', playerId: string, tacticalSlot?: TacticalSlot | null, rank: number }>, lastEditedBy?: { __typename?: 'PitchEditor', id: string, displayName: string } | null } };

export type SquadPlanningUpdatePlayerWageMutationVariables = Exact<{
  input: UpdatePlayerWageInput;
}>;


export type SquadPlanningUpdatePlayerWageMutation = { __typename?: 'Mutation', updatePlayerWage: { __typename?: 'OrganizationPlayerDataModel', id: string, playerId: string, grossAnnualSalary?: number | null } };

export type TeamSelectionTeamFragment = { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string, country?: string | null } | null };

export type TeamSelectionTeamEdgeFragment = { __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string, country?: string | null } | null } };

export type TeamSelectionTeamConnectionFragment = { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string, country?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type TeamSelectionSelectableTeamsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamSelectionSelectableTeamsQuery = { __typename?: 'Query', selectableTeams: { __typename?: 'TeamConnection', edges: Array<{ __typename?: 'TeamEdge', cursor: string, node: { __typename?: 'Team', id: string, name: string, league?: { __typename?: 'League', id: string, name: string, country?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type UpdateFeedEventFragment = { __typename?: 'FeedEvent', id: string, category: FeedEventCategory, headline: string, timestamp: string, clickthrough?: string | null, groupKey: string };

export type GetCurrentLastFeedVisitAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentLastFeedVisitAtQuery = { __typename?: 'Query', getCurrentLastFeedVisitAt?: string | null };

export type CommitLastFeedVisitAtMutationVariables = Exact<{
  at: Scalars['DateTime']['input'];
}>;


export type CommitLastFeedVisitAtMutation = { __typename?: 'Mutation', commitLastFeedVisitAt: { __typename?: 'User', id: string, lastFeedVisitAt?: string | null } };

export type UpdateFeedEventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<FeedEventCategory> | FeedEventCategory>;
}>;


export type UpdateFeedEventsQuery = { __typename?: 'Query', feedEvents: { __typename?: 'FeedEventConnection', totalCount: number, edges: Array<{ __typename?: 'FeedEventEdge', node: { __typename?: 'FeedEvent', id: string, category: FeedEventCategory, headline: string, timestamp: string, clickthrough?: string | null, groupKey: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ArchiveFeedUpdatesMutationVariables = Exact<{
  input: ArchiveFeedUpdatesInput;
}>;


export type ArchiveFeedUpdatesMutation = { __typename?: 'Mutation', archiveFeedUpdates: { __typename?: 'ArchiveFeedUpdatesResult', archivedCount: number } };

export type WatchlistTeamFragment = { __typename?: 'Team', id: string, name: string };

export type WatchlistLeagueFragment = { __typename?: 'League', id: string, name: string };

export type WatchlistPlayerPositionFragment = { __typename?: 'Position', id: string, name: string, abbreviation?: string | null };

export type WatchlistPlayerBioDataFragment = { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null };

export type WatchlistPlayerSeasonWeightedAvgMetricsFragment = { __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number };

export type WatchlistPlayerSeasonCategoricalScoreFragment = { __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null };

export type WatchlistPlayerFragment = { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null };

export type WatchlistPlayerConnectionFragment = { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type WatchlistWatchlistFragment = { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type WatchlistPlayerIdConnectionFragment = { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type WatchlistWatchlistMetaFragment = { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type WatchlistWatchlistConnectionFragment = { __typename?: 'WatchlistConnection', edges: Array<{ __typename?: 'WatchlistEdge', cursor: string, node: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type WatchlistCognitoUserFragment = { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null };

export type WatchlistUserFragment = { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null };

export type WatchlistUserWatchlistFragment = { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, grantSource: UserWatchlistGrantSource, effectiveRole: UserWatchlistRole, isMembershipActive: boolean, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } };

export type WatchlistMyUserWatchlistFragment = { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, isDefault: boolean, watchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistUserWatchlistConnectionFragment = { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', cursor: string, node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, grantSource: UserWatchlistGrantSource, effectiveRole: UserWatchlistRole, isMembershipActive: boolean, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type WatchlistMyUserWatchlistConnectionFragment = { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', cursor: string, node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, isDefault: boolean, watchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type WatchlistWatchlistEdgeFragment = { __typename?: 'WatchlistEdge', cursor: string, node: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistOrganizationUserEdgeFragment = { __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } };

export type WatchlistOrganizationUserFragment = { __typename?: 'OrganizationUser', id: string, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null };

export type WatchlistOrganizationUserConnectionFragment = { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type WatchlistListMyOrganizationsOrganizationUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type WatchlistListMyOrganizationsOrganizationUsersQuery = { __typename?: 'Query', listMyOrganizationsOrganizationUsers: { __typename?: 'OrganizationUserConnection', edges: Array<{ __typename?: 'OrganizationUserEdge', cursor: string, node: { __typename?: 'OrganizationUser', id: string, user?: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type WatchlistListUserWatchlistsByWatchlistIdQueryVariables = Exact<{
  watchlistId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type WatchlistListUserWatchlistsByWatchlistIdQuery = { __typename?: 'Query', listUserWatchlistsByWatchlistId: { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', cursor: string, node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, grantSource: UserWatchlistGrantSource, effectiveRole: UserWatchlistRole, isMembershipActive: boolean, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type WatchlistListMyUserWatchlistsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type WatchlistListMyUserWatchlistsQuery = { __typename?: 'Query', listMyUserWatchlists: { __typename?: 'UserWatchlistConnection', edges: Array<{ __typename?: 'UserWatchlistEdge', cursor: string, node: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, isDefault: boolean, watchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type WatchlistGetPlayerBioDataByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type WatchlistGetPlayerBioDataByPlayerIdQuery = { __typename?: 'Query', getPlayerBioDataByPlayerId?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null };

export type WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type WatchlistListPlayerSeasonWeightedAvgMetricsQuery = { __typename?: 'Query', listPlayerSeasonWeightedAvgMetricsByPlayerId?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null };

export type WatchlistListWatchlistPlayersQueryVariables = Exact<{
  watchlistId: Scalars['ID']['input'];
  sortBy?: InputMaybe<SortField>;
  sortByCustomStatName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<OrderByDirection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type WatchlistListWatchlistPlayersQuery = { __typename?: 'Query', listWatchlistPlayers: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type WatchlistDeleteWatchlistMutationVariables = Exact<{
  input: DeleteWatchlistInput;
}>;


export type WatchlistDeleteWatchlistMutation = { __typename?: 'Mutation', deleteWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistUpdateWatchlistMutationVariables = Exact<{
  input: UpdateWatchlistInput;
}>;


export type WatchlistUpdateWatchlistMutation = { __typename?: 'Mutation', updateWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistRemovePlayerFromWatchlistMutationVariables = Exact<{
  input: RemovePlayerFromWatchlistInput;
}>;


export type WatchlistRemovePlayerFromWatchlistMutation = { __typename?: 'Mutation', removePlayerFromWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistUpdateUserWatchlistPositionMutationVariables = Exact<{
  input: UpdateUserWatchlistPositionInput;
}>;


export type WatchlistUpdateUserWatchlistPositionMutation = { __typename?: 'Mutation', updateUserWatchlistPosition: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistAddPlayerToWatchlistMutationVariables = Exact<{
  input: AddPlayerToWatchlistInput;
}>;


export type WatchlistAddPlayerToWatchlistMutation = { __typename?: 'Mutation', addPlayerToWatchlist: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistUpdateWatchlistPlayerPositionMutationVariables = Exact<{
  input: UpdateWatchlistPlayerPositionInput;
}>;


export type WatchlistUpdateWatchlistPlayerPositionMutation = { __typename?: 'Mutation', updateWatchlistPlayerPosition: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchListUpdateWatchListPlayerPositionsMutationVariables = Exact<{
  input: UpdateWatchlistPlayerPositionsInput;
}>;


export type WatchListUpdateWatchListPlayerPositionsMutation = { __typename?: 'Mutation', updateWatchlistPlayerPositions: { __typename?: 'Watchlist', id: string, name: string, players: { __typename?: 'PlayerConnection', edges: Array<{ __typename?: 'PlayerEdge', cursor: string, node: { __typename?: 'Player', id: string, name: string, knownName?: string | null, firstName: string, lastName: string, isManual: boolean, isAcademy: boolean, teamName?: string | null, isWatchedByCurrentUser: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, league?: { __typename?: 'League', id: string, name: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, positions?: Array<{ __typename?: 'Position', id: string, name: string, abbreviation?: string | null }> | null, seasonWeightedAvgMetrics?: Array<{ __typename?: 'PlayerSeasonWeightedAvgMetrics', epm?: number | null, seasonalGpm?: number | null, ggUnifiedSeasonKey: number }> | null, bioData?: { __typename?: 'PlayerBioData', ggPlayerKey: string, dateOfBirth?: string | null, age?: number | null, foot?: string | null, roleArchetype?: string | null, secondaryRoleArchetype?: string | null, isInjured?: boolean | null, contractExpires?: string | null, playerValuation?: number | null, fairFee?: number | null, expectedFee?: number | null, gpm?: number | null, gpr?: number | null, timeDecayedSeasonalGpm?: number | null, timeDecayedZVaep?: number | null, fitScore?: number | null, teamStyleFit?: number | null, physicalScore?: number | null, passingTransGlobalCategoricalScore?: number | null, shotLocationTransGlobalCategoricalScore?: number | null, dribblingTransGlobalCategoricalScore?: number | null, carryingTransGlobalCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, aerialsTransGlobalCategoricalScore?: number | null, anticipatingTransGlobalCategoricalScore?: number | null, assistingTransGlobalCategoricalScore?: number | null, buildupTransGlobalCategoricalScore?: number | null, creatingTransGlobalCategoricalScore?: number | null, crossingTransGlobalCategoricalScore?: number | null, defensiveAerialsTransGlobalCategoricalScore?: number | null, finishingTransGlobalCategoricalScore?: number | null, headingTransGlobalCategoricalScore?: number | null, pressingTransGlobalCategoricalScore?: number | null, proactiveDefendingTransGlobalCategoricalScore?: number | null, setPieceDeliveringTransGlobalCategoricalScore?: number | null, shotPlacementTransGlobalCategoricalScore?: number | null, tacklingTransGlobalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null, llmDerivedSummary?: string | null, customStats?: Record<string, any> | null } | null, seasonCategoricalScores?: Array<{ __typename?: 'PlayerSeasonCategoricalScore', ggUnifiedSeasonKey: number, carryingTransPositionalCategoricalScore?: number | null, dribblingTransPositionalCategoricalScore?: number | null, gkPassingTransCategoricalScore?: number | null, gkPositioningTransCategoricalScore?: number | null, gkShotStoppingTransCategoricalScore?: number | null, passingTransPositionalCategoricalScore?: number | null, shotLocationTransPositionalCategoricalScore?: number | null, aerialsTransPositionalCategoricalScore?: number | null, anticipatingTransPositionalCategoricalScore?: number | null, assistingTransPositionalCategoricalScore?: number | null, buildupTransPositionalCategoricalScore?: number | null, creatingTransPositionalCategoricalScore?: number | null, crossingTransPositionalCategoricalScore?: number | null, defensiveAerialsTransPositionalCategoricalScore?: number | null, finishingTransPositionalCategoricalScore?: number | null, headingTransPositionalCategoricalScore?: number | null, pressingTransPositionalCategoricalScore?: number | null, proactiveDefendingTransPositionalCategoricalScore?: number | null, setPieceDeliveringTransPositionalCategoricalScore?: number | null, shotPlacementTransPositionalCategoricalScore?: number | null, tacklingTransPositionalCategoricalScore?: number | null, gkCrossInterceptTransCategoricalScore?: number | null, gkKeeperSweeperTransCategoricalScore?: number | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type WatchlistCreateUserWatchlistMutationVariables = Exact<{
  input: CreateUserWatchlistInput;
}>;


export type WatchlistCreateUserWatchlistMutation = { __typename?: 'Mutation', createUserWatchlist: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, grantSource: UserWatchlistGrantSource, effectiveRole: UserWatchlistRole, isMembershipActive: boolean, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export type WatchlistDeleteUserWatchlistMutationVariables = Exact<{
  input: DeleteUserWatchlistInput;
}>;


export type WatchlistDeleteUserWatchlistMutation = { __typename?: 'Mutation', deleteUserWatchlist?: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, grantSource: UserWatchlistGrantSource, effectiveRole: UserWatchlistRole, isMembershipActive: boolean, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } | null };

export type WatchlistUpdateUserWatchlistRoleMutationVariables = Exact<{
  input: UpdateUserWatchlistRoleInput;
}>;


export type WatchlistUpdateUserWatchlistRoleMutation = { __typename?: 'Mutation', updateUserWatchlistRole: { __typename?: 'UserWatchlist', id: string, role: UserWatchlistRole, grantSource: UserWatchlistGrantSource, effectiveRole: UserWatchlistRole, isMembershipActive: boolean, user: { __typename?: 'User', id: string, title?: string | null, phoneNumber: string, cognitoUser?: { __typename?: 'CognitoUser', Username: string, UserAttributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null, Attributes?: Array<{ __typename?: 'CognitoUserAttribute', Name: string, Value: string }> | null } | null } } };

export const ActivityFeedFragmentDoc = gql`
    fragment ActivityFeed on UserActivity {
  id
  activityId
  isRead
  isSeen
  createdAt
  userId
  activity {
    id
    activityType {
      id
      code
      name
    }
    body
    deepLink
    metadata
    targetId
    createdAt
    title
    notificationTitle
    notificationBody
    iconUrl
    userId
    user {
      id
      title
      displayName
      cognitoUser {
        Username
        Attributes {
          Name
          Value
        }
        UserAttributes {
          Name
          Value
        }
      }
    }
  }
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  message
}
    `;
export const AuthAuthenticationResultFragmentDoc = gql`
    fragment AuthAuthenticationResult on AuthenticationResult {
  accessToken
  expiresIn
  tokenType
  refreshToken
  idToken
}
    `;
export const AuthAuthenticationResultWithMessageFragmentDoc = gql`
    fragment AuthAuthenticationResultWithMessage on AuthenticationResultWithMessage {
  data {
    ...AuthAuthenticationResult
  }
  message
}
    ${AuthAuthenticationResultFragmentDoc}`;
export const AuthChallengeParametersResultFragmentDoc = gql`
    fragment AuthChallengeParametersResult on ChallengeParametersResult {
  USERNAME
  attempts
  attemptsLeft
  email
  maxAttempts
}
    `;
export const AuthChallengeResultFragmentDoc = gql`
    fragment AuthChallengeResult on ChallengeResult {
  ChallengeName
  Session
  ChallengeParameters {
    ...AuthChallengeParametersResult
  }
}
    ${AuthChallengeParametersResultFragmentDoc}`;
export const AuthSignInResultFragmentDoc = gql`
    fragment AuthSignInResult on SignInResult {
  message
  data {
    ...AuthChallengeResult
  }
}
    ${AuthChallengeResultFragmentDoc}`;
export const AuthConfirmSignInResultFragmentDoc = gql`
    fragment AuthConfirmSignInResult on ConfirmSignInResult {
  errorMessage {
    ...Message
  }
  authResult {
    ...AuthAuthenticationResultWithMessage
  }
  signInResult {
    ...AuthSignInResult
  }
  validationCodes
}
    ${MessageFragmentDoc}
${AuthAuthenticationResultWithMessageFragmentDoc}
${AuthSignInResultFragmentDoc}`;
export const AuthCognitoUserAttributeFragmentDoc = gql`
    fragment AuthCognitoUserAttribute on CognitoUserAttribute {
  Name
  Value
}
    `;
export const AuthCognitoUserFragmentDoc = gql`
    fragment AuthCognitoUser on CognitoUser {
  Username
  Enabled
  UserStatus
  UserAttributes {
    ...AuthCognitoUserAttribute
  }
  Attributes {
    ...AuthCognitoUserAttribute
  }
}
    ${AuthCognitoUserAttributeFragmentDoc}`;
export const AuthOrganizationFragmentDoc = gql`
    fragment AuthOrganization on Organization {
  id
  name
  currencyCode
  intakeFormUrl
  sportId
  defaultNoteVisibility
  defaultScoutReportVisibility
  teamSelectionMode
  organizationTeams {
    id
    teamId
  }
  recommendationTypes {
    type
    label
  }
}
    `;
export const AuthUserFragmentDoc = gql`
    fragment AuthUser on User {
  id
  email
  organizationId
  phoneNumber
  isAdmin
  title
  languagePreference
  cognitoUser {
    ...AuthCognitoUser
  }
  organization {
    ...AuthOrganization
  }
  role {
    id
    name
  }
}
    ${AuthCognitoUserFragmentDoc}
${AuthOrganizationFragmentDoc}`;
export const PlayerSearchPositionFragmentDoc = gql`
    fragment PlayerSearchPosition on Position {
  id
  name
  abbreviation
}
    `;
export const PlayerSearchTeamFragmentDoc = gql`
    fragment PlayerSearchTeam on Team {
  id
  name
}
    `;
export const PlayerSearchPlayerBioDataFragmentDoc = gql`
    fragment PlayerSearchPlayerBioData on PlayerBioData {
  ggPlayerKey
  age
  dateOfBirth
  fitScore
  teamStyleFit
  playerValuation
  fairFee
  expectedFee
  valuationStatus
  onLoanFrom
  carryingTransGlobalCategoricalScore
  dribblingTransGlobalCategoricalScore
  passingTransGlobalCategoricalScore
  shotLocationTransGlobalCategoricalScore
  gkPassingTransCategoricalScore
  gkPositioningTransCategoricalScore
  gkShotStoppingTransCategoricalScore
  contractExpires
  gpr
  customStats
  roleArchetype
}
    `;
export const PlayerSearchPlayerFragmentDoc = gql`
    fragment PlayerSearchPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  isWatchedByCurrentUser
  teamName
  nationality {
    id
    name
  }
  positions {
    ...PlayerSearchPosition
  }
  team {
    ...PlayerSearchTeam
  }
  bioData {
    ...PlayerSearchPlayerBioData
  }
}
    ${PlayerSearchPositionFragmentDoc}
${PlayerSearchTeamFragmentDoc}
${PlayerSearchPlayerBioDataFragmentDoc}`;
export const ComparePlayersPlayerResultFragmentDoc = gql`
    fragment ComparePlayersPlayerResult on SimilarPlayerResult {
  player {
    ...PlayerSearchPlayer
  }
  similarityScore
}
    ${PlayerSearchPlayerFragmentDoc}`;
export const ComparePlayersSimilarPlayerConnectionFragmentDoc = gql`
    fragment ComparePlayersSimilarPlayerConnection on SimilarPlayerConnection {
  edges {
    node {
      ...ComparePlayersPlayerResult
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${ComparePlayersPlayerResultFragmentDoc}`;
export const DashboardLeagueFragmentDoc = gql`
    fragment DashboardLeague on League {
  id
  name
  isMyOrganizationLeague
}
    `;
export const DashboardLeagueEdgeFragmentDoc = gql`
    fragment DashboardLeagueEdge on LeagueEdge {
  cursor
  node {
    ...DashboardLeague
  }
}
    ${DashboardLeagueFragmentDoc}`;
export const DashboardLeagueConnectionFragmentDoc = gql`
    fragment DashboardLeagueConnection on LeagueConnection {
  edges {
    ...DashboardLeagueEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${DashboardLeagueEdgeFragmentDoc}`;
export const DashboardTransferFragmentDoc = gql`
    fragment DashboardTransfer on TransferModel {
  id
  playerId
  date
  fee
  marketValue
  sourceTeamId
  destinationTeamId
  sourceTeam {
    id
    name
  }
  destinationTeam {
    id
    name
  }
  player {
    id
    name
    firstName
    knownName
    lastName
    positions {
      abbreviation
    }
  }
}
    `;
export const DashboardTransferEdgeFragmentDoc = gql`
    fragment DashboardTransferEdge on TransferEdge {
  cursor
  node {
    ...DashboardTransfer
  }
}
    ${DashboardTransferFragmentDoc}`;
export const DashboardTransferConnectionFragmentDoc = gql`
    fragment DashboardTransferConnection on TransferConnection {
  edges {
    ...DashboardTransferEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${DashboardTransferEdgeFragmentDoc}`;
export const DashboardTeamFragmentDoc = gql`
    fragment DashboardTeam on Team {
  id
  name
}
    `;
export const DashboardPositionFragmentDoc = gql`
    fragment DashboardPosition on Position {
  id
  name
  abbreviation
}
    `;
export const DashboardPlayerBioDataFragmentDoc = gql`
    fragment DashboardPlayerBioData on PlayerBioData {
  ggPlayerKey
  contractExpires
  onLoanFrom
}
    `;
export const DashboardPlayerFragmentDoc = gql`
    fragment DashboardPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  team {
    ...DashboardTeam
  }
  positions {
    ...DashboardPosition
  }
  bioData {
    ...DashboardPlayerBioData
  }
}
    ${DashboardTeamFragmentDoc}
${DashboardPositionFragmentDoc}
${DashboardPlayerBioDataFragmentDoc}`;
export const DashboardPlayerEdgeFragmentDoc = gql`
    fragment DashboardPlayerEdge on PlayerEdge {
  cursor
  node {
    ...DashboardPlayer
  }
}
    ${DashboardPlayerFragmentDoc}`;
export const DashboardPlayerConnectionFragmentDoc = gql`
    fragment DashboardPlayerConnection on PlayerConnection {
  edges {
    ...DashboardPlayerEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${DashboardPlayerEdgeFragmentDoc}`;
export const DashboardExpiringContractFragmentDoc = gql`
    fragment DashboardExpiringContract on ExpiringContractModel {
  id
  playerId
  position
  teamName
  contractExpires
  monthsRemaining
  player {
    id
    name
    firstName
    knownName
    lastName
  }
}
    `;
export const DashboardExpiringContractEdgeFragmentDoc = gql`
    fragment DashboardExpiringContractEdge on ExpiringContractEdge {
  cursor
  node {
    ...DashboardExpiringContract
  }
}
    ${DashboardExpiringContractFragmentDoc}`;
export const DashboardExpiringContractConnectionFragmentDoc = gql`
    fragment DashboardExpiringContractConnection on ExpiringContractConnection {
  edges {
    ...DashboardExpiringContractEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${DashboardExpiringContractEdgeFragmentDoc}`;
export const DashboardRadarMetricsFragmentDoc = gql`
    fragment DashboardRadarMetrics on RadarMetrics {
  gpr
  passing
  dribbling
  carrying
  shooting
}
    `;
export const DashboardRosterStatsFragmentDoc = gql`
    fragment DashboardRosterStats on RosterStats {
  avgGpr
  avgAge
  totalMarketValue
  playerCount
}
    `;
export const DashboardLeaguePlayerSearchNodeFragmentDoc = gql`
    fragment DashboardLeaguePlayerSearchNode on LeaguePlayerSearchNode {
  id
  gpr
  player {
    name
    firstName
    lastName
    knownName
    positions {
      abbreviation
      name
    }
    team {
      id
      name
    }
    bioData {
      ggPlayerKey
      gpr
      passingTransGlobalCategoricalScore
      dribblingTransGlobalCategoricalScore
      carryingTransGlobalCategoricalScore
      shotLocationTransGlobalCategoricalScore
    }
  }
}
    `;
export const DashboardLeaguePlayerSearchEdgeFragmentDoc = gql`
    fragment DashboardLeaguePlayerSearchEdge on LeaguePlayerSearchEdge {
  cursor
  node {
    ...DashboardLeaguePlayerSearchNode
  }
}
    ${DashboardLeaguePlayerSearchNodeFragmentDoc}`;
export const FixturePlanningMatchFragmentDoc = gql`
    fragment FixturePlanningMatch on Match {
  id
  scheduledThingId
  scheduledDate
  scheduledEndDate
  datePrecision
  startTime
  timeZone
  venue
  status
  timeframe
  source
  competitionName
  homeTeamScore
  awayTeamScore
  league {
    id
    name
  }
  homeTeam {
    id
    name
  }
  awayTeam {
    id
    name
  }
}
    `;
export const InvitationsOrganizationFragmentDoc = gql`
    fragment InvitationsOrganization on Organization {
  id
  name
  currencyCode
  intakeFormUrl
  sport {
    id
    name
  }
}
    `;
export const InvitationsOrganizationEdgeFragmentDoc = gql`
    fragment InvitationsOrganizationEdge on OrganizationEdge {
  cursor
  node {
    ...InvitationsOrganization
  }
}
    ${InvitationsOrganizationFragmentDoc}`;
export const InvitationsOrganizationConnectionFragmentDoc = gql`
    fragment InvitationsOrganizationConnection on OrganizationConnection {
  edges {
    ...InvitationsOrganizationEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${InvitationsOrganizationEdgeFragmentDoc}`;
export const InvitationsRoleFragmentDoc = gql`
    fragment InvitationsRole on Role {
  id
  name
}
    `;
export const InvitationsRoleEdgeFragmentDoc = gql`
    fragment InvitationsRoleEdge on RoleEdge {
  cursor
  node {
    ...InvitationsRole
  }
}
    ${InvitationsRoleFragmentDoc}`;
export const InvitationsRoleConnectionFragmentDoc = gql`
    fragment InvitationsRoleConnection on RoleConnection {
  edges {
    ...InvitationsRoleEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${InvitationsRoleEdgeFragmentDoc}`;
export const InvitationsSportFragmentDoc = gql`
    fragment InvitationsSport on Sport {
  id
  name
}
    `;
export const InvitationsSportEdgeFragmentDoc = gql`
    fragment InvitationsSportEdge on SportEdge {
  cursor
  node {
    ...InvitationsSport
  }
}
    ${InvitationsSportFragmentDoc}`;
export const InvitationsSportConnectionFragmentDoc = gql`
    fragment InvitationsSportConnection on SportConnection {
  edges {
    ...InvitationsSportEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${InvitationsSportEdgeFragmentDoc}`;
export const InvitationsInvitationFragmentDoc = gql`
    fragment InvitationsInvitation on Invitation {
  id
  status
  phoneNumber
  receiver {
    id
    cognitoUser {
      Username
      Attributes {
        Name
        Value
      }
    }
  }
  user {
    id
    organization {
      id
      name
    }
    cognitoUser {
      Username
      Attributes {
        Name
        Value
      }
    }
  }
  role {
    id
    name
  }
}
    `;
export const InvitationsInvitationEdgeFragmentDoc = gql`
    fragment InvitationsInvitationEdge on InvitationEdge {
  cursor
  node {
    ...InvitationsInvitation
  }
}
    ${InvitationsInvitationFragmentDoc}`;
export const InvitationsInvitationConnectionFragmentDoc = gql`
    fragment InvitationsInvitationConnection on InvitationConnection {
  edges {
    ...InvitationsInvitationEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${InvitationsInvitationEdgeFragmentDoc}`;
export const InvitationsOrganizationUserFragmentDoc = gql`
    fragment InvitationsOrganizationUser on OrganizationUser {
  id
  status
  role {
    id
    name
  }
  user {
    id
    title
    cognitoUser {
      Username
      Attributes {
        Name
        Value
      }
      UserAttributes {
        Name
        Value
      }
    }
  }
}
    `;
export const InvitationsOrganizationUserEdgeFragmentDoc = gql`
    fragment InvitationsOrganizationUserEdge on OrganizationUserEdge {
  cursor
  node {
    ...InvitationsOrganizationUser
  }
}
    ${InvitationsOrganizationUserFragmentDoc}`;
export const InvitationsOrganizationUserConnectionFragmentDoc = gql`
    fragment InvitationsOrganizationUserConnection on OrganizationUserConnection {
  edges {
    ...InvitationsOrganizationUserEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${InvitationsOrganizationUserEdgeFragmentDoc}`;
export const MatchReportCaptureSquadPlayerFragmentDoc = gql`
    fragment MatchReportCaptureSquadPlayer on Player {
  id
  name
  knownName
  isManual
  positions {
    id
    name
    abbreviation
  }
  team {
    id
    name
  }
}
    `;
export const MatchReportCaptureEvaluationFragmentDoc = gql`
    fragment MatchReportCaptureEvaluation on MatchReportPlayerEvaluation {
  id
  createdAt
  isNoted
  isStarter
  note
  notedAt
  performanceScore
  potentialScore
  shirtNumber
  updatedAt
  player {
    ...MatchReportCaptureSquadPlayer
  }
  team {
    id
  }
}
    ${MatchReportCaptureSquadPlayerFragmentDoc}`;
export const MatchReportCaptureReportFragmentDoc = gql`
    fragment MatchReportCaptureReport on MatchReport {
  id
  status
  watchMode
  submittedAt
  playerCount
  tickedCount
  scoredCount
  squadSize
  hasUnpublishedChanges
  lastPublishedAt
  playerEvaluations {
    ...MatchReportCaptureEvaluation
  }
}
    ${MatchReportCaptureEvaluationFragmentDoc}`;
export const MatchReportCaptureDisciplineSignalFragmentDoc = gql`
    fragment MatchReportCaptureDisciplineSignal on PlayerDisciplineSignal {
  playerId
  recordedRedCards
  recordedYellowCards
  suspensionWarning
}
    `;
export const NotesNoteFragmentDoc = gql`
    fragment NotesNote on Note {
  id
  createdAt
  updatedAt
  title
  body
  isPublic
  playerId
  userId
  user {
    id
    cognitoUser {
      Username
      Attributes {
        Name
        Value
      }
      UserAttributes {
        Name
        Value
      }
    }
  }
}
    `;
export const NotesNoteShareFragmentDoc = gql`
    fragment NotesNoteShare on NoteShare {
  userId
  role
  createdAt
  user {
    id
    cognitoUser {
      Username
      Attributes {
        Name
        Value
      }
      UserAttributes {
        Name
        Value
      }
    }
  }
}
    `;
export const NotificationSettingTypeFragmentDoc = gql`
    fragment NotificationSettingType on ActivityType {
  id
  code
  name
  description
  createdAt
  updatedAt
}
    `;
export const NotificationSettingPreferenceFragmentDoc = gql`
    fragment NotificationSettingPreference on UserNotificationPreference {
  id
  userId
  activityTypeId
  activityType {
    ...NotificationSettingType
  }
  enabled
  createdAt
  updatedAt
}
    ${NotificationSettingTypeFragmentDoc}`;
export const PlayerDetailPlayerBioDataFragmentDoc = gql`
    fragment PlayerDetailPlayerBioData on PlayerBioData {
  age
  archetypeGgPlayerKey
  roleArchetype
  secondaryRoleArchetype
  contractExpires
  contractOption
  currentClub
  currentLeague
  dateOfBirth
  fitScore
  foot
  ggPlayerKey
  gpm
  gpr
  floorGpr
  ceilingGpr
  height
  injuredUntil
  isInjured
  strengths
  weaknesses
  limitedDataWarning
  carryingTransGlobalCategoricalScore
  dribblingTransGlobalCategoricalScore
  gkPassingTransCategoricalScore
  gkPositioningTransCategoricalScore
  gkShotStoppingTransCategoricalScore
  passingTransGlobalCategoricalScore
  shotLocationTransGlobalCategoricalScore
  aerialsTransGlobalCategoricalScore
  anticipatingTransGlobalCategoricalScore
  assistingTransGlobalCategoricalScore
  buildupTransGlobalCategoricalScore
  creatingTransGlobalCategoricalScore
  crossingTransGlobalCategoricalScore
  defensiveAerialsTransGlobalCategoricalScore
  finishingTransGlobalCategoricalScore
  headingTransGlobalCategoricalScore
  pressingTransGlobalCategoricalScore
  proactiveDefendingTransGlobalCategoricalScore
  setPieceDeliveringTransGlobalCategoricalScore
  shotPlacementTransGlobalCategoricalScore
  tacklingTransGlobalCategoricalScore
  gkCrossInterceptTransCategoricalScore
  gkKeeperSweeperTransCategoricalScore
  playerValuation
  fairFee
  expectedFee
  minGeminiPlayerValuation
  maxGeminiPlayerValuation
  valuationStatus
  onLoanFrom
  llmDerivedSummary
  timeDecayedSeasonalGpm
  weaknesses
  strengths
  threats
  opportunities
  timeDecayedVaep
  timeDecayedZVaep
  physicalScore
  teamStyleFit
  playerAgent
  primaryPosition
  generalPosition
  customStats
}
    `;
export const PlayerDetailPlayerSeasonWeightedAvgMetricsFragmentDoc = gql`
    fragment PlayerDetailPlayerSeasonWeightedAvgMetrics on PlayerSeasonWeightedAvgMetrics {
  epm
  seasonalGpm
  ggUnifiedSeasonKey
}
    `;
export const PlayerDetailSeasonCategoricalScoresFragmentDoc = gql`
    fragment PlayerDetailSeasonCategoricalScores on PlayerSeasonCategoricalScore {
  seasonId
  ggUnifiedSeasonKey
  carryingTransPositionalCategoricalScore
  dribblingTransPositionalCategoricalScore
  gkPassingTransCategoricalScore
  gkPositioningTransCategoricalScore
  gkShotStoppingTransCategoricalScore
  passingTransPositionalCategoricalScore
  shotLocationTransGlobalCategoricalScore
  shotLocationTransPositionalCategoricalScore
  aerialsTransPositionalCategoricalScore
  anticipatingTransPositionalCategoricalScore
  assistingTransPositionalCategoricalScore
  buildupTransPositionalCategoricalScore
  creatingTransPositionalCategoricalScore
  crossingTransPositionalCategoricalScore
  defensiveAerialsTransPositionalCategoricalScore
  finishingTransPositionalCategoricalScore
  headingTransPositionalCategoricalScore
  pressingTransPositionalCategoricalScore
  proactiveDefendingTransPositionalCategoricalScore
  setPieceDeliveringTransPositionalCategoricalScore
  shotPlacementTransPositionalCategoricalScore
  tacklingTransPositionalCategoricalScore
  gkCrossInterceptTransCategoricalScore
  gkKeeperSweeperTransCategoricalScore
}
    `;
export const PlayerDetailChartPlayerFragmentDoc = gql`
    fragment PlayerDetailChartPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  bioData {
    ...PlayerDetailPlayerBioData
  }
  seasonWeightedAvgMetrics {
    ...PlayerDetailPlayerSeasonWeightedAvgMetrics
  }
  seasonCategoricalScores {
    ...PlayerDetailSeasonCategoricalScores
  }
}
    ${PlayerDetailPlayerBioDataFragmentDoc}
${PlayerDetailPlayerSeasonWeightedAvgMetricsFragmentDoc}
${PlayerDetailSeasonCategoricalScoresFragmentDoc}`;
export const PlayerDetailChartPlayerConectionFragmentDoc = gql`
    fragment PlayerDetailChartPlayerConection on PlayerConnection {
  edges {
    cursor
    node {
      ...PlayerDetailChartPlayer
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${PlayerDetailChartPlayerFragmentDoc}`;
export const PlayerDetailPositionFragmentDoc = gql`
    fragment PlayerDetailPosition on Position {
  id
  name
  abbreviation
}
    `;
export const PlayerDetailNationalityFragmentDoc = gql`
    fragment PlayerDetailNationality on Nationality {
  id
  name
}
    `;
export const PlayerDetailTeamFragmentDoc = gql`
    fragment PlayerDetailTeam on Team {
  id
  name
  league {
    id
    name
  }
}
    `;
export const PlayerDetailMatchDetailFragmentDoc = gql`
    fragment PlayerDetailMatchDetail on MatchDetail {
  team
  opponent
  ground
  matchDate
}
    `;
export const PlayerDetailScoutReportsFragmentDoc = gql`
    fragment PlayerDetailScoutReports on PlayerScoutReport {
  reportId
  sortDate
  reportKind
  ggPlayerKey
  scoutName
  reportDate
  team
  opponent
  ground
  overallScore
  qnaText
  canEdit
  canArchive
  lastEditDate
  lastEditorName
  matches {
    ...PlayerDetailMatchDetail
  }
}
    ${PlayerDetailMatchDetailFragmentDoc}`;
export const PlayerDetailInjuryFragmentDoc = gql`
    fragment PlayerDetailInjury on PlayerInjuryModel {
  id
  playerId
  injuryDate
  injury
  daysMissed
  gamesMissed
  seasonId
}
    `;
export const PlayerDetailTransferFragmentDoc = gql`
    fragment PlayerDetailTransfer on TransferModel {
  id
  playerId
  date
  fee
  marketValue
  sourceTeamId
  destinationTeamId
  sourceTeam {
    id
    name
  }
  destinationTeam {
    id
    name
  }
}
    `;
export const PlayerDetailSeasonProviderMetricsFragmentDoc = gql`
    fragment PlayerDetailSeasonProviderMetrics on SeasonProviderMetrics {
  seasonId
  playerId
  minutesTotal
  npXgTotal
  headerGoalsTotal
  penaltyGoalsTotal
  diffActualNpGoalsAndNpXgTotal
  cornerXaTotal
  crossXaTotal
}
    `;
export const PlayerDetailGameProviderMetricsFragmentDoc = gql`
    fragment PlayerDetailGameProviderMetrics on GameProviderMetrics {
  gameId
  minutesTotal
  obvTotalNetTotal
}
    `;
export const PlayerDetailPlayerFragmentDoc = gql`
    fragment PlayerDetailPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  transferableDataCounts {
    scoutReportCount
    noteCount
  }
  dateOfBirth
  isWatchedByCurrentUser
  teamName
  positions {
    ...PlayerDetailPosition
  }
  nationality {
    ...PlayerDetailNationality
  }
  bioData {
    ...PlayerDetailPlayerBioData
  }
  team {
    ...PlayerDetailTeam
  }
  league {
    id
  }
  seasonWeightedAvgMetrics {
    ...PlayerDetailPlayerSeasonWeightedAvgMetrics
  }
  scoutReports {
    ...PlayerDetailScoutReports
  }
  seasonCategoricalScores {
    ...PlayerDetailSeasonCategoricalScores
  }
  injuries {
    ...PlayerDetailInjury
  }
  transfers {
    ...PlayerDetailTransfer
  }
  seasonProviderMetrics {
    ...PlayerDetailSeasonProviderMetrics
  }
  gameProviderMetrics {
    ...PlayerDetailGameProviderMetrics
  }
  watchlists {
    id
    name
  }
}
    ${PlayerDetailPositionFragmentDoc}
${PlayerDetailNationalityFragmentDoc}
${PlayerDetailPlayerBioDataFragmentDoc}
${PlayerDetailTeamFragmentDoc}
${PlayerDetailPlayerSeasonWeightedAvgMetricsFragmentDoc}
${PlayerDetailScoutReportsFragmentDoc}
${PlayerDetailSeasonCategoricalScoresFragmentDoc}
${PlayerDetailInjuryFragmentDoc}
${PlayerDetailTransferFragmentDoc}
${PlayerDetailSeasonProviderMetricsFragmentDoc}
${PlayerDetailGameProviderMetricsFragmentDoc}`;
export const PlayerDetailMatchReportEvaluationFragmentDoc = gql`
    fragment PlayerDetailMatchReportEvaluation on PlayerMatchReportEvaluation {
  evaluationId
  sortDate
  reportId
  reportKind
  matchId
  matchDate
  reportDate
  scoutName
  scoutUserId
  team
  opponent
  performanceScore
  potentialScore
  note
  isStarter
  shirtNumber
  notedAt
  submittedAt
}
    `;
export const PlayerDetailPlayerMetaFragmentDoc = gql`
    fragment PlayerDetailPlayerMeta on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  transferableDataCounts {
    scoutReportCount
    noteCount
  }
  dateOfBirth
  isWatchedByCurrentUser
  teamName
  positions {
    ...PlayerDetailPosition
  }
  nationality {
    ...PlayerDetailNationality
  }
  bioData {
    ...PlayerDetailPlayerBioData
  }
  team {
    ...PlayerDetailTeam
  }
  league {
    id
  }
  seasonWeightedAvgMetrics {
    ...PlayerDetailPlayerSeasonWeightedAvgMetrics
  }
  scoutReports {
    ...PlayerDetailScoutReports
  }
  matchReportEvaluations {
    ...PlayerDetailMatchReportEvaluation
  }
  seasonCategoricalScores {
    ...PlayerDetailSeasonCategoricalScores
  }
  injuries {
    ...PlayerDetailInjury
  }
  transfers {
    ...PlayerDetailTransfer
  }
  watchlists {
    id
    name
  }
}
    ${PlayerDetailPositionFragmentDoc}
${PlayerDetailNationalityFragmentDoc}
${PlayerDetailPlayerBioDataFragmentDoc}
${PlayerDetailTeamFragmentDoc}
${PlayerDetailPlayerSeasonWeightedAvgMetricsFragmentDoc}
${PlayerDetailScoutReportsFragmentDoc}
${PlayerDetailMatchReportEvaluationFragmentDoc}
${PlayerDetailSeasonCategoricalScoresFragmentDoc}
${PlayerDetailInjuryFragmentDoc}
${PlayerDetailTransferFragmentDoc}`;
export const PlayerDetailGameMetricsFragmentDoc = gql`
    fragment PlayerDetailGameMetrics on GameMetrics {
  gameId
  ggrRating
  playedEnoughMinutes
  wasSubbedIn
  wasSubbedOut
}
    `;
export const PlayerDetailPlayerMatchFragmentDoc = gql`
    fragment PlayerDetailPlayerMatch on PlayerMatch {
  id
  matchId
  matchDate
  oppositionName
  ground
}
    `;
export const PerformanceAnalyticsPlayerScoresFragmentDoc = gql`
    fragment PerformanceAnalyticsPlayerScores on Player {
  id
  name
  knownName
  firstName
  lastName
  bioData {
    ggPlayerKey
    carryingTransGlobalCategoricalScore
    dribblingTransGlobalCategoricalScore
    passingTransGlobalCategoricalScore
    shotLocationTransGlobalCategoricalScore
    gkPassingTransCategoricalScore
    gkPositioningTransCategoricalScore
    gkShotStoppingTransCategoricalScore
    aerialsTransGlobalCategoricalScore
    anticipatingTransGlobalCategoricalScore
    assistingTransGlobalCategoricalScore
    buildupTransGlobalCategoricalScore
    creatingTransGlobalCategoricalScore
    crossingTransGlobalCategoricalScore
    defensiveAerialsTransGlobalCategoricalScore
    finishingTransGlobalCategoricalScore
    headingTransGlobalCategoricalScore
    pressingTransGlobalCategoricalScore
    proactiveDefendingTransGlobalCategoricalScore
    setPieceDeliveringTransGlobalCategoricalScore
    shotPlacementTransGlobalCategoricalScore
    tacklingTransGlobalCategoricalScore
    gkCrossInterceptTransCategoricalScore
    gkKeeperSweeperTransCategoricalScore
    physicalScore
    gpr
    customStats
  }
  seasonCategoricalScores {
    ggUnifiedSeasonKey
    carryingTransPositionalCategoricalScore
    dribblingTransPositionalCategoricalScore
    passingTransPositionalCategoricalScore
    shotLocationTransGlobalCategoricalScore
    shotLocationTransPositionalCategoricalScore
    gkPassingTransCategoricalScore
    gkPositioningTransCategoricalScore
    gkShotStoppingTransCategoricalScore
    aerialsTransPositionalCategoricalScore
    anticipatingTransPositionalCategoricalScore
    assistingTransPositionalCategoricalScore
    buildupTransPositionalCategoricalScore
    creatingTransPositionalCategoricalScore
    crossingTransPositionalCategoricalScore
    defensiveAerialsTransPositionalCategoricalScore
    finishingTransPositionalCategoricalScore
    headingTransPositionalCategoricalScore
    pressingTransPositionalCategoricalScore
    proactiveDefendingTransPositionalCategoricalScore
    setPieceDeliveringTransPositionalCategoricalScore
    shotPlacementTransPositionalCategoricalScore
    tacklingTransPositionalCategoricalScore
    gkCrossInterceptTransCategoricalScore
    gkKeeperSweeperTransCategoricalScore
  }
}
    `;
export const PlayerDetailSeasonMetricAveragesFragmentDoc = gql`
    fragment PlayerDetailSeasonMetricAverages on SeasonMetricAverages {
  season
  teamAverage
  positionAverage
}
    `;
export const PlayerDetailBasicCompetitionStatsFragmentDoc = gql`
    fragment PlayerDetailBasicCompetitionStats on BasicCompetitionStats {
  playerId
  leagueId
  seasonId
  basicAppearances
  basicGoals
  basicAssists
  basicMinutes
}
    `;
export const KanbanBoardTagFragmentFragmentDoc = gql`
    fragment KanbanBoardTagFragment on KanbanBoardTag {
  id
  kanbanBoardId
  tag {
    id
    name
  }
  color
  createdAt
  updatedAt
}
    `;
export const KanbanBoardFragmentFragmentDoc = gql`
    fragment KanbanBoardFragment on KanbanBoard {
  id
  name
  createdAt
  createdBy
  organization {
    id
    name
  }
  organizationId
  sourceType
  sourceId
  validOutcomes
  pipelineTemplate
}
    `;
export const KanbanPhaseFragmentFragmentDoc = gql`
    fragment KanbanPhaseFragment on KanbanPhase {
  id
  name
  position
  kanbanBoardId
  isProtected
  isTerminal
  timeTargetDays
  createdAt
  updatedAt
}
    `;
export const KanbanCardFragmentFragmentDoc = gql`
    fragment KanbanCardFragment on KanbanCard {
  id
  position
  rank
  notes
  kanbanPhaseId
  enteredStageAt
  kanbanPhase {
    id
    name
  }
  createdAt
  updatedAt
}
    `;
export const KanbanTagFragmentFragmentDoc = gql`
    fragment KanbanTagFragment on KanbanTag {
  id
  name
  cardCount
  createdAt
  updatedAt
}
    `;
export const KanbanCardWithTagsFragmentFragmentDoc = gql`
    fragment KanbanCardWithTagsFragment on KanbanCard {
  ...KanbanCardFragment
  tags {
    ...KanbanTagFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}
${KanbanTagFragmentFragmentDoc}`;
export const KanbanPlayerDataFragmentDoc = gql`
    fragment KanbanPlayerData on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  isAcademy
  dateOfBirth
  teamName
  team {
    id
    name
  }
  positions {
    id
    name
    abbreviation
  }
  bioData {
    ggPlayerKey
    age
    gpr
    roleArchetype
    secondaryRoleArchetype
    minGeminiPlayerValuation
    maxGeminiPlayerValuation
    contractExpires
    playerAgent
    customStats
  }
}
    `;
export const KanbanFilterablePlayerDataFragmentDoc = gql`
    fragment KanbanFilterablePlayerData on Player {
  ...KanbanPlayerData
  league {
    id
    name
  }
  watchlists {
    id
  }
  bioData {
    ggPlayerKey
    secondaryRoleArchetype
    nationality
    geminiPlayerValuation
    fitScore
    teamStyleFit
    carryingTransGlobalCategoricalScore
    dribblingTransGlobalCategoricalScore
    passingTransGlobalCategoricalScore
    shotLocationTransGlobalCategoricalScore
    gkPassingTransCategoricalScore
    gkShotStoppingTransCategoricalScore
    gkPositioningTransCategoricalScore
  }
}
    ${KanbanPlayerDataFragmentDoc}`;
export const KanbanWatchlistDataFragmentDoc = gql`
    fragment KanbanWatchlistData on Watchlist {
  id
  name
  createdAt
  updatedAt
  isOnWatchlist
}
    `;
export const KanbanPlayerConnectionFragmentDoc = gql`
    fragment KanbanPlayerConnection on PlayerConnection {
  totalCount
  edges {
    cursor
    node {
      ...KanbanPlayerData
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${KanbanPlayerDataFragmentDoc}`;
export const KanbanWatchlistWithPlayersFragmentDoc = gql`
    fragment KanbanWatchlistWithPlayers on Watchlist {
  ...KanbanWatchlistData
  players {
    ...KanbanPlayerConnection
  }
}
    ${KanbanWatchlistDataFragmentDoc}
${KanbanPlayerConnectionFragmentDoc}`;
export const KanbanUserWatchlistFragmentDoc = gql`
    fragment KanbanUserWatchlist on UserWatchlist {
  id
  role
  watchlist {
    ...KanbanWatchlistWithPlayers
  }
}
    ${KanbanWatchlistWithPlayersFragmentDoc}`;
export const KanbanUserWatchlistMetaFragmentDoc = gql`
    fragment KanbanUserWatchlistMeta on UserWatchlist {
  id
  role
  watchlist {
    id
    name
    createdAt
    updatedAt
    isOnWatchlist
  }
}
    `;
export const PlayerKanbanPlayerFragmentFragmentDoc = gql`
    fragment PlayerKanbanPlayerFragment on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  isAcademy
  dateOfBirth
  teamName
  team {
    id
    name
  }
  positions {
    id
    name
    abbreviation
  }
  bioData {
    ggPlayerKey
    age
    gpr
    roleArchetype
    secondaryRoleArchetype
    minGeminiPlayerValuation
    maxGeminiPlayerValuation
    contractExpires
    playerAgent
    customStats
  }
}
    `;
export const PipelineActivityEntryFragmentFragmentDoc = gql`
    fragment PipelineActivityEntryFragment on PipelineActivityEntry {
  id
  action
  actorType
  actorUserId
  automationRuleId
  automationRuleName
  playerId
  playerName
  kanbanBoardId
  kanbanCardId
  fromKanbanPhaseId
  toKanbanPhaseId
  fromPhaseName
  toPhaseName
  rationale
  outcome
  occurredAt
}
    `;
export const KanbanCognitoUserFragmentDoc = gql`
    fragment KanbanCognitoUser on CognitoUser {
  Username
  UserAttributes {
    ...AuthCognitoUserAttribute
  }
  Attributes {
    ...AuthCognitoUserAttribute
  }
}
    ${AuthCognitoUserAttributeFragmentDoc}`;
export const KanbanUserFragmentDoc = gql`
    fragment KanbanUser on User {
  id
  title
  phoneNumber
  cognitoUser {
    ...KanbanCognitoUser
  }
}
    ${KanbanCognitoUserFragmentDoc}`;
export const KanbanOrganizationUserFragmentDoc = gql`
    fragment KanbanOrganizationUser on OrganizationUser {
  id
  role {
    id
    name
  }
  user {
    ...KanbanUser
  }
}
    ${KanbanUserFragmentDoc}`;
export const KanbanOrganizationUserConnectionFragmentDoc = gql`
    fragment KanbanOrganizationUserConnection on OrganizationUserConnection {
  edges {
    cursor
    node {
      ...KanbanOrganizationUser
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${KanbanOrganizationUserFragmentDoc}`;
export const UserKanbanBoardFragmentFragmentDoc = gql`
    fragment UserKanbanBoardFragment on UserKanbanBoard {
  id
  userId
  kanbanBoardId
  role
  createdAt
  updatedAt
  user {
    ...KanbanUser
  }
}
    ${KanbanUserFragmentDoc}`;
export const UserKanbanBoardConnectionFragmentDoc = gql`
    fragment UserKanbanBoardConnection on UserKanbanBoardConnection {
  edges {
    cursor
    node {
      ...UserKanbanBoardFragment
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${UserKanbanBoardFragmentFragmentDoc}`;
export const PipelineReviewRequestFragmentFragmentDoc = gql`
    fragment PipelineReviewRequestFragment on PipelineReviewRequest {
  id
  status
  source
  automationRuleId
  automationRuleName
  kanbanBoardId
  kanbanCardId
  playerId
  fromKanbanPhaseId
  fromPhaseName
  targetKanbanPhaseId
  targetPhaseName
  requestedOutcome
  requestReason
  requestedByUserId
  addressedToUserId
  decidedAt
  decidedByUserId
  decisionReason
  correlationKey
  createdAt
}
    `;
export const PipelineAutomationRuleConditionFragmentFragmentDoc = gql`
    fragment PipelineAutomationRuleConditionFragment on PipelineAutomationRuleCondition {
  id
  conditionType
  comparator
  numericValue
  textValue
  kanbanPhaseId
}
    `;
export const PipelineAutomationRuleFragmentFragmentDoc = gql`
    fragment PipelineAutomationRuleFragment on PipelineAutomationRule {
  id
  name
  isEnabled
  kanbanBoardId
  triggerType
  actionType
  triggerKanbanPhaseId
  targetKanbanPhaseId
  kanbanTagId
  requestedOutcome
  reason
  revision
  conditions {
    ...PipelineAutomationRuleConditionFragment
  }
  createdAt
  updatedAt
}
    ${PipelineAutomationRuleConditionFragmentFragmentDoc}`;
export const PipelineSuggestedPlayerFragmentFragmentDoc = gql`
    fragment PipelineSuggestedPlayerFragment on PipelineSuggestedPlayer {
  id
  bestRank
  reasons
  snapshotTimestamp
  player {
    id
    name
    knownName
    teamName
    team {
      id
      name
    }
    league {
      id
      name
    }
    watchlists {
      id
    }
    positions {
      id
      abbreviation
    }
    bioData {
      ggPlayerKey
      age
      gpr
      roleArchetype
      secondaryRoleArchetype
      nationality
      contractExpires
      geminiPlayerValuation
      fitScore
      teamStyleFit
      carryingTransGlobalCategoricalScore
      dribblingTransGlobalCategoricalScore
      passingTransGlobalCategoricalScore
      shotLocationTransGlobalCategoricalScore
      gkPassingTransCategoricalScore
      gkShotStoppingTransCategoricalScore
      gkPositioningTransCategoricalScore
      customStats
    }
  }
}
    `;
export const PlayerSearchPlayerSeasonWeightedAvgMetricsFragmentDoc = gql`
    fragment PlayerSearchPlayerSeasonWeightedAvgMetrics on PlayerSeasonWeightedAvgMetrics {
  ggPlayerKey
  ggUnifiedSeasonKey
  epm
  rapm
  spm
  stdEpm
  stdEpmTransform
}
    `;
export const PlayerSearchPlayerEdgeFragmentDoc = gql`
    fragment PlayerSearchPlayerEdge on PlayerEdge {
  cursor
  node {
    ...PlayerSearchPlayer
  }
}
    ${PlayerSearchPlayerFragmentDoc}`;
export const PlayerSearchPlayerConnectionFragmentDoc = gql`
    fragment PlayerSearchPlayerConnection on PlayerConnection {
  totalCount
  edges {
    ...PlayerSearchPlayerEdge
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${PlayerSearchPlayerEdgeFragmentDoc}`;
export const PlayerSearchPlayerConnectionLiteFragmentDoc = gql`
    fragment PlayerSearchPlayerConnectionLite on PlayerConnection {
  edges {
    ...PlayerSearchPlayerEdge
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${PlayerSearchPlayerEdgeFragmentDoc}`;
export const WatchlistPlayerIdConnectionFragmentDoc = gql`
    fragment WatchlistPlayerIdConnection on PlayerConnection {
  edges {
    cursor
    node {
      id
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const PlayerSearchWatchlistMetaFragmentDoc = gql`
    fragment PlayerSearchWatchlistMeta on Watchlist {
  id
  name
  players(first: 500) {
    ...WatchlistPlayerIdConnection
  }
}
    ${WatchlistPlayerIdConnectionFragmentDoc}`;
export const WatchlistTeamFragmentDoc = gql`
    fragment WatchlistTeam on Team {
  id
  name
}
    `;
export const WatchlistLeagueFragmentDoc = gql`
    fragment WatchlistLeague on League {
  id
  name
}
    `;
export const WatchlistPlayerPositionFragmentDoc = gql`
    fragment WatchlistPlayerPosition on Position {
  id
  name
  abbreviation
}
    `;
export const WatchlistPlayerSeasonWeightedAvgMetricsFragmentDoc = gql`
    fragment WatchlistPlayerSeasonWeightedAvgMetrics on PlayerSeasonWeightedAvgMetrics {
  epm
  seasonalGpm
  ggUnifiedSeasonKey
}
    `;
export const WatchlistPlayerBioDataFragmentDoc = gql`
    fragment WatchlistPlayerBioData on PlayerBioData {
  ggPlayerKey
  dateOfBirth
  age
  foot
  roleArchetype
  secondaryRoleArchetype
  isInjured
  contractExpires
  playerValuation
  fairFee
  expectedFee
  gpm
  gpr
  timeDecayedSeasonalGpm
  timeDecayedZVaep
  fitScore
  teamStyleFit
  physicalScore
  passingTransGlobalCategoricalScore
  shotLocationTransGlobalCategoricalScore
  dribblingTransGlobalCategoricalScore
  carryingTransGlobalCategoricalScore
  gkShotStoppingTransCategoricalScore
  gkPositioningTransCategoricalScore
  gkPassingTransCategoricalScore
  aerialsTransGlobalCategoricalScore
  anticipatingTransGlobalCategoricalScore
  assistingTransGlobalCategoricalScore
  buildupTransGlobalCategoricalScore
  creatingTransGlobalCategoricalScore
  crossingTransGlobalCategoricalScore
  defensiveAerialsTransGlobalCategoricalScore
  finishingTransGlobalCategoricalScore
  headingTransGlobalCategoricalScore
  pressingTransGlobalCategoricalScore
  proactiveDefendingTransGlobalCategoricalScore
  setPieceDeliveringTransGlobalCategoricalScore
  shotPlacementTransGlobalCategoricalScore
  tacklingTransGlobalCategoricalScore
  gkCrossInterceptTransCategoricalScore
  gkKeeperSweeperTransCategoricalScore
  llmDerivedSummary
  customStats
}
    `;
export const WatchlistPlayerSeasonCategoricalScoreFragmentDoc = gql`
    fragment WatchlistPlayerSeasonCategoricalScore on PlayerSeasonCategoricalScore {
  ggUnifiedSeasonKey
  carryingTransPositionalCategoricalScore
  dribblingTransPositionalCategoricalScore
  gkPassingTransCategoricalScore
  gkPositioningTransCategoricalScore
  gkShotStoppingTransCategoricalScore
  passingTransPositionalCategoricalScore
  shotLocationTransPositionalCategoricalScore
  aerialsTransPositionalCategoricalScore
  anticipatingTransPositionalCategoricalScore
  assistingTransPositionalCategoricalScore
  buildupTransPositionalCategoricalScore
  creatingTransPositionalCategoricalScore
  crossingTransPositionalCategoricalScore
  defensiveAerialsTransPositionalCategoricalScore
  finishingTransPositionalCategoricalScore
  headingTransPositionalCategoricalScore
  pressingTransPositionalCategoricalScore
  proactiveDefendingTransPositionalCategoricalScore
  setPieceDeliveringTransPositionalCategoricalScore
  shotPlacementTransPositionalCategoricalScore
  tacklingTransPositionalCategoricalScore
  gkCrossInterceptTransCategoricalScore
  gkKeeperSweeperTransCategoricalScore
}
    `;
export const WatchlistPlayerFragmentDoc = gql`
    fragment WatchlistPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  isAcademy
  teamName
  team {
    ...WatchlistTeam
  }
  league {
    ...WatchlistLeague
  }
  nationality {
    id
    name
  }
  isWatchedByCurrentUser
  positions {
    ...WatchlistPlayerPosition
  }
  seasonWeightedAvgMetrics {
    ...WatchlistPlayerSeasonWeightedAvgMetrics
  }
  bioData {
    ...WatchlistPlayerBioData
  }
  seasonCategoricalScores {
    ...WatchlistPlayerSeasonCategoricalScore
  }
}
    ${WatchlistTeamFragmentDoc}
${WatchlistLeagueFragmentDoc}
${WatchlistPlayerPositionFragmentDoc}
${WatchlistPlayerSeasonWeightedAvgMetricsFragmentDoc}
${WatchlistPlayerBioDataFragmentDoc}
${WatchlistPlayerSeasonCategoricalScoreFragmentDoc}`;
export const WatchlistPlayerConnectionFragmentDoc = gql`
    fragment WatchlistPlayerConnection on PlayerConnection {
  edges {
    cursor
    node {
      ...WatchlistPlayer
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${WatchlistPlayerFragmentDoc}`;
export const PlayerSearchWatchlistFragmentDoc = gql`
    fragment PlayerSearchWatchlist on Watchlist {
  id
  name
  players {
    ...WatchlistPlayerConnection
  }
}
    ${WatchlistPlayerConnectionFragmentDoc}`;
export const PlayerSearchWatchlistEdgeFragmentDoc = gql`
    fragment PlayerSearchWatchlistEdge on WatchlistEdge {
  cursor
  node {
    ...PlayerSearchWatchlist
  }
}
    ${PlayerSearchWatchlistFragmentDoc}`;
export const PlayerSearchWatchlistConnectionFragmentDoc = gql`
    fragment PlayerSearchWatchlistConnection on WatchlistConnection {
  edges {
    ...PlayerSearchWatchlistEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${PlayerSearchWatchlistEdgeFragmentDoc}`;
export const PlayerSearchWatchlistWithPlayerFragmentDoc = gql`
    fragment PlayerSearchWatchlistWithPlayer on Watchlist {
  id
  name
  players {
    ...WatchlistPlayerConnection
  }
  isOnWatchlist(playerId: $playerId)
}
    ${WatchlistPlayerConnectionFragmentDoc}`;
export const PlayerSearchWatchlistEdgeWithPlayerFragmentDoc = gql`
    fragment PlayerSearchWatchlistEdgeWithPlayer on WatchlistEdge {
  cursor
  node {
    ...PlayerSearchWatchlistWithPlayer
  }
}
    ${PlayerSearchWatchlistWithPlayerFragmentDoc}`;
export const PlayerSearchWatchlistConnectionWithPlayerFragmentDoc = gql`
    fragment PlayerSearchWatchlistConnectionWithPlayer on WatchlistConnection {
  edges {
    ...PlayerSearchWatchlistEdgeWithPlayer
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${PlayerSearchWatchlistEdgeWithPlayerFragmentDoc}`;
export const PlayerSearchCompetitionFragmentDoc = gql`
    fragment PlayerSearchCompetition on Competition {
  id
  name
  code
}
    `;
export const RecommendationsTeamFragmentDoc = gql`
    fragment RecommendationsTeam on Team {
  id
  name
}
    `;
export const RecommendationsPlayerPositionFragmentDoc = gql`
    fragment RecommendationsPlayerPosition on Position {
  id
  name
  abbreviation
}
    `;
export const RecommendationsPlayerFragmentDoc = gql`
    fragment RecommendationsPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  isWatchedByCurrentUser
  teamName
  team {
    ...RecommendationsTeam
  }
  positions {
    ...RecommendationsPlayerPosition
  }
  bioData {
    ggPlayerKey
    gpr
  }
}
    ${RecommendationsTeamFragmentDoc}
${RecommendationsPlayerPositionFragmentDoc}`;
export const RecommendationsPlayerRecommendationResultFragmentDoc = gql`
    fragment RecommendationsPlayerRecommendationResult on PlayerRecommendationResult {
  id
  player {
    ...RecommendationsPlayer
  }
  recommendationScore
  recommendationType
  rankChange
  currentRank
  previousRank
}
    ${RecommendationsPlayerFragmentDoc}`;
export const ReportsScoutReportShareFragmentDoc = gql`
    fragment ReportsScoutReportShare on ScoutReportShare {
  userId
  role
  createdAt
  user {
    id
    cognitoUser {
      Username
      UserAttributes {
        ...AuthCognitoUserAttribute
      }
      Attributes {
        ...AuthCognitoUserAttribute
      }
    }
  }
}
    ${AuthCognitoUserAttributeFragmentDoc}`;
export const ReportsPlayerMatchFragmentDoc = gql`
    fragment ReportsPlayerMatch on PlayerMatch {
  id
  competitionKey
  seasonKey
  matchId
  teamName
  oppositionName
  matchDate
  ground
  selectBox
}
    `;
export const RosterManagementSportFragmentDoc = gql`
    fragment RosterManagementSport on Sport {
  id
  name
}
    `;
export const RosterManagementLeagueFragmentDoc = gql`
    fragment RosterManagementLeague on League {
  id
  name
  isMyOrganizationLeague
  sport {
    ...RosterManagementSport
  }
  country
}
    ${RosterManagementSportFragmentDoc}`;
export const RosterManagementLeagueEdgeFragmentDoc = gql`
    fragment RosterManagementLeagueEdge on LeagueEdge {
  cursor
  node {
    ...RosterManagementLeague
  }
}
    ${RosterManagementLeagueFragmentDoc}`;
export const RosterManagementLeagueConnectionFragmentDoc = gql`
    fragment RosterManagementLeagueConnection on LeagueConnection {
  edges {
    ...RosterManagementLeagueEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${RosterManagementLeagueEdgeFragmentDoc}`;
export const RosterManagementTeamFragmentDoc = gql`
    fragment RosterManagementTeam on Team {
  id
  name
  isMyOrganizationTeam
  league {
    id
    name
  }
}
    `;
export const RosterManagementTeamEdgeFragmentDoc = gql`
    fragment RosterManagementTeamEdge on TeamEdge {
  cursor
  node {
    ...RosterManagementTeam
  }
}
    ${RosterManagementTeamFragmentDoc}`;
export const RosterManagementTeamConnectionFragmentDoc = gql`
    fragment RosterManagementTeamConnection on TeamConnection {
  edges {
    ...RosterManagementTeamEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${RosterManagementTeamEdgeFragmentDoc}`;
export const RosterManagmentOrganizationTeamFragmentDoc = gql`
    fragment RosterManagmentOrganizationTeam on OrganizationTeam {
  id
  organizationId
  teamId
}
    `;
export const RosterManagmentOrganizationLeagueFragmentDoc = gql`
    fragment RosterManagmentOrganizationLeague on OrganizationLeague {
  id
  organizationId
  leagueId
}
    `;
export const RosterListPlayerBioDataFragmentDoc = gql`
    fragment RosterListPlayerBioData on PlayerBioData {
  ggPlayerKey
  age
  isInjured
  contractExpires
  fitScore
  teamStyleFit
  carryingTransGlobalCategoricalScore
  dribblingTransGlobalCategoricalScore
  passingTransGlobalCategoricalScore
  shotLocationTransGlobalCategoricalScore
  gkPassingTransCategoricalScore
  gkPositioningTransCategoricalScore
  gkShotStoppingTransCategoricalScore
  physicalScore
  playerValuation
  gpr
  customStats
}
    `;
export const RosterListPlayerFragmentDoc = gql`
    fragment RosterListPlayer on Player {
  id
  name
  knownName
  firstName
  lastName
  isManual
  isWatchedByCurrentUser
  teamName
  team {
    id
    name
  }
  league {
    id
    name
  }
  positions {
    id
    name
    abbreviation
  }
  bioData {
    ...RosterListPlayerBioData
  }
}
    ${RosterListPlayerBioDataFragmentDoc}`;
export const RosterListPlayerConnectionFragmentDoc = gql`
    fragment RosterListPlayerConnection on PlayerConnection {
  edges {
    cursor
    node {
      ...RosterListPlayer
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${RosterListPlayerFragmentDoc}`;
export const RosterManagementNationalityFragmentDoc = gql`
    fragment RosterManagementNationality on Nationality {
  id
  name
}
    `;
export const RosterManagementNationalityEdgeFragmentDoc = gql`
    fragment RosterManagementNationalityEdge on NationalityEdge {
  cursor
  node {
    ...RosterManagementNationality
  }
}
    ${RosterManagementNationalityFragmentDoc}`;
export const RosterManagementNationalityConnectionFragmentDoc = gql`
    fragment RosterManagementNationalityConnection on NationalityConnection {
  edges {
    ...RosterManagementNationalityEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${RosterManagementNationalityEdgeFragmentDoc}`;
export const RosterManagementPositionFragmentDoc = gql`
    fragment RosterManagementPosition on Position {
  id
  name
  sportId
  abbreviation
  createdAt
  updatedAt
}
    `;
export const RosterManagementPositionEdgeFragmentDoc = gql`
    fragment RosterManagementPositionEdge on PositionEdge {
  cursor
  node {
    ...RosterManagementPosition
  }
}
    ${RosterManagementPositionFragmentDoc}`;
export const RosterManagementPositionConnectionFragmentDoc = gql`
    fragment RosterManagementPositionConnection on PositionConnection {
  edges {
    ...RosterManagementPositionEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${RosterManagementPositionEdgeFragmentDoc}`;
export const ScoutingWatchlistBulkMembershipPayloadFragmentDoc = gql`
    fragment ScoutingWatchlistBulkMembershipPayload on WatchlistBulkMembershipPayload {
  watchlist {
    id
    name
    playerCount
  }
  addedPlayerIds
  alreadyPresentPlayerIds
  removedPlayerIds
  notPresentPlayerIds
  pitchRevision
  placementOutcomes {
    playerId
    requestedSlot
    tacticalSlot
    outcome
  }
}
    `;
export const ScoutingShareGroupFragmentDoc = gql`
    fragment ScoutingShareGroup on ShareGroup {
  key
  label
  memberCount
}
    `;
export const ScoutingGroupGrantFragmentDoc = gql`
    fragment ScoutingGroupGrant on GroupGrant {
  id
  entityType
  entityId
  organizationId
  role
  grantedByUserId
  createdAt
  group {
    ...ScoutingShareGroup
  }
}
    ${ScoutingShareGroupFragmentDoc}`;
export const SimilarPlayersPlayerResultFragmentDoc = gql`
    fragment SimilarPlayersPlayerResult on SimilarPlayerResult {
  player {
    ...PlayerSearchPlayer
  }
  similarityScore
}
    ${PlayerSearchPlayerFragmentDoc}`;
export const SimilarPlayersSimilarPlayerConnectionFragmentDoc = gql`
    fragment SimilarPlayersSimilarPlayerConnection on SimilarPlayerConnection {
  edges {
    node {
      ...SimilarPlayersPlayerResult
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${SimilarPlayersPlayerResultFragmentDoc}`;
export const SquadPlanningScenarioAccessFragmentDoc = gql`
    fragment SquadPlanningScenarioAccess on ScenarioModel {
  id
  revision
  financialsVisible
  myRole
  canManageSharing
}
    `;
export const SquadPlanningShareUserFragmentDoc = gql`
    fragment SquadPlanningShareUser on User {
  id
  title
  phoneNumber
  cognitoUser {
    Username
    UserAttributes {
      ...AuthCognitoUserAttribute
    }
    Attributes {
      ...AuthCognitoUserAttribute
    }
  }
}
    ${AuthCognitoUserAttributeFragmentDoc}`;
export const SquadPlanningUserScenarioFragmentDoc = gql`
    fragment SquadPlanningUserScenario on UserScenario {
  id
  scenarioId
  userId
  organizationId
  role
  isMembershipActive
  createdAt
  user {
    ...SquadPlanningShareUser
  }
}
    ${SquadPlanningShareUserFragmentDoc}`;
export const SquadPlanningScenarioPitchFragmentDoc = gql`
    fragment SquadPlanningScenarioPitch on ScenarioPitch {
  scenarioId
  formation
  pitchRevision
  pitchInitialized
  canEdit
  myRole
  entries {
    playerId
    tacticalSlot
    rank
  }
  lastEditedBy {
    id
    displayName
  }
  lastEditedAt
}
    `;
export const TeamSelectionTeamFragmentDoc = gql`
    fragment TeamSelectionTeam on Team {
  id
  name
  league {
    id
    name
    country
  }
}
    `;
export const TeamSelectionTeamEdgeFragmentDoc = gql`
    fragment TeamSelectionTeamEdge on TeamEdge {
  cursor
  node {
    ...TeamSelectionTeam
  }
}
    ${TeamSelectionTeamFragmentDoc}`;
export const TeamSelectionTeamConnectionFragmentDoc = gql`
    fragment TeamSelectionTeamConnection on TeamConnection {
  edges {
    ...TeamSelectionTeamEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${TeamSelectionTeamEdgeFragmentDoc}`;
export const UpdateFeedEventFragmentDoc = gql`
    fragment UpdateFeedEvent on FeedEvent {
  id
  category
  headline
  timestamp
  clickthrough
  groupKey
}
    `;
export const WatchlistWatchlistFragmentDoc = gql`
    fragment WatchlistWatchlist on Watchlist {
  id
  name
  players(first: 500) {
    ...WatchlistPlayerConnection
  }
}
    ${WatchlistPlayerConnectionFragmentDoc}`;
export const WatchlistWatchlistConnectionFragmentDoc = gql`
    fragment WatchlistWatchlistConnection on WatchlistConnection {
  edges {
    cursor
    node {
      ...WatchlistWatchlist
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export const WatchlistCognitoUserFragmentDoc = gql`
    fragment WatchlistCognitoUser on CognitoUser {
  Username
  UserAttributes {
    ...AuthCognitoUserAttribute
  }
  Attributes {
    ...AuthCognitoUserAttribute
  }
}
    ${AuthCognitoUserAttributeFragmentDoc}`;
export const WatchlistUserFragmentDoc = gql`
    fragment WatchlistUser on User {
  id
  title
  phoneNumber
  cognitoUser {
    ...WatchlistCognitoUser
  }
}
    ${WatchlistCognitoUserFragmentDoc}`;
export const WatchlistUserWatchlistFragmentDoc = gql`
    fragment WatchlistUserWatchlist on UserWatchlist {
  id
  role
  grantSource
  effectiveRole
  isMembershipActive
  user {
    ...WatchlistUser
  }
}
    ${WatchlistUserFragmentDoc}`;
export const WatchlistUserWatchlistConnectionFragmentDoc = gql`
    fragment WatchlistUserWatchlistConnection on UserWatchlistConnection {
  edges {
    cursor
    node {
      ...WatchlistUserWatchlist
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${WatchlistUserWatchlistFragmentDoc}`;
export const WatchlistWatchlistMetaFragmentDoc = gql`
    fragment WatchlistWatchlistMeta on Watchlist {
  id
  name
  players(first: 500) {
    ...WatchlistPlayerIdConnection
  }
}
    ${WatchlistPlayerIdConnectionFragmentDoc}`;
export const WatchlistMyUserWatchlistFragmentDoc = gql`
    fragment WatchlistMyUserWatchlist on UserWatchlist {
  id
  role
  isDefault
  watchlist {
    ...WatchlistWatchlistMeta
  }
}
    ${WatchlistWatchlistMetaFragmentDoc}`;
export const WatchlistMyUserWatchlistConnectionFragmentDoc = gql`
    fragment WatchlistMyUserWatchlistConnection on UserWatchlistConnection {
  edges {
    cursor
    node {
      ...WatchlistMyUserWatchlist
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${WatchlistMyUserWatchlistFragmentDoc}`;
export const WatchlistWatchlistEdgeFragmentDoc = gql`
    fragment WatchlistWatchlistEdge on WatchlistEdge {
  cursor
  node {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export const WatchlistOrganizationUserFragmentDoc = gql`
    fragment WatchlistOrganizationUser on OrganizationUser {
  id
  user {
    ...WatchlistUser
  }
}
    ${WatchlistUserFragmentDoc}`;
export const WatchlistOrganizationUserEdgeFragmentDoc = gql`
    fragment WatchlistOrganizationUserEdge on OrganizationUserEdge {
  cursor
  node {
    ...WatchlistOrganizationUser
  }
}
    ${WatchlistOrganizationUserFragmentDoc}`;
export const WatchlistOrganizationUserConnectionFragmentDoc = gql`
    fragment WatchlistOrganizationUserConnection on OrganizationUserConnection {
  edges {
    ...WatchlistOrganizationUserEdge
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${WatchlistOrganizationUserEdgeFragmentDoc}`;
export const ListFeatureFlagsDocument = gql`
    query ListFeatureFlags {
  listFeatureFlags
}
    `;

/**
 * __useListFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useListFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>(ListFeatureFlagsDocument, options);
      }
export function useListFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>(ListFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useListFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>;
export function useListFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeatureFlagsQuery | undefined, ListFeatureFlagsQueryVariables>;
export function useListFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>(ListFeatureFlagsDocument, options);
        }
export type ListFeatureFlagsQueryHookResult = ReturnType<typeof useListFeatureFlagsQuery>;
export type ListFeatureFlagsLazyQueryHookResult = ReturnType<typeof useListFeatureFlagsLazyQuery>;
export type ListFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useListFeatureFlagsSuspenseQuery>;
export type ListFeatureFlagsQueryResult = Apollo.QueryResult<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>;
export const ListActivitiesFeedDocument = gql`
    query ListActivitiesFeed($first: Int, $after: String) {
  listMyActivities(first: $first, after: $after) {
    edges {
      node {
        ...ActivityFeed
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ActivityFeedFragmentDoc}`;

/**
 * __useListActivitiesFeedQuery__
 *
 * To run a query within a React component, call `useListActivitiesFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivitiesFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivitiesFeedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListActivitiesFeedQuery(baseOptions?: Apollo.QueryHookOptions<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>(ListActivitiesFeedDocument, options);
      }
export function useListActivitiesFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>(ListActivitiesFeedDocument, options);
        }
// @ts-ignore
export function useListActivitiesFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>): Apollo.UseSuspenseQueryResult<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>;
export function useListActivitiesFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>): Apollo.UseSuspenseQueryResult<ListActivitiesFeedQuery | undefined, ListActivitiesFeedQueryVariables>;
export function useListActivitiesFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>(ListActivitiesFeedDocument, options);
        }
export type ListActivitiesFeedQueryHookResult = ReturnType<typeof useListActivitiesFeedQuery>;
export type ListActivitiesFeedLazyQueryHookResult = ReturnType<typeof useListActivitiesFeedLazyQuery>;
export type ListActivitiesFeedSuspenseQueryHookResult = ReturnType<typeof useListActivitiesFeedSuspenseQuery>;
export type ListActivitiesFeedQueryResult = Apollo.QueryResult<ListActivitiesFeedQuery, ListActivitiesFeedQueryVariables>;
export const MarkActivitiesAsReadDocument = gql`
    mutation MarkActivitiesAsRead($input: MarkActivitiesAsReadInput!) {
  markActivitiesAsRead(input: $input)
}
    `;
export type MarkActivitiesAsReadMutationFn = Apollo.MutationFunction<MarkActivitiesAsReadMutation, MarkActivitiesAsReadMutationVariables>;

/**
 * __useMarkActivitiesAsReadMutation__
 *
 * To run a mutation, you first call `useMarkActivitiesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkActivitiesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markActivitiesAsReadMutation, { data, loading, error }] = useMarkActivitiesAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkActivitiesAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkActivitiesAsReadMutation, MarkActivitiesAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkActivitiesAsReadMutation, MarkActivitiesAsReadMutationVariables>(MarkActivitiesAsReadDocument, options);
      }
export type MarkActivitiesAsReadMutationHookResult = ReturnType<typeof useMarkActivitiesAsReadMutation>;
export type MarkActivitiesAsReadMutationResult = Apollo.MutationResult<MarkActivitiesAsReadMutation>;
export type MarkActivitiesAsReadMutationOptions = Apollo.BaseMutationOptions<MarkActivitiesAsReadMutation, MarkActivitiesAsReadMutationVariables>;
export const ActivityFeedGetPlayerNameDocument = gql`
    query ActivityFeedGetPlayerName($id: ID!) {
  getPlayer(id: $id) {
    id
    name
    firstName
    knownName
    lastName
  }
}
    `;

/**
 * __useActivityFeedGetPlayerNameQuery__
 *
 * To run a query within a React component, call `useActivityFeedGetPlayerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityFeedGetPlayerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityFeedGetPlayerNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityFeedGetPlayerNameQuery(baseOptions: Apollo.QueryHookOptions<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables> & ({ variables: ActivityFeedGetPlayerNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>(ActivityFeedGetPlayerNameDocument, options);
      }
export function useActivityFeedGetPlayerNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>(ActivityFeedGetPlayerNameDocument, options);
        }
// @ts-ignore
export function useActivityFeedGetPlayerNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>;
export function useActivityFeedGetPlayerNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityFeedGetPlayerNameQuery | undefined, ActivityFeedGetPlayerNameQueryVariables>;
export function useActivityFeedGetPlayerNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>(ActivityFeedGetPlayerNameDocument, options);
        }
export type ActivityFeedGetPlayerNameQueryHookResult = ReturnType<typeof useActivityFeedGetPlayerNameQuery>;
export type ActivityFeedGetPlayerNameLazyQueryHookResult = ReturnType<typeof useActivityFeedGetPlayerNameLazyQuery>;
export type ActivityFeedGetPlayerNameSuspenseQueryHookResult = ReturnType<typeof useActivityFeedGetPlayerNameSuspenseQuery>;
export type ActivityFeedGetPlayerNameQueryResult = Apollo.QueryResult<ActivityFeedGetPlayerNameQuery, ActivityFeedGetPlayerNameQueryVariables>;
export const AuthGetUserDocument = gql`
    query AuthGetUser {
  me {
    ...AuthUser
  }
}
    ${AuthUserFragmentDoc}`;

/**
 * __useAuthGetUserQuery__
 *
 * To run a query within a React component, call `useAuthGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthGetUserQuery(baseOptions?: Apollo.QueryHookOptions<AuthGetUserQuery, AuthGetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthGetUserQuery, AuthGetUserQueryVariables>(AuthGetUserDocument, options);
      }
export function useAuthGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthGetUserQuery, AuthGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthGetUserQuery, AuthGetUserQueryVariables>(AuthGetUserDocument, options);
        }
// @ts-ignore
export function useAuthGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthGetUserQuery, AuthGetUserQueryVariables>): Apollo.UseSuspenseQueryResult<AuthGetUserQuery, AuthGetUserQueryVariables>;
export function useAuthGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthGetUserQuery, AuthGetUserQueryVariables>): Apollo.UseSuspenseQueryResult<AuthGetUserQuery | undefined, AuthGetUserQueryVariables>;
export function useAuthGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthGetUserQuery, AuthGetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthGetUserQuery, AuthGetUserQueryVariables>(AuthGetUserDocument, options);
        }
export type AuthGetUserQueryHookResult = ReturnType<typeof useAuthGetUserQuery>;
export type AuthGetUserLazyQueryHookResult = ReturnType<typeof useAuthGetUserLazyQuery>;
export type AuthGetUserSuspenseQueryHookResult = ReturnType<typeof useAuthGetUserSuspenseQuery>;
export type AuthGetUserQueryResult = Apollo.QueryResult<AuthGetUserQuery, AuthGetUserQueryVariables>;
export const AuthRefreshTokenDocument = gql`
    mutation AuthRefreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    ...AuthAuthenticationResultWithMessage
  }
}
    ${AuthAuthenticationResultWithMessageFragmentDoc}`;
export type AuthRefreshTokenMutationFn = Apollo.MutationFunction<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>;

/**
 * __useAuthRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAuthRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRefreshTokenMutation, { data, loading, error }] = useAuthRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>(AuthRefreshTokenDocument, options);
      }
export type AuthRefreshTokenMutationHookResult = ReturnType<typeof useAuthRefreshTokenMutation>;
export type AuthRefreshTokenMutationResult = Apollo.MutationResult<AuthRefreshTokenMutation>;
export type AuthRefreshTokenMutationOptions = Apollo.BaseMutationOptions<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>;
export const AuthSignInDocument = gql`
    mutation AuthSignIn($input: SignInInput!) {
  signIn(input: $input) {
    message
    data {
      Session
    }
  }
}
    `;
export type AuthSignInMutationFn = Apollo.MutationFunction<AuthSignInMutation, AuthSignInMutationVariables>;

/**
 * __useAuthSignInMutation__
 *
 * To run a mutation, you first call `useAuthSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSignInMutation, { data, loading, error }] = useAuthSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthSignInMutation(baseOptions?: Apollo.MutationHookOptions<AuthSignInMutation, AuthSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSignInMutation, AuthSignInMutationVariables>(AuthSignInDocument, options);
      }
export type AuthSignInMutationHookResult = ReturnType<typeof useAuthSignInMutation>;
export type AuthSignInMutationResult = Apollo.MutationResult<AuthSignInMutation>;
export type AuthSignInMutationOptions = Apollo.BaseMutationOptions<AuthSignInMutation, AuthSignInMutationVariables>;
export const AuthResendVerifyIdentifierDocument = gql`
    mutation AuthResendVerifyIdentifier($input: ResendOtpInput!) {
  resendOTP(input: $input) {
    data {
      Session
    }
  }
}
    `;
export type AuthResendVerifyIdentifierMutationFn = Apollo.MutationFunction<AuthResendVerifyIdentifierMutation, AuthResendVerifyIdentifierMutationVariables>;

/**
 * __useAuthResendVerifyIdentifierMutation__
 *
 * To run a mutation, you first call `useAuthResendVerifyIdentifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthResendVerifyIdentifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authResendVerifyIdentifierMutation, { data, loading, error }] = useAuthResendVerifyIdentifierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthResendVerifyIdentifierMutation(baseOptions?: Apollo.MutationHookOptions<AuthResendVerifyIdentifierMutation, AuthResendVerifyIdentifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthResendVerifyIdentifierMutation, AuthResendVerifyIdentifierMutationVariables>(AuthResendVerifyIdentifierDocument, options);
      }
export type AuthResendVerifyIdentifierMutationHookResult = ReturnType<typeof useAuthResendVerifyIdentifierMutation>;
export type AuthResendVerifyIdentifierMutationResult = Apollo.MutationResult<AuthResendVerifyIdentifierMutation>;
export type AuthResendVerifyIdentifierMutationOptions = Apollo.BaseMutationOptions<AuthResendVerifyIdentifierMutation, AuthResendVerifyIdentifierMutationVariables>;
export const AuthConfirmSignInDocument = gql`
    mutation AuthConfirmSignIn($input: ConfirmSignInInput!) {
  confirmSignIn(input: $input) {
    ...AuthConfirmSignInResult
  }
}
    ${AuthConfirmSignInResultFragmentDoc}`;
export type AuthConfirmSignInMutationFn = Apollo.MutationFunction<AuthConfirmSignInMutation, AuthConfirmSignInMutationVariables>;

/**
 * __useAuthConfirmSignInMutation__
 *
 * To run a mutation, you first call `useAuthConfirmSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthConfirmSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authConfirmSignInMutation, { data, loading, error }] = useAuthConfirmSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthConfirmSignInMutation(baseOptions?: Apollo.MutationHookOptions<AuthConfirmSignInMutation, AuthConfirmSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthConfirmSignInMutation, AuthConfirmSignInMutationVariables>(AuthConfirmSignInDocument, options);
      }
export type AuthConfirmSignInMutationHookResult = ReturnType<typeof useAuthConfirmSignInMutation>;
export type AuthConfirmSignInMutationResult = Apollo.MutationResult<AuthConfirmSignInMutation>;
export type AuthConfirmSignInMutationOptions = Apollo.BaseMutationOptions<AuthConfirmSignInMutation, AuthConfirmSignInMutationVariables>;
export const AuthUpdateMyProfileDocument = gql`
    mutation AuthUpdateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    ...AuthUser
  }
}
    ${AuthUserFragmentDoc}`;
export type AuthUpdateMyProfileMutationFn = Apollo.MutationFunction<AuthUpdateMyProfileMutation, AuthUpdateMyProfileMutationVariables>;

/**
 * __useAuthUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useAuthUpdateMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUpdateMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUpdateMyProfileMutation, { data, loading, error }] = useAuthUpdateMyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthUpdateMyProfileMutation(baseOptions?: Apollo.MutationHookOptions<AuthUpdateMyProfileMutation, AuthUpdateMyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthUpdateMyProfileMutation, AuthUpdateMyProfileMutationVariables>(AuthUpdateMyProfileDocument, options);
      }
export type AuthUpdateMyProfileMutationHookResult = ReturnType<typeof useAuthUpdateMyProfileMutation>;
export type AuthUpdateMyProfileMutationResult = Apollo.MutationResult<AuthUpdateMyProfileMutation>;
export type AuthUpdateMyProfileMutationOptions = Apollo.BaseMutationOptions<AuthUpdateMyProfileMutation, AuthUpdateMyProfileMutationVariables>;
export const AuthSignOutDocument = gql`
    mutation AuthSignOut($input: SignOutInput!) {
  signOut(input: $input) {
    message
  }
}
    `;
export type AuthSignOutMutationFn = Apollo.MutationFunction<AuthSignOutMutation, AuthSignOutMutationVariables>;

/**
 * __useAuthSignOutMutation__
 *
 * To run a mutation, you first call `useAuthSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSignOutMutation, { data, loading, error }] = useAuthSignOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthSignOutMutation(baseOptions?: Apollo.MutationHookOptions<AuthSignOutMutation, AuthSignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSignOutMutation, AuthSignOutMutationVariables>(AuthSignOutDocument, options);
      }
export type AuthSignOutMutationHookResult = ReturnType<typeof useAuthSignOutMutation>;
export type AuthSignOutMutationResult = Apollo.MutationResult<AuthSignOutMutation>;
export type AuthSignOutMutationOptions = Apollo.BaseMutationOptions<AuthSignOutMutation, AuthSignOutMutationVariables>;
export const AuthSignOutAllDevicesDocument = gql`
    mutation AuthSignOutAllDevices {
  signOutAllDevices {
    message
  }
}
    `;
export type AuthSignOutAllDevicesMutationFn = Apollo.MutationFunction<AuthSignOutAllDevicesMutation, AuthSignOutAllDevicesMutationVariables>;

/**
 * __useAuthSignOutAllDevicesMutation__
 *
 * To run a mutation, you first call `useAuthSignOutAllDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSignOutAllDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSignOutAllDevicesMutation, { data, loading, error }] = useAuthSignOutAllDevicesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthSignOutAllDevicesMutation(baseOptions?: Apollo.MutationHookOptions<AuthSignOutAllDevicesMutation, AuthSignOutAllDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSignOutAllDevicesMutation, AuthSignOutAllDevicesMutationVariables>(AuthSignOutAllDevicesDocument, options);
      }
export type AuthSignOutAllDevicesMutationHookResult = ReturnType<typeof useAuthSignOutAllDevicesMutation>;
export type AuthSignOutAllDevicesMutationResult = Apollo.MutationResult<AuthSignOutAllDevicesMutation>;
export type AuthSignOutAllDevicesMutationOptions = Apollo.BaseMutationOptions<AuthSignOutAllDevicesMutation, AuthSignOutAllDevicesMutationVariables>;
export const AuthMeDocument = gql`
    query AuthMe {
  me {
    ...AuthUser
  }
}
    ${AuthUserFragmentDoc}`;

/**
 * __useAuthMeQuery__
 *
 * To run a query within a React component, call `useAuthMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthMeQuery(baseOptions?: Apollo.QueryHookOptions<AuthMeQuery, AuthMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthMeQuery, AuthMeQueryVariables>(AuthMeDocument, options);
      }
export function useAuthMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthMeQuery, AuthMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthMeQuery, AuthMeQueryVariables>(AuthMeDocument, options);
        }
// @ts-ignore
export function useAuthMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthMeQuery, AuthMeQueryVariables>): Apollo.UseSuspenseQueryResult<AuthMeQuery, AuthMeQueryVariables>;
export function useAuthMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthMeQuery, AuthMeQueryVariables>): Apollo.UseSuspenseQueryResult<AuthMeQuery | undefined, AuthMeQueryVariables>;
export function useAuthMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthMeQuery, AuthMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthMeQuery, AuthMeQueryVariables>(AuthMeDocument, options);
        }
export type AuthMeQueryHookResult = ReturnType<typeof useAuthMeQuery>;
export type AuthMeLazyQueryHookResult = ReturnType<typeof useAuthMeLazyQuery>;
export type AuthMeSuspenseQueryHookResult = ReturnType<typeof useAuthMeSuspenseQuery>;
export type AuthMeQueryResult = Apollo.QueryResult<AuthMeQuery, AuthMeQueryVariables>;
export const AuthDeactivateMeDocument = gql`
    mutation AuthDeactivateMe {
  deactivateMe {
    ...AuthUser
  }
}
    ${AuthUserFragmentDoc}`;
export type AuthDeactivateMeMutationFn = Apollo.MutationFunction<AuthDeactivateMeMutation, AuthDeactivateMeMutationVariables>;

/**
 * __useAuthDeactivateMeMutation__
 *
 * To run a mutation, you first call `useAuthDeactivateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthDeactivateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authDeactivateMeMutation, { data, loading, error }] = useAuthDeactivateMeMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthDeactivateMeMutation(baseOptions?: Apollo.MutationHookOptions<AuthDeactivateMeMutation, AuthDeactivateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthDeactivateMeMutation, AuthDeactivateMeMutationVariables>(AuthDeactivateMeDocument, options);
      }
export type AuthDeactivateMeMutationHookResult = ReturnType<typeof useAuthDeactivateMeMutation>;
export type AuthDeactivateMeMutationResult = Apollo.MutationResult<AuthDeactivateMeMutation>;
export type AuthDeactivateMeMutationOptions = Apollo.BaseMutationOptions<AuthDeactivateMeMutation, AuthDeactivateMeMutationVariables>;
export const ComparePlayersListSimilarPlayersDocument = gql`
    query ComparePlayersListSimilarPlayers($playerId: ID!, $first: Int, $after: String, $filter: SimilarPlayerFilterInput) {
  listSimilarPlayers(
    playerId: $playerId
    first: $first
    after: $after
    filter: $filter
  ) {
    ...ComparePlayersSimilarPlayerConnection
  }
}
    ${ComparePlayersSimilarPlayerConnectionFragmentDoc}`;

/**
 * __useComparePlayersListSimilarPlayersQuery__
 *
 * To run a query within a React component, call `useComparePlayersListSimilarPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparePlayersListSimilarPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparePlayersListSimilarPlayersQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useComparePlayersListSimilarPlayersQuery(baseOptions: Apollo.QueryHookOptions<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables> & ({ variables: ComparePlayersListSimilarPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>(ComparePlayersListSimilarPlayersDocument, options);
      }
export function useComparePlayersListSimilarPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>(ComparePlayersListSimilarPlayersDocument, options);
        }
// @ts-ignore
export function useComparePlayersListSimilarPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>;
export function useComparePlayersListSimilarPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ComparePlayersListSimilarPlayersQuery | undefined, ComparePlayersListSimilarPlayersQueryVariables>;
export function useComparePlayersListSimilarPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>(ComparePlayersListSimilarPlayersDocument, options);
        }
export type ComparePlayersListSimilarPlayersQueryHookResult = ReturnType<typeof useComparePlayersListSimilarPlayersQuery>;
export type ComparePlayersListSimilarPlayersLazyQueryHookResult = ReturnType<typeof useComparePlayersListSimilarPlayersLazyQuery>;
export type ComparePlayersListSimilarPlayersSuspenseQueryHookResult = ReturnType<typeof useComparePlayersListSimilarPlayersSuspenseQuery>;
export type ComparePlayersListSimilarPlayersQueryResult = Apollo.QueryResult<ComparePlayersListSimilarPlayersQuery, ComparePlayersListSimilarPlayersQueryVariables>;
export const CompareGetComparisonPlayerDocument = gql`
    query CompareGetComparisonPlayer($id: ID!) {
  getPlayer(id: $id) {
    ...WatchlistPlayer
  }
}
    ${WatchlistPlayerFragmentDoc}`;

/**
 * __useCompareGetComparisonPlayerQuery__
 *
 * To run a query within a React component, call `useCompareGetComparisonPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareGetComparisonPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareGetComparisonPlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompareGetComparisonPlayerQuery(baseOptions: Apollo.QueryHookOptions<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables> & ({ variables: CompareGetComparisonPlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>(CompareGetComparisonPlayerDocument, options);
      }
export function useCompareGetComparisonPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>(CompareGetComparisonPlayerDocument, options);
        }
// @ts-ignore
export function useCompareGetComparisonPlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>;
export function useCompareGetComparisonPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<CompareGetComparisonPlayerQuery | undefined, CompareGetComparisonPlayerQueryVariables>;
export function useCompareGetComparisonPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>(CompareGetComparisonPlayerDocument, options);
        }
export type CompareGetComparisonPlayerQueryHookResult = ReturnType<typeof useCompareGetComparisonPlayerQuery>;
export type CompareGetComparisonPlayerLazyQueryHookResult = ReturnType<typeof useCompareGetComparisonPlayerLazyQuery>;
export type CompareGetComparisonPlayerSuspenseQueryHookResult = ReturnType<typeof useCompareGetComparisonPlayerSuspenseQuery>;
export type CompareGetComparisonPlayerQueryResult = Apollo.QueryResult<CompareGetComparisonPlayerQuery, CompareGetComparisonPlayerQueryVariables>;
export const PlayerContractsOverviewDocument = gql`
    query PlayerContractsOverview($archivedOnly: Boolean) {
  playerContractsOverview(archivedOnly: $archivedOnly) {
    players {
      playerId
      name
      age
      tier
      position
      contractEndDate
      contractStatus
      transferStatus
      transferFeeNotAppliedReason
      lastUpdated
    }
    firstTeamCompleteness {
      contractsTotal
      contractsSaved
      transfersTotal
      transfersSaved
    }
    academyCompleteness {
      contractsTotal
      contractsSaved
      transfersTotal
      transfersSaved
    }
    loaneeCompleteness {
      contractsTotal
      contractsSaved
      transfersTotal
      transfersSaved
    }
  }
}
    `;

/**
 * __usePlayerContractsOverviewQuery__
 *
 * To run a query within a React component, call `usePlayerContractsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerContractsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerContractsOverviewQuery({
 *   variables: {
 *      archivedOnly: // value for 'archivedOnly'
 *   },
 * });
 */
export function usePlayerContractsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>(PlayerContractsOverviewDocument, options);
      }
export function usePlayerContractsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>(PlayerContractsOverviewDocument, options);
        }
// @ts-ignore
export function usePlayerContractsOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>;
export function usePlayerContractsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerContractsOverviewQuery | undefined, PlayerContractsOverviewQueryVariables>;
export function usePlayerContractsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>(PlayerContractsOverviewDocument, options);
        }
export type PlayerContractsOverviewQueryHookResult = ReturnType<typeof usePlayerContractsOverviewQuery>;
export type PlayerContractsOverviewLazyQueryHookResult = ReturnType<typeof usePlayerContractsOverviewLazyQuery>;
export type PlayerContractsOverviewSuspenseQueryHookResult = ReturnType<typeof usePlayerContractsOverviewSuspenseQuery>;
export type PlayerContractsOverviewQueryResult = Apollo.QueryResult<PlayerContractsOverviewQuery, PlayerContractsOverviewQueryVariables>;
export const ArchiveContractExtractionDocument = gql`
    mutation ArchiveContractExtraction($input: ArchiveContractExtractionInput!) {
  archiveContractExtraction(input: $input) {
    id
    playerId
    documentType
    status
  }
}
    `;
export type ArchiveContractExtractionMutationFn = Apollo.MutationFunction<ArchiveContractExtractionMutation, ArchiveContractExtractionMutationVariables>;

/**
 * __useArchiveContractExtractionMutation__
 *
 * To run a mutation, you first call `useArchiveContractExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveContractExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveContractExtractionMutation, { data, loading, error }] = useArchiveContractExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveContractExtractionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveContractExtractionMutation, ArchiveContractExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveContractExtractionMutation, ArchiveContractExtractionMutationVariables>(ArchiveContractExtractionDocument, options);
      }
export type ArchiveContractExtractionMutationHookResult = ReturnType<typeof useArchiveContractExtractionMutation>;
export type ArchiveContractExtractionMutationResult = Apollo.MutationResult<ArchiveContractExtractionMutation>;
export type ArchiveContractExtractionMutationOptions = Apollo.BaseMutationOptions<ArchiveContractExtractionMutation, ArchiveContractExtractionMutationVariables>;
export const UnarchiveContractExtractionDocument = gql`
    mutation UnarchiveContractExtraction($extractionId: ID!) {
  unarchiveContractExtraction(extractionId: $extractionId) {
    id
    playerId
    documentType
    status
  }
}
    `;
export type UnarchiveContractExtractionMutationFn = Apollo.MutationFunction<UnarchiveContractExtractionMutation, UnarchiveContractExtractionMutationVariables>;

/**
 * __useUnarchiveContractExtractionMutation__
 *
 * To run a mutation, you first call `useUnarchiveContractExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveContractExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveContractExtractionMutation, { data, loading, error }] = useUnarchiveContractExtractionMutation({
 *   variables: {
 *      extractionId: // value for 'extractionId'
 *   },
 * });
 */
export function useUnarchiveContractExtractionMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveContractExtractionMutation, UnarchiveContractExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveContractExtractionMutation, UnarchiveContractExtractionMutationVariables>(UnarchiveContractExtractionDocument, options);
      }
export type UnarchiveContractExtractionMutationHookResult = ReturnType<typeof useUnarchiveContractExtractionMutation>;
export type UnarchiveContractExtractionMutationResult = Apollo.MutationResult<UnarchiveContractExtractionMutation>;
export type UnarchiveContractExtractionMutationOptions = Apollo.BaseMutationOptions<UnarchiveContractExtractionMutation, UnarchiveContractExtractionMutationVariables>;
export const CreateContractUploadUrlDocument = gql`
    mutation CreateContractUploadUrl($input: CreateContractUploadUrlInput!) {
  createContractUploadUrl(input: $input) {
    presignedUrl
    s3Key
  }
}
    `;
export type CreateContractUploadUrlMutationFn = Apollo.MutationFunction<CreateContractUploadUrlMutation, CreateContractUploadUrlMutationVariables>;

/**
 * __useCreateContractUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateContractUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractUploadUrlMutation, { data, loading, error }] = useCreateContractUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractUploadUrlMutation, CreateContractUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractUploadUrlMutation, CreateContractUploadUrlMutationVariables>(CreateContractUploadUrlDocument, options);
      }
export type CreateContractUploadUrlMutationHookResult = ReturnType<typeof useCreateContractUploadUrlMutation>;
export type CreateContractUploadUrlMutationResult = Apollo.MutationResult<CreateContractUploadUrlMutation>;
export type CreateContractUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateContractUploadUrlMutation, CreateContractUploadUrlMutationVariables>;
export const ListContractDocumentsDocument = gql`
    query ListContractDocuments($playerId: ID!) {
  listContractDocuments(playerId: $playerId) {
    fileName
    fileSize
    uploadedAt
    s3Key
    contentType
  }
}
    `;

/**
 * __useListContractDocumentsQuery__
 *
 * To run a query within a React component, call `useListContractDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContractDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContractDocumentsQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useListContractDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListContractDocumentsQuery, ListContractDocumentsQueryVariables> & ({ variables: ListContractDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>(ListContractDocumentsDocument, options);
      }
export function useListContractDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>(ListContractDocumentsDocument, options);
        }
// @ts-ignore
export function useListContractDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>;
export function useListContractDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListContractDocumentsQuery | undefined, ListContractDocumentsQueryVariables>;
export function useListContractDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>(ListContractDocumentsDocument, options);
        }
export type ListContractDocumentsQueryHookResult = ReturnType<typeof useListContractDocumentsQuery>;
export type ListContractDocumentsLazyQueryHookResult = ReturnType<typeof useListContractDocumentsLazyQuery>;
export type ListContractDocumentsSuspenseQueryHookResult = ReturnType<typeof useListContractDocumentsSuspenseQuery>;
export type ListContractDocumentsQueryResult = Apollo.QueryResult<ListContractDocumentsQuery, ListContractDocumentsQueryVariables>;
export const GetContractDocumentPreviewUrlDocument = gql`
    query GetContractDocumentPreviewUrl($playerId: ID!, $s3Key: String!) {
  getContractDocumentPreviewUrl(playerId: $playerId, s3Key: $s3Key)
}
    `;

/**
 * __useGetContractDocumentPreviewUrlQuery__
 *
 * To run a query within a React component, call `useGetContractDocumentPreviewUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractDocumentPreviewUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractDocumentPreviewUrlQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useGetContractDocumentPreviewUrlQuery(baseOptions: Apollo.QueryHookOptions<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables> & ({ variables: GetContractDocumentPreviewUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>(GetContractDocumentPreviewUrlDocument, options);
      }
export function useGetContractDocumentPreviewUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>(GetContractDocumentPreviewUrlDocument, options);
        }
// @ts-ignore
export function useGetContractDocumentPreviewUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>;
export function useGetContractDocumentPreviewUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractDocumentPreviewUrlQuery | undefined, GetContractDocumentPreviewUrlQueryVariables>;
export function useGetContractDocumentPreviewUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>(GetContractDocumentPreviewUrlDocument, options);
        }
export type GetContractDocumentPreviewUrlQueryHookResult = ReturnType<typeof useGetContractDocumentPreviewUrlQuery>;
export type GetContractDocumentPreviewUrlLazyQueryHookResult = ReturnType<typeof useGetContractDocumentPreviewUrlLazyQuery>;
export type GetContractDocumentPreviewUrlSuspenseQueryHookResult = ReturnType<typeof useGetContractDocumentPreviewUrlSuspenseQuery>;
export type GetContractDocumentPreviewUrlQueryResult = Apollo.QueryResult<GetContractDocumentPreviewUrlQuery, GetContractDocumentPreviewUrlQueryVariables>;
export const DeleteContractDocumentDocument = gql`
    mutation DeleteContractDocument($playerId: ID!, $s3Key: String!) {
  deleteContractDocument(playerId: $playerId, s3Key: $s3Key)
}
    `;
export type DeleteContractDocumentMutationFn = Apollo.MutationFunction<DeleteContractDocumentMutation, DeleteContractDocumentMutationVariables>;

/**
 * __useDeleteContractDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteContractDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractDocumentMutation, { data, loading, error }] = useDeleteContractDocumentMutation({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useDeleteContractDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractDocumentMutation, DeleteContractDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractDocumentMutation, DeleteContractDocumentMutationVariables>(DeleteContractDocumentDocument, options);
      }
export type DeleteContractDocumentMutationHookResult = ReturnType<typeof useDeleteContractDocumentMutation>;
export type DeleteContractDocumentMutationResult = Apollo.MutationResult<DeleteContractDocumentMutation>;
export type DeleteContractDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteContractDocumentMutation, DeleteContractDocumentMutationVariables>;
export const GetContractExtractionDocument = gql`
    query GetContractExtraction($playerId: ID!, $documentType: DocumentType!) {
  getContractExtraction(playerId: $playerId, documentType: $documentType) {
    id
    playerId
    documentType
    status
    extractedData
    extractedAt
    savedAt
    endDate
  }
}
    `;

/**
 * __useGetContractExtractionQuery__
 *
 * To run a query within a React component, call `useGetContractExtractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractExtractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractExtractionQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useGetContractExtractionQuery(baseOptions: Apollo.QueryHookOptions<GetContractExtractionQuery, GetContractExtractionQueryVariables> & ({ variables: GetContractExtractionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractExtractionQuery, GetContractExtractionQueryVariables>(GetContractExtractionDocument, options);
      }
export function useGetContractExtractionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractExtractionQuery, GetContractExtractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractExtractionQuery, GetContractExtractionQueryVariables>(GetContractExtractionDocument, options);
        }
// @ts-ignore
export function useGetContractExtractionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractExtractionQuery, GetContractExtractionQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractExtractionQuery, GetContractExtractionQueryVariables>;
export function useGetContractExtractionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractExtractionQuery, GetContractExtractionQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractExtractionQuery | undefined, GetContractExtractionQueryVariables>;
export function useGetContractExtractionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractExtractionQuery, GetContractExtractionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractExtractionQuery, GetContractExtractionQueryVariables>(GetContractExtractionDocument, options);
        }
export type GetContractExtractionQueryHookResult = ReturnType<typeof useGetContractExtractionQuery>;
export type GetContractExtractionLazyQueryHookResult = ReturnType<typeof useGetContractExtractionLazyQuery>;
export type GetContractExtractionSuspenseQueryHookResult = ReturnType<typeof useGetContractExtractionSuspenseQuery>;
export type GetContractExtractionQueryResult = Apollo.QueryResult<GetContractExtractionQuery, GetContractExtractionQueryVariables>;
export const EditContractEndDateDocument = gql`
    mutation EditContractEndDate($input: EditContractEndDateInput!) {
  editContractEndDate(input: $input) {
    id
    playerId
    documentType
    status
    extractedData
    extractedAt
    savedAt
    endDate
  }
}
    `;
export type EditContractEndDateMutationFn = Apollo.MutationFunction<EditContractEndDateMutation, EditContractEndDateMutationVariables>;

/**
 * __useEditContractEndDateMutation__
 *
 * To run a mutation, you first call `useEditContractEndDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContractEndDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContractEndDateMutation, { data, loading, error }] = useEditContractEndDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditContractEndDateMutation(baseOptions?: Apollo.MutationHookOptions<EditContractEndDateMutation, EditContractEndDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContractEndDateMutation, EditContractEndDateMutationVariables>(EditContractEndDateDocument, options);
      }
export type EditContractEndDateMutationHookResult = ReturnType<typeof useEditContractEndDateMutation>;
export type EditContractEndDateMutationResult = Apollo.MutationResult<EditContractEndDateMutation>;
export type EditContractEndDateMutationOptions = Apollo.BaseMutationOptions<EditContractEndDateMutation, EditContractEndDateMutationVariables>;
export const DeleteContractExtractionDocument = gql`
    mutation DeleteContractExtraction($input: DeleteContractExtractionInput!, $confirmation: String!) {
  deleteContractExtraction(input: $input, confirmation: $confirmation)
}
    `;
export type DeleteContractExtractionMutationFn = Apollo.MutationFunction<DeleteContractExtractionMutation, DeleteContractExtractionMutationVariables>;

/**
 * __useDeleteContractExtractionMutation__
 *
 * To run a mutation, you first call `useDeleteContractExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractExtractionMutation, { data, loading, error }] = useDeleteContractExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      confirmation: // value for 'confirmation'
 *   },
 * });
 */
export function useDeleteContractExtractionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractExtractionMutation, DeleteContractExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractExtractionMutation, DeleteContractExtractionMutationVariables>(DeleteContractExtractionDocument, options);
      }
export type DeleteContractExtractionMutationHookResult = ReturnType<typeof useDeleteContractExtractionMutation>;
export type DeleteContractExtractionMutationResult = Apollo.MutationResult<DeleteContractExtractionMutation>;
export type DeleteContractExtractionMutationOptions = Apollo.BaseMutationOptions<DeleteContractExtractionMutation, DeleteContractExtractionMutationVariables>;
export const AddContractLineItemDocument = gql`
    mutation AddContractLineItem($input: AddContractLineItemInput!) {
  addContractLineItem(input: $input) {
    success
  }
}
    `;
export type AddContractLineItemMutationFn = Apollo.MutationFunction<AddContractLineItemMutation, AddContractLineItemMutationVariables>;

/**
 * __useAddContractLineItemMutation__
 *
 * To run a mutation, you first call `useAddContractLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContractLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContractLineItemMutation, { data, loading, error }] = useAddContractLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContractLineItemMutation(baseOptions?: Apollo.MutationHookOptions<AddContractLineItemMutation, AddContractLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContractLineItemMutation, AddContractLineItemMutationVariables>(AddContractLineItemDocument, options);
      }
export type AddContractLineItemMutationHookResult = ReturnType<typeof useAddContractLineItemMutation>;
export type AddContractLineItemMutationResult = Apollo.MutationResult<AddContractLineItemMutation>;
export type AddContractLineItemMutationOptions = Apollo.BaseMutationOptions<AddContractLineItemMutation, AddContractLineItemMutationVariables>;
export const TriggerContractExtractionDocument = gql`
    mutation TriggerContractExtraction($input: TriggerContractExtractionInput!) {
  triggerContractExtraction(input: $input) {
    id
    status
  }
}
    `;
export type TriggerContractExtractionMutationFn = Apollo.MutationFunction<TriggerContractExtractionMutation, TriggerContractExtractionMutationVariables>;

/**
 * __useTriggerContractExtractionMutation__
 *
 * To run a mutation, you first call `useTriggerContractExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerContractExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerContractExtractionMutation, { data, loading, error }] = useTriggerContractExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerContractExtractionMutation(baseOptions?: Apollo.MutationHookOptions<TriggerContractExtractionMutation, TriggerContractExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerContractExtractionMutation, TriggerContractExtractionMutationVariables>(TriggerContractExtractionDocument, options);
      }
export type TriggerContractExtractionMutationHookResult = ReturnType<typeof useTriggerContractExtractionMutation>;
export type TriggerContractExtractionMutationResult = Apollo.MutationResult<TriggerContractExtractionMutation>;
export type TriggerContractExtractionMutationOptions = Apollo.BaseMutationOptions<TriggerContractExtractionMutation, TriggerContractExtractionMutationVariables>;
export const ResolveCategoryConflictsDocument = gql`
    mutation ResolveCategoryConflicts($input: ResolveCategoryConflictsInput!) {
  resolveCategoryConflicts(input: $input) {
    success
  }
}
    `;
export type ResolveCategoryConflictsMutationFn = Apollo.MutationFunction<ResolveCategoryConflictsMutation, ResolveCategoryConflictsMutationVariables>;

/**
 * __useResolveCategoryConflictsMutation__
 *
 * To run a mutation, you first call `useResolveCategoryConflictsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveCategoryConflictsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveCategoryConflictsMutation, { data, loading, error }] = useResolveCategoryConflictsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveCategoryConflictsMutation(baseOptions?: Apollo.MutationHookOptions<ResolveCategoryConflictsMutation, ResolveCategoryConflictsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveCategoryConflictsMutation, ResolveCategoryConflictsMutationVariables>(ResolveCategoryConflictsDocument, options);
      }
export type ResolveCategoryConflictsMutationHookResult = ReturnType<typeof useResolveCategoryConflictsMutation>;
export type ResolveCategoryConflictsMutationResult = Apollo.MutationResult<ResolveCategoryConflictsMutation>;
export type ResolveCategoryConflictsMutationOptions = Apollo.BaseMutationOptions<ResolveCategoryConflictsMutation, ResolveCategoryConflictsMutationVariables>;
export const SaveContractExtractionDocument = gql`
    mutation SaveContractExtraction($extractionId: ID!) {
  saveContractExtraction(extractionId: $extractionId) {
    id
    status
    savedAt
  }
}
    `;
export type SaveContractExtractionMutationFn = Apollo.MutationFunction<SaveContractExtractionMutation, SaveContractExtractionMutationVariables>;

/**
 * __useSaveContractExtractionMutation__
 *
 * To run a mutation, you first call `useSaveContractExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContractExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContractExtractionMutation, { data, loading, error }] = useSaveContractExtractionMutation({
 *   variables: {
 *      extractionId: // value for 'extractionId'
 *   },
 * });
 */
export function useSaveContractExtractionMutation(baseOptions?: Apollo.MutationHookOptions<SaveContractExtractionMutation, SaveContractExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveContractExtractionMutation, SaveContractExtractionMutationVariables>(SaveContractExtractionDocument, options);
      }
export type SaveContractExtractionMutationHookResult = ReturnType<typeof useSaveContractExtractionMutation>;
export type SaveContractExtractionMutationResult = Apollo.MutationResult<SaveContractExtractionMutation>;
export type SaveContractExtractionMutationOptions = Apollo.BaseMutationOptions<SaveContractExtractionMutation, SaveContractExtractionMutationVariables>;
export const DashboardListMyOrganizationsLeaguesDocument = gql`
    query DashboardListMyOrganizationsLeagues($first: Int, $after: String) {
  listMyOrganizationsLeagues(first: $first, after: $after) {
    ...DashboardLeagueConnection
  }
}
    ${DashboardLeagueConnectionFragmentDoc}`;

/**
 * __useDashboardListMyOrganizationsLeaguesQuery__
 *
 * To run a query within a React component, call `useDashboardListMyOrganizationsLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListMyOrganizationsLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListMyOrganizationsLeaguesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDashboardListMyOrganizationsLeaguesQuery(baseOptions?: Apollo.QueryHookOptions<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>(DashboardListMyOrganizationsLeaguesDocument, options);
      }
export function useDashboardListMyOrganizationsLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>(DashboardListMyOrganizationsLeaguesDocument, options);
        }
// @ts-ignore
export function useDashboardListMyOrganizationsLeaguesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>;
export function useDashboardListMyOrganizationsLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListMyOrganizationsLeaguesQuery | undefined, DashboardListMyOrganizationsLeaguesQueryVariables>;
export function useDashboardListMyOrganizationsLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>(DashboardListMyOrganizationsLeaguesDocument, options);
        }
export type DashboardListMyOrganizationsLeaguesQueryHookResult = ReturnType<typeof useDashboardListMyOrganizationsLeaguesQuery>;
export type DashboardListMyOrganizationsLeaguesLazyQueryHookResult = ReturnType<typeof useDashboardListMyOrganizationsLeaguesLazyQuery>;
export type DashboardListMyOrganizationsLeaguesSuspenseQueryHookResult = ReturnType<typeof useDashboardListMyOrganizationsLeaguesSuspenseQuery>;
export type DashboardListMyOrganizationsLeaguesQueryResult = Apollo.QueryResult<DashboardListMyOrganizationsLeaguesQuery, DashboardListMyOrganizationsLeaguesQueryVariables>;
export const DashboardListRecentTransfersDocument = gql`
    query DashboardListRecentTransfers($first: Int, $after: String) {
  listRecentTransfers(first: $first, after: $after) {
    ...DashboardTransferConnection
  }
}
    ${DashboardTransferConnectionFragmentDoc}`;

/**
 * __useDashboardListRecentTransfersQuery__
 *
 * To run a query within a React component, call `useDashboardListRecentTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListRecentTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListRecentTransfersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDashboardListRecentTransfersQuery(baseOptions?: Apollo.QueryHookOptions<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>(DashboardListRecentTransfersDocument, options);
      }
export function useDashboardListRecentTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>(DashboardListRecentTransfersDocument, options);
        }
// @ts-ignore
export function useDashboardListRecentTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>;
export function useDashboardListRecentTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListRecentTransfersQuery | undefined, DashboardListRecentTransfersQueryVariables>;
export function useDashboardListRecentTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>(DashboardListRecentTransfersDocument, options);
        }
export type DashboardListRecentTransfersQueryHookResult = ReturnType<typeof useDashboardListRecentTransfersQuery>;
export type DashboardListRecentTransfersLazyQueryHookResult = ReturnType<typeof useDashboardListRecentTransfersLazyQuery>;
export type DashboardListRecentTransfersSuspenseQueryHookResult = ReturnType<typeof useDashboardListRecentTransfersSuspenseQuery>;
export type DashboardListRecentTransfersQueryResult = Apollo.QueryResult<DashboardListRecentTransfersQuery, DashboardListRecentTransfersQueryVariables>;
export const DashboardListExpiringContractsDocument = gql`
    query DashboardListExpiringContracts($first: Int, $after: String, $thresholdMonths: Int) {
  listExpiringContracts(
    first: $first
    after: $after
    thresholdMonths: $thresholdMonths
  ) {
    ...DashboardExpiringContractConnection
  }
}
    ${DashboardExpiringContractConnectionFragmentDoc}`;

/**
 * __useDashboardListExpiringContractsQuery__
 *
 * To run a query within a React component, call `useDashboardListExpiringContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListExpiringContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListExpiringContractsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      thresholdMonths: // value for 'thresholdMonths'
 *   },
 * });
 */
export function useDashboardListExpiringContractsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>(DashboardListExpiringContractsDocument, options);
      }
export function useDashboardListExpiringContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>(DashboardListExpiringContractsDocument, options);
        }
// @ts-ignore
export function useDashboardListExpiringContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>;
export function useDashboardListExpiringContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListExpiringContractsQuery | undefined, DashboardListExpiringContractsQueryVariables>;
export function useDashboardListExpiringContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>(DashboardListExpiringContractsDocument, options);
        }
export type DashboardListExpiringContractsQueryHookResult = ReturnType<typeof useDashboardListExpiringContractsQuery>;
export type DashboardListExpiringContractsLazyQueryHookResult = ReturnType<typeof useDashboardListExpiringContractsLazyQuery>;
export type DashboardListExpiringContractsSuspenseQueryHookResult = ReturnType<typeof useDashboardListExpiringContractsSuspenseQuery>;
export type DashboardListExpiringContractsQueryResult = Apollo.QueryResult<DashboardListExpiringContractsQuery, DashboardListExpiringContractsQueryVariables>;
export const DashboardGetExpiringContractsCountDocument = gql`
    query DashboardGetExpiringContractsCount($thresholdMonths: Int) {
  getExpiringContractsCount(thresholdMonths: $thresholdMonths)
}
    `;

/**
 * __useDashboardGetExpiringContractsCountQuery__
 *
 * To run a query within a React component, call `useDashboardGetExpiringContractsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGetExpiringContractsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGetExpiringContractsCountQuery({
 *   variables: {
 *      thresholdMonths: // value for 'thresholdMonths'
 *   },
 * });
 */
export function useDashboardGetExpiringContractsCountQuery(baseOptions?: Apollo.QueryHookOptions<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>(DashboardGetExpiringContractsCountDocument, options);
      }
export function useDashboardGetExpiringContractsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>(DashboardGetExpiringContractsCountDocument, options);
        }
// @ts-ignore
export function useDashboardGetExpiringContractsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>;
export function useDashboardGetExpiringContractsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardGetExpiringContractsCountQuery | undefined, DashboardGetExpiringContractsCountQueryVariables>;
export function useDashboardGetExpiringContractsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>(DashboardGetExpiringContractsCountDocument, options);
        }
export type DashboardGetExpiringContractsCountQueryHookResult = ReturnType<typeof useDashboardGetExpiringContractsCountQuery>;
export type DashboardGetExpiringContractsCountLazyQueryHookResult = ReturnType<typeof useDashboardGetExpiringContractsCountLazyQuery>;
export type DashboardGetExpiringContractsCountSuspenseQueryHookResult = ReturnType<typeof useDashboardGetExpiringContractsCountSuspenseQuery>;
export type DashboardGetExpiringContractsCountQueryResult = Apollo.QueryResult<DashboardGetExpiringContractsCountQuery, DashboardGetExpiringContractsCountQueryVariables>;
export const DashboardListPositionDistributionDataDocument = gql`
    query DashboardListPositionDistributionData {
  listPositionDistributionData {
    playerId
    positionCategory
    gpr
    source
    player {
      name
      firstName
      lastName
      knownName
    }
  }
}
    `;

/**
 * __useDashboardListPositionDistributionDataQuery__
 *
 * To run a query within a React component, call `useDashboardListPositionDistributionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListPositionDistributionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListPositionDistributionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardListPositionDistributionDataQuery(baseOptions?: Apollo.QueryHookOptions<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>(DashboardListPositionDistributionDataDocument, options);
      }
export function useDashboardListPositionDistributionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>(DashboardListPositionDistributionDataDocument, options);
        }
// @ts-ignore
export function useDashboardListPositionDistributionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>;
export function useDashboardListPositionDistributionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardListPositionDistributionDataQuery | undefined, DashboardListPositionDistributionDataQueryVariables>;
export function useDashboardListPositionDistributionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>(DashboardListPositionDistributionDataDocument, options);
        }
export type DashboardListPositionDistributionDataQueryHookResult = ReturnType<typeof useDashboardListPositionDistributionDataQuery>;
export type DashboardListPositionDistributionDataLazyQueryHookResult = ReturnType<typeof useDashboardListPositionDistributionDataLazyQuery>;
export type DashboardListPositionDistributionDataSuspenseQueryHookResult = ReturnType<typeof useDashboardListPositionDistributionDataSuspenseQuery>;
export type DashboardListPositionDistributionDataQueryResult = Apollo.QueryResult<DashboardListPositionDistributionDataQuery, DashboardListPositionDistributionDataQueryVariables>;
export const DashboardGetTeamLeagueStatsDocument = gql`
    query DashboardGetTeamLeagueStats {
  getTeamLeagueStats {
    teamGprRank
    totalTeams
    teamPercentiles {
      ...DashboardRadarMetrics
    }
    leagueAveragePercentiles {
      ...DashboardRadarMetrics
    }
    rosterStats {
      ...DashboardRosterStats
    }
  }
}
    ${DashboardRadarMetricsFragmentDoc}
${DashboardRosterStatsFragmentDoc}`;

/**
 * __useDashboardGetTeamLeagueStatsQuery__
 *
 * To run a query within a React component, call `useDashboardGetTeamLeagueStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGetTeamLeagueStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGetTeamLeagueStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardGetTeamLeagueStatsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>(DashboardGetTeamLeagueStatsDocument, options);
      }
export function useDashboardGetTeamLeagueStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>(DashboardGetTeamLeagueStatsDocument, options);
        }
// @ts-ignore
export function useDashboardGetTeamLeagueStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>;
export function useDashboardGetTeamLeagueStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardGetTeamLeagueStatsQuery | undefined, DashboardGetTeamLeagueStatsQueryVariables>;
export function useDashboardGetTeamLeagueStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>(DashboardGetTeamLeagueStatsDocument, options);
        }
export type DashboardGetTeamLeagueStatsQueryHookResult = ReturnType<typeof useDashboardGetTeamLeagueStatsQuery>;
export type DashboardGetTeamLeagueStatsLazyQueryHookResult = ReturnType<typeof useDashboardGetTeamLeagueStatsLazyQuery>;
export type DashboardGetTeamLeagueStatsSuspenseQueryHookResult = ReturnType<typeof useDashboardGetTeamLeagueStatsSuspenseQuery>;
export type DashboardGetTeamLeagueStatsQueryResult = Apollo.QueryResult<DashboardGetTeamLeagueStatsQuery, DashboardGetTeamLeagueStatsQueryVariables>;
export const DashboardSearchLeaguePlayersDocument = gql`
    query DashboardSearchLeaguePlayers($query: String, $first: Int, $after: String) {
  searchLeaguePlayers(query: $query, first: $first, after: $after) {
    edges {
      ...DashboardLeaguePlayerSearchEdge
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${DashboardLeaguePlayerSearchEdgeFragmentDoc}`;

/**
 * __useDashboardSearchLeaguePlayersQuery__
 *
 * To run a query within a React component, call `useDashboardSearchLeaguePlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSearchLeaguePlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSearchLeaguePlayersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDashboardSearchLeaguePlayersQuery(baseOptions?: Apollo.QueryHookOptions<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>(DashboardSearchLeaguePlayersDocument, options);
      }
export function useDashboardSearchLeaguePlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>(DashboardSearchLeaguePlayersDocument, options);
        }
// @ts-ignore
export function useDashboardSearchLeaguePlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>;
export function useDashboardSearchLeaguePlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardSearchLeaguePlayersQuery | undefined, DashboardSearchLeaguePlayersQueryVariables>;
export function useDashboardSearchLeaguePlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>(DashboardSearchLeaguePlayersDocument, options);
        }
export type DashboardSearchLeaguePlayersQueryHookResult = ReturnType<typeof useDashboardSearchLeaguePlayersQuery>;
export type DashboardSearchLeaguePlayersLazyQueryHookResult = ReturnType<typeof useDashboardSearchLeaguePlayersLazyQuery>;
export type DashboardSearchLeaguePlayersSuspenseQueryHookResult = ReturnType<typeof useDashboardSearchLeaguePlayersSuspenseQuery>;
export type DashboardSearchLeaguePlayersQueryResult = Apollo.QueryResult<DashboardSearchLeaguePlayersQuery, DashboardSearchLeaguePlayersQueryVariables>;
export const ComplianceViewerTierDocument = gql`
    query ComplianceViewerTier {
  complianceOverview {
    organizationId
    scenarioId
    viewerTier
  }
}
    `;

/**
 * __useComplianceViewerTierQuery__
 *
 * To run a query within a React component, call `useComplianceViewerTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceViewerTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceViewerTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useComplianceViewerTierQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>(ComplianceViewerTierDocument, options);
      }
export function useComplianceViewerTierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>(ComplianceViewerTierDocument, options);
        }
// @ts-ignore
export function useComplianceViewerTierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>;
export function useComplianceViewerTierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceViewerTierQuery | undefined, ComplianceViewerTierQueryVariables>;
export function useComplianceViewerTierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>(ComplianceViewerTierDocument, options);
        }
export type ComplianceViewerTierQueryHookResult = ReturnType<typeof useComplianceViewerTierQuery>;
export type ComplianceViewerTierLazyQueryHookResult = ReturnType<typeof useComplianceViewerTierLazyQuery>;
export type ComplianceViewerTierSuspenseQueryHookResult = ReturnType<typeof useComplianceViewerTierSuspenseQuery>;
export type ComplianceViewerTierQueryResult = Apollo.QueryResult<ComplianceViewerTierQuery, ComplianceViewerTierQueryVariables>;
export const CompliancePlanStatusDocument = gql`
    query CompliancePlanStatus($scenarioId: ID) {
  complianceOverview(scenarioId: $scenarioId) {
    organizationId
    scenarioId
    isScenarioProjection
    viewerTier
    permittedQuantities
    ruleCount
    alertCount
    breachCount
    layers {
      layer
      evaluations {
        ruleId
        ruleName
        metricId
        metricName
        layer
        state
        value
        threshold
        deviation
        unit
        comparator
        showKpi
        partialReasons
        unverifiableFigures
        completeness
        excludedInputs {
          quantity
          subjectCount
        }
        denominatorSource
        missingInputs
        trend {
          hasHistory
          points {
            value
            period {
              periodStart
              periodEnd
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCompliancePlanStatusQuery__
 *
 * To run a query within a React component, call `useCompliancePlanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompliancePlanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompliancePlanStatusQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useCompliancePlanStatusQuery(baseOptions?: Apollo.QueryHookOptions<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>(CompliancePlanStatusDocument, options);
      }
export function useCompliancePlanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>(CompliancePlanStatusDocument, options);
        }
// @ts-ignore
export function useCompliancePlanStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>;
export function useCompliancePlanStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CompliancePlanStatusQuery | undefined, CompliancePlanStatusQueryVariables>;
export function useCompliancePlanStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>(CompliancePlanStatusDocument, options);
        }
export type CompliancePlanStatusQueryHookResult = ReturnType<typeof useCompliancePlanStatusQuery>;
export type CompliancePlanStatusLazyQueryHookResult = ReturnType<typeof useCompliancePlanStatusLazyQuery>;
export type CompliancePlanStatusSuspenseQueryHookResult = ReturnType<typeof useCompliancePlanStatusSuspenseQuery>;
export type CompliancePlanStatusQueryResult = Apollo.QueryResult<CompliancePlanStatusQuery, CompliancePlanStatusQueryVariables>;
export const ClubObjectivesDocument = gql`
    query ClubObjectives {
  complianceOverview {
    organizationId
    scenarioId
    viewerTier
    layers {
      layer
      evaluations {
        ruleId
        ruleName
        regimeName
        regimeKey
        ruleFamily
        layer
        metricId
        metricName
        comparator
        threshold
        amberThreshold
        basisLabel
        consequence
        showKpi
        state
        partialReasons
        isWindowComplete
        unit
        value
        window
        completeness
        excludedInputs {
          quantity
          subjectCount
        }
        denominatorSource
        missingInputs
        warnOnly
        unverifiableFigures
        knownFigures {
          label
          value
          unit
          isLowerBound
        }
        coveredPeriods {
          periodStart
          periodEnd
        }
        trend {
          hasHistory
          points {
            value
            period {
              periodStart
              periodEnd
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useClubObjectivesQuery__
 *
 * To run a query within a React component, call `useClubObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubObjectivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClubObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<ClubObjectivesQuery, ClubObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClubObjectivesQuery, ClubObjectivesQueryVariables>(ClubObjectivesDocument, options);
      }
export function useClubObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClubObjectivesQuery, ClubObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClubObjectivesQuery, ClubObjectivesQueryVariables>(ClubObjectivesDocument, options);
        }
// @ts-ignore
export function useClubObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClubObjectivesQuery, ClubObjectivesQueryVariables>): Apollo.UseSuspenseQueryResult<ClubObjectivesQuery, ClubObjectivesQueryVariables>;
export function useClubObjectivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClubObjectivesQuery, ClubObjectivesQueryVariables>): Apollo.UseSuspenseQueryResult<ClubObjectivesQuery | undefined, ClubObjectivesQueryVariables>;
export function useClubObjectivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClubObjectivesQuery, ClubObjectivesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClubObjectivesQuery, ClubObjectivesQueryVariables>(ClubObjectivesDocument, options);
        }
export type ClubObjectivesQueryHookResult = ReturnType<typeof useClubObjectivesQuery>;
export type ClubObjectivesLazyQueryHookResult = ReturnType<typeof useClubObjectivesLazyQuery>;
export type ClubObjectivesSuspenseQueryHookResult = ReturnType<typeof useClubObjectivesSuspenseQuery>;
export type ClubObjectivesQueryResult = Apollo.QueryResult<ClubObjectivesQuery, ClubObjectivesQueryVariables>;
export const AllClubObjectivesDocument = gql`
    query AllClubObjectives {
  clubObjectives {
    id
    name
    metricId
    metricName
    category
    comparator
    threshold
    amberThreshold
    assessmentWindow
    showKpi
    isEnabled
  }
}
    `;

/**
 * __useAllClubObjectivesQuery__
 *
 * To run a query within a React component, call `useAllClubObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllClubObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllClubObjectivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllClubObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>(AllClubObjectivesDocument, options);
      }
export function useAllClubObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>(AllClubObjectivesDocument, options);
        }
// @ts-ignore
export function useAllClubObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>): Apollo.UseSuspenseQueryResult<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>;
export function useAllClubObjectivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>): Apollo.UseSuspenseQueryResult<AllClubObjectivesQuery | undefined, AllClubObjectivesQueryVariables>;
export function useAllClubObjectivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>(AllClubObjectivesDocument, options);
        }
export type AllClubObjectivesQueryHookResult = ReturnType<typeof useAllClubObjectivesQuery>;
export type AllClubObjectivesLazyQueryHookResult = ReturnType<typeof useAllClubObjectivesLazyQuery>;
export type AllClubObjectivesSuspenseQueryHookResult = ReturnType<typeof useAllClubObjectivesSuspenseQuery>;
export type AllClubObjectivesQueryResult = Apollo.QueryResult<AllClubObjectivesQuery, AllClubObjectivesQueryVariables>;
export const ComplianceMetricsDocument = gql`
    query ComplianceMetrics {
  complianceMetrics {
    id
    name
    category
    isGlobal
    kind
    requiredTier
  }
}
    `;

/**
 * __useComplianceMetricsQuery__
 *
 * To run a query within a React component, call `useComplianceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useComplianceMetricsQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>(ComplianceMetricsDocument, options);
      }
export function useComplianceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>(ComplianceMetricsDocument, options);
        }
// @ts-ignore
export function useComplianceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>;
export function useComplianceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceMetricsQuery | undefined, ComplianceMetricsQueryVariables>;
export function useComplianceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>(ComplianceMetricsDocument, options);
        }
export type ComplianceMetricsQueryHookResult = ReturnType<typeof useComplianceMetricsQuery>;
export type ComplianceMetricsLazyQueryHookResult = ReturnType<typeof useComplianceMetricsLazyQuery>;
export type ComplianceMetricsSuspenseQueryHookResult = ReturnType<typeof useComplianceMetricsSuspenseQuery>;
export type ComplianceMetricsQueryResult = Apollo.QueryResult<ComplianceMetricsQuery, ComplianceMetricsQueryVariables>;
export const CreateClubObjectiveDocument = gql`
    mutation CreateClubObjective($input: CreateClubObjectiveInput!) {
  createClubObjective(input: $input) {
    id
    organizationId
    name
    metricId
    metricName
    category
    comparator
    threshold
    amberThreshold
    assessmentWindow
    showKpi
    isEnabled
  }
}
    `;
export type CreateClubObjectiveMutationFn = Apollo.MutationFunction<CreateClubObjectiveMutation, CreateClubObjectiveMutationVariables>;

/**
 * __useCreateClubObjectiveMutation__
 *
 * To run a mutation, you first call `useCreateClubObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClubObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClubObjectiveMutation, { data, loading, error }] = useCreateClubObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClubObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateClubObjectiveMutation, CreateClubObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClubObjectiveMutation, CreateClubObjectiveMutationVariables>(CreateClubObjectiveDocument, options);
      }
export type CreateClubObjectiveMutationHookResult = ReturnType<typeof useCreateClubObjectiveMutation>;
export type CreateClubObjectiveMutationResult = Apollo.MutationResult<CreateClubObjectiveMutation>;
export type CreateClubObjectiveMutationOptions = Apollo.BaseMutationOptions<CreateClubObjectiveMutation, CreateClubObjectiveMutationVariables>;
export const UpdateClubObjectiveDocument = gql`
    mutation UpdateClubObjective($input: UpdateClubObjectiveInput!) {
  updateClubObjective(input: $input) {
    id
    organizationId
    name
    metricId
    metricName
    category
    comparator
    threshold
    amberThreshold
    assessmentWindow
    showKpi
    isEnabled
  }
}
    `;
export type UpdateClubObjectiveMutationFn = Apollo.MutationFunction<UpdateClubObjectiveMutation, UpdateClubObjectiveMutationVariables>;

/**
 * __useUpdateClubObjectiveMutation__
 *
 * To run a mutation, you first call `useUpdateClubObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubObjectiveMutation, { data, loading, error }] = useUpdateClubObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClubObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubObjectiveMutation, UpdateClubObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubObjectiveMutation, UpdateClubObjectiveMutationVariables>(UpdateClubObjectiveDocument, options);
      }
export type UpdateClubObjectiveMutationHookResult = ReturnType<typeof useUpdateClubObjectiveMutation>;
export type UpdateClubObjectiveMutationResult = Apollo.MutationResult<UpdateClubObjectiveMutation>;
export type UpdateClubObjectiveMutationOptions = Apollo.BaseMutationOptions<UpdateClubObjectiveMutation, UpdateClubObjectiveMutationVariables>;
export const DeleteClubObjectiveDocument = gql`
    mutation DeleteClubObjective($id: ID!) {
  deleteClubObjective(id: $id)
}
    `;
export type DeleteClubObjectiveMutationFn = Apollo.MutationFunction<DeleteClubObjectiveMutation, DeleteClubObjectiveMutationVariables>;

/**
 * __useDeleteClubObjectiveMutation__
 *
 * To run a mutation, you first call `useDeleteClubObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClubObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClubObjectiveMutation, { data, loading, error }] = useDeleteClubObjectiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClubObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClubObjectiveMutation, DeleteClubObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClubObjectiveMutation, DeleteClubObjectiveMutationVariables>(DeleteClubObjectiveDocument, options);
      }
export type DeleteClubObjectiveMutationHookResult = ReturnType<typeof useDeleteClubObjectiveMutation>;
export type DeleteClubObjectiveMutationResult = Apollo.MutationResult<DeleteClubObjectiveMutation>;
export type DeleteClubObjectiveMutationOptions = Apollo.BaseMutationOptions<DeleteClubObjectiveMutation, DeleteClubObjectiveMutationVariables>;
export const CreateComplianceMetricDocument = gql`
    mutation CreateComplianceMetric($input: CreateComplianceMetricInput!) {
  createComplianceMetric(input: $input) {
    id
    name
    category
    isGlobal
    kind
    requiredTier
  }
}
    `;
export type CreateComplianceMetricMutationFn = Apollo.MutationFunction<CreateComplianceMetricMutation, CreateComplianceMetricMutationVariables>;

/**
 * __useCreateComplianceMetricMutation__
 *
 * To run a mutation, you first call `useCreateComplianceMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceMetricMutation, { data, loading, error }] = useCreateComplianceMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplianceMetricMutation(baseOptions?: Apollo.MutationHookOptions<CreateComplianceMetricMutation, CreateComplianceMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComplianceMetricMutation, CreateComplianceMetricMutationVariables>(CreateComplianceMetricDocument, options);
      }
export type CreateComplianceMetricMutationHookResult = ReturnType<typeof useCreateComplianceMetricMutation>;
export type CreateComplianceMetricMutationResult = Apollo.MutationResult<CreateComplianceMetricMutation>;
export type CreateComplianceMetricMutationOptions = Apollo.BaseMutationOptions<CreateComplianceMetricMutation, CreateComplianceMetricMutationVariables>;
export const ComplianceLayersDocument = gql`
    query ComplianceLayers($scenarioId: ID, $asOf: DateTime) {
  complianceOverview(scenarioId: $scenarioId, asOf: $asOf) {
    organizationId
    scenarioId
    isScenarioProjection
    viewerTier
    asOf
    domesticRegimeState
    isCalendarConfigured
    layers {
      layer
      evaluations {
        ruleId
        ruleName
        regimeName
        regimeKey
        ruleFamily
        metricId
        metricName
        layer
        state
        value
        threshold
        amberThreshold
        deviation
        unit
        comparator
        window
        isWindowComplete
        partialReasons
        missingInputs
        warnOnly
        unverifiableFigures
        knownFigures {
          label
          value
          unit
          isLowerBound
        }
        completeness
        excludedInputs {
          quantity
          subjectCount
        }
        denominatorSource
        showKpi
        missingPeriods {
          periodStart
          periodEnd
        }
        consequence
        computedFix {
          availability
          clearsRule
          direction
          isTargetExclusive
          requiredChange
          targetValue
          unit
          reasons
          numeratorUnavailableReason
          numeratorChange {
            label
            direction
            currentValue
            requiredChange
            targetValue
            unit
          }
          saleOffset {
            label
            direction
            capitalGain
            unit
          }
        }
        drivers {
          subjectId
          label
          value
          unit
          sharePercent
        }
        trend {
          hasHistory
        }
      }
    }
  }
}
    `;

/**
 * __useComplianceLayersQuery__
 *
 * To run a query within a React component, call `useComplianceLayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceLayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceLayersQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      asOf: // value for 'asOf'
 *   },
 * });
 */
export function useComplianceLayersQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceLayersQuery, ComplianceLayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceLayersQuery, ComplianceLayersQueryVariables>(ComplianceLayersDocument, options);
      }
export function useComplianceLayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceLayersQuery, ComplianceLayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceLayersQuery, ComplianceLayersQueryVariables>(ComplianceLayersDocument, options);
        }
// @ts-ignore
export function useComplianceLayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplianceLayersQuery, ComplianceLayersQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceLayersQuery, ComplianceLayersQueryVariables>;
export function useComplianceLayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceLayersQuery, ComplianceLayersQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceLayersQuery | undefined, ComplianceLayersQueryVariables>;
export function useComplianceLayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceLayersQuery, ComplianceLayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceLayersQuery, ComplianceLayersQueryVariables>(ComplianceLayersDocument, options);
        }
export type ComplianceLayersQueryHookResult = ReturnType<typeof useComplianceLayersQuery>;
export type ComplianceLayersLazyQueryHookResult = ReturnType<typeof useComplianceLayersLazyQuery>;
export type ComplianceLayersSuspenseQueryHookResult = ReturnType<typeof useComplianceLayersSuspenseQuery>;
export type ComplianceLayersQueryResult = Apollo.QueryResult<ComplianceLayersQuery, ComplianceLayersQueryVariables>;
export const ComplianceForeignPlayerCountDocument = gql`
    query ComplianceForeignPlayerCount($scenarioId: ID) {
  complianceOverview(scenarioId: $scenarioId) {
    organizationId
    scenarioId
    foreignPlayerCount {
      clubCountry
      foreignCount
      domesticCount
      hasAnyInput
      breakdown {
        subjectId
        label
        nationalityName
        isForeign
      }
    }
  }
}
    `;

/**
 * __useComplianceForeignPlayerCountQuery__
 *
 * To run a query within a React component, call `useComplianceForeignPlayerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceForeignPlayerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceForeignPlayerCountQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useComplianceForeignPlayerCountQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>(ComplianceForeignPlayerCountDocument, options);
      }
export function useComplianceForeignPlayerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>(ComplianceForeignPlayerCountDocument, options);
        }
// @ts-ignore
export function useComplianceForeignPlayerCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>;
export function useComplianceForeignPlayerCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceForeignPlayerCountQuery | undefined, ComplianceForeignPlayerCountQueryVariables>;
export function useComplianceForeignPlayerCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>(ComplianceForeignPlayerCountDocument, options);
        }
export type ComplianceForeignPlayerCountQueryHookResult = ReturnType<typeof useComplianceForeignPlayerCountQuery>;
export type ComplianceForeignPlayerCountLazyQueryHookResult = ReturnType<typeof useComplianceForeignPlayerCountLazyQuery>;
export type ComplianceForeignPlayerCountSuspenseQueryHookResult = ReturnType<typeof useComplianceForeignPlayerCountSuspenseQuery>;
export type ComplianceForeignPlayerCountQueryResult = Apollo.QueryResult<ComplianceForeignPlayerCountQuery, ComplianceForeignPlayerCountQueryVariables>;
export const PsrClubCalendarDocument = gql`
    query PsrClubCalendar {
  complianceClubCalendar {
    id
    fiscalYearStartMonth
  }
}
    `;

/**
 * __usePsrClubCalendarQuery__
 *
 * To run a query within a React component, call `usePsrClubCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePsrClubCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePsrClubCalendarQuery({
 *   variables: {
 *   },
 * });
 */
export function usePsrClubCalendarQuery(baseOptions?: Apollo.QueryHookOptions<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>(PsrClubCalendarDocument, options);
      }
export function usePsrClubCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>(PsrClubCalendarDocument, options);
        }
// @ts-ignore
export function usePsrClubCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>;
export function usePsrClubCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<PsrClubCalendarQuery | undefined, PsrClubCalendarQueryVariables>;
export function usePsrClubCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>(PsrClubCalendarDocument, options);
        }
export type PsrClubCalendarQueryHookResult = ReturnType<typeof usePsrClubCalendarQuery>;
export type PsrClubCalendarLazyQueryHookResult = ReturnType<typeof usePsrClubCalendarLazyQuery>;
export type PsrClubCalendarSuspenseQueryHookResult = ReturnType<typeof usePsrClubCalendarSuspenseQuery>;
export type PsrClubCalendarQueryResult = Apollo.QueryResult<PsrClubCalendarQuery, PsrClubCalendarQueryVariables>;
export const PsrEnteredFiguresDocument = gql`
    query PsrEnteredFigures($from: String, $to: String) {
  complianceFinancialFigures(
    quantity: ADJUSTED_RESULT_ROLLING_THREE_YEARS
    from: $from
    to: $to
  ) {
    id
    effectiveFrom
    recordedAt
    amount
    restatesId
    restatementNote
  }
}
    `;

/**
 * __usePsrEnteredFiguresQuery__
 *
 * To run a query within a React component, call `usePsrEnteredFiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `usePsrEnteredFiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePsrEnteredFiguresQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function usePsrEnteredFiguresQuery(baseOptions?: Apollo.QueryHookOptions<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>(PsrEnteredFiguresDocument, options);
      }
export function usePsrEnteredFiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>(PsrEnteredFiguresDocument, options);
        }
// @ts-ignore
export function usePsrEnteredFiguresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>): Apollo.UseSuspenseQueryResult<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>;
export function usePsrEnteredFiguresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>): Apollo.UseSuspenseQueryResult<PsrEnteredFiguresQuery | undefined, PsrEnteredFiguresQueryVariables>;
export function usePsrEnteredFiguresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>(PsrEnteredFiguresDocument, options);
        }
export type PsrEnteredFiguresQueryHookResult = ReturnType<typeof usePsrEnteredFiguresQuery>;
export type PsrEnteredFiguresLazyQueryHookResult = ReturnType<typeof usePsrEnteredFiguresLazyQuery>;
export type PsrEnteredFiguresSuspenseQueryHookResult = ReturnType<typeof usePsrEnteredFiguresSuspenseQuery>;
export type PsrEnteredFiguresQueryResult = Apollo.QueryResult<PsrEnteredFiguresQuery, PsrEnteredFiguresQueryVariables>;
export const AdjustedRevenueEnteredFiguresDocument = gql`
    query AdjustedRevenueEnteredFigures($to: String) {
  complianceFinancialFigures(quantity: ADJUSTED_REVENUE, to: $to) {
    id
    effectiveFrom
    amount
    restatesId
    restatementNote
  }
}
    `;

/**
 * __useAdjustedRevenueEnteredFiguresQuery__
 *
 * To run a query within a React component, call `useAdjustedRevenueEnteredFiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdjustedRevenueEnteredFiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdjustedRevenueEnteredFiguresQuery({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAdjustedRevenueEnteredFiguresQuery(baseOptions?: Apollo.QueryHookOptions<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>(AdjustedRevenueEnteredFiguresDocument, options);
      }
export function useAdjustedRevenueEnteredFiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>(AdjustedRevenueEnteredFiguresDocument, options);
        }
// @ts-ignore
export function useAdjustedRevenueEnteredFiguresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>): Apollo.UseSuspenseQueryResult<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>;
export function useAdjustedRevenueEnteredFiguresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>): Apollo.UseSuspenseQueryResult<AdjustedRevenueEnteredFiguresQuery | undefined, AdjustedRevenueEnteredFiguresQueryVariables>;
export function useAdjustedRevenueEnteredFiguresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>(AdjustedRevenueEnteredFiguresDocument, options);
        }
export type AdjustedRevenueEnteredFiguresQueryHookResult = ReturnType<typeof useAdjustedRevenueEnteredFiguresQuery>;
export type AdjustedRevenueEnteredFiguresLazyQueryHookResult = ReturnType<typeof useAdjustedRevenueEnteredFiguresLazyQuery>;
export type AdjustedRevenueEnteredFiguresSuspenseQueryHookResult = ReturnType<typeof useAdjustedRevenueEnteredFiguresSuspenseQuery>;
export type AdjustedRevenueEnteredFiguresQueryResult = Apollo.QueryResult<AdjustedRevenueEnteredFiguresQuery, AdjustedRevenueEnteredFiguresQueryVariables>;
export const LeagueTwoScmpEnteredFiguresDocument = gql`
    query LeagueTwoScmpEnteredFigures($to: String) {
  relevantTurnover: complianceFinancialFigures(quantity: RELEVANT_TURNOVER, to: $to) {
    id
    effectiveFrom
    amount
  }
  allowablePmTradingIncome: complianceFinancialFigures(quantity: ALLOWABLE_PM_TRADING_INCOME, to: $to) {
    id
    effectiveFrom
    amount
  }
  equityInjectionReceivedAnnual: complianceFinancialFigures(quantity: EQUITY_INJECTION_RECEIVED_ANNUAL, to: $to) {
    id
    effectiveFrom
    amount
  }
  managerSalaryAnnual: complianceFinancialFigures(quantity: MANAGER_SALARY_ANNUAL, to: $to) {
    id
    effectiveFrom
    amount
  }
  agentsFeesPayableAnnual: complianceFinancialFigures(quantity: AGENTS_FEES_PAYABLE_ANNUAL, to: $to) {
    id
    effectiveFrom
    amount
  }
  nonEstablishedU21PlayerCostAnnual: complianceFinancialFigures(quantity: NON_ESTABLISHED_U21_PLAYER_COST_ANNUAL, to: $to) {
    id
    effectiveFrom
    amount
  }
}
    `;

/**
 * __useLeagueTwoScmpEnteredFiguresQuery__
 *
 * To run a query within a React component, call `useLeagueTwoScmpEnteredFiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueTwoScmpEnteredFiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueTwoScmpEnteredFiguresQuery({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useLeagueTwoScmpEnteredFiguresQuery(baseOptions?: Apollo.QueryHookOptions<LeagueTwoScmpEnteredFiguresQuery, LeagueTwoScmpEnteredFiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueTwoScmpEnteredFiguresQuery, LeagueTwoScmpEnteredFiguresQueryVariables>(LeagueTwoScmpEnteredFiguresDocument, options);
      }
export function useLeagueTwoScmpEnteredFiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueTwoScmpEnteredFiguresQuery, LeagueTwoScmpEnteredFiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueTwoScmpEnteredFiguresQuery, LeagueTwoScmpEnteredFiguresQueryVariables>(LeagueTwoScmpEnteredFiguresDocument, options);
        }
export type LeagueTwoScmpEnteredFiguresQueryHookResult = ReturnType<typeof useLeagueTwoScmpEnteredFiguresQuery>;
export type LeagueTwoScmpEnteredFiguresLazyQueryHookResult = ReturnType<typeof useLeagueTwoScmpEnteredFiguresLazyQuery>;
export type LeagueTwoScmpEnteredFiguresQueryResult = Apollo.QueryResult<LeagueTwoScmpEnteredFiguresQuery, LeagueTwoScmpEnteredFiguresQueryVariables>;
export const RecordComplianceFinancialFigureDocument = gql`
    mutation RecordComplianceFinancialFigure($input: RecordComplianceFinancialFigureInput!) {
  recordComplianceFinancialFigure(input: $input) {
    figure {
      id
      effectiveFrom
      amount
      restatesId
      restatementNote
    }
    effectiveFigure {
      id
      effectiveFrom
      amount
      restatesId
      restatementNote
    }
    isRestatement
    restatedAt
    effectiveRestatementNote
  }
}
    `;
export type RecordComplianceFinancialFigureMutationFn = Apollo.MutationFunction<RecordComplianceFinancialFigureMutation, RecordComplianceFinancialFigureMutationVariables>;

/**
 * __useRecordComplianceFinancialFigureMutation__
 *
 * To run a mutation, you first call `useRecordComplianceFinancialFigureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordComplianceFinancialFigureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordComplianceFinancialFigureMutation, { data, loading, error }] = useRecordComplianceFinancialFigureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordComplianceFinancialFigureMutation(baseOptions?: Apollo.MutationHookOptions<RecordComplianceFinancialFigureMutation, RecordComplianceFinancialFigureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordComplianceFinancialFigureMutation, RecordComplianceFinancialFigureMutationVariables>(RecordComplianceFinancialFigureDocument, options);
      }
export type RecordComplianceFinancialFigureMutationHookResult = ReturnType<typeof useRecordComplianceFinancialFigureMutation>;
export type RecordComplianceFinancialFigureMutationResult = Apollo.MutationResult<RecordComplianceFinancialFigureMutation>;
export type RecordComplianceFinancialFigureMutationOptions = Apollo.BaseMutationOptions<RecordComplianceFinancialFigureMutation, RecordComplianceFinancialFigureMutationVariables>;
export const UpdateRegimeRuleTargetDocument = gql`
    mutation UpdateRegimeRuleTarget($input: UpdateRegimeRuleTargetInput!) {
  updateRegimeRuleTarget(input: $input) {
    id
    organizationId
    ruleId
    comparator
    threshold
    amberThreshold
    showKpi
  }
}
    `;
export type UpdateRegimeRuleTargetMutationFn = Apollo.MutationFunction<UpdateRegimeRuleTargetMutation, UpdateRegimeRuleTargetMutationVariables>;

/**
 * __useUpdateRegimeRuleTargetMutation__
 *
 * To run a mutation, you first call `useUpdateRegimeRuleTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegimeRuleTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegimeRuleTargetMutation, { data, loading, error }] = useUpdateRegimeRuleTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegimeRuleTargetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegimeRuleTargetMutation, UpdateRegimeRuleTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegimeRuleTargetMutation, UpdateRegimeRuleTargetMutationVariables>(UpdateRegimeRuleTargetDocument, options);
      }
export type UpdateRegimeRuleTargetMutationHookResult = ReturnType<typeof useUpdateRegimeRuleTargetMutation>;
export type UpdateRegimeRuleTargetMutationResult = Apollo.MutationResult<UpdateRegimeRuleTargetMutation>;
export type UpdateRegimeRuleTargetMutationOptions = Apollo.BaseMutationOptions<UpdateRegimeRuleTargetMutation, UpdateRegimeRuleTargetMutationVariables>;
export const UpdateKpiTargetDocument = gql`
    mutation UpdateKpiTarget($input: UpdateKpiTargetInput!) {
  updateKpiTarget(input: $input) {
    id
    organizationId
    name
    metricId
    metricName
    category
    comparator
    threshold
    amberThreshold
    assessmentWindow
    showKpi
    isEnabled
  }
}
    `;
export type UpdateKpiTargetMutationFn = Apollo.MutationFunction<UpdateKpiTargetMutation, UpdateKpiTargetMutationVariables>;

/**
 * __useUpdateKpiTargetMutation__
 *
 * To run a mutation, you first call `useUpdateKpiTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKpiTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKpiTargetMutation, { data, loading, error }] = useUpdateKpiTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKpiTargetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKpiTargetMutation, UpdateKpiTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKpiTargetMutation, UpdateKpiTargetMutationVariables>(UpdateKpiTargetDocument, options);
      }
export type UpdateKpiTargetMutationHookResult = ReturnType<typeof useUpdateKpiTargetMutation>;
export type UpdateKpiTargetMutationResult = Apollo.MutationResult<UpdateKpiTargetMutation>;
export type UpdateKpiTargetMutationOptions = Apollo.BaseMutationOptions<UpdateKpiTargetMutation, UpdateKpiTargetMutationVariables>;
export const ComplianceDraftEvaluationDocument = gql`
    query ComplianceDraftEvaluation($scenarioId: ID, $draftActions: [ScenarioActionInput!]) {
  complianceOverview(scenarioId: $scenarioId, draftActions: $draftActions) {
    organizationId
    scenarioId
    viewerTier
    permittedQuantities
    layers {
      layer
      evaluations {
        ruleId
        ruleName
        metricName
        layer
        state
        value
        threshold
        unit
        comparator
        partialReasons
        unverifiableFigures
        showKpi
      }
    }
  }
}
    `;

/**
 * __useComplianceDraftEvaluationQuery__
 *
 * To run a query within a React component, call `useComplianceDraftEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceDraftEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceDraftEvaluationQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      draftActions: // value for 'draftActions'
 *   },
 * });
 */
export function useComplianceDraftEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>(ComplianceDraftEvaluationDocument, options);
      }
export function useComplianceDraftEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>(ComplianceDraftEvaluationDocument, options);
        }
// @ts-ignore
export function useComplianceDraftEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>;
export function useComplianceDraftEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<ComplianceDraftEvaluationQuery | undefined, ComplianceDraftEvaluationQueryVariables>;
export function useComplianceDraftEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>(ComplianceDraftEvaluationDocument, options);
        }
export type ComplianceDraftEvaluationQueryHookResult = ReturnType<typeof useComplianceDraftEvaluationQuery>;
export type ComplianceDraftEvaluationLazyQueryHookResult = ReturnType<typeof useComplianceDraftEvaluationLazyQuery>;
export type ComplianceDraftEvaluationSuspenseQueryHookResult = ReturnType<typeof useComplianceDraftEvaluationSuspenseQuery>;
export type ComplianceDraftEvaluationQueryResult = Apollo.QueryResult<ComplianceDraftEvaluationQuery, ComplianceDraftEvaluationQueryVariables>;
export const FixturePlanningMatchesDocument = gql`
    query FixturePlanningMatches($filter: MatchFilterInput!, $first: Int, $after: String) {
  listMatches(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...FixturePlanningMatch
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FixturePlanningMatchFragmentDoc}`;

/**
 * __useFixturePlanningMatchesQuery__
 *
 * To run a query within a React component, call `useFixturePlanningMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixturePlanningMatchesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFixturePlanningMatchesQuery(baseOptions: Apollo.QueryHookOptions<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables> & ({ variables: FixturePlanningMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>(FixturePlanningMatchesDocument, options);
      }
export function useFixturePlanningMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>(FixturePlanningMatchesDocument, options);
        }
// @ts-ignore
export function useFixturePlanningMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>;
export function useFixturePlanningMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningMatchesQuery | undefined, FixturePlanningMatchesQueryVariables>;
export function useFixturePlanningMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>(FixturePlanningMatchesDocument, options);
        }
export type FixturePlanningMatchesQueryHookResult = ReturnType<typeof useFixturePlanningMatchesQuery>;
export type FixturePlanningMatchesLazyQueryHookResult = ReturnType<typeof useFixturePlanningMatchesLazyQuery>;
export type FixturePlanningMatchesSuspenseQueryHookResult = ReturnType<typeof useFixturePlanningMatchesSuspenseQuery>;
export type FixturePlanningMatchesQueryResult = Apollo.QueryResult<FixturePlanningMatchesQuery, FixturePlanningMatchesQueryVariables>;
export const FixturePlanningAssignmentsDocument = gql`
    query FixturePlanningAssignments($filter: AssignmentFilterInput!, $first: Int, $after: String) {
  listAssignments(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        status
        scheduledThing {
          scheduledThingId
        }
        assigneeUser {
          id
          displayName
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFixturePlanningAssignmentsQuery__
 *
 * To run a query within a React component, call `useFixturePlanningAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixturePlanningAssignmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFixturePlanningAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables> & ({ variables: FixturePlanningAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>(FixturePlanningAssignmentsDocument, options);
      }
export function useFixturePlanningAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>(FixturePlanningAssignmentsDocument, options);
        }
// @ts-ignore
export function useFixturePlanningAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>;
export function useFixturePlanningAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningAssignmentsQuery | undefined, FixturePlanningAssignmentsQueryVariables>;
export function useFixturePlanningAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>(FixturePlanningAssignmentsDocument, options);
        }
export type FixturePlanningAssignmentsQueryHookResult = ReturnType<typeof useFixturePlanningAssignmentsQuery>;
export type FixturePlanningAssignmentsLazyQueryHookResult = ReturnType<typeof useFixturePlanningAssignmentsLazyQuery>;
export type FixturePlanningAssignmentsSuspenseQueryHookResult = ReturnType<typeof useFixturePlanningAssignmentsSuspenseQuery>;
export type FixturePlanningAssignmentsQueryResult = Apollo.QueryResult<FixturePlanningAssignmentsQuery, FixturePlanningAssignmentsQueryVariables>;
export const FixturePlanningAssignableScoutsDocument = gql`
    query FixturePlanningAssignableScouts($input: ListAssignableScoutsInput) {
  listAssignableScouts(input: $input) {
    id
    displayName
    title
    sameDayAssignmentCount
  }
}
    `;

/**
 * __useFixturePlanningAssignableScoutsQuery__
 *
 * To run a query within a React component, call `useFixturePlanningAssignableScoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningAssignableScoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixturePlanningAssignableScoutsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFixturePlanningAssignableScoutsQuery(baseOptions?: Apollo.QueryHookOptions<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>(FixturePlanningAssignableScoutsDocument, options);
      }
export function useFixturePlanningAssignableScoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>(FixturePlanningAssignableScoutsDocument, options);
        }
// @ts-ignore
export function useFixturePlanningAssignableScoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>;
export function useFixturePlanningAssignableScoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningAssignableScoutsQuery | undefined, FixturePlanningAssignableScoutsQueryVariables>;
export function useFixturePlanningAssignableScoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>(FixturePlanningAssignableScoutsDocument, options);
        }
export type FixturePlanningAssignableScoutsQueryHookResult = ReturnType<typeof useFixturePlanningAssignableScoutsQuery>;
export type FixturePlanningAssignableScoutsLazyQueryHookResult = ReturnType<typeof useFixturePlanningAssignableScoutsLazyQuery>;
export type FixturePlanningAssignableScoutsSuspenseQueryHookResult = ReturnType<typeof useFixturePlanningAssignableScoutsSuspenseQuery>;
export type FixturePlanningAssignableScoutsQueryResult = Apollo.QueryResult<FixturePlanningAssignableScoutsQuery, FixturePlanningAssignableScoutsQueryVariables>;
export const FixturePlanningLeaguesDocument = gql`
    query FixturePlanningLeagues($search: String, $first: Int) {
  listLeagues(search: $search, first: $first) {
    edges {
      node {
        id
        name
        country
        gender
      }
    }
  }
}
    `;

/**
 * __useFixturePlanningLeaguesQuery__
 *
 * To run a query within a React component, call `useFixturePlanningLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixturePlanningLeaguesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFixturePlanningLeaguesQuery(baseOptions?: Apollo.QueryHookOptions<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>(FixturePlanningLeaguesDocument, options);
      }
export function useFixturePlanningLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>(FixturePlanningLeaguesDocument, options);
        }
// @ts-ignore
export function useFixturePlanningLeaguesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>;
export function useFixturePlanningLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningLeaguesQuery | undefined, FixturePlanningLeaguesQueryVariables>;
export function useFixturePlanningLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>(FixturePlanningLeaguesDocument, options);
        }
export type FixturePlanningLeaguesQueryHookResult = ReturnType<typeof useFixturePlanningLeaguesQuery>;
export type FixturePlanningLeaguesLazyQueryHookResult = ReturnType<typeof useFixturePlanningLeaguesLazyQuery>;
export type FixturePlanningLeaguesSuspenseQueryHookResult = ReturnType<typeof useFixturePlanningLeaguesSuspenseQuery>;
export type FixturePlanningLeaguesQueryResult = Apollo.QueryResult<FixturePlanningLeaguesQuery, FixturePlanningLeaguesQueryVariables>;
export const FixturePlanningSearchTeamsDocument = gql`
    query FixturePlanningSearchTeams($search: String!, $first: Int) {
  searchTeams(search: $search, first: $first) {
    edges {
      node {
        id
        name
        gender
        league {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFixturePlanningSearchTeamsQuery__
 *
 * To run a query within a React component, call `useFixturePlanningSearchTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningSearchTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixturePlanningSearchTeamsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFixturePlanningSearchTeamsQuery(baseOptions: Apollo.QueryHookOptions<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables> & ({ variables: FixturePlanningSearchTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>(FixturePlanningSearchTeamsDocument, options);
      }
export function useFixturePlanningSearchTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>(FixturePlanningSearchTeamsDocument, options);
        }
// @ts-ignore
export function useFixturePlanningSearchTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>;
export function useFixturePlanningSearchTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningSearchTeamsQuery | undefined, FixturePlanningSearchTeamsQueryVariables>;
export function useFixturePlanningSearchTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>(FixturePlanningSearchTeamsDocument, options);
        }
export type FixturePlanningSearchTeamsQueryHookResult = ReturnType<typeof useFixturePlanningSearchTeamsQuery>;
export type FixturePlanningSearchTeamsLazyQueryHookResult = ReturnType<typeof useFixturePlanningSearchTeamsLazyQuery>;
export type FixturePlanningSearchTeamsSuspenseQueryHookResult = ReturnType<typeof useFixturePlanningSearchTeamsSuspenseQuery>;
export type FixturePlanningSearchTeamsQueryResult = Apollo.QueryResult<FixturePlanningSearchTeamsQuery, FixturePlanningSearchTeamsQueryVariables>;
export const FixturePlanningCreateMatchDocument = gql`
    mutation FixturePlanningCreateMatch($input: CreateMatchInput!) {
  createMatch(input: $input) {
    ...FixturePlanningMatch
  }
}
    ${FixturePlanningMatchFragmentDoc}`;
export type FixturePlanningCreateMatchMutationFn = Apollo.MutationFunction<FixturePlanningCreateMatchMutation, FixturePlanningCreateMatchMutationVariables>;

/**
 * __useFixturePlanningCreateMatchMutation__
 *
 * To run a mutation, you first call `useFixturePlanningCreateMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningCreateMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fixturePlanningCreateMatchMutation, { data, loading, error }] = useFixturePlanningCreateMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFixturePlanningCreateMatchMutation(baseOptions?: Apollo.MutationHookOptions<FixturePlanningCreateMatchMutation, FixturePlanningCreateMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FixturePlanningCreateMatchMutation, FixturePlanningCreateMatchMutationVariables>(FixturePlanningCreateMatchDocument, options);
      }
export type FixturePlanningCreateMatchMutationHookResult = ReturnType<typeof useFixturePlanningCreateMatchMutation>;
export type FixturePlanningCreateMatchMutationResult = Apollo.MutationResult<FixturePlanningCreateMatchMutation>;
export type FixturePlanningCreateMatchMutationOptions = Apollo.BaseMutationOptions<FixturePlanningCreateMatchMutation, FixturePlanningCreateMatchMutationVariables>;
export const FixturePlanningCreateTeamDocument = gql`
    mutation FixturePlanningCreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    id
    name
    gender
    league {
      id
      name
    }
  }
}
    `;
export type FixturePlanningCreateTeamMutationFn = Apollo.MutationFunction<FixturePlanningCreateTeamMutation, FixturePlanningCreateTeamMutationVariables>;

/**
 * __useFixturePlanningCreateTeamMutation__
 *
 * To run a mutation, you first call `useFixturePlanningCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fixturePlanningCreateTeamMutation, { data, loading, error }] = useFixturePlanningCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFixturePlanningCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<FixturePlanningCreateTeamMutation, FixturePlanningCreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FixturePlanningCreateTeamMutation, FixturePlanningCreateTeamMutationVariables>(FixturePlanningCreateTeamDocument, options);
      }
export type FixturePlanningCreateTeamMutationHookResult = ReturnType<typeof useFixturePlanningCreateTeamMutation>;
export type FixturePlanningCreateTeamMutationResult = Apollo.MutationResult<FixturePlanningCreateTeamMutation>;
export type FixturePlanningCreateTeamMutationOptions = Apollo.BaseMutationOptions<FixturePlanningCreateTeamMutation, FixturePlanningCreateTeamMutationVariables>;
export const FixturePlanningSetAssignmentsDocument = gql`
    mutation FixturePlanningSetAssignments($input: SetMatchAssignmentsInput!) {
  setMatchAssignments(input: $input) {
    id
    scheduledThingId
  }
}
    `;
export type FixturePlanningSetAssignmentsMutationFn = Apollo.MutationFunction<FixturePlanningSetAssignmentsMutation, FixturePlanningSetAssignmentsMutationVariables>;

/**
 * __useFixturePlanningSetAssignmentsMutation__
 *
 * To run a mutation, you first call `useFixturePlanningSetAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningSetAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fixturePlanningSetAssignmentsMutation, { data, loading, error }] = useFixturePlanningSetAssignmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFixturePlanningSetAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<FixturePlanningSetAssignmentsMutation, FixturePlanningSetAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FixturePlanningSetAssignmentsMutation, FixturePlanningSetAssignmentsMutationVariables>(FixturePlanningSetAssignmentsDocument, options);
      }
export type FixturePlanningSetAssignmentsMutationHookResult = ReturnType<typeof useFixturePlanningSetAssignmentsMutation>;
export type FixturePlanningSetAssignmentsMutationResult = Apollo.MutationResult<FixturePlanningSetAssignmentsMutation>;
export type FixturePlanningSetAssignmentsMutationOptions = Apollo.BaseMutationOptions<FixturePlanningSetAssignmentsMutation, FixturePlanningSetAssignmentsMutationVariables>;
export const FixturePlanningMyReportsDocument = gql`
    query FixturePlanningMyReports($filter: MatchReportFilterInput!, $first: Int, $after: String) {
  listMatchReports(filter: $filter, first: $first, after: $after) {
    edges {
      node {
        id
        submittedAt
        notedCount
        match {
          id
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFixturePlanningMyReportsQuery__
 *
 * To run a query within a React component, call `useFixturePlanningMyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixturePlanningMyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixturePlanningMyReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFixturePlanningMyReportsQuery(baseOptions: Apollo.QueryHookOptions<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables> & ({ variables: FixturePlanningMyReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>(FixturePlanningMyReportsDocument, options);
      }
export function useFixturePlanningMyReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>(FixturePlanningMyReportsDocument, options);
        }
// @ts-ignore
export function useFixturePlanningMyReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>;
export function useFixturePlanningMyReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>): Apollo.UseSuspenseQueryResult<FixturePlanningMyReportsQuery | undefined, FixturePlanningMyReportsQueryVariables>;
export function useFixturePlanningMyReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>(FixturePlanningMyReportsDocument, options);
        }
export type FixturePlanningMyReportsQueryHookResult = ReturnType<typeof useFixturePlanningMyReportsQuery>;
export type FixturePlanningMyReportsLazyQueryHookResult = ReturnType<typeof useFixturePlanningMyReportsLazyQuery>;
export type FixturePlanningMyReportsSuspenseQueryHookResult = ReturnType<typeof useFixturePlanningMyReportsSuspenseQuery>;
export type FixturePlanningMyReportsQueryResult = Apollo.QueryResult<FixturePlanningMyReportsQuery, FixturePlanningMyReportsQueryVariables>;
export const HomeGetScoutingWidgetSummaryDocument = gql`
    query HomeGetScoutingWidgetSummary {
  getScoutingWidgetSummary {
    totalWatchlistPlayers
    withoutReportCount
    noAction30DaysCount
  }
}
    `;

/**
 * __useHomeGetScoutingWidgetSummaryQuery__
 *
 * To run a query within a React component, call `useHomeGetScoutingWidgetSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeGetScoutingWidgetSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeGetScoutingWidgetSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeGetScoutingWidgetSummaryQuery(baseOptions?: Apollo.QueryHookOptions<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>(HomeGetScoutingWidgetSummaryDocument, options);
      }
export function useHomeGetScoutingWidgetSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>(HomeGetScoutingWidgetSummaryDocument, options);
        }
// @ts-ignore
export function useHomeGetScoutingWidgetSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>;
export function useHomeGetScoutingWidgetSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetScoutingWidgetSummaryQuery | undefined, HomeGetScoutingWidgetSummaryQueryVariables>;
export function useHomeGetScoutingWidgetSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>(HomeGetScoutingWidgetSummaryDocument, options);
        }
export type HomeGetScoutingWidgetSummaryQueryHookResult = ReturnType<typeof useHomeGetScoutingWidgetSummaryQuery>;
export type HomeGetScoutingWidgetSummaryLazyQueryHookResult = ReturnType<typeof useHomeGetScoutingWidgetSummaryLazyQuery>;
export type HomeGetScoutingWidgetSummarySuspenseQueryHookResult = ReturnType<typeof useHomeGetScoutingWidgetSummarySuspenseQuery>;
export type HomeGetScoutingWidgetSummaryQueryResult = Apollo.QueryResult<HomeGetScoutingWidgetSummaryQuery, HomeGetScoutingWidgetSummaryQueryVariables>;
export const HomeListTargetsWithoutReportDocument = gql`
    query HomeListTargetsWithoutReport {
  listTargetsWithoutReport {
    playerId
    name
    primaryPosition
    teamName
    watchlistName
  }
}
    `;

/**
 * __useHomeListTargetsWithoutReportQuery__
 *
 * To run a query within a React component, call `useHomeListTargetsWithoutReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListTargetsWithoutReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListTargetsWithoutReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeListTargetsWithoutReportQuery(baseOptions?: Apollo.QueryHookOptions<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>(HomeListTargetsWithoutReportDocument, options);
      }
export function useHomeListTargetsWithoutReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>(HomeListTargetsWithoutReportDocument, options);
        }
// @ts-ignore
export function useHomeListTargetsWithoutReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>;
export function useHomeListTargetsWithoutReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListTargetsWithoutReportQuery | undefined, HomeListTargetsWithoutReportQueryVariables>;
export function useHomeListTargetsWithoutReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>(HomeListTargetsWithoutReportDocument, options);
        }
export type HomeListTargetsWithoutReportQueryHookResult = ReturnType<typeof useHomeListTargetsWithoutReportQuery>;
export type HomeListTargetsWithoutReportLazyQueryHookResult = ReturnType<typeof useHomeListTargetsWithoutReportLazyQuery>;
export type HomeListTargetsWithoutReportSuspenseQueryHookResult = ReturnType<typeof useHomeListTargetsWithoutReportSuspenseQuery>;
export type HomeListTargetsWithoutReportQueryResult = Apollo.QueryResult<HomeListTargetsWithoutReportQuery, HomeListTargetsWithoutReportQueryVariables>;
export const HomeListTargetsNoAction30DaysDocument = gql`
    query HomeListTargetsNoAction30Days {
  listTargetsNoAction30Days {
    playerId
    name
    primaryPosition
    teamName
    watchlistName
    lastActionDate
    lastActionType
  }
}
    `;

/**
 * __useHomeListTargetsNoAction30DaysQuery__
 *
 * To run a query within a React component, call `useHomeListTargetsNoAction30DaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListTargetsNoAction30DaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListTargetsNoAction30DaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeListTargetsNoAction30DaysQuery(baseOptions?: Apollo.QueryHookOptions<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>(HomeListTargetsNoAction30DaysDocument, options);
      }
export function useHomeListTargetsNoAction30DaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>(HomeListTargetsNoAction30DaysDocument, options);
        }
// @ts-ignore
export function useHomeListTargetsNoAction30DaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>;
export function useHomeListTargetsNoAction30DaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListTargetsNoAction30DaysQuery | undefined, HomeListTargetsNoAction30DaysQueryVariables>;
export function useHomeListTargetsNoAction30DaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>(HomeListTargetsNoAction30DaysDocument, options);
        }
export type HomeListTargetsNoAction30DaysQueryHookResult = ReturnType<typeof useHomeListTargetsNoAction30DaysQuery>;
export type HomeListTargetsNoAction30DaysLazyQueryHookResult = ReturnType<typeof useHomeListTargetsNoAction30DaysLazyQuery>;
export type HomeListTargetsNoAction30DaysSuspenseQueryHookResult = ReturnType<typeof useHomeListTargetsNoAction30DaysSuspenseQuery>;
export type HomeListTargetsNoAction30DaysQueryResult = Apollo.QueryResult<HomeListTargetsNoAction30DaysQuery, HomeListTargetsNoAction30DaysQueryVariables>;
export const HomeGetSquadGprDistributionDocument = gql`
    query HomeGetSquadGprDistribution {
  getSquadGprDistribution {
    totalFirstTeamPlayers
    gpr80Plus
    gpr70to79
    gprBelow70
  }
}
    `;

/**
 * __useHomeGetSquadGprDistributionQuery__
 *
 * To run a query within a React component, call `useHomeGetSquadGprDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeGetSquadGprDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeGetSquadGprDistributionQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeGetSquadGprDistributionQuery(baseOptions?: Apollo.QueryHookOptions<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>(HomeGetSquadGprDistributionDocument, options);
      }
export function useHomeGetSquadGprDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>(HomeGetSquadGprDistributionDocument, options);
        }
// @ts-ignore
export function useHomeGetSquadGprDistributionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>;
export function useHomeGetSquadGprDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetSquadGprDistributionQuery | undefined, HomeGetSquadGprDistributionQueryVariables>;
export function useHomeGetSquadGprDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>(HomeGetSquadGprDistributionDocument, options);
        }
export type HomeGetSquadGprDistributionQueryHookResult = ReturnType<typeof useHomeGetSquadGprDistributionQuery>;
export type HomeGetSquadGprDistributionLazyQueryHookResult = ReturnType<typeof useHomeGetSquadGprDistributionLazyQuery>;
export type HomeGetSquadGprDistributionSuspenseQueryHookResult = ReturnType<typeof useHomeGetSquadGprDistributionSuspenseQuery>;
export type HomeGetSquadGprDistributionQueryResult = Apollo.QueryResult<HomeGetSquadGprDistributionQuery, HomeGetSquadGprDistributionQueryVariables>;
export const HomeListFirstTeamPlayersByGprBandDocument = gql`
    query HomeListFirstTeamPlayersByGprBand($band: GprBand!) {
  listFirstTeamPlayersByGprBand(band: $band) {
    playerId
    name
    primaryPosition
    teamName
    gpr
  }
}
    `;

/**
 * __useHomeListFirstTeamPlayersByGprBandQuery__
 *
 * To run a query within a React component, call `useHomeListFirstTeamPlayersByGprBandQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListFirstTeamPlayersByGprBandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListFirstTeamPlayersByGprBandQuery({
 *   variables: {
 *      band: // value for 'band'
 *   },
 * });
 */
export function useHomeListFirstTeamPlayersByGprBandQuery(baseOptions: Apollo.QueryHookOptions<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables> & ({ variables: HomeListFirstTeamPlayersByGprBandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>(HomeListFirstTeamPlayersByGprBandDocument, options);
      }
export function useHomeListFirstTeamPlayersByGprBandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>(HomeListFirstTeamPlayersByGprBandDocument, options);
        }
// @ts-ignore
export function useHomeListFirstTeamPlayersByGprBandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>;
export function useHomeListFirstTeamPlayersByGprBandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListFirstTeamPlayersByGprBandQuery | undefined, HomeListFirstTeamPlayersByGprBandQueryVariables>;
export function useHomeListFirstTeamPlayersByGprBandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>(HomeListFirstTeamPlayersByGprBandDocument, options);
        }
export type HomeListFirstTeamPlayersByGprBandQueryHookResult = ReturnType<typeof useHomeListFirstTeamPlayersByGprBandQuery>;
export type HomeListFirstTeamPlayersByGprBandLazyQueryHookResult = ReturnType<typeof useHomeListFirstTeamPlayersByGprBandLazyQuery>;
export type HomeListFirstTeamPlayersByGprBandSuspenseQueryHookResult = ReturnType<typeof useHomeListFirstTeamPlayersByGprBandSuspenseQuery>;
export type HomeListFirstTeamPlayersByGprBandQueryResult = Apollo.QueryResult<HomeListFirstTeamPlayersByGprBandQuery, HomeListFirstTeamPlayersByGprBandQueryVariables>;
export const HomeListInjuredRosterPlayersDocument = gql`
    query HomeListInjuredRosterPlayers {
  listInjuredRosterPlayers {
    playerId
    name
    primaryPosition
    injuryDate
    daysMissed
    injuryType
  }
}
    `;

/**
 * __useHomeListInjuredRosterPlayersQuery__
 *
 * To run a query within a React component, call `useHomeListInjuredRosterPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListInjuredRosterPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListInjuredRosterPlayersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeListInjuredRosterPlayersQuery(baseOptions?: Apollo.QueryHookOptions<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>(HomeListInjuredRosterPlayersDocument, options);
      }
export function useHomeListInjuredRosterPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>(HomeListInjuredRosterPlayersDocument, options);
        }
// @ts-ignore
export function useHomeListInjuredRosterPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>;
export function useHomeListInjuredRosterPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListInjuredRosterPlayersQuery | undefined, HomeListInjuredRosterPlayersQueryVariables>;
export function useHomeListInjuredRosterPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>(HomeListInjuredRosterPlayersDocument, options);
        }
export type HomeListInjuredRosterPlayersQueryHookResult = ReturnType<typeof useHomeListInjuredRosterPlayersQuery>;
export type HomeListInjuredRosterPlayersLazyQueryHookResult = ReturnType<typeof useHomeListInjuredRosterPlayersLazyQuery>;
export type HomeListInjuredRosterPlayersSuspenseQueryHookResult = ReturnType<typeof useHomeListInjuredRosterPlayersSuspenseQuery>;
export type HomeListInjuredRosterPlayersQueryResult = Apollo.QueryResult<HomeListInjuredRosterPlayersQuery, HomeListInjuredRosterPlayersQueryVariables>;
export const HomeListOnLoanPlayersDocument = gql`
    query HomeListOnLoanPlayers {
  listOnLoanPlayers {
    playerId
    name
    primaryPosition
    onLoanFrom
    contractExpires
  }
}
    `;

/**
 * __useHomeListOnLoanPlayersQuery__
 *
 * To run a query within a React component, call `useHomeListOnLoanPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListOnLoanPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListOnLoanPlayersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeListOnLoanPlayersQuery(baseOptions?: Apollo.QueryHookOptions<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>(HomeListOnLoanPlayersDocument, options);
      }
export function useHomeListOnLoanPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>(HomeListOnLoanPlayersDocument, options);
        }
// @ts-ignore
export function useHomeListOnLoanPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>;
export function useHomeListOnLoanPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListOnLoanPlayersQuery | undefined, HomeListOnLoanPlayersQueryVariables>;
export function useHomeListOnLoanPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>(HomeListOnLoanPlayersDocument, options);
        }
export type HomeListOnLoanPlayersQueryHookResult = ReturnType<typeof useHomeListOnLoanPlayersQuery>;
export type HomeListOnLoanPlayersLazyQueryHookResult = ReturnType<typeof useHomeListOnLoanPlayersLazyQuery>;
export type HomeListOnLoanPlayersSuspenseQueryHookResult = ReturnType<typeof useHomeListOnLoanPlayersSuspenseQuery>;
export type HomeListOnLoanPlayersQueryResult = Apollo.QueryResult<HomeListOnLoanPlayersQuery, HomeListOnLoanPlayersQueryVariables>;
export const HomeGetRosterExpiringContractsDocument = gql`
    query HomeGetRosterExpiringContracts {
  getRosterExpiringContracts {
    expiring6Months
    expiring12Months
  }
}
    `;

/**
 * __useHomeGetRosterExpiringContractsQuery__
 *
 * To run a query within a React component, call `useHomeGetRosterExpiringContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeGetRosterExpiringContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeGetRosterExpiringContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeGetRosterExpiringContractsQuery(baseOptions?: Apollo.QueryHookOptions<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>(HomeGetRosterExpiringContractsDocument, options);
      }
export function useHomeGetRosterExpiringContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>(HomeGetRosterExpiringContractsDocument, options);
        }
// @ts-ignore
export function useHomeGetRosterExpiringContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>;
export function useHomeGetRosterExpiringContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetRosterExpiringContractsQuery | undefined, HomeGetRosterExpiringContractsQueryVariables>;
export function useHomeGetRosterExpiringContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>(HomeGetRosterExpiringContractsDocument, options);
        }
export type HomeGetRosterExpiringContractsQueryHookResult = ReturnType<typeof useHomeGetRosterExpiringContractsQuery>;
export type HomeGetRosterExpiringContractsLazyQueryHookResult = ReturnType<typeof useHomeGetRosterExpiringContractsLazyQuery>;
export type HomeGetRosterExpiringContractsSuspenseQueryHookResult = ReturnType<typeof useHomeGetRosterExpiringContractsSuspenseQuery>;
export type HomeGetRosterExpiringContractsQueryResult = Apollo.QueryResult<HomeGetRosterExpiringContractsQuery, HomeGetRosterExpiringContractsQueryVariables>;
export const HomeListRosterExpiringContractsDocument = gql`
    query HomeListRosterExpiringContracts {
  listRosterExpiringContracts {
    playerId
    name
    primaryPosition
    teamName
    contractExpires
  }
}
    `;

/**
 * __useHomeListRosterExpiringContractsQuery__
 *
 * To run a query within a React component, call `useHomeListRosterExpiringContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListRosterExpiringContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListRosterExpiringContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeListRosterExpiringContractsQuery(baseOptions?: Apollo.QueryHookOptions<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>(HomeListRosterExpiringContractsDocument, options);
      }
export function useHomeListRosterExpiringContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>(HomeListRosterExpiringContractsDocument, options);
        }
// @ts-ignore
export function useHomeListRosterExpiringContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>;
export function useHomeListRosterExpiringContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListRosterExpiringContractsQuery | undefined, HomeListRosterExpiringContractsQueryVariables>;
export function useHomeListRosterExpiringContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>(HomeListRosterExpiringContractsDocument, options);
        }
export type HomeListRosterExpiringContractsQueryHookResult = ReturnType<typeof useHomeListRosterExpiringContractsQuery>;
export type HomeListRosterExpiringContractsLazyQueryHookResult = ReturnType<typeof useHomeListRosterExpiringContractsLazyQuery>;
export type HomeListRosterExpiringContractsSuspenseQueryHookResult = ReturnType<typeof useHomeListRosterExpiringContractsSuspenseQuery>;
export type HomeListRosterExpiringContractsQueryResult = Apollo.QueryResult<HomeListRosterExpiringContractsQuery, HomeListRosterExpiringContractsQueryVariables>;
export const HomeGetPositionalProfileCoverageDocument = gql`
    query HomeGetPositionalProfileCoverage {
  getPositionalProfileCoverage {
    profileName
    playerCount
  }
}
    `;

/**
 * __useHomeGetPositionalProfileCoverageQuery__
 *
 * To run a query within a React component, call `useHomeGetPositionalProfileCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeGetPositionalProfileCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeGetPositionalProfileCoverageQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeGetPositionalProfileCoverageQuery(baseOptions?: Apollo.QueryHookOptions<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>(HomeGetPositionalProfileCoverageDocument, options);
      }
export function useHomeGetPositionalProfileCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>(HomeGetPositionalProfileCoverageDocument, options);
        }
// @ts-ignore
export function useHomeGetPositionalProfileCoverageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>;
export function useHomeGetPositionalProfileCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetPositionalProfileCoverageQuery | undefined, HomeGetPositionalProfileCoverageQueryVariables>;
export function useHomeGetPositionalProfileCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>(HomeGetPositionalProfileCoverageDocument, options);
        }
export type HomeGetPositionalProfileCoverageQueryHookResult = ReturnType<typeof useHomeGetPositionalProfileCoverageQuery>;
export type HomeGetPositionalProfileCoverageLazyQueryHookResult = ReturnType<typeof useHomeGetPositionalProfileCoverageLazyQuery>;
export type HomeGetPositionalProfileCoverageSuspenseQueryHookResult = ReturnType<typeof useHomeGetPositionalProfileCoverageSuspenseQuery>;
export type HomeGetPositionalProfileCoverageQueryResult = Apollo.QueryResult<HomeGetPositionalProfileCoverageQuery, HomeGetPositionalProfileCoverageQueryVariables>;
export const HomeListTargetsByPositionalProfileDocument = gql`
    query HomeListTargetsByPositionalProfile($profileName: String!) {
  listTargetsByPositionalProfile(profileName: $profileName) {
    playerId
    name
    primaryPosition
    teamName
    watchlistName
  }
}
    `;

/**
 * __useHomeListTargetsByPositionalProfileQuery__
 *
 * To run a query within a React component, call `useHomeListTargetsByPositionalProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeListTargetsByPositionalProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeListTargetsByPositionalProfileQuery({
 *   variables: {
 *      profileName: // value for 'profileName'
 *   },
 * });
 */
export function useHomeListTargetsByPositionalProfileQuery(baseOptions: Apollo.QueryHookOptions<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables> & ({ variables: HomeListTargetsByPositionalProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>(HomeListTargetsByPositionalProfileDocument, options);
      }
export function useHomeListTargetsByPositionalProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>(HomeListTargetsByPositionalProfileDocument, options);
        }
// @ts-ignore
export function useHomeListTargetsByPositionalProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>;
export function useHomeListTargetsByPositionalProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>): Apollo.UseSuspenseQueryResult<HomeListTargetsByPositionalProfileQuery | undefined, HomeListTargetsByPositionalProfileQueryVariables>;
export function useHomeListTargetsByPositionalProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>(HomeListTargetsByPositionalProfileDocument, options);
        }
export type HomeListTargetsByPositionalProfileQueryHookResult = ReturnType<typeof useHomeListTargetsByPositionalProfileQuery>;
export type HomeListTargetsByPositionalProfileLazyQueryHookResult = ReturnType<typeof useHomeListTargetsByPositionalProfileLazyQuery>;
export type HomeListTargetsByPositionalProfileSuspenseQueryHookResult = ReturnType<typeof useHomeListTargetsByPositionalProfileSuspenseQuery>;
export type HomeListTargetsByPositionalProfileQueryResult = Apollo.QueryResult<HomeListTargetsByPositionalProfileQuery, HomeListTargetsByPositionalProfileQueryVariables>;
export const HomeGetLeagueGprSpectrumDocument = gql`
    query HomeGetLeagueGprSpectrum {
  getLeagueGprSpectrum {
    userClubGpr
    userClubRank
    lowestClubGpr
    highestClubGpr
    leagueAverageGpr
    totalClubs
  }
}
    `;

/**
 * __useHomeGetLeagueGprSpectrumQuery__
 *
 * To run a query within a React component, call `useHomeGetLeagueGprSpectrumQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeGetLeagueGprSpectrumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeGetLeagueGprSpectrumQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeGetLeagueGprSpectrumQuery(baseOptions?: Apollo.QueryHookOptions<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>(HomeGetLeagueGprSpectrumDocument, options);
      }
export function useHomeGetLeagueGprSpectrumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>(HomeGetLeagueGprSpectrumDocument, options);
        }
// @ts-ignore
export function useHomeGetLeagueGprSpectrumSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>;
export function useHomeGetLeagueGprSpectrumSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>): Apollo.UseSuspenseQueryResult<HomeGetLeagueGprSpectrumQuery | undefined, HomeGetLeagueGprSpectrumQueryVariables>;
export function useHomeGetLeagueGprSpectrumSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>(HomeGetLeagueGprSpectrumDocument, options);
        }
export type HomeGetLeagueGprSpectrumQueryHookResult = ReturnType<typeof useHomeGetLeagueGprSpectrumQuery>;
export type HomeGetLeagueGprSpectrumLazyQueryHookResult = ReturnType<typeof useHomeGetLeagueGprSpectrumLazyQuery>;
export type HomeGetLeagueGprSpectrumSuspenseQueryHookResult = ReturnType<typeof useHomeGetLeagueGprSpectrumSuspenseQuery>;
export type HomeGetLeagueGprSpectrumQueryResult = Apollo.QueryResult<HomeGetLeagueGprSpectrumQuery, HomeGetLeagueGprSpectrumQueryVariables>;
export const InvitationsListMySentInvitationsDocument = gql`
    query InvitationsListMySentInvitations($first: Int, $after: String) {
  listMySentInvitations(first: $first, after: $after) {
    ...InvitationsInvitationConnection
  }
}
    ${InvitationsInvitationConnectionFragmentDoc}`;

/**
 * __useInvitationsListMySentInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsListMySentInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListMySentInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListMySentInvitationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListMySentInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>(InvitationsListMySentInvitationsDocument, options);
      }
export function useInvitationsListMySentInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>(InvitationsListMySentInvitationsDocument, options);
        }
// @ts-ignore
export function useInvitationsListMySentInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>;
export function useInvitationsListMySentInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMySentInvitationsQuery | undefined, InvitationsListMySentInvitationsQueryVariables>;
export function useInvitationsListMySentInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>(InvitationsListMySentInvitationsDocument, options);
        }
export type InvitationsListMySentInvitationsQueryHookResult = ReturnType<typeof useInvitationsListMySentInvitationsQuery>;
export type InvitationsListMySentInvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsListMySentInvitationsLazyQuery>;
export type InvitationsListMySentInvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsListMySentInvitationsSuspenseQuery>;
export type InvitationsListMySentInvitationsQueryResult = Apollo.QueryResult<InvitationsListMySentInvitationsQuery, InvitationsListMySentInvitationsQueryVariables>;
export const InvitationsListMyOrganiationsSentInvitationsDocument = gql`
    query InvitationsListMyOrganiationsSentInvitations($status: InvitationStatus, $first: Int, $after: String) {
  listMyOrganizationsSentInvitations(
    status: $status
    first: $first
    after: $after
  ) {
    ...InvitationsInvitationConnection
  }
}
    ${InvitationsInvitationConnectionFragmentDoc}`;

/**
 * __useInvitationsListMyOrganiationsSentInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsListMyOrganiationsSentInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListMyOrganiationsSentInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListMyOrganiationsSentInvitationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListMyOrganiationsSentInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>(InvitationsListMyOrganiationsSentInvitationsDocument, options);
      }
export function useInvitationsListMyOrganiationsSentInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>(InvitationsListMyOrganiationsSentInvitationsDocument, options);
        }
// @ts-ignore
export function useInvitationsListMyOrganiationsSentInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>;
export function useInvitationsListMyOrganiationsSentInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyOrganiationsSentInvitationsQuery | undefined, InvitationsListMyOrganiationsSentInvitationsQueryVariables>;
export function useInvitationsListMyOrganiationsSentInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>(InvitationsListMyOrganiationsSentInvitationsDocument, options);
        }
export type InvitationsListMyOrganiationsSentInvitationsQueryHookResult = ReturnType<typeof useInvitationsListMyOrganiationsSentInvitationsQuery>;
export type InvitationsListMyOrganiationsSentInvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsListMyOrganiationsSentInvitationsLazyQuery>;
export type InvitationsListMyOrganiationsSentInvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsListMyOrganiationsSentInvitationsSuspenseQuery>;
export type InvitationsListMyOrganiationsSentInvitationsQueryResult = Apollo.QueryResult<InvitationsListMyOrganiationsSentInvitationsQuery, InvitationsListMyOrganiationsSentInvitationsQueryVariables>;
export const InvitationsListMyReceivedInvitationsDocument = gql`
    query InvitationsListMyReceivedInvitations($status: InvitationStatus, $first: Int, $after: String) {
  listMyReceivedInvitations(status: $status, first: $first, after: $after) {
    ...InvitationsInvitationConnection
  }
}
    ${InvitationsInvitationConnectionFragmentDoc}`;

/**
 * __useInvitationsListMyReceivedInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsListMyReceivedInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListMyReceivedInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListMyReceivedInvitationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListMyReceivedInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>(InvitationsListMyReceivedInvitationsDocument, options);
      }
export function useInvitationsListMyReceivedInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>(InvitationsListMyReceivedInvitationsDocument, options);
        }
// @ts-ignore
export function useInvitationsListMyReceivedInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>;
export function useInvitationsListMyReceivedInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyReceivedInvitationsQuery | undefined, InvitationsListMyReceivedInvitationsQueryVariables>;
export function useInvitationsListMyReceivedInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>(InvitationsListMyReceivedInvitationsDocument, options);
        }
export type InvitationsListMyReceivedInvitationsQueryHookResult = ReturnType<typeof useInvitationsListMyReceivedInvitationsQuery>;
export type InvitationsListMyReceivedInvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsListMyReceivedInvitationsLazyQuery>;
export type InvitationsListMyReceivedInvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsListMyReceivedInvitationsSuspenseQuery>;
export type InvitationsListMyReceivedInvitationsQueryResult = Apollo.QueryResult<InvitationsListMyReceivedInvitationsQuery, InvitationsListMyReceivedInvitationsQueryVariables>;
export const InvitationsListMyOrganizationsOrganizationUsersDocument = gql`
    query InvitationsListMyOrganizationsOrganizationUsers($first: Int, $after: String) {
  listMyOrganizationsOrganizationUsers(first: $first, after: $after) {
    ...InvitationsOrganizationUserConnection
  }
}
    ${InvitationsOrganizationUserConnectionFragmentDoc}`;

/**
 * __useInvitationsListMyOrganizationsOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useInvitationsListMyOrganizationsOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListMyOrganizationsOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListMyOrganizationsOrganizationUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListMyOrganizationsOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>(InvitationsListMyOrganizationsOrganizationUsersDocument, options);
      }
export function useInvitationsListMyOrganizationsOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>(InvitationsListMyOrganizationsOrganizationUsersDocument, options);
        }
// @ts-ignore
export function useInvitationsListMyOrganizationsOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>;
export function useInvitationsListMyOrganizationsOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyOrganizationsOrganizationUsersQuery | undefined, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>;
export function useInvitationsListMyOrganizationsOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>(InvitationsListMyOrganizationsOrganizationUsersDocument, options);
        }
export type InvitationsListMyOrganizationsOrganizationUsersQueryHookResult = ReturnType<typeof useInvitationsListMyOrganizationsOrganizationUsersQuery>;
export type InvitationsListMyOrganizationsOrganizationUsersLazyQueryHookResult = ReturnType<typeof useInvitationsListMyOrganizationsOrganizationUsersLazyQuery>;
export type InvitationsListMyOrganizationsOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useInvitationsListMyOrganizationsOrganizationUsersSuspenseQuery>;
export type InvitationsListMyOrganizationsOrganizationUsersQueryResult = Apollo.QueryResult<InvitationsListMyOrganizationsOrganizationUsersQuery, InvitationsListMyOrganizationsOrganizationUsersQueryVariables>;
export const InvitationsListSportsDocument = gql`
    query InvitationsListSports($first: Int, $after: String) {
  listSports(first: $first, after: $after) {
    ...InvitationsSportConnection
  }
}
    ${InvitationsSportConnectionFragmentDoc}`;

/**
 * __useInvitationsListSportsQuery__
 *
 * To run a query within a React component, call `useInvitationsListSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListSportsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListSportsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>(InvitationsListSportsDocument, options);
      }
export function useInvitationsListSportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>(InvitationsListSportsDocument, options);
        }
// @ts-ignore
export function useInvitationsListSportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>;
export function useInvitationsListSportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListSportsQuery | undefined, InvitationsListSportsQueryVariables>;
export function useInvitationsListSportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>(InvitationsListSportsDocument, options);
        }
export type InvitationsListSportsQueryHookResult = ReturnType<typeof useInvitationsListSportsQuery>;
export type InvitationsListSportsLazyQueryHookResult = ReturnType<typeof useInvitationsListSportsLazyQuery>;
export type InvitationsListSportsSuspenseQueryHookResult = ReturnType<typeof useInvitationsListSportsSuspenseQuery>;
export type InvitationsListSportsQueryResult = Apollo.QueryResult<InvitationsListSportsQuery, InvitationsListSportsQueryVariables>;
export const InvitationsListRolesDocument = gql`
    query InvitationsListRoles($first: Int, $after: String) {
  listRoles(first: $first, after: $after) {
    ...InvitationsRoleConnection
  }
}
    ${InvitationsRoleConnectionFragmentDoc}`;

/**
 * __useInvitationsListRolesQuery__
 *
 * To run a query within a React component, call `useInvitationsListRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListRolesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListRolesQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>(InvitationsListRolesDocument, options);
      }
export function useInvitationsListRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>(InvitationsListRolesDocument, options);
        }
// @ts-ignore
export function useInvitationsListRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>;
export function useInvitationsListRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListRolesQuery | undefined, InvitationsListRolesQueryVariables>;
export function useInvitationsListRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>(InvitationsListRolesDocument, options);
        }
export type InvitationsListRolesQueryHookResult = ReturnType<typeof useInvitationsListRolesQuery>;
export type InvitationsListRolesLazyQueryHookResult = ReturnType<typeof useInvitationsListRolesLazyQuery>;
export type InvitationsListRolesSuspenseQueryHookResult = ReturnType<typeof useInvitationsListRolesSuspenseQuery>;
export type InvitationsListRolesQueryResult = Apollo.QueryResult<InvitationsListRolesQuery, InvitationsListRolesQueryVariables>;
export const InvitationsGetOrganizationDocument = gql`
    query InvitationsGetOrganization($id: ID!) {
  getOrganization(id: $id) {
    ...InvitationsOrganization
  }
}
    ${InvitationsOrganizationFragmentDoc}`;

/**
 * __useInvitationsGetOrganizationQuery__
 *
 * To run a query within a React component, call `useInvitationsGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvitationsGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables> & ({ variables: InvitationsGetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>(InvitationsGetOrganizationDocument, options);
      }
export function useInvitationsGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>(InvitationsGetOrganizationDocument, options);
        }
// @ts-ignore
export function useInvitationsGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>;
export function useInvitationsGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsGetOrganizationQuery | undefined, InvitationsGetOrganizationQueryVariables>;
export function useInvitationsGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>(InvitationsGetOrganizationDocument, options);
        }
export type InvitationsGetOrganizationQueryHookResult = ReturnType<typeof useInvitationsGetOrganizationQuery>;
export type InvitationsGetOrganizationLazyQueryHookResult = ReturnType<typeof useInvitationsGetOrganizationLazyQuery>;
export type InvitationsGetOrganizationSuspenseQueryHookResult = ReturnType<typeof useInvitationsGetOrganizationSuspenseQuery>;
export type InvitationsGetOrganizationQueryResult = Apollo.QueryResult<InvitationsGetOrganizationQuery, InvitationsGetOrganizationQueryVariables>;
export const InvitationsListOrganizationsDocument = gql`
    query InvitationsListOrganizations($first: Int, $after: String) {
  listOrganizations(first: $first, after: $after) {
    ...InvitationsOrganizationConnection
  }
}
    ${InvitationsOrganizationConnectionFragmentDoc}`;

/**
 * __useInvitationsListOrganizationsQuery__
 *
 * To run a query within a React component, call `useInvitationsListOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListOrganizationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>(InvitationsListOrganizationsDocument, options);
      }
export function useInvitationsListOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>(InvitationsListOrganizationsDocument, options);
        }
// @ts-ignore
export function useInvitationsListOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>;
export function useInvitationsListOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListOrganizationsQuery | undefined, InvitationsListOrganizationsQueryVariables>;
export function useInvitationsListOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>(InvitationsListOrganizationsDocument, options);
        }
export type InvitationsListOrganizationsQueryHookResult = ReturnType<typeof useInvitationsListOrganizationsQuery>;
export type InvitationsListOrganizationsLazyQueryHookResult = ReturnType<typeof useInvitationsListOrganizationsLazyQuery>;
export type InvitationsListOrganizationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsListOrganizationsSuspenseQuery>;
export type InvitationsListOrganizationsQueryResult = Apollo.QueryResult<InvitationsListOrganizationsQuery, InvitationsListOrganizationsQueryVariables>;
export const InvitationsListMyOrganizationsDocument = gql`
    query InvitationsListMyOrganizations($first: Int, $after: String) {
  listMyOrganizations(first: $first, after: $after) {
    ...InvitationsOrganizationConnection
  }
}
    ${InvitationsOrganizationConnectionFragmentDoc}`;

/**
 * __useInvitationsListMyOrganizationsQuery__
 *
 * To run a query within a React component, call `useInvitationsListMyOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListMyOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListMyOrganizationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvitationsListMyOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>(InvitationsListMyOrganizationsDocument, options);
      }
export function useInvitationsListMyOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>(InvitationsListMyOrganizationsDocument, options);
        }
// @ts-ignore
export function useInvitationsListMyOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>;
export function useInvitationsListMyOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsListMyOrganizationsQuery | undefined, InvitationsListMyOrganizationsQueryVariables>;
export function useInvitationsListMyOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>(InvitationsListMyOrganizationsDocument, options);
        }
export type InvitationsListMyOrganizationsQueryHookResult = ReturnType<typeof useInvitationsListMyOrganizationsQuery>;
export type InvitationsListMyOrganizationsLazyQueryHookResult = ReturnType<typeof useInvitationsListMyOrganizationsLazyQuery>;
export type InvitationsListMyOrganizationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsListMyOrganizationsSuspenseQuery>;
export type InvitationsListMyOrganizationsQueryResult = Apollo.QueryResult<InvitationsListMyOrganizationsQuery, InvitationsListMyOrganizationsQueryVariables>;
export const InvitationsCreateOrganizationDocument = gql`
    mutation InvitationsCreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ...InvitationsOrganization
  }
}
    ${InvitationsOrganizationFragmentDoc}`;
export type InvitationsCreateOrganizationMutationFn = Apollo.MutationFunction<InvitationsCreateOrganizationMutation, InvitationsCreateOrganizationMutationVariables>;

/**
 * __useInvitationsCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useInvitationsCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsCreateOrganizationMutation, { data, loading, error }] = useInvitationsCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsCreateOrganizationMutation, InvitationsCreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsCreateOrganizationMutation, InvitationsCreateOrganizationMutationVariables>(InvitationsCreateOrganizationDocument, options);
      }
export type InvitationsCreateOrganizationMutationHookResult = ReturnType<typeof useInvitationsCreateOrganizationMutation>;
export type InvitationsCreateOrganizationMutationResult = Apollo.MutationResult<InvitationsCreateOrganizationMutation>;
export type InvitationsCreateOrganizationMutationOptions = Apollo.BaseMutationOptions<InvitationsCreateOrganizationMutation, InvitationsCreateOrganizationMutationVariables>;
export const InvitationsLogIntoOrganizationDocument = gql`
    mutation InvitationsLogIntoOrganization($input: LogIntoOrganizationInput!) {
  logIntoOrganization(input: $input) {
    ...AuthUser
  }
}
    ${AuthUserFragmentDoc}`;
export type InvitationsLogIntoOrganizationMutationFn = Apollo.MutationFunction<InvitationsLogIntoOrganizationMutation, InvitationsLogIntoOrganizationMutationVariables>;

/**
 * __useInvitationsLogIntoOrganizationMutation__
 *
 * To run a mutation, you first call `useInvitationsLogIntoOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsLogIntoOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsLogIntoOrganizationMutation, { data, loading, error }] = useInvitationsLogIntoOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsLogIntoOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsLogIntoOrganizationMutation, InvitationsLogIntoOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsLogIntoOrganizationMutation, InvitationsLogIntoOrganizationMutationVariables>(InvitationsLogIntoOrganizationDocument, options);
      }
export type InvitationsLogIntoOrganizationMutationHookResult = ReturnType<typeof useInvitationsLogIntoOrganizationMutation>;
export type InvitationsLogIntoOrganizationMutationResult = Apollo.MutationResult<InvitationsLogIntoOrganizationMutation>;
export type InvitationsLogIntoOrganizationMutationOptions = Apollo.BaseMutationOptions<InvitationsLogIntoOrganizationMutation, InvitationsLogIntoOrganizationMutationVariables>;
export const InvitationsUpdateOrganizationDocument = gql`
    mutation InvitationsUpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...InvitationsOrganization
  }
}
    ${InvitationsOrganizationFragmentDoc}`;
export type InvitationsUpdateOrganizationMutationFn = Apollo.MutationFunction<InvitationsUpdateOrganizationMutation, InvitationsUpdateOrganizationMutationVariables>;

/**
 * __useInvitationsUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useInvitationsUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsUpdateOrganizationMutation, { data, loading, error }] = useInvitationsUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsUpdateOrganizationMutation, InvitationsUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsUpdateOrganizationMutation, InvitationsUpdateOrganizationMutationVariables>(InvitationsUpdateOrganizationDocument, options);
      }
export type InvitationsUpdateOrganizationMutationHookResult = ReturnType<typeof useInvitationsUpdateOrganizationMutation>;
export type InvitationsUpdateOrganizationMutationResult = Apollo.MutationResult<InvitationsUpdateOrganizationMutation>;
export type InvitationsUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<InvitationsUpdateOrganizationMutation, InvitationsUpdateOrganizationMutationVariables>;
export const InvitationsCreateInvitationDocument = gql`
    mutation InvitationsCreateInvitation($input: CreateInvitationInput!) {
  createInvitation(input: $input) {
    ...InvitationsInvitation
  }
}
    ${InvitationsInvitationFragmentDoc}`;
export type InvitationsCreateInvitationMutationFn = Apollo.MutationFunction<InvitationsCreateInvitationMutation, InvitationsCreateInvitationMutationVariables>;

/**
 * __useInvitationsCreateInvitationMutation__
 *
 * To run a mutation, you first call `useInvitationsCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsCreateInvitationMutation, { data, loading, error }] = useInvitationsCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsCreateInvitationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsCreateInvitationMutation, InvitationsCreateInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsCreateInvitationMutation, InvitationsCreateInvitationMutationVariables>(InvitationsCreateInvitationDocument, options);
      }
export type InvitationsCreateInvitationMutationHookResult = ReturnType<typeof useInvitationsCreateInvitationMutation>;
export type InvitationsCreateInvitationMutationResult = Apollo.MutationResult<InvitationsCreateInvitationMutation>;
export type InvitationsCreateInvitationMutationOptions = Apollo.BaseMutationOptions<InvitationsCreateInvitationMutation, InvitationsCreateInvitationMutationVariables>;
export const InvitationsAcceptInvitationDocument = gql`
    mutation InvitationsAcceptInvitation($input: AcceptInvitationInput!) {
  acceptInvitation(input: $input) {
    ...InvitationsInvitation
  }
}
    ${InvitationsInvitationFragmentDoc}`;
export type InvitationsAcceptInvitationMutationFn = Apollo.MutationFunction<InvitationsAcceptInvitationMutation, InvitationsAcceptInvitationMutationVariables>;

/**
 * __useInvitationsAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useInvitationsAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsAcceptInvitationMutation, { data, loading, error }] = useInvitationsAcceptInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsAcceptInvitationMutation, InvitationsAcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsAcceptInvitationMutation, InvitationsAcceptInvitationMutationVariables>(InvitationsAcceptInvitationDocument, options);
      }
export type InvitationsAcceptInvitationMutationHookResult = ReturnType<typeof useInvitationsAcceptInvitationMutation>;
export type InvitationsAcceptInvitationMutationResult = Apollo.MutationResult<InvitationsAcceptInvitationMutation>;
export type InvitationsAcceptInvitationMutationOptions = Apollo.BaseMutationOptions<InvitationsAcceptInvitationMutation, InvitationsAcceptInvitationMutationVariables>;
export const InvitationsResendInvitationDocument = gql`
    mutation InvitationsResendInvitation($input: ResendInvitationInput!) {
  resendInvitation(input: $input) {
    ...InvitationsInvitation
  }
}
    ${InvitationsInvitationFragmentDoc}`;
export type InvitationsResendInvitationMutationFn = Apollo.MutationFunction<InvitationsResendInvitationMutation, InvitationsResendInvitationMutationVariables>;

/**
 * __useInvitationsResendInvitationMutation__
 *
 * To run a mutation, you first call `useInvitationsResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsResendInvitationMutation, { data, loading, error }] = useInvitationsResendInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsResendInvitationMutation, InvitationsResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsResendInvitationMutation, InvitationsResendInvitationMutationVariables>(InvitationsResendInvitationDocument, options);
      }
export type InvitationsResendInvitationMutationHookResult = ReturnType<typeof useInvitationsResendInvitationMutation>;
export type InvitationsResendInvitationMutationResult = Apollo.MutationResult<InvitationsResendInvitationMutation>;
export type InvitationsResendInvitationMutationOptions = Apollo.BaseMutationOptions<InvitationsResendInvitationMutation, InvitationsResendInvitationMutationVariables>;
export const InvitationsDeleteInvitationDocument = gql`
    mutation InvitationsDeleteInvitation($input: DeleteInvitationInput!) {
  deleteInvitation(input: $input) {
    ...InvitationsInvitation
  }
}
    ${InvitationsInvitationFragmentDoc}`;
export type InvitationsDeleteInvitationMutationFn = Apollo.MutationFunction<InvitationsDeleteInvitationMutation, InvitationsDeleteInvitationMutationVariables>;

/**
 * __useInvitationsDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useInvitationsDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationsDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationsDeleteInvitationMutation, { data, loading, error }] = useInvitationsDeleteInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationsDeleteInvitationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationsDeleteInvitationMutation, InvitationsDeleteInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationsDeleteInvitationMutation, InvitationsDeleteInvitationMutationVariables>(InvitationsDeleteInvitationDocument, options);
      }
export type InvitationsDeleteInvitationMutationHookResult = ReturnType<typeof useInvitationsDeleteInvitationMutation>;
export type InvitationsDeleteInvitationMutationResult = Apollo.MutationResult<InvitationsDeleteInvitationMutation>;
export type InvitationsDeleteInvitationMutationOptions = Apollo.BaseMutationOptions<InvitationsDeleteInvitationMutation, InvitationsDeleteInvitationMutationVariables>;
export const InvitationActivateUserDocument = gql`
    mutation InvitationActivateUser($input: ActivateOrganizationUserInput!) {
  activateUser(input: $input) {
    ...InvitationsOrganizationUser
  }
}
    ${InvitationsOrganizationUserFragmentDoc}`;
export type InvitationActivateUserMutationFn = Apollo.MutationFunction<InvitationActivateUserMutation, InvitationActivateUserMutationVariables>;

/**
 * __useInvitationActivateUserMutation__
 *
 * To run a mutation, you first call `useInvitationActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationActivateUserMutation, { data, loading, error }] = useInvitationActivateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<InvitationActivateUserMutation, InvitationActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationActivateUserMutation, InvitationActivateUserMutationVariables>(InvitationActivateUserDocument, options);
      }
export type InvitationActivateUserMutationHookResult = ReturnType<typeof useInvitationActivateUserMutation>;
export type InvitationActivateUserMutationResult = Apollo.MutationResult<InvitationActivateUserMutation>;
export type InvitationActivateUserMutationOptions = Apollo.BaseMutationOptions<InvitationActivateUserMutation, InvitationActivateUserMutationVariables>;
export const InvitationDeactivateUserDocument = gql`
    mutation InvitationDeactivateUser($input: DeactivateOrganizationUserInput!) {
  deactivateUser(input: $input) {
    ...InvitationsOrganizationUser
  }
}
    ${InvitationsOrganizationUserFragmentDoc}`;
export type InvitationDeactivateUserMutationFn = Apollo.MutationFunction<InvitationDeactivateUserMutation, InvitationDeactivateUserMutationVariables>;

/**
 * __useInvitationDeactivateUserMutation__
 *
 * To run a mutation, you first call `useInvitationDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationDeactivateUserMutation, { data, loading, error }] = useInvitationDeactivateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<InvitationDeactivateUserMutation, InvitationDeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationDeactivateUserMutation, InvitationDeactivateUserMutationVariables>(InvitationDeactivateUserDocument, options);
      }
export type InvitationDeactivateUserMutationHookResult = ReturnType<typeof useInvitationDeactivateUserMutation>;
export type InvitationDeactivateUserMutationResult = Apollo.MutationResult<InvitationDeactivateUserMutation>;
export type InvitationDeactivateUserMutationOptions = Apollo.BaseMutationOptions<InvitationDeactivateUserMutation, InvitationDeactivateUserMutationVariables>;
export const InvitationRejectInvitationDocument = gql`
    mutation InvitationRejectInvitation($input: RejectInvitationInput!) {
  rejectInvitation(input: $input) {
    ...InvitationsInvitation
  }
}
    ${InvitationsInvitationFragmentDoc}`;
export type InvitationRejectInvitationMutationFn = Apollo.MutationFunction<InvitationRejectInvitationMutation, InvitationRejectInvitationMutationVariables>;

/**
 * __useInvitationRejectInvitationMutation__
 *
 * To run a mutation, you first call `useInvitationRejectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitationRejectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitationRejectInvitationMutation, { data, loading, error }] = useInvitationRejectInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitationRejectInvitationMutation(baseOptions?: Apollo.MutationHookOptions<InvitationRejectInvitationMutation, InvitationRejectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitationRejectInvitationMutation, InvitationRejectInvitationMutationVariables>(InvitationRejectInvitationDocument, options);
      }
export type InvitationRejectInvitationMutationHookResult = ReturnType<typeof useInvitationRejectInvitationMutation>;
export type InvitationRejectInvitationMutationResult = Apollo.MutationResult<InvitationRejectInvitationMutation>;
export type InvitationRejectInvitationMutationOptions = Apollo.BaseMutationOptions<InvitationRejectInvitationMutation, InvitationRejectInvitationMutationVariables>;
export const SearchMyThreadsDocument = gql`
    query SearchMyThreads($query: String) {
  searchMyThreads(query: $query) {
    edges {
      node {
        id
        firstQuestion
        lastAccessed
        messageCount
        title
        status
        isFavorite
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useSearchMyThreadsQuery__
 *
 * To run a query within a React component, call `useSearchMyThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMyThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMyThreadsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchMyThreadsQuery(baseOptions?: Apollo.QueryHookOptions<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>(SearchMyThreadsDocument, options);
      }
export function useSearchMyThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>(SearchMyThreadsDocument, options);
        }
// @ts-ignore
export function useSearchMyThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>;
export function useSearchMyThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMyThreadsQuery | undefined, SearchMyThreadsQueryVariables>;
export function useSearchMyThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>(SearchMyThreadsDocument, options);
        }
export type SearchMyThreadsQueryHookResult = ReturnType<typeof useSearchMyThreadsQuery>;
export type SearchMyThreadsLazyQueryHookResult = ReturnType<typeof useSearchMyThreadsLazyQuery>;
export type SearchMyThreadsSuspenseQueryHookResult = ReturnType<typeof useSearchMyThreadsSuspenseQuery>;
export type SearchMyThreadsQueryResult = Apollo.QueryResult<SearchMyThreadsQuery, SearchMyThreadsQueryVariables>;
export const GetThreadDocument = gql`
    query GetThread($threadId: String!) {
  getThread(threadId: $threadId) {
    createdAt
    firstQuestion
    id
    isFavorite
    lastAccessed
    lastAnswer
    lastQuestion
    messageCount
    organizationId
    status
    title
    updatedAt
    userId
    metadata {
      lastUpdated
      language
      customFields
      messages {
        content
        id
        role
        timestamp
        metadata {
          model
          inputTokens
          outputTokens
          dataSources
          additionalData
        }
      }
      topic
      tags
      sentiment
      sessionContext
    }
  }
}
    `;

/**
 * __useGetThreadQuery__
 *
 * To run a query within a React component, call `useGetThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetThreadQuery(baseOptions: Apollo.QueryHookOptions<GetThreadQuery, GetThreadQueryVariables> & ({ variables: GetThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadQuery, GetThreadQueryVariables>(GetThreadDocument, options);
      }
export function useGetThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadQuery, GetThreadQueryVariables>(GetThreadDocument, options);
        }
// @ts-ignore
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetThreadQuery, GetThreadQueryVariables>;
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetThreadQuery | undefined, GetThreadQueryVariables>;
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThreadQuery, GetThreadQueryVariables>(GetThreadDocument, options);
        }
export type GetThreadQueryHookResult = ReturnType<typeof useGetThreadQuery>;
export type GetThreadLazyQueryHookResult = ReturnType<typeof useGetThreadLazyQuery>;
export type GetThreadSuspenseQueryHookResult = ReturnType<typeof useGetThreadSuspenseQuery>;
export type GetThreadQueryResult = Apollo.QueryResult<GetThreadQuery, GetThreadQueryVariables>;
export const ToggleThreadFavoriteDocument = gql`
    mutation ToggleThreadFavorite($threadId: String!) {
  toggleThreadFavorite(threadId: $threadId) {
    id
    isFavorite
    updatedAt
  }
}
    `;
export type ToggleThreadFavoriteMutationFn = Apollo.MutationFunction<ToggleThreadFavoriteMutation, ToggleThreadFavoriteMutationVariables>;

/**
 * __useToggleThreadFavoriteMutation__
 *
 * To run a mutation, you first call `useToggleThreadFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleThreadFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleThreadFavoriteMutation, { data, loading, error }] = useToggleThreadFavoriteMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useToggleThreadFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleThreadFavoriteMutation, ToggleThreadFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleThreadFavoriteMutation, ToggleThreadFavoriteMutationVariables>(ToggleThreadFavoriteDocument, options);
      }
export type ToggleThreadFavoriteMutationHookResult = ReturnType<typeof useToggleThreadFavoriteMutation>;
export type ToggleThreadFavoriteMutationResult = Apollo.MutationResult<ToggleThreadFavoriteMutation>;
export type ToggleThreadFavoriteMutationOptions = Apollo.BaseMutationOptions<ToggleThreadFavoriteMutation, ToggleThreadFavoriteMutationVariables>;
export const UpdateThreadStatusDocument = gql`
    mutation UpdateThreadStatus($threadId: String!, $status: String!) {
  updateThreadStatus(threadId: $threadId, status: $status) {
    id
    status
    updatedAt
  }
}
    `;
export type UpdateThreadStatusMutationFn = Apollo.MutationFunction<UpdateThreadStatusMutation, UpdateThreadStatusMutationVariables>;

/**
 * __useUpdateThreadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateThreadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreadStatusMutation, { data, loading, error }] = useUpdateThreadStatusMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateThreadStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThreadStatusMutation, UpdateThreadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThreadStatusMutation, UpdateThreadStatusMutationVariables>(UpdateThreadStatusDocument, options);
      }
export type UpdateThreadStatusMutationHookResult = ReturnType<typeof useUpdateThreadStatusMutation>;
export type UpdateThreadStatusMutationResult = Apollo.MutationResult<UpdateThreadStatusMutation>;
export type UpdateThreadStatusMutationOptions = Apollo.BaseMutationOptions<UpdateThreadStatusMutation, UpdateThreadStatusMutationVariables>;
export const MatchDetailDocument = gql`
    query MatchDetail($id: ID!) {
  getMatch(id: $id) {
    id
    scheduledThingId
    scheduledDate
    scheduledEndDate
    datePrecision
    startTime
    timeZone
    venue
    status
    source
    competitionName
    homeTeamScore
    awayTeamScore
    homeTeam {
      id
      name
    }
    awayTeam {
      id
      name
    }
  }
}
    `;

/**
 * __useMatchDetailQuery__
 *
 * To run a query within a React component, call `useMatchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchDetailQuery(baseOptions: Apollo.QueryHookOptions<MatchDetailQuery, MatchDetailQueryVariables> & ({ variables: MatchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDetailQuery, MatchDetailQueryVariables>(MatchDetailDocument, options);
      }
export function useMatchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDetailQuery, MatchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDetailQuery, MatchDetailQueryVariables>(MatchDetailDocument, options);
        }
// @ts-ignore
export function useMatchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDetailQuery, MatchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<MatchDetailQuery, MatchDetailQueryVariables>;
export function useMatchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchDetailQuery, MatchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<MatchDetailQuery | undefined, MatchDetailQueryVariables>;
export function useMatchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchDetailQuery, MatchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDetailQuery, MatchDetailQueryVariables>(MatchDetailDocument, options);
        }
export type MatchDetailQueryHookResult = ReturnType<typeof useMatchDetailQuery>;
export type MatchDetailLazyQueryHookResult = ReturnType<typeof useMatchDetailLazyQuery>;
export type MatchDetailSuspenseQueryHookResult = ReturnType<typeof useMatchDetailSuspenseQuery>;
export type MatchDetailQueryResult = Apollo.QueryResult<MatchDetailQuery, MatchDetailQueryVariables>;
export const MatchDetailAssignmentsDocument = gql`
    query MatchDetailAssignments($filter: AssignmentFilterInput!, $first: Int) {
  listAssignments(filter: $filter, first: $first) {
    edges {
      node {
        id
        assigneeUser {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useMatchDetailAssignmentsQuery__
 *
 * To run a query within a React component, call `useMatchDetailAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDetailAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDetailAssignmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMatchDetailAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables> & ({ variables: MatchDetailAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>(MatchDetailAssignmentsDocument, options);
      }
export function useMatchDetailAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>(MatchDetailAssignmentsDocument, options);
        }
// @ts-ignore
export function useMatchDetailAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>;
export function useMatchDetailAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchDetailAssignmentsQuery | undefined, MatchDetailAssignmentsQueryVariables>;
export function useMatchDetailAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>(MatchDetailAssignmentsDocument, options);
        }
export type MatchDetailAssignmentsQueryHookResult = ReturnType<typeof useMatchDetailAssignmentsQuery>;
export type MatchDetailAssignmentsLazyQueryHookResult = ReturnType<typeof useMatchDetailAssignmentsLazyQuery>;
export type MatchDetailAssignmentsSuspenseQueryHookResult = ReturnType<typeof useMatchDetailAssignmentsSuspenseQuery>;
export type MatchDetailAssignmentsQueryResult = Apollo.QueryResult<MatchDetailAssignmentsQuery, MatchDetailAssignmentsQueryVariables>;
export const MatchDetailReportsDocument = gql`
    query MatchDetailReports($filter: MatchReportFilterInput!, $first: Int) {
  listMatchReports(filter: $filter, first: $first) {
    edges {
      node {
        id
        status
        submittedAt
        playerCount
        tickedCount
        scoredCount
        squadSize
        scoutUser {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useMatchDetailReportsQuery__
 *
 * To run a query within a React component, call `useMatchDetailReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDetailReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDetailReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMatchDetailReportsQuery(baseOptions: Apollo.QueryHookOptions<MatchDetailReportsQuery, MatchDetailReportsQueryVariables> & ({ variables: MatchDetailReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>(MatchDetailReportsDocument, options);
      }
export function useMatchDetailReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>(MatchDetailReportsDocument, options);
        }
// @ts-ignore
export function useMatchDetailReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>;
export function useMatchDetailReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchDetailReportsQuery | undefined, MatchDetailReportsQueryVariables>;
export function useMatchDetailReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>(MatchDetailReportsDocument, options);
        }
export type MatchDetailReportsQueryHookResult = ReturnType<typeof useMatchDetailReportsQuery>;
export type MatchDetailReportsLazyQueryHookResult = ReturnType<typeof useMatchDetailReportsLazyQuery>;
export type MatchDetailReportsSuspenseQueryHookResult = ReturnType<typeof useMatchDetailReportsSuspenseQuery>;
export type MatchDetailReportsQueryResult = Apollo.QueryResult<MatchDetailReportsQuery, MatchDetailReportsQueryVariables>;
export const MatchEventsDocument = gql`
    query MatchEvents($matchId: ID!) {
  listMatchEvents(matchId: $matchId) {
    id
    kind
    minute
    matchId
    team {
      id
      name
    }
    player {
      id
      name
    }
  }
}
    `;

/**
 * __useMatchEventsQuery__
 *
 * To run a query within a React component, call `useMatchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchEventsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchEventsQuery(baseOptions: Apollo.QueryHookOptions<MatchEventsQuery, MatchEventsQueryVariables> & ({ variables: MatchEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchEventsQuery, MatchEventsQueryVariables>(MatchEventsDocument, options);
      }
export function useMatchEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchEventsQuery, MatchEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchEventsQuery, MatchEventsQueryVariables>(MatchEventsDocument, options);
        }
// @ts-ignore
export function useMatchEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchEventsQuery, MatchEventsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchEventsQuery, MatchEventsQueryVariables>;
export function useMatchEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchEventsQuery, MatchEventsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchEventsQuery | undefined, MatchEventsQueryVariables>;
export function useMatchEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchEventsQuery, MatchEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchEventsQuery, MatchEventsQueryVariables>(MatchEventsDocument, options);
        }
export type MatchEventsQueryHookResult = ReturnType<typeof useMatchEventsQuery>;
export type MatchEventsLazyQueryHookResult = ReturnType<typeof useMatchEventsLazyQuery>;
export type MatchEventsSuspenseQueryHookResult = ReturnType<typeof useMatchEventsSuspenseQuery>;
export type MatchEventsQueryResult = Apollo.QueryResult<MatchEventsQuery, MatchEventsQueryVariables>;
export const MatchAppearancesDocument = gql`
    query MatchAppearances($matchId: ID!) {
  listMatchAppearances(matchId: $matchId) {
    id
    minutesPlayed
    matchId
    team {
      id
      name
    }
    player {
      id
      name
    }
  }
}
    `;

/**
 * __useMatchAppearancesQuery__
 *
 * To run a query within a React component, call `useMatchAppearancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchAppearancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchAppearancesQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchAppearancesQuery(baseOptions: Apollo.QueryHookOptions<MatchAppearancesQuery, MatchAppearancesQueryVariables> & ({ variables: MatchAppearancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchAppearancesQuery, MatchAppearancesQueryVariables>(MatchAppearancesDocument, options);
      }
export function useMatchAppearancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchAppearancesQuery, MatchAppearancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchAppearancesQuery, MatchAppearancesQueryVariables>(MatchAppearancesDocument, options);
        }
// @ts-ignore
export function useMatchAppearancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchAppearancesQuery, MatchAppearancesQueryVariables>): Apollo.UseSuspenseQueryResult<MatchAppearancesQuery, MatchAppearancesQueryVariables>;
export function useMatchAppearancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchAppearancesQuery, MatchAppearancesQueryVariables>): Apollo.UseSuspenseQueryResult<MatchAppearancesQuery | undefined, MatchAppearancesQueryVariables>;
export function useMatchAppearancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchAppearancesQuery, MatchAppearancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchAppearancesQuery, MatchAppearancesQueryVariables>(MatchAppearancesDocument, options);
        }
export type MatchAppearancesQueryHookResult = ReturnType<typeof useMatchAppearancesQuery>;
export type MatchAppearancesLazyQueryHookResult = ReturnType<typeof useMatchAppearancesLazyQuery>;
export type MatchAppearancesSuspenseQueryHookResult = ReturnType<typeof useMatchAppearancesSuspenseQuery>;
export type MatchAppearancesQueryResult = Apollo.QueryResult<MatchAppearancesQuery, MatchAppearancesQueryVariables>;
export const CreateMatchEventDocument = gql`
    mutation CreateMatchEvent($input: CreateMatchEventInput!) {
  createMatchEvent(input: $input) {
    id
    kind
    minute
    matchId
    team {
      id
      name
    }
    player {
      id
      name
    }
  }
}
    `;
export type CreateMatchEventMutationFn = Apollo.MutationFunction<CreateMatchEventMutation, CreateMatchEventMutationVariables>;

/**
 * __useCreateMatchEventMutation__
 *
 * To run a mutation, you first call `useCreateMatchEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchEventMutation, { data, loading, error }] = useCreateMatchEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMatchEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchEventMutation, CreateMatchEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchEventMutation, CreateMatchEventMutationVariables>(CreateMatchEventDocument, options);
      }
export type CreateMatchEventMutationHookResult = ReturnType<typeof useCreateMatchEventMutation>;
export type CreateMatchEventMutationResult = Apollo.MutationResult<CreateMatchEventMutation>;
export type CreateMatchEventMutationOptions = Apollo.BaseMutationOptions<CreateMatchEventMutation, CreateMatchEventMutationVariables>;
export const UpdateMatchEventDocument = gql`
    mutation UpdateMatchEvent($input: UpdateMatchEventInput!) {
  updateMatchEvent(input: $input) {
    id
    kind
    minute
    matchId
    team {
      id
      name
    }
    player {
      id
      name
    }
  }
}
    `;
export type UpdateMatchEventMutationFn = Apollo.MutationFunction<UpdateMatchEventMutation, UpdateMatchEventMutationVariables>;

/**
 * __useUpdateMatchEventMutation__
 *
 * To run a mutation, you first call `useUpdateMatchEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatchEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatchEventMutation, { data, loading, error }] = useUpdateMatchEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMatchEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatchEventMutation, UpdateMatchEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatchEventMutation, UpdateMatchEventMutationVariables>(UpdateMatchEventDocument, options);
      }
export type UpdateMatchEventMutationHookResult = ReturnType<typeof useUpdateMatchEventMutation>;
export type UpdateMatchEventMutationResult = Apollo.MutationResult<UpdateMatchEventMutation>;
export type UpdateMatchEventMutationOptions = Apollo.BaseMutationOptions<UpdateMatchEventMutation, UpdateMatchEventMutationVariables>;
export const DeleteMatchEventDocument = gql`
    mutation DeleteMatchEvent($matchEventId: ID!) {
  deleteMatchEvent(matchEventId: $matchEventId)
}
    `;
export type DeleteMatchEventMutationFn = Apollo.MutationFunction<DeleteMatchEventMutation, DeleteMatchEventMutationVariables>;

/**
 * __useDeleteMatchEventMutation__
 *
 * To run a mutation, you first call `useDeleteMatchEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchEventMutation, { data, loading, error }] = useDeleteMatchEventMutation({
 *   variables: {
 *      matchEventId: // value for 'matchEventId'
 *   },
 * });
 */
export function useDeleteMatchEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchEventMutation, DeleteMatchEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchEventMutation, DeleteMatchEventMutationVariables>(DeleteMatchEventDocument, options);
      }
export type DeleteMatchEventMutationHookResult = ReturnType<typeof useDeleteMatchEventMutation>;
export type DeleteMatchEventMutationResult = Apollo.MutationResult<DeleteMatchEventMutation>;
export type DeleteMatchEventMutationOptions = Apollo.BaseMutationOptions<DeleteMatchEventMutation, DeleteMatchEventMutationVariables>;
export const SetMatchAppearanceDocument = gql`
    mutation SetMatchAppearance($input: SetMatchAppearanceInput!) {
  setMatchAppearance(input: $input) {
    id
    minutesPlayed
    matchId
    team {
      id
      name
    }
    player {
      id
      name
    }
  }
}
    `;
export type SetMatchAppearanceMutationFn = Apollo.MutationFunction<SetMatchAppearanceMutation, SetMatchAppearanceMutationVariables>;

/**
 * __useSetMatchAppearanceMutation__
 *
 * To run a mutation, you first call `useSetMatchAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMatchAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMatchAppearanceMutation, { data, loading, error }] = useSetMatchAppearanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMatchAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<SetMatchAppearanceMutation, SetMatchAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMatchAppearanceMutation, SetMatchAppearanceMutationVariables>(SetMatchAppearanceDocument, options);
      }
export type SetMatchAppearanceMutationHookResult = ReturnType<typeof useSetMatchAppearanceMutation>;
export type SetMatchAppearanceMutationResult = Apollo.MutationResult<SetMatchAppearanceMutation>;
export type SetMatchAppearanceMutationOptions = Apollo.BaseMutationOptions<SetMatchAppearanceMutation, SetMatchAppearanceMutationVariables>;
export const DeleteMatchAppearanceDocument = gql`
    mutation DeleteMatchAppearance($matchAppearanceId: ID!) {
  deleteMatchAppearance(matchAppearanceId: $matchAppearanceId)
}
    `;
export type DeleteMatchAppearanceMutationFn = Apollo.MutationFunction<DeleteMatchAppearanceMutation, DeleteMatchAppearanceMutationVariables>;

/**
 * __useDeleteMatchAppearanceMutation__
 *
 * To run a mutation, you first call `useDeleteMatchAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchAppearanceMutation, { data, loading, error }] = useDeleteMatchAppearanceMutation({
 *   variables: {
 *      matchAppearanceId: // value for 'matchAppearanceId'
 *   },
 * });
 */
export function useDeleteMatchAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchAppearanceMutation, DeleteMatchAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchAppearanceMutation, DeleteMatchAppearanceMutationVariables>(DeleteMatchAppearanceDocument, options);
      }
export type DeleteMatchAppearanceMutationHookResult = ReturnType<typeof useDeleteMatchAppearanceMutation>;
export type DeleteMatchAppearanceMutationResult = Apollo.MutationResult<DeleteMatchAppearanceMutation>;
export type DeleteMatchAppearanceMutationOptions = Apollo.BaseMutationOptions<DeleteMatchAppearanceMutation, DeleteMatchAppearanceMutationVariables>;
export const MatchReportCaptureSquadDocument = gql`
    query MatchReportCaptureSquad($filter: PlayerAdvancedFilterInput!, $first: Int, $after: String) {
  filterPlayers(filter: $filter, first: $first, after: $after) {
    totalCount
    edges {
      cursor
      node {
        ...MatchReportCaptureSquadPlayer
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${MatchReportCaptureSquadPlayerFragmentDoc}`;

/**
 * __useMatchReportCaptureSquadQuery__
 *
 * To run a query within a React component, call `useMatchReportCaptureSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchReportCaptureSquadQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMatchReportCaptureSquadQuery(baseOptions: Apollo.QueryHookOptions<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables> & ({ variables: MatchReportCaptureSquadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>(MatchReportCaptureSquadDocument, options);
      }
export function useMatchReportCaptureSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>(MatchReportCaptureSquadDocument, options);
        }
// @ts-ignore
export function useMatchReportCaptureSquadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>;
export function useMatchReportCaptureSquadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportCaptureSquadQuery | undefined, MatchReportCaptureSquadQueryVariables>;
export function useMatchReportCaptureSquadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>(MatchReportCaptureSquadDocument, options);
        }
export type MatchReportCaptureSquadQueryHookResult = ReturnType<typeof useMatchReportCaptureSquadQuery>;
export type MatchReportCaptureSquadLazyQueryHookResult = ReturnType<typeof useMatchReportCaptureSquadLazyQuery>;
export type MatchReportCaptureSquadSuspenseQueryHookResult = ReturnType<typeof useMatchReportCaptureSquadSuspenseQuery>;
export type MatchReportCaptureSquadQueryResult = Apollo.QueryResult<MatchReportCaptureSquadQuery, MatchReportCaptureSquadQueryVariables>;
export const MatchReportCaptureFixtureDocument = gql`
    query MatchReportCaptureFixture($id: ID!) {
  getMatch(id: $id) {
    id
    scheduledDate
    startTime
    venue
    competitionName
    homeTeam {
      id
      name
    }
    awayTeam {
      id
      name
    }
  }
}
    `;

/**
 * __useMatchReportCaptureFixtureQuery__
 *
 * To run a query within a React component, call `useMatchReportCaptureFixtureQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureFixtureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchReportCaptureFixtureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchReportCaptureFixtureQuery(baseOptions: Apollo.QueryHookOptions<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables> & ({ variables: MatchReportCaptureFixtureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>(MatchReportCaptureFixtureDocument, options);
      }
export function useMatchReportCaptureFixtureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>(MatchReportCaptureFixtureDocument, options);
        }
// @ts-ignore
export function useMatchReportCaptureFixtureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>;
export function useMatchReportCaptureFixtureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportCaptureFixtureQuery | undefined, MatchReportCaptureFixtureQueryVariables>;
export function useMatchReportCaptureFixtureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>(MatchReportCaptureFixtureDocument, options);
        }
export type MatchReportCaptureFixtureQueryHookResult = ReturnType<typeof useMatchReportCaptureFixtureQuery>;
export type MatchReportCaptureFixtureLazyQueryHookResult = ReturnType<typeof useMatchReportCaptureFixtureLazyQuery>;
export type MatchReportCaptureFixtureSuspenseQueryHookResult = ReturnType<typeof useMatchReportCaptureFixtureSuspenseQuery>;
export type MatchReportCaptureFixtureQueryResult = Apollo.QueryResult<MatchReportCaptureFixtureQuery, MatchReportCaptureFixtureQueryVariables>;
export const MatchReportCaptureCreateReportDocument = gql`
    mutation MatchReportCaptureCreateReport($input: CreateMatchReportInput!) {
  createMatchReport(input: $input) {
    ...MatchReportCaptureReport
  }
}
    ${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCaptureCreateReportMutationFn = Apollo.MutationFunction<MatchReportCaptureCreateReportMutation, MatchReportCaptureCreateReportMutationVariables>;

/**
 * __useMatchReportCaptureCreateReportMutation__
 *
 * To run a mutation, you first call `useMatchReportCaptureCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCaptureCreateReportMutation, { data, loading, error }] = useMatchReportCaptureCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCaptureCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCaptureCreateReportMutation, MatchReportCaptureCreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCaptureCreateReportMutation, MatchReportCaptureCreateReportMutationVariables>(MatchReportCaptureCreateReportDocument, options);
      }
export type MatchReportCaptureCreateReportMutationHookResult = ReturnType<typeof useMatchReportCaptureCreateReportMutation>;
export type MatchReportCaptureCreateReportMutationResult = Apollo.MutationResult<MatchReportCaptureCreateReportMutation>;
export type MatchReportCaptureCreateReportMutationOptions = Apollo.BaseMutationOptions<MatchReportCaptureCreateReportMutation, MatchReportCaptureCreateReportMutationVariables>;
export const MatchReportCaptureSetSquadDocument = gql`
    mutation MatchReportCaptureSetSquad($input: SetMatchReportSquadInput!) {
  setMatchReportSquad(input: $input) {
    ...MatchReportCaptureReport
  }
}
    ${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCaptureSetSquadMutationFn = Apollo.MutationFunction<MatchReportCaptureSetSquadMutation, MatchReportCaptureSetSquadMutationVariables>;

/**
 * __useMatchReportCaptureSetSquadMutation__
 *
 * To run a mutation, you first call `useMatchReportCaptureSetSquadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureSetSquadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCaptureSetSquadMutation, { data, loading, error }] = useMatchReportCaptureSetSquadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCaptureSetSquadMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCaptureSetSquadMutation, MatchReportCaptureSetSquadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCaptureSetSquadMutation, MatchReportCaptureSetSquadMutationVariables>(MatchReportCaptureSetSquadDocument, options);
      }
export type MatchReportCaptureSetSquadMutationHookResult = ReturnType<typeof useMatchReportCaptureSetSquadMutation>;
export type MatchReportCaptureSetSquadMutationResult = Apollo.MutationResult<MatchReportCaptureSetSquadMutation>;
export type MatchReportCaptureSetSquadMutationOptions = Apollo.BaseMutationOptions<MatchReportCaptureSetSquadMutation, MatchReportCaptureSetSquadMutationVariables>;
export const MatchReportCaptureAddSquadPlayersDocument = gql`
    mutation MatchReportCaptureAddSquadPlayers($input: AddMatchReportSquadPlayersInput!) {
  addMatchReportSquadPlayers(input: $input) {
    ...MatchReportCaptureReport
  }
}
    ${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCaptureAddSquadPlayersMutationFn = Apollo.MutationFunction<MatchReportCaptureAddSquadPlayersMutation, MatchReportCaptureAddSquadPlayersMutationVariables>;

/**
 * __useMatchReportCaptureAddSquadPlayersMutation__
 *
 * To run a mutation, you first call `useMatchReportCaptureAddSquadPlayersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureAddSquadPlayersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCaptureAddSquadPlayersMutation, { data, loading, error }] = useMatchReportCaptureAddSquadPlayersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCaptureAddSquadPlayersMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCaptureAddSquadPlayersMutation, MatchReportCaptureAddSquadPlayersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCaptureAddSquadPlayersMutation, MatchReportCaptureAddSquadPlayersMutationVariables>(MatchReportCaptureAddSquadPlayersDocument, options);
      }
export type MatchReportCaptureAddSquadPlayersMutationHookResult = ReturnType<typeof useMatchReportCaptureAddSquadPlayersMutation>;
export type MatchReportCaptureAddSquadPlayersMutationResult = Apollo.MutationResult<MatchReportCaptureAddSquadPlayersMutation>;
export type MatchReportCaptureAddSquadPlayersMutationOptions = Apollo.BaseMutationOptions<MatchReportCaptureAddSquadPlayersMutation, MatchReportCaptureAddSquadPlayersMutationVariables>;
export const MatchReportCaptureUpdateReportDocument = gql`
    mutation MatchReportCaptureUpdateReport($input: UpdateMatchReportInput!) {
  updateMatchReport(input: $input) {
    ...MatchReportCaptureReport
  }
}
    ${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCaptureUpdateReportMutationFn = Apollo.MutationFunction<MatchReportCaptureUpdateReportMutation, MatchReportCaptureUpdateReportMutationVariables>;

/**
 * __useMatchReportCaptureUpdateReportMutation__
 *
 * To run a mutation, you first call `useMatchReportCaptureUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCaptureUpdateReportMutation, { data, loading, error }] = useMatchReportCaptureUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCaptureUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCaptureUpdateReportMutation, MatchReportCaptureUpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCaptureUpdateReportMutation, MatchReportCaptureUpdateReportMutationVariables>(MatchReportCaptureUpdateReportDocument, options);
      }
export type MatchReportCaptureUpdateReportMutationHookResult = ReturnType<typeof useMatchReportCaptureUpdateReportMutation>;
export type MatchReportCaptureUpdateReportMutationResult = Apollo.MutationResult<MatchReportCaptureUpdateReportMutation>;
export type MatchReportCaptureUpdateReportMutationOptions = Apollo.BaseMutationOptions<MatchReportCaptureUpdateReportMutation, MatchReportCaptureUpdateReportMutationVariables>;
export const MatchReportCaptureUpsertEvaluationDocument = gql`
    mutation MatchReportCaptureUpsertEvaluation($input: UpsertPlayerEvaluationInput!) {
  upsertPlayerEvaluation(input: $input) {
    evaluation {
      ...MatchReportCaptureEvaluation
    }
    matchReport {
      ...MatchReportCaptureReport
    }
  }
}
    ${MatchReportCaptureEvaluationFragmentDoc}
${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCaptureUpsertEvaluationMutationFn = Apollo.MutationFunction<MatchReportCaptureUpsertEvaluationMutation, MatchReportCaptureUpsertEvaluationMutationVariables>;

/**
 * __useMatchReportCaptureUpsertEvaluationMutation__
 *
 * To run a mutation, you first call `useMatchReportCaptureUpsertEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureUpsertEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCaptureUpsertEvaluationMutation, { data, loading, error }] = useMatchReportCaptureUpsertEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCaptureUpsertEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCaptureUpsertEvaluationMutation, MatchReportCaptureUpsertEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCaptureUpsertEvaluationMutation, MatchReportCaptureUpsertEvaluationMutationVariables>(MatchReportCaptureUpsertEvaluationDocument, options);
      }
export type MatchReportCaptureUpsertEvaluationMutationHookResult = ReturnType<typeof useMatchReportCaptureUpsertEvaluationMutation>;
export type MatchReportCaptureUpsertEvaluationMutationResult = Apollo.MutationResult<MatchReportCaptureUpsertEvaluationMutation>;
export type MatchReportCaptureUpsertEvaluationMutationOptions = Apollo.BaseMutationOptions<MatchReportCaptureUpsertEvaluationMutation, MatchReportCaptureUpsertEvaluationMutationVariables>;
export const MatchReportCaptureSubmitDocument = gql`
    mutation MatchReportCaptureSubmit($input: SubmitMatchReportInput!) {
  submitMatchReport(input: $input) {
    ...MatchReportCaptureReport
  }
}
    ${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCaptureSubmitMutationFn = Apollo.MutationFunction<MatchReportCaptureSubmitMutation, MatchReportCaptureSubmitMutationVariables>;

/**
 * __useMatchReportCaptureSubmitMutation__
 *
 * To run a mutation, you first call `useMatchReportCaptureSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCaptureSubmitMutation, { data, loading, error }] = useMatchReportCaptureSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCaptureSubmitMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCaptureSubmitMutation, MatchReportCaptureSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCaptureSubmitMutation, MatchReportCaptureSubmitMutationVariables>(MatchReportCaptureSubmitDocument, options);
      }
export type MatchReportCaptureSubmitMutationHookResult = ReturnType<typeof useMatchReportCaptureSubmitMutation>;
export type MatchReportCaptureSubmitMutationResult = Apollo.MutationResult<MatchReportCaptureSubmitMutation>;
export type MatchReportCaptureSubmitMutationOptions = Apollo.BaseMutationOptions<MatchReportCaptureSubmitMutation, MatchReportCaptureSubmitMutationVariables>;
export const MatchReportCapturePublishDocument = gql`
    mutation MatchReportCapturePublish($input: PublishMatchReportInput!) {
  publishMatchReport(input: $input) {
    ...MatchReportCaptureReport
  }
}
    ${MatchReportCaptureReportFragmentDoc}`;
export type MatchReportCapturePublishMutationFn = Apollo.MutationFunction<MatchReportCapturePublishMutation, MatchReportCapturePublishMutationVariables>;

/**
 * __useMatchReportCapturePublishMutation__
 *
 * To run a mutation, you first call `useMatchReportCapturePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCapturePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchReportCapturePublishMutation, { data, loading, error }] = useMatchReportCapturePublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchReportCapturePublishMutation(baseOptions?: Apollo.MutationHookOptions<MatchReportCapturePublishMutation, MatchReportCapturePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchReportCapturePublishMutation, MatchReportCapturePublishMutationVariables>(MatchReportCapturePublishDocument, options);
      }
export type MatchReportCapturePublishMutationHookResult = ReturnType<typeof useMatchReportCapturePublishMutation>;
export type MatchReportCapturePublishMutationResult = Apollo.MutationResult<MatchReportCapturePublishMutation>;
export type MatchReportCapturePublishMutationOptions = Apollo.BaseMutationOptions<MatchReportCapturePublishMutation, MatchReportCapturePublishMutationVariables>;
export const MatchReportCaptureDisciplineSignalsDocument = gql`
    query MatchReportCaptureDisciplineSignals($playerIds: [ID!]!) {
  listPlayerDisciplineSignals(playerIds: $playerIds) {
    ...MatchReportCaptureDisciplineSignal
  }
}
    ${MatchReportCaptureDisciplineSignalFragmentDoc}`;

/**
 * __useMatchReportCaptureDisciplineSignalsQuery__
 *
 * To run a query within a React component, call `useMatchReportCaptureDisciplineSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchReportCaptureDisciplineSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchReportCaptureDisciplineSignalsQuery({
 *   variables: {
 *      playerIds: // value for 'playerIds'
 *   },
 * });
 */
export function useMatchReportCaptureDisciplineSignalsQuery(baseOptions: Apollo.QueryHookOptions<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables> & ({ variables: MatchReportCaptureDisciplineSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>(MatchReportCaptureDisciplineSignalsDocument, options);
      }
export function useMatchReportCaptureDisciplineSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>(MatchReportCaptureDisciplineSignalsDocument, options);
        }
// @ts-ignore
export function useMatchReportCaptureDisciplineSignalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>;
export function useMatchReportCaptureDisciplineSignalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportCaptureDisciplineSignalsQuery | undefined, MatchReportCaptureDisciplineSignalsQueryVariables>;
export function useMatchReportCaptureDisciplineSignalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>(MatchReportCaptureDisciplineSignalsDocument, options);
        }
export type MatchReportCaptureDisciplineSignalsQueryHookResult = ReturnType<typeof useMatchReportCaptureDisciplineSignalsQuery>;
export type MatchReportCaptureDisciplineSignalsLazyQueryHookResult = ReturnType<typeof useMatchReportCaptureDisciplineSignalsLazyQuery>;
export type MatchReportCaptureDisciplineSignalsSuspenseQueryHookResult = ReturnType<typeof useMatchReportCaptureDisciplineSignalsSuspenseQuery>;
export type MatchReportCaptureDisciplineSignalsQueryResult = Apollo.QueryResult<MatchReportCaptureDisciplineSignalsQuery, MatchReportCaptureDisciplineSignalsQueryVariables>;
export const MatchReportViewReportDocument = gql`
    query MatchReportViewReport($id: ID!) {
  getMatchReport(id: $id) {
    id
    status
    watchMode
    submittedAt
    updatedAt
    playerCount
    notedCount
    tickedCount
    scoredCount
    squadSize
    match {
      id
      scheduledDate
      startTime
      timeZone
      venue
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      league {
        id
        name
      }
    }
    scoutUser {
      id
      displayName
    }
    scouts {
      id
      displayName
    }
    playerEvaluations {
      id
      isNoted
      isStarter
      performanceScore
      potentialScore
      note
      shirtNumber
      player {
        id
        name
        knownName
        positions {
          id
          abbreviation
        }
        team {
          id
          name
        }
        nationality {
          id
          name
        }
      }
      team {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMatchReportViewReportQuery__
 *
 * To run a query within a React component, call `useMatchReportViewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchReportViewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchReportViewReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchReportViewReportQuery(baseOptions: Apollo.QueryHookOptions<MatchReportViewReportQuery, MatchReportViewReportQueryVariables> & ({ variables: MatchReportViewReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>(MatchReportViewReportDocument, options);
      }
export function useMatchReportViewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>(MatchReportViewReportDocument, options);
        }
// @ts-ignore
export function useMatchReportViewReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>;
export function useMatchReportViewReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>): Apollo.UseSuspenseQueryResult<MatchReportViewReportQuery | undefined, MatchReportViewReportQueryVariables>;
export function useMatchReportViewReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>(MatchReportViewReportDocument, options);
        }
export type MatchReportViewReportQueryHookResult = ReturnType<typeof useMatchReportViewReportQuery>;
export type MatchReportViewReportLazyQueryHookResult = ReturnType<typeof useMatchReportViewReportLazyQuery>;
export type MatchReportViewReportSuspenseQueryHookResult = ReturnType<typeof useMatchReportViewReportSuspenseQuery>;
export type MatchReportViewReportQueryResult = Apollo.QueryResult<MatchReportViewReportQuery, MatchReportViewReportQueryVariables>;
export const NotesGetNoteDocument = gql`
    query NotesGetNote($id: ID!) {
  getNote(id: $id) {
    ...NotesNote
  }
}
    ${NotesNoteFragmentDoc}`;

/**
 * __useNotesGetNoteQuery__
 *
 * To run a query within a React component, call `useNotesGetNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesGetNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesGetNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotesGetNoteQuery(baseOptions: Apollo.QueryHookOptions<NotesGetNoteQuery, NotesGetNoteQueryVariables> & ({ variables: NotesGetNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesGetNoteQuery, NotesGetNoteQueryVariables>(NotesGetNoteDocument, options);
      }
export function useNotesGetNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesGetNoteQuery, NotesGetNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesGetNoteQuery, NotesGetNoteQueryVariables>(NotesGetNoteDocument, options);
        }
// @ts-ignore
export function useNotesGetNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesGetNoteQuery, NotesGetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<NotesGetNoteQuery, NotesGetNoteQueryVariables>;
export function useNotesGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesGetNoteQuery, NotesGetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<NotesGetNoteQuery | undefined, NotesGetNoteQueryVariables>;
export function useNotesGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesGetNoteQuery, NotesGetNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesGetNoteQuery, NotesGetNoteQueryVariables>(NotesGetNoteDocument, options);
        }
export type NotesGetNoteQueryHookResult = ReturnType<typeof useNotesGetNoteQuery>;
export type NotesGetNoteLazyQueryHookResult = ReturnType<typeof useNotesGetNoteLazyQuery>;
export type NotesGetNoteSuspenseQueryHookResult = ReturnType<typeof useNotesGetNoteSuspenseQuery>;
export type NotesGetNoteQueryResult = Apollo.QueryResult<NotesGetNoteQuery, NotesGetNoteQueryVariables>;
export const NotesListNotesByPlayerIdDocument = gql`
    query NotesListNotesByPlayerId($playerId: ID!, $first: Int, $after: String) {
  listNotesByPlayerId(playerId: $playerId, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...NotesNote
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NotesNoteFragmentDoc}`;

/**
 * __useNotesListNotesByPlayerIdQuery__
 *
 * To run a query within a React component, call `useNotesListNotesByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesListNotesByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesListNotesByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNotesListNotesByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables> & ({ variables: NotesListNotesByPlayerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>(NotesListNotesByPlayerIdDocument, options);
      }
export function useNotesListNotesByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>(NotesListNotesByPlayerIdDocument, options);
        }
// @ts-ignore
export function useNotesListNotesByPlayerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>;
export function useNotesListNotesByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<NotesListNotesByPlayerIdQuery | undefined, NotesListNotesByPlayerIdQueryVariables>;
export function useNotesListNotesByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>(NotesListNotesByPlayerIdDocument, options);
        }
export type NotesListNotesByPlayerIdQueryHookResult = ReturnType<typeof useNotesListNotesByPlayerIdQuery>;
export type NotesListNotesByPlayerIdLazyQueryHookResult = ReturnType<typeof useNotesListNotesByPlayerIdLazyQuery>;
export type NotesListNotesByPlayerIdSuspenseQueryHookResult = ReturnType<typeof useNotesListNotesByPlayerIdSuspenseQuery>;
export type NotesListNotesByPlayerIdQueryResult = Apollo.QueryResult<NotesListNotesByPlayerIdQuery, NotesListNotesByPlayerIdQueryVariables>;
export const NotesCreateNoteDocument = gql`
    mutation NotesCreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    ...NotesNote
  }
}
    ${NotesNoteFragmentDoc}`;
export type NotesCreateNoteMutationFn = Apollo.MutationFunction<NotesCreateNoteMutation, NotesCreateNoteMutationVariables>;

/**
 * __useNotesCreateNoteMutation__
 *
 * To run a mutation, you first call `useNotesCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesCreateNoteMutation, { data, loading, error }] = useNotesCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotesCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotesCreateNoteMutation, NotesCreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesCreateNoteMutation, NotesCreateNoteMutationVariables>(NotesCreateNoteDocument, options);
      }
export type NotesCreateNoteMutationHookResult = ReturnType<typeof useNotesCreateNoteMutation>;
export type NotesCreateNoteMutationResult = Apollo.MutationResult<NotesCreateNoteMutation>;
export type NotesCreateNoteMutationOptions = Apollo.BaseMutationOptions<NotesCreateNoteMutation, NotesCreateNoteMutationVariables>;
export const NotesUpdateNoteDocument = gql`
    mutation NotesUpdateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    ...NotesNote
  }
}
    ${NotesNoteFragmentDoc}`;
export type NotesUpdateNoteMutationFn = Apollo.MutationFunction<NotesUpdateNoteMutation, NotesUpdateNoteMutationVariables>;

/**
 * __useNotesUpdateNoteMutation__
 *
 * To run a mutation, you first call `useNotesUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesUpdateNoteMutation, { data, loading, error }] = useNotesUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotesUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotesUpdateNoteMutation, NotesUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesUpdateNoteMutation, NotesUpdateNoteMutationVariables>(NotesUpdateNoteDocument, options);
      }
export type NotesUpdateNoteMutationHookResult = ReturnType<typeof useNotesUpdateNoteMutation>;
export type NotesUpdateNoteMutationResult = Apollo.MutationResult<NotesUpdateNoteMutation>;
export type NotesUpdateNoteMutationOptions = Apollo.BaseMutationOptions<NotesUpdateNoteMutation, NotesUpdateNoteMutationVariables>;
export const NotesDeleteNoteDocument = gql`
    mutation NotesDeleteNote($input: DeleteNoteInput!) {
  deleteNote(input: $input) {
    ...NotesNote
  }
}
    ${NotesNoteFragmentDoc}`;
export type NotesDeleteNoteMutationFn = Apollo.MutationFunction<NotesDeleteNoteMutation, NotesDeleteNoteMutationVariables>;

/**
 * __useNotesDeleteNoteMutation__
 *
 * To run a mutation, you first call `useNotesDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesDeleteNoteMutation, { data, loading, error }] = useNotesDeleteNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotesDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotesDeleteNoteMutation, NotesDeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesDeleteNoteMutation, NotesDeleteNoteMutationVariables>(NotesDeleteNoteDocument, options);
      }
export type NotesDeleteNoteMutationHookResult = ReturnType<typeof useNotesDeleteNoteMutation>;
export type NotesDeleteNoteMutationResult = Apollo.MutationResult<NotesDeleteNoteMutation>;
export type NotesDeleteNoteMutationOptions = Apollo.BaseMutationOptions<NotesDeleteNoteMutation, NotesDeleteNoteMutationVariables>;
export const NotesShareNoteDocument = gql`
    mutation NotesShareNote($input: ShareNoteInput!) {
  shareNote(input: $input)
}
    `;
export type NotesShareNoteMutationFn = Apollo.MutationFunction<NotesShareNoteMutation, NotesShareNoteMutationVariables>;

/**
 * __useNotesShareNoteMutation__
 *
 * To run a mutation, you first call `useNotesShareNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesShareNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesShareNoteMutation, { data, loading, error }] = useNotesShareNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotesShareNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotesShareNoteMutation, NotesShareNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesShareNoteMutation, NotesShareNoteMutationVariables>(NotesShareNoteDocument, options);
      }
export type NotesShareNoteMutationHookResult = ReturnType<typeof useNotesShareNoteMutation>;
export type NotesShareNoteMutationResult = Apollo.MutationResult<NotesShareNoteMutation>;
export type NotesShareNoteMutationOptions = Apollo.BaseMutationOptions<NotesShareNoteMutation, NotesShareNoteMutationVariables>;
export const NotesListNoteSharesDocument = gql`
    query NotesListNoteShares($noteId: ID!) {
  listNoteShares(noteId: $noteId) {
    ...NotesNoteShare
  }
}
    ${NotesNoteShareFragmentDoc}`;

/**
 * __useNotesListNoteSharesQuery__
 *
 * To run a query within a React component, call `useNotesListNoteSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesListNoteSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesListNoteSharesQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useNotesListNoteSharesQuery(baseOptions: Apollo.QueryHookOptions<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables> & ({ variables: NotesListNoteSharesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>(NotesListNoteSharesDocument, options);
      }
export function useNotesListNoteSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>(NotesListNoteSharesDocument, options);
        }
// @ts-ignore
export function useNotesListNoteSharesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>): Apollo.UseSuspenseQueryResult<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>;
export function useNotesListNoteSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>): Apollo.UseSuspenseQueryResult<NotesListNoteSharesQuery | undefined, NotesListNoteSharesQueryVariables>;
export function useNotesListNoteSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>(NotesListNoteSharesDocument, options);
        }
export type NotesListNoteSharesQueryHookResult = ReturnType<typeof useNotesListNoteSharesQuery>;
export type NotesListNoteSharesLazyQueryHookResult = ReturnType<typeof useNotesListNoteSharesLazyQuery>;
export type NotesListNoteSharesSuspenseQueryHookResult = ReturnType<typeof useNotesListNoteSharesSuspenseQuery>;
export type NotesListNoteSharesQueryResult = Apollo.QueryResult<NotesListNoteSharesQuery, NotesListNoteSharesQueryVariables>;
export const NotesRevokeNoteShareDocument = gql`
    mutation NotesRevokeNoteShare($input: RevokeNoteShareInput!) {
  revokeNoteShare(input: $input)
}
    `;
export type NotesRevokeNoteShareMutationFn = Apollo.MutationFunction<NotesRevokeNoteShareMutation, NotesRevokeNoteShareMutationVariables>;

/**
 * __useNotesRevokeNoteShareMutation__
 *
 * To run a mutation, you first call `useNotesRevokeNoteShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesRevokeNoteShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesRevokeNoteShareMutation, { data, loading, error }] = useNotesRevokeNoteShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotesRevokeNoteShareMutation(baseOptions?: Apollo.MutationHookOptions<NotesRevokeNoteShareMutation, NotesRevokeNoteShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesRevokeNoteShareMutation, NotesRevokeNoteShareMutationVariables>(NotesRevokeNoteShareDocument, options);
      }
export type NotesRevokeNoteShareMutationHookResult = ReturnType<typeof useNotesRevokeNoteShareMutation>;
export type NotesRevokeNoteShareMutationResult = Apollo.MutationResult<NotesRevokeNoteShareMutation>;
export type NotesRevokeNoteShareMutationOptions = Apollo.BaseMutationOptions<NotesRevokeNoteShareMutation, NotesRevokeNoteShareMutationVariables>;
export const NotesSetNoteVisibilityDocument = gql`
    mutation NotesSetNoteVisibility($noteId: ID!, $isPublic: Boolean!) {
  setNoteVisibility(noteId: $noteId, isPublic: $isPublic) {
    ...NotesNote
  }
}
    ${NotesNoteFragmentDoc}`;
export type NotesSetNoteVisibilityMutationFn = Apollo.MutationFunction<NotesSetNoteVisibilityMutation, NotesSetNoteVisibilityMutationVariables>;

/**
 * __useNotesSetNoteVisibilityMutation__
 *
 * To run a mutation, you first call `useNotesSetNoteVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesSetNoteVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesSetNoteVisibilityMutation, { data, loading, error }] = useNotesSetNoteVisibilityMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      isPublic: // value for 'isPublic'
 *   },
 * });
 */
export function useNotesSetNoteVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<NotesSetNoteVisibilityMutation, NotesSetNoteVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesSetNoteVisibilityMutation, NotesSetNoteVisibilityMutationVariables>(NotesSetNoteVisibilityDocument, options);
      }
export type NotesSetNoteVisibilityMutationHookResult = ReturnType<typeof useNotesSetNoteVisibilityMutation>;
export type NotesSetNoteVisibilityMutationResult = Apollo.MutationResult<NotesSetNoteVisibilityMutation>;
export type NotesSetNoteVisibilityMutationOptions = Apollo.BaseMutationOptions<NotesSetNoteVisibilityMutation, NotesSetNoteVisibilityMutationVariables>;
export const UserNotificationPreferencesDocument = gql`
    query UserNotificationPreferences {
  userNotificationPreferences {
    ...NotificationSettingPreference
  }
}
    ${NotificationSettingPreferenceFragmentDoc}`;

/**
 * __useUserNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useUserNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>(UserNotificationPreferencesDocument, options);
      }
export function useUserNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>(UserNotificationPreferencesDocument, options);
        }
// @ts-ignore
export function useUserNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>;
export function useUserNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<UserNotificationPreferencesQuery | undefined, UserNotificationPreferencesQueryVariables>;
export function useUserNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>(UserNotificationPreferencesDocument, options);
        }
export type UserNotificationPreferencesQueryHookResult = ReturnType<typeof useUserNotificationPreferencesQuery>;
export type UserNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useUserNotificationPreferencesLazyQuery>;
export type UserNotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useUserNotificationPreferencesSuspenseQuery>;
export type UserNotificationPreferencesQueryResult = Apollo.QueryResult<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>;
export const UpdateAllNotificationPreferencesDocument = gql`
    mutation UpdateAllNotificationPreferences($enabled: Boolean!) {
  updateAllNotificationPreferences(enabled: $enabled)
}
    `;
export type UpdateAllNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateAllNotificationPreferencesMutation, UpdateAllNotificationPreferencesMutationVariables>;

/**
 * __useUpdateAllNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateAllNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllNotificationPreferencesMutation, { data, loading, error }] = useUpdateAllNotificationPreferencesMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateAllNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllNotificationPreferencesMutation, UpdateAllNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllNotificationPreferencesMutation, UpdateAllNotificationPreferencesMutationVariables>(UpdateAllNotificationPreferencesDocument, options);
      }
export type UpdateAllNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateAllNotificationPreferencesMutation>;
export type UpdateAllNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateAllNotificationPreferencesMutation>;
export type UpdateAllNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateAllNotificationPreferencesMutation, UpdateAllNotificationPreferencesMutationVariables>;
export const UpdateNotificationPreferenceDocument = gql`
    mutation UpdateNotificationPreference($activityTypeCode: String!, $enabled: Boolean!) {
  updateNotificationPreference(
    activityTypeCode: $activityTypeCode
    enabled: $enabled
  ) {
    ...NotificationSettingPreference
  }
}
    ${NotificationSettingPreferenceFragmentDoc}`;
export type UpdateNotificationPreferenceMutationFn = Apollo.MutationFunction<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>;

/**
 * __useUpdateNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferenceMutation, { data, loading, error }] = useUpdateNotificationPreferenceMutation({
 *   variables: {
 *      activityTypeCode: // value for 'activityTypeCode'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>(UpdateNotificationPreferenceDocument, options);
      }
export type UpdateNotificationPreferenceMutationHookResult = ReturnType<typeof useUpdateNotificationPreferenceMutation>;
export type UpdateNotificationPreferenceMutationResult = Apollo.MutationResult<UpdateNotificationPreferenceMutation>;
export type UpdateNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>;
export const PlayerDetailSupportedLocalesDocument = gql`
    query PlayerDetailSupportedLocales {
  supportedLocales
}
    `;

/**
 * __usePlayerDetailSupportedLocalesQuery__
 *
 * To run a query within a React component, call `usePlayerDetailSupportedLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailSupportedLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailSupportedLocalesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayerDetailSupportedLocalesQuery(baseOptions?: Apollo.QueryHookOptions<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>(PlayerDetailSupportedLocalesDocument, options);
      }
export function usePlayerDetailSupportedLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>(PlayerDetailSupportedLocalesDocument, options);
        }
// @ts-ignore
export function usePlayerDetailSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>;
export function usePlayerDetailSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailSupportedLocalesQuery | undefined, PlayerDetailSupportedLocalesQueryVariables>;
export function usePlayerDetailSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>(PlayerDetailSupportedLocalesDocument, options);
        }
export type PlayerDetailSupportedLocalesQueryHookResult = ReturnType<typeof usePlayerDetailSupportedLocalesQuery>;
export type PlayerDetailSupportedLocalesLazyQueryHookResult = ReturnType<typeof usePlayerDetailSupportedLocalesLazyQuery>;
export type PlayerDetailSupportedLocalesSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailSupportedLocalesSuspenseQuery>;
export type PlayerDetailSupportedLocalesQueryResult = Apollo.QueryResult<PlayerDetailSupportedLocalesQuery, PlayerDetailSupportedLocalesQueryVariables>;
export const PlayerDetailGetPlayerDocument = gql`
    query PlayerDetailGetPlayer($id: ID!) {
  getPlayer(id: $id) {
    ...PlayerDetailPlayerMeta
  }
}
    ${PlayerDetailPlayerMetaFragmentDoc}`;

/**
 * __usePlayerDetailGetPlayerQuery__
 *
 * To run a query within a React component, call `usePlayerDetailGetPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailGetPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailGetPlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlayerDetailGetPlayerQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables> & ({ variables: PlayerDetailGetPlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>(PlayerDetailGetPlayerDocument, options);
      }
export function usePlayerDetailGetPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>(PlayerDetailGetPlayerDocument, options);
        }
// @ts-ignore
export function usePlayerDetailGetPlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>;
export function usePlayerDetailGetPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetPlayerQuery | undefined, PlayerDetailGetPlayerQueryVariables>;
export function usePlayerDetailGetPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>(PlayerDetailGetPlayerDocument, options);
        }
export type PlayerDetailGetPlayerQueryHookResult = ReturnType<typeof usePlayerDetailGetPlayerQuery>;
export type PlayerDetailGetPlayerLazyQueryHookResult = ReturnType<typeof usePlayerDetailGetPlayerLazyQuery>;
export type PlayerDetailGetPlayerSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailGetPlayerSuspenseQuery>;
export type PlayerDetailGetPlayerQueryResult = Apollo.QueryResult<PlayerDetailGetPlayerQuery, PlayerDetailGetPlayerQueryVariables>;
export const PlayerDetailListPlayersByTeamIdsAndPositionIdsDocument = gql`
    query PlayerDetailListPlayersByTeamIdsAndPositionIds($first: Int, $after: String, $teamIds: [ID!]!, $positionIds: [ID!]!) {
  listPlayersByTeamIdsAndPositionIds(
    first: $first
    after: $after
    teamIds: $teamIds
    positionIds: $positionIds
  ) {
    ...PlayerDetailChartPlayerConection
  }
}
    ${PlayerDetailChartPlayerConectionFragmentDoc}`;

/**
 * __usePlayerDetailListPlayersByTeamIdsAndPositionIdsQuery__
 *
 * To run a query within a React component, call `usePlayerDetailListPlayersByTeamIdsAndPositionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailListPlayersByTeamIdsAndPositionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailListPlayersByTeamIdsAndPositionIdsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      teamIds: // value for 'teamIds'
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function usePlayerDetailListPlayersByTeamIdsAndPositionIdsQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables> & ({ variables: PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>(PlayerDetailListPlayersByTeamIdsAndPositionIdsDocument, options);
      }
export function usePlayerDetailListPlayersByTeamIdsAndPositionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>(PlayerDetailListPlayersByTeamIdsAndPositionIdsDocument, options);
        }
// @ts-ignore
export function usePlayerDetailListPlayersByTeamIdsAndPositionIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>;
export function usePlayerDetailListPlayersByTeamIdsAndPositionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery | undefined, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>;
export function usePlayerDetailListPlayersByTeamIdsAndPositionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>(PlayerDetailListPlayersByTeamIdsAndPositionIdsDocument, options);
        }
export type PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryHookResult = ReturnType<typeof usePlayerDetailListPlayersByTeamIdsAndPositionIdsQuery>;
export type PlayerDetailListPlayersByTeamIdsAndPositionIdsLazyQueryHookResult = ReturnType<typeof usePlayerDetailListPlayersByTeamIdsAndPositionIdsLazyQuery>;
export type PlayerDetailListPlayersByTeamIdsAndPositionIdsSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailListPlayersByTeamIdsAndPositionIdsSuspenseQuery>;
export type PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryResult = Apollo.QueryResult<PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery, PlayerDetailListPlayersByTeamIdsAndPositionIdsQueryVariables>;
export const PlayerDetailGetPlayerKanbanStatusDocument = gql`
    query PlayerDetailGetPlayerKanbanStatus {
  listMyKanbanBoards {
    edges {
      node {
        id
        name
        phases {
          id
          name
          position
          cards {
            id
            player {
              id
            }
            kanbanPhase {
              id
              name
              position
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePlayerDetailGetPlayerKanbanStatusQuery__
 *
 * To run a query within a React component, call `usePlayerDetailGetPlayerKanbanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailGetPlayerKanbanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailGetPlayerKanbanStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayerDetailGetPlayerKanbanStatusQuery(baseOptions?: Apollo.QueryHookOptions<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>(PlayerDetailGetPlayerKanbanStatusDocument, options);
      }
export function usePlayerDetailGetPlayerKanbanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>(PlayerDetailGetPlayerKanbanStatusDocument, options);
        }
// @ts-ignore
export function usePlayerDetailGetPlayerKanbanStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>;
export function usePlayerDetailGetPlayerKanbanStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetPlayerKanbanStatusQuery | undefined, PlayerDetailGetPlayerKanbanStatusQueryVariables>;
export function usePlayerDetailGetPlayerKanbanStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>(PlayerDetailGetPlayerKanbanStatusDocument, options);
        }
export type PlayerDetailGetPlayerKanbanStatusQueryHookResult = ReturnType<typeof usePlayerDetailGetPlayerKanbanStatusQuery>;
export type PlayerDetailGetPlayerKanbanStatusLazyQueryHookResult = ReturnType<typeof usePlayerDetailGetPlayerKanbanStatusLazyQuery>;
export type PlayerDetailGetPlayerKanbanStatusSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailGetPlayerKanbanStatusSuspenseQuery>;
export type PlayerDetailGetPlayerKanbanStatusQueryResult = Apollo.QueryResult<PlayerDetailGetPlayerKanbanStatusQuery, PlayerDetailGetPlayerKanbanStatusQueryVariables>;
export const PlayerDetailGetTransfersByPlayerIdDocument = gql`
    query PlayerDetailGetTransfersByPlayerId($playerId: ID!) {
  transfersByPlayerId(playerId: $playerId) {
    ...PlayerDetailTransfer
  }
}
    ${PlayerDetailTransferFragmentDoc}`;

/**
 * __usePlayerDetailGetTransfersByPlayerIdQuery__
 *
 * To run a query within a React component, call `usePlayerDetailGetTransfersByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailGetTransfersByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailGetTransfersByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayerDetailGetTransfersByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables> & ({ variables: PlayerDetailGetTransfersByPlayerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>(PlayerDetailGetTransfersByPlayerIdDocument, options);
      }
export function usePlayerDetailGetTransfersByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>(PlayerDetailGetTransfersByPlayerIdDocument, options);
        }
// @ts-ignore
export function usePlayerDetailGetTransfersByPlayerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>;
export function usePlayerDetailGetTransfersByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetTransfersByPlayerIdQuery | undefined, PlayerDetailGetTransfersByPlayerIdQueryVariables>;
export function usePlayerDetailGetTransfersByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>(PlayerDetailGetTransfersByPlayerIdDocument, options);
        }
export type PlayerDetailGetTransfersByPlayerIdQueryHookResult = ReturnType<typeof usePlayerDetailGetTransfersByPlayerIdQuery>;
export type PlayerDetailGetTransfersByPlayerIdLazyQueryHookResult = ReturnType<typeof usePlayerDetailGetTransfersByPlayerIdLazyQuery>;
export type PlayerDetailGetTransfersByPlayerIdSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailGetTransfersByPlayerIdSuspenseQuery>;
export type PlayerDetailGetTransfersByPlayerIdQueryResult = Apollo.QueryResult<PlayerDetailGetTransfersByPlayerIdQuery, PlayerDetailGetTransfersByPlayerIdQueryVariables>;
export const PlayerDetailGetInjuriesByPlayerIdDocument = gql`
    query PlayerDetailGetInjuriesByPlayerId($playerId: ID!) {
  injuriesByPlayerId(playerId: $playerId) {
    ...PlayerDetailInjury
  }
}
    ${PlayerDetailInjuryFragmentDoc}`;

/**
 * __usePlayerDetailGetInjuriesByPlayerIdQuery__
 *
 * To run a query within a React component, call `usePlayerDetailGetInjuriesByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailGetInjuriesByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailGetInjuriesByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayerDetailGetInjuriesByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables> & ({ variables: PlayerDetailGetInjuriesByPlayerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>(PlayerDetailGetInjuriesByPlayerIdDocument, options);
      }
export function usePlayerDetailGetInjuriesByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>(PlayerDetailGetInjuriesByPlayerIdDocument, options);
        }
// @ts-ignore
export function usePlayerDetailGetInjuriesByPlayerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>;
export function usePlayerDetailGetInjuriesByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetInjuriesByPlayerIdQuery | undefined, PlayerDetailGetInjuriesByPlayerIdQueryVariables>;
export function usePlayerDetailGetInjuriesByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>(PlayerDetailGetInjuriesByPlayerIdDocument, options);
        }
export type PlayerDetailGetInjuriesByPlayerIdQueryHookResult = ReturnType<typeof usePlayerDetailGetInjuriesByPlayerIdQuery>;
export type PlayerDetailGetInjuriesByPlayerIdLazyQueryHookResult = ReturnType<typeof usePlayerDetailGetInjuriesByPlayerIdLazyQuery>;
export type PlayerDetailGetInjuriesByPlayerIdSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailGetInjuriesByPlayerIdSuspenseQuery>;
export type PlayerDetailGetInjuriesByPlayerIdQueryResult = Apollo.QueryResult<PlayerDetailGetInjuriesByPlayerIdQuery, PlayerDetailGetInjuriesByPlayerIdQueryVariables>;
export const PlayerDetailListGameMetricsDocument = gql`
    query PlayerDetailListGameMetrics($playerId: ID!) {
  listGameMetrics(playerId: $playerId) {
    ...PlayerDetailGameMetrics
  }
}
    ${PlayerDetailGameMetricsFragmentDoc}`;

/**
 * __usePlayerDetailListGameMetricsQuery__
 *
 * To run a query within a React component, call `usePlayerDetailListGameMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailListGameMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailListGameMetricsQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayerDetailListGameMetricsQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables> & ({ variables: PlayerDetailListGameMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>(PlayerDetailListGameMetricsDocument, options);
      }
export function usePlayerDetailListGameMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>(PlayerDetailListGameMetricsDocument, options);
        }
// @ts-ignore
export function usePlayerDetailListGameMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>;
export function usePlayerDetailListGameMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListGameMetricsQuery | undefined, PlayerDetailListGameMetricsQueryVariables>;
export function usePlayerDetailListGameMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>(PlayerDetailListGameMetricsDocument, options);
        }
export type PlayerDetailListGameMetricsQueryHookResult = ReturnType<typeof usePlayerDetailListGameMetricsQuery>;
export type PlayerDetailListGameMetricsLazyQueryHookResult = ReturnType<typeof usePlayerDetailListGameMetricsLazyQuery>;
export type PlayerDetailListGameMetricsSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailListGameMetricsSuspenseQuery>;
export type PlayerDetailListGameMetricsQueryResult = Apollo.QueryResult<PlayerDetailListGameMetricsQuery, PlayerDetailListGameMetricsQueryVariables>;
export const PlayerDetailListGameProviderMetricsDocument = gql`
    query PlayerDetailListGameProviderMetrics($playerId: ID!) {
  listGameProviderMetrics(playerId: $playerId) {
    ...PlayerDetailGameProviderMetrics
  }
}
    ${PlayerDetailGameProviderMetricsFragmentDoc}`;

/**
 * __usePlayerDetailListGameProviderMetricsQuery__
 *
 * To run a query within a React component, call `usePlayerDetailListGameProviderMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailListGameProviderMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailListGameProviderMetricsQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayerDetailListGameProviderMetricsQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables> & ({ variables: PlayerDetailListGameProviderMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>(PlayerDetailListGameProviderMetricsDocument, options);
      }
export function usePlayerDetailListGameProviderMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>(PlayerDetailListGameProviderMetricsDocument, options);
        }
// @ts-ignore
export function usePlayerDetailListGameProviderMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>;
export function usePlayerDetailListGameProviderMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListGameProviderMetricsQuery | undefined, PlayerDetailListGameProviderMetricsQueryVariables>;
export function usePlayerDetailListGameProviderMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>(PlayerDetailListGameProviderMetricsDocument, options);
        }
export type PlayerDetailListGameProviderMetricsQueryHookResult = ReturnType<typeof usePlayerDetailListGameProviderMetricsQuery>;
export type PlayerDetailListGameProviderMetricsLazyQueryHookResult = ReturnType<typeof usePlayerDetailListGameProviderMetricsLazyQuery>;
export type PlayerDetailListGameProviderMetricsSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailListGameProviderMetricsSuspenseQuery>;
export type PlayerDetailListGameProviderMetricsQueryResult = Apollo.QueryResult<PlayerDetailListGameProviderMetricsQuery, PlayerDetailListGameProviderMetricsQueryVariables>;
export const PlayerDetailListPlayerMatchesDocument = gql`
    query PlayerDetailListPlayerMatches($playerId: ID!, $first: Int, $after: String) {
  listPlayerMatches(playerId: $playerId, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...PlayerDetailPlayerMatch
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PlayerDetailPlayerMatchFragmentDoc}`;

/**
 * __usePlayerDetailListPlayerMatchesQuery__
 *
 * To run a query within a React component, call `usePlayerDetailListPlayerMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailListPlayerMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailListPlayerMatchesQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePlayerDetailListPlayerMatchesQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables> & ({ variables: PlayerDetailListPlayerMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>(PlayerDetailListPlayerMatchesDocument, options);
      }
export function usePlayerDetailListPlayerMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>(PlayerDetailListPlayerMatchesDocument, options);
        }
// @ts-ignore
export function usePlayerDetailListPlayerMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>;
export function usePlayerDetailListPlayerMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListPlayerMatchesQuery | undefined, PlayerDetailListPlayerMatchesQueryVariables>;
export function usePlayerDetailListPlayerMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>(PlayerDetailListPlayerMatchesDocument, options);
        }
export type PlayerDetailListPlayerMatchesQueryHookResult = ReturnType<typeof usePlayerDetailListPlayerMatchesQuery>;
export type PlayerDetailListPlayerMatchesLazyQueryHookResult = ReturnType<typeof usePlayerDetailListPlayerMatchesLazyQuery>;
export type PlayerDetailListPlayerMatchesSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailListPlayerMatchesSuspenseQuery>;
export type PlayerDetailListPlayerMatchesQueryResult = Apollo.QueryResult<PlayerDetailListPlayerMatchesQuery, PlayerDetailListPlayerMatchesQueryVariables>;
export const PerformanceAnalyticsFilterPlayersDocument = gql`
    query PerformanceAnalyticsFilterPlayers($filter: PlayerAdvancedFilterInput!, $first: Int) {
  filterPlayers(filter: $filter, first: $first) {
    edges {
      node {
        ...PerformanceAnalyticsPlayerScores
      }
    }
  }
}
    ${PerformanceAnalyticsPlayerScoresFragmentDoc}`;

/**
 * __usePerformanceAnalyticsFilterPlayersQuery__
 *
 * To run a query within a React component, call `usePerformanceAnalyticsFilterPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceAnalyticsFilterPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceAnalyticsFilterPlayersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePerformanceAnalyticsFilterPlayersQuery(baseOptions: Apollo.QueryHookOptions<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables> & ({ variables: PerformanceAnalyticsFilterPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>(PerformanceAnalyticsFilterPlayersDocument, options);
      }
export function usePerformanceAnalyticsFilterPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>(PerformanceAnalyticsFilterPlayersDocument, options);
        }
// @ts-ignore
export function usePerformanceAnalyticsFilterPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>;
export function usePerformanceAnalyticsFilterPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceAnalyticsFilterPlayersQuery | undefined, PerformanceAnalyticsFilterPlayersQueryVariables>;
export function usePerformanceAnalyticsFilterPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>(PerformanceAnalyticsFilterPlayersDocument, options);
        }
export type PerformanceAnalyticsFilterPlayersQueryHookResult = ReturnType<typeof usePerformanceAnalyticsFilterPlayersQuery>;
export type PerformanceAnalyticsFilterPlayersLazyQueryHookResult = ReturnType<typeof usePerformanceAnalyticsFilterPlayersLazyQuery>;
export type PerformanceAnalyticsFilterPlayersSuspenseQueryHookResult = ReturnType<typeof usePerformanceAnalyticsFilterPlayersSuspenseQuery>;
export type PerformanceAnalyticsFilterPlayersQueryResult = Apollo.QueryResult<PerformanceAnalyticsFilterPlayersQuery, PerformanceAnalyticsFilterPlayersQueryVariables>;
export const PerformanceAnalyticsGetComparisonPlayerDocument = gql`
    query PerformanceAnalyticsGetComparisonPlayer($id: ID!) {
  getPlayer(id: $id) {
    ...PerformanceAnalyticsPlayerScores
  }
}
    ${PerformanceAnalyticsPlayerScoresFragmentDoc}`;

/**
 * __usePerformanceAnalyticsGetComparisonPlayerQuery__
 *
 * To run a query within a React component, call `usePerformanceAnalyticsGetComparisonPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceAnalyticsGetComparisonPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceAnalyticsGetComparisonPlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePerformanceAnalyticsGetComparisonPlayerQuery(baseOptions: Apollo.QueryHookOptions<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables> & ({ variables: PerformanceAnalyticsGetComparisonPlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>(PerformanceAnalyticsGetComparisonPlayerDocument, options);
      }
export function usePerformanceAnalyticsGetComparisonPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>(PerformanceAnalyticsGetComparisonPlayerDocument, options);
        }
// @ts-ignore
export function usePerformanceAnalyticsGetComparisonPlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>;
export function usePerformanceAnalyticsGetComparisonPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceAnalyticsGetComparisonPlayerQuery | undefined, PerformanceAnalyticsGetComparisonPlayerQueryVariables>;
export function usePerformanceAnalyticsGetComparisonPlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>(PerformanceAnalyticsGetComparisonPlayerDocument, options);
        }
export type PerformanceAnalyticsGetComparisonPlayerQueryHookResult = ReturnType<typeof usePerformanceAnalyticsGetComparisonPlayerQuery>;
export type PerformanceAnalyticsGetComparisonPlayerLazyQueryHookResult = ReturnType<typeof usePerformanceAnalyticsGetComparisonPlayerLazyQuery>;
export type PerformanceAnalyticsGetComparisonPlayerSuspenseQueryHookResult = ReturnType<typeof usePerformanceAnalyticsGetComparisonPlayerSuspenseQuery>;
export type PerformanceAnalyticsGetComparisonPlayerQueryResult = Apollo.QueryResult<PerformanceAnalyticsGetComparisonPlayerQuery, PerformanceAnalyticsGetComparisonPlayerQueryVariables>;
export const PlayerDetailGetSeasonMetricAveragesDocument = gql`
    query PlayerDetailGetSeasonMetricAverages($teamIds: [ID!]!, $positionIds: [ID!]!, $excludePlayerId: ID!) {
  getSeasonMetricAverages(
    teamIds: $teamIds
    positionIds: $positionIds
    excludePlayerId: $excludePlayerId
  ) {
    passing {
      ...PlayerDetailSeasonMetricAverages
    }
    dribbling {
      ...PlayerDetailSeasonMetricAverages
    }
    carrying {
      ...PlayerDetailSeasonMetricAverages
    }
    shooting {
      ...PlayerDetailSeasonMetricAverages
    }
    gkPassing {
      ...PlayerDetailSeasonMetricAverages
    }
    gkShotStopping {
      ...PlayerDetailSeasonMetricAverages
    }
    gkPositioning {
      ...PlayerDetailSeasonMetricAverages
    }
    aerials {
      ...PlayerDetailSeasonMetricAverages
    }
    anticipating {
      ...PlayerDetailSeasonMetricAverages
    }
    assisting {
      ...PlayerDetailSeasonMetricAverages
    }
    buildup {
      ...PlayerDetailSeasonMetricAverages
    }
    creating {
      ...PlayerDetailSeasonMetricAverages
    }
    crossing {
      ...PlayerDetailSeasonMetricAverages
    }
    defensiveAerials {
      ...PlayerDetailSeasonMetricAverages
    }
    finishing {
      ...PlayerDetailSeasonMetricAverages
    }
    heading {
      ...PlayerDetailSeasonMetricAverages
    }
    pressing {
      ...PlayerDetailSeasonMetricAverages
    }
    proactiveDefending {
      ...PlayerDetailSeasonMetricAverages
    }
    setPieceDelivering {
      ...PlayerDetailSeasonMetricAverages
    }
    shotPlacement {
      ...PlayerDetailSeasonMetricAverages
    }
    tackling {
      ...PlayerDetailSeasonMetricAverages
    }
    gkCrossIntercept {
      ...PlayerDetailSeasonMetricAverages
    }
    gkKeeperSweeper {
      ...PlayerDetailSeasonMetricAverages
    }
  }
}
    ${PlayerDetailSeasonMetricAveragesFragmentDoc}`;

/**
 * __usePlayerDetailGetSeasonMetricAveragesQuery__
 *
 * To run a query within a React component, call `usePlayerDetailGetSeasonMetricAveragesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailGetSeasonMetricAveragesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailGetSeasonMetricAveragesQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *      positionIds: // value for 'positionIds'
 *      excludePlayerId: // value for 'excludePlayerId'
 *   },
 * });
 */
export function usePlayerDetailGetSeasonMetricAveragesQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables> & ({ variables: PlayerDetailGetSeasonMetricAveragesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>(PlayerDetailGetSeasonMetricAveragesDocument, options);
      }
export function usePlayerDetailGetSeasonMetricAveragesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>(PlayerDetailGetSeasonMetricAveragesDocument, options);
        }
// @ts-ignore
export function usePlayerDetailGetSeasonMetricAveragesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>;
export function usePlayerDetailGetSeasonMetricAveragesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailGetSeasonMetricAveragesQuery | undefined, PlayerDetailGetSeasonMetricAveragesQueryVariables>;
export function usePlayerDetailGetSeasonMetricAveragesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>(PlayerDetailGetSeasonMetricAveragesDocument, options);
        }
export type PlayerDetailGetSeasonMetricAveragesQueryHookResult = ReturnType<typeof usePlayerDetailGetSeasonMetricAveragesQuery>;
export type PlayerDetailGetSeasonMetricAveragesLazyQueryHookResult = ReturnType<typeof usePlayerDetailGetSeasonMetricAveragesLazyQuery>;
export type PlayerDetailGetSeasonMetricAveragesSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailGetSeasonMetricAveragesSuspenseQuery>;
export type PlayerDetailGetSeasonMetricAveragesQueryResult = Apollo.QueryResult<PlayerDetailGetSeasonMetricAveragesQuery, PlayerDetailGetSeasonMetricAveragesQueryVariables>;
export const PlayerDetailUpdateManualPlayerDocument = gql`
    mutation PlayerDetailUpdateManualPlayer($input: UpdateManualPlayerInput!) {
  updateManualPlayer(input: $input) {
    ...PlayerDetailPlayer
  }
}
    ${PlayerDetailPlayerFragmentDoc}`;
export type PlayerDetailUpdateManualPlayerMutationFn = Apollo.MutationFunction<PlayerDetailUpdateManualPlayerMutation, PlayerDetailUpdateManualPlayerMutationVariables>;

/**
 * __usePlayerDetailUpdateManualPlayerMutation__
 *
 * To run a mutation, you first call `usePlayerDetailUpdateManualPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailUpdateManualPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerDetailUpdateManualPlayerMutation, { data, loading, error }] = usePlayerDetailUpdateManualPlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerDetailUpdateManualPlayerMutation(baseOptions?: Apollo.MutationHookOptions<PlayerDetailUpdateManualPlayerMutation, PlayerDetailUpdateManualPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerDetailUpdateManualPlayerMutation, PlayerDetailUpdateManualPlayerMutationVariables>(PlayerDetailUpdateManualPlayerDocument, options);
      }
export type PlayerDetailUpdateManualPlayerMutationHookResult = ReturnType<typeof usePlayerDetailUpdateManualPlayerMutation>;
export type PlayerDetailUpdateManualPlayerMutationResult = Apollo.MutationResult<PlayerDetailUpdateManualPlayerMutation>;
export type PlayerDetailUpdateManualPlayerMutationOptions = Apollo.BaseMutationOptions<PlayerDetailUpdateManualPlayerMutation, PlayerDetailUpdateManualPlayerMutationVariables>;
export const PlayerDetailDeleteManualPlayerDocument = gql`
    mutation PlayerDetailDeleteManualPlayer($input: DeleteManualPlayerInput!) {
  deleteManualPlayer(input: $input) {
    id
  }
}
    `;
export type PlayerDetailDeleteManualPlayerMutationFn = Apollo.MutationFunction<PlayerDetailDeleteManualPlayerMutation, PlayerDetailDeleteManualPlayerMutationVariables>;

/**
 * __usePlayerDetailDeleteManualPlayerMutation__
 *
 * To run a mutation, you first call `usePlayerDetailDeleteManualPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailDeleteManualPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerDetailDeleteManualPlayerMutation, { data, loading, error }] = usePlayerDetailDeleteManualPlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerDetailDeleteManualPlayerMutation(baseOptions?: Apollo.MutationHookOptions<PlayerDetailDeleteManualPlayerMutation, PlayerDetailDeleteManualPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerDetailDeleteManualPlayerMutation, PlayerDetailDeleteManualPlayerMutationVariables>(PlayerDetailDeleteManualPlayerDocument, options);
      }
export type PlayerDetailDeleteManualPlayerMutationHookResult = ReturnType<typeof usePlayerDetailDeleteManualPlayerMutation>;
export type PlayerDetailDeleteManualPlayerMutationResult = Apollo.MutationResult<PlayerDetailDeleteManualPlayerMutation>;
export type PlayerDetailDeleteManualPlayerMutationOptions = Apollo.BaseMutationOptions<PlayerDetailDeleteManualPlayerMutation, PlayerDetailDeleteManualPlayerMutationVariables>;
export const PlayerDetailTransferManualPlayerDataDocument = gql`
    mutation PlayerDetailTransferManualPlayerData($input: TransferManualPlayerDataInput!) {
  transferManualPlayerData(input: $input) {
    scoutReportsTransferred
    notesTransferred
    sourcePlayerId
    targetPlayerId
  }
}
    `;
export type PlayerDetailTransferManualPlayerDataMutationFn = Apollo.MutationFunction<PlayerDetailTransferManualPlayerDataMutation, PlayerDetailTransferManualPlayerDataMutationVariables>;

/**
 * __usePlayerDetailTransferManualPlayerDataMutation__
 *
 * To run a mutation, you first call `usePlayerDetailTransferManualPlayerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailTransferManualPlayerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerDetailTransferManualPlayerDataMutation, { data, loading, error }] = usePlayerDetailTransferManualPlayerDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerDetailTransferManualPlayerDataMutation(baseOptions?: Apollo.MutationHookOptions<PlayerDetailTransferManualPlayerDataMutation, PlayerDetailTransferManualPlayerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerDetailTransferManualPlayerDataMutation, PlayerDetailTransferManualPlayerDataMutationVariables>(PlayerDetailTransferManualPlayerDataDocument, options);
      }
export type PlayerDetailTransferManualPlayerDataMutationHookResult = ReturnType<typeof usePlayerDetailTransferManualPlayerDataMutation>;
export type PlayerDetailTransferManualPlayerDataMutationResult = Apollo.MutationResult<PlayerDetailTransferManualPlayerDataMutation>;
export type PlayerDetailTransferManualPlayerDataMutationOptions = Apollo.BaseMutationOptions<PlayerDetailTransferManualPlayerDataMutation, PlayerDetailTransferManualPlayerDataMutationVariables>;
export const GetDistributionScoresDocument = gql`
    query GetDistributionScores($seasonId: ID, $positionIds: [ID!], $leagueIds: [ID!], $excludePlayerId: ID, $shadowTeamId: ID, $watchlistId: ID) {
  getDistributionScores(
    seasonId: $seasonId
    positionIds: $positionIds
    leagueIds: $leagueIds
    excludePlayerId: $excludePlayerId
    shadowTeamId: $shadowTeamId
    watchlistId: $watchlistId
  ) {
    playerId
    playerName
    carrying
    dribbling
    passing
    shooting
    gpr
    physicalScore
    gkPassing
    gkShotStopping
    gkPositioning
  }
}
    `;

/**
 * __useGetDistributionScoresQuery__
 *
 * To run a query within a React component, call `useGetDistributionScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionScoresQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      positionIds: // value for 'positionIds'
 *      leagueIds: // value for 'leagueIds'
 *      excludePlayerId: // value for 'excludePlayerId'
 *      shadowTeamId: // value for 'shadowTeamId'
 *      watchlistId: // value for 'watchlistId'
 *   },
 * });
 */
export function useGetDistributionScoresQuery(baseOptions?: Apollo.QueryHookOptions<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>(GetDistributionScoresDocument, options);
      }
export function useGetDistributionScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>(GetDistributionScoresDocument, options);
        }
// @ts-ignore
export function useGetDistributionScoresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>;
export function useGetDistributionScoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistributionScoresQuery | undefined, GetDistributionScoresQueryVariables>;
export function useGetDistributionScoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>(GetDistributionScoresDocument, options);
        }
export type GetDistributionScoresQueryHookResult = ReturnType<typeof useGetDistributionScoresQuery>;
export type GetDistributionScoresLazyQueryHookResult = ReturnType<typeof useGetDistributionScoresLazyQuery>;
export type GetDistributionScoresSuspenseQueryHookResult = ReturnType<typeof useGetDistributionScoresSuspenseQuery>;
export type GetDistributionScoresQueryResult = Apollo.QueryResult<GetDistributionScoresQuery, GetDistributionScoresQueryVariables>;
export const PlayerDetailListBasicCompetitionStatsDocument = gql`
    query PlayerDetailListBasicCompetitionStats($playerId: ID!) {
  listBasicCompetitionStats(playerId: $playerId) {
    ...PlayerDetailBasicCompetitionStats
  }
}
    ${PlayerDetailBasicCompetitionStatsFragmentDoc}`;

/**
 * __usePlayerDetailListBasicCompetitionStatsQuery__
 *
 * To run a query within a React component, call `usePlayerDetailListBasicCompetitionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerDetailListBasicCompetitionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerDetailListBasicCompetitionStatsQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayerDetailListBasicCompetitionStatsQuery(baseOptions: Apollo.QueryHookOptions<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables> & ({ variables: PlayerDetailListBasicCompetitionStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>(PlayerDetailListBasicCompetitionStatsDocument, options);
      }
export function usePlayerDetailListBasicCompetitionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>(PlayerDetailListBasicCompetitionStatsDocument, options);
        }
// @ts-ignore
export function usePlayerDetailListBasicCompetitionStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>;
export function usePlayerDetailListBasicCompetitionStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerDetailListBasicCompetitionStatsQuery | undefined, PlayerDetailListBasicCompetitionStatsQueryVariables>;
export function usePlayerDetailListBasicCompetitionStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>(PlayerDetailListBasicCompetitionStatsDocument, options);
        }
export type PlayerDetailListBasicCompetitionStatsQueryHookResult = ReturnType<typeof usePlayerDetailListBasicCompetitionStatsQuery>;
export type PlayerDetailListBasicCompetitionStatsLazyQueryHookResult = ReturnType<typeof usePlayerDetailListBasicCompetitionStatsLazyQuery>;
export type PlayerDetailListBasicCompetitionStatsSuspenseQueryHookResult = ReturnType<typeof usePlayerDetailListBasicCompetitionStatsSuspenseQuery>;
export type PlayerDetailListBasicCompetitionStatsQueryResult = Apollo.QueryResult<PlayerDetailListBasicCompetitionStatsQuery, PlayerDetailListBasicCompetitionStatsQueryVariables>;
export const PlayerIntakeGetFormUrlDocument = gql`
    query PlayerIntakeGetFormUrl($playerId: ID!, $matchIds: [ID!]) {
  getIntakeFormUrl(playerId: $playerId, matchIds: $matchIds)
}
    `;

/**
 * __usePlayerIntakeGetFormUrlQuery__
 *
 * To run a query within a React component, call `usePlayerIntakeGetFormUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerIntakeGetFormUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerIntakeGetFormUrlQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      matchIds: // value for 'matchIds'
 *   },
 * });
 */
export function usePlayerIntakeGetFormUrlQuery(baseOptions: Apollo.QueryHookOptions<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables> & ({ variables: PlayerIntakeGetFormUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>(PlayerIntakeGetFormUrlDocument, options);
      }
export function usePlayerIntakeGetFormUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>(PlayerIntakeGetFormUrlDocument, options);
        }
// @ts-ignore
export function usePlayerIntakeGetFormUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>;
export function usePlayerIntakeGetFormUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerIntakeGetFormUrlQuery | undefined, PlayerIntakeGetFormUrlQueryVariables>;
export function usePlayerIntakeGetFormUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>(PlayerIntakeGetFormUrlDocument, options);
        }
export type PlayerIntakeGetFormUrlQueryHookResult = ReturnType<typeof usePlayerIntakeGetFormUrlQuery>;
export type PlayerIntakeGetFormUrlLazyQueryHookResult = ReturnType<typeof usePlayerIntakeGetFormUrlLazyQuery>;
export type PlayerIntakeGetFormUrlSuspenseQueryHookResult = ReturnType<typeof usePlayerIntakeGetFormUrlSuspenseQuery>;
export type PlayerIntakeGetFormUrlQueryResult = Apollo.QueryResult<PlayerIntakeGetFormUrlQuery, PlayerIntakeGetFormUrlQueryVariables>;
export const KanbanGetWatchlistDocument = gql`
    query KanbanGetWatchlist($watchlistId: ID!) {
  getWatchlist(id: $watchlistId) {
    ...KanbanWatchlistWithPlayers
  }
}
    ${KanbanWatchlistWithPlayersFragmentDoc}`;

/**
 * __useKanbanGetWatchlistQuery__
 *
 * To run a query within a React component, call `useKanbanGetWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanGetWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanGetWatchlistQuery({
 *   variables: {
 *      watchlistId: // value for 'watchlistId'
 *   },
 * });
 */
export function useKanbanGetWatchlistQuery(baseOptions: Apollo.QueryHookOptions<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables> & ({ variables: KanbanGetWatchlistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>(KanbanGetWatchlistDocument, options);
      }
export function useKanbanGetWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>(KanbanGetWatchlistDocument, options);
        }
// @ts-ignore
export function useKanbanGetWatchlistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>;
export function useKanbanGetWatchlistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanGetWatchlistQuery | undefined, KanbanGetWatchlistQueryVariables>;
export function useKanbanGetWatchlistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>(KanbanGetWatchlistDocument, options);
        }
export type KanbanGetWatchlistQueryHookResult = ReturnType<typeof useKanbanGetWatchlistQuery>;
export type KanbanGetWatchlistLazyQueryHookResult = ReturnType<typeof useKanbanGetWatchlistLazyQuery>;
export type KanbanGetWatchlistSuspenseQueryHookResult = ReturnType<typeof useKanbanGetWatchlistSuspenseQuery>;
export type KanbanGetWatchlistQueryResult = Apollo.QueryResult<KanbanGetWatchlistQuery, KanbanGetWatchlistQueryVariables>;
export const KanbanListMyUserWatchlistsDocument = gql`
    query KanbanListMyUserWatchlists($first: Int, $after: String) {
  listMyUserWatchlists(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...KanbanUserWatchlistMeta
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${KanbanUserWatchlistMetaFragmentDoc}`;

/**
 * __useKanbanListMyUserWatchlistsQuery__
 *
 * To run a query within a React component, call `useKanbanListMyUserWatchlistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanListMyUserWatchlistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanListMyUserWatchlistsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useKanbanListMyUserWatchlistsQuery(baseOptions?: Apollo.QueryHookOptions<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>(KanbanListMyUserWatchlistsDocument, options);
      }
export function useKanbanListMyUserWatchlistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>(KanbanListMyUserWatchlistsDocument, options);
        }
// @ts-ignore
export function useKanbanListMyUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>;
export function useKanbanListMyUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanListMyUserWatchlistsQuery | undefined, KanbanListMyUserWatchlistsQueryVariables>;
export function useKanbanListMyUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>(KanbanListMyUserWatchlistsDocument, options);
        }
export type KanbanListMyUserWatchlistsQueryHookResult = ReturnType<typeof useKanbanListMyUserWatchlistsQuery>;
export type KanbanListMyUserWatchlistsLazyQueryHookResult = ReturnType<typeof useKanbanListMyUserWatchlistsLazyQuery>;
export type KanbanListMyUserWatchlistsSuspenseQueryHookResult = ReturnType<typeof useKanbanListMyUserWatchlistsSuspenseQuery>;
export type KanbanListMyUserWatchlistsQueryResult = Apollo.QueryResult<KanbanListMyUserWatchlistsQuery, KanbanListMyUserWatchlistsQueryVariables>;
export const KanbanListWatchlistPlayersDocument = gql`
    query KanbanListWatchlistPlayers($watchlistIds: [ID!]!, $sortBy: SortField, $sortOrder: OrderByDirection, $first: Int, $after: String, $minGeminiPlayerValuation: Float, $maxGeminiPlayerValuation: Float) {
  listWatchlistPlayers(
    watchlistIds: $watchlistIds
    sortBy: $sortBy
    sortOrder: $sortOrder
    first: $first
    after: $after
    minGeminiPlayerValuation: $minGeminiPlayerValuation
    maxGeminiPlayerValuation: $maxGeminiPlayerValuation
  ) {
    ...KanbanPlayerConnection
  }
}
    ${KanbanPlayerConnectionFragmentDoc}`;

/**
 * __useKanbanListWatchlistPlayersQuery__
 *
 * To run a query within a React component, call `useKanbanListWatchlistPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanListWatchlistPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanListWatchlistPlayersQuery({
 *   variables: {
 *      watchlistIds: // value for 'watchlistIds'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      minGeminiPlayerValuation: // value for 'minGeminiPlayerValuation'
 *      maxGeminiPlayerValuation: // value for 'maxGeminiPlayerValuation'
 *   },
 * });
 */
export function useKanbanListWatchlistPlayersQuery(baseOptions: Apollo.QueryHookOptions<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables> & ({ variables: KanbanListWatchlistPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>(KanbanListWatchlistPlayersDocument, options);
      }
export function useKanbanListWatchlistPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>(KanbanListWatchlistPlayersDocument, options);
        }
// @ts-ignore
export function useKanbanListWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>;
export function useKanbanListWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanListWatchlistPlayersQuery | undefined, KanbanListWatchlistPlayersQueryVariables>;
export function useKanbanListWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>(KanbanListWatchlistPlayersDocument, options);
        }
export type KanbanListWatchlistPlayersQueryHookResult = ReturnType<typeof useKanbanListWatchlistPlayersQuery>;
export type KanbanListWatchlistPlayersLazyQueryHookResult = ReturnType<typeof useKanbanListWatchlistPlayersLazyQuery>;
export type KanbanListWatchlistPlayersSuspenseQueryHookResult = ReturnType<typeof useKanbanListWatchlistPlayersSuspenseQuery>;
export type KanbanListWatchlistPlayersQueryResult = Apollo.QueryResult<KanbanListWatchlistPlayersQuery, KanbanListWatchlistPlayersQueryVariables>;
export const KanbanListMyOrganizationsPlayersDocument = gql`
    query KanbanListMyOrganizationsPlayers($first: Int, $after: String, $sortBy: SortField, $sortByCustomStatName: String, $sortOrder: OrderByDirection, $positionIds: [ID!]) {
  listMyOrganizationsPlayers(
    first: $first
    after: $after
    sortBy: $sortBy
    sortByCustomStatName: $sortByCustomStatName
    sortOrder: $sortOrder
    positionIds: $positionIds
  ) {
    ...KanbanPlayerConnection
  }
}
    ${KanbanPlayerConnectionFragmentDoc}`;

/**
 * __useKanbanListMyOrganizationsPlayersQuery__
 *
 * To run a query within a React component, call `useKanbanListMyOrganizationsPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanListMyOrganizationsPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanListMyOrganizationsPlayersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      sortOrder: // value for 'sortOrder'
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useKanbanListMyOrganizationsPlayersQuery(baseOptions?: Apollo.QueryHookOptions<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>(KanbanListMyOrganizationsPlayersDocument, options);
      }
export function useKanbanListMyOrganizationsPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>(KanbanListMyOrganizationsPlayersDocument, options);
        }
// @ts-ignore
export function useKanbanListMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>;
export function useKanbanListMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanListMyOrganizationsPlayersQuery | undefined, KanbanListMyOrganizationsPlayersQueryVariables>;
export function useKanbanListMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>(KanbanListMyOrganizationsPlayersDocument, options);
        }
export type KanbanListMyOrganizationsPlayersQueryHookResult = ReturnType<typeof useKanbanListMyOrganizationsPlayersQuery>;
export type KanbanListMyOrganizationsPlayersLazyQueryHookResult = ReturnType<typeof useKanbanListMyOrganizationsPlayersLazyQuery>;
export type KanbanListMyOrganizationsPlayersSuspenseQueryHookResult = ReturnType<typeof useKanbanListMyOrganizationsPlayersSuspenseQuery>;
export type KanbanListMyOrganizationsPlayersQueryResult = Apollo.QueryResult<KanbanListMyOrganizationsPlayersQuery, KanbanListMyOrganizationsPlayersQueryVariables>;
export const KanbanFilteredWatchlistPlayersDocument = gql`
    query KanbanFilteredWatchlistPlayers($watchlistIds: [ID!]!, $first: Int, $after: String, $minGeminiPlayerValuation: Float, $maxGeminiPlayerValuation: Float) {
  listWatchlistPlayers(
    watchlistIds: $watchlistIds
    first: $first
    after: $after
    minGeminiPlayerValuation: $minGeminiPlayerValuation
    maxGeminiPlayerValuation: $maxGeminiPlayerValuation
  ) {
    edges {
      cursor
      node {
        ...KanbanFilterablePlayerData
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${KanbanFilterablePlayerDataFragmentDoc}`;

/**
 * __useKanbanFilteredWatchlistPlayersQuery__
 *
 * To run a query within a React component, call `useKanbanFilteredWatchlistPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanFilteredWatchlistPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanFilteredWatchlistPlayersQuery({
 *   variables: {
 *      watchlistIds: // value for 'watchlistIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      minGeminiPlayerValuation: // value for 'minGeminiPlayerValuation'
 *      maxGeminiPlayerValuation: // value for 'maxGeminiPlayerValuation'
 *   },
 * });
 */
export function useKanbanFilteredWatchlistPlayersQuery(baseOptions: Apollo.QueryHookOptions<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables> & ({ variables: KanbanFilteredWatchlistPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>(KanbanFilteredWatchlistPlayersDocument, options);
      }
export function useKanbanFilteredWatchlistPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>(KanbanFilteredWatchlistPlayersDocument, options);
        }
// @ts-ignore
export function useKanbanFilteredWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>;
export function useKanbanFilteredWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanFilteredWatchlistPlayersQuery | undefined, KanbanFilteredWatchlistPlayersQueryVariables>;
export function useKanbanFilteredWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>(KanbanFilteredWatchlistPlayersDocument, options);
        }
export type KanbanFilteredWatchlistPlayersQueryHookResult = ReturnType<typeof useKanbanFilteredWatchlistPlayersQuery>;
export type KanbanFilteredWatchlistPlayersLazyQueryHookResult = ReturnType<typeof useKanbanFilteredWatchlistPlayersLazyQuery>;
export type KanbanFilteredWatchlistPlayersSuspenseQueryHookResult = ReturnType<typeof useKanbanFilteredWatchlistPlayersSuspenseQuery>;
export type KanbanFilteredWatchlistPlayersQueryResult = Apollo.QueryResult<KanbanFilteredWatchlistPlayersQuery, KanbanFilteredWatchlistPlayersQueryVariables>;
export const KanbanFilteredMyOrganizationsPlayersDocument = gql`
    query KanbanFilteredMyOrganizationsPlayers($first: Int, $after: String) {
  listMyOrganizationsPlayers(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...KanbanFilterablePlayerData
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${KanbanFilterablePlayerDataFragmentDoc}`;

/**
 * __useKanbanFilteredMyOrganizationsPlayersQuery__
 *
 * To run a query within a React component, call `useKanbanFilteredMyOrganizationsPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanFilteredMyOrganizationsPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanFilteredMyOrganizationsPlayersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useKanbanFilteredMyOrganizationsPlayersQuery(baseOptions?: Apollo.QueryHookOptions<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>(KanbanFilteredMyOrganizationsPlayersDocument, options);
      }
export function useKanbanFilteredMyOrganizationsPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>(KanbanFilteredMyOrganizationsPlayersDocument, options);
        }
// @ts-ignore
export function useKanbanFilteredMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>;
export function useKanbanFilteredMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanFilteredMyOrganizationsPlayersQuery | undefined, KanbanFilteredMyOrganizationsPlayersQueryVariables>;
export function useKanbanFilteredMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>(KanbanFilteredMyOrganizationsPlayersDocument, options);
        }
export type KanbanFilteredMyOrganizationsPlayersQueryHookResult = ReturnType<typeof useKanbanFilteredMyOrganizationsPlayersQuery>;
export type KanbanFilteredMyOrganizationsPlayersLazyQueryHookResult = ReturnType<typeof useKanbanFilteredMyOrganizationsPlayersLazyQuery>;
export type KanbanFilteredMyOrganizationsPlayersSuspenseQueryHookResult = ReturnType<typeof useKanbanFilteredMyOrganizationsPlayersSuspenseQuery>;
export type KanbanFilteredMyOrganizationsPlayersQueryResult = Apollo.QueryResult<KanbanFilteredMyOrganizationsPlayersQuery, KanbanFilteredMyOrganizationsPlayersQueryVariables>;
export const KanbanCreateWatchlistDocument = gql`
    mutation KanbanCreateWatchlist($input: CreateWatchlistInput!) {
  createWatchlist(input: $input) {
    ...KanbanWatchlistData
  }
}
    ${KanbanWatchlistDataFragmentDoc}`;
export type KanbanCreateWatchlistMutationFn = Apollo.MutationFunction<KanbanCreateWatchlistMutation, KanbanCreateWatchlistMutationVariables>;

/**
 * __useKanbanCreateWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanCreateWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanCreateWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanCreateWatchlistMutation, { data, loading, error }] = useKanbanCreateWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanCreateWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanCreateWatchlistMutation, KanbanCreateWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanCreateWatchlistMutation, KanbanCreateWatchlistMutationVariables>(KanbanCreateWatchlistDocument, options);
      }
export type KanbanCreateWatchlistMutationHookResult = ReturnType<typeof useKanbanCreateWatchlistMutation>;
export type KanbanCreateWatchlistMutationResult = Apollo.MutationResult<KanbanCreateWatchlistMutation>;
export type KanbanCreateWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanCreateWatchlistMutation, KanbanCreateWatchlistMutationVariables>;
export const KanbanUpdateWatchlistDocument = gql`
    mutation KanbanUpdateWatchlist($input: UpdateWatchlistInput!) {
  updateWatchlist(input: $input) {
    ...KanbanWatchlistData
  }
}
    ${KanbanWatchlistDataFragmentDoc}`;
export type KanbanUpdateWatchlistMutationFn = Apollo.MutationFunction<KanbanUpdateWatchlistMutation, KanbanUpdateWatchlistMutationVariables>;

/**
 * __useKanbanUpdateWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanUpdateWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanUpdateWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanUpdateWatchlistMutation, { data, loading, error }] = useKanbanUpdateWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanUpdateWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanUpdateWatchlistMutation, KanbanUpdateWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanUpdateWatchlistMutation, KanbanUpdateWatchlistMutationVariables>(KanbanUpdateWatchlistDocument, options);
      }
export type KanbanUpdateWatchlistMutationHookResult = ReturnType<typeof useKanbanUpdateWatchlistMutation>;
export type KanbanUpdateWatchlistMutationResult = Apollo.MutationResult<KanbanUpdateWatchlistMutation>;
export type KanbanUpdateWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanUpdateWatchlistMutation, KanbanUpdateWatchlistMutationVariables>;
export const KanbanDeleteWatchlistDocument = gql`
    mutation KanbanDeleteWatchlist($input: DeleteWatchlistInput!) {
  deleteWatchlist(input: $input) {
    ...KanbanWatchlistData
  }
}
    ${KanbanWatchlistDataFragmentDoc}`;
export type KanbanDeleteWatchlistMutationFn = Apollo.MutationFunction<KanbanDeleteWatchlistMutation, KanbanDeleteWatchlistMutationVariables>;

/**
 * __useKanbanDeleteWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanDeleteWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanDeleteWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanDeleteWatchlistMutation, { data, loading, error }] = useKanbanDeleteWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanDeleteWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanDeleteWatchlistMutation, KanbanDeleteWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanDeleteWatchlistMutation, KanbanDeleteWatchlistMutationVariables>(KanbanDeleteWatchlistDocument, options);
      }
export type KanbanDeleteWatchlistMutationHookResult = ReturnType<typeof useKanbanDeleteWatchlistMutation>;
export type KanbanDeleteWatchlistMutationResult = Apollo.MutationResult<KanbanDeleteWatchlistMutation>;
export type KanbanDeleteWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanDeleteWatchlistMutation, KanbanDeleteWatchlistMutationVariables>;
export const KanbanAddPlayerToWatchlistDocument = gql`
    mutation KanbanAddPlayerToWatchlist($input: AddPlayerToWatchlistInput!) {
  addPlayerToWatchlist(input: $input) {
    ...KanbanWatchlistWithPlayers
  }
}
    ${KanbanWatchlistWithPlayersFragmentDoc}`;
export type KanbanAddPlayerToWatchlistMutationFn = Apollo.MutationFunction<KanbanAddPlayerToWatchlistMutation, KanbanAddPlayerToWatchlistMutationVariables>;

/**
 * __useKanbanAddPlayerToWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanAddPlayerToWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanAddPlayerToWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanAddPlayerToWatchlistMutation, { data, loading, error }] = useKanbanAddPlayerToWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanAddPlayerToWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanAddPlayerToWatchlistMutation, KanbanAddPlayerToWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanAddPlayerToWatchlistMutation, KanbanAddPlayerToWatchlistMutationVariables>(KanbanAddPlayerToWatchlistDocument, options);
      }
export type KanbanAddPlayerToWatchlistMutationHookResult = ReturnType<typeof useKanbanAddPlayerToWatchlistMutation>;
export type KanbanAddPlayerToWatchlistMutationResult = Apollo.MutationResult<KanbanAddPlayerToWatchlistMutation>;
export type KanbanAddPlayerToWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanAddPlayerToWatchlistMutation, KanbanAddPlayerToWatchlistMutationVariables>;
export const KanbanRemovePlayerFromWatchlistDocument = gql`
    mutation KanbanRemovePlayerFromWatchlist($input: RemovePlayerFromWatchlistInput!) {
  removePlayerFromWatchlist(input: $input) {
    ...KanbanWatchlistWithPlayers
  }
}
    ${KanbanWatchlistWithPlayersFragmentDoc}`;
export type KanbanRemovePlayerFromWatchlistMutationFn = Apollo.MutationFunction<KanbanRemovePlayerFromWatchlistMutation, KanbanRemovePlayerFromWatchlistMutationVariables>;

/**
 * __useKanbanRemovePlayerFromWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanRemovePlayerFromWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanRemovePlayerFromWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanRemovePlayerFromWatchlistMutation, { data, loading, error }] = useKanbanRemovePlayerFromWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanRemovePlayerFromWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanRemovePlayerFromWatchlistMutation, KanbanRemovePlayerFromWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanRemovePlayerFromWatchlistMutation, KanbanRemovePlayerFromWatchlistMutationVariables>(KanbanRemovePlayerFromWatchlistDocument, options);
      }
export type KanbanRemovePlayerFromWatchlistMutationHookResult = ReturnType<typeof useKanbanRemovePlayerFromWatchlistMutation>;
export type KanbanRemovePlayerFromWatchlistMutationResult = Apollo.MutationResult<KanbanRemovePlayerFromWatchlistMutation>;
export type KanbanRemovePlayerFromWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanRemovePlayerFromWatchlistMutation, KanbanRemovePlayerFromWatchlistMutationVariables>;
export const KanbanUpdateWatchlistPlayerPositionDocument = gql`
    mutation KanbanUpdateWatchlistPlayerPosition($input: UpdateWatchlistPlayerPositionInput!) {
  updateWatchlistPlayerPosition(input: $input) {
    ...KanbanWatchlistWithPlayers
  }
}
    ${KanbanWatchlistWithPlayersFragmentDoc}`;
export type KanbanUpdateWatchlistPlayerPositionMutationFn = Apollo.MutationFunction<KanbanUpdateWatchlistPlayerPositionMutation, KanbanUpdateWatchlistPlayerPositionMutationVariables>;

/**
 * __useKanbanUpdateWatchlistPlayerPositionMutation__
 *
 * To run a mutation, you first call `useKanbanUpdateWatchlistPlayerPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanUpdateWatchlistPlayerPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanUpdateWatchlistPlayerPositionMutation, { data, loading, error }] = useKanbanUpdateWatchlistPlayerPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanUpdateWatchlistPlayerPositionMutation(baseOptions?: Apollo.MutationHookOptions<KanbanUpdateWatchlistPlayerPositionMutation, KanbanUpdateWatchlistPlayerPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanUpdateWatchlistPlayerPositionMutation, KanbanUpdateWatchlistPlayerPositionMutationVariables>(KanbanUpdateWatchlistPlayerPositionDocument, options);
      }
export type KanbanUpdateWatchlistPlayerPositionMutationHookResult = ReturnType<typeof useKanbanUpdateWatchlistPlayerPositionMutation>;
export type KanbanUpdateWatchlistPlayerPositionMutationResult = Apollo.MutationResult<KanbanUpdateWatchlistPlayerPositionMutation>;
export type KanbanUpdateWatchlistPlayerPositionMutationOptions = Apollo.BaseMutationOptions<KanbanUpdateWatchlistPlayerPositionMutation, KanbanUpdateWatchlistPlayerPositionMutationVariables>;
export const KanbanUpdateWatchlistPlayerPositionsDocument = gql`
    mutation KanbanUpdateWatchlistPlayerPositions($input: UpdateWatchlistPlayerPositionsInput!) {
  updateWatchlistPlayerPositions(input: $input) {
    ...KanbanWatchlistWithPlayers
  }
}
    ${KanbanWatchlistWithPlayersFragmentDoc}`;
export type KanbanUpdateWatchlistPlayerPositionsMutationFn = Apollo.MutationFunction<KanbanUpdateWatchlistPlayerPositionsMutation, KanbanUpdateWatchlistPlayerPositionsMutationVariables>;

/**
 * __useKanbanUpdateWatchlistPlayerPositionsMutation__
 *
 * To run a mutation, you first call `useKanbanUpdateWatchlistPlayerPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanUpdateWatchlistPlayerPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanUpdateWatchlistPlayerPositionsMutation, { data, loading, error }] = useKanbanUpdateWatchlistPlayerPositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanUpdateWatchlistPlayerPositionsMutation(baseOptions?: Apollo.MutationHookOptions<KanbanUpdateWatchlistPlayerPositionsMutation, KanbanUpdateWatchlistPlayerPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanUpdateWatchlistPlayerPositionsMutation, KanbanUpdateWatchlistPlayerPositionsMutationVariables>(KanbanUpdateWatchlistPlayerPositionsDocument, options);
      }
export type KanbanUpdateWatchlistPlayerPositionsMutationHookResult = ReturnType<typeof useKanbanUpdateWatchlistPlayerPositionsMutation>;
export type KanbanUpdateWatchlistPlayerPositionsMutationResult = Apollo.MutationResult<KanbanUpdateWatchlistPlayerPositionsMutation>;
export type KanbanUpdateWatchlistPlayerPositionsMutationOptions = Apollo.BaseMutationOptions<KanbanUpdateWatchlistPlayerPositionsMutation, KanbanUpdateWatchlistPlayerPositionsMutationVariables>;
export const GetKanbanBoardDocument = gql`
    query GetKanbanBoard($id: ID!) {
  getKanbanBoard(id: $id) {
    ...KanbanBoardFragment
  }
}
    ${KanbanBoardFragmentFragmentDoc}`;

/**
 * __useGetKanbanBoardQuery__
 *
 * To run a query within a React component, call `useGetKanbanBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKanbanBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKanbanBoardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKanbanBoardQuery(baseOptions: Apollo.QueryHookOptions<GetKanbanBoardQuery, GetKanbanBoardQueryVariables> & ({ variables: GetKanbanBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>(GetKanbanBoardDocument, options);
      }
export function useGetKanbanBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>(GetKanbanBoardDocument, options);
        }
// @ts-ignore
export function useGetKanbanBoardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>;
export function useGetKanbanBoardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanBoardQuery | undefined, GetKanbanBoardQueryVariables>;
export function useGetKanbanBoardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>(GetKanbanBoardDocument, options);
        }
export type GetKanbanBoardQueryHookResult = ReturnType<typeof useGetKanbanBoardQuery>;
export type GetKanbanBoardLazyQueryHookResult = ReturnType<typeof useGetKanbanBoardLazyQuery>;
export type GetKanbanBoardSuspenseQueryHookResult = ReturnType<typeof useGetKanbanBoardSuspenseQuery>;
export type GetKanbanBoardQueryResult = Apollo.QueryResult<GetKanbanBoardQuery, GetKanbanBoardQueryVariables>;
export const ListMyKanbanBoardsDocument = gql`
    query ListMyKanbanBoards($first: Int, $after: String) {
  listMyKanbanBoards(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...KanbanBoardFragment
        users(first: 100) {
          edges {
            node {
              id
              userId
              role
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${KanbanBoardFragmentFragmentDoc}`;

/**
 * __useListMyKanbanBoardsQuery__
 *
 * To run a query within a React component, call `useListMyKanbanBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyKanbanBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyKanbanBoardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListMyKanbanBoardsQuery(baseOptions?: Apollo.QueryHookOptions<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>(ListMyKanbanBoardsDocument, options);
      }
export function useListMyKanbanBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>(ListMyKanbanBoardsDocument, options);
        }
// @ts-ignore
export function useListMyKanbanBoardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>;
export function useListMyKanbanBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMyKanbanBoardsQuery | undefined, ListMyKanbanBoardsQueryVariables>;
export function useListMyKanbanBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>(ListMyKanbanBoardsDocument, options);
        }
export type ListMyKanbanBoardsQueryHookResult = ReturnType<typeof useListMyKanbanBoardsQuery>;
export type ListMyKanbanBoardsLazyQueryHookResult = ReturnType<typeof useListMyKanbanBoardsLazyQuery>;
export type ListMyKanbanBoardsSuspenseQueryHookResult = ReturnType<typeof useListMyKanbanBoardsSuspenseQuery>;
export type ListMyKanbanBoardsQueryResult = Apollo.QueryResult<ListMyKanbanBoardsQuery, ListMyKanbanBoardsQueryVariables>;
export const AddToPipelineDialogBoardsDocument = gql`
    query AddToPipelineDialogBoards($first: Int) {
  listMyKanbanBoards(first: $first) {
    edges {
      node {
        id
        name
        sourceType
      }
    }
  }
}
    `;

/**
 * __useAddToPipelineDialogBoardsQuery__
 *
 * To run a query within a React component, call `useAddToPipelineDialogBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddToPipelineDialogBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddToPipelineDialogBoardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAddToPipelineDialogBoardsQuery(baseOptions?: Apollo.QueryHookOptions<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>(AddToPipelineDialogBoardsDocument, options);
      }
export function useAddToPipelineDialogBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>(AddToPipelineDialogBoardsDocument, options);
        }
// @ts-ignore
export function useAddToPipelineDialogBoardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>): Apollo.UseSuspenseQueryResult<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>;
export function useAddToPipelineDialogBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>): Apollo.UseSuspenseQueryResult<AddToPipelineDialogBoardsQuery | undefined, AddToPipelineDialogBoardsQueryVariables>;
export function useAddToPipelineDialogBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>(AddToPipelineDialogBoardsDocument, options);
        }
export type AddToPipelineDialogBoardsQueryHookResult = ReturnType<typeof useAddToPipelineDialogBoardsQuery>;
export type AddToPipelineDialogBoardsLazyQueryHookResult = ReturnType<typeof useAddToPipelineDialogBoardsLazyQuery>;
export type AddToPipelineDialogBoardsSuspenseQueryHookResult = ReturnType<typeof useAddToPipelineDialogBoardsSuspenseQuery>;
export type AddToPipelineDialogBoardsQueryResult = Apollo.QueryResult<AddToPipelineDialogBoardsQuery, AddToPipelineDialogBoardsQueryVariables>;
export const PipelineSwitcherBoardsDocument = gql`
    query PipelineSwitcherBoards($first: Int, $after: String) {
  listMyKanbanBoards(first: $first, after: $after) {
    edges {
      node {
        id
        name
        sourceType
        createdBy
        pipelineTemplate
        updatedAt
        creator {
          id
          email
        }
        users(first: 100) {
          edges {
            node {
              userId
              role
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __usePipelineSwitcherBoardsQuery__
 *
 * To run a query within a React component, call `usePipelineSwitcherBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineSwitcherBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineSwitcherBoardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePipelineSwitcherBoardsQuery(baseOptions?: Apollo.QueryHookOptions<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>(PipelineSwitcherBoardsDocument, options);
      }
export function usePipelineSwitcherBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>(PipelineSwitcherBoardsDocument, options);
        }
// @ts-ignore
export function usePipelineSwitcherBoardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>;
export function usePipelineSwitcherBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineSwitcherBoardsQuery | undefined, PipelineSwitcherBoardsQueryVariables>;
export function usePipelineSwitcherBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>(PipelineSwitcherBoardsDocument, options);
        }
export type PipelineSwitcherBoardsQueryHookResult = ReturnType<typeof usePipelineSwitcherBoardsQuery>;
export type PipelineSwitcherBoardsLazyQueryHookResult = ReturnType<typeof usePipelineSwitcherBoardsLazyQuery>;
export type PipelineSwitcherBoardsSuspenseQueryHookResult = ReturnType<typeof usePipelineSwitcherBoardsSuspenseQuery>;
export type PipelineSwitcherBoardsQueryResult = Apollo.QueryResult<PipelineSwitcherBoardsQuery, PipelineSwitcherBoardsQueryVariables>;
export const PipelineDrawerCardCountDocument = gql`
    query PipelineDrawerCardCount($kanbanBoardId: ID!, $first: Int) {
  listKanbanCards(kanbanBoardId: $kanbanBoardId, first: $first) {
    edges {
      node {
        player {
          id
        }
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __usePipelineDrawerCardCountQuery__
 *
 * To run a query within a React component, call `usePipelineDrawerCardCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineDrawerCardCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineDrawerCardCountQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePipelineDrawerCardCountQuery(baseOptions: Apollo.QueryHookOptions<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables> & ({ variables: PipelineDrawerCardCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>(PipelineDrawerCardCountDocument, options);
      }
export function usePipelineDrawerCardCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>(PipelineDrawerCardCountDocument, options);
        }
// @ts-ignore
export function usePipelineDrawerCardCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>;
export function usePipelineDrawerCardCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineDrawerCardCountQuery | undefined, PipelineDrawerCardCountQueryVariables>;
export function usePipelineDrawerCardCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>(PipelineDrawerCardCountDocument, options);
        }
export type PipelineDrawerCardCountQueryHookResult = ReturnType<typeof usePipelineDrawerCardCountQuery>;
export type PipelineDrawerCardCountLazyQueryHookResult = ReturnType<typeof usePipelineDrawerCardCountLazyQuery>;
export type PipelineDrawerCardCountSuspenseQueryHookResult = ReturnType<typeof usePipelineDrawerCardCountSuspenseQuery>;
export type PipelineDrawerCardCountQueryResult = Apollo.QueryResult<PipelineDrawerCardCountQuery, PipelineDrawerCardCountQueryVariables>;
export const ListKanbanPhasesDocument = gql`
    query ListKanbanPhases($kanbanBoardId: ID!) {
  listKanbanPhases(kanbanBoardId: $kanbanBoardId) {
    ...KanbanPhaseFragment
  }
}
    ${KanbanPhaseFragmentFragmentDoc}`;

/**
 * __useListKanbanPhasesQuery__
 *
 * To run a query within a React component, call `useListKanbanPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanPhasesQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useListKanbanPhasesQuery(baseOptions: Apollo.QueryHookOptions<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables> & ({ variables: ListKanbanPhasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>(ListKanbanPhasesDocument, options);
      }
export function useListKanbanPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>(ListKanbanPhasesDocument, options);
        }
// @ts-ignore
export function useListKanbanPhasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>;
export function useListKanbanPhasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanPhasesQuery | undefined, ListKanbanPhasesQueryVariables>;
export function useListKanbanPhasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>(ListKanbanPhasesDocument, options);
        }
export type ListKanbanPhasesQueryHookResult = ReturnType<typeof useListKanbanPhasesQuery>;
export type ListKanbanPhasesLazyQueryHookResult = ReturnType<typeof useListKanbanPhasesLazyQuery>;
export type ListKanbanPhasesSuspenseQueryHookResult = ReturnType<typeof useListKanbanPhasesSuspenseQuery>;
export type ListKanbanPhasesQueryResult = Apollo.QueryResult<ListKanbanPhasesQuery, ListKanbanPhasesQueryVariables>;
export const PipelineActivityLogDocument = gql`
    query PipelineActivityLog($kanbanBoardId: ID!, $kanbanCardId: ID, $action: [PipelineActivityAction!], $actorType: [PipelineActorType!], $first: Int, $after: String) {
  pipelineActivityLog(
    kanbanBoardId: $kanbanBoardId
    kanbanCardId: $kanbanCardId
    action: $action
    actorType: $actorType
    first: $first
    after: $after
  ) {
    totalCount
    edges {
      cursor
      node {
        ...PipelineActivityEntryFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${PipelineActivityEntryFragmentFragmentDoc}`;

/**
 * __usePipelineActivityLogQuery__
 *
 * To run a query within a React component, call `usePipelineActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineActivityLogQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      kanbanCardId: // value for 'kanbanCardId'
 *      action: // value for 'action'
 *      actorType: // value for 'actorType'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePipelineActivityLogQuery(baseOptions: Apollo.QueryHookOptions<PipelineActivityLogQuery, PipelineActivityLogQueryVariables> & ({ variables: PipelineActivityLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>(PipelineActivityLogDocument, options);
      }
export function usePipelineActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>(PipelineActivityLogDocument, options);
        }
// @ts-ignore
export function usePipelineActivityLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>;
export function usePipelineActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineActivityLogQuery | undefined, PipelineActivityLogQueryVariables>;
export function usePipelineActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>(PipelineActivityLogDocument, options);
        }
export type PipelineActivityLogQueryHookResult = ReturnType<typeof usePipelineActivityLogQuery>;
export type PipelineActivityLogLazyQueryHookResult = ReturnType<typeof usePipelineActivityLogLazyQuery>;
export type PipelineActivityLogSuspenseQueryHookResult = ReturnType<typeof usePipelineActivityLogSuspenseQuery>;
export type PipelineActivityLogQueryResult = Apollo.QueryResult<PipelineActivityLogQuery, PipelineActivityLogQueryVariables>;
export const ListKanbanCardsDocument = gql`
    query ListKanbanCards($kanbanBoardId: ID!, $first: Int, $after: String) {
  listKanbanCards(kanbanBoardId: $kanbanBoardId, first: $first, after: $after) {
    edges {
      node {
        kanbanPhaseId
        player {
          id
          name
          knownName
          firstName
          lastName
          isManual
          isAcademy
          dateOfBirth
          teamName
          imageUrl
          transferableDataCounts {
            scoutReportCount
          }
          scoutReports {
            reportDate
            overallScore
          }
          team {
            id
            name
          }
          league {
            id
            name
          }
          positions {
            id
            name
            abbreviation
          }
          bioData {
            ggPlayerKey
            age
            gpr
            nationality
            geminiPlayerValuation
            roleArchetype
            secondaryRoleArchetype
            primaryPosition
            leagueCountry
            minGeminiPlayerValuation
            maxGeminiPlayerValuation
            contractExpires
            playerAgent
            customStats
          }
          watchlists {
            id
            name
          }
        }
        kanbanCard {
          ...KanbanCardFragment
          outcome
          closedAt
          lastEditedByUserId
          tags {
            id
            name
            cardCount
            color(kanbanBoardId: $kanbanBoardId)
            createdAt
            updatedAt
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${KanbanCardFragmentFragmentDoc}`;

/**
 * __useListKanbanCardsQuery__
 *
 * To run a query within a React component, call `useListKanbanCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanCardsQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListKanbanCardsQuery(baseOptions: Apollo.QueryHookOptions<ListKanbanCardsQuery, ListKanbanCardsQueryVariables> & ({ variables: ListKanbanCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>(ListKanbanCardsDocument, options);
      }
export function useListKanbanCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>(ListKanbanCardsDocument, options);
        }
// @ts-ignore
export function useListKanbanCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>;
export function useListKanbanCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanCardsQuery | undefined, ListKanbanCardsQueryVariables>;
export function useListKanbanCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>(ListKanbanCardsDocument, options);
        }
export type ListKanbanCardsQueryHookResult = ReturnType<typeof useListKanbanCardsQuery>;
export type ListKanbanCardsLazyQueryHookResult = ReturnType<typeof useListKanbanCardsLazyQuery>;
export type ListKanbanCardsSuspenseQueryHookResult = ReturnType<typeof useListKanbanCardsSuspenseQuery>;
export type ListKanbanCardsQueryResult = Apollo.QueryResult<ListKanbanCardsQuery, ListKanbanCardsQueryVariables>;
export const CreateKanbanBoardDocument = gql`
    mutation CreateKanbanBoard($input: CreateKanbanBoardInput!) {
  createKanbanBoard(input: $input) {
    ...KanbanBoardFragment
    phases {
      id
    }
  }
}
    ${KanbanBoardFragmentFragmentDoc}`;
export type CreateKanbanBoardMutationFn = Apollo.MutationFunction<CreateKanbanBoardMutation, CreateKanbanBoardMutationVariables>;

/**
 * __useCreateKanbanBoardMutation__
 *
 * To run a mutation, you first call `useCreateKanbanBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKanbanBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKanbanBoardMutation, { data, loading, error }] = useCreateKanbanBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKanbanBoardMutation(baseOptions?: Apollo.MutationHookOptions<CreateKanbanBoardMutation, CreateKanbanBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKanbanBoardMutation, CreateKanbanBoardMutationVariables>(CreateKanbanBoardDocument, options);
      }
export type CreateKanbanBoardMutationHookResult = ReturnType<typeof useCreateKanbanBoardMutation>;
export type CreateKanbanBoardMutationResult = Apollo.MutationResult<CreateKanbanBoardMutation>;
export type CreateKanbanBoardMutationOptions = Apollo.BaseMutationOptions<CreateKanbanBoardMutation, CreateKanbanBoardMutationVariables>;
export const UpdateKanbanBoardDocument = gql`
    mutation UpdateKanbanBoard($id: ID!, $input: UpdateKanbanBoardInput!) {
  updateKanbanBoard(id: $id, input: $input) {
    ...KanbanBoardFragment
  }
}
    ${KanbanBoardFragmentFragmentDoc}`;
export type UpdateKanbanBoardMutationFn = Apollo.MutationFunction<UpdateKanbanBoardMutation, UpdateKanbanBoardMutationVariables>;

/**
 * __useUpdateKanbanBoardMutation__
 *
 * To run a mutation, you first call `useUpdateKanbanBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKanbanBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKanbanBoardMutation, { data, loading, error }] = useUpdateKanbanBoardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKanbanBoardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKanbanBoardMutation, UpdateKanbanBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKanbanBoardMutation, UpdateKanbanBoardMutationVariables>(UpdateKanbanBoardDocument, options);
      }
export type UpdateKanbanBoardMutationHookResult = ReturnType<typeof useUpdateKanbanBoardMutation>;
export type UpdateKanbanBoardMutationResult = Apollo.MutationResult<UpdateKanbanBoardMutation>;
export type UpdateKanbanBoardMutationOptions = Apollo.BaseMutationOptions<UpdateKanbanBoardMutation, UpdateKanbanBoardMutationVariables>;
export const DeleteKanbanBoardDocument = gql`
    mutation DeleteKanbanBoard($id: ID!) {
  deleteKanbanBoard(id: $id) {
    ...KanbanBoardFragment
  }
}
    ${KanbanBoardFragmentFragmentDoc}`;
export type DeleteKanbanBoardMutationFn = Apollo.MutationFunction<DeleteKanbanBoardMutation, DeleteKanbanBoardMutationVariables>;

/**
 * __useDeleteKanbanBoardMutation__
 *
 * To run a mutation, you first call `useDeleteKanbanBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKanbanBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKanbanBoardMutation, { data, loading, error }] = useDeleteKanbanBoardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKanbanBoardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKanbanBoardMutation, DeleteKanbanBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKanbanBoardMutation, DeleteKanbanBoardMutationVariables>(DeleteKanbanBoardDocument, options);
      }
export type DeleteKanbanBoardMutationHookResult = ReturnType<typeof useDeleteKanbanBoardMutation>;
export type DeleteKanbanBoardMutationResult = Apollo.MutationResult<DeleteKanbanBoardMutation>;
export type DeleteKanbanBoardMutationOptions = Apollo.BaseMutationOptions<DeleteKanbanBoardMutation, DeleteKanbanBoardMutationVariables>;
export const CreateKanbanPhaseDocument = gql`
    mutation CreateKanbanPhase($input: CreateKanbanPhaseInput!) {
  createKanbanPhase(input: $input) {
    ...KanbanPhaseFragment
  }
}
    ${KanbanPhaseFragmentFragmentDoc}`;
export type CreateKanbanPhaseMutationFn = Apollo.MutationFunction<CreateKanbanPhaseMutation, CreateKanbanPhaseMutationVariables>;

/**
 * __useCreateKanbanPhaseMutation__
 *
 * To run a mutation, you first call `useCreateKanbanPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKanbanPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKanbanPhaseMutation, { data, loading, error }] = useCreateKanbanPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKanbanPhaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateKanbanPhaseMutation, CreateKanbanPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKanbanPhaseMutation, CreateKanbanPhaseMutationVariables>(CreateKanbanPhaseDocument, options);
      }
export type CreateKanbanPhaseMutationHookResult = ReturnType<typeof useCreateKanbanPhaseMutation>;
export type CreateKanbanPhaseMutationResult = Apollo.MutationResult<CreateKanbanPhaseMutation>;
export type CreateKanbanPhaseMutationOptions = Apollo.BaseMutationOptions<CreateKanbanPhaseMutation, CreateKanbanPhaseMutationVariables>;
export const UpdateKanbanPhaseDocument = gql`
    mutation UpdateKanbanPhase($id: ID!, $input: UpdateKanbanPhaseInput!) {
  updateKanbanPhase(id: $id, input: $input) {
    ...KanbanPhaseFragment
  }
}
    ${KanbanPhaseFragmentFragmentDoc}`;
export type UpdateKanbanPhaseMutationFn = Apollo.MutationFunction<UpdateKanbanPhaseMutation, UpdateKanbanPhaseMutationVariables>;

/**
 * __useUpdateKanbanPhaseMutation__
 *
 * To run a mutation, you first call `useUpdateKanbanPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKanbanPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKanbanPhaseMutation, { data, loading, error }] = useUpdateKanbanPhaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKanbanPhaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKanbanPhaseMutation, UpdateKanbanPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKanbanPhaseMutation, UpdateKanbanPhaseMutationVariables>(UpdateKanbanPhaseDocument, options);
      }
export type UpdateKanbanPhaseMutationHookResult = ReturnType<typeof useUpdateKanbanPhaseMutation>;
export type UpdateKanbanPhaseMutationResult = Apollo.MutationResult<UpdateKanbanPhaseMutation>;
export type UpdateKanbanPhaseMutationOptions = Apollo.BaseMutationOptions<UpdateKanbanPhaseMutation, UpdateKanbanPhaseMutationVariables>;
export const DeleteKanbanPhaseDocument = gql`
    mutation DeleteKanbanPhase($id: ID!) {
  deleteKanbanPhase(id: $id) {
    ...KanbanPhaseFragment
  }
}
    ${KanbanPhaseFragmentFragmentDoc}`;
export type DeleteKanbanPhaseMutationFn = Apollo.MutationFunction<DeleteKanbanPhaseMutation, DeleteKanbanPhaseMutationVariables>;

/**
 * __useDeleteKanbanPhaseMutation__
 *
 * To run a mutation, you first call `useDeleteKanbanPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKanbanPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKanbanPhaseMutation, { data, loading, error }] = useDeleteKanbanPhaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKanbanPhaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKanbanPhaseMutation, DeleteKanbanPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKanbanPhaseMutation, DeleteKanbanPhaseMutationVariables>(DeleteKanbanPhaseDocument, options);
      }
export type DeleteKanbanPhaseMutationHookResult = ReturnType<typeof useDeleteKanbanPhaseMutation>;
export type DeleteKanbanPhaseMutationResult = Apollo.MutationResult<DeleteKanbanPhaseMutation>;
export type DeleteKanbanPhaseMutationOptions = Apollo.BaseMutationOptions<DeleteKanbanPhaseMutation, DeleteKanbanPhaseMutationVariables>;
export const UpdateKanbanPhasePositionsDocument = gql`
    mutation UpdateKanbanPhasePositions($input: UpdateKanbanPhasePositionsInput!) {
  updateKanbanPhasePositions(input: $input) {
    ...KanbanPhaseFragment
  }
}
    ${KanbanPhaseFragmentFragmentDoc}`;
export type UpdateKanbanPhasePositionsMutationFn = Apollo.MutationFunction<UpdateKanbanPhasePositionsMutation, UpdateKanbanPhasePositionsMutationVariables>;

/**
 * __useUpdateKanbanPhasePositionsMutation__
 *
 * To run a mutation, you first call `useUpdateKanbanPhasePositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKanbanPhasePositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKanbanPhasePositionsMutation, { data, loading, error }] = useUpdateKanbanPhasePositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKanbanPhasePositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKanbanPhasePositionsMutation, UpdateKanbanPhasePositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKanbanPhasePositionsMutation, UpdateKanbanPhasePositionsMutationVariables>(UpdateKanbanPhasePositionsDocument, options);
      }
export type UpdateKanbanPhasePositionsMutationHookResult = ReturnType<typeof useUpdateKanbanPhasePositionsMutation>;
export type UpdateKanbanPhasePositionsMutationResult = Apollo.MutationResult<UpdateKanbanPhasePositionsMutation>;
export type UpdateKanbanPhasePositionsMutationOptions = Apollo.BaseMutationOptions<UpdateKanbanPhasePositionsMutation, UpdateKanbanPhasePositionsMutationVariables>;
export const AddPlayerToKanbanDocument = gql`
    mutation AddPlayerToKanban($input: AddPlayerToKanbanInput!) {
  addPlayerToKanban(input: $input) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type AddPlayerToKanbanMutationFn = Apollo.MutationFunction<AddPlayerToKanbanMutation, AddPlayerToKanbanMutationVariables>;

/**
 * __useAddPlayerToKanbanMutation__
 *
 * To run a mutation, you first call `useAddPlayerToKanbanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlayerToKanbanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlayerToKanbanMutation, { data, loading, error }] = useAddPlayerToKanbanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlayerToKanbanMutation(baseOptions?: Apollo.MutationHookOptions<AddPlayerToKanbanMutation, AddPlayerToKanbanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlayerToKanbanMutation, AddPlayerToKanbanMutationVariables>(AddPlayerToKanbanDocument, options);
      }
export type AddPlayerToKanbanMutationHookResult = ReturnType<typeof useAddPlayerToKanbanMutation>;
export type AddPlayerToKanbanMutationResult = Apollo.MutationResult<AddPlayerToKanbanMutation>;
export type AddPlayerToKanbanMutationOptions = Apollo.BaseMutationOptions<AddPlayerToKanbanMutation, AddPlayerToKanbanMutationVariables>;
export const MoveKanbanCardDocument = gql`
    mutation MoveKanbanCard($input: MoveKanbanCardInput!) {
  moveKanbanCard(input: $input) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type MoveKanbanCardMutationFn = Apollo.MutationFunction<MoveKanbanCardMutation, MoveKanbanCardMutationVariables>;

/**
 * __useMoveKanbanCardMutation__
 *
 * To run a mutation, you first call `useMoveKanbanCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveKanbanCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveKanbanCardMutation, { data, loading, error }] = useMoveKanbanCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveKanbanCardMutation(baseOptions?: Apollo.MutationHookOptions<MoveKanbanCardMutation, MoveKanbanCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveKanbanCardMutation, MoveKanbanCardMutationVariables>(MoveKanbanCardDocument, options);
      }
export type MoveKanbanCardMutationHookResult = ReturnType<typeof useMoveKanbanCardMutation>;
export type MoveKanbanCardMutationResult = Apollo.MutationResult<MoveKanbanCardMutation>;
export type MoveKanbanCardMutationOptions = Apollo.BaseMutationOptions<MoveKanbanCardMutation, MoveKanbanCardMutationVariables>;
export const UpdateKanbanCardDocument = gql`
    mutation UpdateKanbanCard($id: ID!, $input: UpdateKanbanCardInput!) {
  updateKanbanCard(id: $id, input: $input) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type UpdateKanbanCardMutationFn = Apollo.MutationFunction<UpdateKanbanCardMutation, UpdateKanbanCardMutationVariables>;

/**
 * __useUpdateKanbanCardMutation__
 *
 * To run a mutation, you first call `useUpdateKanbanCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKanbanCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKanbanCardMutation, { data, loading, error }] = useUpdateKanbanCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKanbanCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKanbanCardMutation, UpdateKanbanCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKanbanCardMutation, UpdateKanbanCardMutationVariables>(UpdateKanbanCardDocument, options);
      }
export type UpdateKanbanCardMutationHookResult = ReturnType<typeof useUpdateKanbanCardMutation>;
export type UpdateKanbanCardMutationResult = Apollo.MutationResult<UpdateKanbanCardMutation>;
export type UpdateKanbanCardMutationOptions = Apollo.BaseMutationOptions<UpdateKanbanCardMutation, UpdateKanbanCardMutationVariables>;
export const CloseKanbanCardToTerminalStageDocument = gql`
    mutation CloseKanbanCardToTerminalStage($input: CloseKanbanCardToTerminalStageInput!) {
  closeKanbanCardToTerminalStage(input: $input) {
    ...KanbanCardFragment
    outcome
    closedAt
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type CloseKanbanCardToTerminalStageMutationFn = Apollo.MutationFunction<CloseKanbanCardToTerminalStageMutation, CloseKanbanCardToTerminalStageMutationVariables>;

/**
 * __useCloseKanbanCardToTerminalStageMutation__
 *
 * To run a mutation, you first call `useCloseKanbanCardToTerminalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseKanbanCardToTerminalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeKanbanCardToTerminalStageMutation, { data, loading, error }] = useCloseKanbanCardToTerminalStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseKanbanCardToTerminalStageMutation(baseOptions?: Apollo.MutationHookOptions<CloseKanbanCardToTerminalStageMutation, CloseKanbanCardToTerminalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseKanbanCardToTerminalStageMutation, CloseKanbanCardToTerminalStageMutationVariables>(CloseKanbanCardToTerminalStageDocument, options);
      }
export type CloseKanbanCardToTerminalStageMutationHookResult = ReturnType<typeof useCloseKanbanCardToTerminalStageMutation>;
export type CloseKanbanCardToTerminalStageMutationResult = Apollo.MutationResult<CloseKanbanCardToTerminalStageMutation>;
export type CloseKanbanCardToTerminalStageMutationOptions = Apollo.BaseMutationOptions<CloseKanbanCardToTerminalStageMutation, CloseKanbanCardToTerminalStageMutationVariables>;
export const ReopenKanbanCardDocument = gql`
    mutation ReopenKanbanCard($input: ReopenKanbanCardInput!) {
  reopenKanbanCard(input: $input) {
    ...KanbanCardFragment
    outcome
    closedAt
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type ReopenKanbanCardMutationFn = Apollo.MutationFunction<ReopenKanbanCardMutation, ReopenKanbanCardMutationVariables>;

/**
 * __useReopenKanbanCardMutation__
 *
 * To run a mutation, you first call `useReopenKanbanCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenKanbanCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenKanbanCardMutation, { data, loading, error }] = useReopenKanbanCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenKanbanCardMutation(baseOptions?: Apollo.MutationHookOptions<ReopenKanbanCardMutation, ReopenKanbanCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenKanbanCardMutation, ReopenKanbanCardMutationVariables>(ReopenKanbanCardDocument, options);
      }
export type ReopenKanbanCardMutationHookResult = ReturnType<typeof useReopenKanbanCardMutation>;
export type ReopenKanbanCardMutationResult = Apollo.MutationResult<ReopenKanbanCardMutation>;
export type ReopenKanbanCardMutationOptions = Apollo.BaseMutationOptions<ReopenKanbanCardMutation, ReopenKanbanCardMutationVariables>;
export const RemovePlayerFromKanbanDocument = gql`
    mutation RemovePlayerFromKanban($kanbanBoardId: ID!, $playerId: ID!, $rationale: String) {
  removePlayerFromKanban(
    kanbanBoardId: $kanbanBoardId
    playerId: $playerId
    rationale: $rationale
  ) {
    id
    position
    notes
    kanbanPhaseId
    kanbanPhase {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;
export type RemovePlayerFromKanbanMutationFn = Apollo.MutationFunction<RemovePlayerFromKanbanMutation, RemovePlayerFromKanbanMutationVariables>;

/**
 * __useRemovePlayerFromKanbanMutation__
 *
 * To run a mutation, you first call `useRemovePlayerFromKanbanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlayerFromKanbanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlayerFromKanbanMutation, { data, loading, error }] = useRemovePlayerFromKanbanMutation({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      playerId: // value for 'playerId'
 *      rationale: // value for 'rationale'
 *   },
 * });
 */
export function useRemovePlayerFromKanbanMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlayerFromKanbanMutation, RemovePlayerFromKanbanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlayerFromKanbanMutation, RemovePlayerFromKanbanMutationVariables>(RemovePlayerFromKanbanDocument, options);
      }
export type RemovePlayerFromKanbanMutationHookResult = ReturnType<typeof useRemovePlayerFromKanbanMutation>;
export type RemovePlayerFromKanbanMutationResult = Apollo.MutationResult<RemovePlayerFromKanbanMutation>;
export type RemovePlayerFromKanbanMutationOptions = Apollo.BaseMutationOptions<RemovePlayerFromKanbanMutation, RemovePlayerFromKanbanMutationVariables>;
export const UpdateKanbanCardPositionsDocument = gql`
    mutation UpdateKanbanCardPositions($input: UpdateKanbanCardPositionsInput!) {
  updateKanbanCardPositions(input: $input) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type UpdateKanbanCardPositionsMutationFn = Apollo.MutationFunction<UpdateKanbanCardPositionsMutation, UpdateKanbanCardPositionsMutationVariables>;

/**
 * __useUpdateKanbanCardPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateKanbanCardPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKanbanCardPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKanbanCardPositionsMutation, { data, loading, error }] = useUpdateKanbanCardPositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKanbanCardPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKanbanCardPositionsMutation, UpdateKanbanCardPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKanbanCardPositionsMutation, UpdateKanbanCardPositionsMutationVariables>(UpdateKanbanCardPositionsDocument, options);
      }
export type UpdateKanbanCardPositionsMutationHookResult = ReturnType<typeof useUpdateKanbanCardPositionsMutation>;
export type UpdateKanbanCardPositionsMutationResult = Apollo.MutationResult<UpdateKanbanCardPositionsMutation>;
export type UpdateKanbanCardPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateKanbanCardPositionsMutation, UpdateKanbanCardPositionsMutationVariables>;
export const SetKanbanBoardDefaultCardOrderDocument = gql`
    mutation SetKanbanBoardDefaultCardOrder($kanbanBoardId: ID!) {
  setKanbanBoardDefaultCardOrder(kanbanBoardId: $kanbanBoardId) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type SetKanbanBoardDefaultCardOrderMutationFn = Apollo.MutationFunction<SetKanbanBoardDefaultCardOrderMutation, SetKanbanBoardDefaultCardOrderMutationVariables>;

/**
 * __useSetKanbanBoardDefaultCardOrderMutation__
 *
 * To run a mutation, you first call `useSetKanbanBoardDefaultCardOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetKanbanBoardDefaultCardOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setKanbanBoardDefaultCardOrderMutation, { data, loading, error }] = useSetKanbanBoardDefaultCardOrderMutation({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useSetKanbanBoardDefaultCardOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetKanbanBoardDefaultCardOrderMutation, SetKanbanBoardDefaultCardOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetKanbanBoardDefaultCardOrderMutation, SetKanbanBoardDefaultCardOrderMutationVariables>(SetKanbanBoardDefaultCardOrderDocument, options);
      }
export type SetKanbanBoardDefaultCardOrderMutationHookResult = ReturnType<typeof useSetKanbanBoardDefaultCardOrderMutation>;
export type SetKanbanBoardDefaultCardOrderMutationResult = Apollo.MutationResult<SetKanbanBoardDefaultCardOrderMutation>;
export type SetKanbanBoardDefaultCardOrderMutationOptions = Apollo.BaseMutationOptions<SetKanbanBoardDefaultCardOrderMutation, SetKanbanBoardDefaultCardOrderMutationVariables>;
export const ResetKanbanBoardCardOrderDocument = gql`
    mutation ResetKanbanBoardCardOrder($kanbanBoardId: ID!) {
  resetKanbanBoardCardOrder(kanbanBoardId: $kanbanBoardId) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type ResetKanbanBoardCardOrderMutationFn = Apollo.MutationFunction<ResetKanbanBoardCardOrderMutation, ResetKanbanBoardCardOrderMutationVariables>;

/**
 * __useResetKanbanBoardCardOrderMutation__
 *
 * To run a mutation, you first call `useResetKanbanBoardCardOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetKanbanBoardCardOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetKanbanBoardCardOrderMutation, { data, loading, error }] = useResetKanbanBoardCardOrderMutation({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useResetKanbanBoardCardOrderMutation(baseOptions?: Apollo.MutationHookOptions<ResetKanbanBoardCardOrderMutation, ResetKanbanBoardCardOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetKanbanBoardCardOrderMutation, ResetKanbanBoardCardOrderMutationVariables>(ResetKanbanBoardCardOrderDocument, options);
      }
export type ResetKanbanBoardCardOrderMutationHookResult = ReturnType<typeof useResetKanbanBoardCardOrderMutation>;
export type ResetKanbanBoardCardOrderMutationResult = Apollo.MutationResult<ResetKanbanBoardCardOrderMutation>;
export type ResetKanbanBoardCardOrderMutationOptions = Apollo.BaseMutationOptions<ResetKanbanBoardCardOrderMutation, ResetKanbanBoardCardOrderMutationVariables>;
export const GetKanbanBoardCardOrderStateDocument = gql`
    query GetKanbanBoardCardOrderState($id: ID!) {
  getKanbanBoard(id: $id) {
    id
    hasPersonalCardOrder
  }
}
    `;

/**
 * __useGetKanbanBoardCardOrderStateQuery__
 *
 * To run a query within a React component, call `useGetKanbanBoardCardOrderStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKanbanBoardCardOrderStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKanbanBoardCardOrderStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKanbanBoardCardOrderStateQuery(baseOptions: Apollo.QueryHookOptions<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables> & ({ variables: GetKanbanBoardCardOrderStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>(GetKanbanBoardCardOrderStateDocument, options);
      }
export function useGetKanbanBoardCardOrderStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>(GetKanbanBoardCardOrderStateDocument, options);
        }
// @ts-ignore
export function useGetKanbanBoardCardOrderStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>;
export function useGetKanbanBoardCardOrderStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanBoardCardOrderStateQuery | undefined, GetKanbanBoardCardOrderStateQueryVariables>;
export function useGetKanbanBoardCardOrderStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>(GetKanbanBoardCardOrderStateDocument, options);
        }
export type GetKanbanBoardCardOrderStateQueryHookResult = ReturnType<typeof useGetKanbanBoardCardOrderStateQuery>;
export type GetKanbanBoardCardOrderStateLazyQueryHookResult = ReturnType<typeof useGetKanbanBoardCardOrderStateLazyQuery>;
export type GetKanbanBoardCardOrderStateSuspenseQueryHookResult = ReturnType<typeof useGetKanbanBoardCardOrderStateSuspenseQuery>;
export type GetKanbanBoardCardOrderStateQueryResult = Apollo.QueryResult<GetKanbanBoardCardOrderStateQuery, GetKanbanBoardCardOrderStateQueryVariables>;
export const KanbanCreateUserWatchlistDocument = gql`
    mutation KanbanCreateUserWatchlist($input: CreateUserWatchlistInput!) {
  createUserWatchlist(input: $input) {
    ...KanbanUserWatchlist
  }
}
    ${KanbanUserWatchlistFragmentDoc}`;
export type KanbanCreateUserWatchlistMutationFn = Apollo.MutationFunction<KanbanCreateUserWatchlistMutation, KanbanCreateUserWatchlistMutationVariables>;

/**
 * __useKanbanCreateUserWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanCreateUserWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanCreateUserWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanCreateUserWatchlistMutation, { data, loading, error }] = useKanbanCreateUserWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanCreateUserWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanCreateUserWatchlistMutation, KanbanCreateUserWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanCreateUserWatchlistMutation, KanbanCreateUserWatchlistMutationVariables>(KanbanCreateUserWatchlistDocument, options);
      }
export type KanbanCreateUserWatchlistMutationHookResult = ReturnType<typeof useKanbanCreateUserWatchlistMutation>;
export type KanbanCreateUserWatchlistMutationResult = Apollo.MutationResult<KanbanCreateUserWatchlistMutation>;
export type KanbanCreateUserWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanCreateUserWatchlistMutation, KanbanCreateUserWatchlistMutationVariables>;
export const KanbanDeleteUserWatchlistDocument = gql`
    mutation KanbanDeleteUserWatchlist($input: DeleteUserWatchlistInput!) {
  deleteUserWatchlist(input: $input) {
    ...KanbanUserWatchlist
  }
}
    ${KanbanUserWatchlistFragmentDoc}`;
export type KanbanDeleteUserWatchlistMutationFn = Apollo.MutationFunction<KanbanDeleteUserWatchlistMutation, KanbanDeleteUserWatchlistMutationVariables>;

/**
 * __useKanbanDeleteUserWatchlistMutation__
 *
 * To run a mutation, you first call `useKanbanDeleteUserWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKanbanDeleteUserWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kanbanDeleteUserWatchlistMutation, { data, loading, error }] = useKanbanDeleteUserWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKanbanDeleteUserWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<KanbanDeleteUserWatchlistMutation, KanbanDeleteUserWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KanbanDeleteUserWatchlistMutation, KanbanDeleteUserWatchlistMutationVariables>(KanbanDeleteUserWatchlistDocument, options);
      }
export type KanbanDeleteUserWatchlistMutationHookResult = ReturnType<typeof useKanbanDeleteUserWatchlistMutation>;
export type KanbanDeleteUserWatchlistMutationResult = Apollo.MutationResult<KanbanDeleteUserWatchlistMutation>;
export type KanbanDeleteUserWatchlistMutationOptions = Apollo.BaseMutationOptions<KanbanDeleteUserWatchlistMutation, KanbanDeleteUserWatchlistMutationVariables>;
export const ListKanbanTagsDocument = gql`
    query ListKanbanTags($first: Int, $after: String) {
  listKanbanTags(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...KanbanTagFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${KanbanTagFragmentFragmentDoc}`;

/**
 * __useListKanbanTagsQuery__
 *
 * To run a query within a React component, call `useListKanbanTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListKanbanTagsQuery(baseOptions?: Apollo.QueryHookOptions<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>(ListKanbanTagsDocument, options);
      }
export function useListKanbanTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>(ListKanbanTagsDocument, options);
        }
// @ts-ignore
export function useListKanbanTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>;
export function useListKanbanTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanTagsQuery | undefined, ListKanbanTagsQueryVariables>;
export function useListKanbanTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>(ListKanbanTagsDocument, options);
        }
export type ListKanbanTagsQueryHookResult = ReturnType<typeof useListKanbanTagsQuery>;
export type ListKanbanTagsLazyQueryHookResult = ReturnType<typeof useListKanbanTagsLazyQuery>;
export type ListKanbanTagsSuspenseQueryHookResult = ReturnType<typeof useListKanbanTagsSuspenseQuery>;
export type ListKanbanTagsQueryResult = Apollo.QueryResult<ListKanbanTagsQuery, ListKanbanTagsQueryVariables>;
export const ListKanbanTagsWithColorDocument = gql`
    query ListKanbanTagsWithColor($kanbanBoardId: ID!, $first: Int, $after: String) {
  listKanbanTags(first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        name
        cardCount
        color(kanbanBoardId: $kanbanBoardId)
        createdAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useListKanbanTagsWithColorQuery__
 *
 * To run a query within a React component, call `useListKanbanTagsWithColorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanTagsWithColorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanTagsWithColorQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListKanbanTagsWithColorQuery(baseOptions: Apollo.QueryHookOptions<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables> & ({ variables: ListKanbanTagsWithColorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>(ListKanbanTagsWithColorDocument, options);
      }
export function useListKanbanTagsWithColorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>(ListKanbanTagsWithColorDocument, options);
        }
// @ts-ignore
export function useListKanbanTagsWithColorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>;
export function useListKanbanTagsWithColorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanTagsWithColorQuery | undefined, ListKanbanTagsWithColorQueryVariables>;
export function useListKanbanTagsWithColorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>(ListKanbanTagsWithColorDocument, options);
        }
export type ListKanbanTagsWithColorQueryHookResult = ReturnType<typeof useListKanbanTagsWithColorQuery>;
export type ListKanbanTagsWithColorLazyQueryHookResult = ReturnType<typeof useListKanbanTagsWithColorLazyQuery>;
export type ListKanbanTagsWithColorSuspenseQueryHookResult = ReturnType<typeof useListKanbanTagsWithColorSuspenseQuery>;
export type ListKanbanTagsWithColorQueryResult = Apollo.QueryResult<ListKanbanTagsWithColorQuery, ListKanbanTagsWithColorQueryVariables>;
export const GetKanbanTagDocument = gql`
    query GetKanbanTag($id: ID!) {
  kanbanTag(id: $id) {
    ...KanbanTagFragment
  }
}
    ${KanbanTagFragmentFragmentDoc}`;

/**
 * __useGetKanbanTagQuery__
 *
 * To run a query within a React component, call `useGetKanbanTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKanbanTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKanbanTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKanbanTagQuery(baseOptions: Apollo.QueryHookOptions<GetKanbanTagQuery, GetKanbanTagQueryVariables> & ({ variables: GetKanbanTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKanbanTagQuery, GetKanbanTagQueryVariables>(GetKanbanTagDocument, options);
      }
export function useGetKanbanTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKanbanTagQuery, GetKanbanTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKanbanTagQuery, GetKanbanTagQueryVariables>(GetKanbanTagDocument, options);
        }
// @ts-ignore
export function useGetKanbanTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKanbanTagQuery, GetKanbanTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanTagQuery, GetKanbanTagQueryVariables>;
export function useGetKanbanTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanTagQuery, GetKanbanTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanTagQuery | undefined, GetKanbanTagQueryVariables>;
export function useGetKanbanTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanTagQuery, GetKanbanTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKanbanTagQuery, GetKanbanTagQueryVariables>(GetKanbanTagDocument, options);
        }
export type GetKanbanTagQueryHookResult = ReturnType<typeof useGetKanbanTagQuery>;
export type GetKanbanTagLazyQueryHookResult = ReturnType<typeof useGetKanbanTagLazyQuery>;
export type GetKanbanTagSuspenseQueryHookResult = ReturnType<typeof useGetKanbanTagSuspenseQuery>;
export type GetKanbanTagQueryResult = Apollo.QueryResult<GetKanbanTagQuery, GetKanbanTagQueryVariables>;
export const ListKanbanBoardTagsDocument = gql`
    query ListKanbanBoardTags($kanbanBoardId: ID!, $first: Int, $after: String) {
  listKanbanBoardTags(kanbanBoardId: $kanbanBoardId, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...KanbanBoardTagFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${KanbanBoardTagFragmentFragmentDoc}`;

/**
 * __useListKanbanBoardTagsQuery__
 *
 * To run a query within a React component, call `useListKanbanBoardTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanBoardTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanBoardTagsQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListKanbanBoardTagsQuery(baseOptions: Apollo.QueryHookOptions<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables> & ({ variables: ListKanbanBoardTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>(ListKanbanBoardTagsDocument, options);
      }
export function useListKanbanBoardTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>(ListKanbanBoardTagsDocument, options);
        }
// @ts-ignore
export function useListKanbanBoardTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>;
export function useListKanbanBoardTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanBoardTagsQuery | undefined, ListKanbanBoardTagsQueryVariables>;
export function useListKanbanBoardTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>(ListKanbanBoardTagsDocument, options);
        }
export type ListKanbanBoardTagsQueryHookResult = ReturnType<typeof useListKanbanBoardTagsQuery>;
export type ListKanbanBoardTagsLazyQueryHookResult = ReturnType<typeof useListKanbanBoardTagsLazyQuery>;
export type ListKanbanBoardTagsSuspenseQueryHookResult = ReturnType<typeof useListKanbanBoardTagsSuspenseQuery>;
export type ListKanbanBoardTagsQueryResult = Apollo.QueryResult<ListKanbanBoardTagsQuery, ListKanbanBoardTagsQueryVariables>;
export const KanbanCardTagsDocument = gql`
    query KanbanCardTags($id: ID!, $kanbanBoardId: ID!) {
  kanbanCard(id: $id) {
    id
    tags {
      id
      name
      cardCount
      color(kanbanBoardId: $kanbanBoardId)
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useKanbanCardTagsQuery__
 *
 * To run a query within a React component, call `useKanbanCardTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKanbanCardTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKanbanCardTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useKanbanCardTagsQuery(baseOptions: Apollo.QueryHookOptions<KanbanCardTagsQuery, KanbanCardTagsQueryVariables> & ({ variables: KanbanCardTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>(KanbanCardTagsDocument, options);
      }
export function useKanbanCardTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>(KanbanCardTagsDocument, options);
        }
// @ts-ignore
export function useKanbanCardTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>;
export function useKanbanCardTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>): Apollo.UseSuspenseQueryResult<KanbanCardTagsQuery | undefined, KanbanCardTagsQueryVariables>;
export function useKanbanCardTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>(KanbanCardTagsDocument, options);
        }
export type KanbanCardTagsQueryHookResult = ReturnType<typeof useKanbanCardTagsQuery>;
export type KanbanCardTagsLazyQueryHookResult = ReturnType<typeof useKanbanCardTagsLazyQuery>;
export type KanbanCardTagsSuspenseQueryHookResult = ReturnType<typeof useKanbanCardTagsSuspenseQuery>;
export type KanbanCardTagsQueryResult = Apollo.QueryResult<KanbanCardTagsQuery, KanbanCardTagsQueryVariables>;
export const CreateKanbanTagDocument = gql`
    mutation CreateKanbanTag($input: CreateKanbanTagInput!) {
  createKanbanTag(input: $input) {
    ...KanbanTagFragment
  }
}
    ${KanbanTagFragmentFragmentDoc}`;
export type CreateKanbanTagMutationFn = Apollo.MutationFunction<CreateKanbanTagMutation, CreateKanbanTagMutationVariables>;

/**
 * __useCreateKanbanTagMutation__
 *
 * To run a mutation, you first call `useCreateKanbanTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKanbanTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKanbanTagMutation, { data, loading, error }] = useCreateKanbanTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKanbanTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateKanbanTagMutation, CreateKanbanTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKanbanTagMutation, CreateKanbanTagMutationVariables>(CreateKanbanTagDocument, options);
      }
export type CreateKanbanTagMutationHookResult = ReturnType<typeof useCreateKanbanTagMutation>;
export type CreateKanbanTagMutationResult = Apollo.MutationResult<CreateKanbanTagMutation>;
export type CreateKanbanTagMutationOptions = Apollo.BaseMutationOptions<CreateKanbanTagMutation, CreateKanbanTagMutationVariables>;
export const UpdateKanbanTagDocument = gql`
    mutation UpdateKanbanTag($id: ID!, $input: UpdateKanbanTagInput!) {
  updateKanbanTag(id: $id, input: $input) {
    ...KanbanTagFragment
  }
}
    ${KanbanTagFragmentFragmentDoc}`;
export type UpdateKanbanTagMutationFn = Apollo.MutationFunction<UpdateKanbanTagMutation, UpdateKanbanTagMutationVariables>;

/**
 * __useUpdateKanbanTagMutation__
 *
 * To run a mutation, you first call `useUpdateKanbanTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKanbanTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKanbanTagMutation, { data, loading, error }] = useUpdateKanbanTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKanbanTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKanbanTagMutation, UpdateKanbanTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKanbanTagMutation, UpdateKanbanTagMutationVariables>(UpdateKanbanTagDocument, options);
      }
export type UpdateKanbanTagMutationHookResult = ReturnType<typeof useUpdateKanbanTagMutation>;
export type UpdateKanbanTagMutationResult = Apollo.MutationResult<UpdateKanbanTagMutation>;
export type UpdateKanbanTagMutationOptions = Apollo.BaseMutationOptions<UpdateKanbanTagMutation, UpdateKanbanTagMutationVariables>;
export const DeleteKanbanTagDocument = gql`
    mutation DeleteKanbanTag($id: ID!) {
  deleteKanbanTag(id: $id) {
    ...KanbanTagFragment
  }
}
    ${KanbanTagFragmentFragmentDoc}`;
export type DeleteKanbanTagMutationFn = Apollo.MutationFunction<DeleteKanbanTagMutation, DeleteKanbanTagMutationVariables>;

/**
 * __useDeleteKanbanTagMutation__
 *
 * To run a mutation, you first call `useDeleteKanbanTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKanbanTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKanbanTagMutation, { data, loading, error }] = useDeleteKanbanTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKanbanTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKanbanTagMutation, DeleteKanbanTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKanbanTagMutation, DeleteKanbanTagMutationVariables>(DeleteKanbanTagDocument, options);
      }
export type DeleteKanbanTagMutationHookResult = ReturnType<typeof useDeleteKanbanTagMutation>;
export type DeleteKanbanTagMutationResult = Apollo.MutationResult<DeleteKanbanTagMutation>;
export type DeleteKanbanTagMutationOptions = Apollo.BaseMutationOptions<DeleteKanbanTagMutation, DeleteKanbanTagMutationVariables>;
export const SetKanbanBoardTagColorDocument = gql`
    mutation SetKanbanBoardTagColor($input: SetKanbanBoardTagColorInput!) {
  setKanbanBoardTagColor(input: $input) {
    ...KanbanBoardTagFragment
  }
}
    ${KanbanBoardTagFragmentFragmentDoc}`;
export type SetKanbanBoardTagColorMutationFn = Apollo.MutationFunction<SetKanbanBoardTagColorMutation, SetKanbanBoardTagColorMutationVariables>;

/**
 * __useSetKanbanBoardTagColorMutation__
 *
 * To run a mutation, you first call `useSetKanbanBoardTagColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetKanbanBoardTagColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setKanbanBoardTagColorMutation, { data, loading, error }] = useSetKanbanBoardTagColorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetKanbanBoardTagColorMutation(baseOptions?: Apollo.MutationHookOptions<SetKanbanBoardTagColorMutation, SetKanbanBoardTagColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetKanbanBoardTagColorMutation, SetKanbanBoardTagColorMutationVariables>(SetKanbanBoardTagColorDocument, options);
      }
export type SetKanbanBoardTagColorMutationHookResult = ReturnType<typeof useSetKanbanBoardTagColorMutation>;
export type SetKanbanBoardTagColorMutationResult = Apollo.MutationResult<SetKanbanBoardTagColorMutation>;
export type SetKanbanBoardTagColorMutationOptions = Apollo.BaseMutationOptions<SetKanbanBoardTagColorMutation, SetKanbanBoardTagColorMutationVariables>;
export const AddTagsToKanbanCardDocument = gql`
    mutation AddTagsToKanbanCard($cardId: ID!, $tagIds: [ID!]!, $kanbanBoardId: ID!) {
  addTagsToKanbanCard(cardId: $cardId, tagIds: $tagIds) {
    ...KanbanCardFragment
    tags {
      id
      name
      cardCount
      color(kanbanBoardId: $kanbanBoardId)
      createdAt
      updatedAt
    }
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type AddTagsToKanbanCardMutationFn = Apollo.MutationFunction<AddTagsToKanbanCardMutation, AddTagsToKanbanCardMutationVariables>;

/**
 * __useAddTagsToKanbanCardMutation__
 *
 * To run a mutation, you first call `useAddTagsToKanbanCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToKanbanCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToKanbanCardMutation, { data, loading, error }] = useAddTagsToKanbanCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      tagIds: // value for 'tagIds'
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useAddTagsToKanbanCardMutation(baseOptions?: Apollo.MutationHookOptions<AddTagsToKanbanCardMutation, AddTagsToKanbanCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagsToKanbanCardMutation, AddTagsToKanbanCardMutationVariables>(AddTagsToKanbanCardDocument, options);
      }
export type AddTagsToKanbanCardMutationHookResult = ReturnType<typeof useAddTagsToKanbanCardMutation>;
export type AddTagsToKanbanCardMutationResult = Apollo.MutationResult<AddTagsToKanbanCardMutation>;
export type AddTagsToKanbanCardMutationOptions = Apollo.BaseMutationOptions<AddTagsToKanbanCardMutation, AddTagsToKanbanCardMutationVariables>;
export const RemoveTagsFromKanbanCardDocument = gql`
    mutation RemoveTagsFromKanbanCard($cardId: ID!, $tagIds: [ID!]!, $kanbanBoardId: ID!) {
  removeTagsFromKanbanCard(cardId: $cardId, tagIds: $tagIds) {
    ...KanbanCardFragment
    tags {
      id
      name
      cardCount
      color(kanbanBoardId: $kanbanBoardId)
      createdAt
      updatedAt
    }
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type RemoveTagsFromKanbanCardMutationFn = Apollo.MutationFunction<RemoveTagsFromKanbanCardMutation, RemoveTagsFromKanbanCardMutationVariables>;

/**
 * __useRemoveTagsFromKanbanCardMutation__
 *
 * To run a mutation, you first call `useRemoveTagsFromKanbanCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagsFromKanbanCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagsFromKanbanCardMutation, { data, loading, error }] = useRemoveTagsFromKanbanCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      tagIds: // value for 'tagIds'
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useRemoveTagsFromKanbanCardMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagsFromKanbanCardMutation, RemoveTagsFromKanbanCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagsFromKanbanCardMutation, RemoveTagsFromKanbanCardMutationVariables>(RemoveTagsFromKanbanCardDocument, options);
      }
export type RemoveTagsFromKanbanCardMutationHookResult = ReturnType<typeof useRemoveTagsFromKanbanCardMutation>;
export type RemoveTagsFromKanbanCardMutationResult = Apollo.MutationResult<RemoveTagsFromKanbanCardMutation>;
export type RemoveTagsFromKanbanCardMutationOptions = Apollo.BaseMutationOptions<RemoveTagsFromKanbanCardMutation, RemoveTagsFromKanbanCardMutationVariables>;
export const SetKanbanCardTagsDocument = gql`
    mutation SetKanbanCardTags($cardId: ID!, $tagIds: [ID!]!, $kanbanBoardId: ID!) {
  setKanbanCardTags(cardId: $cardId, tagIds: $tagIds) {
    ...KanbanCardFragment
    tags {
      id
      name
      cardCount
      color(kanbanBoardId: $kanbanBoardId)
      createdAt
      updatedAt
    }
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type SetKanbanCardTagsMutationFn = Apollo.MutationFunction<SetKanbanCardTagsMutation, SetKanbanCardTagsMutationVariables>;

/**
 * __useSetKanbanCardTagsMutation__
 *
 * To run a mutation, you first call `useSetKanbanCardTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetKanbanCardTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setKanbanCardTagsMutation, { data, loading, error }] = useSetKanbanCardTagsMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      tagIds: // value for 'tagIds'
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useSetKanbanCardTagsMutation(baseOptions?: Apollo.MutationHookOptions<SetKanbanCardTagsMutation, SetKanbanCardTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetKanbanCardTagsMutation, SetKanbanCardTagsMutationVariables>(SetKanbanCardTagsDocument, options);
      }
export type SetKanbanCardTagsMutationHookResult = ReturnType<typeof useSetKanbanCardTagsMutation>;
export type SetKanbanCardTagsMutationResult = Apollo.MutationResult<SetKanbanCardTagsMutation>;
export type SetKanbanCardTagsMutationOptions = Apollo.BaseMutationOptions<SetKanbanCardTagsMutation, SetKanbanCardTagsMutationVariables>;
export const GetKanbanBoardWithPermissionsDocument = gql`
    query GetKanbanBoardWithPermissions($id: ID!, $first: Int, $after: String) {
  getKanbanBoard(id: $id) {
    ...KanbanBoardFragment
    users(first: $first, after: $after) {
      ...UserKanbanBoardConnection
    }
  }
}
    ${KanbanBoardFragmentFragmentDoc}
${UserKanbanBoardConnectionFragmentDoc}`;

/**
 * __useGetKanbanBoardWithPermissionsQuery__
 *
 * To run a query within a React component, call `useGetKanbanBoardWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKanbanBoardWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKanbanBoardWithPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetKanbanBoardWithPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables> & ({ variables: GetKanbanBoardWithPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>(GetKanbanBoardWithPermissionsDocument, options);
      }
export function useGetKanbanBoardWithPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>(GetKanbanBoardWithPermissionsDocument, options);
        }
// @ts-ignore
export function useGetKanbanBoardWithPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>;
export function useGetKanbanBoardWithPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetKanbanBoardWithPermissionsQuery | undefined, GetKanbanBoardWithPermissionsQueryVariables>;
export function useGetKanbanBoardWithPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>(GetKanbanBoardWithPermissionsDocument, options);
        }
export type GetKanbanBoardWithPermissionsQueryHookResult = ReturnType<typeof useGetKanbanBoardWithPermissionsQuery>;
export type GetKanbanBoardWithPermissionsLazyQueryHookResult = ReturnType<typeof useGetKanbanBoardWithPermissionsLazyQuery>;
export type GetKanbanBoardWithPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetKanbanBoardWithPermissionsSuspenseQuery>;
export type GetKanbanBoardWithPermissionsQueryResult = Apollo.QueryResult<GetKanbanBoardWithPermissionsQuery, GetKanbanBoardWithPermissionsQueryVariables>;
export const ListKanbanOrganizationUsersDocument = gql`
    query ListKanbanOrganizationUsers($first: Int, $after: String) {
  listMyOrganizationsOrganizationUsers(first: $first, after: $after) {
    ...KanbanOrganizationUserConnection
  }
}
    ${KanbanOrganizationUserConnectionFragmentDoc}`;

/**
 * __useListKanbanOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useListKanbanOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanOrganizationUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListKanbanOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>(ListKanbanOrganizationUsersDocument, options);
      }
export function useListKanbanOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>(ListKanbanOrganizationUsersDocument, options);
        }
// @ts-ignore
export function useListKanbanOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>;
export function useListKanbanOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanOrganizationUsersQuery | undefined, ListKanbanOrganizationUsersQueryVariables>;
export function useListKanbanOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>(ListKanbanOrganizationUsersDocument, options);
        }
export type ListKanbanOrganizationUsersQueryHookResult = ReturnType<typeof useListKanbanOrganizationUsersQuery>;
export type ListKanbanOrganizationUsersLazyQueryHookResult = ReturnType<typeof useListKanbanOrganizationUsersLazyQuery>;
export type ListKanbanOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useListKanbanOrganizationUsersSuspenseQuery>;
export type ListKanbanOrganizationUsersQueryResult = Apollo.QueryResult<ListKanbanOrganizationUsersQuery, ListKanbanOrganizationUsersQueryVariables>;
export const AddUserToKanbanBoardDocument = gql`
    mutation AddUserToKanbanBoard($input: AddUserToKanbanBoardInput!) {
  addUserToKanbanBoard(input: $input) {
    ...UserKanbanBoardFragment
  }
}
    ${UserKanbanBoardFragmentFragmentDoc}`;
export type AddUserToKanbanBoardMutationFn = Apollo.MutationFunction<AddUserToKanbanBoardMutation, AddUserToKanbanBoardMutationVariables>;

/**
 * __useAddUserToKanbanBoardMutation__
 *
 * To run a mutation, you first call `useAddUserToKanbanBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToKanbanBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToKanbanBoardMutation, { data, loading, error }] = useAddUserToKanbanBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToKanbanBoardMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToKanbanBoardMutation, AddUserToKanbanBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToKanbanBoardMutation, AddUserToKanbanBoardMutationVariables>(AddUserToKanbanBoardDocument, options);
      }
export type AddUserToKanbanBoardMutationHookResult = ReturnType<typeof useAddUserToKanbanBoardMutation>;
export type AddUserToKanbanBoardMutationResult = Apollo.MutationResult<AddUserToKanbanBoardMutation>;
export type AddUserToKanbanBoardMutationOptions = Apollo.BaseMutationOptions<AddUserToKanbanBoardMutation, AddUserToKanbanBoardMutationVariables>;
export const RemoveUserFromKanbanBoardDocument = gql`
    mutation RemoveUserFromKanbanBoard($input: RemoveUserFromKanbanBoardInput!) {
  removeUserFromKanbanBoard(input: $input) {
    ...UserKanbanBoardFragment
  }
}
    ${UserKanbanBoardFragmentFragmentDoc}`;
export type RemoveUserFromKanbanBoardMutationFn = Apollo.MutationFunction<RemoveUserFromKanbanBoardMutation, RemoveUserFromKanbanBoardMutationVariables>;

/**
 * __useRemoveUserFromKanbanBoardMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromKanbanBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromKanbanBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromKanbanBoardMutation, { data, loading, error }] = useRemoveUserFromKanbanBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserFromKanbanBoardMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromKanbanBoardMutation, RemoveUserFromKanbanBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromKanbanBoardMutation, RemoveUserFromKanbanBoardMutationVariables>(RemoveUserFromKanbanBoardDocument, options);
      }
export type RemoveUserFromKanbanBoardMutationHookResult = ReturnType<typeof useRemoveUserFromKanbanBoardMutation>;
export type RemoveUserFromKanbanBoardMutationResult = Apollo.MutationResult<RemoveUserFromKanbanBoardMutation>;
export type RemoveUserFromKanbanBoardMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromKanbanBoardMutation, RemoveUserFromKanbanBoardMutationVariables>;
export const UpdateUserKanbanBoardRoleDocument = gql`
    mutation UpdateUserKanbanBoardRole($input: UpdateUserKanbanBoardRoleInput!) {
  updateUserKanbanBoardRole(input: $input) {
    ...UserKanbanBoardFragment
  }
}
    ${UserKanbanBoardFragmentFragmentDoc}`;
export type UpdateUserKanbanBoardRoleMutationFn = Apollo.MutationFunction<UpdateUserKanbanBoardRoleMutation, UpdateUserKanbanBoardRoleMutationVariables>;

/**
 * __useUpdateUserKanbanBoardRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserKanbanBoardRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserKanbanBoardRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserKanbanBoardRoleMutation, { data, loading, error }] = useUpdateUserKanbanBoardRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserKanbanBoardRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserKanbanBoardRoleMutation, UpdateUserKanbanBoardRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserKanbanBoardRoleMutation, UpdateUserKanbanBoardRoleMutationVariables>(UpdateUserKanbanBoardRoleDocument, options);
      }
export type UpdateUserKanbanBoardRoleMutationHookResult = ReturnType<typeof useUpdateUserKanbanBoardRoleMutation>;
export type UpdateUserKanbanBoardRoleMutationResult = Apollo.MutationResult<UpdateUserKanbanBoardRoleMutation>;
export type UpdateUserKanbanBoardRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserKanbanBoardRoleMutation, UpdateUserKanbanBoardRoleMutationVariables>;
export const TransferKanbanBoardOwnershipDocument = gql`
    mutation TransferKanbanBoardOwnership($input: TransferKanbanBoardOwnershipInput!) {
  transferKanbanBoardOwnership(input: $input) {
    ...UserKanbanBoardFragment
  }
}
    ${UserKanbanBoardFragmentFragmentDoc}`;
export type TransferKanbanBoardOwnershipMutationFn = Apollo.MutationFunction<TransferKanbanBoardOwnershipMutation, TransferKanbanBoardOwnershipMutationVariables>;

/**
 * __useTransferKanbanBoardOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferKanbanBoardOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferKanbanBoardOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferKanbanBoardOwnershipMutation, { data, loading, error }] = useTransferKanbanBoardOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferKanbanBoardOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferKanbanBoardOwnershipMutation, TransferKanbanBoardOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferKanbanBoardOwnershipMutation, TransferKanbanBoardOwnershipMutationVariables>(TransferKanbanBoardOwnershipDocument, options);
      }
export type TransferKanbanBoardOwnershipMutationHookResult = ReturnType<typeof useTransferKanbanBoardOwnershipMutation>;
export type TransferKanbanBoardOwnershipMutationResult = Apollo.MutationResult<TransferKanbanBoardOwnershipMutation>;
export type TransferKanbanBoardOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferKanbanBoardOwnershipMutation, TransferKanbanBoardOwnershipMutationVariables>;
export const PipelineReviewQueueDocument = gql`
    query PipelineReviewQueue($status: PipelineReviewStatus, $kanbanBoardId: ID, $addressedToMe: Boolean, $first: Int, $after: String) {
  pipelineReviewQueue(
    status: $status
    kanbanBoardId: $kanbanBoardId
    addressedToMe: $addressedToMe
    first: $first
    after: $after
  ) {
    totalCount
    edges {
      cursor
      node {
        ...PipelineReviewRequestFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${PipelineReviewRequestFragmentFragmentDoc}`;

/**
 * __usePipelineReviewQueueQuery__
 *
 * To run a query within a React component, call `usePipelineReviewQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineReviewQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineReviewQueueQuery({
 *   variables: {
 *      status: // value for 'status'
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      addressedToMe: // value for 'addressedToMe'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePipelineReviewQueueQuery(baseOptions?: Apollo.QueryHookOptions<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>(PipelineReviewQueueDocument, options);
      }
export function usePipelineReviewQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>(PipelineReviewQueueDocument, options);
        }
// @ts-ignore
export function usePipelineReviewQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>;
export function usePipelineReviewQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineReviewQueueQuery | undefined, PipelineReviewQueueQueryVariables>;
export function usePipelineReviewQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>(PipelineReviewQueueDocument, options);
        }
export type PipelineReviewQueueQueryHookResult = ReturnType<typeof usePipelineReviewQueueQuery>;
export type PipelineReviewQueueLazyQueryHookResult = ReturnType<typeof usePipelineReviewQueueLazyQuery>;
export type PipelineReviewQueueSuspenseQueryHookResult = ReturnType<typeof usePipelineReviewQueueSuspenseQuery>;
export type PipelineReviewQueueQueryResult = Apollo.QueryResult<PipelineReviewQueueQuery, PipelineReviewQueueQueryVariables>;
export const PipelineReviewQueuePlayerDocument = gql`
    query PipelineReviewQueuePlayer($id: ID!) {
  getPlayer(id: $id) {
    id
    name
    knownName
    firstName
    lastName
    teamName
    positions {
      id
      name
      abbreviation
    }
  }
}
    `;

/**
 * __usePipelineReviewQueuePlayerQuery__
 *
 * To run a query within a React component, call `usePipelineReviewQueuePlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineReviewQueuePlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineReviewQueuePlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePipelineReviewQueuePlayerQuery(baseOptions: Apollo.QueryHookOptions<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables> & ({ variables: PipelineReviewQueuePlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>(PipelineReviewQueuePlayerDocument, options);
      }
export function usePipelineReviewQueuePlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>(PipelineReviewQueuePlayerDocument, options);
        }
// @ts-ignore
export function usePipelineReviewQueuePlayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>;
export function usePipelineReviewQueuePlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineReviewQueuePlayerQuery | undefined, PipelineReviewQueuePlayerQueryVariables>;
export function usePipelineReviewQueuePlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>(PipelineReviewQueuePlayerDocument, options);
        }
export type PipelineReviewQueuePlayerQueryHookResult = ReturnType<typeof usePipelineReviewQueuePlayerQuery>;
export type PipelineReviewQueuePlayerLazyQueryHookResult = ReturnType<typeof usePipelineReviewQueuePlayerLazyQuery>;
export type PipelineReviewQueuePlayerSuspenseQueryHookResult = ReturnType<typeof usePipelineReviewQueuePlayerSuspenseQuery>;
export type PipelineReviewQueuePlayerQueryResult = Apollo.QueryResult<PipelineReviewQueuePlayerQuery, PipelineReviewQueuePlayerQueryVariables>;
export const AcceptPipelineReviewRequestDocument = gql`
    mutation AcceptPipelineReviewRequest($input: AcceptPipelineReviewRequestInput!) {
  acceptPipelineReviewRequest(input: $input) {
    ...PipelineReviewRequestFragment
  }
}
    ${PipelineReviewRequestFragmentFragmentDoc}`;
export type AcceptPipelineReviewRequestMutationFn = Apollo.MutationFunction<AcceptPipelineReviewRequestMutation, AcceptPipelineReviewRequestMutationVariables>;

/**
 * __useAcceptPipelineReviewRequestMutation__
 *
 * To run a mutation, you first call `useAcceptPipelineReviewRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPipelineReviewRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPipelineReviewRequestMutation, { data, loading, error }] = useAcceptPipelineReviewRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptPipelineReviewRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPipelineReviewRequestMutation, AcceptPipelineReviewRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPipelineReviewRequestMutation, AcceptPipelineReviewRequestMutationVariables>(AcceptPipelineReviewRequestDocument, options);
      }
export type AcceptPipelineReviewRequestMutationHookResult = ReturnType<typeof useAcceptPipelineReviewRequestMutation>;
export type AcceptPipelineReviewRequestMutationResult = Apollo.MutationResult<AcceptPipelineReviewRequestMutation>;
export type AcceptPipelineReviewRequestMutationOptions = Apollo.BaseMutationOptions<AcceptPipelineReviewRequestMutation, AcceptPipelineReviewRequestMutationVariables>;
export const DeclinePipelineReviewRequestDocument = gql`
    mutation DeclinePipelineReviewRequest($input: DeclinePipelineReviewRequestInput!) {
  declinePipelineReviewRequest(input: $input) {
    ...PipelineReviewRequestFragment
  }
}
    ${PipelineReviewRequestFragmentFragmentDoc}`;
export type DeclinePipelineReviewRequestMutationFn = Apollo.MutationFunction<DeclinePipelineReviewRequestMutation, DeclinePipelineReviewRequestMutationVariables>;

/**
 * __useDeclinePipelineReviewRequestMutation__
 *
 * To run a mutation, you first call `useDeclinePipelineReviewRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclinePipelineReviewRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declinePipelineReviewRequestMutation, { data, loading, error }] = useDeclinePipelineReviewRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclinePipelineReviewRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclinePipelineReviewRequestMutation, DeclinePipelineReviewRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclinePipelineReviewRequestMutation, DeclinePipelineReviewRequestMutationVariables>(DeclinePipelineReviewRequestDocument, options);
      }
export type DeclinePipelineReviewRequestMutationHookResult = ReturnType<typeof useDeclinePipelineReviewRequestMutation>;
export type DeclinePipelineReviewRequestMutationResult = Apollo.MutationResult<DeclinePipelineReviewRequestMutation>;
export type DeclinePipelineReviewRequestMutationOptions = Apollo.BaseMutationOptions<DeclinePipelineReviewRequestMutation, DeclinePipelineReviewRequestMutationVariables>;
export const PipelineAutomationRulesDocument = gql`
    query PipelineAutomationRules($kanbanBoardId: ID!, $first: Int, $after: String) {
  pipelineAutomationRules(
    kanbanBoardId: $kanbanBoardId
    first: $first
    after: $after
  ) {
    totalCount
    edges {
      cursor
      node {
        ...PipelineAutomationRuleFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${PipelineAutomationRuleFragmentFragmentDoc}`;

/**
 * __usePipelineAutomationRulesQuery__
 *
 * To run a query within a React component, call `usePipelineAutomationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineAutomationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineAutomationRulesQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePipelineAutomationRulesQuery(baseOptions: Apollo.QueryHookOptions<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables> & ({ variables: PipelineAutomationRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>(PipelineAutomationRulesDocument, options);
      }
export function usePipelineAutomationRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>(PipelineAutomationRulesDocument, options);
        }
// @ts-ignore
export function usePipelineAutomationRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>;
export function usePipelineAutomationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<PipelineAutomationRulesQuery | undefined, PipelineAutomationRulesQueryVariables>;
export function usePipelineAutomationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>(PipelineAutomationRulesDocument, options);
        }
export type PipelineAutomationRulesQueryHookResult = ReturnType<typeof usePipelineAutomationRulesQuery>;
export type PipelineAutomationRulesLazyQueryHookResult = ReturnType<typeof usePipelineAutomationRulesLazyQuery>;
export type PipelineAutomationRulesSuspenseQueryHookResult = ReturnType<typeof usePipelineAutomationRulesSuspenseQuery>;
export type PipelineAutomationRulesQueryResult = Apollo.QueryResult<PipelineAutomationRulesQuery, PipelineAutomationRulesQueryVariables>;
export const CreatePipelineAutomationRuleDocument = gql`
    mutation CreatePipelineAutomationRule($input: CreatePipelineAutomationRuleInput!) {
  createPipelineAutomationRule(input: $input) {
    ...PipelineAutomationRuleFragment
  }
}
    ${PipelineAutomationRuleFragmentFragmentDoc}`;
export type CreatePipelineAutomationRuleMutationFn = Apollo.MutationFunction<CreatePipelineAutomationRuleMutation, CreatePipelineAutomationRuleMutationVariables>;

/**
 * __useCreatePipelineAutomationRuleMutation__
 *
 * To run a mutation, you first call `useCreatePipelineAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePipelineAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPipelineAutomationRuleMutation, { data, loading, error }] = useCreatePipelineAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePipelineAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePipelineAutomationRuleMutation, CreatePipelineAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePipelineAutomationRuleMutation, CreatePipelineAutomationRuleMutationVariables>(CreatePipelineAutomationRuleDocument, options);
      }
export type CreatePipelineAutomationRuleMutationHookResult = ReturnType<typeof useCreatePipelineAutomationRuleMutation>;
export type CreatePipelineAutomationRuleMutationResult = Apollo.MutationResult<CreatePipelineAutomationRuleMutation>;
export type CreatePipelineAutomationRuleMutationOptions = Apollo.BaseMutationOptions<CreatePipelineAutomationRuleMutation, CreatePipelineAutomationRuleMutationVariables>;
export const UpdatePipelineAutomationRuleDocument = gql`
    mutation UpdatePipelineAutomationRule($input: UpdatePipelineAutomationRuleInput!) {
  updatePipelineAutomationRule(input: $input) {
    ...PipelineAutomationRuleFragment
  }
}
    ${PipelineAutomationRuleFragmentFragmentDoc}`;
export type UpdatePipelineAutomationRuleMutationFn = Apollo.MutationFunction<UpdatePipelineAutomationRuleMutation, UpdatePipelineAutomationRuleMutationVariables>;

/**
 * __useUpdatePipelineAutomationRuleMutation__
 *
 * To run a mutation, you first call `useUpdatePipelineAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePipelineAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePipelineAutomationRuleMutation, { data, loading, error }] = useUpdatePipelineAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePipelineAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePipelineAutomationRuleMutation, UpdatePipelineAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePipelineAutomationRuleMutation, UpdatePipelineAutomationRuleMutationVariables>(UpdatePipelineAutomationRuleDocument, options);
      }
export type UpdatePipelineAutomationRuleMutationHookResult = ReturnType<typeof useUpdatePipelineAutomationRuleMutation>;
export type UpdatePipelineAutomationRuleMutationResult = Apollo.MutationResult<UpdatePipelineAutomationRuleMutation>;
export type UpdatePipelineAutomationRuleMutationOptions = Apollo.BaseMutationOptions<UpdatePipelineAutomationRuleMutation, UpdatePipelineAutomationRuleMutationVariables>;
export const DeletePipelineAutomationRuleDocument = gql`
    mutation DeletePipelineAutomationRule($automationRuleId: ID!) {
  deletePipelineAutomationRule(automationRuleId: $automationRuleId)
}
    `;
export type DeletePipelineAutomationRuleMutationFn = Apollo.MutationFunction<DeletePipelineAutomationRuleMutation, DeletePipelineAutomationRuleMutationVariables>;

/**
 * __useDeletePipelineAutomationRuleMutation__
 *
 * To run a mutation, you first call `useDeletePipelineAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePipelineAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePipelineAutomationRuleMutation, { data, loading, error }] = useDeletePipelineAutomationRuleMutation({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *   },
 * });
 */
export function useDeletePipelineAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeletePipelineAutomationRuleMutation, DeletePipelineAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePipelineAutomationRuleMutation, DeletePipelineAutomationRuleMutationVariables>(DeletePipelineAutomationRuleDocument, options);
      }
export type DeletePipelineAutomationRuleMutationHookResult = ReturnType<typeof useDeletePipelineAutomationRuleMutation>;
export type DeletePipelineAutomationRuleMutationResult = Apollo.MutationResult<DeletePipelineAutomationRuleMutation>;
export type DeletePipelineAutomationRuleMutationOptions = Apollo.BaseMutationOptions<DeletePipelineAutomationRuleMutation, DeletePipelineAutomationRuleMutationVariables>;
export const SetPipelineAutomationRuleEnabledDocument = gql`
    mutation SetPipelineAutomationRuleEnabled($input: SetPipelineAutomationRuleEnabledInput!) {
  setPipelineAutomationRuleEnabled(input: $input) {
    ...PipelineAutomationRuleFragment
  }
}
    ${PipelineAutomationRuleFragmentFragmentDoc}`;
export type SetPipelineAutomationRuleEnabledMutationFn = Apollo.MutationFunction<SetPipelineAutomationRuleEnabledMutation, SetPipelineAutomationRuleEnabledMutationVariables>;

/**
 * __useSetPipelineAutomationRuleEnabledMutation__
 *
 * To run a mutation, you first call `useSetPipelineAutomationRuleEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPipelineAutomationRuleEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPipelineAutomationRuleEnabledMutation, { data, loading, error }] = useSetPipelineAutomationRuleEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPipelineAutomationRuleEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetPipelineAutomationRuleEnabledMutation, SetPipelineAutomationRuleEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPipelineAutomationRuleEnabledMutation, SetPipelineAutomationRuleEnabledMutationVariables>(SetPipelineAutomationRuleEnabledDocument, options);
      }
export type SetPipelineAutomationRuleEnabledMutationHookResult = ReturnType<typeof useSetPipelineAutomationRuleEnabledMutation>;
export type SetPipelineAutomationRuleEnabledMutationResult = Apollo.MutationResult<SetPipelineAutomationRuleEnabledMutation>;
export type SetPipelineAutomationRuleEnabledMutationOptions = Apollo.BaseMutationOptions<SetPipelineAutomationRuleEnabledMutation, SetPipelineAutomationRuleEnabledMutationVariables>;
export const ListPipelineSuggestedPlayersDocument = gql`
    query ListPipelineSuggestedPlayers($kanbanBoardId: ID!, $first: Int, $after: String) {
  listPipelineSuggestedPlayers(
    kanbanBoardId: $kanbanBoardId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...PipelineSuggestedPlayerFragment
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PipelineSuggestedPlayerFragmentFragmentDoc}`;

/**
 * __useListPipelineSuggestedPlayersQuery__
 *
 * To run a query within a React component, call `useListPipelineSuggestedPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPipelineSuggestedPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPipelineSuggestedPlayersQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListPipelineSuggestedPlayersQuery(baseOptions: Apollo.QueryHookOptions<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables> & ({ variables: ListPipelineSuggestedPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>(ListPipelineSuggestedPlayersDocument, options);
      }
export function useListPipelineSuggestedPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>(ListPipelineSuggestedPlayersDocument, options);
        }
// @ts-ignore
export function useListPipelineSuggestedPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>;
export function useListPipelineSuggestedPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ListPipelineSuggestedPlayersQuery | undefined, ListPipelineSuggestedPlayersQueryVariables>;
export function useListPipelineSuggestedPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>(ListPipelineSuggestedPlayersDocument, options);
        }
export type ListPipelineSuggestedPlayersQueryHookResult = ReturnType<typeof useListPipelineSuggestedPlayersQuery>;
export type ListPipelineSuggestedPlayersLazyQueryHookResult = ReturnType<typeof useListPipelineSuggestedPlayersLazyQuery>;
export type ListPipelineSuggestedPlayersSuspenseQueryHookResult = ReturnType<typeof useListPipelineSuggestedPlayersSuspenseQuery>;
export type ListPipelineSuggestedPlayersQueryResult = Apollo.QueryResult<ListPipelineSuggestedPlayersQuery, ListPipelineSuggestedPlayersQueryVariables>;
export const AddSuggestedPlayerToPipelineDocument = gql`
    mutation AddSuggestedPlayerToPipeline($kanbanBoardId: ID!, $playerId: ID!) {
  addSuggestedPlayerToPipeline(kanbanBoardId: $kanbanBoardId, playerId: $playerId) {
    ...KanbanCardFragment
  }
}
    ${KanbanCardFragmentFragmentDoc}`;
export type AddSuggestedPlayerToPipelineMutationFn = Apollo.MutationFunction<AddSuggestedPlayerToPipelineMutation, AddSuggestedPlayerToPipelineMutationVariables>;

/**
 * __useAddSuggestedPlayerToPipelineMutation__
 *
 * To run a mutation, you first call `useAddSuggestedPlayerToPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSuggestedPlayerToPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSuggestedPlayerToPipelineMutation, { data, loading, error }] = useAddSuggestedPlayerToPipelineMutation({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useAddSuggestedPlayerToPipelineMutation(baseOptions?: Apollo.MutationHookOptions<AddSuggestedPlayerToPipelineMutation, AddSuggestedPlayerToPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSuggestedPlayerToPipelineMutation, AddSuggestedPlayerToPipelineMutationVariables>(AddSuggestedPlayerToPipelineDocument, options);
      }
export type AddSuggestedPlayerToPipelineMutationHookResult = ReturnType<typeof useAddSuggestedPlayerToPipelineMutation>;
export type AddSuggestedPlayerToPipelineMutationResult = Apollo.MutationResult<AddSuggestedPlayerToPipelineMutation>;
export type AddSuggestedPlayerToPipelineMutationOptions = Apollo.BaseMutationOptions<AddSuggestedPlayerToPipelineMutation, AddSuggestedPlayerToPipelineMutationVariables>;
export const ListKanbanBoardPlayerMetricsDocument = gql`
    query ListKanbanBoardPlayerMetrics($kanbanBoardId: ID!) {
  listKanbanBoardPlayerMetrics(kanbanBoardId: $kanbanBoardId) {
    playerId
    fitScore
    teamStyleFit
    carryingTransGlobalCategoricalScore
    dribblingTransGlobalCategoricalScore
    passingTransGlobalCategoricalScore
    shotLocationTransGlobalCategoricalScore
    gkPassingTransCategoricalScore
    gkShotStoppingTransCategoricalScore
    gkPositioningTransCategoricalScore
  }
}
    `;

/**
 * __useListKanbanBoardPlayerMetricsQuery__
 *
 * To run a query within a React component, call `useListKanbanBoardPlayerMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListKanbanBoardPlayerMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListKanbanBoardPlayerMetricsQuery({
 *   variables: {
 *      kanbanBoardId: // value for 'kanbanBoardId'
 *   },
 * });
 */
export function useListKanbanBoardPlayerMetricsQuery(baseOptions: Apollo.QueryHookOptions<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables> & ({ variables: ListKanbanBoardPlayerMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>(ListKanbanBoardPlayerMetricsDocument, options);
      }
export function useListKanbanBoardPlayerMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>(ListKanbanBoardPlayerMetricsDocument, options);
        }
// @ts-ignore
export function useListKanbanBoardPlayerMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>;
export function useListKanbanBoardPlayerMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<ListKanbanBoardPlayerMetricsQuery | undefined, ListKanbanBoardPlayerMetricsQueryVariables>;
export function useListKanbanBoardPlayerMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>(ListKanbanBoardPlayerMetricsDocument, options);
        }
export type ListKanbanBoardPlayerMetricsQueryHookResult = ReturnType<typeof useListKanbanBoardPlayerMetricsQuery>;
export type ListKanbanBoardPlayerMetricsLazyQueryHookResult = ReturnType<typeof useListKanbanBoardPlayerMetricsLazyQuery>;
export type ListKanbanBoardPlayerMetricsSuspenseQueryHookResult = ReturnType<typeof useListKanbanBoardPlayerMetricsSuspenseQuery>;
export type ListKanbanBoardPlayerMetricsQueryResult = Apollo.QueryResult<ListKanbanBoardPlayerMetricsQuery, ListKanbanBoardPlayerMetricsQueryVariables>;
export const PlayerMatchReportsDocument = gql`
    query PlayerMatchReports($filter: MatchReportFilterInput!, $first: Int, $after: String) {
  listMatchReports(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        status
        submittedAt
        watchMode
        scoutUser {
          id
          email
          displayName
        }
        match {
          id
          scheduledDate
          startTime
          venue
          competitionName
          homeTeam {
            id
            name
          }
          awayTeam {
            id
            name
          }
        }
        playerEvaluations {
          id
          isNoted
          performanceScore
          potentialScore
          note
          isStarter
          notedAt
          player {
            id
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __usePlayerMatchReportsQuery__
 *
 * To run a query within a React component, call `usePlayerMatchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerMatchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerMatchReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePlayerMatchReportsQuery(baseOptions: Apollo.QueryHookOptions<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables> & ({ variables: PlayerMatchReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>(PlayerMatchReportsDocument, options);
      }
export function usePlayerMatchReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>(PlayerMatchReportsDocument, options);
        }
// @ts-ignore
export function usePlayerMatchReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>;
export function usePlayerMatchReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerMatchReportsQuery | undefined, PlayerMatchReportsQueryVariables>;
export function usePlayerMatchReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>(PlayerMatchReportsDocument, options);
        }
export type PlayerMatchReportsQueryHookResult = ReturnType<typeof usePlayerMatchReportsQuery>;
export type PlayerMatchReportsLazyQueryHookResult = ReturnType<typeof usePlayerMatchReportsLazyQuery>;
export type PlayerMatchReportsSuspenseQueryHookResult = ReturnType<typeof usePlayerMatchReportsSuspenseQuery>;
export type PlayerMatchReportsQueryResult = Apollo.QueryResult<PlayerMatchReportsQuery, PlayerMatchReportsQueryVariables>;
export const PlayerSearchListCompetitionsDocument = gql`
    query PlayerSearchListCompetitions($first: Int, $after: String) {
  listCompetitions(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...PlayerSearchCompetition
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PlayerSearchCompetitionFragmentDoc}`;

/**
 * __usePlayerSearchListCompetitionsQuery__
 *
 * To run a query within a React component, call `usePlayerSearchListCompetitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchListCompetitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchListCompetitionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePlayerSearchListCompetitionsQuery(baseOptions?: Apollo.QueryHookOptions<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>(PlayerSearchListCompetitionsDocument, options);
      }
export function usePlayerSearchListCompetitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>(PlayerSearchListCompetitionsDocument, options);
        }
// @ts-ignore
export function usePlayerSearchListCompetitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>;
export function usePlayerSearchListCompetitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchListCompetitionsQuery | undefined, PlayerSearchListCompetitionsQueryVariables>;
export function usePlayerSearchListCompetitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>(PlayerSearchListCompetitionsDocument, options);
        }
export type PlayerSearchListCompetitionsQueryHookResult = ReturnType<typeof usePlayerSearchListCompetitionsQuery>;
export type PlayerSearchListCompetitionsLazyQueryHookResult = ReturnType<typeof usePlayerSearchListCompetitionsLazyQuery>;
export type PlayerSearchListCompetitionsSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchListCompetitionsSuspenseQuery>;
export type PlayerSearchListCompetitionsQueryResult = Apollo.QueryResult<PlayerSearchListCompetitionsQuery, PlayerSearchListCompetitionsQueryVariables>;
export const PlayerSearchFilterPlayersDocument = gql`
    query PlayerSearchFilterPlayers($filter: PlayerAdvancedFilterInput!, $first: Int, $after: String, $sortBy: SortField, $sortByCustomStatName: String, $sortOrder: OrderByDirection) {
  filterPlayers(
    filter: $filter
    first: $first
    after: $after
    sortBy: $sortBy
    sortByCustomStatName: $sortByCustomStatName
    sortOrder: $sortOrder
  ) {
    ...PlayerSearchPlayerConnection
  }
}
    ${PlayerSearchPlayerConnectionFragmentDoc}`;

/**
 * __usePlayerSearchFilterPlayersQuery__
 *
 * To run a query within a React component, call `usePlayerSearchFilterPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchFilterPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchFilterPlayersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function usePlayerSearchFilterPlayersQuery(baseOptions: Apollo.QueryHookOptions<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables> & ({ variables: PlayerSearchFilterPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>(PlayerSearchFilterPlayersDocument, options);
      }
export function usePlayerSearchFilterPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>(PlayerSearchFilterPlayersDocument, options);
        }
// @ts-ignore
export function usePlayerSearchFilterPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>;
export function usePlayerSearchFilterPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchFilterPlayersQuery | undefined, PlayerSearchFilterPlayersQueryVariables>;
export function usePlayerSearchFilterPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>(PlayerSearchFilterPlayersDocument, options);
        }
export type PlayerSearchFilterPlayersQueryHookResult = ReturnType<typeof usePlayerSearchFilterPlayersQuery>;
export type PlayerSearchFilterPlayersLazyQueryHookResult = ReturnType<typeof usePlayerSearchFilterPlayersLazyQuery>;
export type PlayerSearchFilterPlayersSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchFilterPlayersSuspenseQuery>;
export type PlayerSearchFilterPlayersQueryResult = Apollo.QueryResult<PlayerSearchFilterPlayersQuery, PlayerSearchFilterPlayersQueryVariables>;
export const PlayerSearchSearchPlayersDocument = gql`
    query PlayerSearchSearchPlayers($query: String!, $first: Int, $after: String, $sortBy: SortField, $sortByCustomStatName: String, $sortOrder: OrderByDirection) {
  searchPlayers(
    query: $query
    first: $first
    after: $after
    sortBy: $sortBy
    sortByCustomStatName: $sortByCustomStatName
    sortOrder: $sortOrder
  ) {
    ...PlayerSearchPlayerConnection
  }
}
    ${PlayerSearchPlayerConnectionFragmentDoc}`;

/**
 * __usePlayerSearchSearchPlayersQuery__
 *
 * To run a query within a React component, call `usePlayerSearchSearchPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchSearchPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchSearchPlayersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function usePlayerSearchSearchPlayersQuery(baseOptions: Apollo.QueryHookOptions<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables> & ({ variables: PlayerSearchSearchPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>(PlayerSearchSearchPlayersDocument, options);
      }
export function usePlayerSearchSearchPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>(PlayerSearchSearchPlayersDocument, options);
        }
// @ts-ignore
export function usePlayerSearchSearchPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>;
export function usePlayerSearchSearchPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchSearchPlayersQuery | undefined, PlayerSearchSearchPlayersQueryVariables>;
export function usePlayerSearchSearchPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>(PlayerSearchSearchPlayersDocument, options);
        }
export type PlayerSearchSearchPlayersQueryHookResult = ReturnType<typeof usePlayerSearchSearchPlayersQuery>;
export type PlayerSearchSearchPlayersLazyQueryHookResult = ReturnType<typeof usePlayerSearchSearchPlayersLazyQuery>;
export type PlayerSearchSearchPlayersSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchSearchPlayersSuspenseQuery>;
export type PlayerSearchSearchPlayersQueryResult = Apollo.QueryResult<PlayerSearchSearchPlayersQuery, PlayerSearchSearchPlayersQueryVariables>;
export const PlayerSearchSearchPlayersLiteDocument = gql`
    query PlayerSearchSearchPlayersLite($query: String!, $first: Int, $after: String, $sortBy: SortField, $sortByCustomStatName: String, $sortOrder: OrderByDirection) {
  searchPlayers(
    query: $query
    first: $first
    after: $after
    sortBy: $sortBy
    sortByCustomStatName: $sortByCustomStatName
    sortOrder: $sortOrder
  ) {
    ...PlayerSearchPlayerConnectionLite
  }
}
    ${PlayerSearchPlayerConnectionLiteFragmentDoc}`;

/**
 * __usePlayerSearchSearchPlayersLiteQuery__
 *
 * To run a query within a React component, call `usePlayerSearchSearchPlayersLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchSearchPlayersLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchSearchPlayersLiteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function usePlayerSearchSearchPlayersLiteQuery(baseOptions: Apollo.QueryHookOptions<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables> & ({ variables: PlayerSearchSearchPlayersLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>(PlayerSearchSearchPlayersLiteDocument, options);
      }
export function usePlayerSearchSearchPlayersLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>(PlayerSearchSearchPlayersLiteDocument, options);
        }
// @ts-ignore
export function usePlayerSearchSearchPlayersLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>;
export function usePlayerSearchSearchPlayersLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchSearchPlayersLiteQuery | undefined, PlayerSearchSearchPlayersLiteQueryVariables>;
export function usePlayerSearchSearchPlayersLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>(PlayerSearchSearchPlayersLiteDocument, options);
        }
export type PlayerSearchSearchPlayersLiteQueryHookResult = ReturnType<typeof usePlayerSearchSearchPlayersLiteQuery>;
export type PlayerSearchSearchPlayersLiteLazyQueryHookResult = ReturnType<typeof usePlayerSearchSearchPlayersLiteLazyQuery>;
export type PlayerSearchSearchPlayersLiteSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchSearchPlayersLiteSuspenseQuery>;
export type PlayerSearchSearchPlayersLiteQueryResult = Apollo.QueryResult<PlayerSearchSearchPlayersLiteQuery, PlayerSearchSearchPlayersLiteQueryVariables>;
export const PlayerSearchGetPlayerByTransfermarktIdDocument = gql`
    query PlayerSearchGetPlayerByTransfermarktId($transfermarktId: Int!) {
  getPlayerByTransfermarktId(transfermarktId: $transfermarktId) {
    ...PlayerSearchPlayer
  }
}
    ${PlayerSearchPlayerFragmentDoc}`;

/**
 * __usePlayerSearchGetPlayerByTransfermarktIdQuery__
 *
 * To run a query within a React component, call `usePlayerSearchGetPlayerByTransfermarktIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchGetPlayerByTransfermarktIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchGetPlayerByTransfermarktIdQuery({
 *   variables: {
 *      transfermarktId: // value for 'transfermarktId'
 *   },
 * });
 */
export function usePlayerSearchGetPlayerByTransfermarktIdQuery(baseOptions: Apollo.QueryHookOptions<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables> & ({ variables: PlayerSearchGetPlayerByTransfermarktIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>(PlayerSearchGetPlayerByTransfermarktIdDocument, options);
      }
export function usePlayerSearchGetPlayerByTransfermarktIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>(PlayerSearchGetPlayerByTransfermarktIdDocument, options);
        }
// @ts-ignore
export function usePlayerSearchGetPlayerByTransfermarktIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>;
export function usePlayerSearchGetPlayerByTransfermarktIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchGetPlayerByTransfermarktIdQuery | undefined, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>;
export function usePlayerSearchGetPlayerByTransfermarktIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>(PlayerSearchGetPlayerByTransfermarktIdDocument, options);
        }
export type PlayerSearchGetPlayerByTransfermarktIdQueryHookResult = ReturnType<typeof usePlayerSearchGetPlayerByTransfermarktIdQuery>;
export type PlayerSearchGetPlayerByTransfermarktIdLazyQueryHookResult = ReturnType<typeof usePlayerSearchGetPlayerByTransfermarktIdLazyQuery>;
export type PlayerSearchGetPlayerByTransfermarktIdSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchGetPlayerByTransfermarktIdSuspenseQuery>;
export type PlayerSearchGetPlayerByTransfermarktIdQueryResult = Apollo.QueryResult<PlayerSearchGetPlayerByTransfermarktIdQuery, PlayerSearchGetPlayerByTransfermarktIdQueryVariables>;
export const PlayerSearchListRoleArchetypesDocument = gql`
    query PlayerSearchListRoleArchetypes {
  listRoleArchetypes
}
    `;

/**
 * __usePlayerSearchListRoleArchetypesQuery__
 *
 * To run a query within a React component, call `usePlayerSearchListRoleArchetypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchListRoleArchetypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchListRoleArchetypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayerSearchListRoleArchetypesQuery(baseOptions?: Apollo.QueryHookOptions<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>(PlayerSearchListRoleArchetypesDocument, options);
      }
export function usePlayerSearchListRoleArchetypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>(PlayerSearchListRoleArchetypesDocument, options);
        }
// @ts-ignore
export function usePlayerSearchListRoleArchetypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>;
export function usePlayerSearchListRoleArchetypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchListRoleArchetypesQuery | undefined, PlayerSearchListRoleArchetypesQueryVariables>;
export function usePlayerSearchListRoleArchetypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>(PlayerSearchListRoleArchetypesDocument, options);
        }
export type PlayerSearchListRoleArchetypesQueryHookResult = ReturnType<typeof usePlayerSearchListRoleArchetypesQuery>;
export type PlayerSearchListRoleArchetypesLazyQueryHookResult = ReturnType<typeof usePlayerSearchListRoleArchetypesLazyQuery>;
export type PlayerSearchListRoleArchetypesSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchListRoleArchetypesSuspenseQuery>;
export type PlayerSearchListRoleArchetypesQueryResult = Apollo.QueryResult<PlayerSearchListRoleArchetypesQuery, PlayerSearchListRoleArchetypesQueryVariables>;
export const PlayerSearchListAvailableCustomStatsDocument = gql`
    query PlayerSearchListAvailableCustomStats {
  listAvailableCustomStats {
    name
    description
  }
}
    `;

/**
 * __usePlayerSearchListAvailableCustomStatsQuery__
 *
 * To run a query within a React component, call `usePlayerSearchListAvailableCustomStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchListAvailableCustomStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerSearchListAvailableCustomStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayerSearchListAvailableCustomStatsQuery(baseOptions?: Apollo.QueryHookOptions<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>(PlayerSearchListAvailableCustomStatsDocument, options);
      }
export function usePlayerSearchListAvailableCustomStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>(PlayerSearchListAvailableCustomStatsDocument, options);
        }
// @ts-ignore
export function usePlayerSearchListAvailableCustomStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>;
export function usePlayerSearchListAvailableCustomStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>): Apollo.UseSuspenseQueryResult<PlayerSearchListAvailableCustomStatsQuery | undefined, PlayerSearchListAvailableCustomStatsQueryVariables>;
export function usePlayerSearchListAvailableCustomStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>(PlayerSearchListAvailableCustomStatsDocument, options);
        }
export type PlayerSearchListAvailableCustomStatsQueryHookResult = ReturnType<typeof usePlayerSearchListAvailableCustomStatsQuery>;
export type PlayerSearchListAvailableCustomStatsLazyQueryHookResult = ReturnType<typeof usePlayerSearchListAvailableCustomStatsLazyQuery>;
export type PlayerSearchListAvailableCustomStatsSuspenseQueryHookResult = ReturnType<typeof usePlayerSearchListAvailableCustomStatsSuspenseQuery>;
export type PlayerSearchListAvailableCustomStatsQueryResult = Apollo.QueryResult<PlayerSearchListAvailableCustomStatsQuery, PlayerSearchListAvailableCustomStatsQueryVariables>;
export const PlayerSearchAddPlayerToWatchlistDocument = gql`
    mutation PlayerSearchAddPlayerToWatchlist($input: AddPlayerToWatchlistInput!) {
  addPlayerToWatchlist(input: $input) {
    ...PlayerSearchWatchlistMeta
  }
}
    ${PlayerSearchWatchlistMetaFragmentDoc}`;
export type PlayerSearchAddPlayerToWatchlistMutationFn = Apollo.MutationFunction<PlayerSearchAddPlayerToWatchlistMutation, PlayerSearchAddPlayerToWatchlistMutationVariables>;

/**
 * __usePlayerSearchAddPlayerToWatchlistMutation__
 *
 * To run a mutation, you first call `usePlayerSearchAddPlayerToWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchAddPlayerToWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerSearchAddPlayerToWatchlistMutation, { data, loading, error }] = usePlayerSearchAddPlayerToWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerSearchAddPlayerToWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<PlayerSearchAddPlayerToWatchlistMutation, PlayerSearchAddPlayerToWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerSearchAddPlayerToWatchlistMutation, PlayerSearchAddPlayerToWatchlistMutationVariables>(PlayerSearchAddPlayerToWatchlistDocument, options);
      }
export type PlayerSearchAddPlayerToWatchlistMutationHookResult = ReturnType<typeof usePlayerSearchAddPlayerToWatchlistMutation>;
export type PlayerSearchAddPlayerToWatchlistMutationResult = Apollo.MutationResult<PlayerSearchAddPlayerToWatchlistMutation>;
export type PlayerSearchAddPlayerToWatchlistMutationOptions = Apollo.BaseMutationOptions<PlayerSearchAddPlayerToWatchlistMutation, PlayerSearchAddPlayerToWatchlistMutationVariables>;
export const PlayerSearchRemovePlayerFromWatchlistDocument = gql`
    mutation PlayerSearchRemovePlayerFromWatchlist($input: RemovePlayerFromWatchlistInput!) {
  removePlayerFromWatchlist(input: $input) {
    ...PlayerSearchWatchlistMeta
  }
}
    ${PlayerSearchWatchlistMetaFragmentDoc}`;
export type PlayerSearchRemovePlayerFromWatchlistMutationFn = Apollo.MutationFunction<PlayerSearchRemovePlayerFromWatchlistMutation, PlayerSearchRemovePlayerFromWatchlistMutationVariables>;

/**
 * __usePlayerSearchRemovePlayerFromWatchlistMutation__
 *
 * To run a mutation, you first call `usePlayerSearchRemovePlayerFromWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchRemovePlayerFromWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerSearchRemovePlayerFromWatchlistMutation, { data, loading, error }] = usePlayerSearchRemovePlayerFromWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerSearchRemovePlayerFromWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<PlayerSearchRemovePlayerFromWatchlistMutation, PlayerSearchRemovePlayerFromWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerSearchRemovePlayerFromWatchlistMutation, PlayerSearchRemovePlayerFromWatchlistMutationVariables>(PlayerSearchRemovePlayerFromWatchlistDocument, options);
      }
export type PlayerSearchRemovePlayerFromWatchlistMutationHookResult = ReturnType<typeof usePlayerSearchRemovePlayerFromWatchlistMutation>;
export type PlayerSearchRemovePlayerFromWatchlistMutationResult = Apollo.MutationResult<PlayerSearchRemovePlayerFromWatchlistMutation>;
export type PlayerSearchRemovePlayerFromWatchlistMutationOptions = Apollo.BaseMutationOptions<PlayerSearchRemovePlayerFromWatchlistMutation, PlayerSearchRemovePlayerFromWatchlistMutationVariables>;
export const PlayerSearchCreateWatchlistDocument = gql`
    mutation PlayerSearchCreateWatchlist($input: CreateWatchlistInput!) {
  createWatchlist(input: $input) {
    ...PlayerSearchWatchlistMeta
  }
}
    ${PlayerSearchWatchlistMetaFragmentDoc}`;
export type PlayerSearchCreateWatchlistMutationFn = Apollo.MutationFunction<PlayerSearchCreateWatchlistMutation, PlayerSearchCreateWatchlistMutationVariables>;

/**
 * __usePlayerSearchCreateWatchlistMutation__
 *
 * To run a mutation, you first call `usePlayerSearchCreateWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchCreateWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerSearchCreateWatchlistMutation, { data, loading, error }] = usePlayerSearchCreateWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerSearchCreateWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<PlayerSearchCreateWatchlistMutation, PlayerSearchCreateWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerSearchCreateWatchlistMutation, PlayerSearchCreateWatchlistMutationVariables>(PlayerSearchCreateWatchlistDocument, options);
      }
export type PlayerSearchCreateWatchlistMutationHookResult = ReturnType<typeof usePlayerSearchCreateWatchlistMutation>;
export type PlayerSearchCreateWatchlistMutationResult = Apollo.MutationResult<PlayerSearchCreateWatchlistMutation>;
export type PlayerSearchCreateWatchlistMutationOptions = Apollo.BaseMutationOptions<PlayerSearchCreateWatchlistMutation, PlayerSearchCreateWatchlistMutationVariables>;
export const PlayerSearchCreateManualPlayerDocument = gql`
    mutation PlayerSearchCreateManualPlayer($input: CreateManualPlayerInput!) {
  createManualPlayer(input: $input) {
    ...PlayerSearchPlayer
  }
}
    ${PlayerSearchPlayerFragmentDoc}`;
export type PlayerSearchCreateManualPlayerMutationFn = Apollo.MutationFunction<PlayerSearchCreateManualPlayerMutation, PlayerSearchCreateManualPlayerMutationVariables>;

/**
 * __usePlayerSearchCreateManualPlayerMutation__
 *
 * To run a mutation, you first call `usePlayerSearchCreateManualPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerSearchCreateManualPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerSearchCreateManualPlayerMutation, { data, loading, error }] = usePlayerSearchCreateManualPlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayerSearchCreateManualPlayerMutation(baseOptions?: Apollo.MutationHookOptions<PlayerSearchCreateManualPlayerMutation, PlayerSearchCreateManualPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerSearchCreateManualPlayerMutation, PlayerSearchCreateManualPlayerMutationVariables>(PlayerSearchCreateManualPlayerDocument, options);
      }
export type PlayerSearchCreateManualPlayerMutationHookResult = ReturnType<typeof usePlayerSearchCreateManualPlayerMutation>;
export type PlayerSearchCreateManualPlayerMutationResult = Apollo.MutationResult<PlayerSearchCreateManualPlayerMutation>;
export type PlayerSearchCreateManualPlayerMutationOptions = Apollo.BaseMutationOptions<PlayerSearchCreateManualPlayerMutation, PlayerSearchCreateManualPlayerMutationVariables>;
export const PushNotificationsCreateDeviceDocument = gql`
    mutation PushNotificationsCreateDevice($input: CreateDeviceInput!) {
  createDevice(input: $input) {
    id
  }
}
    `;
export type PushNotificationsCreateDeviceMutationFn = Apollo.MutationFunction<PushNotificationsCreateDeviceMutation, PushNotificationsCreateDeviceMutationVariables>;

/**
 * __usePushNotificationsCreateDeviceMutation__
 *
 * To run a mutation, you first call `usePushNotificationsCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushNotificationsCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushNotificationsCreateDeviceMutation, { data, loading, error }] = usePushNotificationsCreateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushNotificationsCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<PushNotificationsCreateDeviceMutation, PushNotificationsCreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushNotificationsCreateDeviceMutation, PushNotificationsCreateDeviceMutationVariables>(PushNotificationsCreateDeviceDocument, options);
      }
export type PushNotificationsCreateDeviceMutationHookResult = ReturnType<typeof usePushNotificationsCreateDeviceMutation>;
export type PushNotificationsCreateDeviceMutationResult = Apollo.MutationResult<PushNotificationsCreateDeviceMutation>;
export type PushNotificationsCreateDeviceMutationOptions = Apollo.BaseMutationOptions<PushNotificationsCreateDeviceMutation, PushNotificationsCreateDeviceMutationVariables>;
export const RecommendationsListPlayerRecommendationsDocument = gql`
    query RecommendationsListPlayerRecommendations($recommendationType: String!) {
  listPlayerRecommendations(recommendationType: $recommendationType) {
    ...RecommendationsPlayerRecommendationResult
  }
}
    ${RecommendationsPlayerRecommendationResultFragmentDoc}`;

/**
 * __useRecommendationsListPlayerRecommendationsQuery__
 *
 * To run a query within a React component, call `useRecommendationsListPlayerRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsListPlayerRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsListPlayerRecommendationsQuery({
 *   variables: {
 *      recommendationType: // value for 'recommendationType'
 *   },
 * });
 */
export function useRecommendationsListPlayerRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables> & ({ variables: RecommendationsListPlayerRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>(RecommendationsListPlayerRecommendationsDocument, options);
      }
export function useRecommendationsListPlayerRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>(RecommendationsListPlayerRecommendationsDocument, options);
        }
// @ts-ignore
export function useRecommendationsListPlayerRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>;
export function useRecommendationsListPlayerRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<RecommendationsListPlayerRecommendationsQuery | undefined, RecommendationsListPlayerRecommendationsQueryVariables>;
export function useRecommendationsListPlayerRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>(RecommendationsListPlayerRecommendationsDocument, options);
        }
export type RecommendationsListPlayerRecommendationsQueryHookResult = ReturnType<typeof useRecommendationsListPlayerRecommendationsQuery>;
export type RecommendationsListPlayerRecommendationsLazyQueryHookResult = ReturnType<typeof useRecommendationsListPlayerRecommendationsLazyQuery>;
export type RecommendationsListPlayerRecommendationsSuspenseQueryHookResult = ReturnType<typeof useRecommendationsListPlayerRecommendationsSuspenseQuery>;
export type RecommendationsListPlayerRecommendationsQueryResult = Apollo.QueryResult<RecommendationsListPlayerRecommendationsQuery, RecommendationsListPlayerRecommendationsQueryVariables>;
export const RecommendationsRemovePlayerFromRecommendationsDocument = gql`
    mutation RecommendationsRemovePlayerFromRecommendations($playerId: ID!) {
  removePlayerFromRecommendations(playerId: $playerId) {
    ...RecommendationsPlayer
  }
}
    ${RecommendationsPlayerFragmentDoc}`;
export type RecommendationsRemovePlayerFromRecommendationsMutationFn = Apollo.MutationFunction<RecommendationsRemovePlayerFromRecommendationsMutation, RecommendationsRemovePlayerFromRecommendationsMutationVariables>;

/**
 * __useRecommendationsRemovePlayerFromRecommendationsMutation__
 *
 * To run a mutation, you first call `useRecommendationsRemovePlayerFromRecommendationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsRemovePlayerFromRecommendationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendationsRemovePlayerFromRecommendationsMutation, { data, loading, error }] = useRecommendationsRemovePlayerFromRecommendationsMutation({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useRecommendationsRemovePlayerFromRecommendationsMutation(baseOptions?: Apollo.MutationHookOptions<RecommendationsRemovePlayerFromRecommendationsMutation, RecommendationsRemovePlayerFromRecommendationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendationsRemovePlayerFromRecommendationsMutation, RecommendationsRemovePlayerFromRecommendationsMutationVariables>(RecommendationsRemovePlayerFromRecommendationsDocument, options);
      }
export type RecommendationsRemovePlayerFromRecommendationsMutationHookResult = ReturnType<typeof useRecommendationsRemovePlayerFromRecommendationsMutation>;
export type RecommendationsRemovePlayerFromRecommendationsMutationResult = Apollo.MutationResult<RecommendationsRemovePlayerFromRecommendationsMutation>;
export type RecommendationsRemovePlayerFromRecommendationsMutationOptions = Apollo.BaseMutationOptions<RecommendationsRemovePlayerFromRecommendationsMutation, RecommendationsRemovePlayerFromRecommendationsMutationVariables>;
export const ReportsGetScoutReportEditUrlDocument = gql`
    query ReportsGetScoutReportEditUrl($scoutReportId: ID!) {
  getScoutReportEditUrl(scoutReportId: $scoutReportId)
}
    `;

/**
 * __useReportsGetScoutReportEditUrlQuery__
 *
 * To run a query within a React component, call `useReportsGetScoutReportEditUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsGetScoutReportEditUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsGetScoutReportEditUrlQuery({
 *   variables: {
 *      scoutReportId: // value for 'scoutReportId'
 *   },
 * });
 */
export function useReportsGetScoutReportEditUrlQuery(baseOptions: Apollo.QueryHookOptions<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables> & ({ variables: ReportsGetScoutReportEditUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>(ReportsGetScoutReportEditUrlDocument, options);
      }
export function useReportsGetScoutReportEditUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>(ReportsGetScoutReportEditUrlDocument, options);
        }
// @ts-ignore
export function useReportsGetScoutReportEditUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>;
export function useReportsGetScoutReportEditUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsGetScoutReportEditUrlQuery | undefined, ReportsGetScoutReportEditUrlQueryVariables>;
export function useReportsGetScoutReportEditUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>(ReportsGetScoutReportEditUrlDocument, options);
        }
export type ReportsGetScoutReportEditUrlQueryHookResult = ReturnType<typeof useReportsGetScoutReportEditUrlQuery>;
export type ReportsGetScoutReportEditUrlLazyQueryHookResult = ReturnType<typeof useReportsGetScoutReportEditUrlLazyQuery>;
export type ReportsGetScoutReportEditUrlSuspenseQueryHookResult = ReturnType<typeof useReportsGetScoutReportEditUrlSuspenseQuery>;
export type ReportsGetScoutReportEditUrlQueryResult = Apollo.QueryResult<ReportsGetScoutReportEditUrlQuery, ReportsGetScoutReportEditUrlQueryVariables>;
export const ReportsShareScoutReportDocument = gql`
    mutation ReportsShareScoutReport($input: ShareScoutReportInput!) {
  shareScoutReport(input: $input)
}
    `;
export type ReportsShareScoutReportMutationFn = Apollo.MutationFunction<ReportsShareScoutReportMutation, ReportsShareScoutReportMutationVariables>;

/**
 * __useReportsShareScoutReportMutation__
 *
 * To run a mutation, you first call `useReportsShareScoutReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsShareScoutReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsShareScoutReportMutation, { data, loading, error }] = useReportsShareScoutReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportsShareScoutReportMutation(baseOptions?: Apollo.MutationHookOptions<ReportsShareScoutReportMutation, ReportsShareScoutReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportsShareScoutReportMutation, ReportsShareScoutReportMutationVariables>(ReportsShareScoutReportDocument, options);
      }
export type ReportsShareScoutReportMutationHookResult = ReturnType<typeof useReportsShareScoutReportMutation>;
export type ReportsShareScoutReportMutationResult = Apollo.MutationResult<ReportsShareScoutReportMutation>;
export type ReportsShareScoutReportMutationOptions = Apollo.BaseMutationOptions<ReportsShareScoutReportMutation, ReportsShareScoutReportMutationVariables>;
export const ReportsListScoutReportSharesDocument = gql`
    query ReportsListScoutReportShares($scoutReportId: ID!) {
  listScoutReportShares(scoutReportId: $scoutReportId) {
    ...ReportsScoutReportShare
  }
}
    ${ReportsScoutReportShareFragmentDoc}`;

/**
 * __useReportsListScoutReportSharesQuery__
 *
 * To run a query within a React component, call `useReportsListScoutReportSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsListScoutReportSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsListScoutReportSharesQuery({
 *   variables: {
 *      scoutReportId: // value for 'scoutReportId'
 *   },
 * });
 */
export function useReportsListScoutReportSharesQuery(baseOptions: Apollo.QueryHookOptions<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables> & ({ variables: ReportsListScoutReportSharesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>(ReportsListScoutReportSharesDocument, options);
      }
export function useReportsListScoutReportSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>(ReportsListScoutReportSharesDocument, options);
        }
// @ts-ignore
export function useReportsListScoutReportSharesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>;
export function useReportsListScoutReportSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsListScoutReportSharesQuery | undefined, ReportsListScoutReportSharesQueryVariables>;
export function useReportsListScoutReportSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>(ReportsListScoutReportSharesDocument, options);
        }
export type ReportsListScoutReportSharesQueryHookResult = ReturnType<typeof useReportsListScoutReportSharesQuery>;
export type ReportsListScoutReportSharesLazyQueryHookResult = ReturnType<typeof useReportsListScoutReportSharesLazyQuery>;
export type ReportsListScoutReportSharesSuspenseQueryHookResult = ReturnType<typeof useReportsListScoutReportSharesSuspenseQuery>;
export type ReportsListScoutReportSharesQueryResult = Apollo.QueryResult<ReportsListScoutReportSharesQuery, ReportsListScoutReportSharesQueryVariables>;
export const ReportsRevokeScoutReportShareDocument = gql`
    mutation ReportsRevokeScoutReportShare($input: RevokeScoutReportShareInput!) {
  revokeScoutReportShare(input: $input)
}
    `;
export type ReportsRevokeScoutReportShareMutationFn = Apollo.MutationFunction<ReportsRevokeScoutReportShareMutation, ReportsRevokeScoutReportShareMutationVariables>;

/**
 * __useReportsRevokeScoutReportShareMutation__
 *
 * To run a mutation, you first call `useReportsRevokeScoutReportShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsRevokeScoutReportShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsRevokeScoutReportShareMutation, { data, loading, error }] = useReportsRevokeScoutReportShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportsRevokeScoutReportShareMutation(baseOptions?: Apollo.MutationHookOptions<ReportsRevokeScoutReportShareMutation, ReportsRevokeScoutReportShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportsRevokeScoutReportShareMutation, ReportsRevokeScoutReportShareMutationVariables>(ReportsRevokeScoutReportShareDocument, options);
      }
export type ReportsRevokeScoutReportShareMutationHookResult = ReturnType<typeof useReportsRevokeScoutReportShareMutation>;
export type ReportsRevokeScoutReportShareMutationResult = Apollo.MutationResult<ReportsRevokeScoutReportShareMutation>;
export type ReportsRevokeScoutReportShareMutationOptions = Apollo.BaseMutationOptions<ReportsRevokeScoutReportShareMutation, ReportsRevokeScoutReportShareMutationVariables>;
export const ReportsSetScoutReportVisibilityDocument = gql`
    mutation ReportsSetScoutReportVisibility($scoutReportId: ID!, $isPublic: Boolean!) {
  setScoutReportVisibility(scoutReportId: $scoutReportId, isPublic: $isPublic) {
    id
    isPublic
  }
}
    `;
export type ReportsSetScoutReportVisibilityMutationFn = Apollo.MutationFunction<ReportsSetScoutReportVisibilityMutation, ReportsSetScoutReportVisibilityMutationVariables>;

/**
 * __useReportsSetScoutReportVisibilityMutation__
 *
 * To run a mutation, you first call `useReportsSetScoutReportVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsSetScoutReportVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsSetScoutReportVisibilityMutation, { data, loading, error }] = useReportsSetScoutReportVisibilityMutation({
 *   variables: {
 *      scoutReportId: // value for 'scoutReportId'
 *      isPublic: // value for 'isPublic'
 *   },
 * });
 */
export function useReportsSetScoutReportVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ReportsSetScoutReportVisibilityMutation, ReportsSetScoutReportVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportsSetScoutReportVisibilityMutation, ReportsSetScoutReportVisibilityMutationVariables>(ReportsSetScoutReportVisibilityDocument, options);
      }
export type ReportsSetScoutReportVisibilityMutationHookResult = ReturnType<typeof useReportsSetScoutReportVisibilityMutation>;
export type ReportsSetScoutReportVisibilityMutationResult = Apollo.MutationResult<ReportsSetScoutReportVisibilityMutation>;
export type ReportsSetScoutReportVisibilityMutationOptions = Apollo.BaseMutationOptions<ReportsSetScoutReportVisibilityMutation, ReportsSetScoutReportVisibilityMutationVariables>;
export const ReportsArchiveScoutReportDocument = gql`
    mutation ReportsArchiveScoutReport($scoutReportId: ID!, $confirmation: String!) {
  archiveScoutReport(scoutReportId: $scoutReportId, confirmation: $confirmation) {
    id
    archivedAt
  }
}
    `;
export type ReportsArchiveScoutReportMutationFn = Apollo.MutationFunction<ReportsArchiveScoutReportMutation, ReportsArchiveScoutReportMutationVariables>;

/**
 * __useReportsArchiveScoutReportMutation__
 *
 * To run a mutation, you first call `useReportsArchiveScoutReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsArchiveScoutReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsArchiveScoutReportMutation, { data, loading, error }] = useReportsArchiveScoutReportMutation({
 *   variables: {
 *      scoutReportId: // value for 'scoutReportId'
 *      confirmation: // value for 'confirmation'
 *   },
 * });
 */
export function useReportsArchiveScoutReportMutation(baseOptions?: Apollo.MutationHookOptions<ReportsArchiveScoutReportMutation, ReportsArchiveScoutReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportsArchiveScoutReportMutation, ReportsArchiveScoutReportMutationVariables>(ReportsArchiveScoutReportDocument, options);
      }
export type ReportsArchiveScoutReportMutationHookResult = ReturnType<typeof useReportsArchiveScoutReportMutation>;
export type ReportsArchiveScoutReportMutationResult = Apollo.MutationResult<ReportsArchiveScoutReportMutation>;
export type ReportsArchiveScoutReportMutationOptions = Apollo.BaseMutationOptions<ReportsArchiveScoutReportMutation, ReportsArchiveScoutReportMutationVariables>;
export const ReportsUnarchiveScoutReportDocument = gql`
    mutation ReportsUnarchiveScoutReport($scoutReportId: ID!) {
  unarchiveScoutReport(scoutReportId: $scoutReportId) {
    id
    archivedAt
  }
}
    `;
export type ReportsUnarchiveScoutReportMutationFn = Apollo.MutationFunction<ReportsUnarchiveScoutReportMutation, ReportsUnarchiveScoutReportMutationVariables>;

/**
 * __useReportsUnarchiveScoutReportMutation__
 *
 * To run a mutation, you first call `useReportsUnarchiveScoutReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsUnarchiveScoutReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsUnarchiveScoutReportMutation, { data, loading, error }] = useReportsUnarchiveScoutReportMutation({
 *   variables: {
 *      scoutReportId: // value for 'scoutReportId'
 *   },
 * });
 */
export function useReportsUnarchiveScoutReportMutation(baseOptions?: Apollo.MutationHookOptions<ReportsUnarchiveScoutReportMutation, ReportsUnarchiveScoutReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportsUnarchiveScoutReportMutation, ReportsUnarchiveScoutReportMutationVariables>(ReportsUnarchiveScoutReportDocument, options);
      }
export type ReportsUnarchiveScoutReportMutationHookResult = ReturnType<typeof useReportsUnarchiveScoutReportMutation>;
export type ReportsUnarchiveScoutReportMutationResult = Apollo.MutationResult<ReportsUnarchiveScoutReportMutation>;
export type ReportsUnarchiveScoutReportMutationOptions = Apollo.BaseMutationOptions<ReportsUnarchiveScoutReportMutation, ReportsUnarchiveScoutReportMutationVariables>;
export const ReportsTranslateScoutReportDocument = gql`
    mutation ReportsTranslateScoutReport($input: TranslateScoutReportInput!) {
  translateScoutReport(input: $input) {
    reportId
    qnaText
    translatedQnaText
    availableTranslations
  }
}
    `;
export type ReportsTranslateScoutReportMutationFn = Apollo.MutationFunction<ReportsTranslateScoutReportMutation, ReportsTranslateScoutReportMutationVariables>;

/**
 * __useReportsTranslateScoutReportMutation__
 *
 * To run a mutation, you first call `useReportsTranslateScoutReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsTranslateScoutReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsTranslateScoutReportMutation, { data, loading, error }] = useReportsTranslateScoutReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportsTranslateScoutReportMutation(baseOptions?: Apollo.MutationHookOptions<ReportsTranslateScoutReportMutation, ReportsTranslateScoutReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportsTranslateScoutReportMutation, ReportsTranslateScoutReportMutationVariables>(ReportsTranslateScoutReportDocument, options);
      }
export type ReportsTranslateScoutReportMutationHookResult = ReturnType<typeof useReportsTranslateScoutReportMutation>;
export type ReportsTranslateScoutReportMutationResult = Apollo.MutationResult<ReportsTranslateScoutReportMutation>;
export type ReportsTranslateScoutReportMutationOptions = Apollo.BaseMutationOptions<ReportsTranslateScoutReportMutation, ReportsTranslateScoutReportMutationVariables>;
export const ReportsListPlayerMatchesDocument = gql`
    query ReportsListPlayerMatches($playerId: ID!, $first: Int, $after: String) {
  listPlayerMatches(playerId: $playerId, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...ReportsPlayerMatch
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ReportsPlayerMatchFragmentDoc}`;

/**
 * __useReportsListPlayerMatchesQuery__
 *
 * To run a query within a React component, call `useReportsListPlayerMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsListPlayerMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsListPlayerMatchesQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportsListPlayerMatchesQuery(baseOptions: Apollo.QueryHookOptions<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables> & ({ variables: ReportsListPlayerMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>(ReportsListPlayerMatchesDocument, options);
      }
export function useReportsListPlayerMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>(ReportsListPlayerMatchesDocument, options);
        }
// @ts-ignore
export function useReportsListPlayerMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>;
export function useReportsListPlayerMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<ReportsListPlayerMatchesQuery | undefined, ReportsListPlayerMatchesQueryVariables>;
export function useReportsListPlayerMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>(ReportsListPlayerMatchesDocument, options);
        }
export type ReportsListPlayerMatchesQueryHookResult = ReturnType<typeof useReportsListPlayerMatchesQuery>;
export type ReportsListPlayerMatchesLazyQueryHookResult = ReturnType<typeof useReportsListPlayerMatchesLazyQuery>;
export type ReportsListPlayerMatchesSuspenseQueryHookResult = ReturnType<typeof useReportsListPlayerMatchesSuspenseQuery>;
export type ReportsListPlayerMatchesQueryResult = Apollo.QueryResult<ReportsListPlayerMatchesQuery, ReportsListPlayerMatchesQueryVariables>;
export const RosterManagementListMyOrganizationsPlayersDocument = gql`
    query RosterManagementListMyOrganizationsPlayers($first: Int, $after: String, $sortBy: SortField, $sortByCustomStatName: String, $sortOrder: OrderByDirection, $positionIds: [ID!], $search: String) {
  listMyOrganizationsPlayers(
    first: $first
    after: $after
    sortBy: $sortBy
    sortByCustomStatName: $sortByCustomStatName
    sortOrder: $sortOrder
    positionIds: $positionIds
    search: $search
  ) {
    ...RosterListPlayerConnection
  }
}
    ${RosterListPlayerConnectionFragmentDoc}`;

/**
 * __useRosterManagementListMyOrganizationsPlayersQuery__
 *
 * To run a query within a React component, call `useRosterManagementListMyOrganizationsPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListMyOrganizationsPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListMyOrganizationsPlayersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      sortOrder: // value for 'sortOrder'
 *      positionIds: // value for 'positionIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRosterManagementListMyOrganizationsPlayersQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>(RosterManagementListMyOrganizationsPlayersDocument, options);
      }
export function useRosterManagementListMyOrganizationsPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>(RosterManagementListMyOrganizationsPlayersDocument, options);
        }
// @ts-ignore
export function useRosterManagementListMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>;
export function useRosterManagementListMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsPlayersQuery | undefined, RosterManagementListMyOrganizationsPlayersQueryVariables>;
export function useRosterManagementListMyOrganizationsPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>(RosterManagementListMyOrganizationsPlayersDocument, options);
        }
export type RosterManagementListMyOrganizationsPlayersQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsPlayersQuery>;
export type RosterManagementListMyOrganizationsPlayersLazyQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsPlayersLazyQuery>;
export type RosterManagementListMyOrganizationsPlayersSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsPlayersSuspenseQuery>;
export type RosterManagementListMyOrganizationsPlayersQueryResult = Apollo.QueryResult<RosterManagementListMyOrganizationsPlayersQuery, RosterManagementListMyOrganizationsPlayersQueryVariables>;
export const RosterManagementListMyOrganizationsTeamsDocument = gql`
    query RosterManagementListMyOrganizationsTeams($first: Int, $after: String) {
  listMyOrganizationsTeams(first: $first, after: $after) {
    ...RosterManagementTeamConnection
  }
}
    ${RosterManagementTeamConnectionFragmentDoc}`;

/**
 * __useRosterManagementListMyOrganizationsTeamsQuery__
 *
 * To run a query within a React component, call `useRosterManagementListMyOrganizationsTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListMyOrganizationsTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListMyOrganizationsTeamsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRosterManagementListMyOrganizationsTeamsQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>(RosterManagementListMyOrganizationsTeamsDocument, options);
      }
export function useRosterManagementListMyOrganizationsTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>(RosterManagementListMyOrganizationsTeamsDocument, options);
        }
// @ts-ignore
export function useRosterManagementListMyOrganizationsTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>;
export function useRosterManagementListMyOrganizationsTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsTeamsQuery | undefined, RosterManagementListMyOrganizationsTeamsQueryVariables>;
export function useRosterManagementListMyOrganizationsTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>(RosterManagementListMyOrganizationsTeamsDocument, options);
        }
export type RosterManagementListMyOrganizationsTeamsQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsTeamsQuery>;
export type RosterManagementListMyOrganizationsTeamsLazyQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsTeamsLazyQuery>;
export type RosterManagementListMyOrganizationsTeamsSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsTeamsSuspenseQuery>;
export type RosterManagementListMyOrganizationsTeamsQueryResult = Apollo.QueryResult<RosterManagementListMyOrganizationsTeamsQuery, RosterManagementListMyOrganizationsTeamsQueryVariables>;
export const RosterManagementListMyOrganizationsLeaguesDocument = gql`
    query RosterManagementListMyOrganizationsLeagues($first: Int, $after: String) {
  listMyOrganizationsLeagues(first: $first, after: $after) {
    ...RosterManagementLeagueConnection
  }
}
    ${RosterManagementLeagueConnectionFragmentDoc}`;

/**
 * __useRosterManagementListMyOrganizationsLeaguesQuery__
 *
 * To run a query within a React component, call `useRosterManagementListMyOrganizationsLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListMyOrganizationsLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListMyOrganizationsLeaguesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRosterManagementListMyOrganizationsLeaguesQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>(RosterManagementListMyOrganizationsLeaguesDocument, options);
      }
export function useRosterManagementListMyOrganizationsLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>(RosterManagementListMyOrganizationsLeaguesDocument, options);
        }
// @ts-ignore
export function useRosterManagementListMyOrganizationsLeaguesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>;
export function useRosterManagementListMyOrganizationsLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsLeaguesQuery | undefined, RosterManagementListMyOrganizationsLeaguesQueryVariables>;
export function useRosterManagementListMyOrganizationsLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>(RosterManagementListMyOrganizationsLeaguesDocument, options);
        }
export type RosterManagementListMyOrganizationsLeaguesQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsLeaguesQuery>;
export type RosterManagementListMyOrganizationsLeaguesLazyQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsLeaguesLazyQuery>;
export type RosterManagementListMyOrganizationsLeaguesSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsLeaguesSuspenseQuery>;
export type RosterManagementListMyOrganizationsLeaguesQueryResult = Apollo.QueryResult<RosterManagementListMyOrganizationsLeaguesQuery, RosterManagementListMyOrganizationsLeaguesQueryVariables>;
export const RosterManagementListMyOrganizationsEligibleTeamsDocument = gql`
    query RosterManagementListMyOrganizationsEligibleTeams($first: Int, $after: String, $search: String) {
  listMyOrganizationsEligibleTeams(first: $first, after: $after, search: $search) {
    ...RosterManagementTeamConnection
  }
}
    ${RosterManagementTeamConnectionFragmentDoc}`;

/**
 * __useRosterManagementListMyOrganizationsEligibleTeamsQuery__
 *
 * To run a query within a React component, call `useRosterManagementListMyOrganizationsEligibleTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListMyOrganizationsEligibleTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListMyOrganizationsEligibleTeamsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRosterManagementListMyOrganizationsEligibleTeamsQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>(RosterManagementListMyOrganizationsEligibleTeamsDocument, options);
      }
export function useRosterManagementListMyOrganizationsEligibleTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>(RosterManagementListMyOrganizationsEligibleTeamsDocument, options);
        }
// @ts-ignore
export function useRosterManagementListMyOrganizationsEligibleTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>;
export function useRosterManagementListMyOrganizationsEligibleTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListMyOrganizationsEligibleTeamsQuery | undefined, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>;
export function useRosterManagementListMyOrganizationsEligibleTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>(RosterManagementListMyOrganizationsEligibleTeamsDocument, options);
        }
export type RosterManagementListMyOrganizationsEligibleTeamsQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsEligibleTeamsQuery>;
export type RosterManagementListMyOrganizationsEligibleTeamsLazyQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsEligibleTeamsLazyQuery>;
export type RosterManagementListMyOrganizationsEligibleTeamsSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListMyOrganizationsEligibleTeamsSuspenseQuery>;
export type RosterManagementListMyOrganizationsEligibleTeamsQueryResult = Apollo.QueryResult<RosterManagementListMyOrganizationsEligibleTeamsQuery, RosterManagementListMyOrganizationsEligibleTeamsQueryVariables>;
export const RosterManagementListLeaguesDocument = gql`
    query RosterManagementListLeagues($first: Int, $after: String, $search: String) {
  listLeagues(first: $first, after: $after, search: $search) {
    ...RosterManagementLeagueConnection
  }
}
    ${RosterManagementLeagueConnectionFragmentDoc}`;

/**
 * __useRosterManagementListLeaguesQuery__
 *
 * To run a query within a React component, call `useRosterManagementListLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListLeaguesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRosterManagementListLeaguesQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>(RosterManagementListLeaguesDocument, options);
      }
export function useRosterManagementListLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>(RosterManagementListLeaguesDocument, options);
        }
// @ts-ignore
export function useRosterManagementListLeaguesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>;
export function useRosterManagementListLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListLeaguesQuery | undefined, RosterManagementListLeaguesQueryVariables>;
export function useRosterManagementListLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>(RosterManagementListLeaguesDocument, options);
        }
export type RosterManagementListLeaguesQueryHookResult = ReturnType<typeof useRosterManagementListLeaguesQuery>;
export type RosterManagementListLeaguesLazyQueryHookResult = ReturnType<typeof useRosterManagementListLeaguesLazyQuery>;
export type RosterManagementListLeaguesSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListLeaguesSuspenseQuery>;
export type RosterManagementListLeaguesQueryResult = Apollo.QueryResult<RosterManagementListLeaguesQuery, RosterManagementListLeaguesQueryVariables>;
export const RosterManagementListNationalitiesDocument = gql`
    query RosterManagementListNationalities($first: Int, $after: String) {
  listNationalities(first: $first, after: $after) {
    ...RosterManagementNationalityConnection
  }
}
    ${RosterManagementNationalityConnectionFragmentDoc}`;

/**
 * __useRosterManagementListNationalitiesQuery__
 *
 * To run a query within a React component, call `useRosterManagementListNationalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListNationalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListNationalitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRosterManagementListNationalitiesQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>(RosterManagementListNationalitiesDocument, options);
      }
export function useRosterManagementListNationalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>(RosterManagementListNationalitiesDocument, options);
        }
// @ts-ignore
export function useRosterManagementListNationalitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>;
export function useRosterManagementListNationalitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListNationalitiesQuery | undefined, RosterManagementListNationalitiesQueryVariables>;
export function useRosterManagementListNationalitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>(RosterManagementListNationalitiesDocument, options);
        }
export type RosterManagementListNationalitiesQueryHookResult = ReturnType<typeof useRosterManagementListNationalitiesQuery>;
export type RosterManagementListNationalitiesLazyQueryHookResult = ReturnType<typeof useRosterManagementListNationalitiesLazyQuery>;
export type RosterManagementListNationalitiesSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListNationalitiesSuspenseQuery>;
export type RosterManagementListNationalitiesQueryResult = Apollo.QueryResult<RosterManagementListNationalitiesQuery, RosterManagementListNationalitiesQueryVariables>;
export const RosterManagementListPositionsDocument = gql`
    query RosterManagementListPositions($first: Int, $after: String) {
  listPositions(first: $first, after: $after) {
    ...RosterManagementPositionConnection
  }
}
    ${RosterManagementPositionConnectionFragmentDoc}`;

/**
 * __useRosterManagementListPositionsQuery__
 *
 * To run a query within a React component, call `useRosterManagementListPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementListPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterManagementListPositionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRosterManagementListPositionsQuery(baseOptions?: Apollo.QueryHookOptions<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>(RosterManagementListPositionsDocument, options);
      }
export function useRosterManagementListPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>(RosterManagementListPositionsDocument, options);
        }
// @ts-ignore
export function useRosterManagementListPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>;
export function useRosterManagementListPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<RosterManagementListPositionsQuery | undefined, RosterManagementListPositionsQueryVariables>;
export function useRosterManagementListPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>(RosterManagementListPositionsDocument, options);
        }
export type RosterManagementListPositionsQueryHookResult = ReturnType<typeof useRosterManagementListPositionsQuery>;
export type RosterManagementListPositionsLazyQueryHookResult = ReturnType<typeof useRosterManagementListPositionsLazyQuery>;
export type RosterManagementListPositionsSuspenseQueryHookResult = ReturnType<typeof useRosterManagementListPositionsSuspenseQuery>;
export type RosterManagementListPositionsQueryResult = Apollo.QueryResult<RosterManagementListPositionsQuery, RosterManagementListPositionsQueryVariables>;
export const RosterManagementCreateOrganizationLeagueDocument = gql`
    mutation RosterManagementCreateOrganizationLeague($input: CreateOrganizationLeagueInput!) {
  createOrganizationLeague(input: $input) {
    ...RosterManagmentOrganizationLeague
  }
}
    ${RosterManagmentOrganizationLeagueFragmentDoc}`;
export type RosterManagementCreateOrganizationLeagueMutationFn = Apollo.MutationFunction<RosterManagementCreateOrganizationLeagueMutation, RosterManagementCreateOrganizationLeagueMutationVariables>;

/**
 * __useRosterManagementCreateOrganizationLeagueMutation__
 *
 * To run a mutation, you first call `useRosterManagementCreateOrganizationLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementCreateOrganizationLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rosterManagementCreateOrganizationLeagueMutation, { data, loading, error }] = useRosterManagementCreateOrganizationLeagueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRosterManagementCreateOrganizationLeagueMutation(baseOptions?: Apollo.MutationHookOptions<RosterManagementCreateOrganizationLeagueMutation, RosterManagementCreateOrganizationLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RosterManagementCreateOrganizationLeagueMutation, RosterManagementCreateOrganizationLeagueMutationVariables>(RosterManagementCreateOrganizationLeagueDocument, options);
      }
export type RosterManagementCreateOrganizationLeagueMutationHookResult = ReturnType<typeof useRosterManagementCreateOrganizationLeagueMutation>;
export type RosterManagementCreateOrganizationLeagueMutationResult = Apollo.MutationResult<RosterManagementCreateOrganizationLeagueMutation>;
export type RosterManagementCreateOrganizationLeagueMutationOptions = Apollo.BaseMutationOptions<RosterManagementCreateOrganizationLeagueMutation, RosterManagementCreateOrganizationLeagueMutationVariables>;
export const RosterManagementDeleteOrganizationLeagueDocument = gql`
    mutation RosterManagementDeleteOrganizationLeague($input: DeleteOrganizationLeagueInput!) {
  deleteOrganizationLeague(input: $input) {
    ...RosterManagmentOrganizationLeague
  }
}
    ${RosterManagmentOrganizationLeagueFragmentDoc}`;
export type RosterManagementDeleteOrganizationLeagueMutationFn = Apollo.MutationFunction<RosterManagementDeleteOrganizationLeagueMutation, RosterManagementDeleteOrganizationLeagueMutationVariables>;

/**
 * __useRosterManagementDeleteOrganizationLeagueMutation__
 *
 * To run a mutation, you first call `useRosterManagementDeleteOrganizationLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementDeleteOrganizationLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rosterManagementDeleteOrganizationLeagueMutation, { data, loading, error }] = useRosterManagementDeleteOrganizationLeagueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRosterManagementDeleteOrganizationLeagueMutation(baseOptions?: Apollo.MutationHookOptions<RosterManagementDeleteOrganizationLeagueMutation, RosterManagementDeleteOrganizationLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RosterManagementDeleteOrganizationLeagueMutation, RosterManagementDeleteOrganizationLeagueMutationVariables>(RosterManagementDeleteOrganizationLeagueDocument, options);
      }
export type RosterManagementDeleteOrganizationLeagueMutationHookResult = ReturnType<typeof useRosterManagementDeleteOrganizationLeagueMutation>;
export type RosterManagementDeleteOrganizationLeagueMutationResult = Apollo.MutationResult<RosterManagementDeleteOrganizationLeagueMutation>;
export type RosterManagementDeleteOrganizationLeagueMutationOptions = Apollo.BaseMutationOptions<RosterManagementDeleteOrganizationLeagueMutation, RosterManagementDeleteOrganizationLeagueMutationVariables>;
export const RosterManagementCreateOrganizationTeamDocument = gql`
    mutation RosterManagementCreateOrganizationTeam($input: CreateOrganizationTeamInput!) {
  createOrganizationTeam(input: $input) {
    ...RosterManagmentOrganizationTeam
  }
}
    ${RosterManagmentOrganizationTeamFragmentDoc}`;
export type RosterManagementCreateOrganizationTeamMutationFn = Apollo.MutationFunction<RosterManagementCreateOrganizationTeamMutation, RosterManagementCreateOrganizationTeamMutationVariables>;

/**
 * __useRosterManagementCreateOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useRosterManagementCreateOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementCreateOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rosterManagementCreateOrganizationTeamMutation, { data, loading, error }] = useRosterManagementCreateOrganizationTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRosterManagementCreateOrganizationTeamMutation(baseOptions?: Apollo.MutationHookOptions<RosterManagementCreateOrganizationTeamMutation, RosterManagementCreateOrganizationTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RosterManagementCreateOrganizationTeamMutation, RosterManagementCreateOrganizationTeamMutationVariables>(RosterManagementCreateOrganizationTeamDocument, options);
      }
export type RosterManagementCreateOrganizationTeamMutationHookResult = ReturnType<typeof useRosterManagementCreateOrganizationTeamMutation>;
export type RosterManagementCreateOrganizationTeamMutationResult = Apollo.MutationResult<RosterManagementCreateOrganizationTeamMutation>;
export type RosterManagementCreateOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<RosterManagementCreateOrganizationTeamMutation, RosterManagementCreateOrganizationTeamMutationVariables>;
export const RosterManagementDeleteOrganizationTeamDocument = gql`
    mutation RosterManagementDeleteOrganizationTeam($input: DeleteOrganizationTeamInput!) {
  deleteOrganizationTeam(input: $input) {
    ...RosterManagmentOrganizationTeam
  }
}
    ${RosterManagmentOrganizationTeamFragmentDoc}`;
export type RosterManagementDeleteOrganizationTeamMutationFn = Apollo.MutationFunction<RosterManagementDeleteOrganizationTeamMutation, RosterManagementDeleteOrganizationTeamMutationVariables>;

/**
 * __useRosterManagementDeleteOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useRosterManagementDeleteOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRosterManagementDeleteOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rosterManagementDeleteOrganizationTeamMutation, { data, loading, error }] = useRosterManagementDeleteOrganizationTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRosterManagementDeleteOrganizationTeamMutation(baseOptions?: Apollo.MutationHookOptions<RosterManagementDeleteOrganizationTeamMutation, RosterManagementDeleteOrganizationTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RosterManagementDeleteOrganizationTeamMutation, RosterManagementDeleteOrganizationTeamMutationVariables>(RosterManagementDeleteOrganizationTeamDocument, options);
      }
export type RosterManagementDeleteOrganizationTeamMutationHookResult = ReturnType<typeof useRosterManagementDeleteOrganizationTeamMutation>;
export type RosterManagementDeleteOrganizationTeamMutationResult = Apollo.MutationResult<RosterManagementDeleteOrganizationTeamMutation>;
export type RosterManagementDeleteOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<RosterManagementDeleteOrganizationTeamMutation, RosterManagementDeleteOrganizationTeamMutationVariables>;
export const ScoutingListAllTargetsDocument = gql`
    query ScoutingListAllTargets($first: Int = 50, $after: String, $search: String, $filterByPositionIds: [ID!], $filterByTeamIds: [ID!], $filterByWatchlistIds: [ID!], $filterByScoutIds: [ID!], $filterByNationalityIds: [ID!], $filterByLeagueIds: [ID!], $filterByRoleArchetypes: [String!], $sortBy: SortField, $sortOrder: OrderByDirection, $sortByCustomStatName: String, $minAge: Int, $maxAge: Int, $minGeminiPlayerValuation: Float, $maxGeminiPlayerValuation: Float, $minContractMonths: Int, $maxContractMonths: Int, $minGpr: Float, $maxGpr: Float, $minFitScore: Float, $maxFitScore: Float, $minTeamStyleFit: Float, $maxTeamStyleFit: Float, $minCarrying: Float, $maxCarrying: Float, $minPassing: Float, $maxPassing: Float, $minDribbling: Float, $maxDribbling: Float, $minShooting: Float, $maxShooting: Float, $minGkShotStopping: Float, $maxGkShotStopping: Float, $minGkPositioning: Float, $maxGkPositioning: Float, $minGkPassing: Float, $maxGkPassing: Float, $filterByCustomStats: [CustomStatFilterInput!], $filterByOrganizationRoster: Boolean) {
  listAllScoutingTargets(
    first: $first
    after: $after
    search: $search
    filterByPositionIds: $filterByPositionIds
    filterByTeamIds: $filterByTeamIds
    filterByWatchlistIds: $filterByWatchlistIds
    filterByScoutIds: $filterByScoutIds
    filterByNationalityIds: $filterByNationalityIds
    filterByLeagueIds: $filterByLeagueIds
    filterByRoleArchetypes: $filterByRoleArchetypes
    sortBy: $sortBy
    sortOrder: $sortOrder
    sortByCustomStatName: $sortByCustomStatName
    minAge: $minAge
    maxAge: $maxAge
    minGeminiPlayerValuation: $minGeminiPlayerValuation
    maxGeminiPlayerValuation: $maxGeminiPlayerValuation
    minContractMonths: $minContractMonths
    maxContractMonths: $maxContractMonths
    minGpr: $minGpr
    maxGpr: $maxGpr
    minFitScore: $minFitScore
    maxFitScore: $maxFitScore
    minTeamStyleFit: $minTeamStyleFit
    maxTeamStyleFit: $maxTeamStyleFit
    minCarrying: $minCarrying
    maxCarrying: $maxCarrying
    minPassing: $minPassing
    maxPassing: $maxPassing
    minDribbling: $minDribbling
    maxDribbling: $maxDribbling
    minShooting: $minShooting
    maxShooting: $maxShooting
    minGkShotStopping: $minGkShotStopping
    maxGkShotStopping: $maxGkShotStopping
    minGkPositioning: $minGkPositioning
    maxGkPositioning: $maxGkPositioning
    minGkPassing: $minGkPassing
    maxGkPassing: $maxGkPassing
    filterByCustomStats: $filterByCustomStats
    filterByOrganizationRoster: $filterByOrganizationRoster
  ) {
    edges {
      cursor
      node {
        id
        player {
          id
          name
          knownName
          firstName
          lastName
          dateOfBirth
          team {
            id
            name
          }
          teamName
          league {
            id
            name
          }
          positions {
            id
            name
            abbreviation
          }
          nationality {
            id
            name
          }
          bioData {
            ggPlayerKey
            gpr
            primaryPosition
            fitScore
            teamStyleFit
            customStats
            carryingTransGlobalCategoricalScore
            dribblingTransGlobalCategoricalScore
            passingTransGlobalCategoricalScore
            shotLocationTransGlobalCategoricalScore
            gkPassingTransCategoricalScore
            gkPositioningTransCategoricalScore
            gkShotStoppingTransCategoricalScore
            contractExpires
            dateOfBirth
            age
          }
        }
        scoutReportCount
        avgScoutRating
        scoutRatingScaleMax
        lastEditedAt
        lastEditor {
          id
          displayName
        }
        averageRatings {
          name
          average
          count
        }
        watchlists {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useScoutingListAllTargetsQuery__
 *
 * To run a query within a React component, call `useScoutingListAllTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListAllTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListAllTargetsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filterByPositionIds: // value for 'filterByPositionIds'
 *      filterByTeamIds: // value for 'filterByTeamIds'
 *      filterByWatchlistIds: // value for 'filterByWatchlistIds'
 *      filterByScoutIds: // value for 'filterByScoutIds'
 *      filterByNationalityIds: // value for 'filterByNationalityIds'
 *      filterByLeagueIds: // value for 'filterByLeagueIds'
 *      filterByRoleArchetypes: // value for 'filterByRoleArchetypes'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      minAge: // value for 'minAge'
 *      maxAge: // value for 'maxAge'
 *      minGeminiPlayerValuation: // value for 'minGeminiPlayerValuation'
 *      maxGeminiPlayerValuation: // value for 'maxGeminiPlayerValuation'
 *      minContractMonths: // value for 'minContractMonths'
 *      maxContractMonths: // value for 'maxContractMonths'
 *      minGpr: // value for 'minGpr'
 *      maxGpr: // value for 'maxGpr'
 *      minFitScore: // value for 'minFitScore'
 *      maxFitScore: // value for 'maxFitScore'
 *      minTeamStyleFit: // value for 'minTeamStyleFit'
 *      maxTeamStyleFit: // value for 'maxTeamStyleFit'
 *      minCarrying: // value for 'minCarrying'
 *      maxCarrying: // value for 'maxCarrying'
 *      minPassing: // value for 'minPassing'
 *      maxPassing: // value for 'maxPassing'
 *      minDribbling: // value for 'minDribbling'
 *      maxDribbling: // value for 'maxDribbling'
 *      minShooting: // value for 'minShooting'
 *      maxShooting: // value for 'maxShooting'
 *      minGkShotStopping: // value for 'minGkShotStopping'
 *      maxGkShotStopping: // value for 'maxGkShotStopping'
 *      minGkPositioning: // value for 'minGkPositioning'
 *      maxGkPositioning: // value for 'maxGkPositioning'
 *      minGkPassing: // value for 'minGkPassing'
 *      maxGkPassing: // value for 'maxGkPassing'
 *      filterByCustomStats: // value for 'filterByCustomStats'
 *      filterByOrganizationRoster: // value for 'filterByOrganizationRoster'
 *   },
 * });
 */
export function useScoutingListAllTargetsQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>(ScoutingListAllTargetsDocument, options);
      }
export function useScoutingListAllTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>(ScoutingListAllTargetsDocument, options);
        }
// @ts-ignore
export function useScoutingListAllTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>;
export function useScoutingListAllTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListAllTargetsQuery | undefined, ScoutingListAllTargetsQueryVariables>;
export function useScoutingListAllTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>(ScoutingListAllTargetsDocument, options);
        }
export type ScoutingListAllTargetsQueryHookResult = ReturnType<typeof useScoutingListAllTargetsQuery>;
export type ScoutingListAllTargetsLazyQueryHookResult = ReturnType<typeof useScoutingListAllTargetsLazyQuery>;
export type ScoutingListAllTargetsSuspenseQueryHookResult = ReturnType<typeof useScoutingListAllTargetsSuspenseQuery>;
export type ScoutingListAllTargetsQueryResult = Apollo.QueryResult<ScoutingListAllTargetsQuery, ScoutingListAllTargetsQueryVariables>;
export const ScoutingListRoleArchetypesDocument = gql`
    query ScoutingListRoleArchetypes {
  listRoleArchetypes
}
    `;

/**
 * __useScoutingListRoleArchetypesQuery__
 *
 * To run a query within a React component, call `useScoutingListRoleArchetypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListRoleArchetypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListRoleArchetypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useScoutingListRoleArchetypesQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>(ScoutingListRoleArchetypesDocument, options);
      }
export function useScoutingListRoleArchetypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>(ScoutingListRoleArchetypesDocument, options);
        }
// @ts-ignore
export function useScoutingListRoleArchetypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>;
export function useScoutingListRoleArchetypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListRoleArchetypesQuery | undefined, ScoutingListRoleArchetypesQueryVariables>;
export function useScoutingListRoleArchetypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>(ScoutingListRoleArchetypesDocument, options);
        }
export type ScoutingListRoleArchetypesQueryHookResult = ReturnType<typeof useScoutingListRoleArchetypesQuery>;
export type ScoutingListRoleArchetypesLazyQueryHookResult = ReturnType<typeof useScoutingListRoleArchetypesLazyQuery>;
export type ScoutingListRoleArchetypesSuspenseQueryHookResult = ReturnType<typeof useScoutingListRoleArchetypesSuspenseQuery>;
export type ScoutingListRoleArchetypesQueryResult = Apollo.QueryResult<ScoutingListRoleArchetypesQuery, ScoutingListRoleArchetypesQueryVariables>;
export const ScoutingListScoutsDocument = gql`
    query ScoutingListScouts {
  listScoutingScouts {
    id
    email
    title
  }
}
    `;

/**
 * __useScoutingListScoutsQuery__
 *
 * To run a query within a React component, call `useScoutingListScoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListScoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListScoutsQuery({
 *   variables: {
 *   },
 * });
 */
export function useScoutingListScoutsQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>(ScoutingListScoutsDocument, options);
      }
export function useScoutingListScoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>(ScoutingListScoutsDocument, options);
        }
// @ts-ignore
export function useScoutingListScoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>;
export function useScoutingListScoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListScoutsQuery | undefined, ScoutingListScoutsQueryVariables>;
export function useScoutingListScoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>(ScoutingListScoutsDocument, options);
        }
export type ScoutingListScoutsQueryHookResult = ReturnType<typeof useScoutingListScoutsQuery>;
export type ScoutingListScoutsLazyQueryHookResult = ReturnType<typeof useScoutingListScoutsLazyQuery>;
export type ScoutingListScoutsSuspenseQueryHookResult = ReturnType<typeof useScoutingListScoutsSuspenseQuery>;
export type ScoutingListScoutsQueryResult = Apollo.QueryResult<ScoutingListScoutsQuery, ScoutingListScoutsQueryVariables>;
export const ScoutingListRecentlyInteractedPlayersDocument = gql`
    query ScoutingListRecentlyInteractedPlayers($limit: Int = 50, $sinceDays: Int = 30) {
  listRecentlyInteractedPlayers(limit: $limit, sinceDays: $sinceDays) {
    id
    lastActivityAt
    activityType
    player {
      id
      name
      knownName
      firstName
      lastName
      teamName
      positions {
        id
        abbreviation
      }
      team {
        id
        name
      }
      bioData {
        ggPlayerKey
        gpr
      }
    }
  }
}
    `;

/**
 * __useScoutingListRecentlyInteractedPlayersQuery__
 *
 * To run a query within a React component, call `useScoutingListRecentlyInteractedPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListRecentlyInteractedPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListRecentlyInteractedPlayersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sinceDays: // value for 'sinceDays'
 *   },
 * });
 */
export function useScoutingListRecentlyInteractedPlayersQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>(ScoutingListRecentlyInteractedPlayersDocument, options);
      }
export function useScoutingListRecentlyInteractedPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>(ScoutingListRecentlyInteractedPlayersDocument, options);
        }
// @ts-ignore
export function useScoutingListRecentlyInteractedPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>;
export function useScoutingListRecentlyInteractedPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListRecentlyInteractedPlayersQuery | undefined, ScoutingListRecentlyInteractedPlayersQueryVariables>;
export function useScoutingListRecentlyInteractedPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>(ScoutingListRecentlyInteractedPlayersDocument, options);
        }
export type ScoutingListRecentlyInteractedPlayersQueryHookResult = ReturnType<typeof useScoutingListRecentlyInteractedPlayersQuery>;
export type ScoutingListRecentlyInteractedPlayersLazyQueryHookResult = ReturnType<typeof useScoutingListRecentlyInteractedPlayersLazyQuery>;
export type ScoutingListRecentlyInteractedPlayersSuspenseQueryHookResult = ReturnType<typeof useScoutingListRecentlyInteractedPlayersSuspenseQuery>;
export type ScoutingListRecentlyInteractedPlayersQueryResult = Apollo.QueryResult<ScoutingListRecentlyInteractedPlayersQuery, ScoutingListRecentlyInteractedPlayersQueryVariables>;
export const LogPlayerProfileViewDocument = gql`
    mutation LogPlayerProfileView($playerId: ID!) {
  logPlayerProfileView(input: {playerId: $playerId}) {
    id
  }
}
    `;
export type LogPlayerProfileViewMutationFn = Apollo.MutationFunction<LogPlayerProfileViewMutation, LogPlayerProfileViewMutationVariables>;

/**
 * __useLogPlayerProfileViewMutation__
 *
 * To run a mutation, you first call `useLogPlayerProfileViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogPlayerProfileViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logPlayerProfileViewMutation, { data, loading, error }] = useLogPlayerProfileViewMutation({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useLogPlayerProfileViewMutation(baseOptions?: Apollo.MutationHookOptions<LogPlayerProfileViewMutation, LogPlayerProfileViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogPlayerProfileViewMutation, LogPlayerProfileViewMutationVariables>(LogPlayerProfileViewDocument, options);
      }
export type LogPlayerProfileViewMutationHookResult = ReturnType<typeof useLogPlayerProfileViewMutation>;
export type LogPlayerProfileViewMutationResult = Apollo.MutationResult<LogPlayerProfileViewMutation>;
export type LogPlayerProfileViewMutationOptions = Apollo.BaseMutationOptions<LogPlayerProfileViewMutation, LogPlayerProfileViewMutationVariables>;
export const ScoutingListUserWatchlistsDocument = gql`
    query ScoutingListUserWatchlists($first: Int = 100) {
  listMyUserWatchlists(first: $first) {
    edges {
      node {
        id
        role
        effectiveRole
        grantSource
        userId
        isDefault
        lastSelectedAt
        watchlist {
          id
          name
          playerCount
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useScoutingListUserWatchlistsQuery__
 *
 * To run a query within a React component, call `useScoutingListUserWatchlistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListUserWatchlistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListUserWatchlistsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useScoutingListUserWatchlistsQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>(ScoutingListUserWatchlistsDocument, options);
      }
export function useScoutingListUserWatchlistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>(ScoutingListUserWatchlistsDocument, options);
        }
// @ts-ignore
export function useScoutingListUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>;
export function useScoutingListUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListUserWatchlistsQuery | undefined, ScoutingListUserWatchlistsQueryVariables>;
export function useScoutingListUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>(ScoutingListUserWatchlistsDocument, options);
        }
export type ScoutingListUserWatchlistsQueryHookResult = ReturnType<typeof useScoutingListUserWatchlistsQuery>;
export type ScoutingListUserWatchlistsLazyQueryHookResult = ReturnType<typeof useScoutingListUserWatchlistsLazyQuery>;
export type ScoutingListUserWatchlistsSuspenseQueryHookResult = ReturnType<typeof useScoutingListUserWatchlistsSuspenseQuery>;
export type ScoutingListUserWatchlistsQueryResult = Apollo.QueryResult<ScoutingListUserWatchlistsQuery, ScoutingListUserWatchlistsQueryVariables>;
export const ScoutingGetWatchlistPitchDocument = gql`
    query ScoutingGetWatchlistPitch($id: ID!, $first: Int = 50, $after: String, $filter: WatchlistPitchFilterInput) {
  getWatchlistPitch(id: $id, first: $first, after: $after, filter: $filter) {
    id
    name
    role
    canEdit
    formation
    pitchRevision
    pitchInitialized
    manualOrder
    members {
      edges {
        cursor
        node {
          id
          playerId
          rank
          effectiveSlot
          assignmentOrigin
          primaryPositionCode
          primaryPositionSource
          naturalPositions {
            id
            name
            abbreviation
          }
          displayName
          club
          imageUrl
          gpr
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    watchlistCount
    overlay {
      id
      club
      age
      nationality
      displayName
      imageUrl
      naturalPositions {
        id
        name
        abbreviation
      }
      gpr
      rosterTier
    }
    overlayCount
  }
}
    `;

/**
 * __useScoutingGetWatchlistPitchQuery__
 *
 * To run a query within a React component, call `useScoutingGetWatchlistPitchQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingGetWatchlistPitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingGetWatchlistPitchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScoutingGetWatchlistPitchQuery(baseOptions: Apollo.QueryHookOptions<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables> & ({ variables: ScoutingGetWatchlistPitchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>(ScoutingGetWatchlistPitchDocument, options);
      }
export function useScoutingGetWatchlistPitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>(ScoutingGetWatchlistPitchDocument, options);
        }
// @ts-ignore
export function useScoutingGetWatchlistPitchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>;
export function useScoutingGetWatchlistPitchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingGetWatchlistPitchQuery | undefined, ScoutingGetWatchlistPitchQueryVariables>;
export function useScoutingGetWatchlistPitchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>(ScoutingGetWatchlistPitchDocument, options);
        }
export type ScoutingGetWatchlistPitchQueryHookResult = ReturnType<typeof useScoutingGetWatchlistPitchQuery>;
export type ScoutingGetWatchlistPitchLazyQueryHookResult = ReturnType<typeof useScoutingGetWatchlistPitchLazyQuery>;
export type ScoutingGetWatchlistPitchSuspenseQueryHookResult = ReturnType<typeof useScoutingGetWatchlistPitchSuspenseQuery>;
export type ScoutingGetWatchlistPitchQueryResult = Apollo.QueryResult<ScoutingGetWatchlistPitchQuery, ScoutingGetWatchlistPitchQueryVariables>;
export const ScoutingUpdateWatchlistPitchAssignmentDocument = gql`
    mutation ScoutingUpdateWatchlistPitchAssignment($input: UpdateWatchlistPitchAssignmentInput!) {
  updateWatchlistPitchAssignment(input: $input) {
    watchlistId
    formation
    pitchInitialized
    pitchRevision
    assignments {
      playerId
      rank
      tacticalSlot
    }
  }
}
    `;
export type ScoutingUpdateWatchlistPitchAssignmentMutationFn = Apollo.MutationFunction<ScoutingUpdateWatchlistPitchAssignmentMutation, ScoutingUpdateWatchlistPitchAssignmentMutationVariables>;

/**
 * __useScoutingUpdateWatchlistPitchAssignmentMutation__
 *
 * To run a mutation, you first call `useScoutingUpdateWatchlistPitchAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingUpdateWatchlistPitchAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingUpdateWatchlistPitchAssignmentMutation, { data, loading, error }] = useScoutingUpdateWatchlistPitchAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingUpdateWatchlistPitchAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingUpdateWatchlistPitchAssignmentMutation, ScoutingUpdateWatchlistPitchAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingUpdateWatchlistPitchAssignmentMutation, ScoutingUpdateWatchlistPitchAssignmentMutationVariables>(ScoutingUpdateWatchlistPitchAssignmentDocument, options);
      }
export type ScoutingUpdateWatchlistPitchAssignmentMutationHookResult = ReturnType<typeof useScoutingUpdateWatchlistPitchAssignmentMutation>;
export type ScoutingUpdateWatchlistPitchAssignmentMutationResult = Apollo.MutationResult<ScoutingUpdateWatchlistPitchAssignmentMutation>;
export type ScoutingUpdateWatchlistPitchAssignmentMutationOptions = Apollo.BaseMutationOptions<ScoutingUpdateWatchlistPitchAssignmentMutation, ScoutingUpdateWatchlistPitchAssignmentMutationVariables>;
export const ScoutingUpdateWatchlistFormationDocument = gql`
    mutation ScoutingUpdateWatchlistFormation($input: UpdateWatchlistFormationInput!) {
  updateWatchlistFormation(input: $input) {
    watchlistId
    formation
    pitchInitialized
    pitchRevision
    assignments {
      playerId
      rank
      tacticalSlot
    }
  }
}
    `;
export type ScoutingUpdateWatchlistFormationMutationFn = Apollo.MutationFunction<ScoutingUpdateWatchlistFormationMutation, ScoutingUpdateWatchlistFormationMutationVariables>;

/**
 * __useScoutingUpdateWatchlistFormationMutation__
 *
 * To run a mutation, you first call `useScoutingUpdateWatchlistFormationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingUpdateWatchlistFormationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingUpdateWatchlistFormationMutation, { data, loading, error }] = useScoutingUpdateWatchlistFormationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingUpdateWatchlistFormationMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingUpdateWatchlistFormationMutation, ScoutingUpdateWatchlistFormationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingUpdateWatchlistFormationMutation, ScoutingUpdateWatchlistFormationMutationVariables>(ScoutingUpdateWatchlistFormationDocument, options);
      }
export type ScoutingUpdateWatchlistFormationMutationHookResult = ReturnType<typeof useScoutingUpdateWatchlistFormationMutation>;
export type ScoutingUpdateWatchlistFormationMutationResult = Apollo.MutationResult<ScoutingUpdateWatchlistFormationMutation>;
export type ScoutingUpdateWatchlistFormationMutationOptions = Apollo.BaseMutationOptions<ScoutingUpdateWatchlistFormationMutation, ScoutingUpdateWatchlistFormationMutationVariables>;
export const ScoutingGetScoutReportDocument = gql`
    query ScoutingGetScoutReport($id: ID!) {
  getScoutReport(id: $id) {
    reportId
    canEdit
    canArchive
    ggPlayerKey
    scoutUserId
    scoutName
    reportDate
    team
    opponent
    ground
    overallScore
    qnaText
    translatedQnaText
    availableTranslations
    matches {
      team
      opponent
      ground
      matchDate
    }
    matchName
    lastEditorUserId
    lastEditorName
    lastEditDate
  }
}
    `;

/**
 * __useScoutingGetScoutReportQuery__
 *
 * To run a query within a React component, call `useScoutingGetScoutReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingGetScoutReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingGetScoutReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScoutingGetScoutReportQuery(baseOptions: Apollo.QueryHookOptions<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables> & ({ variables: ScoutingGetScoutReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>(ScoutingGetScoutReportDocument, options);
      }
export function useScoutingGetScoutReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>(ScoutingGetScoutReportDocument, options);
        }
// @ts-ignore
export function useScoutingGetScoutReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>;
export function useScoutingGetScoutReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingGetScoutReportQuery | undefined, ScoutingGetScoutReportQueryVariables>;
export function useScoutingGetScoutReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>(ScoutingGetScoutReportDocument, options);
        }
export type ScoutingGetScoutReportQueryHookResult = ReturnType<typeof useScoutingGetScoutReportQuery>;
export type ScoutingGetScoutReportLazyQueryHookResult = ReturnType<typeof useScoutingGetScoutReportLazyQuery>;
export type ScoutingGetScoutReportSuspenseQueryHookResult = ReturnType<typeof useScoutingGetScoutReportSuspenseQuery>;
export type ScoutingGetScoutReportQueryResult = Apollo.QueryResult<ScoutingGetScoutReportQuery, ScoutingGetScoutReportQueryVariables>;
export const ScoutingGetScoutReportTypesDocument = gql`
    query ScoutingGetScoutReportTypes {
  getScoutReportTypes {
    id
    name
    reportFormat
    ratingDefinitions {
      key
      label
    }
    categoricalRatingDefinitions {
      key
      label
    }
  }
}
    `;

/**
 * __useScoutingGetScoutReportTypesQuery__
 *
 * To run a query within a React component, call `useScoutingGetScoutReportTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingGetScoutReportTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingGetScoutReportTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useScoutingGetScoutReportTypesQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>(ScoutingGetScoutReportTypesDocument, options);
      }
export function useScoutingGetScoutReportTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>(ScoutingGetScoutReportTypesDocument, options);
        }
// @ts-ignore
export function useScoutingGetScoutReportTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>;
export function useScoutingGetScoutReportTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingGetScoutReportTypesQuery | undefined, ScoutingGetScoutReportTypesQueryVariables>;
export function useScoutingGetScoutReportTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>(ScoutingGetScoutReportTypesDocument, options);
        }
export type ScoutingGetScoutReportTypesQueryHookResult = ReturnType<typeof useScoutingGetScoutReportTypesQuery>;
export type ScoutingGetScoutReportTypesLazyQueryHookResult = ReturnType<typeof useScoutingGetScoutReportTypesLazyQuery>;
export type ScoutingGetScoutReportTypesSuspenseQueryHookResult = ReturnType<typeof useScoutingGetScoutReportTypesSuspenseQuery>;
export type ScoutingGetScoutReportTypesQueryResult = Apollo.QueryResult<ScoutingGetScoutReportTypesQuery, ScoutingGetScoutReportTypesQueryVariables>;
export const ScoutingScoutReportFilterOptionsDocument = gql`
    query ScoutingScoutReportFilterOptions {
  scoutReportFilterOptions {
    teams {
      name
      teamIds
    }
    matchNames
    scouts {
      userId
      name
    }
    ratingKeys {
      key
      label
    }
  }
}
    `;

/**
 * __useScoutingScoutReportFilterOptionsQuery__
 *
 * To run a query within a React component, call `useScoutingScoutReportFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingScoutReportFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingScoutReportFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useScoutingScoutReportFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>(ScoutingScoutReportFilterOptionsDocument, options);
      }
export function useScoutingScoutReportFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>(ScoutingScoutReportFilterOptionsDocument, options);
        }
// @ts-ignore
export function useScoutingScoutReportFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>;
export function useScoutingScoutReportFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingScoutReportFilterOptionsQuery | undefined, ScoutingScoutReportFilterOptionsQueryVariables>;
export function useScoutingScoutReportFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>(ScoutingScoutReportFilterOptionsDocument, options);
        }
export type ScoutingScoutReportFilterOptionsQueryHookResult = ReturnType<typeof useScoutingScoutReportFilterOptionsQuery>;
export type ScoutingScoutReportFilterOptionsLazyQueryHookResult = ReturnType<typeof useScoutingScoutReportFilterOptionsLazyQuery>;
export type ScoutingScoutReportFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useScoutingScoutReportFilterOptionsSuspenseQuery>;
export type ScoutingScoutReportFilterOptionsQueryResult = Apollo.QueryResult<ScoutingScoutReportFilterOptionsQuery, ScoutingScoutReportFilterOptionsQueryVariables>;
export const ScoutingOrganizationScoutReportsDocument = gql`
    query ScoutingOrganizationScoutReports($first: Int = 50, $after: String, $filter: OrganizationScoutReportsFilterInput, $sort: OrganizationScoutReportsSortInput) {
  organizationScoutReports(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    edges {
      cursor
      node {
        id
        playerName
        playerId
        club
        matchName
        matchDate
        createdAt
        updatedAt
        scoutName
        scoutUserId
        reportTypeName
        reportTypeId
        overallScore
        numericRatings {
          key
          label
          value
        }
        categoricalRatings {
          key
          label
          value
        }
        matches {
          team
          opponent
          ground
          matchDate
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useScoutingOrganizationScoutReportsQuery__
 *
 * To run a query within a React component, call `useScoutingOrganizationScoutReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingOrganizationScoutReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingOrganizationScoutReportsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useScoutingOrganizationScoutReportsQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>(ScoutingOrganizationScoutReportsDocument, options);
      }
export function useScoutingOrganizationScoutReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>(ScoutingOrganizationScoutReportsDocument, options);
        }
// @ts-ignore
export function useScoutingOrganizationScoutReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>;
export function useScoutingOrganizationScoutReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingOrganizationScoutReportsQuery | undefined, ScoutingOrganizationScoutReportsQueryVariables>;
export function useScoutingOrganizationScoutReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>(ScoutingOrganizationScoutReportsDocument, options);
        }
export type ScoutingOrganizationScoutReportsQueryHookResult = ReturnType<typeof useScoutingOrganizationScoutReportsQuery>;
export type ScoutingOrganizationScoutReportsLazyQueryHookResult = ReturnType<typeof useScoutingOrganizationScoutReportsLazyQuery>;
export type ScoutingOrganizationScoutReportsSuspenseQueryHookResult = ReturnType<typeof useScoutingOrganizationScoutReportsSuspenseQuery>;
export type ScoutingOrganizationScoutReportsQueryResult = Apollo.QueryResult<ScoutingOrganizationScoutReportsQuery, ScoutingOrganizationScoutReportsQueryVariables>;
export const SeeAllListsDrawerDocument = gql`
    query SeeAllListsDrawer($first: Int = 100) {
  listMyUserWatchlists(first: $first) {
    edges {
      node {
        id
        role
        effectiveRole
        grantSource
        lastSelectedAt
        watchlist {
          id
          name
          playerCount
          lastActivityAt
          updatedAt
          users {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSeeAllListsDrawerQuery__
 *
 * To run a query within a React component, call `useSeeAllListsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeeAllListsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeeAllListsDrawerQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSeeAllListsDrawerQuery(baseOptions?: Apollo.QueryHookOptions<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>(SeeAllListsDrawerDocument, options);
      }
export function useSeeAllListsDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>(SeeAllListsDrawerDocument, options);
        }
// @ts-ignore
export function useSeeAllListsDrawerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>): Apollo.UseSuspenseQueryResult<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>;
export function useSeeAllListsDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>): Apollo.UseSuspenseQueryResult<SeeAllListsDrawerQuery | undefined, SeeAllListsDrawerQueryVariables>;
export function useSeeAllListsDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>(SeeAllListsDrawerDocument, options);
        }
export type SeeAllListsDrawerQueryHookResult = ReturnType<typeof useSeeAllListsDrawerQuery>;
export type SeeAllListsDrawerLazyQueryHookResult = ReturnType<typeof useSeeAllListsDrawerLazyQuery>;
export type SeeAllListsDrawerSuspenseQueryHookResult = ReturnType<typeof useSeeAllListsDrawerSuspenseQuery>;
export type SeeAllListsDrawerQueryResult = Apollo.QueryResult<SeeAllListsDrawerQuery, SeeAllListsDrawerQueryVariables>;
export const SeeAllListsDrawerMarkSelectedDocument = gql`
    mutation SeeAllListsDrawerMarkSelected($watchlistId: ID!) {
  markUserWatchlistAsRecentlySelected(watchlistId: $watchlistId) {
    id
    watchlistId
    lastSelectedAt
  }
}
    `;
export type SeeAllListsDrawerMarkSelectedMutationFn = Apollo.MutationFunction<SeeAllListsDrawerMarkSelectedMutation, SeeAllListsDrawerMarkSelectedMutationVariables>;

/**
 * __useSeeAllListsDrawerMarkSelectedMutation__
 *
 * To run a mutation, you first call `useSeeAllListsDrawerMarkSelectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeeAllListsDrawerMarkSelectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seeAllListsDrawerMarkSelectedMutation, { data, loading, error }] = useSeeAllListsDrawerMarkSelectedMutation({
 *   variables: {
 *      watchlistId: // value for 'watchlistId'
 *   },
 * });
 */
export function useSeeAllListsDrawerMarkSelectedMutation(baseOptions?: Apollo.MutationHookOptions<SeeAllListsDrawerMarkSelectedMutation, SeeAllListsDrawerMarkSelectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeeAllListsDrawerMarkSelectedMutation, SeeAllListsDrawerMarkSelectedMutationVariables>(SeeAllListsDrawerMarkSelectedDocument, options);
      }
export type SeeAllListsDrawerMarkSelectedMutationHookResult = ReturnType<typeof useSeeAllListsDrawerMarkSelectedMutation>;
export type SeeAllListsDrawerMarkSelectedMutationResult = Apollo.MutationResult<SeeAllListsDrawerMarkSelectedMutation>;
export type SeeAllListsDrawerMarkSelectedMutationOptions = Apollo.BaseMutationOptions<SeeAllListsDrawerMarkSelectedMutation, SeeAllListsDrawerMarkSelectedMutationVariables>;
export const ScoutingListMatchReportsDocument = gql`
    query ScoutingListMatchReports($first: Int = 50, $after: String, $filter: MatchReportFilterInput) {
  listMatchReports(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        id
        status
        notedCount
        tickedCount
        scoredCount
        squadSize
        submittedAt
        createdAt
        updatedAt
        watchMode
        match {
          id
          scheduledDate
          homeTeam {
            id
            name
          }
          awayTeam {
            id
            name
          }
          league {
            id
            name
          }
        }
        scoutUser {
          id
          displayName
        }
        scouts {
          id
          displayName
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useScoutingListMatchReportsQuery__
 *
 * To run a query within a React component, call `useScoutingListMatchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListMatchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListMatchReportsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScoutingListMatchReportsQuery(baseOptions?: Apollo.QueryHookOptions<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>(ScoutingListMatchReportsDocument, options);
      }
export function useScoutingListMatchReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>(ScoutingListMatchReportsDocument, options);
        }
// @ts-ignore
export function useScoutingListMatchReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>;
export function useScoutingListMatchReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListMatchReportsQuery | undefined, ScoutingListMatchReportsQueryVariables>;
export function useScoutingListMatchReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>(ScoutingListMatchReportsDocument, options);
        }
export type ScoutingListMatchReportsQueryHookResult = ReturnType<typeof useScoutingListMatchReportsQuery>;
export type ScoutingListMatchReportsLazyQueryHookResult = ReturnType<typeof useScoutingListMatchReportsLazyQuery>;
export type ScoutingListMatchReportsSuspenseQueryHookResult = ReturnType<typeof useScoutingListMatchReportsSuspenseQuery>;
export type ScoutingListMatchReportsQueryResult = Apollo.QueryResult<ScoutingListMatchReportsQuery, ScoutingListMatchReportsQueryVariables>;
export const ScoutingMatchReportPlayersDocument = gql`
    query ScoutingMatchReportPlayers($id: ID!) {
  getMatchReport(id: $id) {
    id
    playerEvaluations {
      id
      isNoted
      performanceScore
      potentialScore
      note
      shirtNumber
      player {
        id
        name
        knownName
        positions {
          id
          abbreviation
        }
      }
      team {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useScoutingMatchReportPlayersQuery__
 *
 * To run a query within a React component, call `useScoutingMatchReportPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingMatchReportPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingMatchReportPlayersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScoutingMatchReportPlayersQuery(baseOptions: Apollo.QueryHookOptions<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables> & ({ variables: ScoutingMatchReportPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>(ScoutingMatchReportPlayersDocument, options);
      }
export function useScoutingMatchReportPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>(ScoutingMatchReportPlayersDocument, options);
        }
// @ts-ignore
export function useScoutingMatchReportPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>;
export function useScoutingMatchReportPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingMatchReportPlayersQuery | undefined, ScoutingMatchReportPlayersQueryVariables>;
export function useScoutingMatchReportPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>(ScoutingMatchReportPlayersDocument, options);
        }
export type ScoutingMatchReportPlayersQueryHookResult = ReturnType<typeof useScoutingMatchReportPlayersQuery>;
export type ScoutingMatchReportPlayersLazyQueryHookResult = ReturnType<typeof useScoutingMatchReportPlayersLazyQuery>;
export type ScoutingMatchReportPlayersSuspenseQueryHookResult = ReturnType<typeof useScoutingMatchReportPlayersSuspenseQuery>;
export type ScoutingMatchReportPlayersQueryResult = Apollo.QueryResult<ScoutingMatchReportPlayersQuery, ScoutingMatchReportPlayersQueryVariables>;
export const ScoutingAddPlayersToWatchlistDocument = gql`
    mutation ScoutingAddPlayersToWatchlist($input: AddPlayersToWatchlistInput!) {
  addPlayersToWatchlist(input: $input) {
    ...ScoutingWatchlistBulkMembershipPayload
  }
}
    ${ScoutingWatchlistBulkMembershipPayloadFragmentDoc}`;
export type ScoutingAddPlayersToWatchlistMutationFn = Apollo.MutationFunction<ScoutingAddPlayersToWatchlistMutation, ScoutingAddPlayersToWatchlistMutationVariables>;

/**
 * __useScoutingAddPlayersToWatchlistMutation__
 *
 * To run a mutation, you first call `useScoutingAddPlayersToWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingAddPlayersToWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingAddPlayersToWatchlistMutation, { data, loading, error }] = useScoutingAddPlayersToWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingAddPlayersToWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingAddPlayersToWatchlistMutation, ScoutingAddPlayersToWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingAddPlayersToWatchlistMutation, ScoutingAddPlayersToWatchlistMutationVariables>(ScoutingAddPlayersToWatchlistDocument, options);
      }
export type ScoutingAddPlayersToWatchlistMutationHookResult = ReturnType<typeof useScoutingAddPlayersToWatchlistMutation>;
export type ScoutingAddPlayersToWatchlistMutationResult = Apollo.MutationResult<ScoutingAddPlayersToWatchlistMutation>;
export type ScoutingAddPlayersToWatchlistMutationOptions = Apollo.BaseMutationOptions<ScoutingAddPlayersToWatchlistMutation, ScoutingAddPlayersToWatchlistMutationVariables>;
export const ScoutingRemovePlayersFromWatchlistDocument = gql`
    mutation ScoutingRemovePlayersFromWatchlist($input: RemovePlayersFromWatchlistInput!) {
  removePlayersFromWatchlist(input: $input) {
    ...ScoutingWatchlistBulkMembershipPayload
  }
}
    ${ScoutingWatchlistBulkMembershipPayloadFragmentDoc}`;
export type ScoutingRemovePlayersFromWatchlistMutationFn = Apollo.MutationFunction<ScoutingRemovePlayersFromWatchlistMutation, ScoutingRemovePlayersFromWatchlistMutationVariables>;

/**
 * __useScoutingRemovePlayersFromWatchlistMutation__
 *
 * To run a mutation, you first call `useScoutingRemovePlayersFromWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingRemovePlayersFromWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingRemovePlayersFromWatchlistMutation, { data, loading, error }] = useScoutingRemovePlayersFromWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingRemovePlayersFromWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingRemovePlayersFromWatchlistMutation, ScoutingRemovePlayersFromWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingRemovePlayersFromWatchlistMutation, ScoutingRemovePlayersFromWatchlistMutationVariables>(ScoutingRemovePlayersFromWatchlistDocument, options);
      }
export type ScoutingRemovePlayersFromWatchlistMutationHookResult = ReturnType<typeof useScoutingRemovePlayersFromWatchlistMutation>;
export type ScoutingRemovePlayersFromWatchlistMutationResult = Apollo.MutationResult<ScoutingRemovePlayersFromWatchlistMutation>;
export type ScoutingRemovePlayersFromWatchlistMutationOptions = Apollo.BaseMutationOptions<ScoutingRemovePlayersFromWatchlistMutation, ScoutingRemovePlayersFromWatchlistMutationVariables>;
export const ScoutingCreateWatchlistFromSelectionDocument = gql`
    mutation ScoutingCreateWatchlistFromSelection($input: CreateWatchlistInput!) {
  createWatchlist(input: $input) {
    id
    name
    playerCount
  }
}
    `;
export type ScoutingCreateWatchlistFromSelectionMutationFn = Apollo.MutationFunction<ScoutingCreateWatchlistFromSelectionMutation, ScoutingCreateWatchlistFromSelectionMutationVariables>;

/**
 * __useScoutingCreateWatchlistFromSelectionMutation__
 *
 * To run a mutation, you first call `useScoutingCreateWatchlistFromSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingCreateWatchlistFromSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingCreateWatchlistFromSelectionMutation, { data, loading, error }] = useScoutingCreateWatchlistFromSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingCreateWatchlistFromSelectionMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingCreateWatchlistFromSelectionMutation, ScoutingCreateWatchlistFromSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingCreateWatchlistFromSelectionMutation, ScoutingCreateWatchlistFromSelectionMutationVariables>(ScoutingCreateWatchlistFromSelectionDocument, options);
      }
export type ScoutingCreateWatchlistFromSelectionMutationHookResult = ReturnType<typeof useScoutingCreateWatchlistFromSelectionMutation>;
export type ScoutingCreateWatchlistFromSelectionMutationResult = Apollo.MutationResult<ScoutingCreateWatchlistFromSelectionMutation>;
export type ScoutingCreateWatchlistFromSelectionMutationOptions = Apollo.BaseMutationOptions<ScoutingCreateWatchlistFromSelectionMutation, ScoutingCreateWatchlistFromSelectionMutationVariables>;
export const ScoutingListWatchlistPlayerIdsDocument = gql`
    query ScoutingListWatchlistPlayerIds($watchlistId: ID!, $first: Int, $after: String) {
  listWatchlistPlayers(watchlistId: $watchlistId, first: $first, after: $after) {
    edges {
      node {
        id
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useScoutingListWatchlistPlayerIdsQuery__
 *
 * To run a query within a React component, call `useScoutingListWatchlistPlayerIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListWatchlistPlayerIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListWatchlistPlayerIdsQuery({
 *   variables: {
 *      watchlistId: // value for 'watchlistId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useScoutingListWatchlistPlayerIdsQuery(baseOptions: Apollo.QueryHookOptions<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables> & ({ variables: ScoutingListWatchlistPlayerIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>(ScoutingListWatchlistPlayerIdsDocument, options);
      }
export function useScoutingListWatchlistPlayerIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>(ScoutingListWatchlistPlayerIdsDocument, options);
        }
// @ts-ignore
export function useScoutingListWatchlistPlayerIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>;
export function useScoutingListWatchlistPlayerIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListWatchlistPlayerIdsQuery | undefined, ScoutingListWatchlistPlayerIdsQueryVariables>;
export function useScoutingListWatchlistPlayerIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>(ScoutingListWatchlistPlayerIdsDocument, options);
        }
export type ScoutingListWatchlistPlayerIdsQueryHookResult = ReturnType<typeof useScoutingListWatchlistPlayerIdsQuery>;
export type ScoutingListWatchlistPlayerIdsLazyQueryHookResult = ReturnType<typeof useScoutingListWatchlistPlayerIdsLazyQuery>;
export type ScoutingListWatchlistPlayerIdsSuspenseQueryHookResult = ReturnType<typeof useScoutingListWatchlistPlayerIdsSuspenseQuery>;
export type ScoutingListWatchlistPlayerIdsQueryResult = Apollo.QueryResult<ScoutingListWatchlistPlayerIdsQuery, ScoutingListWatchlistPlayerIdsQueryVariables>;
export const ScoutingEligibleShareGroupsDocument = gql`
    query ScoutingEligibleShareGroups($entityType: ShareEntityType!, $entityId: ID!) {
  eligibleShareGroups(entityType: $entityType, entityId: $entityId) {
    ...ScoutingShareGroup
  }
}
    ${ScoutingShareGroupFragmentDoc}`;

/**
 * __useScoutingEligibleShareGroupsQuery__
 *
 * To run a query within a React component, call `useScoutingEligibleShareGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingEligibleShareGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingEligibleShareGroupsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useScoutingEligibleShareGroupsQuery(baseOptions: Apollo.QueryHookOptions<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables> & ({ variables: ScoutingEligibleShareGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>(ScoutingEligibleShareGroupsDocument, options);
      }
export function useScoutingEligibleShareGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>(ScoutingEligibleShareGroupsDocument, options);
        }
// @ts-ignore
export function useScoutingEligibleShareGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>;
export function useScoutingEligibleShareGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingEligibleShareGroupsQuery | undefined, ScoutingEligibleShareGroupsQueryVariables>;
export function useScoutingEligibleShareGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>(ScoutingEligibleShareGroupsDocument, options);
        }
export type ScoutingEligibleShareGroupsQueryHookResult = ReturnType<typeof useScoutingEligibleShareGroupsQuery>;
export type ScoutingEligibleShareGroupsLazyQueryHookResult = ReturnType<typeof useScoutingEligibleShareGroupsLazyQuery>;
export type ScoutingEligibleShareGroupsSuspenseQueryHookResult = ReturnType<typeof useScoutingEligibleShareGroupsSuspenseQuery>;
export type ScoutingEligibleShareGroupsQueryResult = Apollo.QueryResult<ScoutingEligibleShareGroupsQuery, ScoutingEligibleShareGroupsQueryVariables>;
export const ScoutingListGroupGrantsDocument = gql`
    query ScoutingListGroupGrants($entityType: ShareEntityType!, $entityId: ID!) {
  listGroupGrants(entityType: $entityType, entityId: $entityId) {
    ...ScoutingGroupGrant
  }
}
    ${ScoutingGroupGrantFragmentDoc}`;

/**
 * __useScoutingListGroupGrantsQuery__
 *
 * To run a query within a React component, call `useScoutingListGroupGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoutingListGroupGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoutingListGroupGrantsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useScoutingListGroupGrantsQuery(baseOptions: Apollo.QueryHookOptions<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables> & ({ variables: ScoutingListGroupGrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>(ScoutingListGroupGrantsDocument, options);
      }
export function useScoutingListGroupGrantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>(ScoutingListGroupGrantsDocument, options);
        }
// @ts-ignore
export function useScoutingListGroupGrantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>;
export function useScoutingListGroupGrantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>): Apollo.UseSuspenseQueryResult<ScoutingListGroupGrantsQuery | undefined, ScoutingListGroupGrantsQueryVariables>;
export function useScoutingListGroupGrantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>(ScoutingListGroupGrantsDocument, options);
        }
export type ScoutingListGroupGrantsQueryHookResult = ReturnType<typeof useScoutingListGroupGrantsQuery>;
export type ScoutingListGroupGrantsLazyQueryHookResult = ReturnType<typeof useScoutingListGroupGrantsLazyQuery>;
export type ScoutingListGroupGrantsSuspenseQueryHookResult = ReturnType<typeof useScoutingListGroupGrantsSuspenseQuery>;
export type ScoutingListGroupGrantsQueryResult = Apollo.QueryResult<ScoutingListGroupGrantsQuery, ScoutingListGroupGrantsQueryVariables>;
export const ScoutingCreateGroupGrantDocument = gql`
    mutation ScoutingCreateGroupGrant($input: CreateGroupGrantInput!) {
  createGroupGrant(input: $input) {
    ...ScoutingGroupGrant
  }
}
    ${ScoutingGroupGrantFragmentDoc}`;
export type ScoutingCreateGroupGrantMutationFn = Apollo.MutationFunction<ScoutingCreateGroupGrantMutation, ScoutingCreateGroupGrantMutationVariables>;

/**
 * __useScoutingCreateGroupGrantMutation__
 *
 * To run a mutation, you first call `useScoutingCreateGroupGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingCreateGroupGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingCreateGroupGrantMutation, { data, loading, error }] = useScoutingCreateGroupGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingCreateGroupGrantMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingCreateGroupGrantMutation, ScoutingCreateGroupGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingCreateGroupGrantMutation, ScoutingCreateGroupGrantMutationVariables>(ScoutingCreateGroupGrantDocument, options);
      }
export type ScoutingCreateGroupGrantMutationHookResult = ReturnType<typeof useScoutingCreateGroupGrantMutation>;
export type ScoutingCreateGroupGrantMutationResult = Apollo.MutationResult<ScoutingCreateGroupGrantMutation>;
export type ScoutingCreateGroupGrantMutationOptions = Apollo.BaseMutationOptions<ScoutingCreateGroupGrantMutation, ScoutingCreateGroupGrantMutationVariables>;
export const ScoutingUpdateGroupGrantRoleDocument = gql`
    mutation ScoutingUpdateGroupGrantRole($input: UpdateGroupGrantRoleInput!) {
  updateGroupGrantRole(input: $input) {
    ...ScoutingGroupGrant
  }
}
    ${ScoutingGroupGrantFragmentDoc}`;
export type ScoutingUpdateGroupGrantRoleMutationFn = Apollo.MutationFunction<ScoutingUpdateGroupGrantRoleMutation, ScoutingUpdateGroupGrantRoleMutationVariables>;

/**
 * __useScoutingUpdateGroupGrantRoleMutation__
 *
 * To run a mutation, you first call `useScoutingUpdateGroupGrantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingUpdateGroupGrantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingUpdateGroupGrantRoleMutation, { data, loading, error }] = useScoutingUpdateGroupGrantRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingUpdateGroupGrantRoleMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingUpdateGroupGrantRoleMutation, ScoutingUpdateGroupGrantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingUpdateGroupGrantRoleMutation, ScoutingUpdateGroupGrantRoleMutationVariables>(ScoutingUpdateGroupGrantRoleDocument, options);
      }
export type ScoutingUpdateGroupGrantRoleMutationHookResult = ReturnType<typeof useScoutingUpdateGroupGrantRoleMutation>;
export type ScoutingUpdateGroupGrantRoleMutationResult = Apollo.MutationResult<ScoutingUpdateGroupGrantRoleMutation>;
export type ScoutingUpdateGroupGrantRoleMutationOptions = Apollo.BaseMutationOptions<ScoutingUpdateGroupGrantRoleMutation, ScoutingUpdateGroupGrantRoleMutationVariables>;
export const ScoutingDeleteGroupGrantDocument = gql`
    mutation ScoutingDeleteGroupGrant($input: DeleteGroupGrantInput!) {
  deleteGroupGrant(input: $input) {
    id
    removed
  }
}
    `;
export type ScoutingDeleteGroupGrantMutationFn = Apollo.MutationFunction<ScoutingDeleteGroupGrantMutation, ScoutingDeleteGroupGrantMutationVariables>;

/**
 * __useScoutingDeleteGroupGrantMutation__
 *
 * To run a mutation, you first call `useScoutingDeleteGroupGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScoutingDeleteGroupGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scoutingDeleteGroupGrantMutation, { data, loading, error }] = useScoutingDeleteGroupGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScoutingDeleteGroupGrantMutation(baseOptions?: Apollo.MutationHookOptions<ScoutingDeleteGroupGrantMutation, ScoutingDeleteGroupGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScoutingDeleteGroupGrantMutation, ScoutingDeleteGroupGrantMutationVariables>(ScoutingDeleteGroupGrantDocument, options);
      }
export type ScoutingDeleteGroupGrantMutationHookResult = ReturnType<typeof useScoutingDeleteGroupGrantMutation>;
export type ScoutingDeleteGroupGrantMutationResult = Apollo.MutationResult<ScoutingDeleteGroupGrantMutation>;
export type ScoutingDeleteGroupGrantMutationOptions = Apollo.BaseMutationOptions<ScoutingDeleteGroupGrantMutation, ScoutingDeleteGroupGrantMutationVariables>;
export const SimilarPlayersListSimilarPlayersDocument = gql`
    query SimilarPlayersListSimilarPlayers($playerId: ID!, $first: Int, $after: String, $filter: SimilarPlayerFilterInput) {
  listSimilarPlayers(
    playerId: $playerId
    first: $first
    after: $after
    filter: $filter
  ) {
    ...SimilarPlayersSimilarPlayerConnection
  }
}
    ${SimilarPlayersSimilarPlayerConnectionFragmentDoc}`;

/**
 * __useSimilarPlayersListSimilarPlayersQuery__
 *
 * To run a query within a React component, call `useSimilarPlayersListSimilarPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarPlayersListSimilarPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarPlayersListSimilarPlayersQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSimilarPlayersListSimilarPlayersQuery(baseOptions: Apollo.QueryHookOptions<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables> & ({ variables: SimilarPlayersListSimilarPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>(SimilarPlayersListSimilarPlayersDocument, options);
      }
export function useSimilarPlayersListSimilarPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>(SimilarPlayersListSimilarPlayersDocument, options);
        }
// @ts-ignore
export function useSimilarPlayersListSimilarPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>;
export function useSimilarPlayersListSimilarPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarPlayersListSimilarPlayersQuery | undefined, SimilarPlayersListSimilarPlayersQueryVariables>;
export function useSimilarPlayersListSimilarPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>(SimilarPlayersListSimilarPlayersDocument, options);
        }
export type SimilarPlayersListSimilarPlayersQueryHookResult = ReturnType<typeof useSimilarPlayersListSimilarPlayersQuery>;
export type SimilarPlayersListSimilarPlayersLazyQueryHookResult = ReturnType<typeof useSimilarPlayersListSimilarPlayersLazyQuery>;
export type SimilarPlayersListSimilarPlayersSuspenseQueryHookResult = ReturnType<typeof useSimilarPlayersListSimilarPlayersSuspenseQuery>;
export type SimilarPlayersListSimilarPlayersQueryResult = Apollo.QueryResult<SimilarPlayersListSimilarPlayersQuery, SimilarPlayersListSimilarPlayersQueryVariables>;
export const SquadPlanningGetSquadPlayersByPositionDocument = gql`
    query SquadPlanningGetSquadPlayersByPosition($scenarioId: ID) {
  getSquadPlayersByPosition(scenarioId: $scenarioId) {
    firstTeam {
      id
      name
      firstName
      knownName
      lastName
      age
      gpr
      gpv
      gpvMin
      gpvMax
      minutes
      wage
      amortisationAnnual
      netBookValue
      estVal
      contractExpiry
      status
      position
      positions
      nationalityName
      isManual
      teamName
      transitionType
    }
    academy {
      id
      name
      firstName
      knownName
      lastName
      age
      gpr
      gpv
      gpvMin
      gpvMax
      minutes
      wage
      amortisationAnnual
      netBookValue
      estVal
      contractExpiry
      status
      position
      positions
      nationalityName
      isManual
      teamName
      readinessTag
      transitionType
    }
    targets {
      id
      name
      age
      gpr
      gpv
      gpvMin
      gpvMax
      minutes
      wage
      amortisationAnnual
      netBookValue
      estVal
      contractExpiry
      status
      position
      positions
      nationalityName
      isManual
      teamName
      sourceWatchlists
      transitionType
    }
  }
}
    `;

/**
 * __useSquadPlanningGetSquadPlayersByPositionQuery__
 *
 * To run a query within a React component, call `useSquadPlanningGetSquadPlayersByPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningGetSquadPlayersByPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningGetSquadPlayersByPositionQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningGetSquadPlayersByPositionQuery(baseOptions?: Apollo.QueryHookOptions<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>(SquadPlanningGetSquadPlayersByPositionDocument, options);
      }
export function useSquadPlanningGetSquadPlayersByPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>(SquadPlanningGetSquadPlayersByPositionDocument, options);
        }
// @ts-ignore
export function useSquadPlanningGetSquadPlayersByPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>;
export function useSquadPlanningGetSquadPlayersByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetSquadPlayersByPositionQuery | undefined, SquadPlanningGetSquadPlayersByPositionQueryVariables>;
export function useSquadPlanningGetSquadPlayersByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>(SquadPlanningGetSquadPlayersByPositionDocument, options);
        }
export type SquadPlanningGetSquadPlayersByPositionQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadPlayersByPositionQuery>;
export type SquadPlanningGetSquadPlayersByPositionLazyQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadPlayersByPositionLazyQuery>;
export type SquadPlanningGetSquadPlayersByPositionSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadPlayersByPositionSuspenseQuery>;
export type SquadPlanningGetSquadPlayersByPositionQueryResult = Apollo.QueryResult<SquadPlanningGetSquadPlayersByPositionQuery, SquadPlanningGetSquadPlayersByPositionQueryVariables>;
export const SquadPlanningGetSquadDepthByPositionDocument = gql`
    query SquadPlanningGetSquadDepthByPosition($scenarioId: ID) {
  getSquadDepthByPosition(scenarioId: $scenarioId) {
    formation
    positions {
      positionId
      name
      playerCount
      avgGpr
    }
  }
}
    `;

/**
 * __useSquadPlanningGetSquadDepthByPositionQuery__
 *
 * To run a query within a React component, call `useSquadPlanningGetSquadDepthByPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningGetSquadDepthByPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningGetSquadDepthByPositionQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningGetSquadDepthByPositionQuery(baseOptions?: Apollo.QueryHookOptions<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>(SquadPlanningGetSquadDepthByPositionDocument, options);
      }
export function useSquadPlanningGetSquadDepthByPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>(SquadPlanningGetSquadDepthByPositionDocument, options);
        }
// @ts-ignore
export function useSquadPlanningGetSquadDepthByPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>;
export function useSquadPlanningGetSquadDepthByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetSquadDepthByPositionQuery | undefined, SquadPlanningGetSquadDepthByPositionQueryVariables>;
export function useSquadPlanningGetSquadDepthByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>(SquadPlanningGetSquadDepthByPositionDocument, options);
        }
export type SquadPlanningGetSquadDepthByPositionQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadDepthByPositionQuery>;
export type SquadPlanningGetSquadDepthByPositionLazyQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadDepthByPositionLazyQuery>;
export type SquadPlanningGetSquadDepthByPositionSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadDepthByPositionSuspenseQuery>;
export type SquadPlanningGetSquadDepthByPositionQueryResult = Apollo.QueryResult<SquadPlanningGetSquadDepthByPositionQuery, SquadPlanningGetSquadDepthByPositionQueryVariables>;
export const SquadPlanningGetSquadKpIsDocument = gql`
    query SquadPlanningGetSquadKPIs($scenarioId: ID) {
  getSquadKPIs(scenarioId: $scenarioId) {
    totalPlayers {
      firstTeam
      academy
    }
    totalWageBill
    contractsExpiring12Mo
    unavailableCount
    wageCompleteness
    scenarioImpact {
      acquisitionCost
      capitalGains
      playerDelta
      firstTeamDelta
      academyDelta
      wageImpact
      completeness {
        complete
        notProvidedCount
        notProvided {
          playerId
          playerName
          transitionType
          missing
        }
      }
    }
  }
}
    `;

/**
 * __useSquadPlanningGetSquadKpIsQuery__
 *
 * To run a query within a React component, call `useSquadPlanningGetSquadKpIsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningGetSquadKpIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningGetSquadKpIsQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningGetSquadKpIsQuery(baseOptions?: Apollo.QueryHookOptions<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>(SquadPlanningGetSquadKpIsDocument, options);
      }
export function useSquadPlanningGetSquadKpIsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>(SquadPlanningGetSquadKpIsDocument, options);
        }
// @ts-ignore
export function useSquadPlanningGetSquadKpIsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>;
export function useSquadPlanningGetSquadKpIsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetSquadKpIsQuery | undefined, SquadPlanningGetSquadKpIsQueryVariables>;
export function useSquadPlanningGetSquadKpIsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>(SquadPlanningGetSquadKpIsDocument, options);
        }
export type SquadPlanningGetSquadKpIsQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadKpIsQuery>;
export type SquadPlanningGetSquadKpIsLazyQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadKpIsLazyQuery>;
export type SquadPlanningGetSquadKpIsSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningGetSquadKpIsSuspenseQuery>;
export type SquadPlanningGetSquadKpIsQueryResult = Apollo.QueryResult<SquadPlanningGetSquadKpIsQuery, SquadPlanningGetSquadKpIsQueryVariables>;
export const SquadPlanningGetScenarioDocument = gql`
    query SquadPlanningGetScenario($scenarioId: ID!) {
  getScenario(scenarioId: $scenarioId) {
    id
    name
    createdAt
    updatedAt
    ownerUserId
    isLegacyNoOwner
    revision
    actions {
      playerId
      playerName
      transitionType
      financialDetails {
        salePrice
        loanFee
        signingFee
        wage
        durationMonths
        signingBonus
        agentFee
        coveredSharePercent
      }
      externalPlayerData {
        name
        teamName
        positions
        age
        gpr
        nationalityName
      }
    }
  }
}
    `;

/**
 * __useSquadPlanningGetScenarioQuery__
 *
 * To run a query within a React component, call `useSquadPlanningGetScenarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningGetScenarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningGetScenarioQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningGetScenarioQuery(baseOptions: Apollo.QueryHookOptions<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables> & ({ variables: SquadPlanningGetScenarioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>(SquadPlanningGetScenarioDocument, options);
      }
export function useSquadPlanningGetScenarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>(SquadPlanningGetScenarioDocument, options);
        }
// @ts-ignore
export function useSquadPlanningGetScenarioSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>;
export function useSquadPlanningGetScenarioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetScenarioQuery | undefined, SquadPlanningGetScenarioQueryVariables>;
export function useSquadPlanningGetScenarioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>(SquadPlanningGetScenarioDocument, options);
        }
export type SquadPlanningGetScenarioQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioQuery>;
export type SquadPlanningGetScenarioLazyQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioLazyQuery>;
export type SquadPlanningGetScenarioSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioSuspenseQuery>;
export type SquadPlanningGetScenarioQueryResult = Apollo.QueryResult<SquadPlanningGetScenarioQuery, SquadPlanningGetScenarioQueryVariables>;
export const SquadPlanningListScenariosDocument = gql`
    query SquadPlanningListScenarios {
  listScenarios {
    id
    name
    createdAt
    updatedAt
    ownerUserId
    isLegacyNoOwner
    revision
  }
}
    `;

/**
 * __useSquadPlanningListScenariosQuery__
 *
 * To run a query within a React component, call `useSquadPlanningListScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningListScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningListScenariosQuery({
 *   variables: {
 *   },
 * });
 */
export function useSquadPlanningListScenariosQuery(baseOptions?: Apollo.QueryHookOptions<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>(SquadPlanningListScenariosDocument, options);
      }
export function useSquadPlanningListScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>(SquadPlanningListScenariosDocument, options);
        }
// @ts-ignore
export function useSquadPlanningListScenariosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>;
export function useSquadPlanningListScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningListScenariosQuery | undefined, SquadPlanningListScenariosQueryVariables>;
export function useSquadPlanningListScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>(SquadPlanningListScenariosDocument, options);
        }
export type SquadPlanningListScenariosQueryHookResult = ReturnType<typeof useSquadPlanningListScenariosQuery>;
export type SquadPlanningListScenariosLazyQueryHookResult = ReturnType<typeof useSquadPlanningListScenariosLazyQuery>;
export type SquadPlanningListScenariosSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningListScenariosSuspenseQuery>;
export type SquadPlanningListScenariosQueryResult = Apollo.QueryResult<SquadPlanningListScenariosQuery, SquadPlanningListScenariosQueryVariables>;
export const SquadPlanningCreateScenarioDocument = gql`
    mutation SquadPlanningCreateScenario($input: CreateScenarioInput!) {
  createScenario(input: $input) {
    id
    name
    createdAt
    updatedAt
    ownerUserId
    isLegacyNoOwner
    revision
  }
}
    `;
export type SquadPlanningCreateScenarioMutationFn = Apollo.MutationFunction<SquadPlanningCreateScenarioMutation, SquadPlanningCreateScenarioMutationVariables>;

/**
 * __useSquadPlanningCreateScenarioMutation__
 *
 * To run a mutation, you first call `useSquadPlanningCreateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningCreateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningCreateScenarioMutation, { data, loading, error }] = useSquadPlanningCreateScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningCreateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningCreateScenarioMutation, SquadPlanningCreateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningCreateScenarioMutation, SquadPlanningCreateScenarioMutationVariables>(SquadPlanningCreateScenarioDocument, options);
      }
export type SquadPlanningCreateScenarioMutationHookResult = ReturnType<typeof useSquadPlanningCreateScenarioMutation>;
export type SquadPlanningCreateScenarioMutationResult = Apollo.MutationResult<SquadPlanningCreateScenarioMutation>;
export type SquadPlanningCreateScenarioMutationOptions = Apollo.BaseMutationOptions<SquadPlanningCreateScenarioMutation, SquadPlanningCreateScenarioMutationVariables>;
export const SquadPlanningClaimScenarioOwnershipDocument = gql`
    mutation SquadPlanningClaimScenarioOwnership($input: ClaimScenarioOwnershipInput!) {
  claimScenarioOwnership(input: $input) {
    id
    name
    createdAt
    updatedAt
    ownerUserId
    isLegacyNoOwner
    revision
  }
}
    `;
export type SquadPlanningClaimScenarioOwnershipMutationFn = Apollo.MutationFunction<SquadPlanningClaimScenarioOwnershipMutation, SquadPlanningClaimScenarioOwnershipMutationVariables>;

/**
 * __useSquadPlanningClaimScenarioOwnershipMutation__
 *
 * To run a mutation, you first call `useSquadPlanningClaimScenarioOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningClaimScenarioOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningClaimScenarioOwnershipMutation, { data, loading, error }] = useSquadPlanningClaimScenarioOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningClaimScenarioOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningClaimScenarioOwnershipMutation, SquadPlanningClaimScenarioOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningClaimScenarioOwnershipMutation, SquadPlanningClaimScenarioOwnershipMutationVariables>(SquadPlanningClaimScenarioOwnershipDocument, options);
      }
export type SquadPlanningClaimScenarioOwnershipMutationHookResult = ReturnType<typeof useSquadPlanningClaimScenarioOwnershipMutation>;
export type SquadPlanningClaimScenarioOwnershipMutationResult = Apollo.MutationResult<SquadPlanningClaimScenarioOwnershipMutation>;
export type SquadPlanningClaimScenarioOwnershipMutationOptions = Apollo.BaseMutationOptions<SquadPlanningClaimScenarioOwnershipMutation, SquadPlanningClaimScenarioOwnershipMutationVariables>;
export const SquadPlanningRemoveScenarioActionDocument = gql`
    mutation SquadPlanningRemoveScenarioAction($input: RemoveScenarioActionInput!) {
  removeScenarioAction(input: $input) {
    scenario {
      id
      revision
      updatedAt
    }
    removed
    removedTransitionType
    wasExternal
  }
}
    `;
export type SquadPlanningRemoveScenarioActionMutationFn = Apollo.MutationFunction<SquadPlanningRemoveScenarioActionMutation, SquadPlanningRemoveScenarioActionMutationVariables>;

/**
 * __useSquadPlanningRemoveScenarioActionMutation__
 *
 * To run a mutation, you first call `useSquadPlanningRemoveScenarioActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningRemoveScenarioActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningRemoveScenarioActionMutation, { data, loading, error }] = useSquadPlanningRemoveScenarioActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningRemoveScenarioActionMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningRemoveScenarioActionMutation, SquadPlanningRemoveScenarioActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningRemoveScenarioActionMutation, SquadPlanningRemoveScenarioActionMutationVariables>(SquadPlanningRemoveScenarioActionDocument, options);
      }
export type SquadPlanningRemoveScenarioActionMutationHookResult = ReturnType<typeof useSquadPlanningRemoveScenarioActionMutation>;
export type SquadPlanningRemoveScenarioActionMutationResult = Apollo.MutationResult<SquadPlanningRemoveScenarioActionMutation>;
export type SquadPlanningRemoveScenarioActionMutationOptions = Apollo.BaseMutationOptions<SquadPlanningRemoveScenarioActionMutation, SquadPlanningRemoveScenarioActionMutationVariables>;
export const SquadPlanningUpdateScenarioDocument = gql`
    mutation SquadPlanningUpdateScenario($input: UpdateScenarioInput!) {
  updateScenario(input: $input) {
    id
    name
    updatedAt
  }
}
    `;
export type SquadPlanningUpdateScenarioMutationFn = Apollo.MutationFunction<SquadPlanningUpdateScenarioMutation, SquadPlanningUpdateScenarioMutationVariables>;

/**
 * __useSquadPlanningUpdateScenarioMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpdateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpdateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpdateScenarioMutation, { data, loading, error }] = useSquadPlanningUpdateScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpdateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpdateScenarioMutation, SquadPlanningUpdateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpdateScenarioMutation, SquadPlanningUpdateScenarioMutationVariables>(SquadPlanningUpdateScenarioDocument, options);
      }
export type SquadPlanningUpdateScenarioMutationHookResult = ReturnType<typeof useSquadPlanningUpdateScenarioMutation>;
export type SquadPlanningUpdateScenarioMutationResult = Apollo.MutationResult<SquadPlanningUpdateScenarioMutation>;
export type SquadPlanningUpdateScenarioMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpdateScenarioMutation, SquadPlanningUpdateScenarioMutationVariables>;
export const SquadPlanningDeleteScenarioDocument = gql`
    mutation SquadPlanningDeleteScenario($scenarioId: ID!) {
  deleteScenario(scenarioId: $scenarioId) {
    success
  }
}
    `;
export type SquadPlanningDeleteScenarioMutationFn = Apollo.MutationFunction<SquadPlanningDeleteScenarioMutation, SquadPlanningDeleteScenarioMutationVariables>;

/**
 * __useSquadPlanningDeleteScenarioMutation__
 *
 * To run a mutation, you first call `useSquadPlanningDeleteScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningDeleteScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningDeleteScenarioMutation, { data, loading, error }] = useSquadPlanningDeleteScenarioMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningDeleteScenarioMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningDeleteScenarioMutation, SquadPlanningDeleteScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningDeleteScenarioMutation, SquadPlanningDeleteScenarioMutationVariables>(SquadPlanningDeleteScenarioDocument, options);
      }
export type SquadPlanningDeleteScenarioMutationHookResult = ReturnType<typeof useSquadPlanningDeleteScenarioMutation>;
export type SquadPlanningDeleteScenarioMutationResult = Apollo.MutationResult<SquadPlanningDeleteScenarioMutation>;
export type SquadPlanningDeleteScenarioMutationOptions = Apollo.BaseMutationOptions<SquadPlanningDeleteScenarioMutation, SquadPlanningDeleteScenarioMutationVariables>;
export const SquadPlanningSetPlayerAcademyStatusDocument = gql`
    mutation SquadPlanningSetPlayerAcademyStatus($input: SetPlayerAcademyStatusInput!) {
  setPlayerAcademyStatus(input: $input) {
    id
    isAcademy
    isManual
  }
}
    `;
export type SquadPlanningSetPlayerAcademyStatusMutationFn = Apollo.MutationFunction<SquadPlanningSetPlayerAcademyStatusMutation, SquadPlanningSetPlayerAcademyStatusMutationVariables>;

/**
 * __useSquadPlanningSetPlayerAcademyStatusMutation__
 *
 * To run a mutation, you first call `useSquadPlanningSetPlayerAcademyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningSetPlayerAcademyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningSetPlayerAcademyStatusMutation, { data, loading, error }] = useSquadPlanningSetPlayerAcademyStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningSetPlayerAcademyStatusMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningSetPlayerAcademyStatusMutation, SquadPlanningSetPlayerAcademyStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningSetPlayerAcademyStatusMutation, SquadPlanningSetPlayerAcademyStatusMutationVariables>(SquadPlanningSetPlayerAcademyStatusDocument, options);
      }
export type SquadPlanningSetPlayerAcademyStatusMutationHookResult = ReturnType<typeof useSquadPlanningSetPlayerAcademyStatusMutation>;
export type SquadPlanningSetPlayerAcademyStatusMutationResult = Apollo.MutationResult<SquadPlanningSetPlayerAcademyStatusMutation>;
export type SquadPlanningSetPlayerAcademyStatusMutationOptions = Apollo.BaseMutationOptions<SquadPlanningSetPlayerAcademyStatusMutation, SquadPlanningSetPlayerAcademyStatusMutationVariables>;
export const SquadPlanningUpsertOrganizationPlayerDataDocument = gql`
    mutation SquadPlanningUpsertOrganizationPlayerData($input: UpsertOrganizationPlayerDataInput!) {
  upsertOrganizationPlayerData(input: $input) {
    id
    grossAnnualSalary
    estValuation
    readinessTag
  }
}
    `;
export type SquadPlanningUpsertOrganizationPlayerDataMutationFn = Apollo.MutationFunction<SquadPlanningUpsertOrganizationPlayerDataMutation, SquadPlanningUpsertOrganizationPlayerDataMutationVariables>;

/**
 * __useSquadPlanningUpsertOrganizationPlayerDataMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpsertOrganizationPlayerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpsertOrganizationPlayerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpsertOrganizationPlayerDataMutation, { data, loading, error }] = useSquadPlanningUpsertOrganizationPlayerDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpsertOrganizationPlayerDataMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpsertOrganizationPlayerDataMutation, SquadPlanningUpsertOrganizationPlayerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpsertOrganizationPlayerDataMutation, SquadPlanningUpsertOrganizationPlayerDataMutationVariables>(SquadPlanningUpsertOrganizationPlayerDataDocument, options);
      }
export type SquadPlanningUpsertOrganizationPlayerDataMutationHookResult = ReturnType<typeof useSquadPlanningUpsertOrganizationPlayerDataMutation>;
export type SquadPlanningUpsertOrganizationPlayerDataMutationResult = Apollo.MutationResult<SquadPlanningUpsertOrganizationPlayerDataMutation>;
export type SquadPlanningUpsertOrganizationPlayerDataMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpsertOrganizationPlayerDataMutation, SquadPlanningUpsertOrganizationPlayerDataMutationVariables>;
export const SquadPlanningListScenarioAccessDocument = gql`
    query SquadPlanningListScenarioAccess {
  listScenarios {
    ...SquadPlanningScenarioAccess
  }
}
    ${SquadPlanningScenarioAccessFragmentDoc}`;

/**
 * __useSquadPlanningListScenarioAccessQuery__
 *
 * To run a query within a React component, call `useSquadPlanningListScenarioAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningListScenarioAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningListScenarioAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useSquadPlanningListScenarioAccessQuery(baseOptions?: Apollo.QueryHookOptions<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>(SquadPlanningListScenarioAccessDocument, options);
      }
export function useSquadPlanningListScenarioAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>(SquadPlanningListScenarioAccessDocument, options);
        }
// @ts-ignore
export function useSquadPlanningListScenarioAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>;
export function useSquadPlanningListScenarioAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningListScenarioAccessQuery | undefined, SquadPlanningListScenarioAccessQueryVariables>;
export function useSquadPlanningListScenarioAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>(SquadPlanningListScenarioAccessDocument, options);
        }
export type SquadPlanningListScenarioAccessQueryHookResult = ReturnType<typeof useSquadPlanningListScenarioAccessQuery>;
export type SquadPlanningListScenarioAccessLazyQueryHookResult = ReturnType<typeof useSquadPlanningListScenarioAccessLazyQuery>;
export type SquadPlanningListScenarioAccessSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningListScenarioAccessSuspenseQuery>;
export type SquadPlanningListScenarioAccessQueryResult = Apollo.QueryResult<SquadPlanningListScenarioAccessQuery, SquadPlanningListScenarioAccessQueryVariables>;
export const SquadPlanningGetScenarioGrantsDocument = gql`
    query SquadPlanningGetScenarioGrants($scenarioId: ID!) {
  getScenario(scenarioId: $scenarioId) {
    id
    revision
    financialsVisible
    myRole
    canManageSharing
    grants {
      ...SquadPlanningUserScenario
    }
  }
}
    ${SquadPlanningUserScenarioFragmentDoc}`;

/**
 * __useSquadPlanningGetScenarioGrantsQuery__
 *
 * To run a query within a React component, call `useSquadPlanningGetScenarioGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningGetScenarioGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningGetScenarioGrantsQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningGetScenarioGrantsQuery(baseOptions: Apollo.QueryHookOptions<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables> & ({ variables: SquadPlanningGetScenarioGrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>(SquadPlanningGetScenarioGrantsDocument, options);
      }
export function useSquadPlanningGetScenarioGrantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>(SquadPlanningGetScenarioGrantsDocument, options);
        }
// @ts-ignore
export function useSquadPlanningGetScenarioGrantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>;
export function useSquadPlanningGetScenarioGrantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetScenarioGrantsQuery | undefined, SquadPlanningGetScenarioGrantsQueryVariables>;
export function useSquadPlanningGetScenarioGrantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>(SquadPlanningGetScenarioGrantsDocument, options);
        }
export type SquadPlanningGetScenarioGrantsQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioGrantsQuery>;
export type SquadPlanningGetScenarioGrantsLazyQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioGrantsLazyQuery>;
export type SquadPlanningGetScenarioGrantsSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioGrantsSuspenseQuery>;
export type SquadPlanningGetScenarioGrantsQueryResult = Apollo.QueryResult<SquadPlanningGetScenarioGrantsQuery, SquadPlanningGetScenarioGrantsQueryVariables>;
export const SquadPlanningListOrganizationUsersForSharingDocument = gql`
    query SquadPlanningListOrganizationUsersForSharing($first: Int, $after: String) {
  listMyOrganizationsOrganizationUsers(first: $first, after: $after) {
    edges {
      node {
        id
        role {
          id
          name
        }
        user {
          ...SquadPlanningShareUser
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${SquadPlanningShareUserFragmentDoc}`;

/**
 * __useSquadPlanningListOrganizationUsersForSharingQuery__
 *
 * To run a query within a React component, call `useSquadPlanningListOrganizationUsersForSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningListOrganizationUsersForSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningListOrganizationUsersForSharingQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSquadPlanningListOrganizationUsersForSharingQuery(baseOptions?: Apollo.QueryHookOptions<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>(SquadPlanningListOrganizationUsersForSharingDocument, options);
      }
export function useSquadPlanningListOrganizationUsersForSharingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>(SquadPlanningListOrganizationUsersForSharingDocument, options);
        }
// @ts-ignore
export function useSquadPlanningListOrganizationUsersForSharingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>;
export function useSquadPlanningListOrganizationUsersForSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningListOrganizationUsersForSharingQuery | undefined, SquadPlanningListOrganizationUsersForSharingQueryVariables>;
export function useSquadPlanningListOrganizationUsersForSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>(SquadPlanningListOrganizationUsersForSharingDocument, options);
        }
export type SquadPlanningListOrganizationUsersForSharingQueryHookResult = ReturnType<typeof useSquadPlanningListOrganizationUsersForSharingQuery>;
export type SquadPlanningListOrganizationUsersForSharingLazyQueryHookResult = ReturnType<typeof useSquadPlanningListOrganizationUsersForSharingLazyQuery>;
export type SquadPlanningListOrganizationUsersForSharingSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningListOrganizationUsersForSharingSuspenseQuery>;
export type SquadPlanningListOrganizationUsersForSharingQueryResult = Apollo.QueryResult<SquadPlanningListOrganizationUsersForSharingQuery, SquadPlanningListOrganizationUsersForSharingQueryVariables>;
export const SquadPlanningCreateUserScenarioDocument = gql`
    mutation SquadPlanningCreateUserScenario($input: CreateUserScenarioInput!) {
  createUserScenario(input: $input) {
    ...SquadPlanningUserScenario
  }
}
    ${SquadPlanningUserScenarioFragmentDoc}`;
export type SquadPlanningCreateUserScenarioMutationFn = Apollo.MutationFunction<SquadPlanningCreateUserScenarioMutation, SquadPlanningCreateUserScenarioMutationVariables>;

/**
 * __useSquadPlanningCreateUserScenarioMutation__
 *
 * To run a mutation, you first call `useSquadPlanningCreateUserScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningCreateUserScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningCreateUserScenarioMutation, { data, loading, error }] = useSquadPlanningCreateUserScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningCreateUserScenarioMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningCreateUserScenarioMutation, SquadPlanningCreateUserScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningCreateUserScenarioMutation, SquadPlanningCreateUserScenarioMutationVariables>(SquadPlanningCreateUserScenarioDocument, options);
      }
export type SquadPlanningCreateUserScenarioMutationHookResult = ReturnType<typeof useSquadPlanningCreateUserScenarioMutation>;
export type SquadPlanningCreateUserScenarioMutationResult = Apollo.MutationResult<SquadPlanningCreateUserScenarioMutation>;
export type SquadPlanningCreateUserScenarioMutationOptions = Apollo.BaseMutationOptions<SquadPlanningCreateUserScenarioMutation, SquadPlanningCreateUserScenarioMutationVariables>;
export const SquadPlanningUpdateUserScenarioRoleDocument = gql`
    mutation SquadPlanningUpdateUserScenarioRole($input: UpdateUserScenarioRoleInput!) {
  updateUserScenarioRole(input: $input) {
    ...SquadPlanningUserScenario
  }
}
    ${SquadPlanningUserScenarioFragmentDoc}`;
export type SquadPlanningUpdateUserScenarioRoleMutationFn = Apollo.MutationFunction<SquadPlanningUpdateUserScenarioRoleMutation, SquadPlanningUpdateUserScenarioRoleMutationVariables>;

/**
 * __useSquadPlanningUpdateUserScenarioRoleMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpdateUserScenarioRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpdateUserScenarioRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpdateUserScenarioRoleMutation, { data, loading, error }] = useSquadPlanningUpdateUserScenarioRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpdateUserScenarioRoleMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpdateUserScenarioRoleMutation, SquadPlanningUpdateUserScenarioRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpdateUserScenarioRoleMutation, SquadPlanningUpdateUserScenarioRoleMutationVariables>(SquadPlanningUpdateUserScenarioRoleDocument, options);
      }
export type SquadPlanningUpdateUserScenarioRoleMutationHookResult = ReturnType<typeof useSquadPlanningUpdateUserScenarioRoleMutation>;
export type SquadPlanningUpdateUserScenarioRoleMutationResult = Apollo.MutationResult<SquadPlanningUpdateUserScenarioRoleMutation>;
export type SquadPlanningUpdateUserScenarioRoleMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpdateUserScenarioRoleMutation, SquadPlanningUpdateUserScenarioRoleMutationVariables>;
export const SquadPlanningDeleteUserScenarioDocument = gql`
    mutation SquadPlanningDeleteUserScenario($input: DeleteUserScenarioInput!) {
  deleteUserScenario(input: $input) {
    id
    removed
  }
}
    `;
export type SquadPlanningDeleteUserScenarioMutationFn = Apollo.MutationFunction<SquadPlanningDeleteUserScenarioMutation, SquadPlanningDeleteUserScenarioMutationVariables>;

/**
 * __useSquadPlanningDeleteUserScenarioMutation__
 *
 * To run a mutation, you first call `useSquadPlanningDeleteUserScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningDeleteUserScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningDeleteUserScenarioMutation, { data, loading, error }] = useSquadPlanningDeleteUserScenarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningDeleteUserScenarioMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningDeleteUserScenarioMutation, SquadPlanningDeleteUserScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningDeleteUserScenarioMutation, SquadPlanningDeleteUserScenarioMutationVariables>(SquadPlanningDeleteUserScenarioDocument, options);
      }
export type SquadPlanningDeleteUserScenarioMutationHookResult = ReturnType<typeof useSquadPlanningDeleteUserScenarioMutation>;
export type SquadPlanningDeleteUserScenarioMutationResult = Apollo.MutationResult<SquadPlanningDeleteUserScenarioMutation>;
export type SquadPlanningDeleteUserScenarioMutationOptions = Apollo.BaseMutationOptions<SquadPlanningDeleteUserScenarioMutation, SquadPlanningDeleteUserScenarioMutationVariables>;
export const SquadPlanningSetScenarioFinancialsVisibilityDocument = gql`
    mutation SquadPlanningSetScenarioFinancialsVisibility($input: SetScenarioFinancialsVisibilityInput!) {
  setScenarioFinancialsVisibility(input: $input) {
    ...SquadPlanningScenarioAccess
  }
}
    ${SquadPlanningScenarioAccessFragmentDoc}`;
export type SquadPlanningSetScenarioFinancialsVisibilityMutationFn = Apollo.MutationFunction<SquadPlanningSetScenarioFinancialsVisibilityMutation, SquadPlanningSetScenarioFinancialsVisibilityMutationVariables>;

/**
 * __useSquadPlanningSetScenarioFinancialsVisibilityMutation__
 *
 * To run a mutation, you first call `useSquadPlanningSetScenarioFinancialsVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningSetScenarioFinancialsVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningSetScenarioFinancialsVisibilityMutation, { data, loading, error }] = useSquadPlanningSetScenarioFinancialsVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningSetScenarioFinancialsVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningSetScenarioFinancialsVisibilityMutation, SquadPlanningSetScenarioFinancialsVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningSetScenarioFinancialsVisibilityMutation, SquadPlanningSetScenarioFinancialsVisibilityMutationVariables>(SquadPlanningSetScenarioFinancialsVisibilityDocument, options);
      }
export type SquadPlanningSetScenarioFinancialsVisibilityMutationHookResult = ReturnType<typeof useSquadPlanningSetScenarioFinancialsVisibilityMutation>;
export type SquadPlanningSetScenarioFinancialsVisibilityMutationResult = Apollo.MutationResult<SquadPlanningSetScenarioFinancialsVisibilityMutation>;
export type SquadPlanningSetScenarioFinancialsVisibilityMutationOptions = Apollo.BaseMutationOptions<SquadPlanningSetScenarioFinancialsVisibilityMutation, SquadPlanningSetScenarioFinancialsVisibilityMutationVariables>;
export const SquadPlanningGetScenarioPitchDocument = gql`
    query SquadPlanningGetScenarioPitch($scenarioId: ID!) {
  getScenarioPitch(scenarioId: $scenarioId) {
    ...SquadPlanningScenarioPitch
  }
}
    ${SquadPlanningScenarioPitchFragmentDoc}`;

/**
 * __useSquadPlanningGetScenarioPitchQuery__
 *
 * To run a query within a React component, call `useSquadPlanningGetScenarioPitchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningGetScenarioPitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquadPlanningGetScenarioPitchQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useSquadPlanningGetScenarioPitchQuery(baseOptions: Apollo.QueryHookOptions<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables> & ({ variables: SquadPlanningGetScenarioPitchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>(SquadPlanningGetScenarioPitchDocument, options);
      }
export function useSquadPlanningGetScenarioPitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>(SquadPlanningGetScenarioPitchDocument, options);
        }
// @ts-ignore
export function useSquadPlanningGetScenarioPitchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>;
export function useSquadPlanningGetScenarioPitchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>): Apollo.UseSuspenseQueryResult<SquadPlanningGetScenarioPitchQuery | undefined, SquadPlanningGetScenarioPitchQueryVariables>;
export function useSquadPlanningGetScenarioPitchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>(SquadPlanningGetScenarioPitchDocument, options);
        }
export type SquadPlanningGetScenarioPitchQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioPitchQuery>;
export type SquadPlanningGetScenarioPitchLazyQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioPitchLazyQuery>;
export type SquadPlanningGetScenarioPitchSuspenseQueryHookResult = ReturnType<typeof useSquadPlanningGetScenarioPitchSuspenseQuery>;
export type SquadPlanningGetScenarioPitchQueryResult = Apollo.QueryResult<SquadPlanningGetScenarioPitchQuery, SquadPlanningGetScenarioPitchQueryVariables>;
export const SquadPlanningUpdateScenarioPreferenceOrderDocument = gql`
    mutation SquadPlanningUpdateScenarioPreferenceOrder($input: UpdateScenarioPreferenceOrderInput!) {
  updateScenarioPreferenceOrder(input: $input) {
    ...SquadPlanningScenarioPitch
  }
}
    ${SquadPlanningScenarioPitchFragmentDoc}`;
export type SquadPlanningUpdateScenarioPreferenceOrderMutationFn = Apollo.MutationFunction<SquadPlanningUpdateScenarioPreferenceOrderMutation, SquadPlanningUpdateScenarioPreferenceOrderMutationVariables>;

/**
 * __useSquadPlanningUpdateScenarioPreferenceOrderMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpdateScenarioPreferenceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpdateScenarioPreferenceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpdateScenarioPreferenceOrderMutation, { data, loading, error }] = useSquadPlanningUpdateScenarioPreferenceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpdateScenarioPreferenceOrderMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpdateScenarioPreferenceOrderMutation, SquadPlanningUpdateScenarioPreferenceOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpdateScenarioPreferenceOrderMutation, SquadPlanningUpdateScenarioPreferenceOrderMutationVariables>(SquadPlanningUpdateScenarioPreferenceOrderDocument, options);
      }
export type SquadPlanningUpdateScenarioPreferenceOrderMutationHookResult = ReturnType<typeof useSquadPlanningUpdateScenarioPreferenceOrderMutation>;
export type SquadPlanningUpdateScenarioPreferenceOrderMutationResult = Apollo.MutationResult<SquadPlanningUpdateScenarioPreferenceOrderMutation>;
export type SquadPlanningUpdateScenarioPreferenceOrderMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpdateScenarioPreferenceOrderMutation, SquadPlanningUpdateScenarioPreferenceOrderMutationVariables>;
export const SquadPlanningUpdateScenarioPitchAssignmentDocument = gql`
    mutation SquadPlanningUpdateScenarioPitchAssignment($input: UpdateScenarioPitchAssignmentInput!) {
  updateScenarioPitchAssignment(input: $input) {
    ...SquadPlanningScenarioPitch
  }
}
    ${SquadPlanningScenarioPitchFragmentDoc}`;
export type SquadPlanningUpdateScenarioPitchAssignmentMutationFn = Apollo.MutationFunction<SquadPlanningUpdateScenarioPitchAssignmentMutation, SquadPlanningUpdateScenarioPitchAssignmentMutationVariables>;

/**
 * __useSquadPlanningUpdateScenarioPitchAssignmentMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpdateScenarioPitchAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpdateScenarioPitchAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpdateScenarioPitchAssignmentMutation, { data, loading, error }] = useSquadPlanningUpdateScenarioPitchAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpdateScenarioPitchAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpdateScenarioPitchAssignmentMutation, SquadPlanningUpdateScenarioPitchAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpdateScenarioPitchAssignmentMutation, SquadPlanningUpdateScenarioPitchAssignmentMutationVariables>(SquadPlanningUpdateScenarioPitchAssignmentDocument, options);
      }
export type SquadPlanningUpdateScenarioPitchAssignmentMutationHookResult = ReturnType<typeof useSquadPlanningUpdateScenarioPitchAssignmentMutation>;
export type SquadPlanningUpdateScenarioPitchAssignmentMutationResult = Apollo.MutationResult<SquadPlanningUpdateScenarioPitchAssignmentMutation>;
export type SquadPlanningUpdateScenarioPitchAssignmentMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpdateScenarioPitchAssignmentMutation, SquadPlanningUpdateScenarioPitchAssignmentMutationVariables>;
export const SquadPlanningUpdateScenarioFormationDocument = gql`
    mutation SquadPlanningUpdateScenarioFormation($input: UpdateScenarioFormationInput!) {
  updateScenarioFormation(input: $input) {
    ...SquadPlanningScenarioPitch
  }
}
    ${SquadPlanningScenarioPitchFragmentDoc}`;
export type SquadPlanningUpdateScenarioFormationMutationFn = Apollo.MutationFunction<SquadPlanningUpdateScenarioFormationMutation, SquadPlanningUpdateScenarioFormationMutationVariables>;

/**
 * __useSquadPlanningUpdateScenarioFormationMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpdateScenarioFormationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpdateScenarioFormationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpdateScenarioFormationMutation, { data, loading, error }] = useSquadPlanningUpdateScenarioFormationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpdateScenarioFormationMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpdateScenarioFormationMutation, SquadPlanningUpdateScenarioFormationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpdateScenarioFormationMutation, SquadPlanningUpdateScenarioFormationMutationVariables>(SquadPlanningUpdateScenarioFormationDocument, options);
      }
export type SquadPlanningUpdateScenarioFormationMutationHookResult = ReturnType<typeof useSquadPlanningUpdateScenarioFormationMutation>;
export type SquadPlanningUpdateScenarioFormationMutationResult = Apollo.MutationResult<SquadPlanningUpdateScenarioFormationMutation>;
export type SquadPlanningUpdateScenarioFormationMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpdateScenarioFormationMutation, SquadPlanningUpdateScenarioFormationMutationVariables>;
export const SquadPlanningUpdatePlayerWageDocument = gql`
    mutation SquadPlanningUpdatePlayerWage($input: UpdatePlayerWageInput!) {
  updatePlayerWage(input: $input) {
    id
    playerId
    grossAnnualSalary
  }
}
    `;
export type SquadPlanningUpdatePlayerWageMutationFn = Apollo.MutationFunction<SquadPlanningUpdatePlayerWageMutation, SquadPlanningUpdatePlayerWageMutationVariables>;

/**
 * __useSquadPlanningUpdatePlayerWageMutation__
 *
 * To run a mutation, you first call `useSquadPlanningUpdatePlayerWageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquadPlanningUpdatePlayerWageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squadPlanningUpdatePlayerWageMutation, { data, loading, error }] = useSquadPlanningUpdatePlayerWageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSquadPlanningUpdatePlayerWageMutation(baseOptions?: Apollo.MutationHookOptions<SquadPlanningUpdatePlayerWageMutation, SquadPlanningUpdatePlayerWageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquadPlanningUpdatePlayerWageMutation, SquadPlanningUpdatePlayerWageMutationVariables>(SquadPlanningUpdatePlayerWageDocument, options);
      }
export type SquadPlanningUpdatePlayerWageMutationHookResult = ReturnType<typeof useSquadPlanningUpdatePlayerWageMutation>;
export type SquadPlanningUpdatePlayerWageMutationResult = Apollo.MutationResult<SquadPlanningUpdatePlayerWageMutation>;
export type SquadPlanningUpdatePlayerWageMutationOptions = Apollo.BaseMutationOptions<SquadPlanningUpdatePlayerWageMutation, SquadPlanningUpdatePlayerWageMutationVariables>;
export const TeamSelectionSelectableTeamsDocument = gql`
    query TeamSelectionSelectableTeams($query: String, $first: Int = 20, $after: String) {
  selectableTeams(query: $query, first: $first, after: $after) {
    ...TeamSelectionTeamConnection
  }
}
    ${TeamSelectionTeamConnectionFragmentDoc}`;

/**
 * __useTeamSelectionSelectableTeamsQuery__
 *
 * To run a query within a React component, call `useTeamSelectionSelectableTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamSelectionSelectableTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamSelectionSelectableTeamsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTeamSelectionSelectableTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>(TeamSelectionSelectableTeamsDocument, options);
      }
export function useTeamSelectionSelectableTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>(TeamSelectionSelectableTeamsDocument, options);
        }
// @ts-ignore
export function useTeamSelectionSelectableTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>;
export function useTeamSelectionSelectableTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<TeamSelectionSelectableTeamsQuery | undefined, TeamSelectionSelectableTeamsQueryVariables>;
export function useTeamSelectionSelectableTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>(TeamSelectionSelectableTeamsDocument, options);
        }
export type TeamSelectionSelectableTeamsQueryHookResult = ReturnType<typeof useTeamSelectionSelectableTeamsQuery>;
export type TeamSelectionSelectableTeamsLazyQueryHookResult = ReturnType<typeof useTeamSelectionSelectableTeamsLazyQuery>;
export type TeamSelectionSelectableTeamsSuspenseQueryHookResult = ReturnType<typeof useTeamSelectionSelectableTeamsSuspenseQuery>;
export type TeamSelectionSelectableTeamsQueryResult = Apollo.QueryResult<TeamSelectionSelectableTeamsQuery, TeamSelectionSelectableTeamsQueryVariables>;
export const GetCurrentLastFeedVisitAtDocument = gql`
    query GetCurrentLastFeedVisitAt {
  getCurrentLastFeedVisitAt
}
    `;

/**
 * __useGetCurrentLastFeedVisitAtQuery__
 *
 * To run a query within a React component, call `useGetCurrentLastFeedVisitAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentLastFeedVisitAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentLastFeedVisitAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentLastFeedVisitAtQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>(GetCurrentLastFeedVisitAtDocument, options);
      }
export function useGetCurrentLastFeedVisitAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>(GetCurrentLastFeedVisitAtDocument, options);
        }
// @ts-ignore
export function useGetCurrentLastFeedVisitAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>;
export function useGetCurrentLastFeedVisitAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentLastFeedVisitAtQuery | undefined, GetCurrentLastFeedVisitAtQueryVariables>;
export function useGetCurrentLastFeedVisitAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>(GetCurrentLastFeedVisitAtDocument, options);
        }
export type GetCurrentLastFeedVisitAtQueryHookResult = ReturnType<typeof useGetCurrentLastFeedVisitAtQuery>;
export type GetCurrentLastFeedVisitAtLazyQueryHookResult = ReturnType<typeof useGetCurrentLastFeedVisitAtLazyQuery>;
export type GetCurrentLastFeedVisitAtSuspenseQueryHookResult = ReturnType<typeof useGetCurrentLastFeedVisitAtSuspenseQuery>;
export type GetCurrentLastFeedVisitAtQueryResult = Apollo.QueryResult<GetCurrentLastFeedVisitAtQuery, GetCurrentLastFeedVisitAtQueryVariables>;
export const CommitLastFeedVisitAtDocument = gql`
    mutation CommitLastFeedVisitAt($at: DateTime!) {
  commitLastFeedVisitAt(at: $at) {
    id
    lastFeedVisitAt
  }
}
    `;
export type CommitLastFeedVisitAtMutationFn = Apollo.MutationFunction<CommitLastFeedVisitAtMutation, CommitLastFeedVisitAtMutationVariables>;

/**
 * __useCommitLastFeedVisitAtMutation__
 *
 * To run a mutation, you first call `useCommitLastFeedVisitAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitLastFeedVisitAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitLastFeedVisitAtMutation, { data, loading, error }] = useCommitLastFeedVisitAtMutation({
 *   variables: {
 *      at: // value for 'at'
 *   },
 * });
 */
export function useCommitLastFeedVisitAtMutation(baseOptions?: Apollo.MutationHookOptions<CommitLastFeedVisitAtMutation, CommitLastFeedVisitAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitLastFeedVisitAtMutation, CommitLastFeedVisitAtMutationVariables>(CommitLastFeedVisitAtDocument, options);
      }
export type CommitLastFeedVisitAtMutationHookResult = ReturnType<typeof useCommitLastFeedVisitAtMutation>;
export type CommitLastFeedVisitAtMutationResult = Apollo.MutationResult<CommitLastFeedVisitAtMutation>;
export type CommitLastFeedVisitAtMutationOptions = Apollo.BaseMutationOptions<CommitLastFeedVisitAtMutation, CommitLastFeedVisitAtMutationVariables>;
export const UpdateFeedEventsDocument = gql`
    query UpdateFeedEvents($first: Int, $after: String, $categories: [FeedEventCategory!]) {
  feedEvents(first: $first, after: $after, categories: $categories) {
    edges {
      node {
        ...UpdateFeedEvent
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${UpdateFeedEventFragmentDoc}`;

/**
 * __useUpdateFeedEventsQuery__
 *
 * To run a query within a React component, call `useUpdateFeedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateFeedEventsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUpdateFeedEventsQuery(baseOptions?: Apollo.QueryHookOptions<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>(UpdateFeedEventsDocument, options);
      }
export function useUpdateFeedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>(UpdateFeedEventsDocument, options);
        }
// @ts-ignore
export function useUpdateFeedEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>;
export function useUpdateFeedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateFeedEventsQuery | undefined, UpdateFeedEventsQueryVariables>;
export function useUpdateFeedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>(UpdateFeedEventsDocument, options);
        }
export type UpdateFeedEventsQueryHookResult = ReturnType<typeof useUpdateFeedEventsQuery>;
export type UpdateFeedEventsLazyQueryHookResult = ReturnType<typeof useUpdateFeedEventsLazyQuery>;
export type UpdateFeedEventsSuspenseQueryHookResult = ReturnType<typeof useUpdateFeedEventsSuspenseQuery>;
export type UpdateFeedEventsQueryResult = Apollo.QueryResult<UpdateFeedEventsQuery, UpdateFeedEventsQueryVariables>;
export const ArchiveFeedUpdatesDocument = gql`
    mutation ArchiveFeedUpdates($input: ArchiveFeedUpdatesInput!) {
  archiveFeedUpdates(input: $input) {
    archivedCount
  }
}
    `;
export type ArchiveFeedUpdatesMutationFn = Apollo.MutationFunction<ArchiveFeedUpdatesMutation, ArchiveFeedUpdatesMutationVariables>;

/**
 * __useArchiveFeedUpdatesMutation__
 *
 * To run a mutation, you first call `useArchiveFeedUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFeedUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFeedUpdatesMutation, { data, loading, error }] = useArchiveFeedUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFeedUpdatesMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFeedUpdatesMutation, ArchiveFeedUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFeedUpdatesMutation, ArchiveFeedUpdatesMutationVariables>(ArchiveFeedUpdatesDocument, options);
      }
export type ArchiveFeedUpdatesMutationHookResult = ReturnType<typeof useArchiveFeedUpdatesMutation>;
export type ArchiveFeedUpdatesMutationResult = Apollo.MutationResult<ArchiveFeedUpdatesMutation>;
export type ArchiveFeedUpdatesMutationOptions = Apollo.BaseMutationOptions<ArchiveFeedUpdatesMutation, ArchiveFeedUpdatesMutationVariables>;
export const WatchlistListMyOrganizationsOrganizationUsersDocument = gql`
    query WatchlistListMyOrganizationsOrganizationUsers($first: Int, $after: String) {
  listMyOrganizationsOrganizationUsers(first: $first, after: $after) {
    ...WatchlistOrganizationUserConnection
  }
}
    ${WatchlistOrganizationUserConnectionFragmentDoc}`;

/**
 * __useWatchlistListMyOrganizationsOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useWatchlistListMyOrganizationsOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistListMyOrganizationsOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistListMyOrganizationsOrganizationUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWatchlistListMyOrganizationsOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>(WatchlistListMyOrganizationsOrganizationUsersDocument, options);
      }
export function useWatchlistListMyOrganizationsOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>(WatchlistListMyOrganizationsOrganizationUsersDocument, options);
        }
// @ts-ignore
export function useWatchlistListMyOrganizationsOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>;
export function useWatchlistListMyOrganizationsOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListMyOrganizationsOrganizationUsersQuery | undefined, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>;
export function useWatchlistListMyOrganizationsOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>(WatchlistListMyOrganizationsOrganizationUsersDocument, options);
        }
export type WatchlistListMyOrganizationsOrganizationUsersQueryHookResult = ReturnType<typeof useWatchlistListMyOrganizationsOrganizationUsersQuery>;
export type WatchlistListMyOrganizationsOrganizationUsersLazyQueryHookResult = ReturnType<typeof useWatchlistListMyOrganizationsOrganizationUsersLazyQuery>;
export type WatchlistListMyOrganizationsOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useWatchlistListMyOrganizationsOrganizationUsersSuspenseQuery>;
export type WatchlistListMyOrganizationsOrganizationUsersQueryResult = Apollo.QueryResult<WatchlistListMyOrganizationsOrganizationUsersQuery, WatchlistListMyOrganizationsOrganizationUsersQueryVariables>;
export const WatchlistListUserWatchlistsByWatchlistIdDocument = gql`
    query WatchlistListUserWatchlistsByWatchlistId($watchlistId: ID!, $first: Int, $after: String) {
  listUserWatchlistsByWatchlistId(
    watchlistId: $watchlistId
    first: $first
    after: $after
  ) {
    ...WatchlistUserWatchlistConnection
  }
}
    ${WatchlistUserWatchlistConnectionFragmentDoc}`;

/**
 * __useWatchlistListUserWatchlistsByWatchlistIdQuery__
 *
 * To run a query within a React component, call `useWatchlistListUserWatchlistsByWatchlistIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistListUserWatchlistsByWatchlistIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistListUserWatchlistsByWatchlistIdQuery({
 *   variables: {
 *      watchlistId: // value for 'watchlistId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWatchlistListUserWatchlistsByWatchlistIdQuery(baseOptions: Apollo.QueryHookOptions<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables> & ({ variables: WatchlistListUserWatchlistsByWatchlistIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>(WatchlistListUserWatchlistsByWatchlistIdDocument, options);
      }
export function useWatchlistListUserWatchlistsByWatchlistIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>(WatchlistListUserWatchlistsByWatchlistIdDocument, options);
        }
// @ts-ignore
export function useWatchlistListUserWatchlistsByWatchlistIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>;
export function useWatchlistListUserWatchlistsByWatchlistIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListUserWatchlistsByWatchlistIdQuery | undefined, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>;
export function useWatchlistListUserWatchlistsByWatchlistIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>(WatchlistListUserWatchlistsByWatchlistIdDocument, options);
        }
export type WatchlistListUserWatchlistsByWatchlistIdQueryHookResult = ReturnType<typeof useWatchlistListUserWatchlistsByWatchlistIdQuery>;
export type WatchlistListUserWatchlistsByWatchlistIdLazyQueryHookResult = ReturnType<typeof useWatchlistListUserWatchlistsByWatchlistIdLazyQuery>;
export type WatchlistListUserWatchlistsByWatchlistIdSuspenseQueryHookResult = ReturnType<typeof useWatchlistListUserWatchlistsByWatchlistIdSuspenseQuery>;
export type WatchlistListUserWatchlistsByWatchlistIdQueryResult = Apollo.QueryResult<WatchlistListUserWatchlistsByWatchlistIdQuery, WatchlistListUserWatchlistsByWatchlistIdQueryVariables>;
export const WatchlistListMyUserWatchlistsDocument = gql`
    query WatchlistListMyUserWatchlists($first: Int, $after: String) {
  listMyUserWatchlists(first: $first, after: $after) {
    ...WatchlistMyUserWatchlistConnection
  }
}
    ${WatchlistMyUserWatchlistConnectionFragmentDoc}`;

/**
 * __useWatchlistListMyUserWatchlistsQuery__
 *
 * To run a query within a React component, call `useWatchlistListMyUserWatchlistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistListMyUserWatchlistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistListMyUserWatchlistsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWatchlistListMyUserWatchlistsQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>(WatchlistListMyUserWatchlistsDocument, options);
      }
export function useWatchlistListMyUserWatchlistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>(WatchlistListMyUserWatchlistsDocument, options);
        }
// @ts-ignore
export function useWatchlistListMyUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>;
export function useWatchlistListMyUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListMyUserWatchlistsQuery | undefined, WatchlistListMyUserWatchlistsQueryVariables>;
export function useWatchlistListMyUserWatchlistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>(WatchlistListMyUserWatchlistsDocument, options);
        }
export type WatchlistListMyUserWatchlistsQueryHookResult = ReturnType<typeof useWatchlistListMyUserWatchlistsQuery>;
export type WatchlistListMyUserWatchlistsLazyQueryHookResult = ReturnType<typeof useWatchlistListMyUserWatchlistsLazyQuery>;
export type WatchlistListMyUserWatchlistsSuspenseQueryHookResult = ReturnType<typeof useWatchlistListMyUserWatchlistsSuspenseQuery>;
export type WatchlistListMyUserWatchlistsQueryResult = Apollo.QueryResult<WatchlistListMyUserWatchlistsQuery, WatchlistListMyUserWatchlistsQueryVariables>;
export const WatchlistGetPlayerBioDataByPlayerIdDocument = gql`
    query WatchlistGetPlayerBioDataByPlayerId($playerId: ID!) {
  getPlayerBioDataByPlayerId(playerId: $playerId) {
    ...WatchlistPlayerBioData
  }
}
    ${WatchlistPlayerBioDataFragmentDoc}`;

/**
 * __useWatchlistGetPlayerBioDataByPlayerIdQuery__
 *
 * To run a query within a React component, call `useWatchlistGetPlayerBioDataByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistGetPlayerBioDataByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistGetPlayerBioDataByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useWatchlistGetPlayerBioDataByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables> & ({ variables: WatchlistGetPlayerBioDataByPlayerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>(WatchlistGetPlayerBioDataByPlayerIdDocument, options);
      }
export function useWatchlistGetPlayerBioDataByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>(WatchlistGetPlayerBioDataByPlayerIdDocument, options);
        }
// @ts-ignore
export function useWatchlistGetPlayerBioDataByPlayerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>;
export function useWatchlistGetPlayerBioDataByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistGetPlayerBioDataByPlayerIdQuery | undefined, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>;
export function useWatchlistGetPlayerBioDataByPlayerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>(WatchlistGetPlayerBioDataByPlayerIdDocument, options);
        }
export type WatchlistGetPlayerBioDataByPlayerIdQueryHookResult = ReturnType<typeof useWatchlistGetPlayerBioDataByPlayerIdQuery>;
export type WatchlistGetPlayerBioDataByPlayerIdLazyQueryHookResult = ReturnType<typeof useWatchlistGetPlayerBioDataByPlayerIdLazyQuery>;
export type WatchlistGetPlayerBioDataByPlayerIdSuspenseQueryHookResult = ReturnType<typeof useWatchlistGetPlayerBioDataByPlayerIdSuspenseQuery>;
export type WatchlistGetPlayerBioDataByPlayerIdQueryResult = Apollo.QueryResult<WatchlistGetPlayerBioDataByPlayerIdQuery, WatchlistGetPlayerBioDataByPlayerIdQueryVariables>;
export const WatchlistListPlayerSeasonWeightedAvgMetricsDocument = gql`
    query WatchlistListPlayerSeasonWeightedAvgMetrics($playerId: ID!) {
  listPlayerSeasonWeightedAvgMetricsByPlayerId(playerId: $playerId) {
    ...WatchlistPlayerSeasonWeightedAvgMetrics
  }
}
    ${WatchlistPlayerSeasonWeightedAvgMetricsFragmentDoc}`;

/**
 * __useWatchlistListPlayerSeasonWeightedAvgMetricsQuery__
 *
 * To run a query within a React component, call `useWatchlistListPlayerSeasonWeightedAvgMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistListPlayerSeasonWeightedAvgMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistListPlayerSeasonWeightedAvgMetricsQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useWatchlistListPlayerSeasonWeightedAvgMetricsQuery(baseOptions: Apollo.QueryHookOptions<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables> & ({ variables: WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>(WatchlistListPlayerSeasonWeightedAvgMetricsDocument, options);
      }
export function useWatchlistListPlayerSeasonWeightedAvgMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>(WatchlistListPlayerSeasonWeightedAvgMetricsDocument, options);
        }
// @ts-ignore
export function useWatchlistListPlayerSeasonWeightedAvgMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>;
export function useWatchlistListPlayerSeasonWeightedAvgMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListPlayerSeasonWeightedAvgMetricsQuery | undefined, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>;
export function useWatchlistListPlayerSeasonWeightedAvgMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>(WatchlistListPlayerSeasonWeightedAvgMetricsDocument, options);
        }
export type WatchlistListPlayerSeasonWeightedAvgMetricsQueryHookResult = ReturnType<typeof useWatchlistListPlayerSeasonWeightedAvgMetricsQuery>;
export type WatchlistListPlayerSeasonWeightedAvgMetricsLazyQueryHookResult = ReturnType<typeof useWatchlistListPlayerSeasonWeightedAvgMetricsLazyQuery>;
export type WatchlistListPlayerSeasonWeightedAvgMetricsSuspenseQueryHookResult = ReturnType<typeof useWatchlistListPlayerSeasonWeightedAvgMetricsSuspenseQuery>;
export type WatchlistListPlayerSeasonWeightedAvgMetricsQueryResult = Apollo.QueryResult<WatchlistListPlayerSeasonWeightedAvgMetricsQuery, WatchlistListPlayerSeasonWeightedAvgMetricsQueryVariables>;
export const WatchlistListWatchlistPlayersDocument = gql`
    query WatchlistListWatchlistPlayers($watchlistId: ID!, $sortBy: SortField, $sortByCustomStatName: String, $sortOrder: OrderByDirection, $first: Int, $after: String) {
  listWatchlistPlayers(
    watchlistId: $watchlistId
    sortBy: $sortBy
    sortByCustomStatName: $sortByCustomStatName
    sortOrder: $sortOrder
    first: $first
    after: $after
  ) {
    ...WatchlistPlayerConnection
  }
}
    ${WatchlistPlayerConnectionFragmentDoc}`;

/**
 * __useWatchlistListWatchlistPlayersQuery__
 *
 * To run a query within a React component, call `useWatchlistListWatchlistPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistListWatchlistPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistListWatchlistPlayersQuery({
 *   variables: {
 *      watchlistId: // value for 'watchlistId'
 *      sortBy: // value for 'sortBy'
 *      sortByCustomStatName: // value for 'sortByCustomStatName'
 *      sortOrder: // value for 'sortOrder'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWatchlistListWatchlistPlayersQuery(baseOptions: Apollo.QueryHookOptions<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables> & ({ variables: WatchlistListWatchlistPlayersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>(WatchlistListWatchlistPlayersDocument, options);
      }
export function useWatchlistListWatchlistPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>(WatchlistListWatchlistPlayersDocument, options);
        }
// @ts-ignore
export function useWatchlistListWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>;
export function useWatchlistListWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>): Apollo.UseSuspenseQueryResult<WatchlistListWatchlistPlayersQuery | undefined, WatchlistListWatchlistPlayersQueryVariables>;
export function useWatchlistListWatchlistPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>(WatchlistListWatchlistPlayersDocument, options);
        }
export type WatchlistListWatchlistPlayersQueryHookResult = ReturnType<typeof useWatchlistListWatchlistPlayersQuery>;
export type WatchlistListWatchlistPlayersLazyQueryHookResult = ReturnType<typeof useWatchlistListWatchlistPlayersLazyQuery>;
export type WatchlistListWatchlistPlayersSuspenseQueryHookResult = ReturnType<typeof useWatchlistListWatchlistPlayersSuspenseQuery>;
export type WatchlistListWatchlistPlayersQueryResult = Apollo.QueryResult<WatchlistListWatchlistPlayersQuery, WatchlistListWatchlistPlayersQueryVariables>;
export const WatchlistDeleteWatchlistDocument = gql`
    mutation WatchlistDeleteWatchlist($input: DeleteWatchlistInput!) {
  deleteWatchlist(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchlistDeleteWatchlistMutationFn = Apollo.MutationFunction<WatchlistDeleteWatchlistMutation, WatchlistDeleteWatchlistMutationVariables>;

/**
 * __useWatchlistDeleteWatchlistMutation__
 *
 * To run a mutation, you first call `useWatchlistDeleteWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistDeleteWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistDeleteWatchlistMutation, { data, loading, error }] = useWatchlistDeleteWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistDeleteWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistDeleteWatchlistMutation, WatchlistDeleteWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistDeleteWatchlistMutation, WatchlistDeleteWatchlistMutationVariables>(WatchlistDeleteWatchlistDocument, options);
      }
export type WatchlistDeleteWatchlistMutationHookResult = ReturnType<typeof useWatchlistDeleteWatchlistMutation>;
export type WatchlistDeleteWatchlistMutationResult = Apollo.MutationResult<WatchlistDeleteWatchlistMutation>;
export type WatchlistDeleteWatchlistMutationOptions = Apollo.BaseMutationOptions<WatchlistDeleteWatchlistMutation, WatchlistDeleteWatchlistMutationVariables>;
export const WatchlistUpdateWatchlistDocument = gql`
    mutation WatchlistUpdateWatchlist($input: UpdateWatchlistInput!) {
  updateWatchlist(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchlistUpdateWatchlistMutationFn = Apollo.MutationFunction<WatchlistUpdateWatchlistMutation, WatchlistUpdateWatchlistMutationVariables>;

/**
 * __useWatchlistUpdateWatchlistMutation__
 *
 * To run a mutation, you first call `useWatchlistUpdateWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistUpdateWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistUpdateWatchlistMutation, { data, loading, error }] = useWatchlistUpdateWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistUpdateWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistUpdateWatchlistMutation, WatchlistUpdateWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistUpdateWatchlistMutation, WatchlistUpdateWatchlistMutationVariables>(WatchlistUpdateWatchlistDocument, options);
      }
export type WatchlistUpdateWatchlistMutationHookResult = ReturnType<typeof useWatchlistUpdateWatchlistMutation>;
export type WatchlistUpdateWatchlistMutationResult = Apollo.MutationResult<WatchlistUpdateWatchlistMutation>;
export type WatchlistUpdateWatchlistMutationOptions = Apollo.BaseMutationOptions<WatchlistUpdateWatchlistMutation, WatchlistUpdateWatchlistMutationVariables>;
export const WatchlistRemovePlayerFromWatchlistDocument = gql`
    mutation WatchlistRemovePlayerFromWatchlist($input: RemovePlayerFromWatchlistInput!) {
  removePlayerFromWatchlist(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchlistRemovePlayerFromWatchlistMutationFn = Apollo.MutationFunction<WatchlistRemovePlayerFromWatchlistMutation, WatchlistRemovePlayerFromWatchlistMutationVariables>;

/**
 * __useWatchlistRemovePlayerFromWatchlistMutation__
 *
 * To run a mutation, you first call `useWatchlistRemovePlayerFromWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistRemovePlayerFromWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistRemovePlayerFromWatchlistMutation, { data, loading, error }] = useWatchlistRemovePlayerFromWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistRemovePlayerFromWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistRemovePlayerFromWatchlistMutation, WatchlistRemovePlayerFromWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistRemovePlayerFromWatchlistMutation, WatchlistRemovePlayerFromWatchlistMutationVariables>(WatchlistRemovePlayerFromWatchlistDocument, options);
      }
export type WatchlistRemovePlayerFromWatchlistMutationHookResult = ReturnType<typeof useWatchlistRemovePlayerFromWatchlistMutation>;
export type WatchlistRemovePlayerFromWatchlistMutationResult = Apollo.MutationResult<WatchlistRemovePlayerFromWatchlistMutation>;
export type WatchlistRemovePlayerFromWatchlistMutationOptions = Apollo.BaseMutationOptions<WatchlistRemovePlayerFromWatchlistMutation, WatchlistRemovePlayerFromWatchlistMutationVariables>;
export const WatchlistUpdateUserWatchlistPositionDocument = gql`
    mutation WatchlistUpdateUserWatchlistPosition($input: UpdateUserWatchlistPositionInput!) {
  updateUserWatchlistPosition(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchlistUpdateUserWatchlistPositionMutationFn = Apollo.MutationFunction<WatchlistUpdateUserWatchlistPositionMutation, WatchlistUpdateUserWatchlistPositionMutationVariables>;

/**
 * __useWatchlistUpdateUserWatchlistPositionMutation__
 *
 * To run a mutation, you first call `useWatchlistUpdateUserWatchlistPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistUpdateUserWatchlistPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistUpdateUserWatchlistPositionMutation, { data, loading, error }] = useWatchlistUpdateUserWatchlistPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistUpdateUserWatchlistPositionMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistUpdateUserWatchlistPositionMutation, WatchlistUpdateUserWatchlistPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistUpdateUserWatchlistPositionMutation, WatchlistUpdateUserWatchlistPositionMutationVariables>(WatchlistUpdateUserWatchlistPositionDocument, options);
      }
export type WatchlistUpdateUserWatchlistPositionMutationHookResult = ReturnType<typeof useWatchlistUpdateUserWatchlistPositionMutation>;
export type WatchlistUpdateUserWatchlistPositionMutationResult = Apollo.MutationResult<WatchlistUpdateUserWatchlistPositionMutation>;
export type WatchlistUpdateUserWatchlistPositionMutationOptions = Apollo.BaseMutationOptions<WatchlistUpdateUserWatchlistPositionMutation, WatchlistUpdateUserWatchlistPositionMutationVariables>;
export const WatchlistAddPlayerToWatchlistDocument = gql`
    mutation WatchlistAddPlayerToWatchlist($input: AddPlayerToWatchlistInput!) {
  addPlayerToWatchlist(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchlistAddPlayerToWatchlistMutationFn = Apollo.MutationFunction<WatchlistAddPlayerToWatchlistMutation, WatchlistAddPlayerToWatchlistMutationVariables>;

/**
 * __useWatchlistAddPlayerToWatchlistMutation__
 *
 * To run a mutation, you first call `useWatchlistAddPlayerToWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistAddPlayerToWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistAddPlayerToWatchlistMutation, { data, loading, error }] = useWatchlistAddPlayerToWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistAddPlayerToWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistAddPlayerToWatchlistMutation, WatchlistAddPlayerToWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistAddPlayerToWatchlistMutation, WatchlistAddPlayerToWatchlistMutationVariables>(WatchlistAddPlayerToWatchlistDocument, options);
      }
export type WatchlistAddPlayerToWatchlistMutationHookResult = ReturnType<typeof useWatchlistAddPlayerToWatchlistMutation>;
export type WatchlistAddPlayerToWatchlistMutationResult = Apollo.MutationResult<WatchlistAddPlayerToWatchlistMutation>;
export type WatchlistAddPlayerToWatchlistMutationOptions = Apollo.BaseMutationOptions<WatchlistAddPlayerToWatchlistMutation, WatchlistAddPlayerToWatchlistMutationVariables>;
export const WatchlistUpdateWatchlistPlayerPositionDocument = gql`
    mutation WatchlistUpdateWatchlistPlayerPosition($input: UpdateWatchlistPlayerPositionInput!) {
  updateWatchlistPlayerPosition(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchlistUpdateWatchlistPlayerPositionMutationFn = Apollo.MutationFunction<WatchlistUpdateWatchlistPlayerPositionMutation, WatchlistUpdateWatchlistPlayerPositionMutationVariables>;

/**
 * __useWatchlistUpdateWatchlistPlayerPositionMutation__
 *
 * To run a mutation, you first call `useWatchlistUpdateWatchlistPlayerPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistUpdateWatchlistPlayerPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistUpdateWatchlistPlayerPositionMutation, { data, loading, error }] = useWatchlistUpdateWatchlistPlayerPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistUpdateWatchlistPlayerPositionMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistUpdateWatchlistPlayerPositionMutation, WatchlistUpdateWatchlistPlayerPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistUpdateWatchlistPlayerPositionMutation, WatchlistUpdateWatchlistPlayerPositionMutationVariables>(WatchlistUpdateWatchlistPlayerPositionDocument, options);
      }
export type WatchlistUpdateWatchlistPlayerPositionMutationHookResult = ReturnType<typeof useWatchlistUpdateWatchlistPlayerPositionMutation>;
export type WatchlistUpdateWatchlistPlayerPositionMutationResult = Apollo.MutationResult<WatchlistUpdateWatchlistPlayerPositionMutation>;
export type WatchlistUpdateWatchlistPlayerPositionMutationOptions = Apollo.BaseMutationOptions<WatchlistUpdateWatchlistPlayerPositionMutation, WatchlistUpdateWatchlistPlayerPositionMutationVariables>;
export const WatchListUpdateWatchListPlayerPositionsDocument = gql`
    mutation WatchListUpdateWatchListPlayerPositions($input: UpdateWatchlistPlayerPositionsInput!) {
  updateWatchlistPlayerPositions(input: $input) {
    ...WatchlistWatchlist
  }
}
    ${WatchlistWatchlistFragmentDoc}`;
export type WatchListUpdateWatchListPlayerPositionsMutationFn = Apollo.MutationFunction<WatchListUpdateWatchListPlayerPositionsMutation, WatchListUpdateWatchListPlayerPositionsMutationVariables>;

/**
 * __useWatchListUpdateWatchListPlayerPositionsMutation__
 *
 * To run a mutation, you first call `useWatchListUpdateWatchListPlayerPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchListUpdateWatchListPlayerPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchListUpdateWatchListPlayerPositionsMutation, { data, loading, error }] = useWatchListUpdateWatchListPlayerPositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchListUpdateWatchListPlayerPositionsMutation(baseOptions?: Apollo.MutationHookOptions<WatchListUpdateWatchListPlayerPositionsMutation, WatchListUpdateWatchListPlayerPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchListUpdateWatchListPlayerPositionsMutation, WatchListUpdateWatchListPlayerPositionsMutationVariables>(WatchListUpdateWatchListPlayerPositionsDocument, options);
      }
export type WatchListUpdateWatchListPlayerPositionsMutationHookResult = ReturnType<typeof useWatchListUpdateWatchListPlayerPositionsMutation>;
export type WatchListUpdateWatchListPlayerPositionsMutationResult = Apollo.MutationResult<WatchListUpdateWatchListPlayerPositionsMutation>;
export type WatchListUpdateWatchListPlayerPositionsMutationOptions = Apollo.BaseMutationOptions<WatchListUpdateWatchListPlayerPositionsMutation, WatchListUpdateWatchListPlayerPositionsMutationVariables>;
export const WatchlistCreateUserWatchlistDocument = gql`
    mutation WatchlistCreateUserWatchlist($input: CreateUserWatchlistInput!) {
  createUserWatchlist(input: $input) {
    ...WatchlistUserWatchlist
  }
}
    ${WatchlistUserWatchlistFragmentDoc}`;
export type WatchlistCreateUserWatchlistMutationFn = Apollo.MutationFunction<WatchlistCreateUserWatchlistMutation, WatchlistCreateUserWatchlistMutationVariables>;

/**
 * __useWatchlistCreateUserWatchlistMutation__
 *
 * To run a mutation, you first call `useWatchlistCreateUserWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistCreateUserWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistCreateUserWatchlistMutation, { data, loading, error }] = useWatchlistCreateUserWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistCreateUserWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistCreateUserWatchlistMutation, WatchlistCreateUserWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistCreateUserWatchlistMutation, WatchlistCreateUserWatchlistMutationVariables>(WatchlistCreateUserWatchlistDocument, options);
      }
export type WatchlistCreateUserWatchlistMutationHookResult = ReturnType<typeof useWatchlistCreateUserWatchlistMutation>;
export type WatchlistCreateUserWatchlistMutationResult = Apollo.MutationResult<WatchlistCreateUserWatchlistMutation>;
export type WatchlistCreateUserWatchlistMutationOptions = Apollo.BaseMutationOptions<WatchlistCreateUserWatchlistMutation, WatchlistCreateUserWatchlistMutationVariables>;
export const WatchlistDeleteUserWatchlistDocument = gql`
    mutation WatchlistDeleteUserWatchlist($input: DeleteUserWatchlistInput!) {
  deleteUserWatchlist(input: $input) {
    ...WatchlistUserWatchlist
  }
}
    ${WatchlistUserWatchlistFragmentDoc}`;
export type WatchlistDeleteUserWatchlistMutationFn = Apollo.MutationFunction<WatchlistDeleteUserWatchlistMutation, WatchlistDeleteUserWatchlistMutationVariables>;

/**
 * __useWatchlistDeleteUserWatchlistMutation__
 *
 * To run a mutation, you first call `useWatchlistDeleteUserWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistDeleteUserWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistDeleteUserWatchlistMutation, { data, loading, error }] = useWatchlistDeleteUserWatchlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistDeleteUserWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistDeleteUserWatchlistMutation, WatchlistDeleteUserWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistDeleteUserWatchlistMutation, WatchlistDeleteUserWatchlistMutationVariables>(WatchlistDeleteUserWatchlistDocument, options);
      }
export type WatchlistDeleteUserWatchlistMutationHookResult = ReturnType<typeof useWatchlistDeleteUserWatchlistMutation>;
export type WatchlistDeleteUserWatchlistMutationResult = Apollo.MutationResult<WatchlistDeleteUserWatchlistMutation>;
export type WatchlistDeleteUserWatchlistMutationOptions = Apollo.BaseMutationOptions<WatchlistDeleteUserWatchlistMutation, WatchlistDeleteUserWatchlistMutationVariables>;
export const WatchlistUpdateUserWatchlistRoleDocument = gql`
    mutation WatchlistUpdateUserWatchlistRole($input: UpdateUserWatchlistRoleInput!) {
  updateUserWatchlistRole(input: $input) {
    ...WatchlistUserWatchlist
  }
}
    ${WatchlistUserWatchlistFragmentDoc}`;
export type WatchlistUpdateUserWatchlistRoleMutationFn = Apollo.MutationFunction<WatchlistUpdateUserWatchlistRoleMutation, WatchlistUpdateUserWatchlistRoleMutationVariables>;

/**
 * __useWatchlistUpdateUserWatchlistRoleMutation__
 *
 * To run a mutation, you first call `useWatchlistUpdateUserWatchlistRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistUpdateUserWatchlistRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistUpdateUserWatchlistRoleMutation, { data, loading, error }] = useWatchlistUpdateUserWatchlistRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchlistUpdateUserWatchlistRoleMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistUpdateUserWatchlistRoleMutation, WatchlistUpdateUserWatchlistRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistUpdateUserWatchlistRoleMutation, WatchlistUpdateUserWatchlistRoleMutationVariables>(WatchlistUpdateUserWatchlistRoleDocument, options);
      }
export type WatchlistUpdateUserWatchlistRoleMutationHookResult = ReturnType<typeof useWatchlistUpdateUserWatchlistRoleMutation>;
export type WatchlistUpdateUserWatchlistRoleMutationResult = Apollo.MutationResult<WatchlistUpdateUserWatchlistRoleMutation>;
export type WatchlistUpdateUserWatchlistRoleMutationOptions = Apollo.BaseMutationOptions<WatchlistUpdateUserWatchlistRoleMutation, WatchlistUpdateUserWatchlistRoleMutationVariables>;